
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*!
 * excalibur - 0.29.2 - 2024-4-7
 * https://github.com/excaliburjs/Excalibur
 * Copyright (c) 2024 Excalibur.js <https://github.com/excaliburjs/Excalibur/graphs/contributors>
 * Licensed BSD-2-Clause
 * @preserve
 */ /******/ var $2c23f148d58cd887$var$__webpack_modules__ = {
    /***/ 8851: /***/ (module, __webpack_exports__, __webpack_require__)=>{
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
            /* harmony export */ A: ()=>__WEBPACK_DEFAULT_EXPORT__
        });
        /* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2001);
        /* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(935);
        /* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
        // Imports
        var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default());
        // Module
        ___CSS_LOADER_EXPORT___.push([
            module.id,
            `/* Buttons styles start */

button#excalibur-play {
  display: inline-block;
  position: relative;
  z-index: 999;
  border-radius: 6px;
  border: none;
  /*border: 3px solid;
    border-color: white;
    box-shadow: 0 0 10px #ccc;*/
  padding: 1rem 1.5rem 1rem 4rem;
  margin: 0;
  text-decoration: none;
  background: #00b233;
  color: #ffffff;
  font-family: sans-serif;
  font-size: 2rem;
  white-space: nowrap;
  line-height: 1;
  cursor: pointer;
  text-align: center;
  transition: background 250ms ease-in-out, transform 150ms ease;
  -webkit-appearance: none;
  -moz-appearance: none;

  -webkit-animation: excalibur-button-fadein 200ms; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: excalibur-button-fadein 200ms; /* Firefox < 16 */
  -ms-animation: excalibur-button-fadein 200ms; /* Internet Explorer */
  -o-animation: excalibur-button-fadein 200ms; /* Opera < 12.1 */
  animation: excalibur-button-fadein 200ms;
}

/*
button#excalibur-play {
  display: none;
}*/

button#excalibur-play:after {
  position: absolute;
  content: '';
  border: 8px solid;
  border-color: transparent transparent transparent white;
  left: 35px;
  top: 24px;
  width: 0;
  height: 0;
}

button#excalibur-play:before {
  position: absolute;
  content: '';
  border: 3px solid;
  left: 19px;
  top: 14px;
  border-radius: 20px;
  width: 30px;
  height: 30px;
}

button#excalibur-play:hover,
button#excalibur-play:focus {
  background: #00982c;
}

button#excalibur-play:focus {
  outline: 1px solid #fff;
  outline-offset: -4px;
}

button#excalibur-play:active {
  transform: scale(0.99);
}

@keyframes excalibur-button-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes excalibur-button-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes excalibur-button-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes excalibur-button-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes excalibur-button-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
`,
            "",
            {
                "version": 3,
                "sources": [
                    "webpack://./Director/Loader.css"
                ],
                "names": [],
                "mappings": "AAAA,yBAAyB;;AAEzB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ;;+BAE6B;EAC7B,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,8DAA8D;EAC9D,wBAAwB;EACxB,qBAAqB;;EAErB,gDAAgD,EAAE,oCAAoC;EACtF,6CAA6C,EAAE,iBAAiB;EAChE,4CAA4C,EAAE,sBAAsB;EACpE,2CAA2C,EAAE,iBAAiB;EAC9D,wCAAwC;AAC1C;;AAEA;;;EAGE;;AAEF;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,uDAAuD;EACvD,UAAU;EACV,SAAS;EACT,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF",
                "sourcesContent": [
                    "/* Buttons styles start */\r\n\r\nbutton#excalibur-play {\r\n  display: inline-block;\r\n  position: relative;\r\n  z-index: 999;\r\n  border-radius: 6px;\r\n  border: none;\r\n  /*border: 3px solid;\r\n    border-color: white;\r\n    box-shadow: 0 0 10px #ccc;*/\r\n  padding: 1rem 1.5rem 1rem 4rem;\r\n  margin: 0;\r\n  text-decoration: none;\r\n  background: #00b233;\r\n  color: #ffffff;\r\n  font-family: sans-serif;\r\n  font-size: 2rem;\r\n  white-space: nowrap;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  transition: background 250ms ease-in-out, transform 150ms ease;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n\r\n  -webkit-animation: excalibur-button-fadein 200ms; /* Safari, Chrome and Opera > 12.1 */\r\n  -moz-animation: excalibur-button-fadein 200ms; /* Firefox < 16 */\r\n  -ms-animation: excalibur-button-fadein 200ms; /* Internet Explorer */\r\n  -o-animation: excalibur-button-fadein 200ms; /* Opera < 12.1 */\r\n  animation: excalibur-button-fadein 200ms;\r\n}\r\n\r\n/*\r\nbutton#excalibur-play {\r\n  display: none;\r\n}*/\r\n\r\nbutton#excalibur-play:after {\r\n  position: absolute;\r\n  content: '';\r\n  border: 8px solid;\r\n  border-color: transparent transparent transparent white;\r\n  left: 35px;\r\n  top: 24px;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\nbutton#excalibur-play:before {\r\n  position: absolute;\r\n  content: '';\r\n  border: 3px solid;\r\n  left: 19px;\r\n  top: 14px;\r\n  border-radius: 20px;\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\nbutton#excalibur-play:hover,\r\nbutton#excalibur-play:focus {\r\n  background: #00982c;\r\n}\r\n\r\nbutton#excalibur-play:focus {\r\n  outline: 1px solid #fff;\r\n  outline-offset: -4px;\r\n}\r\n\r\nbutton#excalibur-play:active {\r\n  transform: scale(0.99);\r\n}\r\n\r\n@keyframes excalibur-button-fadein {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Firefox < 16 */\r\n@-moz-keyframes excalibur-button-fadein {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Safari, Chrome and Opera > 12.1 */\r\n@-webkit-keyframes excalibur-button-fadein {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Internet Explorer */\r\n@-ms-keyframes excalibur-button-fadein {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Opera < 12.1 */\r\n@-o-keyframes excalibur-button-fadein {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n"
                ],
                "sourceRoot": ""
            }
        ]);
        // Exports
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ___CSS_LOADER_EXPORT___;
    /***/ },
    /***/ 4296: /***/ (module, __webpack_exports__, __webpack_require__)=>{
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
            /* harmony export */ A: ()=>__WEBPACK_DEFAULT_EXPORT__
        });
        /* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2001);
        /* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(935);
        /* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
        // Imports
        var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default());
        // Module
        ___CSS_LOADER_EXPORT___.push([
            module.id,
            `
#ex-toast-container {
  position: absolute;
  height: 0;
  min-width: 50%;
  left: 50%;
  top: 0;
}

.ex-toast-message {
  left: -50%;
  position: relative;
  display: flex;
  justify-content: space-between;


  padding: 10px;
  margin-top: 5px;
  font-size: 18px;
  font-family: sans-serif;
  border-radius: 6px;
  border: 3px solid #b7b779;
  background-color: rgb(253, 253, 192);
}


.ex-toast-message button {
  align-self: flex-start;
}`,
            "",
            {
                "version": 3,
                "sources": [
                    "webpack://./Util/Toaster.css"
                ],
                "names": [],
                "mappings": ";AACA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,SAAS;EACT,MAAM;AACR;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,8BAA8B;;;EAG9B,aAAa;EACb,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;AACtC;;;AAGA;EACE,sBAAsB;AACxB",
                "sourcesContent": [
                    "\r\n#ex-toast-container {\r\n  position: absolute;\r\n  height: 0;\r\n  min-width: 50%;\r\n  left: 50%;\r\n  top: 0;\r\n}\r\n\r\n.ex-toast-message {\r\n  left: -50%;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: space-between;\r\n\r\n\r\n  padding: 10px;\r\n  margin-top: 5px;\r\n  font-size: 18px;\r\n  font-family: sans-serif;\r\n  border-radius: 6px;\r\n  border: 3px solid #b7b779;\r\n  background-color: rgb(253, 253, 192);\r\n}\r\n\r\n\r\n.ex-toast-message button {\r\n  align-self: flex-start;\r\n}"
                ],
                "sourceRoot": ""
            }
        ]);
        // Exports
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ___CSS_LOADER_EXPORT___;
    /***/ },
    /***/ 935: /***/ (module)=>{
        /*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/ module.exports = function(cssWithMappingToString) {
            var list = [];
            // return the list of modules as css string
            list.toString = function toString() {
                return this.map(function(item) {
                    var content = "";
                    var needLayer = typeof item[5] !== "undefined";
                    if (item[4]) content += "@supports (".concat(item[4], ") {");
                    if (item[2]) content += "@media ".concat(item[2], " {");
                    if (needLayer) content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
                    content += cssWithMappingToString(item);
                    if (needLayer) content += "}";
                    if (item[2]) content += "}";
                    if (item[4]) content += "}";
                    return content;
                }).join("");
            };
            // import a list of modules into the list
            list.i = function i(modules, media, dedupe, supports, layer) {
                if (typeof modules === "string") modules = [
                    [
                        null,
                        modules,
                        undefined
                    ]
                ];
                var alreadyImportedModules = {};
                if (dedupe) for(var k = 0; k < this.length; k++){
                    var id = this[k][0];
                    if (id != null) alreadyImportedModules[id] = true;
                }
                for(var _k = 0; _k < modules.length; _k++){
                    var item = [].concat(modules[_k]);
                    if (dedupe && alreadyImportedModules[item[0]]) continue;
                    if (typeof layer !== "undefined") {
                        if (typeof item[5] === "undefined") item[5] = layer;
                        else {
                            item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
                            item[5] = layer;
                        }
                    }
                    if (media) {
                        if (!item[2]) item[2] = media;
                        else {
                            item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
                            item[2] = media;
                        }
                    }
                    if (supports) {
                        if (!item[4]) item[4] = "".concat(supports);
                        else {
                            item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
                            item[4] = supports;
                        }
                    }
                    list.push(item);
                }
            };
            return list;
        };
    /***/ },
    /***/ 2001: /***/ (module)=>{
        module.exports = function(item) {
            var content = item[1];
            var cssMapping = item[3];
            if (!cssMapping) return content;
            if (typeof btoa === "function") {
                var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
                var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
                var sourceMapping = "/*# ".concat(data, " */");
                return [
                    content
                ].concat([
                    sourceMapping
                ]).join("\n");
            }
            return [
                content
            ].join("\n");
        };
    /***/ },
    /***/ 9493: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        __webpack_require__(3975);
        var entryUnbind = __webpack_require__(2564);
        module.exports = entryUnbind("Array", "sort");
    /***/ },
    /***/ 311: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        __webpack_require__(8291);
        var path = __webpack_require__(9120);
        module.exports = path.Object.keys;
    /***/ },
    /***/ 4977: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var isCallable = __webpack_require__(4188);
        var tryToString = __webpack_require__(3174);
        var $TypeError = TypeError;
        // `Assert: IsCallable(argument) is true`
        module.exports = function(argument) {
            if (isCallable(argument)) return argument;
            throw new $TypeError(tryToString(argument) + " is not a function");
        };
    /***/ },
    /***/ 3770: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var isObject = __webpack_require__(831);
        var $String = String;
        var $TypeError = TypeError;
        // `Assert: Type(argument) is Object`
        module.exports = function(argument) {
            if (isObject(argument)) return argument;
            throw new $TypeError($String(argument) + " is not an object");
        };
    /***/ },
    /***/ 1458: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var toIndexedObject = __webpack_require__(380);
        var toAbsoluteIndex = __webpack_require__(675);
        var lengthOfArrayLike = __webpack_require__(9389);
        // `Array.prototype.{ indexOf, includes }` methods implementation
        var createMethod = function(IS_INCLUDES) {
            return function($this, el, fromIndex) {
                var O = toIndexedObject($this);
                var length = lengthOfArrayLike(O);
                if (length === 0) return !IS_INCLUDES && -1;
                var index = toAbsoluteIndex(fromIndex, length);
                var value;
                // Array#includes uses SameValueZero equality algorithm
                // eslint-disable-next-line no-self-compare -- NaN check
                if (IS_INCLUDES && el !== el) while(length > index){
                    value = O[index++];
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (value !== value) return true;
                // Array#indexOf ignores holes, Array#includes - not
                }
                else for(; length > index; index++){
                    if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                }
                return !IS_INCLUDES && -1;
            };
        };
        module.exports = {
            // `Array.prototype.includes` method
            // https://tc39.es/ecma262/#sec-array.prototype.includes
            includes: createMethod(true),
            // `Array.prototype.indexOf` method
            // https://tc39.es/ecma262/#sec-array.prototype.indexof
            indexOf: createMethod(false)
        };
    /***/ },
    /***/ 5397: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var fails = __webpack_require__(5234);
        module.exports = function(METHOD_NAME, argument) {
            var method = [][METHOD_NAME];
            return !!method && fails(function() {
                // eslint-disable-next-line no-useless-call -- required for testing
                method.call(null, argument || function() {
                    return 1;
                }, 1);
            });
        };
    /***/ },
    /***/ 7825: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        module.exports = uncurryThis([].slice);
    /***/ },
    /***/ 9295: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var arraySlice = __webpack_require__(7825);
        var floor = Math.floor;
        var sort = function(array, comparefn) {
            var length = array.length;
            if (length < 8) {
                // insertion sort
                var i = 1;
                var element, j;
                while(i < length){
                    j = i;
                    element = array[i];
                    while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
                    if (j !== i++) array[j] = element;
                }
            } else {
                // merge sort
                var middle = floor(length / 2);
                var left = sort(arraySlice(array, 0, middle), comparefn);
                var right = sort(arraySlice(array, middle), comparefn);
                var llength = left.length;
                var rlength = right.length;
                var lindex = 0;
                var rindex = 0;
                while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
            }
            return array;
        };
        module.exports = sort;
    /***/ },
    /***/ 8689: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var toString = uncurryThis({}.toString);
        var stringSlice = uncurryThis("".slice);
        module.exports = function(it) {
            return stringSlice(toString(it), 8, -1);
        };
    /***/ },
    /***/ 5438: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var TO_STRING_TAG_SUPPORT = __webpack_require__(9345);
        var isCallable = __webpack_require__(4188);
        var classofRaw = __webpack_require__(8689);
        var wellKnownSymbol = __webpack_require__(4282);
        var TO_STRING_TAG = wellKnownSymbol("toStringTag");
        var $Object = Object;
        // ES3 wrong here
        var CORRECT_ARGUMENTS = classofRaw(function() {
            return arguments;
        }()) === "Arguments";
        // fallback for IE11 Script Access Denied error
        var tryGet = function(it, key) {
            try {
                return it[key];
            } catch (error) {}
        };
        // getting tag from ES6+ `Object.prototype.toString`
        module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
            var O, tag, result;
            return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === "Object" && isCallable(O.callee) ? "Arguments" : result;
        };
    /***/ },
    /***/ 8657: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var hasOwn = __webpack_require__(4418);
        var ownKeys = __webpack_require__(3168);
        var getOwnPropertyDescriptorModule = __webpack_require__(9304);
        var definePropertyModule = __webpack_require__(4466);
        module.exports = function(target, source, exceptions) {
            var keys = ownKeys(source);
            var defineProperty = definePropertyModule.f;
            var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
            }
        };
    /***/ },
    /***/ 8088: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var DESCRIPTORS = __webpack_require__(6893);
        var definePropertyModule = __webpack_require__(4466);
        var createPropertyDescriptor = __webpack_require__(9123);
        module.exports = DESCRIPTORS ? function(object, key, value) {
            return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
        } : function(object, key, value) {
            object[key] = value;
            return object;
        };
    /***/ },
    /***/ 9123: /***/ (module)=>{
        module.exports = function(bitmap, value) {
            return {
                enumerable: !(bitmap & 1),
                configurable: !(bitmap & 2),
                writable: !(bitmap & 4),
                value: value
            };
        };
    /***/ },
    /***/ 7509: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var isCallable = __webpack_require__(4188);
        var definePropertyModule = __webpack_require__(4466);
        var makeBuiltIn = __webpack_require__(4530);
        var defineGlobalProperty = __webpack_require__(4798);
        module.exports = function(O, key, value, options) {
            if (!options) options = {};
            var simple = options.enumerable;
            var name = options.name !== undefined ? options.name : key;
            if (isCallable(value)) makeBuiltIn(value, name, options);
            if (options.global) {
                if (simple) O[key] = value;
                else defineGlobalProperty(key, value);
            } else {
                try {
                    if (!options.unsafe) delete O[key];
                    else if (O[key]) simple = true;
                } catch (error) {}
                if (simple) O[key] = value;
                else definePropertyModule.f(O, key, {
                    value: value,
                    enumerable: false,
                    configurable: !options.nonConfigurable,
                    writable: !options.nonWritable
                });
            }
            return O;
        };
    /***/ },
    /***/ 4798: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;
        module.exports = function(key, value) {
            try {
                defineProperty(global, key, {
                    value: value,
                    configurable: true,
                    writable: true
                });
            } catch (error) {
                global[key] = value;
            }
            return value;
        };
    /***/ },
    /***/ 1305: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var tryToString = __webpack_require__(3174);
        var $TypeError = TypeError;
        module.exports = function(O, P) {
            if (!delete O[P]) throw new $TypeError("Cannot delete property " + tryToString(P) + " of " + tryToString(O));
        };
    /***/ },
    /***/ 6893: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var fails = __webpack_require__(5234);
        // Detect IE8's incomplete defineProperty implementation
        module.exports = !fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty({}, 1, {
                get: function() {
                    return 7;
                }
            })[1] !== 7;
        });
    /***/ },
    /***/ 5926: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var isObject = __webpack_require__(831);
        var document1 = global.document;
        // typeof document.createElement is 'object' in old IE
        var EXISTS = isObject(document1) && isObject(document1.createElement);
        module.exports = function(it) {
            return EXISTS ? document1.createElement(it) : {};
        };
    /***/ },
    /***/ 8807: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var userAgent = __webpack_require__(4109);
        var firefox = userAgent.match(/firefox\/(\d+)/i);
        module.exports = !!firefox && +firefox[1];
    /***/ },
    /***/ 5661: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var UA = __webpack_require__(4109);
        module.exports = /MSIE|Trident/.test(UA);
    /***/ },
    /***/ 4109: /***/ (module)=>{
        module.exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";
    /***/ },
    /***/ 3749: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var userAgent = __webpack_require__(4109);
        var process = global.process;
        var Deno = global.Deno;
        var versions = process && process.versions || Deno && Deno.version;
        var v8 = versions && versions.v8;
        var match, version;
        if (v8) {
            match = v8.split(".");
            // in old Chrome, versions of V8 isn't V8 = Chrome / 10
            // but their correct versions are not interesting for us
            version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
        }
        // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
        // so check `userAgent` even if `.v8` exists, but 0
        if (!version && userAgent) {
            match = userAgent.match(/Edge\/(\d+)/);
            if (!match || match[1] >= 74) {
                match = userAgent.match(/Chrome\/(\d+)/);
                if (match) version = +match[1];
            }
        }
        module.exports = version;
    /***/ },
    /***/ 3589: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var userAgent = __webpack_require__(4109);
        var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
        module.exports = !!webkit && +webkit[1];
    /***/ },
    /***/ 2564: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var uncurryThis = __webpack_require__(6881);
        module.exports = function(CONSTRUCTOR, METHOD) {
            return uncurryThis(global[CONSTRUCTOR].prototype[METHOD]);
        };
    /***/ },
    /***/ 1274: /***/ (module)=>{
        // IE8- don't enum bug keys
        module.exports = [
            "constructor",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "toLocaleString",
            "toString",
            "valueOf"
        ];
    /***/ },
    /***/ 5613: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var getOwnPropertyDescriptor = __webpack_require__(9304).f;
        var createNonEnumerableProperty = __webpack_require__(8088);
        var defineBuiltIn = __webpack_require__(7509);
        var defineGlobalProperty = __webpack_require__(4798);
        var copyConstructorProperties = __webpack_require__(8657);
        var isForced = __webpack_require__(8489);
        /*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
            var TARGET = options.target;
            var GLOBAL = options.global;
            var STATIC = options.stat;
            var FORCED, target, key, targetProperty, sourceProperty, descriptor;
            if (GLOBAL) target = global;
            else if (STATIC) target = global[TARGET] || defineGlobalProperty(TARGET, {});
            else target = global[TARGET] && global[TARGET].prototype;
            if (target) for(key in source){
                sourceProperty = source[key];
                if (options.dontCallGetSet) {
                    descriptor = getOwnPropertyDescriptor(target, key);
                    targetProperty = descriptor && descriptor.value;
                } else targetProperty = target[key];
                FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
                // contained in target
                if (!FORCED && targetProperty !== undefined) {
                    if (typeof sourceProperty == typeof targetProperty) continue;
                    copyConstructorProperties(sourceProperty, targetProperty);
                }
                // add a flag to not completely full polyfills
                if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, "sham", true);
                defineBuiltIn(target, key, sourceProperty, options);
            }
        };
    /***/ },
    /***/ 5234: /***/ (module)=>{
        module.exports = function(exec) {
            try {
                return !!exec();
            } catch (error) {
                return true;
            }
        };
    /***/ },
    /***/ 9055: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var fails = __webpack_require__(5234);
        module.exports = !fails(function() {
            // eslint-disable-next-line es/no-function-prototype-bind -- safe
            var test = (function() {}).bind();
            // eslint-disable-next-line no-prototype-builtins -- safe
            return typeof test != "function" || test.hasOwnProperty("prototype");
        });
    /***/ },
    /***/ 9944: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var NATIVE_BIND = __webpack_require__(9055);
        var call = Function.prototype.call;
        module.exports = NATIVE_BIND ? call.bind(call) : function() {
            return call.apply(call, arguments);
        };
    /***/ },
    /***/ 2735: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var DESCRIPTORS = __webpack_require__(6893);
        var hasOwn = __webpack_require__(4418);
        var FunctionPrototype = Function.prototype;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
        var EXISTS = hasOwn(FunctionPrototype, "name");
        // additional protection from minified / mangled / dropped function names
        var PROPER = EXISTS && (function something() {}).name === "something";
        var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, "name").configurable);
        module.exports = {
            EXISTS: EXISTS,
            PROPER: PROPER,
            CONFIGURABLE: CONFIGURABLE
        };
    /***/ },
    /***/ 6881: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var NATIVE_BIND = __webpack_require__(9055);
        var FunctionPrototype = Function.prototype;
        var call = FunctionPrototype.call;
        var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
        module.exports = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
            return function() {
                return call.apply(fn, arguments);
            };
        };
    /***/ },
    /***/ 5604: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var isCallable = __webpack_require__(4188);
        var aFunction = function(argument) {
            return isCallable(argument) ? argument : undefined;
        };
        module.exports = function(namespace, method) {
            return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
        };
    /***/ },
    /***/ 2913: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var aCallable = __webpack_require__(4977);
        var isNullOrUndefined = __webpack_require__(4318);
        // `GetMethod` abstract operation
        // https://tc39.es/ecma262/#sec-getmethod
        module.exports = function(V, P) {
            var func = V[P];
            return isNullOrUndefined(func) ? undefined : aCallable(func);
        };
    /***/ },
    /***/ 1488: /***/ function(module, __unused_webpack_exports, __webpack_require__) {
        var check = function(it) {
            return it && it.Math === Math && it;
        };
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        module.exports = // eslint-disable-next-line es/no-global-this -- safe
        check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
        check(typeof self == "object" && self) || check(typeof __webpack_require__.g == "object" && __webpack_require__.g) || check(typeof this == "object" && this) || // eslint-disable-next-line no-new-func -- fallback
        function() {
            return this;
        }() || Function("return this")();
    /***/ },
    /***/ 4418: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var toObject = __webpack_require__(3628);
        var hasOwnProperty = uncurryThis({}.hasOwnProperty);
        // `HasOwnProperty` abstract operation
        // https://tc39.es/ecma262/#sec-hasownproperty
        // eslint-disable-next-line es/no-object-hasown -- safe
        module.exports = Object.hasOwn || function hasOwn(it, key) {
            return hasOwnProperty(toObject(it), key);
        };
    /***/ },
    /***/ 7588: /***/ (module)=>{
        module.exports = {};
    /***/ },
    /***/ 9622: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var DESCRIPTORS = __webpack_require__(6893);
        var fails = __webpack_require__(5234);
        var createElement = __webpack_require__(5926);
        // Thanks to IE8 for its funny defineProperty
        module.exports = !DESCRIPTORS && !fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty(createElement("div"), "a", {
                get: function() {
                    return 7;
                }
            }).a !== 7;
        });
    /***/ },
    /***/ 7568: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var fails = __webpack_require__(5234);
        var classof = __webpack_require__(8689);
        var $Object = Object;
        var split = uncurryThis("".split);
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        module.exports = fails(function() {
            // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
            // eslint-disable-next-line no-prototype-builtins -- safe
            return !$Object("z").propertyIsEnumerable(0);
        }) ? function(it) {
            return classof(it) === "String" ? split(it, "") : $Object(it);
        } : $Object;
    /***/ },
    /***/ 3029: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var isCallable = __webpack_require__(4188);
        var store = __webpack_require__(2694);
        var functionToString = uncurryThis(Function.toString);
        // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
        if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
            return functionToString(it);
        };
        module.exports = store.inspectSource;
    /***/ },
    /***/ 3086: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var NATIVE_WEAK_MAP = __webpack_require__(5945);
        var global = __webpack_require__(1488);
        var isObject = __webpack_require__(831);
        var createNonEnumerableProperty = __webpack_require__(8088);
        var hasOwn = __webpack_require__(4418);
        var shared = __webpack_require__(2694);
        var sharedKey = __webpack_require__(168);
        var hiddenKeys = __webpack_require__(7588);
        var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
        var TypeError1 = global.TypeError;
        var WeakMap1 = global.WeakMap;
        var set, get, has;
        var enforce = function(it) {
            return has(it) ? get(it) : set(it, {});
        };
        var getterFor = function(TYPE) {
            return function(it) {
                var state;
                if (!isObject(it) || (state = get(it)).type !== TYPE) throw new TypeError1("Incompatible receiver, " + TYPE + " required");
                return state;
            };
        };
        if (NATIVE_WEAK_MAP || shared.state) {
            var store = shared.state || (shared.state = new WeakMap1());
            /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
            store.has = store.has;
            store.set = store.set;
            /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
                if (store.has(it)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                metadata.facade = it;
                store.set(it, metadata);
                return metadata;
            };
            get = function(it) {
                return store.get(it) || {};
            };
            has = function(it) {
                return store.has(it);
            };
        } else {
            var STATE = sharedKey("state");
            hiddenKeys[STATE] = true;
            set = function(it, metadata) {
                if (hasOwn(it, STATE)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                metadata.facade = it;
                createNonEnumerableProperty(it, STATE, metadata);
                return metadata;
            };
            get = function(it) {
                return hasOwn(it, STATE) ? it[STATE] : {};
            };
            has = function(it) {
                return hasOwn(it, STATE);
            };
        }
        module.exports = {
            set: set,
            get: get,
            has: has,
            enforce: enforce,
            getterFor: getterFor
        };
    /***/ },
    /***/ 4188: /***/ (module)=>{
        // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
        var documentAll = typeof document == "object" && document.all;
        // `IsCallable` abstract operation
        // https://tc39.es/ecma262/#sec-iscallable
        // eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
        module.exports = typeof documentAll == "undefined" && documentAll !== undefined ? function(argument) {
            return typeof argument == "function" || argument === documentAll;
        } : function(argument) {
            return typeof argument == "function";
        };
    /***/ },
    /***/ 8489: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var fails = __webpack_require__(5234);
        var isCallable = __webpack_require__(4188);
        var replacement = /#|\.prototype\./;
        var isForced = function(feature, detection) {
            var value = data[normalize(feature)];
            return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
        };
        var normalize = isForced.normalize = function(string) {
            return String(string).replace(replacement, ".").toLowerCase();
        };
        var data = isForced.data = {};
        var NATIVE = isForced.NATIVE = "N";
        var POLYFILL = isForced.POLYFILL = "P";
        module.exports = isForced;
    /***/ },
    /***/ 4318: /***/ (module)=>{
        // we can't use just `it == null` since of `document.all` special case
        // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
        module.exports = function(it) {
            return it === null || it === undefined;
        };
    /***/ },
    /***/ 831: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var isCallable = __webpack_require__(4188);
        module.exports = function(it) {
            return typeof it == "object" ? it !== null : isCallable(it);
        };
    /***/ },
    /***/ 1942: /***/ (module)=>{
        module.exports = false;
    /***/ },
    /***/ 6032: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var getBuiltIn = __webpack_require__(5604);
        var isCallable = __webpack_require__(4188);
        var isPrototypeOf = __webpack_require__(4578);
        var USE_SYMBOL_AS_UID = __webpack_require__(9809);
        var $Object = Object;
        module.exports = USE_SYMBOL_AS_UID ? function(it) {
            return typeof it == "symbol";
        } : function(it) {
            var $Symbol = getBuiltIn("Symbol");
            return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
        };
    /***/ },
    /***/ 9389: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var toLength = __webpack_require__(7611);
        // `LengthOfArrayLike` abstract operation
        // https://tc39.es/ecma262/#sec-lengthofarraylike
        module.exports = function(obj) {
            return toLength(obj.length);
        };
    /***/ },
    /***/ 4530: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var fails = __webpack_require__(5234);
        var isCallable = __webpack_require__(4188);
        var hasOwn = __webpack_require__(4418);
        var DESCRIPTORS = __webpack_require__(6893);
        var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(2735).CONFIGURABLE;
        var inspectSource = __webpack_require__(3029);
        var InternalStateModule = __webpack_require__(3086);
        var enforceInternalState = InternalStateModule.enforce;
        var getInternalState = InternalStateModule.get;
        var $String = String;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;
        var stringSlice = uncurryThis("".slice);
        var replace = uncurryThis("".replace);
        var join = uncurryThis([].join);
        var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function() {
            return defineProperty(function() {}, "length", {
                value: 8
            }).length !== 8;
        });
        var TEMPLATE = String(String).split("String");
        var makeBuiltIn = module.exports = function(value, name, options) {
            if (stringSlice($String(name), 0, 7) === "Symbol(") name = "[" + replace($String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
            if (options && options.getter) name = "get " + name;
            if (options && options.setter) name = "set " + name;
            if (!hasOwn(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
                if (DESCRIPTORS) defineProperty(value, "name", {
                    value: name,
                    configurable: true
                });
                else value.name = name;
            }
            if (CONFIGURABLE_LENGTH && options && hasOwn(options, "arity") && value.length !== options.arity) defineProperty(value, "length", {
                value: options.arity
            });
            try {
                if (options && hasOwn(options, "constructor") && options.constructor) {
                    if (DESCRIPTORS) defineProperty(value, "prototype", {
                        writable: false
                    });
                } else if (value.prototype) value.prototype = undefined;
            } catch (error) {}
            var state = enforceInternalState(value);
            if (!hasOwn(state, "source")) state.source = join(TEMPLATE, typeof name == "string" ? name : "");
            return value;
        };
        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
        // eslint-disable-next-line no-extend-native -- required
        Function.prototype.toString = makeBuiltIn(function toString() {
            return isCallable(this) && getInternalState(this).source || inspectSource(this);
        }, "toString");
    /***/ },
    /***/ 142: /***/ (module)=>{
        var ceil = Math.ceil;
        var floor = Math.floor;
        // `Math.trunc` method
        // https://tc39.es/ecma262/#sec-math.trunc
        // eslint-disable-next-line es/no-math-trunc -- safe
        module.exports = Math.trunc || function trunc(x) {
            var n = +x;
            return (n > 0 ? floor : ceil)(n);
        };
    /***/ },
    /***/ 4466: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
        var DESCRIPTORS = __webpack_require__(6893);
        var IE8_DOM_DEFINE = __webpack_require__(9622);
        var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3315);
        var anObject = __webpack_require__(3770);
        var toPropertyKey = __webpack_require__(2344);
        var $TypeError = TypeError;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var $defineProperty = Object.defineProperty;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var ENUMERABLE = "enumerable";
        var CONFIGURABLE = "configurable";
        var WRITABLE = "writable";
        // `Object.defineProperty` method
        // https://tc39.es/ecma262/#sec-object.defineproperty
        exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPropertyKey(P);
            anObject(Attributes);
            if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
                var current = $getOwnPropertyDescriptor(O, P);
                if (current && current[WRITABLE]) {
                    O[P] = Attributes.value;
                    Attributes = {
                        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                        writable: false
                    };
                }
            }
            return $defineProperty(O, P, Attributes);
        } : $defineProperty : function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPropertyKey(P);
            anObject(Attributes);
            if (IE8_DOM_DEFINE) try {
                return $defineProperty(O, P, Attributes);
            } catch (error) {}
            if ("get" in Attributes || "set" in Attributes) throw new $TypeError("Accessors not supported");
            if ("value" in Attributes) O[P] = Attributes.value;
            return O;
        };
    /***/ },
    /***/ 9304: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
        var DESCRIPTORS = __webpack_require__(6893);
        var call = __webpack_require__(9944);
        var propertyIsEnumerableModule = __webpack_require__(4416);
        var createPropertyDescriptor = __webpack_require__(9123);
        var toIndexedObject = __webpack_require__(380);
        var toPropertyKey = __webpack_require__(2344);
        var hasOwn = __webpack_require__(4418);
        var IE8_DOM_DEFINE = __webpack_require__(9622);
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
        exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
            O = toIndexedObject(O);
            P = toPropertyKey(P);
            if (IE8_DOM_DEFINE) try {
                return $getOwnPropertyDescriptor(O, P);
            } catch (error) {}
            if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
        };
    /***/ },
    /***/ 5629: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
        var internalObjectKeys = __webpack_require__(1843);
        var enumBugKeys = __webpack_require__(1274);
        var hiddenKeys = enumBugKeys.concat("length", "prototype");
        // `Object.getOwnPropertyNames` method
        // https://tc39.es/ecma262/#sec-object.getownpropertynames
        // eslint-disable-next-line es/no-object-getownpropertynames -- safe
        exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
            return internalObjectKeys(O, hiddenKeys);
        };
    /***/ },
    /***/ 156: /***/ (__unused_webpack_module, exports)=>{
        // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
        exports.f = Object.getOwnPropertySymbols;
    /***/ },
    /***/ 4578: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        module.exports = uncurryThis({}.isPrototypeOf);
    /***/ },
    /***/ 1843: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var hasOwn = __webpack_require__(4418);
        var toIndexedObject = __webpack_require__(380);
        var indexOf = __webpack_require__(1458).indexOf;
        var hiddenKeys = __webpack_require__(7588);
        var push = uncurryThis([].push);
        module.exports = function(object, names) {
            var O = toIndexedObject(object);
            var i = 0;
            var result = [];
            var key;
            for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
            // Don't enum bug & hidden keys
            while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
            return result;
        };
    /***/ },
    /***/ 7137: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var internalObjectKeys = __webpack_require__(1843);
        var enumBugKeys = __webpack_require__(1274);
        // `Object.keys` method
        // https://tc39.es/ecma262/#sec-object.keys
        // eslint-disable-next-line es/no-object-keys -- safe
        module.exports = Object.keys || function keys(O) {
            return internalObjectKeys(O, enumBugKeys);
        };
    /***/ },
    /***/ 4416: /***/ (__unused_webpack_module, exports)=>{
        var $propertyIsEnumerable = {}.propertyIsEnumerable;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // Nashorn ~ JDK8 bug
        var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
            1: 2
        }, 1);
        // `Object.prototype.propertyIsEnumerable` method implementation
        // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
        exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
            var descriptor = getOwnPropertyDescriptor(this, V);
            return !!descriptor && descriptor.enumerable;
        } : $propertyIsEnumerable;
    /***/ },
    /***/ 2287: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var call = __webpack_require__(9944);
        var isCallable = __webpack_require__(4188);
        var isObject = __webpack_require__(831);
        var $TypeError = TypeError;
        // `OrdinaryToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-ordinarytoprimitive
        module.exports = function(input, pref) {
            var fn, val;
            if (pref === "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
            if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
            if (pref !== "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
            throw new $TypeError("Can't convert object to primitive value");
        };
    /***/ },
    /***/ 3168: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var getBuiltIn = __webpack_require__(5604);
        var uncurryThis = __webpack_require__(6881);
        var getOwnPropertyNamesModule = __webpack_require__(5629);
        var getOwnPropertySymbolsModule = __webpack_require__(156);
        var anObject = __webpack_require__(3770);
        var concat = uncurryThis([].concat);
        // all object keys, includes non-enumerable and symbols
        module.exports = getBuiltIn("Reflect", "ownKeys") || function ownKeys(it) {
            var keys = getOwnPropertyNamesModule.f(anObject(it));
            var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
            return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
        };
    /***/ },
    /***/ 9120: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        module.exports = global;
    /***/ },
    /***/ 9509: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var isNullOrUndefined = __webpack_require__(4318);
        var $TypeError = TypeError;
        // `RequireObjectCoercible` abstract operation
        // https://tc39.es/ecma262/#sec-requireobjectcoercible
        module.exports = function(it) {
            if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
            return it;
        };
    /***/ },
    /***/ 168: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var shared = __webpack_require__(746);
        var uid = __webpack_require__(6209);
        var keys = shared("keys");
        module.exports = function(key) {
            return keys[key] || (keys[key] = uid(key));
        };
    /***/ },
    /***/ 2694: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var IS_PURE = __webpack_require__(1942);
        var globalThis1 = __webpack_require__(1488);
        var defineGlobalProperty = __webpack_require__(4798);
        var SHARED = "__core-js_shared__";
        var store = module.exports = globalThis1[SHARED] || defineGlobalProperty(SHARED, {});
        (store.versions || (store.versions = [])).push({
            version: "3.36.1",
            mode: IS_PURE ? "pure" : "global",
            copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
            license: "https://github.com/zloirock/core-js/blob/v3.36.1/LICENSE",
            source: "https://github.com/zloirock/core-js"
        });
    /***/ },
    /***/ 746: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var store = __webpack_require__(2694);
        module.exports = function(key, value) {
            return store[key] || (store[key] = value || {});
        };
    /***/ },
    /***/ 8944: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        /* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = __webpack_require__(3749);
        var fails = __webpack_require__(5234);
        var global = __webpack_require__(1488);
        var $String = global.String;
        // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
        module.exports = !!Object.getOwnPropertySymbols && !fails(function() {
            var symbol = Symbol("symbol detection");
            // Chrome 38 Symbol has incorrect toString conversion
            // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
            // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
            // of course, fail.
            return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
            !Symbol.sham && V8_VERSION && V8_VERSION < 41;
        });
    /***/ },
    /***/ 675: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var toIntegerOrInfinity = __webpack_require__(6744);
        var max = Math.max;
        var min = Math.min;
        // Helper for a popular repeating case of the spec:
        // Let integer be ? ToInteger(index).
        // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
        module.exports = function(index, length) {
            var integer = toIntegerOrInfinity(index);
            return integer < 0 ? max(integer + length, 0) : min(integer, length);
        };
    /***/ },
    /***/ 380: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        // toObject with fallback for non-array-like ES3 strings
        var IndexedObject = __webpack_require__(7568);
        var requireObjectCoercible = __webpack_require__(9509);
        module.exports = function(it) {
            return IndexedObject(requireObjectCoercible(it));
        };
    /***/ },
    /***/ 6744: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var trunc = __webpack_require__(142);
        // `ToIntegerOrInfinity` abstract operation
        // https://tc39.es/ecma262/#sec-tointegerorinfinity
        module.exports = function(argument) {
            var number = +argument;
            // eslint-disable-next-line no-self-compare -- NaN check
            return number !== number || number === 0 ? 0 : trunc(number);
        };
    /***/ },
    /***/ 7611: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var toIntegerOrInfinity = __webpack_require__(6744);
        var min = Math.min;
        // `ToLength` abstract operation
        // https://tc39.es/ecma262/#sec-tolength
        module.exports = function(argument) {
            var len = toIntegerOrInfinity(argument);
            return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
        };
    /***/ },
    /***/ 3628: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var requireObjectCoercible = __webpack_require__(9509);
        var $Object = Object;
        // `ToObject` abstract operation
        // https://tc39.es/ecma262/#sec-toobject
        module.exports = function(argument) {
            return $Object(requireObjectCoercible(argument));
        };
    /***/ },
    /***/ 290: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var call = __webpack_require__(9944);
        var isObject = __webpack_require__(831);
        var isSymbol = __webpack_require__(6032);
        var getMethod = __webpack_require__(2913);
        var ordinaryToPrimitive = __webpack_require__(2287);
        var wellKnownSymbol = __webpack_require__(4282);
        var $TypeError = TypeError;
        var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
        // `ToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-toprimitive
        module.exports = function(input, pref) {
            if (!isObject(input) || isSymbol(input)) return input;
            var exoticToPrim = getMethod(input, TO_PRIMITIVE);
            var result;
            if (exoticToPrim) {
                if (pref === undefined) pref = "default";
                result = call(exoticToPrim, input, pref);
                if (!isObject(result) || isSymbol(result)) return result;
                throw new $TypeError("Can't convert object to primitive value");
            }
            if (pref === undefined) pref = "number";
            return ordinaryToPrimitive(input, pref);
        };
    /***/ },
    /***/ 2344: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var toPrimitive = __webpack_require__(290);
        var isSymbol = __webpack_require__(6032);
        // `ToPropertyKey` abstract operation
        // https://tc39.es/ecma262/#sec-topropertykey
        module.exports = function(argument) {
            var key = toPrimitive(argument, "string");
            return isSymbol(key) ? key : key + "";
        };
    /***/ },
    /***/ 9345: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var wellKnownSymbol = __webpack_require__(4282);
        var TO_STRING_TAG = wellKnownSymbol("toStringTag");
        var test = {};
        test[TO_STRING_TAG] = "z";
        module.exports = String(test) === "[object z]";
    /***/ },
    /***/ 2618: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var classof = __webpack_require__(5438);
        var $String = String;
        module.exports = function(argument) {
            if (classof(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
            return $String(argument);
        };
    /***/ },
    /***/ 3174: /***/ (module)=>{
        var $String = String;
        module.exports = function(argument) {
            try {
                return $String(argument);
            } catch (error) {
                return "Object";
            }
        };
    /***/ },
    /***/ 6209: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var uncurryThis = __webpack_require__(6881);
        var id = 0;
        var postfix = Math.random();
        var toString = uncurryThis(1.0.toString);
        module.exports = function(key) {
            return "Symbol(" + (key === undefined ? "" : key) + ")_" + toString(++id + postfix, 36);
        };
    /***/ },
    /***/ 9809: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        /* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = __webpack_require__(8944);
        module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";
    /***/ },
    /***/ 3315: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var DESCRIPTORS = __webpack_require__(6893);
        var fails = __webpack_require__(5234);
        // V8 ~ Chrome 36-
        // https://bugs.chromium.org/p/v8/issues/detail?id=3334
        module.exports = DESCRIPTORS && fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty(function() {}, "prototype", {
                value: 42,
                writable: false
            }).prototype !== 42;
        });
    /***/ },
    /***/ 5945: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var isCallable = __webpack_require__(4188);
        var WeakMap1 = global.WeakMap;
        module.exports = isCallable(WeakMap1) && /native code/.test(String(WeakMap1));
    /***/ },
    /***/ 4282: /***/ (module, __unused_webpack_exports, __webpack_require__)=>{
        var global = __webpack_require__(1488);
        var shared = __webpack_require__(746);
        var hasOwn = __webpack_require__(4418);
        var uid = __webpack_require__(6209);
        var NATIVE_SYMBOL = __webpack_require__(8944);
        var USE_SYMBOL_AS_UID = __webpack_require__(9809);
        var Symbol1 = global.Symbol;
        var WellKnownSymbolsStore = shared("wks");
        var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol1["for"] || Symbol1 : Symbol1 && Symbol1.withoutSetter || uid;
        module.exports = function(name) {
            if (!hasOwn(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol1, name) ? Symbol1[name] : createWellKnownSymbol("Symbol." + name);
            return WellKnownSymbolsStore[name];
        };
    /***/ },
    /***/ 3975: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
        var $ = __webpack_require__(5613);
        var uncurryThis = __webpack_require__(6881);
        var aCallable = __webpack_require__(4977);
        var toObject = __webpack_require__(3628);
        var lengthOfArrayLike = __webpack_require__(9389);
        var deletePropertyOrThrow = __webpack_require__(1305);
        var toString = __webpack_require__(2618);
        var fails = __webpack_require__(5234);
        var internalSort = __webpack_require__(9295);
        var arrayMethodIsStrict = __webpack_require__(5397);
        var FF = __webpack_require__(8807);
        var IE_OR_EDGE = __webpack_require__(5661);
        var V8 = __webpack_require__(3749);
        var WEBKIT = __webpack_require__(3589);
        var test = [];
        var nativeSort = uncurryThis(test.sort);
        var push = uncurryThis(test.push);
        // IE8-
        var FAILS_ON_UNDEFINED = fails(function() {
            test.sort(undefined);
        });
        // V8 bug
        var FAILS_ON_NULL = fails(function() {
            test.sort(null);
        });
        // Old WebKit
        var STRICT_METHOD = arrayMethodIsStrict("sort");
        var STABLE_SORT = !fails(function() {
            // feature detection can be too slow, so check engines versions
            if (V8) return V8 < 70;
            if (FF && FF > 3) return;
            if (IE_OR_EDGE) return true;
            if (WEBKIT) return WEBKIT < 603;
            var result = "";
            var code, chr, value, index;
            // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
            for(code = 65; code < 76; code++){
                chr = String.fromCharCode(code);
                switch(code){
                    case 66:
                    case 69:
                    case 70:
                    case 72:
                        value = 3;
                        break;
                    case 68:
                    case 71:
                        value = 4;
                        break;
                    default:
                        value = 2;
                }
                for(index = 0; index < 47; index++)test.push({
                    k: chr + index,
                    v: value
                });
            }
            test.sort(function(a, b) {
                return b.v - a.v;
            });
            for(index = 0; index < test.length; index++){
                chr = test[index].k.charAt(0);
                if (result.charAt(result.length - 1) !== chr) result += chr;
            }
            return result !== "DGBEFHACIJK";
        });
        var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
        var getSortCompare = function(comparefn) {
            return function(x, y) {
                if (y === undefined) return -1;
                if (x === undefined) return 1;
                if (comparefn !== undefined) return +comparefn(x, y) || 0;
                return toString(x) > toString(y) ? 1 : -1;
            };
        };
        // `Array.prototype.sort` method
        // https://tc39.es/ecma262/#sec-array.prototype.sort
        $({
            target: "Array",
            proto: true,
            forced: FORCED
        }, {
            sort: function sort(comparefn) {
                if (comparefn !== undefined) aCallable(comparefn);
                var array = toObject(this);
                if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);
                var items = [];
                var arrayLength = lengthOfArrayLike(array);
                var itemsLength, index;
                for(index = 0; index < arrayLength; index++)if (index in array) push(items, array[index]);
                internalSort(items, getSortCompare(comparefn));
                itemsLength = lengthOfArrayLike(items);
                index = 0;
                while(index < itemsLength)array[index] = items[index++];
                while(index < arrayLength)deletePropertyOrThrow(array, index++);
                return array;
            }
        });
    /***/ },
    /***/ 8291: /***/ (__unused_webpack_module, __unused_webpack_exports, __webpack_require__)=>{
        var $ = __webpack_require__(5613);
        var toObject = __webpack_require__(3628);
        var nativeKeys = __webpack_require__(7137);
        var fails = __webpack_require__(5234);
        var FAILS_ON_PRIMITIVES = fails(function() {
            nativeKeys(1);
        });
        // `Object.keys` method
        // https://tc39.es/ecma262/#sec-object.keys
        $({
            target: "Object",
            stat: true,
            forced: FAILS_ON_PRIMITIVES
        }, {
            keys: function keys(it) {
                return nativeKeys(toObject(it));
            }
        });
    /***/ }
};
/************************************************************************/ /******/ // The module cache
/******/ var $2c23f148d58cd887$var$__webpack_module_cache__ = {};
/******/ /******/ // The require function
/******/ function $2c23f148d58cd887$var$__webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = $2c23f148d58cd887$var$__webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = $2c23f148d58cd887$var$__webpack_module_cache__[moduleId] = {
        /******/ id: moduleId,
        /******/ // no module.loaded needed
        /******/ exports: {}
    };
    /******/ /******/ // Execute the module function
    /******/ $2c23f148d58cd887$var$__webpack_modules__[moduleId].call(module.exports, module, module.exports, $2c23f148d58cd887$var$__webpack_require__);
    /******/ /******/ // Return the exports of the module
    /******/ return module.exports;
/******/ }
/******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ (()=>{
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ $2c23f148d58cd887$var$__webpack_require__.n = (module)=>{
        /******/ var getter = module && module.__esModule ? /******/ ()=>module["default"] : /******/ ()=>module;
        /******/ $2c23f148d58cd887$var$__webpack_require__.d(getter, {
            a: getter
        });
        /******/ return getter;
    /******/ };
/******/ })();
/******/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
    /******/ // define getter functions for harmony exports
    /******/ $2c23f148d58cd887$var$__webpack_require__.d = (exports, definition)=>{
        /******/ for(var key in definition)/******/ if ($2c23f148d58cd887$var$__webpack_require__.o(definition, key) && !$2c23f148d58cd887$var$__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
        });
    /******/ };
/******/ })();
/******/ /******/ /* webpack/runtime/global */ /******/ (()=>{
    /******/ $2c23f148d58cd887$var$__webpack_require__.g = function() {
        /******/ if (typeof globalThis === "object") return globalThis;
        /******/ try {
            /******/ return this || new Function("return this")();
        /******/ } catch (e) {
            /******/ if (typeof window === "object") return window;
        /******/ }
    /******/ }();
/******/ })();
/******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
    /******/ $2c23f148d58cd887$var$__webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
/******/ })();
/******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
    /******/ // define __esModule on exports
    /******/ $2c23f148d58cd887$var$__webpack_require__.r = (exports)=>{
        /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
            value: "Module"
        });
        /******/ Object.defineProperty(exports, "__esModule", {
            value: true
        });
    /******/ };
/******/ })();
/******/ /************************************************************************/ var $2c23f148d58cd887$var$__webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(()=>{
    // EXPORTS
    $2c23f148d58cd887$var$__webpack_require__.d($2c23f148d58cd887$var$__webpack_exports__, {
        eKr: ()=>/* reexport */ ActionCompleteEvent,
        yVm: ()=>/* reexport */ ActionContext,
        a7j: ()=>/* reexport */ ActionQueue,
        U_w: ()=>/* reexport */ ActionSequence,
        JF2: ()=>/* reexport */ ActionStartEvent,
        htg: ()=>/* reexport */ ActionsComponent,
        HXL: ()=>/* reexport */ ActionsSystem,
        mcg: ()=>/* reexport */ ActivateEvent,
        Agj: ()=>/* reexport */ Actor,
        u6S: ()=>/* reexport */ AddedComponent,
        x7M: ()=>/* reexport */ AffineMatrix,
        X55: ()=>/* reexport */ Animation,
        m3M: ()=>/* reexport */ AnimationDirection,
        aE5: ()=>/* reexport */ AnimationEvents,
        YJU: ()=>/* reexport */ AnimationStrategy,
        eZi: ()=>/* reexport */ ArcadeSolver,
        GNv: ()=>/* reexport */ AudioContextFactory,
        Y56: ()=>/* reexport */ Axes,
        _0v: ()=>/* reexport */ Axis,
        vhs: ()=>/* reexport */ BaseAlign,
        Z8b: ()=>/* reexport */ Blink,
        Yfw: ()=>/* reexport */ BodyComponent,
        IcQ: ()=>/* reexport */ BoundingBox,
        Rl2: ()=>/* reexport */ BroadphaseStrategy,
        kgJ: ()=>/* reexport */ BrowserComponent,
        GTT: ()=>/* reexport */ BrowserEvents,
        ypY: ()=>/* reexport */ Buttons,
        i7d: ()=>/* reexport */ Camera,
        fQ3: ()=>/* reexport */ CameraEvents,
        HlI: ()=>/* reexport */ Canvas,
        jlt: ()=>/* reexport */ Circle,
        VQc: ()=>/* reexport */ CircleCollider,
        zD7: ()=>/* reexport */ Clock,
        I0I: ()=>/* reexport */ ClosestLine,
        AUF: ()=>/* reexport */ ClosestLineJumpTable,
        JoF: ()=>/* reexport */ Collider,
        MlA: ()=>/* reexport */ ColliderComponent,
        PZh: ()=>/* reexport */ CollisionContact,
        qA: ()=>/* reexport */ CollisionEndEvent,
        CrD: ()=>/* reexport */ CollisionGroup,
        dQK: ()=>/* reexport */ CollisionGroupManager,
        D3r: ()=>/* reexport */ CollisionJumpTable,
        Qpo: ()=>/* reexport */ CollisionPostSolveEvent,
        D9n: ()=>/* reexport */ CollisionPreSolveEvent,
        b6v: ()=>/* reexport */ CollisionStartEvent,
        mvh: ()=>/* reexport */ CollisionSystem,
        Bpo: ()=>/* reexport */ CollisionType,
        Q1f: ()=>/* reexport */ Color,
        IKv: ()=>/* reexport */ ColorBlindFlags,
        fcV: ()=>/* reexport */ ColorBlindnessMode,
        Glf: ()=>/* reexport */ ColorBlindnessPostProcessor,
        uAl: ()=>/* reexport */ Component,
        ElT: ()=>/* reexport */ CompositeCollider,
        MPu: ()=>/* reexport */ Configurable,
        Z8r: ()=>/* reexport */ ConsoleAppender,
        QSL: ()=>/* reexport */ ContactConstraintPoint,
        sPV: ()=>/* reexport */ ContactEndEvent,
        nAn: ()=>/* reexport */ ContactSolveBias,
        zCU: ()=>/* reexport */ ContactStartEvent,
        QrV: ()=>/* reexport */ CoordPlane,
        fF9: ()=>/* reexport */ CrossFade,
        xI8: ()=>/* reexport */ DeactivateEvent,
        yar: ()=>/* reexport */ Debug,
        SP7: ()=>/* reexport */ DebugConfig,
        oRy: ()=>/* reexport */ DebugGraphicsComponent,
        f5X: ()=>/* reexport */ DebugSystem,
        V1c: ()=>/* reexport */ DebugText,
        Mlx: ()=>/* reexport */ DefaultAntialiasOptions,
        ZCo: ()=>/* reexport */ DefaultLoader,
        Vy3: ()=>/* reexport */ DefaultPhysicsConfig,
        J5p: ()=>/* reexport */ DefaultPixelArtOptions,
        mL_: ()=>/* reexport */ DegreeOfFreedom,
        Guw: ()=>/* reexport */ Delay,
        VKx: ()=>/* reexport */ DeprecatedStaticToConfig,
        N5j: ()=>/* reexport */ Detector,
        pgY: ()=>/* reexport */ Die,
        OP3: ()=>/* reexport */ Direction,
        rl5: ()=>/* reexport */ Director,
        eod: ()=>/* reexport */ DirectorEvents,
        q5Z: ()=>/* reexport */ DisplayMode,
        YUC: ()=>/* reexport */ DynamicTree,
        saR: ()=>/* reexport */ DynamicTreeCollisionProcessor,
        hvr: ()=>/* binding */ EX_VERSION,
        Qol: ()=>/* reexport */ EaseBy,
        Wf4: ()=>/* reexport */ EaseTo,
        JCs: ()=>/* reexport */ EasingFunctions,
        gJV: ()=>/* reexport */ EdgeCollider,
        fWD: ()=>/* reexport */ ElasticToActorStrategy,
        Va_: ()=>/* reexport */ EmitterType,
        N$8: ()=>/* reexport */ Engine,
        _jQ: ()=>/* reexport */ EngineEvents,
        rxj: ()=>/* reexport */ EnterTriggerEvent,
        rhv: ()=>/* reexport */ EnterViewPortEvent,
        wCu: ()=>/* reexport */ Entity,
        HAp: ()=>/* reexport */ EntityEvents,
        Zy1: ()=>/* reexport */ EntityManager,
        Qev: ()=>/* reexport */ EventDispatcher,
        bkB: ()=>/* reexport */ EventEmitter,
        wfL: ()=>/* reexport */ EventTypes,
        sVA: ()=>/* reexport */ Events_namespaceObject,
        $Gs: ()=>/* reexport */ ExResponse,
        CJ0: ()=>/* reexport */ ExcaliburGraphicsContext2DCanvas,
        NWh: ()=>/* reexport */ ExcaliburGraphicsContextWebGL,
        tWi: ()=>/* reexport */ ExitTriggerEvent,
        xAj: ()=>/* reexport */ ExitViewPortEvent,
        zWh: ()=>/* reexport */ Fade,
        i_4: ()=>/* reexport */ FadeInOut,
        iIx: ()=>/* reexport */ Flags,
        c9e: ()=>/* reexport */ Follow,
        KQV: ()=>/* reexport */ Font,
        weH: ()=>/* reexport */ FontCache,
        jXp: ()=>/* reexport */ FontSource,
        zzY: ()=>/* reexport */ FontStyle,
        yRQ: ()=>/* reexport */ FontUnit,
        MtE: ()=>/* reexport */ FpsSampler,
        rPj: ()=>/* reexport */ FrameStats,
        KLc: ()=>/* reexport */ Future,
        Fir: ()=>/* reexport */ GameEvent,
        V5f: ()=>/* reexport */ GameStartEvent,
        Xj7: ()=>/* reexport */ GameStopEvent,
        Wud: ()=>/* reexport */ Gamepad,
        FVg: ()=>/* reexport */ GamepadAxisEvent,
        g5Y: ()=>/* reexport */ GamepadButtonEvent,
        YQB: ()=>/* reexport */ GamepadConnectEvent,
        KPb: ()=>/* reexport */ GamepadDisconnectEvent,
        nHK: ()=>/* reexport */ Gamepads,
        TX_: ()=>/* reexport */ Gif,
        r3n: ()=>/* reexport */ GlobalCoordinates,
        vYh: ()=>/* reexport */ Graphic,
        hnk: ()=>/* reexport */ GraphicsComponent,
        D2R: ()=>/* reexport */ GraphicsGroup,
        n1o: ()=>/* reexport */ GraphicsSystem,
        RLG: ()=>/* reexport */ HiddenEvent,
        fBU: ()=>/* reexport */ HorizontalFirst,
        Adb: ()=>/* reexport */ ImageFiltering,
        bEs: ()=>/* reexport */ ImageSource,
        wCy: ()=>/* reexport */ ImageSourceAttributeConstants,
        CbD: ()=>/* reexport */ ImageWrapping,
        x_C: ()=>/* reexport */ InitializeEvent,
        pde: ()=>/* reexport */ Input_Index_namespaceObject,
        pGf: ()=>/* reexport */ InputHost,
        ibQ: ()=>/* reexport */ InputMapper,
        QlN: ()=>/* reexport */ Integrator,
        shR: ()=>/* reexport */ IsometricEntityComponent,
        Yjk: ()=>/* reexport */ IsometricEntitySystem,
        _u1: ()=>/* reexport */ IsometricMap,
        OBI: ()=>/* reexport */ IsometricTile,
        klh: ()=>/* reexport */ KeyEvent,
        s3S: ()=>/* reexport */ Keyboard,
        D$R: ()=>/* reexport */ Keys,
        xth: ()=>/* reexport */ KillEvent,
        JU7: ()=>/* reexport */ Label,
        h9x: ()=>/* reexport */ LimitCameraBoundsStrategy,
        N1A: ()=>/* reexport */ Line,
        e_k: ()=>/* reexport */ LineSegment,
        aHM: ()=>/* reexport */ Loader,
        tlv: ()=>/* reexport */ LoaderEvents,
        Vi9: ()=>/* reexport */ LockCameraToActorAxisStrategy,
        ieR: ()=>/* reexport */ LockCameraToActorStrategy,
        $bb: ()=>/* reexport */ LogLevel,
        VyI: ()=>/* reexport */ Logger,
        imn: ()=>/* reexport */ Material,
        uqu: ()=>/* reexport */ Matrix,
        QnL: ()=>/* reexport */ MatrixLocations,
        vnc: ()=>/* reexport */ MediaEvent,
        wk_: ()=>/* reexport */ Meet,
        GH0: ()=>/* reexport */ MotionComponent,
        _1r: ()=>/* reexport */ MotionSystem,
        l0X: ()=>/* reexport */ MoveBy,
        HHX: ()=>/* reexport */ MoveTo,
        tjk: ()=>/* reexport */ NativePointerButton,
        rWe: ()=>/* reexport */ NativeSoundEvent,
        j9l: ()=>/* reexport */ NativeSoundProcessedEvent,
        NVp: ()=>/* reexport */ None,
        cPK: ()=>/* reexport */ Observable,
        XoL: ()=>/* reexport */ OffscreenSystem,
        RmF: ()=>/* reexport */ Pair,
        DXI: ()=>/* reexport */ ParallaxComponent,
        tCD: ()=>/* reexport */ ParallelActions,
        oGn: ()=>/* reexport */ ParseGif,
        J3D: ()=>/* reexport */ Particle,
        vCJ: ()=>/* reexport */ ParticleEmitter,
        f9l: ()=>/* reexport */ ParticleTransform,
        AQx: ()=>/* reexport */ Physics,
        v9m: ()=>/* reexport */ PhysicsStats,
        yRJ: ()=>/* reexport */ PhysicsWorld,
        EU6: ()=>/* reexport */ PointerAbstraction,
        m3O: ()=>/* reexport */ PointerButton,
        Ryz: ()=>/* reexport */ PointerComponent,
        OxP: ()=>/* reexport */ PointerEvent,
        LEs: ()=>/* reexport */ PointerEventReceiver,
        Ec: ()=>/* reexport */ PointerScope,
        Pi5: ()=>/* reexport */ PointerSystem,
        gmH: ()=>/* reexport */ PointerType,
        tS: ()=>/* reexport */ Polygon,
        XxX: ()=>/* reexport */ PolygonCollider,
        bCz: ()=>/* reexport */ Pool,
        nYS: ()=>/* reexport */ PostCollisionEvent,
        yiT: ()=>/* reexport */ PostDebugDrawEvent,
        NHl: ()=>/* reexport */ PostDrawEvent,
        mO8: ()=>/* reexport */ PostFrameEvent,
        PXI: ()=>/* reexport */ PostKillEvent,
        bn5: ()=>/* reexport */ PostTransformDrawEvent,
        Ywr: ()=>/* reexport */ PostUpdateEvent,
        cMd: ()=>/* reexport */ PreCollisionEvent,
        Bs6: ()=>/* reexport */ PreDebugDrawEvent,
        G0k: ()=>/* reexport */ PreDrawEvent,
        pyn: ()=>/* reexport */ PreFrameEvent,
        QeM: ()=>/* reexport */ PreKillEvent,
        aPX: ()=>/* reexport */ PreLoadEvent,
        ITP: ()=>/* reexport */ PreTransformDrawEvent,
        BY0: ()=>/* reexport */ PreUpdateEvent,
        MFw: ()=>/* reexport */ Projection,
        sBn: ()=>/* reexport */ QuadIndexBuffer,
        S3L: ()=>/* reexport */ QuadTree,
        XKQ: ()=>/* reexport */ Query,
        ESI: ()=>/* reexport */ QueryManager,
        uxz: ()=>/* reexport */ RadiusAroundActorStrategy,
        o8N: ()=>/* reexport */ Random,
        u_r: ()=>/* reexport */ Raster,
        RlV: ()=>/* reexport */ Ray,
        gVA: ()=>/* reexport */ RealisticSolver,
        M_G: ()=>/* reexport */ Rectangle,
        GRB: ()=>/* reexport */ RemovedComponent,
        kM6: ()=>/* reexport */ Repeat,
        dO8: ()=>/* reexport */ RepeatForever,
        jgM: ()=>/* reexport */ Resolution,
        FWq: ()=>/* reexport */ Resource,
        s3j: ()=>/* reexport */ ResourceEvents,
        hlw: ()=>/* reexport */ RotateBy,
        B7e: ()=>/* reexport */ RotateTo,
        H_X: ()=>/* reexport */ RotationType,
        S_d: ()=>/* reexport */ ScaleBy,
        U7E: ()=>/* reexport */ ScaleTo,
        Z58: ()=>/* reexport */ Scene,
        yh2: ()=>/* reexport */ SceneEvents,
        ff$: ()=>/* reexport */ Screen,
        cWi: ()=>/* reexport */ ScreenAppender,
        NBt: ()=>/* reexport */ ScreenElement,
        oNz: ()=>/* reexport */ ScreenEvents,
        QlU: ()=>/* reexport */ ScreenShader,
        Xey: ()=>/* reexport */ ScrollPreventionMode,
        jft: ()=>/* reexport */ Semaphore,
        Mtr: ()=>/* reexport */ Shader,
        ypk: ()=>/* reexport */ Shape,
        mnM: ()=>/* reexport */ Side,
        bAZ: ()=>/* reexport */ SolverStrategy,
        ABN: ()=>/* reexport */ Sound,
        VK6: ()=>/* reexport */ SoundEvents,
        kxk: ()=>/* reexport */ Sprite,
        DT1: ()=>/* reexport */ SpriteFont,
        FLG: ()=>/* reexport */ SpriteSheet,
        qN_: ()=>/* reexport */ StandardClock,
        Z37: ()=>/* reexport */ StateMachine,
        FtL: ()=>/* reexport */ StrategyContainer,
        Z6X: ()=>/* reexport */ Stream,
        iQT: ()=>/* reexport */ System,
        ziO: ()=>/* reexport */ SystemManager,
        OEF: ()=>/* reexport */ SystemPriority,
        uuE: ()=>/* reexport */ SystemType,
        tiv: ()=>/* reexport */ TagQuery,
        T$Y: ()=>/* reexport */ TestClock,
        EYj: ()=>/* reexport */ Text,
        nOB: ()=>/* reexport */ TextAlign,
        Tap: ()=>/* reexport */ TextureLoader,
        FAs: ()=>/* reexport */ Tile,
        B_P: ()=>/* reexport */ TileMap,
        aA5: ()=>/* reexport */ TileMapEvents,
        M4G: ()=>/* reexport */ Timer,
        l$l: ()=>/* reexport */ Toaster,
        dLy: ()=>/* reexport */ transform_Transform,
        WZP: ()=>/* reexport */ TransformComponent,
        eB6: ()=>/* reexport */ Transition,
        nFK: ()=>/* reexport */ TreeNode,
        l9z: ()=>/* reexport */ Trigger,
        YOF: ()=>/* reexport */ TriggerEvents,
        yhB: ()=>/* reexport */ TwoPI,
        J0N: ()=>/* reexport */ Util_Index_namespaceObject,
        Miz: ()=>/* reexport */ Vector,
        Bj4: ()=>/* reexport */ VectorView,
        Rcs: ()=>/* reexport */ VertexBuffer,
        vJ4: ()=>/* reexport */ VertexLayout,
        TqC: ()=>/* reexport */ VerticalFirst,
        nM0: ()=>/* reexport */ VisibleEvent,
        X1u: ()=>/* reexport */ WebAudio,
        SpZ: ()=>/* reexport */ WebAudioInstance,
        DX8: ()=>/* reexport */ WheelDeltaMode,
        Yx$: ()=>/* reexport */ WheelEvent,
        HK4: ()=>/* reexport */ World,
        SE$: ()=>/* reexport */ canonicalizeAngle,
        qE8: ()=>/* reexport */ clamp,
        Pz7: ()=>/* reexport */ coroutine,
        sX_: ()=>/* reexport */ createId,
        JuI: ()=>/* reexport */ frac,
        Nl$: ()=>/* reexport */ hasGraphicsTick,
        OwT: ()=>/* reexport */ hasOnInitialize,
        P$G: ()=>/* reexport */ hasOnPostUpdate,
        mHV: ()=>/* reexport */ hasOnPreUpdate,
        Fx_: ()=>/* reexport */ hasPostDraw,
        WFC: ()=>/* reexport */ hasPreDraw,
        aDq: ()=>/* reexport */ has_initialize,
        jIg: ()=>/* reexport */ has_postupdate,
        UH3: ()=>/* reexport */ has_preupdate,
        K6X: ()=>/* reexport */ isAddedComponent,
        C1Y: ()=>/* reexport */ isComponentCtor,
        Aw1: ()=>/* reexport */ isLoaderConstructor,
        A8$: ()=>/* reexport */ isRemovedComponent,
        hsx: ()=>/* reexport */ isSceneConstructor,
        l9E: ()=>/* reexport */ isScreenElement,
        aSf: ()=>/* reexport */ isSystemConstructor,
        Zex: ()=>/* reexport */ maxMessages,
        mXP: ()=>/* reexport */ obsolete,
        vt$: ()=>/* reexport */ parseImageFiltering,
        hCA: ()=>/* reexport */ parseImageWrapping,
        pjR: ()=>/* reexport */ pixelSnapEpsilon,
        U43: ()=>/* reexport */ randomInRange,
        pSZ: ()=>/* reexport */ randomIntInRange,
        y17: ()=>/* reexport */ range,
        jVr: ()=>/* reexport */ resetObsoleteCounter,
        _SZ: ()=>/* reexport */ sign,
        xWn: ()=>/* reexport */ toDegrees,
        ehJ: ()=>/* reexport */ toRadians,
        t6s: ()=>/* reexport */ vec,
        Eyn: ()=>/* reexport */ webgl_util_namespaceObject
    });
    // NAMESPACE OBJECT: ./Graphics/Context/webgl-util.ts
    var webgl_util_namespaceObject = {};
    $2c23f148d58cd887$var$__webpack_require__.r(webgl_util_namespaceObject);
    $2c23f148d58cd887$var$__webpack_require__.d(webgl_util_namespaceObject, {
        getAttributeComponentSize: ()=>getAttributeComponentSize,
        getAttributePointerType: ()=>getAttributePointerType,
        getGLTypeFromSource: ()=>getGLTypeFromSource,
        getGlTypeSizeBytes: ()=>getGlTypeSizeBytes,
        isAttributeInSource: ()=>isAttributeInSource
    });
    // NAMESPACE OBJECT: ./Events.ts
    var Events_namespaceObject = {};
    $2c23f148d58cd887$var$__webpack_require__.r(Events_namespaceObject);
    $2c23f148d58cd887$var$__webpack_require__.d(Events_namespaceObject, {
        ActionCompleteEvent: ()=>ActionCompleteEvent,
        ActionStartEvent: ()=>ActionStartEvent,
        ActivateEvent: ()=>ActivateEvent,
        CollisionEndEvent: ()=>CollisionEndEvent,
        CollisionPostSolveEvent: ()=>CollisionPostSolveEvent,
        CollisionPreSolveEvent: ()=>CollisionPreSolveEvent,
        CollisionStartEvent: ()=>CollisionStartEvent,
        ContactEndEvent: ()=>ContactEndEvent,
        ContactStartEvent: ()=>ContactStartEvent,
        DeactivateEvent: ()=>DeactivateEvent,
        EnterTriggerEvent: ()=>EnterTriggerEvent,
        EnterViewPortEvent: ()=>EnterViewPortEvent,
        EventTypes: ()=>EventTypes,
        ExitTriggerEvent: ()=>ExitTriggerEvent,
        ExitViewPortEvent: ()=>ExitViewPortEvent,
        GameEvent: ()=>GameEvent,
        GameStartEvent: ()=>GameStartEvent,
        GameStopEvent: ()=>GameStopEvent,
        GamepadAxisEvent: ()=>GamepadAxisEvent,
        GamepadButtonEvent: ()=>GamepadButtonEvent,
        GamepadConnectEvent: ()=>GamepadConnectEvent,
        GamepadDisconnectEvent: ()=>GamepadDisconnectEvent,
        HiddenEvent: ()=>HiddenEvent,
        InitializeEvent: ()=>InitializeEvent,
        KillEvent: ()=>KillEvent,
        PostCollisionEvent: ()=>PostCollisionEvent,
        PostDebugDrawEvent: ()=>PostDebugDrawEvent,
        PostDrawEvent: ()=>PostDrawEvent,
        PostFrameEvent: ()=>PostFrameEvent,
        PostKillEvent: ()=>PostKillEvent,
        PostTransformDrawEvent: ()=>PostTransformDrawEvent,
        PostUpdateEvent: ()=>PostUpdateEvent,
        PreCollisionEvent: ()=>PreCollisionEvent,
        PreDebugDrawEvent: ()=>PreDebugDrawEvent,
        PreDrawEvent: ()=>PreDrawEvent,
        PreFrameEvent: ()=>PreFrameEvent,
        PreKillEvent: ()=>PreKillEvent,
        PreTransformDrawEvent: ()=>PreTransformDrawEvent,
        PreUpdateEvent: ()=>PreUpdateEvent,
        VisibleEvent: ()=>VisibleEvent
    });
    // NAMESPACE OBJECT: ./Util/DrawUtil.ts
    var DrawUtil_namespaceObject = {};
    $2c23f148d58cd887$var$__webpack_require__.r(DrawUtil_namespaceObject);
    $2c23f148d58cd887$var$__webpack_require__.d(DrawUtil_namespaceObject, {
        circle: ()=>circle,
        line: ()=>line,
        point: ()=>point,
        roundRect: ()=>roundRect,
        vector: ()=>vector
    });
    // NAMESPACE OBJECT: ./Input/Index.ts
    var Input_Index_namespaceObject = {};
    $2c23f148d58cd887$var$__webpack_require__.r(Input_Index_namespaceObject);
    $2c23f148d58cd887$var$__webpack_require__.d(Input_Index_namespaceObject, {
        Axes: ()=>Axes,
        Buttons: ()=>Buttons,
        Gamepad: ()=>Gamepad,
        Gamepads: ()=>Gamepads,
        KeyEvent: ()=>KeyEvent,
        Keyboard: ()=>Keyboard,
        Keys: ()=>Keys,
        NativePointerButton: ()=>NativePointerButton,
        PointerButton: ()=>PointerButton,
        PointerComponent: ()=>PointerComponent,
        PointerEvent: ()=>PointerEvent,
        PointerEventReceiver: ()=>PointerEventReceiver,
        PointerScope: ()=>PointerScope,
        PointerSystem: ()=>PointerSystem,
        PointerType: ()=>PointerType,
        WheelDeltaMode: ()=>WheelDeltaMode,
        WheelEvent: ()=>WheelEvent
    });
    // NAMESPACE OBJECT: ./Util/Index.ts
    var Util_Index_namespaceObject = {};
    $2c23f148d58cd887$var$__webpack_require__.r(Util_Index_namespaceObject);
    $2c23f148d58cd887$var$__webpack_require__.d(Util_Index_namespaceObject, {
        ConsoleAppender: ()=>ConsoleAppender,
        DrawUtil: ()=>DrawUtil_namespaceObject,
        EasingFunctions: ()=>EasingFunctions,
        LogLevel: ()=>LogLevel,
        Logger: ()=>Logger,
        Observable: ()=>Observable,
        ScreenAppender: ()=>ScreenAppender,
        addItemToArray: ()=>addItemToArray,
        contains: ()=>contains,
        delay: ()=>delay,
        fail: ()=>fail,
        getPosition: ()=>getPosition,
        omit: ()=>omit,
        removeItemFromArray: ()=>removeItemFromArray
    });
    // EXTERNAL MODULE: ../../node_modules/core-js/es/array/sort.js
    var sort = $2c23f148d58cd887$var$__webpack_require__(9493);
    // EXTERNAL MODULE: ../../node_modules/core-js/es/object/keys.js
    var keys = $2c23f148d58cd887$var$__webpack_require__(311);
    /**
 * Polyfill adding function
 */ function polyfill() {
        /* istanbul ignore next */ if (typeof window === "undefined") window = {
            audioContext: function() {
                return;
            }
        };
        /* istanbul ignore next */ if (typeof window !== "undefined" && !window.requestAnimationFrame) window.requestAnimationFrame = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
            window.setInterval(callback, 1000 / 60);
        };
        /* istanbul ignore next */ if (typeof window !== "undefined" && !window.cancelAnimationFrame) window.cancelAnimationFrame = window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || function() {
            return;
        };
        /* istanbul ignore next */ if (typeof window !== "undefined" && !window.AudioContext) {
            if (window.webkitAudioContext) {
                const ctx = window.webkitAudioContext;
                const replaceMe = ctx.prototype.decodeAudioData;
                window.webkitAudioContext.prototype.decodeAudioData = function(arrayBuffer) {
                    return new Promise((resolve, reject)=>{
                        replaceMe.call(this, arrayBuffer, resolve, reject);
                    });
                };
            }
            window.AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.msAudioContext || window.oAudioContext;
        }
        /* istanbul ignore next */ if (typeof window !== "undefined" && !window.devicePixelRatio) window.devicePixelRatio = window.devicePixelRatio || 1;
    }
    /**
 * Flags is a feature flag implementation for Excalibur. They can only be operated **before [[Engine]] construction**
 * after which they are frozen and are read-only.
 *
 * Flags are used to enable experimental or preview features in Excalibur.
 */ class Flags {
        /**
     * Force excalibur to load the Canvas 2D graphics context fallback
     * @warning not all features of excalibur are supported in the Canvas 2D fallback
     */ static useCanvasGraphicsContext() {
            Flags.enable("use-canvas-context");
        }
        /**
     * Freeze all flag modifications making them readonly
     */ static freeze() {
            Flags._FROZEN = true;
        }
        /**
     * Resets internal flag state, not meant to be called by users. Only used for testing.
     *
     * Calling this in your game is UNSUPPORTED
     * @internal
     */ static _reset() {
            Flags._FROZEN = false;
            Flags._FLAGS = {};
        }
        /**
     * Enable a specific feature flag by name. **Note: can only be set before [[Engine]] constructor time**
     * @param flagName
     */ static enable(flagName) {
            if (this._FROZEN) throw Error("Feature flags can only be enabled before Engine constructor time");
            Flags._FLAGS[flagName] = true;
        }
        /**
     * Disable a specific feature flag by name. **Note: can only be set before [[Engine]] constructor time**
     * @param flagName
     */ static disable(flagName) {
            if (this._FROZEN) throw Error("Feature flags can only be disabled before Engine constructor time");
            Flags._FLAGS[flagName] = false;
        }
        /**
     * Check if a flag is enabled. If the flag is disabled or does not exist `false` is returned
     * @param flagName
     */ static isEnabled(flagName) {
            return !!Flags._FLAGS[flagName];
        }
        /**
     * Show a list of currently known flags
     */ static show() {
            return Object.keys(Flags._FLAGS);
        }
    }
    Flags._FROZEN = false;
    Flags._FLAGS = {};
    /**
 * Create a branded ID type from a number
 */ function createId(type, value) {
        return {
            type: type,
            value: value
        };
    }
    /**
 * Future is a wrapper around a native browser Promise to allow resolving/rejecting at any time
 */ class Future {
        constructor(){
            this._isCompleted = false;
            this.promise = new Promise((resolve, reject)=>{
                this._resolver = resolve;
                this._rejecter = reject;
            });
        }
        get isCompleted() {
            return this._isCompleted;
        }
        resolve(value) {
            if (this._isCompleted) return;
            this._isCompleted = true;
            this._resolver(value);
        }
        reject(error) {
            if (this._isCompleted) return;
            this._isCompleted = true;
            this._rejecter(error);
        }
    }
    /**
 * Excalibur's typed event emitter, this allows events to be sent with any string to Type mapping
 */ class EventEmitter {
        constructor(){
            this._paused = false;
            this._listeners = {};
            this._listenersOnce = {};
            this._pipes = [];
        }
        clear() {
            this._listeners = {};
            this._listenersOnce = {};
            this._pipes.length = 0;
        }
        on(eventName, handler) {
            var _a;
            this._listeners[eventName] = (_a = this._listeners[eventName]) !== null && _a !== void 0 ? _a : [];
            this._listeners[eventName].push(handler);
            return {
                close: ()=>this.off(eventName, handler)
            };
        }
        once(eventName, handler) {
            var _a;
            this._listenersOnce[eventName] = (_a = this._listenersOnce[eventName]) !== null && _a !== void 0 ? _a : [];
            this._listenersOnce[eventName].push(handler);
            return {
                close: ()=>this.off(eventName, handler)
            };
        }
        off(eventName, handler) {
            var _a, _b;
            if (handler) {
                const newListeners = (_a = this._listeners[eventName]) === null || _a === void 0 ? void 0 : _a.filter((h)=>h !== handler);
                this._listeners[eventName] = newListeners;
                const newOnceListeners = (_b = this._listenersOnce[eventName]) === null || _b === void 0 ? void 0 : _b.filter((h)=>h !== handler);
                this._listenersOnce[eventName] = newOnceListeners;
            } else delete this._listeners[eventName];
        }
        emit(eventName, event) {
            var _a;
            if (this._paused) return;
            (_a = this._listeners[eventName]) === null || _a === void 0 || _a.forEach((fn)=>fn(event));
            const onces = this._listenersOnce[eventName];
            this._listenersOnce[eventName] = [];
            if (onces) onces.forEach((fn)=>fn(event));
            this._pipes.forEach((pipe)=>{
                pipe.emit(eventName, event);
            });
        }
        pipe(emitter) {
            if (this === emitter) throw Error("Cannot pipe to self");
            this._pipes.push(emitter);
            return {
                close: ()=>{
                    const i = this._pipes.indexOf(emitter);
                    if (i > -1) this._pipes.splice(i, 1);
                }
            };
        }
        unpipe(emitter) {
            const i = this._pipes.indexOf(emitter);
            if (i > -1) this._pipes.splice(i, 1);
        }
        pause() {
            this._paused = true;
        }
        unpause() {
            this._paused = false;
        }
    }
    /**
 * Determines the scope of handling mouse/touch events.
 */ var PointerScope;
    (function(PointerScope) {
        /**
     * Handle events on the `canvas` element only. Events originating outside the
     * `canvas` will not be handled.
     */ PointerScope["Canvas"] = "Canvas";
        /**
     * Handles events on the entire document. All events will be handled by Excalibur.
     */ PointerScope["Document"] = "Document";
    })(PointerScope || (PointerScope = {}));
    /**
 * @module
 * Pseudo-Random Utility
 *
 * A pseudo-random utility to add seeded random support for help in
 * generating things like terrain or reproducible randomness. Uses the
 * [Mersenne Twister](https://en.wikipedia.org/wiki/Mersenne_Twister) algorithm.
 */ /**
 * 32-bit mask
 */ const BITMASK32 = 0xffffffff;
    /**
 * Pseudo-random number generator following the Mersenne_Twister algorithm. Given a seed this generator will produce the same sequence
 * of numbers each time it is called.
 * See https://en.wikipedia.org/wiki/Mersenne_Twister for more details.
 * Uses the MT19937-32 (2002) implementation documented here http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/MT2002/emt19937ar.html
 *
 * Api inspired by http://chancejs.com/# https://github.com/chancejs/chancejs
 */ class Random {
        /**
     * If no seed is specified, the Date.now() is used
     */ constructor(seed){
            this.seed = seed;
            // Separation point of one one word, the number of bits in the lower bitmask 0 <= r <= w-1
            this._lowerMask = 0x7fffffff; // 31 bits same as _r
            this._upperMask = 0x80000000; // 34 high bits
            // Word size, 64 bits
            this._w = 32;
            // Degree of recurrence
            this._n = 624;
            // Middle word, an offset used in the recurrence defining the series x, 1<=m<n
            this._m = 397;
            // coefficients of teh rational normal form twist matrix
            this._a = 0x9908b0df;
            // tempering bit shifts and masks
            this._u = 11;
            this._s = 7;
            this._b = 0x9d2c5680;
            this._t = 15;
            this._c = 0xefc60000;
            this._l = 18;
            this._f = 1812433253;
            this._mt = new Array(this._n);
            // need to mask to support higher bit machines
            this._mt[0] = (seed || Date.now()) >>> 0;
            for(let i = 1; i < this._n; i++){
                const s = this._mt[i - 1] ^ this._mt[i - 1] >>> this._w - 2;
                // numbers are bigger than the JS max safe int, add in 16-bit chunks to prevent IEEE rounding errors on high bits
                this._mt[i] = (this._f * ((s & 0xffff0000) >>> 16) << 16) + this._f * (s & 0xffff) + i >>> 0;
            }
            this._index = this._n;
        }
        /**
     * Apply the twist
     */ _twist() {
            const mag01 = [
                0x0,
                this._a
            ];
            let y = 0, i = 0;
            for(; i < this._n - this._m; i++){
                y = this._mt[i] & this._upperMask | this._mt[i + 1] & this._lowerMask;
                this._mt[i] = this._mt[i + this._m] ^ y >>> 1 ^ mag01[y & 0x1] & BITMASK32;
            }
            for(; i < this._n - 1; i++){
                y = this._mt[i] & this._upperMask | this._mt[i + 1] & this._lowerMask;
                this._mt[i] = this._mt[i + (this._m - this._n)] ^ y >>> 1 ^ mag01[y & 0x1] & BITMASK32;
            }
            y = this._mt[this._n - 1] & this._upperMask | this._mt[0] & this._lowerMask;
            this._mt[this._n - 1] = this._mt[this._m - 1] ^ y >>> 1 ^ mag01[y & 0x1] & BITMASK32;
            this._index = 0;
        }
        /**
     * Return next 32 bit integer number in sequence
     */ nextInt() {
            if (this._index >= this._n) this._twist();
            let y = this._mt[this._index++];
            y ^= y >>> this._u;
            y ^= y << this._s & this._b;
            y ^= y << this._t & this._c;
            y ^= y >>> this._l;
            return y >>> 0;
        }
        /**
     * Return a random floating point number between [0, 1)
     */ next() {
            return this.nextInt() * (1.0 / 4294967296.0); // divided by 2^32
        }
        /**
     * Return a random floating point in range [min, max) min is included, max is not included
     */ floating(min, max) {
            return (max - min) * this.next() + min;
        }
        /**
     * Return a random integer in range [min, max] min is included, max is included.
     * Implemented with rejection sampling, see https://medium.com/@betable/tifu-by-using-math-random-f1c308c4fd9d#.i13tdiu5a
     */ integer(min, max) {
            return Math.floor((max - min + 1) * this.next() + min);
        }
        /**
     * Returns true or false randomly with 50/50 odds by default.
     * By default the likelihood of returning a true is .5 (50%).
     * @param likelihood takes values between [0, 1]
     */ bool(likelihood = 0.5) {
            return this.next() <= likelihood;
        }
        /**
     * Returns one element from an array at random
     */ pickOne(array) {
            return array[this.integer(0, array.length - 1)];
        }
        /**
     * Returns a new array random picking elements from the original
     * @param array Original array to pick from
     * @param numPicks can be any positive number
     * @param allowDuplicates indicates whether the returned set is allowed duplicates (it does not mean there will always be duplicates
     * just that it is possible)
     */ pickSet(array, numPicks, allowDuplicates = false) {
            if (allowDuplicates) return this._pickSetWithDuplicates(array, numPicks);
            else return this._pickSetWithoutDuplicates(array, numPicks);
        }
        /**
     * Returns a new array randomly picking elements in the original (not reused)
     * @param array Array to pick elements out of
     * @param numPicks must be less than or equal to the number of elements in the array.
     */ _pickSetWithoutDuplicates(array, numPicks) {
            if (numPicks > array.length || numPicks < 0) throw new Error("Invalid number of elements to pick, must pick a value 0 < n <= length");
            if (numPicks === array.length) return array;
            const result = new Array(numPicks);
            let currentPick = 0;
            const tempArray = array.slice(0);
            while(currentPick < numPicks){
                const index = this.integer(0, tempArray.length - 1);
                result[currentPick++] = tempArray[index];
                tempArray.splice(index, 1);
            }
            return result;
        }
        /**
     * Returns a new array random picking elements from the original allowing duplicates
     * @param array Array to pick elements out of
     * @param numPicks can be any positive number
     */ _pickSetWithDuplicates(array, numPicks) {
            // Typescript numbers are all floating point, so do we add check for int? (or floor the input?)
            if (numPicks < 0) throw new Error("Invalid number of elements to pick, must pick a value 0 <= n < MAX_INT");
            const result = new Array(numPicks);
            for(let i = 0; i < numPicks; i++)result[i] = this.pickOne(array);
            return result;
        }
        /**
     * Returns a new array that has its elements shuffled. Using the Fisher/Yates method
     * https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle
     */ shuffle(array) {
            const tempArray = array.slice(0);
            let swap = null;
            for(let i = 0; i < tempArray.length - 2; i++){
                const randomIndex = this.integer(i, tempArray.length - 1);
                swap = tempArray[i];
                tempArray[i] = tempArray[randomIndex];
                tempArray[randomIndex] = swap;
            }
            return tempArray;
        }
        /**
     * Generate a list of random integer numbers
     * @param length the length of the final array
     * @param min the minimum integer number to generate inclusive
     * @param max the maximum integer number to generate inclusive
     */ range(length, min, max) {
            const result = new Array(length);
            for(let i = 0; i < length; i++)result[i] = this.integer(min, max);
            return result;
        }
        /**
     * Returns the result of a d4 dice roll
     */ d4() {
            return this.integer(1, 4);
        }
        /**
     * Returns the result of a d6 dice roll
     */ d6() {
            return this.integer(1, 6);
        }
        /**
     * Returns the result of a d8 dice roll
     */ d8() {
            return this.integer(1, 8);
        }
        /**
     * Returns the result of a d10 dice roll
     */ d10() {
            return this.integer(1, 10);
        }
        /**
     * Returns the result of a d12 dice roll
     */ d12() {
            return this.integer(1, 12);
        }
        /**
     * Returns the result of a d20 dice roll
     */ d20() {
            return this.integer(1, 20);
        }
    }
    /**
 * Two PI constant
 */ const TwoPI = Math.PI * 2;
    /**
 * Returns the fractional part of a number
 * @param x
 */ function frac(x) {
        if (x >= 0) return x - Math.floor(x);
        else return x - Math.ceil(x);
    }
    /**
 * Returns the sign of a number, if 0 returns 0
 */ function sign(val) {
        if (val === 0) return 0;
        return val < 0 ? -1 : 1;
    }
    /**
 * Clamps a value between a min and max inclusive
 */ function clamp(val, min, max) {
        return Math.min(Math.max(min, val), max);
    }
    /**
 * Convert an angle to be the equivalent in the range [0, 2PI]
 */ function canonicalizeAngle(angle) {
        let tmpAngle = angle;
        if (angle > TwoPI) while(tmpAngle > TwoPI)tmpAngle -= TwoPI;
        if (angle < 0) while(tmpAngle < 0)tmpAngle += TwoPI;
        return tmpAngle;
    }
    /**
 * Convert radians to degrees
 */ function toDegrees(radians) {
        return 180 / Math.PI * radians;
    }
    /**
 * Convert degrees to radians
 */ function toRadians(degrees) {
        return degrees / 180 * Math.PI;
    }
    /**
 * Generate a range of numbers
 * For example: range(0, 5) -> [0, 1, 2, 3, 4, 5]
 * @param from inclusive
 * @param to inclusive
 */ const range = (from, to)=>Array.from(new Array(to - from + 1), (_x, i)=>i + from);
    /**
 * Find a random floating point number in range
 */ function randomInRange(min, max, random = new Random()) {
        return random ? random.floating(min, max) : min + Math.random() * (max - min);
    }
    /**
 * Find a random integer in a range
 */ function randomIntInRange(min, max, random = new Random()) {
        return random ? random.integer(min, max) : Math.round(randomInRange(min, max));
    }
    /**
 * A 2D vector on a plane.
 */ class Vector {
        /**
     * A (0, 0) vector
     */ static get Zero() {
            return new Vector(0, 0);
        }
        /**
     * A (1, 1) vector
     */ static get One() {
            return new Vector(1, 1);
        }
        /**
     * A (0.5, 0.5) vector
     */ static get Half() {
            return new Vector(0.5, 0.5);
        }
        /**
     * A unit vector pointing up (0, -1)
     */ static get Up() {
            return new Vector(0, -1);
        }
        /**
     * A unit vector pointing down (0, 1)
     */ static get Down() {
            return new Vector(0, 1);
        }
        /**
     * A unit vector pointing left (-1, 0)
     */ static get Left() {
            return new Vector(-1, 0);
        }
        /**
     * A unit vector pointing right (1, 0)
     */ static get Right() {
            return new Vector(1, 0);
        }
        /**
     * Returns a vector of unit length in the direction of the specified angle in Radians.
     * @param angle The angle to generate the vector
     */ static fromAngle(angle) {
            return new Vector(Math.cos(angle), Math.sin(angle));
        }
        /**
     * Checks if vector is not null, undefined, or if any of its components are NaN or Infinity.
     */ static isValid(vec) {
            if (vec === null || vec === undefined) return false;
            if (isNaN(vec.x) || isNaN(vec.y)) return false;
            if (vec.x === Infinity || vec.y === Infinity || vec.x === -Infinity || vec.y === -Infinity) return false;
            return true;
        }
        /**
     * Calculates distance between two Vectors
     * @param vec1
     * @param vec2
     */ static distance(vec1, vec2) {
            return Math.sqrt(Math.pow(vec1.x - vec2.x, 2) + Math.pow(vec1.y - vec2.y, 2));
        }
        static min(vec1, vec2) {
            return new Vector(Math.min(vec1.x, vec2.x), Math.min(vec1.y, vec2.y));
        }
        static max(vec1, vec2) {
            return new Vector(Math.max(vec1.x, vec2.x), Math.max(vec1.y, vec2.y));
        }
        /**
     * @param x  X component of the Vector
     * @param y  Y component of the Vector
     */ constructor(x, y){
            this._x = 0;
            this._y = 0;
            this._x = x;
            this._y = y;
        }
        /**
     * Get the x component of the vector
     */ get x() {
            return this._x;
        }
        /**
     * Set the x component, THIS MUTATES the current vector. It is usually better to create a new vector.
     * @warning **Be very careful setting components on shared vectors, mutating shared vectors can cause hard to find bugs**
     */ set x(val) {
            this._x = val;
        }
        /**
     * Get the y component of the vector
     */ get y() {
            return this._y;
        }
        /**
     * Set the y component, THIS MUTATES the current vector. It is usually better to create a new vector.
     * @warning **Be very careful setting components on shared vectors, mutating shared vectors can cause hard to find bugs**
     */ set y(val) {
            this._y = val;
        }
        /**
     * Sets the x and y components at once, THIS MUTATES the current vector. It is usually better to create a new vector.
     * @warning **Be very careful using this, mutating vectors can cause hard to find bugs**
     */ setTo(x, y) {
            this.x = x;
            this.y = y;
        }
        /**
     * Compares this point against another and tests for equality
     * @param vector The other point to compare to
     * @param tolerance Amount of euclidean distance off we are willing to tolerate
     */ equals(vector, tolerance = Vector.EQUALS_EPSILON) {
            return Math.abs(this.x - vector.x) <= tolerance && Math.abs(this.y - vector.y) <= tolerance;
        }
        /**
     * The distance to another vector. If no other Vector is specified, this will return the [[magnitude]].
     * @param v  The other vector. Leave blank to use origin vector.
     */ distance(v) {
            if (!v) return Math.sqrt(this.x * this.x + this.y * this.y);
            const deltaX = this.x - v.x;
            const deltaY = this.y - v.y;
            return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        }
        squareDistance(v) {
            if (!v) v = Vector.Zero;
            const deltaX = this.x - v.x;
            const deltaY = this.y - v.y;
            return deltaX * deltaX + deltaY * deltaY;
        }
        /**
     * Clamps the current vector's magnitude mutating it
     * @param magnitude
     */ clampMagnitude(magnitude) {
            const size = this.size;
            const newSize = clamp(size, 0, magnitude);
            this.size = newSize;
            return this;
        }
        /**
     * The size (magnitude) of the Vector
     */ get size() {
            return this.distance();
        }
        /**
     * Setting the size mutates the current vector
     * @warning Can be used to set the size of the vector, **be very careful using this, mutating vectors can cause hard to find bugs**
     */ set size(newLength) {
            const v = this.normalize().scale(newLength);
            this.setTo(v.x, v.y);
        }
        /**
     * Normalizes a vector to have a magnitude of 1.
     */ normalize() {
            const d = this.distance();
            if (d > 0) return new Vector(this.x / d, this.y / d);
            else return new Vector(0, 1);
        }
        /**
     * Returns the average (midpoint) between the current point and the specified
     */ average(vec) {
            return this.add(vec).scale(0.5);
        }
        scale(sizeOrScale, dest) {
            const result = dest || new Vector(0, 0);
            if (sizeOrScale instanceof Vector) {
                result.x = this.x * sizeOrScale.x;
                result.y = this.y * sizeOrScale.y;
            } else {
                result.x = this.x * sizeOrScale;
                result.y = this.y * sizeOrScale;
            }
            return result;
        }
        /**
     * Adds one vector to another
     * @param v The vector to add
     * @param dest Optionally copy the result into a provided vector
     */ add(v, dest) {
            if (dest) {
                dest.x = this.x + v.x;
                dest.y = this.y + v.y;
                return dest;
            }
            return new Vector(this.x + v.x, this.y + v.y);
        }
        /**
     * Subtracts a vector from another, if you subtract vector `B.sub(A)` the resulting vector points from A -> B
     * @param v The vector to subtract
     */ sub(v) {
            return new Vector(this.x - v.x, this.y - v.y);
        }
        /**
     * Adds one vector to this one modifying the original
     * @param v The vector to add
     * @warning Be very careful using this, mutating vectors can cause hard to find bugs
     */ addEqual(v) {
            this.setTo(this.x + v.x, this.y + v.y);
            return this;
        }
        /**
     * Subtracts a vector from this one modifying the original
     * @param v The vector to subtract
     * @warning Be very careful using this, mutating vectors can cause hard to find bugs
     */ subEqual(v) {
            this.setTo(this.x - v.x, this.y - v.y);
            return this;
        }
        /**
     * Scales this vector by a factor of size and modifies the original
     * @warning Be very careful using this, mutating vectors can cause hard to find bugs
     */ scaleEqual(size) {
            this.setTo(this.x * size, this.y * size);
            return this;
        }
        /**
     * Performs a dot product with another vector
     * @param v  The vector to dot
     */ dot(v) {
            return this.x * v.x + this.y * v.y;
        }
        cross(v) {
            if (v instanceof Vector) return this.x * v.y - this.y * v.x;
            else if (typeof v === "number") return new Vector(v * this.y, -v * this.x);
        }
        static cross(num, vec) {
            return new Vector(-num * vec.y, num * vec.x);
        }
        /**
     * Returns the perpendicular vector to this one
     */ perpendicular() {
            return new Vector(this.y, -this.x);
        }
        /**
     * Returns the normal vector to this one, same as the perpendicular of length 1
     */ normal() {
            return this.perpendicular().normalize();
        }
        /**
     * Negate the current vector
     */ negate() {
            return this.scale(-1);
        }
        /**
     * Returns the angle of this vector.
     */ toAngle() {
            return Math.atan2(this.y, this.x);
        }
        /**
     * Rotates the current vector around a point by a certain angle in radians.
     */ rotate(angle, anchor) {
            if (!anchor) anchor = new Vector(0, 0);
            const sinAngle = Math.sin(angle);
            const cosAngle = Math.cos(angle);
            const x = cosAngle * (this.x - anchor.x) - sinAngle * (this.y - anchor.y) + anchor.x;
            const y = sinAngle * (this.x - anchor.x) + cosAngle * (this.y - anchor.y) + anchor.y;
            return new Vector(x, y);
        }
        /**
     * Creates new vector that has the same values as the previous.
     */ clone(dest) {
            const v = dest !== null && dest !== void 0 ? dest : new Vector(0, 0);
            v.x = this.x;
            v.y = this.y;
            return v;
        }
        /**
     * Returns a string representation of the vector.
     */ toString(fixed) {
            if (fixed) return `(${this.x.toFixed(fixed)}, ${this.y.toFixed(fixed)})`;
            return `(${this.x}, ${this.y})`;
        }
    }
    /**
 * Get or set the vector equals epsilon, by default 0.001 meaning vectors within that tolerance on x or y will be considered equal.
 */ Vector.EQUALS_EPSILON = .001;
    /**
 * Shorthand for creating new Vectors - returns a new Vector instance with the
 * provided X and Y components.
 * @param x  X component of the Vector
 * @param y  Y component of the Vector
 */ function vec(x, y) {
        return new Vector(x, y);
    }
    /**
 * Provides standard colors (e.g. [[Color.Black]])
 * but you can also create custom colors using RGB, HSL, or Hex. Also provides
 * useful color operations like [[Color.lighten]], [[Color.darken]], and more.
 */ class Color {
        /**
     * Creates a new instance of Color from an r, g, b, a
     * @param r  The red component of color (0-255)
     * @param g  The green component of color (0-255)
     * @param b  The blue component of color (0-255)
     * @param a  The alpha component of color (0-1.0)
     */ constructor(r, g, b, a){
            this.r = r;
            this.g = g;
            this.b = b;
            this.a = a != null ? a : 1;
        }
        /**
     * Creates a new instance of Color from an r, g, b, a
     * @param r  The red component of color (0-255)
     * @param g  The green component of color (0-255)
     * @param b  The blue component of color (0-255)
     * @param a  The alpha component of color (0-1.0)
     */ static fromRGB(r, g, b, a) {
            return new Color(r, g, b, a);
        }
        /**
     * Creates a new instance of Color from a rgb string
     * @param string  CSS color string of the form rgba(255, 255, 255, 1) or rgb(255, 255, 255)
     */ static fromRGBString(string) {
            const rgbaRegEx = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/i;
            let match = null;
            if (match = string.match(rgbaRegEx)) {
                const r = parseInt(match[1], 10);
                const g = parseInt(match[2], 10);
                const b = parseInt(match[3], 10);
                let a = 1;
                if (match[4]) a = parseFloat(match[4]);
                return new Color(r, g, b, a);
            } else throw new Error("Invalid rgb/a string: " + string);
        }
        /**
     * Creates a new instance of Color from a hex string
     * @param hex  CSS color string of the form #ffffff, the alpha component is optional
     */ static fromHex(hex) {
            const hexRegEx = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})?$/i;
            let match = null;
            if (match = hex.match(hexRegEx)) {
                const r = parseInt(match[1], 16);
                const g = parseInt(match[2], 16);
                const b = parseInt(match[3], 16);
                let a = 1;
                if (match[4]) a = parseInt(match[4], 16) / 255;
                return new Color(r, g, b, a);
            } else throw new Error("Invalid hex string: " + hex);
        }
        /**
     * Creates a new instance of Color from hsla values
     * @param h  Hue is represented [0-1]
     * @param s  Saturation is represented [0-1]
     * @param l  Luminance is represented [0-1]
     * @param a  Alpha is represented [0-1]
     */ static fromHSL(h, s, l, a = 1.0) {
            const temp = new HSLColor(h, s, l, a);
            return temp.toRGBA();
        }
        /**
     * Lightens the current color by a specified amount
     * @param factor  The amount to lighten by [0-1]
     */ lighten(factor = 0.1) {
            const temp = HSLColor.fromRGBA(this.r, this.g, this.b, this.a);
            temp.l += (1 - temp.l) * factor;
            return temp.toRGBA();
        }
        /**
     * Darkens the current color by a specified amount
     * @param factor  The amount to darken by [0-1]
     */ darken(factor = 0.1) {
            const temp = HSLColor.fromRGBA(this.r, this.g, this.b, this.a);
            temp.l -= temp.l * factor;
            return temp.toRGBA();
        }
        /**
     * Saturates the current color by a specified amount
     * @param factor  The amount to saturate by [0-1]
     */ saturate(factor = 0.1) {
            const temp = HSLColor.fromRGBA(this.r, this.g, this.b, this.a);
            temp.s += temp.s * factor;
            return temp.toRGBA();
        }
        /**
     * Desaturates the current color by a specified amount
     * @param factor  The amount to desaturate by [0-1]
     */ desaturate(factor = 0.1) {
            const temp = HSLColor.fromRGBA(this.r, this.g, this.b, this.a);
            temp.s -= temp.s * factor;
            return temp.toRGBA();
        }
        /**
     * Multiplies a color by another, results in a darker color
     * @param color  The other color
     */ multiply(color) {
            const newR = color.r / 255 * this.r / 255 * 255;
            const newG = color.g / 255 * this.g / 255 * 255;
            const newB = color.b / 255 * this.b / 255 * 255;
            const newA = color.a * this.a;
            return new Color(newR, newG, newB, newA);
        }
        /**
     * Screens a color by another, results in a lighter color
     * @param color  The other color
     */ screen(color) {
            const color1 = color.invert();
            const color2 = color.invert();
            return color1.multiply(color2).invert();
        }
        /**
     * Inverts the current color
     */ invert() {
            return new Color(255 - this.r, 255 - this.g, 255 - this.b, 1.0 - this.a);
        }
        /**
     * Averages the current color with another
     * @param color  The other color
     */ average(color) {
            const newR = (color.r + this.r) / 2;
            const newG = (color.g + this.g) / 2;
            const newB = (color.b + this.b) / 2;
            const newA = (color.a + this.a) / 2;
            return new Color(newR, newG, newB, newA);
        }
        equal(color) {
            return this.toString() === color.toString();
        }
        /**
     * Returns a CSS string representation of a color.
     * @param format Color representation, accepts: rgb, hsl, or hex
     */ toString(format = "rgb") {
            switch(format){
                case "rgb":
                    return this.toRGBA();
                case "hsl":
                    return this.toHSLA();
                case "hex":
                    return this.toHex();
                default:
                    throw new Error("Invalid Color format");
            }
        }
        /**
     * Returns Hex Value of a color component
     * @param c color component
     * @see https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
     */ _componentToHex(c) {
            // Handle negative and fractional numbers
            const hex = Math.max(Math.round(c), 0).toString(16);
            return hex.length === 1 ? "0" + hex : hex;
        }
        /**
     * Return Hex representation of a color.
     */ toHex() {
            let hexRepresentation = "#" + this._componentToHex(this.r) + this._componentToHex(this.g) + this._componentToHex(this.b);
            if (this.a !== 1) hexRepresentation += this._componentToHex(this.a * 255);
            return hexRepresentation;
        }
        /**
     * Return RGBA representation of a color.
     */ toRGBA() {
            const result = String(this.r.toFixed(0)) + ", " + String(this.g.toFixed(0)) + ", " + String(this.b.toFixed(0));
            if (this.a !== undefined || this.a !== null) return "rgba(" + result + ", " + String(this.a) + ")";
            return "rgb(" + result + ")";
        }
        /**
     * Return HSLA representation of a color.
     */ toHSLA() {
            return HSLColor.fromRGBA(this.r, this.g, this.b, this.a).toString();
        }
        /**
     * Returns a CSS string representation of a color.
     */ fillStyle() {
            return this.toString();
        }
        /**
     * Returns a clone of the current color.
     */ clone() {
            return new Color(this.r, this.g, this.b, this.a);
        }
        /**
     * Black (#000000)
     */ static get Black() {
            return Color.fromHex("#000000");
        }
        /**
     * White (#FFFFFF)
     */ static get White() {
            return Color.fromHex("#FFFFFF");
        }
        /**
     * Gray (#808080)
     */ static get Gray() {
            return Color.fromHex("#808080");
        }
        /**
     * Light gray (#D3D3D3)
     */ static get LightGray() {
            return Color.fromHex("#D3D3D3");
        }
        /**
     * Dark gray (#A9A9A9)
     */ static get DarkGray() {
            return Color.fromHex("#A9A9A9");
        }
        /**
     * Yellow (#FFFF00)
     */ static get Yellow() {
            return Color.fromHex("#FFFF00");
        }
        /**
     * Orange (#FFA500)
     */ static get Orange() {
            return Color.fromHex("#FFA500");
        }
        /**
     * Red (#FF0000)
     */ static get Red() {
            return Color.fromHex("#FF0000");
        }
        /**
     * Vermilion (#FF5B31)
     */ static get Vermilion() {
            return Color.fromHex("#FF5B31");
        }
        /**
     * Rose (#FF007F)
     */ static get Rose() {
            return Color.fromHex("#FF007F");
        }
        /**
     * Magenta (#FF00FF)
     */ static get Magenta() {
            return Color.fromHex("#FF00FF");
        }
        /**
     * Violet (#7F00FF)
     */ static get Violet() {
            return Color.fromHex("#7F00FF");
        }
        /**
     * Blue (#0000FF)
     */ static get Blue() {
            return Color.fromHex("#0000FF");
        }
        /**
     * Azure (#007FFF)
     */ static get Azure() {
            return Color.fromHex("#007FFF");
        }
        /**
     * Cyan (#00FFFF)
     */ static get Cyan() {
            return Color.fromHex("#00FFFF");
        }
        /**
     * Viridian (#59978F)
     */ static get Viridian() {
            return Color.fromHex("#59978F");
        }
        /**
     * Green (#00FF00)
     */ static get Green() {
            return Color.fromHex("#00FF00");
        }
        /**
     * Chartreuse (#7FFF00)
     */ static get Chartreuse() {
            return Color.fromHex("#7FFF00");
        }
        /**
     * Transparent (#FFFFFF00)
     */ static get Transparent() {
            return Color.fromHex("#FFFFFF00");
        }
        /**
     * ExcaliburBlue (#176BAA)
     */ static get ExcaliburBlue() {
            return Color.fromHex("#176BAA");
        }
    }
    /**
 * Internal HSL Color representation
 *
 * http://en.wikipedia.org/wiki/HSL_and_HSV
 * http://axonflux.com/handy-rgb-to-hsl-and-rgb-to-hsv-color-model-c
 */ class HSLColor {
        constructor(h, s, l, a){
            this.h = h;
            this.s = s;
            this.l = l;
            this.a = a;
        }
        static hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        static fromRGBA(r, g, b, a) {
            r /= 255;
            g /= 255;
            b /= 255;
            const max = Math.max(r, g, b), min = Math.min(r, g, b);
            let h, s;
            const l = (max + min) / 2;
            if (max === min) h = s = 0; // achromatic
            else {
                const d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                }
                h /= 6;
            }
            return new HSLColor(h, s, l, a);
        }
        toRGBA() {
            let r, g, b;
            if (this.s === 0) r = g = b = this.l; // achromatic
            else {
                const q = this.l < 0.5 ? this.l * (1 + this.s) : this.l + this.s - this.l * this.s;
                const p = 2 * this.l - q;
                r = HSLColor.hue2rgb(p, q, this.h + 1 / 3);
                g = HSLColor.hue2rgb(p, q, this.h);
                b = HSLColor.hue2rgb(p, q, this.h - 1 / 3);
            }
            return new Color(r * 255, g * 255, b * 255, this.a);
        }
        toString() {
            const h = this.h.toFixed(0), s = this.s.toFixed(0), l = this.l.toFixed(0), a = this.a.toFixed(0);
            return `hsla(${h}, ${s}, ${l}, ${a})`;
        }
    }
    /* eslint-disable no-console */ /**
 * Logging level that Excalibur will tag
 */ var LogLevel;
    (function(LogLevel) {
        LogLevel[LogLevel["Debug"] = 0] = "Debug";
        LogLevel[LogLevel["Info"] = 1] = "Info";
        LogLevel[LogLevel["Warn"] = 2] = "Warn";
        LogLevel[LogLevel["Error"] = 3] = "Error";
        LogLevel[LogLevel["Fatal"] = 4] = "Fatal";
    })(LogLevel || (LogLevel = {}));
    /**
 * Static singleton that represents the logging facility for Excalibur.
 * Excalibur comes built-in with a [[ConsoleAppender]] and [[ScreenAppender]].
 * Derive from [[Appender]] to create your own logging appenders.
 */ class Logger {
        constructor(){
            this._appenders = [];
            /**
         * Gets or sets the default logging level. Excalibur will only log
         * messages if equal to or above this level. Default: [[LogLevel.Info]]
         */ this.defaultLevel = LogLevel.Info;
            this._logOnceSet = new Set();
            if (Logger._INSTANCE) throw new Error("Logger is a singleton");
            Logger._INSTANCE = this;
            // Default console appender
            Logger._INSTANCE.addAppender(new ConsoleAppender());
            return Logger._INSTANCE;
        }
        /**
     * Gets the current static instance of Logger
     */ static getInstance() {
            if (Logger._INSTANCE == null) Logger._INSTANCE = new Logger();
            return Logger._INSTANCE;
        }
        /**
     * Adds a new [[Appender]] to the list of appenders to write to
     */ addAppender(appender) {
            this._appenders.push(appender);
        }
        /**
     * Clears all appenders from the logger
     */ clearAppenders() {
            this._appenders.length = 0;
        }
        /**
     * Logs a message at a given LogLevel
     * @param level  The LogLevel`to log the message at
     * @param args   An array of arguments to write to an appender
     */ _log(level, args) {
            if (level == null) level = this.defaultLevel;
            const len = this._appenders.length;
            for(let i = 0; i < len; i++)if (level >= this.defaultLevel) this._appenders[i].log(level, args);
        }
        _logOnce(level, args) {
            const serialized = level + args.join("+");
            if (this._logOnceSet.has(serialized)) return;
            else {
                this._logOnceSet.add(serialized);
                this._log(level, args);
            }
        }
        /**
     * Writes a log message at the [[LogLevel.Debug]] level
     * @param args  Accepts any number of arguments
     */ debug(...args) {
            this._log(LogLevel.Debug, args);
        }
        /**
     * Writes a log message once at the [[LogLevel.Fatal]] level, if it sees the same args again it wont log
     * @param args  Accepts any number of arguments
     */ debugOnce(...args) {
            this._logOnce(LogLevel.Debug, args);
        }
        /**
     * Writes a log message at the [[LogLevel.Info]] level
     * @param args  Accepts any number of arguments
     */ info(...args) {
            this._log(LogLevel.Info, args);
        }
        /**
     * Writes a log message once at the [[LogLevel.Info]] level, if it sees the same args again it wont log
     * @param args  Accepts any number of arguments
     */ infoOnce(...args) {
            this._logOnce(LogLevel.Info, args);
        }
        /**
     * Writes a log message at the [[LogLevel.Warn]] level
     * @param args  Accepts any number of arguments
     */ warn(...args) {
            this._log(LogLevel.Warn, args);
        }
        /**
     * Writes a log message once at the [[LogLevel.Warn]] level, if it sees the same args again it won't log
     * @param args  Accepts any number of arguments
     */ warnOnce(...args) {
            this._logOnce(LogLevel.Warn, args);
        }
        /**
     * Writes a log message at the [[LogLevel.Error]] level
     * @param args  Accepts any number of arguments
     */ error(...args) {
            this._log(LogLevel.Error, args);
        }
        /**
     * Writes a log message once at the [[LogLevel.Error]] level, if it sees the same args again it won't log
     * @param args  Accepts any number of arguments
     */ errorOnce(...args) {
            this._logOnce(LogLevel.Error, args);
        }
        /**
     * Writes a log message at the [[LogLevel.Fatal]] level
     * @param args  Accepts any number of arguments
     */ fatal(...args) {
            this._log(LogLevel.Fatal, args);
        }
        /**
     * Writes a log message once at the [[LogLevel.Fatal]] level, if it sees the same args again it won't log
     * @param args  Accepts any number of arguments
     */ fatalOnce(...args) {
            this._logOnce(LogLevel.Fatal, args);
        }
    }
    Logger._INSTANCE = null;
    /**
 * Console appender for browsers (i.e. `console.log`)
 */ class ConsoleAppender {
        /**
     * Logs a message at the given [[LogLevel]]
     * @param level  Level to log at
     * @param args   Arguments to log
     */ log(level, args) {
            // Check for console support
            if (!console && !console.log && console.warn && console.error) // todo maybe do something better than nothing
            return;
            // Create a new console args array
            const consoleArgs = [];
            consoleArgs.unshift.apply(consoleArgs, args);
            consoleArgs.unshift("[" + LogLevel[level] + "] : ");
            if (level < LogLevel.Warn) {
                // Call .log for Debug/Info
                if (console.log.apply) // this is required on some older browsers that don't support apply on console.log :(
                console.log.apply(console, consoleArgs);
                else console.log(consoleArgs.join(" "));
            } else if (level < LogLevel.Error) {
                // Call .warn for Warn
                if (console.warn.apply) console.warn.apply(console, consoleArgs);
                else console.warn(consoleArgs.join(" "));
            } else // Call .error for Error/Fatal
            if (console.error.apply) console.error.apply(console, consoleArgs);
            else console.error(consoleArgs.join(" "));
        }
    }
    /**
 * On-screen (canvas) appender
 */ class ScreenAppender {
        constructor(options){
            var _a, _b;
            this._messages = [];
            this._pos = 10;
            this._color = Color.Black;
            this._options = options;
            this.canvas = document.createElement("canvas");
            this._ctx = this.canvas.getContext("2d");
            this.canvas.style.position = "absolute";
            this.canvas.style.zIndex = (_b = (_a = options.zIndex) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "99";
            document.body.appendChild(this.canvas);
            this._positionScreenAppenderCanvas();
            options.engine.screen.events.on("resize", ()=>{
                this._positionScreenAppenderCanvas();
            });
        }
        _positionScreenAppenderCanvas() {
            var _a, _b, _c, _d;
            const options = this._options;
            this.canvas.width = (_a = options.width) !== null && _a !== void 0 ? _a : options.engine.screen.resolution.width;
            this.canvas.height = (_b = options.height) !== null && _b !== void 0 ? _b : options.engine.screen.resolution.height;
            this.canvas.style.position = "absolute";
            const pagePos = options.engine.screen.screenToPageCoordinates(vec(0, 0));
            this.canvas.style.left = pagePos.x + "px";
            this.canvas.style.top = pagePos.y + "px";
            this._pos = (_c = options.xPos) !== null && _c !== void 0 ? _c : this._pos;
            this._color = (_d = options.color) !== null && _d !== void 0 ? _d : this._color;
        }
        /**
     * Logs a message at the given [[LogLevel]]
     * @param level  Level to log at
     * @param args   Arguments to log
     */ log(level, args) {
            const message = args.join(",");
            this._ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this._messages.unshift("[" + LogLevel[level] + "] : " + message);
            let pos = 10;
            this._messages = this._messages.slice(0, 1000);
            for(let i = 0; i < this._messages.length; i++){
                this._ctx.fillStyle = this._color.toRGBA();
                this._ctx.fillText(this._messages[i], this._pos, pos);
                pos += 10;
            }
        }
    }
    /**
 * An enum that describes the sides of an axis aligned box for collision
 */ var Side;
    (function(Side) {
        Side["None"] = "None";
        Side["Top"] = "Top";
        Side["Bottom"] = "Bottom";
        Side["Left"] = "Left";
        Side["Right"] = "Right";
    })(Side || (Side = {}));
    (function(Side) {
        /**
     * Returns the opposite side from the current
     */ function getOpposite(side) {
            if (side === Side.Top) return Side.Bottom;
            if (side === Side.Bottom) return Side.Top;
            if (side === Side.Left) return Side.Right;
            if (side === Side.Right) return Side.Left;
            return Side.None;
        }
        Side.getOpposite = getOpposite;
        /**
     * Given a vector, return the Side most in that direction (via dot product)
     */ function fromDirection(direction) {
            const directions = [
                Vector.Left,
                Vector.Right,
                Vector.Up,
                Vector.Down
            ];
            const directionEnum = [
                Side.Left,
                Side.Right,
                Side.Top,
                Side.Bottom
            ];
            let max = -Number.MAX_VALUE;
            let maxIndex = -1;
            for(let i = 0; i < directions.length; i++)if (directions[i].dot(direction) > max) {
                max = directions[i].dot(direction);
                maxIndex = i;
            }
            return directionEnum[maxIndex];
        }
        Side.fromDirection = fromDirection;
    })(Side || (Side = {}));
    /**
 * Axis Aligned collision primitive for Excalibur.
 */ class BoundingBox {
        /**
     * Constructor allows passing of either an object with all coordinate components,
     * or the coordinate components passed separately.
     * @param leftOrOptions    Either x coordinate of the left edge or an options object
     * containing the four coordinate components.
     * @param top     y coordinate of the top edge
     * @param right   x coordinate of the right edge
     * @param bottom  y coordinate of the bottom edge
     */ constructor(leftOrOptions = 0, top = 0, right = 0, bottom = 0){
            // Cache bounding box point returns
            this._points = [];
            if (typeof leftOrOptions === "object") {
                this.left = leftOrOptions.left;
                this.top = leftOrOptions.top;
                this.right = leftOrOptions.right;
                this.bottom = leftOrOptions.bottom;
            } else if (typeof leftOrOptions === "number") {
                this.left = leftOrOptions;
                this.top = top;
                this.right = right;
                this.bottom = bottom;
            }
        }
        /**
     * Returns a new instance of [[BoundingBox]] that is a copy of the current instance
     */ clone() {
            return new BoundingBox(this.left, this.top, this.right, this.bottom);
        }
        /**
     * Given bounding box A & B, returns the side relative to A when intersection is performed.
     * @param intersection Intersection vector between 2 bounding boxes
     */ static getSideFromIntersection(intersection) {
            if (!intersection) return Side.None;
            if (intersection) {
                if (Math.abs(intersection.x) > Math.abs(intersection.y)) {
                    if (intersection.x < 0) return Side.Right;
                    return Side.Left;
                } else {
                    if (intersection.y < 0) return Side.Bottom;
                    return Side.Top;
                }
            }
            return Side.None;
        }
        static fromPoints(points) {
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            for(let i = 0; i < points.length; i++){
                if (points[i].x < minX) minX = points[i].x;
                if (points[i].x > maxX) maxX = points[i].x;
                if (points[i].y < minY) minY = points[i].y;
                if (points[i].y > maxY) maxY = points[i].y;
            }
            return new BoundingBox(minX, minY, maxX, maxY);
        }
        /**
     * Creates a bounding box from a width and height
     * @param width
     * @param height
     * @param anchor Default Vector.Half
     * @param pos Default Vector.Zero
     */ static fromDimension(width, height, anchor = Vector.Half, pos = Vector.Zero) {
            return new BoundingBox(-width * anchor.x + pos.x, -height * anchor.y + pos.y, width - width * anchor.x + pos.x, height - height * anchor.y + pos.y);
        }
        /**
     * Returns the calculated width of the bounding box
     */ get width() {
            return this.right - this.left;
        }
        /**
     * Returns the calculated height of the bounding box
     */ get height() {
            return this.bottom - this.top;
        }
        /**
     * Return whether the bounding box has zero dimensions in height,width or both
     */ hasZeroDimensions() {
            return this.width === 0 || this.height === 0;
        }
        /**
     * Returns the center of the bounding box
     */ get center() {
            return new Vector((this.left + this.right) / 2, (this.top + this.bottom) / 2);
        }
        get topLeft() {
            return new Vector(this.left, this.top);
        }
        get bottomRight() {
            return new Vector(this.right, this.bottom);
        }
        get topRight() {
            return new Vector(this.right, this.top);
        }
        get bottomLeft() {
            return new Vector(this.left, this.bottom);
        }
        translate(pos) {
            return new BoundingBox(this.left + pos.x, this.top + pos.y, this.right + pos.x, this.bottom + pos.y);
        }
        /**
     * Rotates a bounding box by and angle and around a point, if no point is specified (0, 0) is used by default. The resulting bounding
     * box is also axis-align. This is useful when a new axis-aligned bounding box is needed for rotated geometry.
     */ rotate(angle, point = Vector.Zero) {
            const points = this.getPoints().map((p)=>p.rotate(angle, point));
            return BoundingBox.fromPoints(points);
        }
        /**
     * Scale a bounding box by a scale factor, optionally provide a point
     * @param scale
     * @param point
     */ scale(scale, point = Vector.Zero) {
            const shifted = this.translate(point);
            return new BoundingBox(shifted.left * scale.x, shifted.top * scale.y, shifted.right * scale.x, shifted.bottom * scale.y);
        }
        /**
     * Transform the axis aligned bounding box by a [[Matrix]], producing a new axis aligned bounding box
     * @param matrix
     */ transform(matrix) {
            // inlined these calculations to not use vectors would speed it up slightly
            // const matFirstColumn = vec(matrix.data[0], matrix.data[1]);
            // const xa = matFirstColumn.scale(this.left);
            const xa1 = matrix.data[0] * this.left;
            const xa2 = matrix.data[1] * this.left;
            // const xb = matFirstColumn.scale(this.right);
            const xb1 = matrix.data[0] * this.right;
            const xb2 = matrix.data[1] * this.right;
            // const matSecondColumn = vec(matrix.data[2], matrix.data[3]);
            // const ya = matSecondColumn.scale(this.top);
            const ya1 = matrix.data[2] * this.top;
            const ya2 = matrix.data[3] * this.top;
            // const yb = matSecondColumn.scale(this.bottom);
            const yb1 = matrix.data[2] * this.bottom;
            const yb2 = matrix.data[3] * this.bottom;
            const matrixPos = matrix.getPosition();
            // const topLeft = Vector.min(xa, xb).add(Vector.min(ya, yb)).add(matrixPos);
            // const bottomRight = Vector.max(xa, xb).add(Vector.max(ya, yb)).add(matrixPos);
            const left = Math.min(xa1, xb1) + Math.min(ya1, yb1) + matrixPos.x;
            const top = Math.min(xa2, xb2) + Math.min(ya2, yb2) + matrixPos.y;
            const right = Math.max(xa1, xb1) + Math.max(ya1, yb1) + matrixPos.x;
            const bottom = Math.max(xa2, xb2) + Math.max(ya2, yb2) + matrixPos.y;
            return new BoundingBox({
                left: left,
                top: top,
                right: right,
                bottom: bottom //: bottomRight.y
            });
        }
        /**
     * Returns the perimeter of the bounding box
     */ getPerimeter() {
            const wx = this.width;
            const wy = this.height;
            return 2 * (wx + wy);
        }
        /**
     * Returns the world space points that make up the corners of the bounding box as a polygon
     */ getPoints() {
            if (this._left !== this.left || this._right !== this.right || this._top !== this.top || this._bottom !== this.bottom) {
                this._points.length = 0;
                this._points.push(new Vector(this.left, this.top));
                this._points.push(new Vector(this.right, this.top));
                this._points.push(new Vector(this.right, this.bottom));
                this._points.push(new Vector(this.left, this.bottom));
                this._left = this.left;
                this._right = this.right;
                this._top = this.top;
                this._bottom = this.bottom;
            }
            return this._points;
        }
        /**
     * Determines whether a ray intersects with a bounding box
     */ rayCast(ray, farClipDistance = Infinity) {
            // algorithm from https://tavianator.com/fast-branchless-raybounding-box-intersections/
            let tmin = -Infinity;
            let tmax = Infinity;
            const xinv = ray.dir.x === 0 ? Number.MAX_VALUE : 1 / ray.dir.x;
            const yinv = ray.dir.y === 0 ? Number.MAX_VALUE : 1 / ray.dir.y;
            const tx1 = (this.left - ray.pos.x) * xinv;
            const tx2 = (this.right - ray.pos.x) * xinv;
            tmin = Math.min(tx1, tx2);
            tmax = Math.max(tx1, tx2);
            const ty1 = (this.top - ray.pos.y) * yinv;
            const ty2 = (this.bottom - ray.pos.y) * yinv;
            tmin = Math.max(tmin, Math.min(ty1, ty2));
            tmax = Math.min(tmax, Math.max(ty1, ty2));
            return tmax >= Math.max(0, tmin) && tmin < farClipDistance;
        }
        rayCastTime(ray, farClipDistance = Infinity) {
            // algorithm from https://tavianator.com/fast-branchless-raybounding-box-intersections/
            let tmin = -Infinity;
            let tmax = Infinity;
            const xinv = ray.dir.x === 0 ? Number.MAX_VALUE : 1 / ray.dir.x;
            const yinv = ray.dir.y === 0 ? Number.MAX_VALUE : 1 / ray.dir.y;
            const tx1 = (this.left - ray.pos.x) * xinv;
            const tx2 = (this.right - ray.pos.x) * xinv;
            tmin = Math.min(tx1, tx2);
            tmax = Math.max(tx1, tx2);
            const ty1 = (this.top - ray.pos.y) * yinv;
            const ty2 = (this.bottom - ray.pos.y) * yinv;
            tmin = Math.max(tmin, Math.min(ty1, ty2));
            tmax = Math.min(tmax, Math.max(ty1, ty2));
            if (tmax >= Math.max(0, tmin) && tmin < farClipDistance) return tmin;
            return -1;
        }
        contains(val) {
            if (val instanceof Vector) return this.left <= val.x && this.top <= val.y && this.bottom >= val.y && this.right >= val.x;
            else if (val instanceof BoundingBox) {
                if (this.left <= val.left && this.top <= val.top && val.bottom <= this.bottom && val.right <= this.right) return true;
                return false;
            }
            return false;
        }
        /**
     * Combines this bounding box and another together returning a new bounding box
     * @param other  The bounding box to combine
     */ combine(other) {
            const compositeBB = new BoundingBox(Math.min(this.left, other.left), Math.min(this.top, other.top), Math.max(this.right, other.right), Math.max(this.bottom, other.bottom));
            return compositeBB;
        }
        get dimensions() {
            return new Vector(this.width, this.height);
        }
        /**
     * Returns true if the bounding boxes overlap.
     * @param other
     * @param epsilon Optionally specify a small epsilon (default 0) as amount of overlap to ignore as overlap.
     * This epsilon is useful in stable collision simulations.
     */ overlaps(other, epsilon) {
            const e = epsilon || 0;
            if (other.hasZeroDimensions()) return this.contains(other);
            if (this.hasZeroDimensions()) return other.contains(this);
            const totalBoundingBox = this.combine(other);
            return totalBoundingBox.width + e < other.width + this.width && totalBoundingBox.height + e < other.height + this.height;
        }
        /**
     * Test wether this bounding box intersects with another returning
     * the intersection vector that can be used to resolve the collision. If there
     * is no intersection null is returned.
     * @param other  Other [[BoundingBox]] to test intersection with
     * @returns A Vector in the direction of the current BoundingBox, this <- other
     */ intersect(other) {
            const totalBoundingBox = this.combine(other);
            // If the total bounding box is less than or equal the sum of the 2 bounds then there is collision
            if (totalBoundingBox.width < other.width + this.width && totalBoundingBox.height < other.height + this.height && !totalBoundingBox.dimensions.equals(other.dimensions) && !totalBoundingBox.dimensions.equals(this.dimensions)) {
                // collision
                let overlapX = 0;
                // right edge is between the other's left and right edge
                /**
             *     +-this-+
             *     |      |
             *     |    +-other-+
             *     +----|-+     |
             *          |       |
             *          +-------+
             *         <---
             *          ^ overlap
             */ if (this.right >= other.left && this.right <= other.right) overlapX = other.left - this.right;
                else overlapX = other.right - this.left;
                let overlapY = 0;
                // top edge is between the other's top and bottom edge
                /**
             *     +-other-+
             *     |       |
             *     |    +-this-+   | <- overlap
             *     +----|--+   |   |
             *          |      |  \ /
             *          +------+   '
             */ if (this.top <= other.bottom && this.top >= other.top) overlapY = other.bottom - this.top;
                else overlapY = other.top - this.bottom;
                if (Math.abs(overlapX) < Math.abs(overlapY)) return new Vector(overlapX, 0);
                else return new Vector(0, overlapY);
            // Case of total containment of one bounding box by another
            } else if (totalBoundingBox.dimensions.equals(other.dimensions) || totalBoundingBox.dimensions.equals(this.dimensions)) {
                let overlapX = 0;
                // this is wider than the other
                if (this.width - other.width >= 0) {
                    // This right edge is closest to the others right edge
                    if (this.right - other.right <= other.left - this.left) overlapX = other.left - this.right;
                    else overlapX = other.right - this.left;
                } else // This right edge is closest to the others right edge
                if (other.right - this.right <= this.left - other.left) overlapX = this.left - other.right;
                else overlapX = this.right - other.left;
                let overlapY = 0;
                // this is taller than other
                if (this.height - other.height >= 0) {
                    // The bottom edge is closest to the others bottom edge
                    if (this.bottom - other.bottom <= other.top - this.top) overlapY = other.top - this.bottom;
                    else overlapY = other.bottom - this.top;
                } else // The bottom edge is closest to the others bottom edge
                if (other.bottom - this.bottom <= this.top - other.top) overlapY = this.top - other.bottom;
                else overlapY = this.bottom - other.top;
                if (Math.abs(overlapX) < Math.abs(overlapY)) return new Vector(overlapX, 0);
                else return new Vector(0, overlapY);
            } else return null;
        }
        /**
     * Test whether the bounding box has intersected with another bounding box, returns the side of the current bb that intersected.
     * @param bb The other actor to test
     */ intersectWithSide(bb) {
            const intersect = this.intersect(bb);
            return BoundingBox.getSideFromIntersection(intersect);
        }
        /**
     * Draw a debug bounding box
     * @param ex
     * @param color
     */ draw(ex, color = Color.Yellow) {
            ex.debug.drawRect(this.left, this.top, this.width, this.height, {
                color: color
            });
        }
    }
    /**
 * Find the screen position of an HTML element
 */ function getPosition(el) {
        // do we need the scroll too? technically the offset method before did that
        if (el) {
            const rect = el.getBoundingClientRect();
            return vec(rect.x + window.scrollX, rect.y + window.scrollY);
        }
        return Vector.Zero;
    }
    /**
 * Add an item to an array list if it doesn't already exist. Returns true if added, false if not and already exists in the array.
 * @deprecated Will be removed in v0.26.0
 */ function addItemToArray(item, array) {
        if (array.indexOf(item) === -1) {
            array.push(item);
            return true;
        }
        return false;
    }
    /**
 * Remove an item from an list
 * @deprecated Will be removed in v0.26.0
 */ function removeItemFromArray(item, array) {
        let index = -1;
        if ((index = array.indexOf(item)) > -1) {
            array.splice(index, 1);
            return true;
        }
        return false;
    }
    /**
 * See if an array contains something
 */ function contains(array, obj) {
        for(let i = 0; i < array.length; i++){
            if (array[i] === obj) return true;
        }
        return false;
    }
    /**
 * Used for exhaustive checks at compile time
 */ function fail(message) {
        throw new Error(message);
    }
    /**
 * Create a promise that resolves after a certain number of milliseconds
 *
 * It is strongly recommended you pass the excalibur clock so delays are bound to the
 * excalibur clock which would be unaffected by stop/pause.
 * @param milliseconds
 * @param clock
 */ function delay(milliseconds, clock) {
        var _a;
        const future = new Future();
        const schedule = (_a = clock === null || clock === void 0 ? void 0 : clock.schedule.bind(clock)) !== null && _a !== void 0 ? _a : setTimeout;
        schedule(()=>{
            future.resolve();
        }, milliseconds);
        return future.promise;
    }
    /**
 * Remove keys from object literals
 * @param object
 * @param keys
 */ function omit(object, keys) {
        const newObj = {};
        for(const key in object)if (!keys.includes(key)) newObj[key] = object[key];
        return newObj;
    }
    var MatrixLocations;
    (function(MatrixLocations) {
        MatrixLocations[MatrixLocations["X"] = 12] = "X";
        MatrixLocations[MatrixLocations["Y"] = 13] = "Y";
    })(MatrixLocations || (MatrixLocations = {}));
    /**
 * Excalibur Matrix helper for 4x4 matrices
 *
 * Useful for webgl 4x4 matrices
 */ class Matrix {
        constructor(){
            /**
         *  4x4 matrix in column major order
         *
         * |         |         |          |          |
         * | ------- | ------- | -------- | -------- |
         * | data[0] | data[4] | data[8]  | data[12] |
         * | data[1] | data[5] | data[9]  | data[13] |
         * | data[2] | data[6] | data[10] | data[14] |
         * | data[3] | data[7] | data[11] | data[15] |
         *
         */ this.data = new Float32Array(16);
            this._scaleX = 1;
            this._scaleSignX = 1;
            this._scaleY = 1;
            this._scaleSignY = 1;
        }
        /**
     * Creates an orthographic (flat non-perspective) projection
     * https://en.wikipedia.org/wiki/Orthographic_projection
     * @param left
     * @param right
     * @param bottom
     * @param top
     * @param near
     * @param far
     */ static ortho(left, right, bottom, top, near, far) {
            const mat = new Matrix();
            mat.data[0] = 2 / (right - left);
            mat.data[1] = 0;
            mat.data[2] = 0;
            mat.data[3] = 0;
            mat.data[4] = 0;
            mat.data[5] = 2 / (top - bottom);
            mat.data[6] = 0;
            mat.data[7] = 0;
            mat.data[8] = 0;
            mat.data[9] = 0;
            mat.data[10] = -2 / (far - near);
            mat.data[11] = 0;
            mat.data[12] = -(right + left) / (right - left);
            mat.data[13] = -(top + bottom) / (top - bottom);
            mat.data[14] = -(far + near) / (far - near);
            mat.data[15] = 1;
            return mat;
        }
        /**
     * Creates a new Matrix with the same data as the current 4x4
     */ clone(dest) {
            const mat = dest || new Matrix();
            mat.data[0] = this.data[0];
            mat.data[1] = this.data[1];
            mat.data[2] = this.data[2];
            mat.data[3] = this.data[3];
            mat.data[4] = this.data[4];
            mat.data[5] = this.data[5];
            mat.data[6] = this.data[6];
            mat.data[7] = this.data[7];
            mat.data[8] = this.data[8];
            mat.data[9] = this.data[9];
            mat.data[10] = this.data[10];
            mat.data[11] = this.data[11];
            mat.data[12] = this.data[12];
            mat.data[13] = this.data[13];
            mat.data[14] = this.data[14];
            mat.data[15] = this.data[15];
            return mat;
        }
        /**
     * Converts the current matrix into a DOMMatrix
     *
     * This is useful when working with the browser Canvas context
     * @returns {DOMMatrix} DOMMatrix
     */ toDOMMatrix() {
            return new DOMMatrix([
                ...this.data
            ]);
        }
        static fromFloat32Array(data) {
            const matrix = new Matrix();
            matrix.data = data;
            return matrix;
        }
        /**
     * Creates a new identity matrix (a matrix that when applied does nothing)
     */ static identity() {
            const mat = new Matrix();
            mat.data[0] = 1;
            mat.data[1] = 0;
            mat.data[2] = 0;
            mat.data[3] = 0;
            mat.data[4] = 0;
            mat.data[5] = 1;
            mat.data[6] = 0;
            mat.data[7] = 0;
            mat.data[8] = 0;
            mat.data[9] = 0;
            mat.data[10] = 1;
            mat.data[11] = 0;
            mat.data[12] = 0;
            mat.data[13] = 0;
            mat.data[14] = 0;
            mat.data[15] = 1;
            return mat;
        }
        /**
     * Resets the current matrix to the identity matrix, mutating it
     * @returns {Matrix} Current matrix as identity
     */ reset() {
            const mat = this;
            mat.data[0] = 1;
            mat.data[1] = 0;
            mat.data[2] = 0;
            mat.data[3] = 0;
            mat.data[4] = 0;
            mat.data[5] = 1;
            mat.data[6] = 0;
            mat.data[7] = 0;
            mat.data[8] = 0;
            mat.data[9] = 0;
            mat.data[10] = 1;
            mat.data[11] = 0;
            mat.data[12] = 0;
            mat.data[13] = 0;
            mat.data[14] = 0;
            mat.data[15] = 1;
            return mat;
        }
        /**
     * Creates a brand new translation matrix at the specified 3d point
     * @param x
     * @param y
     */ static translation(x, y) {
            const mat = Matrix.identity();
            mat.data[12] = x;
            mat.data[13] = y;
            return mat;
        }
        /**
     * Creates a brand new scaling matrix with the specified scaling factor
     * @param sx
     * @param sy
     */ static scale(sx, sy) {
            const mat = Matrix.identity();
            mat.data[0] = sx;
            mat.data[5] = sy;
            mat.data[10] = 1;
            mat.data[15] = 1;
            return mat;
        }
        /**
     * Creates a brand new rotation matrix with the specified angle
     * @param angleRadians
     */ static rotation(angleRadians) {
            const mat = Matrix.identity();
            mat.data[0] = Math.cos(angleRadians);
            mat.data[4] = -Math.sin(angleRadians);
            mat.data[1] = Math.sin(angleRadians);
            mat.data[5] = Math.cos(angleRadians);
            return mat;
        }
        multiply(vectorOrMatrix, dest) {
            if (vectorOrMatrix instanceof Vector) {
                const result = dest || new Vector(0, 0);
                const vector = vectorOrMatrix;
                // these shenanigans are to allow dest and vector to be the same instance
                const resultX = vector.x * this.data[0] + vector.y * this.data[4] + this.data[12];
                const resultY = vector.x * this.data[1] + vector.y * this.data[5] + this.data[13];
                result.x = resultX;
                result.y = resultY;
                return result;
            } else {
                const result = dest || new Matrix();
                const other = vectorOrMatrix;
                const a11 = this.data[0];
                const a21 = this.data[1];
                const a31 = this.data[2];
                const a41 = this.data[3];
                const a12 = this.data[4];
                const a22 = this.data[5];
                const a32 = this.data[6];
                const a42 = this.data[7];
                const a13 = this.data[8];
                const a23 = this.data[9];
                const a33 = this.data[10];
                const a43 = this.data[11];
                const a14 = this.data[12];
                const a24 = this.data[13];
                const a34 = this.data[14];
                const a44 = this.data[15];
                const b11 = other.data[0];
                const b21 = other.data[1];
                const b31 = other.data[2];
                const b41 = other.data[3];
                const b12 = other.data[4];
                const b22 = other.data[5];
                const b32 = other.data[6];
                const b42 = other.data[7];
                const b13 = other.data[8];
                const b23 = other.data[9];
                const b33 = other.data[10];
                const b43 = other.data[11];
                const b14 = other.data[12];
                const b24 = other.data[13];
                const b34 = other.data[14];
                const b44 = other.data[15];
                result.data[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
                result.data[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
                result.data[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
                result.data[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
                result.data[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
                result.data[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
                result.data[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
                result.data[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
                result.data[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
                result.data[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
                result.data[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
                result.data[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
                result.data[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
                result.data[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
                result.data[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
                result.data[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
                const s = this.getScale();
                result._scaleSignX = sign(s.x) * sign(result._scaleSignX);
                result._scaleSignY = sign(s.y) * sign(result._scaleSignY);
                return result;
            }
        }
        /**
     * Applies translation to the current matrix mutating it
     * @param x
     * @param y
     */ translate(x, y) {
            const a11 = this.data[0];
            const a21 = this.data[1];
            const a31 = this.data[2];
            const a41 = this.data[3];
            const a12 = this.data[4];
            const a22 = this.data[5];
            const a32 = this.data[6];
            const a42 = this.data[7];
            const a13 = this.data[8];
            const a23 = this.data[9];
            const a33 = this.data[10];
            const a43 = this.data[11];
            const a14 = this.data[12];
            const a24 = this.data[13];
            const a34 = this.data[14];
            const a44 = this.data[15];
            // Doesn't change z
            const z = 0;
            const w = 1;
            this.data[12] = a11 * x + a12 * y + a13 * z + a14 * w;
            this.data[13] = a21 * x + a22 * y + a23 * z + a24 * w;
            this.data[14] = a31 * x + a32 * y + a33 * z + a34 * w;
            this.data[15] = a41 * x + a42 * y + a43 * z + a44 * w;
            return this;
        }
        setPosition(x, y) {
            this.data[12] = x;
            this.data[13] = y;
        }
        getPosition() {
            return vec(this.data[12], this.data[13]);
        }
        /**
     * Applies rotation to the current matrix mutating it
     * @param angle in Radians
     */ rotate(angle) {
            const a11 = this.data[0];
            const a21 = this.data[1];
            const a31 = this.data[2];
            const a41 = this.data[3];
            const a12 = this.data[4];
            const a22 = this.data[5];
            const a32 = this.data[6];
            const a42 = this.data[7];
            const sine = Math.sin(angle);
            const cosine = Math.cos(angle);
            this.data[0] = cosine * a11 + sine * a12;
            this.data[1] = cosine * a21 + sine * a22;
            this.data[2] = cosine * a31 + sine * a32;
            this.data[3] = cosine * a41 + sine * a42;
            this.data[4] = cosine * a12 - sine * a11;
            this.data[5] = cosine * a22 - sine * a21;
            this.data[6] = cosine * a32 - sine * a31;
            this.data[7] = cosine * a42 - sine * a41;
            return this;
        }
        /**
     * Applies scaling to the current matrix mutating it
     * @param x
     * @param y
     */ scale(x, y) {
            const a11 = this.data[0];
            const a21 = this.data[1];
            const a31 = this.data[2];
            const a41 = this.data[3];
            const a12 = this.data[4];
            const a22 = this.data[5];
            const a32 = this.data[6];
            const a42 = this.data[7];
            this.data[0] = a11 * x;
            this.data[1] = a21 * x;
            this.data[2] = a31 * x;
            this.data[3] = a41 * x;
            this.data[4] = a12 * y;
            this.data[5] = a22 * y;
            this.data[6] = a32 * y;
            this.data[7] = a42 * y;
            return this;
        }
        setRotation(angle) {
            const currentScale = this.getScale();
            const sine = Math.sin(angle);
            const cosine = Math.cos(angle);
            this.data[0] = cosine * currentScale.x;
            this.data[1] = sine * currentScale.y;
            this.data[4] = -sine * currentScale.x;
            this.data[5] = cosine * currentScale.y;
        }
        getRotation() {
            const angle = Math.atan2(this.data[1] / this.getScaleY(), this.data[0] / this.getScaleX());
            return canonicalizeAngle(angle);
        }
        getScaleX() {
            // absolute scale of the matrix (we lose sign so need to add it back)
            const xscale = vec(this.data[0], this.data[4]).size;
            return this._scaleSignX * xscale;
        }
        getScaleY() {
            // absolute scale of the matrix (we lose sign so need to add it back)
            const yscale = vec(this.data[1], this.data[5]).size;
            return this._scaleSignY * yscale;
        }
        /**
     * Get the scale of the matrix
     */ getScale() {
            return vec(this.getScaleX(), this.getScaleY());
        }
        setScaleX(val) {
            if (this._scaleX === val) return;
            this._scaleSignX = sign(val);
            // negative scale acts like a 180 rotation, so flip
            const xscale = vec(this.data[0] * this._scaleSignX, this.data[4] * this._scaleSignX).normalize();
            this.data[0] = xscale.x * val;
            this.data[4] = xscale.y * val;
            this._scaleX = val;
        }
        setScaleY(val) {
            if (this._scaleY === val) return;
            this._scaleSignY = sign(val);
            // negative scale acts like a 180 rotation, so flip
            const yscale = vec(this.data[1] * this._scaleSignY, this.data[5] * this._scaleSignY).normalize();
            this.data[1] = yscale.x * val;
            this.data[5] = yscale.y * val;
            this._scaleY = val;
        }
        setScale(scale) {
            this.setScaleX(scale.x);
            this.setScaleY(scale.y);
        }
        /**
     * Determinant of the upper left 2x2 matrix
     */ getBasisDeterminant() {
            return this.data[0] * this.data[5] - this.data[1] * this.data[4];
        }
        /**
     * Return the affine inverse, optionally store it in a target matrix.
     *
     * It's recommended you call .reset() the target unless you know what you're doing
     * @param target
     */ getAffineInverse(target) {
            // See http://negativeprobability.blogspot.com/2011/11/affine-transformations-and-their.html
            // See https://www.mathsisfun.com/algebra/matrix-inverse.html
            // Since we are actually only doing 2D transformations we can use this hack
            // We don't actually use the 3rd or 4th dimension
            const det = this.getBasisDeterminant();
            const inverseDet = 1 / det; // todo zero check
            const a = this.data[0];
            const b = this.data[4];
            const c = this.data[1];
            const d = this.data[5];
            const m = target || Matrix.identity();
            // inverts rotation and scale
            m.data[0] = d * inverseDet;
            m.data[1] = -c * inverseDet;
            m.data[4] = -b * inverseDet;
            m.data[5] = a * inverseDet;
            const tx = this.data[12];
            const ty = this.data[13];
            // invert translation
            // transform translation into the matrix basis created by rot/scale
            m.data[12] = -(tx * m.data[0] + ty * m.data[4]);
            m.data[13] = -(tx * m.data[1] + ty * m.data[5]);
            return m;
        }
        isIdentity() {
            return this.data[0] === 1 && this.data[1] === 0 && this.data[2] === 0 && this.data[3] === 0 && this.data[4] === 0 && this.data[5] === 1 && this.data[6] === 0 && this.data[7] === 0 && this.data[8] === 0 && this.data[9] === 0 && this.data[10] === 1 && this.data[11] === 0 && this.data[12] === 0 && this.data[13] === 0 && this.data[14] === 0 && this.data[15] === 1;
        }
        toString() {
            return `
[${this.data[0]} ${this.data[4]} ${this.data[8]} ${this.data[12]}]
[${this.data[1]} ${this.data[5]} ${this.data[9]} ${this.data[13]}]
[${this.data[2]} ${this.data[6]} ${this.data[10]} ${this.data[14]}]
[${this.data[3]} ${this.data[7]} ${this.data[11]} ${this.data[15]}]
`;
        }
    }
    class AffineMatrix {
        constructor(){
            /**
         * |         |         |          |
         * | ------- | ------- | -------- |
         * | data[0] | data[2] | data[4]  |
         * | data[1] | data[3] | data[5]  |
         * |   0     |    0    |    1     |
         */ this.data = new Float64Array(6);
            this._scale = new Float64Array([
                1,
                1
            ]);
            this._scaleSignX = 1;
            this._scaleSignY = 1;
        }
        /**
     * Converts the current matrix into a DOMMatrix
     *
     * This is useful when working with the browser Canvas context
     * @returns {DOMMatrix} DOMMatrix
     */ toDOMMatrix() {
            return new DOMMatrix([
                ...this.data
            ]);
        }
        static identity() {
            const mat = new AffineMatrix();
            mat.data[0] = 1;
            mat.data[1] = 0;
            mat.data[2] = 0;
            mat.data[3] = 1;
            mat.data[4] = 0;
            mat.data[5] = 0;
            return mat;
        }
        /**
     * Creates a brand new translation matrix at the specified 3d point
     * @param x
     * @param y
     */ static translation(x, y) {
            const mat = AffineMatrix.identity();
            mat.data[4] = x;
            mat.data[5] = y;
            return mat;
        }
        /**
     * Creates a brand new scaling matrix with the specified scaling factor
     * @param sx
     * @param sy
     */ static scale(sx, sy) {
            const mat = AffineMatrix.identity();
            mat.data[0] = sx;
            mat.data[3] = sy;
            mat._scale[0] = sx;
            mat._scale[1] = sy;
            return mat;
        }
        /**
     * Creates a brand new rotation matrix with the specified angle
     * @param angleRadians
     */ static rotation(angleRadians) {
            const mat = AffineMatrix.identity();
            mat.data[0] = Math.cos(angleRadians);
            mat.data[1] = Math.sin(angleRadians);
            mat.data[2] = -Math.sin(angleRadians);
            mat.data[3] = Math.cos(angleRadians);
            return mat;
        }
        setPosition(x, y) {
            this.data[4] = x;
            this.data[5] = y;
        }
        getPosition() {
            return vec(this.data[4], this.data[5]);
        }
        /**
     * Applies rotation to the current matrix mutating it
     * @param angle in Radians
     */ rotate(angle) {
            const a11 = this.data[0];
            const a21 = this.data[1];
            const a12 = this.data[2];
            const a22 = this.data[3];
            const sine = Math.sin(angle);
            const cosine = Math.cos(angle);
            this.data[0] = cosine * a11 + sine * a12;
            this.data[1] = cosine * a21 + sine * a22;
            this.data[2] = cosine * a12 - sine * a11;
            this.data[3] = cosine * a22 - sine * a21;
            return this;
        }
        /**
     * Applies translation to the current matrix mutating it
     * @param x
     * @param y
     */ translate(x, y) {
            const a11 = this.data[0];
            const a21 = this.data[1];
            // const a31 = 0;
            const a12 = this.data[2];
            const a22 = this.data[3];
            // const a32 = 0;
            const a13 = this.data[4];
            const a23 = this.data[5];
            // const a33 = 1;
            // Doesn't change z
            this.data[4] = a11 * x + a12 * y + a13;
            this.data[5] = a21 * x + a22 * y + a23;
            return this;
        }
        /**
     * Applies scaling to the current matrix mutating it
     * @param x
     * @param y
     */ scale(x, y) {
            const a11 = this.data[0];
            const a21 = this.data[1];
            const a12 = this.data[2];
            const a22 = this.data[3];
            this.data[0] = a11 * x;
            this.data[1] = a21 * x;
            this.data[2] = a12 * y;
            this.data[3] = a22 * y;
            this._scale[0] = x;
            this._scale[1] = y;
            return this;
        }
        determinant() {
            return this.data[0] * this.data[3] - this.data[1] * this.data[2];
        }
        /**
     * Return the affine inverse, optionally store it in a target matrix.
     *
     * It's recommended you call .reset() the target unless you know what you're doing
     * @param target
     */ inverse(target) {
            // See http://negativeprobability.blogspot.com/2011/11/affine-transformations-and-their.html
            // See https://www.mathsisfun.com/algebra/matrix-inverse.html
            // Since we are actually only doing 2D transformations we can use this hack
            // We don't actually use the 3rd or 4th dimension
            const det = this.determinant();
            const inverseDet = 1 / det; // TODO zero check
            const a = this.data[0];
            const b = this.data[2];
            const c = this.data[1];
            const d = this.data[3];
            const m = target || AffineMatrix.identity();
            // inverts rotation and scale
            m.data[0] = d * inverseDet;
            m.data[1] = -c * inverseDet;
            m.data[2] = -b * inverseDet;
            m.data[3] = a * inverseDet;
            const tx = this.data[4];
            const ty = this.data[5];
            // invert translation
            // transform translation into the matrix basis created by rot/scale
            m.data[4] = -(tx * m.data[0] + ty * m.data[2]);
            m.data[5] = -(tx * m.data[1] + ty * m.data[3]);
            return m;
        }
        multiply(vectorOrMatrix, dest) {
            if (vectorOrMatrix instanceof Vector) {
                const result = dest || new Vector(0, 0);
                const vector = vectorOrMatrix;
                // these shenanigans are to allow dest and vector to be the same instance
                const resultX = vector.x * this.data[0] + vector.y * this.data[2] + this.data[4];
                const resultY = vector.x * this.data[1] + vector.y * this.data[3] + this.data[5];
                result.x = resultX;
                result.y = resultY;
                return result;
            } else {
                const result = dest || new AffineMatrix();
                const other = vectorOrMatrix;
                const a11 = this.data[0];
                const a21 = this.data[1];
                //  const a31 = 0;
                const a12 = this.data[2];
                const a22 = this.data[3];
                //  const a32 = 0;
                const a13 = this.data[4];
                const a23 = this.data[5];
                //  const a33 = 1;
                const b11 = other.data[0];
                const b21 = other.data[1];
                //  const b31 = 0;
                const b12 = other.data[2];
                const b22 = other.data[3];
                //  const b32 = 0;
                const b13 = other.data[4];
                const b23 = other.data[5];
                //  const b33 = 1;
                result.data[0] = a11 * b11 + a12 * b21; // + a13 * b31; // zero
                result.data[1] = a21 * b11 + a22 * b21; // + a23 * b31; // zero
                result.data[2] = a11 * b12 + a12 * b22; // + a13 * b32; // zero
                result.data[3] = a21 * b12 + a22 * b22; // + a23 * b32; // zero
                result.data[4] = a11 * b13 + a12 * b23 + a13; // * b33; // one
                result.data[5] = a21 * b13 + a22 * b23 + a23; // * b33; // one
                const s = this.getScale();
                result._scaleSignX = sign(s.x) * sign(result._scaleSignX);
                result._scaleSignY = sign(s.y) * sign(result._scaleSignY);
                return result;
            }
        }
        /**
     * Packed array of length 8, that contains 4 vertices, with 2 components each
     * So: [x0, y0, x1, y1, x2, y2, x3, y3]
     * @param quad
     */ multiplyQuadInPlace(quad) {
            const resultTopLeftX = quad[0] * this.data[0] + quad[1] * this.data[2] + this.data[4];
            const resultTopLeftY = quad[0] * this.data[1] + quad[1] * this.data[3] + this.data[5];
            quad[0] = resultTopLeftX;
            quad[1] = resultTopLeftY;
            const resultTopRightX = quad[2] * this.data[0] + quad[3] * this.data[2] + this.data[4];
            const resultTopRightY = quad[2] * this.data[1] + quad[3] * this.data[3] + this.data[5];
            quad[2] = resultTopRightX;
            quad[3] = resultTopRightY;
            const resultBottomLeftX = quad[4] * this.data[0] + quad[5] * this.data[2] + this.data[4];
            const resultBottomLeftY = quad[4] * this.data[1] + quad[5] * this.data[3] + this.data[5];
            quad[4] = resultBottomLeftX;
            quad[5] = resultBottomLeftY;
            const resultBottomRightX = quad[6] * this.data[0] + quad[7] * this.data[2] + this.data[4];
            const resultBottomRightY = quad[6] * this.data[1] + quad[7] * this.data[3] + this.data[5];
            quad[6] = resultBottomRightX;
            quad[7] = resultBottomRightY;
        }
        to4x4() {
            const mat = new Matrix();
            mat.data[0] = this.data[0];
            mat.data[1] = this.data[1];
            mat.data[2] = 0;
            mat.data[3] = 0;
            mat.data[4] = this.data[2];
            mat.data[5] = this.data[3];
            mat.data[6] = 0;
            mat.data[7] = 0;
            mat.data[8] = 0;
            mat.data[9] = 0;
            mat.data[10] = 1;
            mat.data[11] = 0;
            mat.data[12] = this.data[4];
            mat.data[13] = this.data[5];
            mat.data[14] = 0;
            mat.data[15] = 1;
            return mat;
        }
        setRotation(angle) {
            const currentScale = this.getScale();
            const sine = Math.sin(angle);
            const cosine = Math.cos(angle);
            this.data[0] = cosine * currentScale.x;
            this.data[1] = sine * currentScale.y;
            this.data[2] = -sine * currentScale.x;
            this.data[3] = cosine * currentScale.y;
        }
        getRotation() {
            const angle = Math.atan2(this.data[1] / this.getScaleY(), this.data[0] / this.getScaleX());
            return canonicalizeAngle(angle);
        }
        getScaleX() {
            // absolute scale of the matrix (we lose sign so need to add it back)
            const xscale = vec(this.data[0], this.data[2]).distance();
            return this._scaleSignX * xscale;
        }
        getScaleY() {
            // absolute scale of the matrix (we lose sign so need to add it back)
            const yscale = vec(this.data[1], this.data[3]).distance();
            return this._scaleSignY * yscale;
        }
        /**
     * Get the scale of the matrix
     */ getScale() {
            return vec(this.getScaleX(), this.getScaleY());
        }
        setScaleX(val) {
            if (val === this._scale[0]) return;
            this._scaleSignX = sign(val);
            // negative scale acts like a 180 rotation, so flip
            const xscale = vec(this.data[0] * this._scaleSignX, this.data[2] * this._scaleSignX).normalize();
            this.data[0] = xscale.x * val;
            this.data[2] = xscale.y * val;
            this._scale[0] = val;
        }
        setScaleY(val) {
            if (val === this._scale[1]) return;
            this._scaleSignY = sign(val);
            // negative scale acts like a 180 rotation, so flip
            const yscale = vec(this.data[1] * this._scaleSignY, this.data[3] * this._scaleSignY).normalize();
            this.data[1] = yscale.x * val;
            this.data[3] = yscale.y * val;
            this._scale[1] = val;
        }
        setScale(scale) {
            this.setScaleX(scale.x);
            this.setScaleY(scale.y);
        }
        isIdentity() {
            return this.data[0] === 1 && this.data[1] === 0 && this.data[2] === 0 && this.data[3] === 1 && this.data[4] === 0 && this.data[5] === 0;
        }
        /**
     * Resets the current matrix to the identity matrix, mutating it
     * @returns {AffineMatrix} Current matrix as identity
     */ reset() {
            const mat = this;
            mat.data[0] = 1;
            mat.data[1] = 0;
            mat.data[2] = 0;
            mat.data[3] = 1;
            mat.data[4] = 0;
            mat.data[5] = 0;
            return mat;
        }
        /**
     * Creates a new Matrix with the same data as the current [[AffineMatrix]]
     */ clone(dest) {
            const mat = dest || new AffineMatrix();
            mat.data.set(this.data);
            return mat;
        }
        toString() {
            return `
[${this.data[0]} ${this.data[2]} ${this.data[4]}]
[${this.data[1]} ${this.data[3]} ${this.data[5]}]
[0 0 1]
`;
        }
    }
    class TransformStack {
        constructor(){
            this._transforms = [];
            this._currentTransform = AffineMatrix.identity();
        }
        save() {
            this._transforms.push(this._currentTransform);
            this._currentTransform = this._currentTransform.clone();
        }
        restore() {
            this._currentTransform = this._transforms.pop();
        }
        translate(x, y) {
            return this._currentTransform.translate(x, y);
        }
        rotate(angle) {
            return this._currentTransform.rotate(angle);
        }
        scale(x, y) {
            return this._currentTransform.scale(x, y);
        }
        set current(matrix) {
            this._currentTransform = matrix;
        }
        get current() {
            return this._currentTransform;
        }
    }
    class StateStack {
        constructor(){
            this.current = this._getDefaultState();
            this._states = [];
        }
        _getDefaultState() {
            return {
                opacity: 1,
                z: 0,
                tint: Color.White,
                material: null
            };
        }
        _cloneState() {
            return {
                opacity: this.current.opacity,
                z: this.current.z,
                tint: this.current.tint.clone(),
                material: this.current.material // TODO is this going to cause problems when cloning
            };
        }
        save() {
            this._states.push(this.current);
            this.current = this._cloneState();
        }
        restore() {
            this.current = this._states.pop();
        }
    }
    const ResourceEvents = {
        Complete: "complete",
        Load: "load",
        LoadStart: "loadstart",
        Progress: "progress",
        Error: "error"
    };
    /**
 * The [[Resource]] type allows games built in Excalibur to load generic resources.
 * For any type of remote resource it is recommended to use [[Resource]] for preloading.
 */ class Resource {
        /**
     * @param path          Path to the remote resource
     * @param responseType  The type to expect as a response: "" | "arraybuffer" | "blob" | "document" | "json" | "text";
     * @param bustCache     Whether or not to cache-bust requests
     */ constructor(path, responseType, bustCache = false){
            this.path = path;
            this.responseType = responseType;
            this.bustCache = bustCache;
            this.data = null;
            this.logger = Logger.getInstance();
            this.events = new EventEmitter();
        }
        /**
     * Returns true if the Resource is completely loaded and is ready
     * to be drawn.
     */ isLoaded() {
            return this.data !== null;
        }
        _cacheBust(uri) {
            const query = /\?\w*=\w*/;
            if (query.test(uri)) uri += "&__=" + Date.now();
            else uri += "?__=" + Date.now();
            return uri;
        }
        /**
     * Begin loading the resource and returns a promise to be resolved on completion
     */ load() {
            return new Promise((resolve, reject)=>{
                // Exit early if we already have data
                if (this.data !== null) {
                    this.logger.debug("Already have data for resource", this.path);
                    this.events.emit("complete", this.data);
                    resolve(this.data);
                    return;
                }
                const request = new XMLHttpRequest();
                request.open("GET", this.bustCache ? this._cacheBust(this.path) : this.path, true);
                request.responseType = this.responseType;
                request.addEventListener("loadstart", (e)=>this.events.emit("loadstart", e));
                request.addEventListener("progress", (e)=>this.events.emit("progress", e));
                request.addEventListener("error", (e)=>this.events.emit("error", e));
                request.addEventListener("load", (e)=>this.events.emit("load", e));
                request.addEventListener("load", ()=>{
                    // XHR on file:// success status is 0, such as with PhantomJS
                    if (request.status !== 0 && request.status !== 200) {
                        this.logger.error("Failed to load resource ", this.path, " server responded with error code", request.status);
                        this.events.emit("error", request.response);
                        reject(new Error(request.statusText));
                        return;
                    }
                    this.data = request.response;
                    this.events.emit("complete", this.data);
                    this.logger.debug("Completed loading resource", this.path);
                    resolve(this.data);
                });
                request.send();
            });
        }
    }
    /**
 * Watch an object with a proxy, only fires if property value is different
 */ function watch(type, change) {
        if (!type) return type;
        if (type.__isProxy === undefined) // expando hack to mark a proxy
        return new Proxy(type, {
            set: (obj, prop, value)=>{
                // The default behavior to store the value
                if (obj[prop] !== value) {
                    obj[prop] = value;
                    // Avoid watching private junk
                    if (typeof prop === "string") {
                        if (prop[0] !== "_") change(obj);
                    }
                }
                // Indicate success
                return true;
            },
            get: (obj, prop)=>{
                if (prop !== "__isProxy") return obj[prop];
                return true;
            }
        });
        return type;
    }
    const createHandler = (path = [], change, typeType)=>({
            get: (target, key)=>{
                if (key === "__isProxy") return true;
                if (typeof target[key] === "object" && target[key] != null) return new Proxy(target[key], createHandler([
                    ...path,
                    key
                ], change, typeType));
                return target[key];
            },
            set: (target, key, value)=>{
                if (typeof key === "string") {
                    if (key[0] !== "_") change(typeType);
                }
                target[key] = value;
                return true;
            }
        });
    /**
 *
 */ function watchDeep(type, change) {
        if (!type) return type;
        if (type.__isProxy === undefined) // expando hack to mark a proxy
        return new Proxy(type, createHandler([], change, type));
        return type;
    }
    /**
 * Watch an object with a proxy, fires change on any property value change
 */ function watchAny(type, change) {
        if (!type) return type;
        if (type.__isProxy === undefined) // expando hack to mark a proxy
        return new Proxy(type, {
            set: (obj, prop, value)=>{
                // The default behavior to store the value
                obj[prop] = value;
                // Avoid watching private junk
                if (typeof prop === "string") {
                    if (prop[0] !== "_") change(obj);
                }
                // Indicate success
                return true;
            },
            get: (obj, prop)=>{
                if (prop !== "__isProxy") return obj[prop];
                return true;
            }
        });
        return type;
    }
    /**
 * A Graphic is the base Excalibur primitive for something that can be drawn to the [[ExcaliburGraphicsContext]].
 * [[Sprite]], [[Animation]], [[GraphicsGroup]], [[Canvas]], [[Rectangle]], [[Circle]], and [[Polygon]] all derive from the
 * [[Graphic]] abstract class.
 *
 * Implementors of a Graphic must override the abstract [[Graphic._drawImage]] method to render an image to the graphics context. Graphic
 * handles all the position, rotation, and scale transformations in [[Graphic._preDraw]] and [[Graphic._postDraw]]
 */ class Graphic {
        isStale() {
            return this._transformStale;
        }
        /**
     * Gets or sets the flipHorizontal, which will flip the graphic horizontally (across the y axis)
     */ get flipHorizontal() {
            return this._flipHorizontal;
        }
        set flipHorizontal(value) {
            this._flipHorizontal = value;
            this._transformStale = true;
        }
        /**
     * Gets or sets the flipVertical, which will flip the graphic vertically (across the x axis)
     */ get flipVertical() {
            return this._flipVertical;
        }
        set flipVertical(value) {
            this._flipVertical = value;
            this._transformStale = true;
        }
        /**
     * Gets or sets the rotation of the graphic
     */ get rotation() {
            return this._rotation;
        }
        set rotation(value) {
            this._rotation = value;
            this._transformStale = true;
        }
        /**
     * Gets or sets the scale of the graphic, this affects the width and
     */ get scale() {
            return this._scale;
        }
        set scale(value) {
            this._scale = watch(value, ()=>{
                this._transformStale = true;
            });
            this._transformStale = true;
        }
        /**
     * Gets or sets the origin of the graphic, if not set the center of the graphic is the origin
     */ get origin() {
            return this._origin;
        }
        set origin(value) {
            this._origin = watch(value, ()=>{
                this._transformStale = true;
            });
            this._transformStale = true;
        }
        constructor(options){
            var _a, _b, _c, _d, _e, _f, _g;
            this.id = Graphic._ID++;
            this.transform = AffineMatrix.identity();
            this.tint = null;
            this._transformStale = true;
            /**
         * Gets or sets wether to show debug information about the graphic
         */ this.showDebug = false;
            this._flipHorizontal = false;
            this._flipVertical = false;
            this._rotation = 0;
            /**
         * Gets or sets the opacity of the graphic, 0 is transparent, 1 is solid (opaque).
         */ this.opacity = 1;
            this._scale = Vector.One;
            this._origin = null;
            this._width = 0;
            this._height = 0;
            if (options) {
                this.origin = (_a = options.origin) !== null && _a !== void 0 ? _a : this.origin;
                this.flipHorizontal = (_b = options.flipHorizontal) !== null && _b !== void 0 ? _b : this.flipHorizontal;
                this.flipVertical = (_c = options.flipVertical) !== null && _c !== void 0 ? _c : this.flipVertical;
                this.rotation = (_d = options.rotation) !== null && _d !== void 0 ? _d : this.rotation;
                this.opacity = (_e = options.opacity) !== null && _e !== void 0 ? _e : this.opacity;
                this.scale = (_f = options.scale) !== null && _f !== void 0 ? _f : this.scale;
                this.tint = (_g = options.tint) !== null && _g !== void 0 ? _g : this.tint;
            }
        }
        cloneGraphicOptions() {
            return {
                width: this.width / this.scale.x,
                height: this.height / this.scale.y,
                origin: this.origin ? this.origin.clone() : null,
                flipHorizontal: this.flipHorizontal,
                flipVertical: this.flipVertical,
                rotation: this.rotation,
                opacity: this.opacity,
                scale: this.scale ? this.scale.clone() : null,
                tint: this.tint ? this.tint.clone() : null
            };
        }
        /**
     * Gets or sets the width of the graphic (always positive)
     */ get width() {
            return Math.abs(this._width * this.scale.x);
        }
        /**
     * Gets or sets the height of the graphic (always positive)
     */ get height() {
            return Math.abs(this._height * this.scale.y);
        }
        set width(value) {
            this._width = value;
            this._transformStale = true;
        }
        set height(value) {
            this._height = value;
            this._transformStale = true;
        }
        /**
     * Gets a copy of the bounds in pixels occupied by the graphic on the the screen. This includes scale.
     */ get localBounds() {
            return BoundingBox.fromDimension(this.width, this.height, Vector.Zero);
        }
        /**
     * Draw the whole graphic to the context including transform
     * @param ex The excalibur graphics context
     * @param x
     * @param y
     */ draw(ex, x, y) {
            this._preDraw(ex, x, y);
            this._drawImage(ex, 0, 0);
            this._postDraw(ex);
        }
        /**
     * Apply affine transformations to the graphics context to manipulate the graphic before [[Graphic._drawImage]]
     * @param ex
     * @param x
     * @param y
     */ _preDraw(ex, x, y) {
            ex.save();
            ex.translate(x, y);
            if (this._transformStale) {
                this.transform.reset();
                this.transform.scale(Math.abs(this.scale.x), Math.abs(this.scale.y));
                this._rotate(this.transform);
                this._flip(this.transform);
                this._transformStale = false;
            }
            ex.multiply(this.transform);
            // it is important to multiply alphas so graphics respect the current context
            ex.opacity = ex.opacity * this.opacity;
            if (this.tint) ex.tint = this.tint;
        }
        _rotate(ex) {
            var _a;
            const scaleDirX = this.scale.x > 0 ? 1 : -1;
            const scaleDirY = this.scale.y > 0 ? 1 : -1;
            const origin = (_a = this.origin) !== null && _a !== void 0 ? _a : vec(this.width / 2, this.height / 2);
            ex.translate(origin.x, origin.y);
            ex.rotate(this.rotation);
            // This is for handling direction changes 1 or -1, that way we don't have mismatched translates()
            ex.scale(scaleDirX, scaleDirY);
            ex.translate(-origin.x, -origin.y);
        }
        _flip(ex) {
            if (this.flipHorizontal) {
                ex.translate(this.width / this.scale.x, 0);
                ex.scale(-1, 1);
            }
            if (this.flipVertical) {
                ex.translate(0, this.height / this.scale.y);
                ex.scale(1, -1);
            }
        }
        /**
     * Apply any additional work after [[Graphic._drawImage]] and restore the context state.
     * @param ex
     */ _postDraw(ex) {
            if (this.showDebug) ex.debug.drawRect(0, 0, this.width, this.height);
            ex.restore();
        }
    }
    Graphic._ID = 0;
    class Sprite extends Graphic {
        static from(image) {
            return new Sprite({
                image: image
            });
        }
        constructor(options){
            var _a, _b;
            super(options);
            this._logger = Logger.getInstance();
            this._dirty = true;
            this.image = options.image;
            const { width: width, height: height } = options;
            this.sourceView = (_a = options.sourceView) !== null && _a !== void 0 ? _a : {
                x: 0,
                y: 0,
                width: width !== null && width !== void 0 ? width : 0,
                height: height !== null && height !== void 0 ? height : 0
            };
            this.destSize = (_b = options.destSize) !== null && _b !== void 0 ? _b : {
                width: width !== null && width !== void 0 ? width : 0,
                height: height !== null && height !== void 0 ? height : 0
            };
            this._updateSpriteDimensions();
            // Fire when loaded
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.image.ready.then(()=>{
                this._updateSpriteDimensions();
            });
        }
        get width() {
            return Math.abs(this.destSize.width * this.scale.x);
        }
        get height() {
            return Math.abs(this.destSize.height * this.scale.y);
        }
        set width(newWidth) {
            newWidth /= Math.abs(this.scale.x);
            this.destSize.width = newWidth;
            super.width = Math.ceil(this.destSize.width);
        }
        set height(newHeight) {
            newHeight /= Math.abs(this.scale.y);
            this.destSize.height = newHeight;
            super.height = Math.ceil(this.destSize.height);
        }
        _updateSpriteDimensions() {
            var _a, _b, _c, _d, _e, _f;
            const { width: nativeWidth, height: nativeHeight } = this.image;
            // This code uses || to avoid 0's
            // If the source is not specified, use the native dimension
            this.sourceView.width = ((_a = this.sourceView) === null || _a === void 0 ? void 0 : _a.width) || nativeWidth;
            this.sourceView.height = ((_b = this.sourceView) === null || _b === void 0 ? void 0 : _b.height) || nativeHeight;
            // If the destination is not specified, use the source if specified, then native
            this.destSize.width = ((_c = this.destSize) === null || _c === void 0 ? void 0 : _c.width) || ((_d = this.sourceView) === null || _d === void 0 ? void 0 : _d.width) || nativeWidth;
            this.destSize.height = ((_e = this.destSize) === null || _e === void 0 ? void 0 : _e.height) || ((_f = this.sourceView) === null || _f === void 0 ? void 0 : _f.height) || nativeHeight;
            this.width = Math.ceil(this.destSize.width) * this.scale.x;
            this.height = Math.ceil(this.destSize.height) * this.scale.y;
        }
        _preDraw(ex, x, y) {
            if (this.image.isLoaded() && this._dirty) {
                this._dirty = false;
                this._updateSpriteDimensions();
            }
            super._preDraw(ex, x, y);
        }
        _drawImage(ex, x, y) {
            if (this.image.isLoaded()) ex.drawImage(this.image.image, this.sourceView.x, this.sourceView.y, this.sourceView.width, this.sourceView.height, x, y, this.destSize.width, this.destSize.height);
            else this._logger.warnOnce(`ImageSource ${this.image.path}` + ` is not yet loaded and won't be drawn. Please call .load() or include in a Loader.\n\n` + `Read https://excaliburjs.com/docs/imagesource for more information.`);
        }
        clone() {
            return new Sprite({
                image: this.image,
                sourceView: {
                    ...this.sourceView
                },
                destSize: {
                    ...this.destSize
                },
                ...this.cloneGraphicOptions()
            });
        }
    }
    /**
 * Describes the different image filtering modes
 */ var ImageFiltering;
    (function(ImageFiltering) {
        /**
     * Pixel is useful when you do not want smoothing aka antialiasing applied to your graphics.
     *
     * Useful for Pixel art aesthetics.
     */ ImageFiltering["Pixel"] = "Pixel";
        /**
     * Blended is useful when you have high resolution artwork and would like it blended and smoothed
     */ ImageFiltering["Blended"] = "Blended";
    })(ImageFiltering || (ImageFiltering = {}));
    /**
 * Parse the image filtering attribute value, if it doesn't match returns null
 */ function parseImageFiltering(val) {
        switch(val){
            case ImageFiltering.Pixel:
                return ImageFiltering.Pixel;
            case ImageFiltering.Blended:
                return ImageFiltering.Blended;
            default:
                return null;
        }
    }
    /**
 * Describes the different image wrapping modes
 */ var ImageWrapping;
    (function(ImageWrapping) {
        ImageWrapping["Clamp"] = "Clamp";
        ImageWrapping["Repeat"] = "Repeat";
        ImageWrapping["Mirror"] = "Mirror";
    })(ImageWrapping || (ImageWrapping = {}));
    /**
 *
 */ function parseImageWrapping(val) {
        switch(val){
            case ImageWrapping.Clamp:
                return ImageWrapping.Clamp;
            case ImageWrapping.Repeat:
                return ImageWrapping.Repeat;
            case ImageWrapping.Mirror:
                return ImageWrapping.Mirror;
            default:
                return ImageWrapping.Clamp;
        }
    }
    /**
 * Manages loading image sources into webgl textures, a unique id is associated with all sources
 */ class TextureLoader {
        constructor(gl){
            this._textureMap = new Map();
            this._gl = gl;
            TextureLoader._MAX_TEXTURE_SIZE = gl.getParameter(gl.MAX_TEXTURE_SIZE);
        }
        dispose() {
            for (const [image] of this._textureMap)this.delete(image);
            this._textureMap.clear();
            this._gl = null;
        }
        /**
     * Get the WebGL Texture from a source image
     * @param image
     */ get(image) {
            return this._textureMap.get(image);
        }
        /**
     * Returns whether a source image has been loaded as a texture
     * @param image
     */ has(image) {
            return this._textureMap.has(image);
        }
        /**
     * Loads a graphic into webgl and returns it's texture info, a webgl context must be previously registered
     * @param image Source graphic
     * @param options {ImageSourceOptions} Optionally configure the ImageFiltering and ImageWrapping mode to apply to the loaded texture
     * @param forceUpdate Optionally force a texture to be reloaded, useful if the source graphic has changed
     */ load(image, options, forceUpdate = false) {
            // Ignore loading if webgl is not registered
            const gl = this._gl;
            if (!gl) return null;
            const { filtering: filtering, wrapping: wrapping } = {
                ...options
            };
            let tex = null;
            // If reuse the texture if it's from the same source
            if (this.has(image)) tex = this.get(image);
            // Update existing webgl texture and return early
            if (tex) {
                if (forceUpdate) {
                    gl.bindTexture(gl.TEXTURE_2D, tex);
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
                }
                return tex;
            }
            // No texture exists create a new one
            tex = gl.createTexture();
            // TODO implement texture gc with weakmap and timer
            TextureLoader.checkImageSizeSupportedAndLog(image);
            gl.bindTexture(gl.TEXTURE_2D, tex);
            gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
            let wrappingConfig;
            if (wrapping) {
                if (typeof wrapping === "string") wrappingConfig = {
                    x: wrapping,
                    y: wrapping
                };
                else wrappingConfig = {
                    x: wrapping.x,
                    y: wrapping.y
                };
            }
            const { x: xWrap, y: yWrap } = wrappingConfig !== null && wrappingConfig !== void 0 ? wrappingConfig : TextureLoader.wrapping;
            switch(xWrap){
                case ImageWrapping.Clamp:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                    break;
                case ImageWrapping.Repeat:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
                    break;
                case ImageWrapping.Mirror:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.MIRRORED_REPEAT);
                    break;
                default:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            }
            switch(yWrap){
                case ImageWrapping.Clamp:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                    break;
                case ImageWrapping.Repeat:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
                    break;
                case ImageWrapping.Mirror:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.MIRRORED_REPEAT);
                    break;
                default:
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            }
            // NEAREST for pixel art, LINEAR for hi-res
            const filterMode = filtering !== null && filtering !== void 0 ? filtering : TextureLoader.filtering;
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filterMode === ImageFiltering.Pixel ? gl.NEAREST : gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filterMode === ImageFiltering.Pixel ? gl.NEAREST : gl.LINEAR);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
            this._textureMap.set(image, tex);
            return tex;
        }
        delete(image) {
            // Ignore loading if webgl is not registered
            const gl = this._gl;
            if (!gl) return null;
            let tex = null;
            if (this.has(image)) {
                tex = this.get(image);
                gl.deleteTexture(tex);
            }
        }
        /**
     * Takes an image and returns if it meets size criteria for hardware
     * @param image
     * @returns if the image will be supported at runtime
     */ static checkImageSizeSupportedAndLog(image) {
            var _a;
            const originalSrc = (_a = image.dataset.originalSrc) !== null && _a !== void 0 ? _a : "internal canvas bitmap";
            if (image.width > TextureLoader._MAX_TEXTURE_SIZE || image.height > TextureLoader._MAX_TEXTURE_SIZE) {
                TextureLoader._LOGGER.error(`The image [${originalSrc}] provided to Excalibur is too large for the device's maximum texture size of ` + `(${TextureLoader._MAX_TEXTURE_SIZE}x${TextureLoader._MAX_TEXTURE_SIZE}) please resize to an image ` + `for excalibur to render properly.\n\nImages will likely render as black rectangles.\n\n` + `Read more here: https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/WebGL_best_practices#understand_system_limits`);
                return false;
            } else if (image.width > 4096 || image.height > 4096) // https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/WebGL_best_practices#understand_system_limits
            TextureLoader._LOGGER.warn(`The image [${originalSrc}] provided to excalibur is too large may not work on all mobile devices, ` + `it is recommended you resize images to a maximum (4096x4096).\n\n` + `Images will likely render as black rectangles on some mobile platforms.\n\n` + `Read more here: https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/WebGL_best_practices#understand_system_limits`);
            return true;
        }
    }
    TextureLoader._LOGGER = Logger.getInstance();
    /**
 * Sets the default filtering for the Excalibur texture loader, default [[ImageFiltering.Blended]]
 */ TextureLoader.filtering = ImageFiltering.Blended;
    TextureLoader.wrapping = {
        x: ImageWrapping.Clamp,
        y: ImageWrapping.Clamp
    };
    TextureLoader._MAX_TEXTURE_SIZE = 4096;
    const ImageSourceAttributeConstants = {
        Filtering: "filtering",
        WrappingX: "wrapping-x",
        WrappingY: "wrapping-y"
    };
    class ImageSource {
        /**
     * The original size of the source image in pixels
     */ get width() {
            return this.image.naturalWidth;
        }
        /**
     * The original height of the source image in pixels
     */ get height() {
            return this.image.naturalHeight;
        }
        /**
     * Returns true if the Texture is completely loaded and is ready
     * to be drawn.
     */ isLoaded() {
            if (!this._src) // this boosts speed of access
            this._src = this.data.src;
            return !!this._src;
        }
        get image() {
            return this.data;
        }
        constructor(path, bustCacheOrOptions, filtering){
            this._logger = Logger.getInstance();
            /**
         * Access to the underlying html image element
         */ this.data = new Image();
            this._readyFuture = new Future();
            /**
         * Promise the resolves when the image is loaded and ready for use, does not initiate loading
         */ this.ready = this._readyFuture.promise;
            this.path = path;
            let bustCache = false;
            let wrapping;
            if (typeof bustCacheOrOptions === "boolean") bustCache = bustCacheOrOptions;
            else ({ filtering: filtering, wrapping: wrapping, bustCache: bustCache } = {
                ...bustCacheOrOptions
            });
            this._resource = new Resource(path, "blob", bustCache);
            this.filtering = filtering !== null && filtering !== void 0 ? filtering : this.filtering;
            if (typeof wrapping === "string") this.wrapping = {
                x: wrapping,
                y: wrapping
            };
            else this.wrapping = wrapping !== null && wrapping !== void 0 ? wrapping : this.wrapping;
            if (path.endsWith(".svg") || path.endsWith(".gif")) this._logger.warn(`Image type is not fully supported, you may have mixed results ${path}. Fully supported: jpg, bmp, and png`);
        }
        /**
     * Create an ImageSource from and HTML <image> tag element
     * @param image
     */ static fromHtmlImageElement(image, options) {
            const imageSource = new ImageSource("");
            imageSource._src = "image-element";
            imageSource.data = image;
            imageSource.data.setAttribute("data-original-src", "image-element");
            if (options === null || options === void 0 ? void 0 : options.filtering) imageSource.data.setAttribute(ImageSourceAttributeConstants.Filtering, options === null || options === void 0 ? void 0 : options.filtering);
            else imageSource.data.setAttribute(ImageSourceAttributeConstants.Filtering, ImageFiltering.Blended);
            if (options === null || options === void 0 ? void 0 : options.wrapping) {
                let wrapping;
                if (typeof options.wrapping === "string") wrapping = {
                    x: options.wrapping,
                    y: options.wrapping
                };
                else wrapping = {
                    x: options.wrapping.x,
                    y: options.wrapping.y
                };
                imageSource.data.setAttribute(ImageSourceAttributeConstants.WrappingX, wrapping.x);
                imageSource.data.setAttribute(ImageSourceAttributeConstants.WrappingY, wrapping.y);
            } else {
                imageSource.data.setAttribute(ImageSourceAttributeConstants.WrappingX, ImageWrapping.Clamp);
                imageSource.data.setAttribute(ImageSourceAttributeConstants.WrappingY, ImageWrapping.Clamp);
            }
            TextureLoader.checkImageSizeSupportedAndLog(image);
            imageSource._readyFuture.resolve(image);
            return imageSource;
        }
        /**
     * Should excalibur add a cache busting querystring? By default false.
     * Must be set before loading
     */ get bustCache() {
            return this._resource.bustCache;
        }
        set bustCache(val) {
            this._resource.bustCache = val;
        }
        /**
     * Begins loading the image and returns a promise that resolves when the image is loaded
     */ async load() {
            var _a, _b, _c, _d;
            if (this.isLoaded()) return this.data;
            try {
                // Load base64 or blob if needed
                let url;
                if (!this.path.includes("data:image/")) {
                    const blob = await this._resource.load();
                    url = URL.createObjectURL(blob);
                } else url = this.path;
                // Decode the image
                const image = new Image();
                // Use Image.onload over Image.decode()
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1055828#c7
                // Otherwise chrome will throw still Image.decode() failures for large textures
                const loadedFuture = new Future();
                image.onload = ()=>loadedFuture.resolve();
                image.src = url;
                image.setAttribute("data-original-src", this.path);
                await loadedFuture.promise;
                // Set results
                // We defer loading the texture into webgl until the first draw that way we avoid a singleton
                // and for the multi-engine case the texture needs to be created in EACH webgl context to work
                // See image-renderer.ts draw()
                this.data = image;
                // emit warning if potentially too big
                TextureLoader.checkImageSizeSupportedAndLog(this.data);
            } catch (error) {
                throw `Error loading ImageSource from path '${this.path}' with error [${error.message}]`;
            }
            // Do a bad thing to pass the filtering as an attribute
            this.data.setAttribute(ImageSourceAttributeConstants.Filtering, this.filtering);
            this.data.setAttribute(ImageSourceAttributeConstants.WrappingX, (_b = (_a = this.wrapping) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : ImageWrapping.Clamp);
            this.data.setAttribute(ImageSourceAttributeConstants.WrappingY, (_d = (_c = this.wrapping) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : ImageWrapping.Clamp);
            // todo emit complete
            this._readyFuture.resolve(this.data);
            return this.data;
        }
        /**
     * Build a sprite from this ImageSource
     */ toSprite() {
            return Sprite.from(this);
        }
        /**
     * Unload images from memory
     */ unload() {
            this.data = new Image();
        }
    }
    class SpriteFont extends Graphic {
        constructor(options){
            super(options);
            this._text = "";
            this.alphabet = "";
            this.shadow = null;
            this.caseInsensitive = false;
            this.spacing = 0;
            this.lineHeight = undefined;
            this._logger = Logger.getInstance();
            const { alphabet: alphabet, spriteSheet: spriteSheet, caseInsensitive: caseInsensitive, spacing: spacing, shadow: shadow, lineHeight: lineHeight } = options;
            this.alphabet = alphabet;
            this.spriteSheet = spriteSheet;
            this.caseInsensitive = caseInsensitive !== null && caseInsensitive !== void 0 ? caseInsensitive : this.caseInsensitive;
            this.spacing = spacing !== null && spacing !== void 0 ? spacing : this.spacing;
            this.shadow = shadow !== null && shadow !== void 0 ? shadow : this.shadow;
            this.lineHeight = lineHeight !== null && lineHeight !== void 0 ? lineHeight : this.lineHeight;
        }
        _getCharacterSprites(text) {
            const results = [];
            // handle case insensitive
            const textToRender = this.caseInsensitive ? text.toLocaleLowerCase() : text;
            const alphabet = this.caseInsensitive ? this.alphabet.toLocaleLowerCase() : this.alphabet;
            // for each letter in text
            for(let letterIndex = 0; letterIndex < textToRender.length; letterIndex++){
                // find the sprite index in alphabet , if there is an error pick the first
                const letter = textToRender[letterIndex];
                let spriteIndex = alphabet.indexOf(letter);
                if (spriteIndex === -1) {
                    spriteIndex = 0;
                    this._logger.warnOnce(`SpriteFont - Cannot find letter '${letter}' in configured alphabet '${alphabet}'.`);
                    this._logger.warnOnce("There maybe be more issues in the SpriteFont configuration. No additional warnings will be logged.");
                }
                const letterSprite = this.spriteSheet.sprites[spriteIndex];
                if (letterSprite) results.push(letterSprite);
                else {
                    this._logger.warnOnce(`SpriteFont - Cannot find sprite for '${letter}' at index '${spriteIndex}' in configured SpriteSheet`);
                    this._logger.warnOnce("There maybe be more issues in the SpriteFont configuration. No additional warnings will be logged.");
                }
            }
            return results;
        }
        measureText(text, maxWidth) {
            const lines = this._getLinesFromText(text, maxWidth);
            const maxWidthLine = lines.reduce((a, b)=>{
                return a.length > b.length ? a : b;
            });
            const sprites = this._getCharacterSprites(maxWidthLine);
            let width = 0;
            let height = 0;
            for (const sprite of sprites){
                width += sprite.width + this.spacing;
                height = Math.max(height, sprite.height);
            }
            return BoundingBox.fromDimension(width, height * lines.length, Vector.Zero);
        }
        _drawImage(ex, x, y, maxWidth) {
            var _a;
            let xCursor = 0;
            let yCursor = 0;
            let height = 0;
            const lines = this._getLinesFromText(this._text, maxWidth);
            for (const line of lines){
                for (const sprite of this._getCharacterSprites(line)){
                    // draw it in the right spot and increase the cursor by sprite width
                    sprite.draw(ex, x + xCursor, y + yCursor);
                    xCursor += sprite.width + this.spacing;
                    height = Math.max(height, sprite.height);
                }
                xCursor = 0;
                yCursor += (_a = this.lineHeight) !== null && _a !== void 0 ? _a : height;
            }
        }
        render(ex, text, _color, x, y, maxWidth) {
            // SpriteFont doesn't support _color, yet...
            this._text = text;
            const bounds = this.measureText(text, maxWidth);
            this.width = bounds.width;
            this.height = bounds.height;
            if (this.shadow) {
                ex.save();
                ex.translate(this.shadow.offset.x, this.shadow.offset.y);
                this._preDraw(ex, x, y);
                this._drawImage(ex, 0, 0, maxWidth);
                this._postDraw(ex);
                ex.restore();
            }
            this._preDraw(ex, x, y);
            this._drawImage(ex, 0, 0, maxWidth);
            this._postDraw(ex);
        }
        clone() {
            return new SpriteFont({
                alphabet: this.alphabet,
                spriteSheet: this.spriteSheet,
                spacing: this.spacing
            });
        }
        _getLinesFromText(text, maxWidth) {
            if (this._cachedText === text && this._cachedRenderWidth === maxWidth) return this._cachedLines;
            const lines = text.split("\n");
            if (maxWidth == null) return lines;
            // If the current line goes past the maxWidth, append a new line without modifying the underlying text.
            for(let i = 0; i < lines.length; i++){
                let line = lines[i];
                let newLine = "";
                // Note: we subtract the spacing to counter the initial padding on the left side.
                if (this.measureText(line).width > maxWidth) {
                    while(this.measureText(line).width > maxWidth){
                        newLine = line[line.length - 1] + newLine;
                        line = line.slice(0, -1); // Remove last character from line
                    }
                    // Update the array with our new values
                    lines[i] = line;
                    lines[i + 1] = newLine;
                }
            }
            this._cachedText = text;
            this._cachedLines = lines;
            this._cachedRenderWidth = maxWidth;
            return lines;
        }
    }
    /**
 * Represents a collection of sprites from a source image with some organization in a grid
 */ class SpriteSheet {
        /**
     * Build a new sprite sheet from a list of sprites
     *
     * Use [[SpriteSheet.fromImageSource]] to create a SpriteSheet from an [[ImageSource]] organized in a grid
     * @param options
     */ constructor(options){
            this.sprites = [];
            const { sprites: sprites, rows: rows, columns: columns } = options;
            this.sprites = sprites;
            this.rows = rows !== null && rows !== void 0 ? rows : 1;
            this.columns = columns !== null && columns !== void 0 ? columns : this.sprites.length;
        }
        /**
     * Find a sprite by their x/y integer coordinates in the SpriteSheet, for example `getSprite(0, 0)` is the [[Sprite]] in the top-left
     * and `getSprite(1, 0)` is the sprite one to the right.
     * @param x
     * @param y
     */ getSprite(x, y, options) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (x >= this.columns || x < 0) throw Error(`No sprite exists in the SpriteSheet at (${x}, ${y}), x: ${x} should be between 0 and ${this.columns - 1}`);
            if (y >= this.rows || y < 0) throw Error(`No sprite exists in the SpriteSheet at (${x}, ${y}), y: ${y} should be between 0 and ${this.rows - 1}`);
            const spriteIndex = x + y * this.columns;
            const sprite = this.sprites[spriteIndex];
            if (sprite) {
                if (options) {
                    const spriteWithOptions = sprite.clone();
                    spriteWithOptions.flipHorizontal = (_a = options.flipHorizontal) !== null && _a !== void 0 ? _a : spriteWithOptions.flipHorizontal;
                    spriteWithOptions.flipVertical = (_b = options.flipVertical) !== null && _b !== void 0 ? _b : spriteWithOptions.flipVertical;
                    spriteWithOptions.width = (_c = options.width) !== null && _c !== void 0 ? _c : spriteWithOptions.width;
                    spriteWithOptions.height = (_d = options.height) !== null && _d !== void 0 ? _d : spriteWithOptions.height;
                    spriteWithOptions.rotation = (_e = options.rotation) !== null && _e !== void 0 ? _e : spriteWithOptions.rotation;
                    spriteWithOptions.scale = (_f = options.scale) !== null && _f !== void 0 ? _f : spriteWithOptions.scale;
                    spriteWithOptions.opacity = (_g = options.opacity) !== null && _g !== void 0 ? _g : spriteWithOptions.opacity;
                    spriteWithOptions.tint = (_h = options.tint) !== null && _h !== void 0 ? _h : spriteWithOptions.tint;
                    spriteWithOptions.origin = (_j = options.origin) !== null && _j !== void 0 ? _j : spriteWithOptions.origin;
                    return spriteWithOptions;
                }
                return sprite;
            }
            throw Error(`Invalid sprite coordinates (${x}, ${y}`);
        }
        /**
     * Create a sprite sheet from a sparse set of [[SourceView]] rectangles
     * @param options
     */ static fromImageSourceWithSourceViews(options) {
            const sprites = options.sourceViews.map((sourceView)=>{
                return new Sprite({
                    image: options.image,
                    sourceView: sourceView
                });
            });
            return new SpriteSheet({
                sprites: sprites
            });
        }
        /**
     * Create a SpriteSheet from an [[ImageSource]] organized in a grid
     *
     * Example:
     * ```
     * const spriteSheet = SpriteSheet.fromImageSource({
     *   image: imageSource,
     *   grid: {
     *     rows: 5,
     *     columns: 2,
     *     spriteWidth: 32, // pixels
     *     spriteHeight: 32 // pixels
     *   },
     *   // Optionally specify spacing
     *   spacing: {
     *     // pixels from the top left to start the sprite parsing
     *     originOffset: {
     *       x: 5,
     *       y: 5
     *     },
     *     // pixels between each sprite while parsing
     *     margin: {
     *       x: 1,
     *       y: 1
     *     }
     *   }
     * })
     * ```
     * @param options
     */ static fromImageSource(options) {
            var _a;
            const sprites = [];
            options.spacing = (_a = options.spacing) !== null && _a !== void 0 ? _a : {};
            const { image: image, grid: { rows: rows, columns: cols, spriteWidth: spriteWidth, spriteHeight: spriteHeight }, spacing: { originOffset: originOffset, margin: margin } } = options;
            const offsetDefaults = {
                x: 0,
                y: 0,
                ...originOffset
            };
            const marginDefaults = {
                x: 0,
                y: 0,
                ...margin
            };
            for(let x = 0; x < cols; x++)for(let y = 0; y < rows; y++)sprites[x + y * cols] = new Sprite({
                image: image,
                sourceView: {
                    x: x * spriteWidth + marginDefaults.x * x + offsetDefaults.x,
                    y: y * spriteHeight + marginDefaults.y * y + offsetDefaults.y,
                    width: spriteWidth,
                    height: spriteHeight
                },
                destSize: {
                    height: spriteHeight,
                    width: spriteWidth
                }
            });
            return new SpriteSheet({
                sprites: sprites,
                rows: rows,
                columns: cols
            });
        }
        clone() {
            return new SpriteSheet({
                sprites: this.sprites.map((sprite)=>sprite.clone()),
                rows: this.rows,
                columns: this.columns
            });
        }
    }
    /* harmony default export */ const debug_font = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAABACAYAAAD1Xam+AAAAAXNSR0IArs4c6QAABlFJREFUeJztndmy4yoMRcWt/v9fdr8EWoDAaDD4JntVpeqcxBrMIGQDNhEAAAAAAAAAAAAAAOCrSbMfr+u6yoEpTY+906GV57YtPkjyXj9WZZ+wHWHfo2N3/bU6Tte9Rv6ptruqRyMvKvvIX/zY3I/vjLeqsg6l/CWdp0KHKO/1Y1H2EdsR9j06Ntdfp+N03SvkH2u7i3pu5XkQ+DNTkgNJSok+/183xpcdWZHjgUzpQ2pGD67vaf//KRAGAq3tdhCy2tcMQKPyXyz7iPqrdBjbX5h9g7xbtvWf4ZJvM4D/BKG24Sd+IkQ0TC9aW5NM5FbO2HgrPVzW2vmN50DZNv/QWtl5bfPy85SBtdy9dFmjsf2F2SehTBVE+u+tkE5+lAGcJlFwGuodwRRU2Qe3rx0FhPNflc3HWC7BEh8EDGVR5IMCiLnDONtPp87qhxVH/S/LvzUAuDs/kyGimA5oSONKR1w8vsLpv+v+S9vhmS71JRiX1xB5CWZNw7m6rMrllMag/RJyWb67BEgpDVMWSydc+K47pr35w05kWd7ReEq6116KaG4CsbJ7OmV9PdZLEKkONiC1/7ZONVgDsajLIJPYp2OUAXRpnPcGmnIE6eSK4nv5YQqqSYO52JqnYfYj/PdQXQIY7XszuMofMgZRT/1LdeC5h2I5/0EdWDMY2Yb05WDE1RodVdpSA5r85slArAVnSf+89iP896St0f5bZKVA7Gk/3ja8q+152/+wrLqBWZTem3IBADbRBoDuHgAA4HdAAADgh0EAAOCHQQAA4IdBAADgh0EAAOCHuVsKbJ3P9M7jjuxHzGfv8j9iDt47Dx7hP8cjq5F/o/0T62Aer//ZOgDrajBp6aNlOWTEajKLjgj/Pcs/vfZD/a++3Pc8hNfZ966EVeh5vP75luDRJUAl0KzJfnopaqbaTuzZiulc2BS5lltFXntu3dcQsXadl59Wn1H+dfYNtrt2d6D/LDF9HkCQw6eXFbr8P9X5W/un5Ol8gz1t39p5pWOPn0vLynbgdnfe8maEQw+UIPJdfxdOd/4oTtVD0IYg8wDywGas0I04T5O3P8/qf2UWwPpkn1PbOT1bN2tFe59EM7TvKf+TRFw+erZ2ey4hpS3hp9qBkqq/tjsSU1OYqucBWB1yynt5QxC42Mdk30pAEIio//zRG3feBzLUX+TTjCKwlH83aI/KbpQBVEHgUGF0j/SitcLofHem8q6AyH0wBhFv4WszuOjy0yK2vc/oRWQoP2X9ve78jfaLnpncbBqQSC6s0HnIRT0a2yNZjfxT8+ir8t+yDsDTWaS6X70GP33+d77stp+I5HtBdwEAAPBl8ECApcAA/DBvfSowAGAB7/05ZAAA/DAIAADMMU3fOuS2ggAAwBjrorKoxWiPBxHMAgAg490Ts0VeePdA+ZfJDKcCh7sBqY88mmjklZeOt9iXPrvx2I2QPRnN2/qzyJ84h4gNcbtfasq5mM1rZr+bBWh2A+bIIX13Z9wqL+nQvFno7v3oq4tJItCed7isUT6C/I7BUn9KP95wDicYBYpcjncrO2c/dmW4tBtw4RiRld1IDxDyYsoXMHxF1w3dyz0Nne8033AOFsT6VgRCafl89fenTZUfbm8CGhrgdDcS7anAsvnkkP0IeCfQ+JzYunky6jhNYj5bl7++4fJvN9WDSKS/292A0wyANyKDI91bfkm3kcH7ckaP/SKW/VHKRZAcI14pP3beu0fPyn/DuZQbWMogNnsc16sziE96f7H/iai7uTf0/3N8lwFz/e13T00Djt4OrInCnkeChXT+qOcKOLA21tJpsv/G8/COnGnw97J9QwbTvd6djYSv7fxEVTuV/LzNhj7nOawv6bfbAGCYEpQ6HxFtuxs6sq9tzOYHobQ6Nje+6vo5BwFrPZ4OgMayS4PPt1NlzdLfbRCYBoBc+NaO4JWPwLEf33oN3unY3InKPQBW6Z7nEZzEmrl4iZjC804lqgePPEOguQcwWghUphxm343wyt/pWpWR0OrR+jvyxavHajfb9pTjbt9bH07Z5/expM4TLWfwb7QQqMoC+UDWXZo/4RgA38LOgUvLJAAQ1Td9y9//0ylxAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB+g79apuVUsS5ZmwAAAABJRU5ErkJggg==";
    /**
 * Internal debugtext helper
 */ class DebugText {
        constructor(){
            /**
         * base64 font
         */ this.fontSheet = debug_font;
            this.size = 16;
            // We fire and forget, we don't care if it's loaded or not
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.load();
        }
        load() {
            this._imageSource = new ImageSource(this.fontSheet);
            return this._imageSource.load().then(()=>{
                this._spriteSheet = SpriteSheet.fromImageSource({
                    image: this._imageSource,
                    grid: {
                        rows: 4,
                        columns: 16,
                        spriteWidth: 16,
                        spriteHeight: 16
                    }
                });
                this._spriteFont = new SpriteFont({
                    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ,!'&.\"?-()+# ",
                    caseInsensitive: true,
                    spriteSheet: this._spriteSheet,
                    spacing: -6
                });
            });
        }
        /**
     * Writes debug text using the built in sprint font
     * @param ctx
     * @param text
     * @param pos
     */ write(ctx, text, pos) {
            if (this._imageSource.isLoaded()) this._spriteFont.render(ctx, text, null, pos.x, pos.y);
        }
    }
    class RenderSource {
        constructor(_gl, _texture){
            this._gl = _gl;
            this._texture = _texture;
        }
        use() {
            const gl = this._gl;
            gl.activeTexture(gl.TEXTURE0);
            gl.bindTexture(gl.TEXTURE_2D, this._texture);
        }
        disable() {
            const gl = this._gl;
            gl.bindTexture(gl.TEXTURE_2D, null);
        }
    }
    class RenderTarget {
        constructor(options){
            var _a, _b;
            this.antialias = false;
            this.samples = 1;
            this._gl = options.gl;
            this.width = options.width;
            this.height = options.height;
            this.transparency = options.transparency;
            this.antialias = (_a = options.antialias) !== null && _a !== void 0 ? _a : this.antialias;
            this.samples = (_b = options.samples) !== null && _b !== void 0 ? _b : this._gl.getParameter(this._gl.MAX_SAMPLES);
            const gl = this._gl;
            // Determine current context format for blitting later needs to match
            if (gl.drawingBufferFormat) this.bufferFormat = gl.drawingBufferFormat;
            else // Documented in webgl spec
            // https://registry.khronos.org/webgl/specs/latest/1.0/
            if (this.transparency) this.bufferFormat = gl.RGBA8;
            else this.bufferFormat = gl.RGB8;
            this._setupRenderBuffer();
            this._setupFramebuffer();
        }
        setResolution(width, height) {
            const gl = this._gl;
            this.width = width;
            this.height = height;
            // update backing texture size
            gl.bindTexture(gl.TEXTURE_2D, this._frameTexture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
            // update render buffer size
            if (this._renderBuffer) {
                gl.bindRenderbuffer(gl.RENDERBUFFER, this._renderBuffer);
                gl.renderbufferStorageMultisample(gl.RENDERBUFFER, Math.min(this.samples, gl.getParameter(gl.MAX_SAMPLES)), this.bufferFormat, this.width, this.height);
            }
        }
        get renderBuffer() {
            return this._renderBuffer;
        }
        get renderFrameBuffer() {
            return this._renderFrameBuffer;
        }
        get frameBuffer() {
            return this._frameBuffer;
        }
        get frameTexture() {
            return this._frameTexture;
        }
        _setupRenderBuffer() {
            if (this.antialias) {
                const gl = this._gl;
                // Render buffers can be used as an input to a shader
                this._renderBuffer = gl.createRenderbuffer();
                this._renderFrameBuffer = gl.createFramebuffer();
                gl.bindRenderbuffer(gl.RENDERBUFFER, this._renderBuffer);
                gl.renderbufferStorageMultisample(gl.RENDERBUFFER, Math.min(this.samples, gl.getParameter(gl.MAX_SAMPLES)), this.bufferFormat, this.width, this.height);
                gl.bindFramebuffer(gl.FRAMEBUFFER, this._renderFrameBuffer);
                gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, this._renderBuffer);
            }
        }
        _setupFramebuffer() {
            // Allocates frame buffer
            const gl = this._gl;
            this._frameTexture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, this._frameTexture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
            // set the filtering so we don't need mips
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            // attach the texture as the first color attachment
            const attachmentPoint = gl.COLOR_ATTACHMENT0;
            // After this bind all draw calls will draw to this framebuffer texture
            this._frameBuffer = gl.createFramebuffer();
            gl.bindFramebuffer(gl.FRAMEBUFFER, this._frameBuffer);
            gl.framebufferTexture2D(gl.FRAMEBUFFER, attachmentPoint, gl.TEXTURE_2D, this._frameTexture, 0);
            // Reset after initialized
            this.disable();
        }
        toRenderSource() {
            if (this.renderBuffer) this.blitRenderBufferToFrameBuffer();
            const source = new RenderSource(this._gl, this._frameTexture);
            return source;
        }
        blitToScreen() {
            const gl = this._gl;
            // set to size of canvas's drawingBuffer
            if (this._renderBuffer) {
                gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.renderFrameBuffer);
                gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
                gl.clearBufferfv(gl.COLOR, 0, [
                    0.0,
                    0.0,
                    1.0,
                    1.0
                ]);
                gl.blitFramebuffer(0, 0, this.width, this.height, 0, 0, this.width, this.height, gl.COLOR_BUFFER_BIT, gl.LINEAR);
            } else {
                gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.frameBuffer);
                gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
                gl.clearBufferfv(gl.COLOR, 0, [
                    0.0,
                    0.0,
                    1.0,
                    1.0
                ]);
                gl.blitFramebuffer(0, 0, this.width, this.height, 0, 0, this.width, this.height, gl.COLOR_BUFFER_BIT, gl.LINEAR);
            }
        }
        blitRenderBufferToFrameBuffer() {
            if (this._renderBuffer) {
                const gl = this._gl;
                gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.renderFrameBuffer);
                gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this.frameBuffer);
                gl.clearBufferfv(gl.COLOR, 0, [
                    0.0,
                    0.0,
                    1.0,
                    1.0
                ]);
                gl.blitFramebuffer(0, 0, this.width, this.height, 0, 0, this.width, this.height, gl.COLOR_BUFFER_BIT, gl.LINEAR);
            }
        }
        copyToTexture(texture) {
            const gl = this._gl;
            if (this._renderBuffer) this.blitRenderBufferToFrameBuffer();
            gl.bindFramebuffer(gl.FRAMEBUFFER, this._frameBuffer);
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.copyTexImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 0, 0, this.width, this.height, 0);
        }
        /**
     * When called, all drawing gets redirected to this render target
     */ use() {
            const gl = this._gl;
            if (this.antialias) gl.bindFramebuffer(gl.FRAMEBUFFER, this._renderFrameBuffer);
            else gl.bindFramebuffer(gl.FRAMEBUFFER, this._frameBuffer);
            // very important to set the viewport to the size of the framebuffer texture
            gl.viewport(0, 0, this.width, this.height);
        }
        /**
     * When called, all drawing is sent back to the canvas
     */ disable() {
            const gl = this._gl;
            // passing null switches rendering back to the canvas
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            gl.bindTexture(gl.TEXTURE_2D, null);
        }
    }
    /* harmony default export */ const line_vertex = "#version 300 es\r\nin vec2 a_position;\r\nin vec4 a_color;\r\n\r\nout lowp vec4 v_color;\r\n\r\nuniform mat4 u_matrix;\r\n\r\nvoid main() {\r\n   // Set the vertex position using the ortho transform matrix\r\n   gl_Position = u_matrix * vec4(a_position, 0.0, 1.0);\r\n\r\n   // Passthrough the color\r\n   v_color = a_color;\r\n}";
    /* harmony default export */ const line_fragment = "#version 300 es\r\nprecision mediump float;\r\n\r\n// Color\r\nin lowp vec4 v_color;\r\n\r\nout vec4 fragColor;\r\n\r\nvoid main() {\r\n  fragColor = v_color;\r\n}";
    /**
 * Return the size of the GlType in bytes
 * @param gl
 * @param type
 */ function getGlTypeSizeBytes(gl, type) {
        switch(type){
            case gl.FLOAT:
                return 4;
            case gl.SHORT:
                return 2;
            case gl.UNSIGNED_SHORT:
                return 2;
            case gl.BYTE:
                return 1;
            case gl.UNSIGNED_BYTE:
                return 1;
            default:
                return 1;
        }
    }
    /**
 * Checks if an attribute is present in vertex source
 */ function isAttributeInSource(source, variable) {
        const attributeRegexTemplate = `(?<type>[a-z0-9]+)\\s+${variable};`;
        const regex = new RegExp(attributeRegexTemplate, "g");
        const matches = regex.exec(source);
        return (matches === null || matches === void 0 ? void 0 : matches.length) > 0;
    }
    /**
 * Attempt to discern the glType of an attribute from vertex source
 * @param gl
 * @param source
 * @param variable
 */ function getGLTypeFromSource(gl, source, variable) {
        var _a;
        const attributeRegexTemplate = `(?<type>[a-z0-9]+)\\s+${variable};`;
        const regex = new RegExp(attributeRegexTemplate, "g");
        const matches = regex.exec(source);
        const type = (_a = matches === null || matches === void 0 ? void 0 : matches.groups) === null || _a === void 0 ? void 0 : _a.type;
        switch(type){
            case "float":
            case "vec2":
            case "vec3":
            case "vec4":
                return gl.FLOAT;
            case "int":
            case "ivec2":
            case "ivec3":
            case "ivec4":
                return gl.INT;
            case "uint":
            case "uvec2":
            case "uvec3":
            case "uvec4":
                return gl.UNSIGNED_INT;
            case "bool":
            case "bvec2":
            case "bvec3":
            case "bvec4":
                return gl.BOOL;
            case "short":
                return gl.SHORT;
            case "ushort":
                return gl.UNSIGNED_SHORT;
            case "ubyte":
                return gl.UNSIGNED_BYTE;
            case "byte":
                return gl.BYTE;
            default:
                return gl.FLOAT;
        }
    }
    /**
 * Based on the type return the number of attribute components
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/vertexAttribPointer
 * @param gl
 * @param type
 */ function getAttributeComponentSize(gl, type) {
        switch(type){
            case gl.LOW_FLOAT:
            case gl.HIGH_FLOAT:
            case gl.FLOAT:
                return 1;
            case gl.FLOAT_VEC2:
                return 2;
            case gl.FLOAT_VEC3:
                return 3;
            case gl.FLOAT_VEC4:
                return 4;
            case gl.BYTE:
                return 1;
            case gl.UNSIGNED_BYTE:
                return 1;
            case gl.UNSIGNED_SHORT:
            case gl.SHORT:
                return 1;
            default:
                return 1;
        }
    }
    /**
 * Based on the attribute return the corresponding supported attrib pointer type
 * https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/vertexAttribPointer
 * @param gl
 * @param type
 */ function getAttributePointerType(gl, type) {
        switch(type){
            case gl.LOW_FLOAT:
            case gl.HIGH_FLOAT:
            case gl.FLOAT:
            case gl.FLOAT_VEC2:
            case gl.FLOAT_VEC3:
            case gl.FLOAT_VEC4:
                return gl.FLOAT;
            case gl.BYTE:
                return gl.BYTE;
            case gl.UNSIGNED_BYTE:
                return gl.UNSIGNED_BYTE;
            case gl.SHORT:
                return gl.SHORT;
            case gl.UNSIGNED_SHORT:
                return gl.UNSIGNED_SHORT;
            default:
                return gl.FLOAT;
        }
    }
    class Shader {
        get compiled() {
            return this._compiled;
        }
        /**
     * Create a shader program in excalibur
     * @param options specify shader vertex and fragment source
     */ constructor(options){
            this._logger = Logger.getInstance();
            this.uniforms = {};
            this.attributes = {};
            this._compiled = false;
            const { gl: gl, vertexSource: vertexSource, fragmentSource: fragmentSource } = options;
            this._gl = gl;
            this.vertexSource = vertexSource;
            this.fragmentSource = fragmentSource;
        }
        dispose() {
            const gl = this._gl;
            gl.deleteProgram(this.program);
            this._gl = null;
        }
        /**
     * Binds the shader program
     */ use() {
            const gl = this._gl;
            gl.useProgram(this.program);
            Shader._ACTIVE_SHADER_INSTANCE = this;
        }
        isCurrentlyBound() {
            return Shader._ACTIVE_SHADER_INSTANCE === this;
        }
        /**
     * Compile the current shader against a webgl context
     */ compile() {
            const gl = this._gl;
            const vertexShader = this._compileShader(gl, this.vertexSource, gl.VERTEX_SHADER);
            const fragmentShader = this._compileShader(gl, this.fragmentSource, gl.FRAGMENT_SHADER);
            this.program = this._createProgram(gl, vertexShader, fragmentShader);
            const attributes = this.getAttributes();
            for (const attribute of attributes)this.attributes[attribute.name] = attribute;
            const uniforms = this.getUniforms();
            for (const uniform of uniforms)this.uniforms[uniform.name] = uniform;
            this._compiled = true;
            return this.program;
        }
        getUniforms() {
            const gl = this._gl;
            const uniformCount = gl.getProgramParameter(this.program, gl.ACTIVE_UNIFORMS);
            const uniforms = [];
            for(let i = 0; i < uniformCount; i++){
                const uniform = gl.getActiveUniform(this.program, i);
                const uniformLocation = gl.getUniformLocation(this.program, uniform.name);
                uniforms.push({
                    name: uniform.name,
                    glType: uniform.type,
                    location: uniformLocation
                });
            }
            return uniforms;
        }
        getAttributes() {
            const gl = this._gl;
            const attributeCount = gl.getProgramParameter(this.program, gl.ACTIVE_ATTRIBUTES);
            const attributes = [];
            for(let i = 0; i < attributeCount; i++){
                const attribute = gl.getActiveAttrib(this.program, i);
                const attributeLocation = gl.getAttribLocation(this.program, attribute.name);
                attributes.push({
                    name: attribute.name,
                    glType: getAttributePointerType(gl, attribute.type),
                    size: getAttributeComponentSize(gl, attribute.type),
                    location: attributeLocation,
                    normalized: false
                });
            }
            return attributes;
        }
        /**
     * Set a texture in a gpu texture slot
     * @param slotNumber
     * @param texture
     */ setTexture(slotNumber, texture) {
            const gl = this._gl;
            gl.activeTexture(gl.TEXTURE0 + slotNumber);
            gl.bindTexture(gl.TEXTURE_2D, texture);
        }
        /**
     * Set an integer uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformInt(name, value) {
            this.setUniform("uniform1i", name, ~~value);
        }
        /**
     * Set an integer uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformInt(name, value) {
            return this.trySetUniform("uniform1i", name, ~~value);
        }
        /**
     * Set an integer array uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformIntArray(name, value) {
            this.setUniform("uniform1iv", name, value);
        }
        /**
     * Set an integer array uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformIntArray(name, value) {
            return this.trySetUniform("uniform1iv", name, value);
        }
        /**
     * Set a boolean uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformBoolean(name, value) {
            this.setUniform("uniform1i", name, value ? 1 : 0);
        }
        /**
     * Set a boolean uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformBoolean(name, value) {
            return this.trySetUniform("uniform1i", name, value ? 1 : 0);
        }
        /**
     * Set a float uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformFloat(name, value) {
            this.setUniform("uniform1f", name, value);
        }
        /**
     * Set a float uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformFloat(name, value) {
            return this.trySetUniform("uniform1f", name, value);
        }
        /**
     * Set a float array uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformFloatArray(name, value) {
            this.setUniform("uniform1fv", name, value);
        }
        /**
     * Set a float array uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformFloatArray(name, value) {
            return this.trySetUniform("uniform1fv", name, value);
        }
        /**
     * Set a [[Vector]] uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformFloatVector(name, value) {
            this.setUniform("uniform2f", name, value.x, value.y);
        }
        /**
     * Set a [[Vector]] uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformFloatVector(name, value) {
            return this.trySetUniform("uniform2f", name, value.x, value.y);
        }
        /**
     * Set a [[Color]] uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformFloatColor(name, value) {
            this.setUniform("uniform4f", name, value.r / 255, value.g / 255, value.b / 255, value.a);
        }
        /**
     * Set a [[Color]] uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformFloatColor(name, value) {
            return this.trySetUniform("uniform4f", name, value.r / 255, value.g / 255, value.b / 255, value.a);
        }
        /**
     * Set an [[Matrix]] uniform for the current shader
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ setUniformMatrix(name, value) {
            this.setUniform("uniformMatrix4fv", name, false, value.data);
        }
        /**
     * Set an [[Matrix]] uniform for the current shader, WILL NOT THROW on error.
     *
     * **Important** Must call ex.Shader.use() before setting a uniform!
     * @param name
     * @param value
     */ trySetUniformMatrix(name, value) {
            return this.trySetUniform("uniformMatrix4fv", name, false, value.data);
        }
        /**
     * Set any available uniform type in webgl
     *
     * For example setUniform('uniformMatrix2fv', 'u_my2x2_mat`, ...);
     */ setUniform(uniformType, name, ...value) {
            if (!this._compiled) throw Error(`Must compile shader before setting a uniform ${uniformType}:${name}`);
            if (!this.isCurrentlyBound()) throw Error("Currently accessed shader instance is not the current active shader in WebGL, must call `shader.use()` before setting uniforms");
            const gl = this._gl;
            const location1 = gl.getUniformLocation(this.program, name);
            if (location1) {
                const args = [
                    location1,
                    ...value
                ];
                this._gl[uniformType].apply(this._gl, args);
            } else throw Error(`Uniform ${uniformType}:${name} doesn\'t exist or is not used in the shader source code,` + " unused uniforms are optimized away by most browsers");
        }
        /**
     * Set any available uniform type in webgl. Will try to set the uniform, will return false if the uniform didn't exist,
     * true if it was set.
     *
     * WILL NOT THROW on error
     *
     * For example setUniform('uniformMatrix2fv', 'u_my2x2_mat`, ...);
     *
     */ trySetUniform(uniformType, name, ...value) {
            if (!this._compiled) {
                this._logger.warn(`Must compile shader before setting a uniform ${uniformType}:${name}`);
                return false;
            }
            if (!this.isCurrentlyBound()) {
                this._logger.warn("Currently accessed shader instance is not the current active shader in WebGL, must call `shader.use()` before setting uniforms");
                return false;
            }
            const gl = this._gl;
            const location1 = gl.getUniformLocation(this.program, name);
            if (location1) {
                const args = [
                    location1,
                    ...value
                ];
                this._gl[uniformType].apply(this._gl, args);
            } else return false;
            return true;
        }
        _createProgram(gl, vertexShader, fragmentShader) {
            const program = gl.createProgram();
            if (program === null) throw Error("Could not create graphics shader program");
            // attach the shaders.
            gl.attachShader(program, vertexShader);
            gl.attachShader(program, fragmentShader);
            // link the program.
            gl.linkProgram(program);
            const success = gl.getProgramParameter(program, gl.LINK_STATUS);
            if (!success) throw Error(`Could not link the program: [${gl.getProgramInfoLog(program)}]`);
            return program;
        }
        _compileShader(gl, source, type) {
            const typeName = gl.VERTEX_SHADER === type ? "vertex" : "fragment";
            const shader = gl.createShader(type);
            if (shader === null) throw Error(`Could not build shader: [${source}]`);
            gl.shaderSource(shader, source);
            gl.compileShader(shader);
            const success = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
            if (!success) {
                const errorInfo = gl.getShaderInfoLog(shader);
                throw Error(`Could not compile ${typeName} shader:\n\n${errorInfo}${this._processSourceForError(source, errorInfo)}`);
            }
            return shader;
        }
        _processSourceForError(source, errorInfo) {
            if (!source) return errorInfo;
            const lines = source.split("\n");
            const errorLineStart = errorInfo.search(/\d:\d/);
            const errorLineEnd = errorInfo.indexOf(" ", errorLineStart);
            const [_, error2] = errorInfo.slice(errorLineStart, errorLineEnd).split(":").map((v)=>Number(v));
            for(let i = 0; i < lines.length; i++)lines[i] = `${i + 1}: ${lines[i]}${error2 === i + 1 ? " <----- ERROR!" : ""}`;
            return "\n\nSource:\n" + lines.join("\n");
        }
    }
    Shader._ACTIVE_SHADER_INSTANCE = null;
    /**
 * Helper around vertex buffer to simplify creating and uploading geometry
 *
 * Under the hood uses Float32Array
 */ class VertexBuffer {
        constructor(options){
            /**
         * If the vertices never change switching 'static' can be more efficient on the gpu
         *
         * Default is 'dynamic'
         */ this.type = "dynamic";
            const { gl: gl, size: size, type: type, data: data } = options;
            this._gl = gl;
            this.buffer = this._gl.createBuffer();
            if (!data && !size) throw Error("Must either provide data or a size to the VertexBuffer");
            if (!data) this.bufferData = new Float32Array(size);
            else this.bufferData = data;
            this.type = type !== null && type !== void 0 ? type : this.type;
            // Allocate buffer
            gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
            gl.bufferData(gl.ARRAY_BUFFER, this.bufferData, this.type === "static" ? gl.STATIC_DRAW : gl.DYNAMIC_DRAW);
        }
        /**
     * Bind this vertex buffer
     */ bind() {
            const gl = this._gl;
            gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        }
        unbind() {
            const gl = this._gl;
            gl.bindBuffer(gl.ARRAY_BUFFER, null);
        }
        /**
     * Upload vertex buffer geometry to the GPU
     */ upload(count) {
            const gl = this._gl;
            gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
            if (count) gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.bufferData, 0, count);
            else // TODO always use bufferSubData? need to perf test it
            gl.bufferData(gl.ARRAY_BUFFER, this.bufferData, this.type === "static" ? gl.STATIC_DRAW : gl.DYNAMIC_DRAW);
        }
        dispose() {
            const gl = this._gl;
            gl.deleteBuffer(this.buffer);
            this._gl = null;
        }
    }
    /**
 * Helper around creating vertex attributes in a given [[VertexBuffer]], this is useful for describing
 * the memory layout for your vertices inside a particular buffer
 *
 * Note: This helper assumes interleaved attributes in one [[VertexBuffer]], not many.
 *
 * Working with `gl.vertexAttribPointer` can be tricky, and this attempts to double check you
 */ class VertexLayout {
        get vertexBuffer() {
            return this._vertexBuffer;
        }
        get attributes() {
            return this._attributes;
        }
        constructor(options){
            this._logger = Logger.getInstance();
            this._suppressWarnings = false;
            this._layout = [];
            this._attributes = [];
            this._vertexTotalSizeBytes = 0;
            this._initialized = false;
            const { gl: gl, shader: shader, vertexBuffer: vertexBuffer, attributes: attributes, suppressWarnings: suppressWarnings } = options;
            this._gl = gl;
            this._vertexBuffer = vertexBuffer;
            this._attributes = attributes;
            this._shader = shader;
            this._suppressWarnings = suppressWarnings;
            if (shader) this.initialize();
        }
        /**
     * Total number of bytes that the vertex will take up
     */ get totalVertexSizeBytes() {
            return this._vertexTotalSizeBytes;
        }
        set shader(shader) {
            if (shader && this._shader !== shader) {
                this._shader = shader;
                this.initialize();
            }
        }
        get shader() {
            return this._shader;
        }
        /**
     * Layouts need shader locations and must be bound to a shader
     */ initialize() {
            if (this._initialized) return;
            if (!this._shader) return;
            if (!this._shader.compiled) throw Error("Shader not compiled, shader must be compiled before defining a vertex layout");
            this._vertexTotalSizeBytes = 0;
            this._layout.length = 0;
            const shaderAttributes = this._shader.attributes;
            for (const attribute of this._attributes){
                const attrib = shaderAttributes[attribute[0]];
                if (!attrib) {
                    if (!isAttributeInSource(this._shader.vertexSource, attribute[0])) throw Error(`The attribute named: ${attribute[0]} size ${attribute[1]}` + ` not found in the shader source code:\n ${this._shader.vertexSource}`);
                    if (!this._suppressWarnings) this._logger.warn(`The attribute named: ${attribute[0]} size ${attribute[1]}` + ` not found in the compiled shader. This is possibly a bug:\n` + ` 1. Not a bug, but should remove unused code - attribute "${attribute[0]}" is unused in` + ` vertex/fragment and has been automatically removed by glsl compiler.\n` + ` 2. Definitely a bug, attribute "${attribute[0]}" in layout has been mistyped or is missing` + ` in shader, check vertex/fragment source.`);
                    const glType = getGLTypeFromSource(this._gl, this._shader.vertexSource, attribute[0]);
                    // Unused attribute placeholder
                    this._layout.push({
                        name: attribute[0],
                        glType: glType,
                        size: attribute[1],
                        location: -1,
                        normalized: false
                    });
                }
                if (attrib) {
                    if (attrib.size !== attribute[1]) throw Error(`VertexLayout size definition for attribute: [${attribute[0]}, ${attribute[1]}],` + ` doesn\'t match shader source size ${attrib.size}:\n ${this._shader.vertexSource}`);
                    this._layout.push(attrib);
                }
            }
            // calc size
            let componentsPerVertex = 0;
            for (const vertAttribute of this._layout){
                const typeSize = getGlTypeSizeBytes(this._gl, vertAttribute.glType);
                this._vertexTotalSizeBytes += typeSize * vertAttribute.size;
                componentsPerVertex += vertAttribute.size;
            }
            if (this._vertexBuffer.bufferData.length % componentsPerVertex !== 0) this._logger.warn(`The vertex component size (${componentsPerVertex})  does NOT divide evenly into the specified vertex buffer` + ` (${this._vertexBuffer.bufferData.length})`);
            // create VAO
            const gl = this._gl;
            this._vao = gl.createVertexArray();
            gl.bindVertexArray(this._vao);
            this._vertexBuffer.bind();
            let offset = 0;
            for (const vert of this._layout){
                if (vert.location !== -1) {
                    gl.vertexAttribPointer(vert.location, vert.size, vert.glType, vert.normalized, this.totalVertexSizeBytes, offset);
                    gl.enableVertexAttribArray(vert.location);
                }
                offset += getGlTypeSizeBytes(gl, vert.glType) * vert.size;
            }
            gl.bindVertexArray(null);
            this._vertexBuffer.unbind();
            this._initialized = true;
        }
        /**
     * Bind this layout with it's associated vertex buffer
     * @param uploadBuffer Optionally indicate you wish to upload the buffer to the GPU associated with this layout
     */ use(uploadBuffer = false, count) {
            if (!this._shader) throw Error("No shader is associated with this vertex layout, a shader must be set");
            const gl = this._gl;
            if (!this._shader.isCurrentlyBound()) throw Error("Shader associated with this vertex layout is not active! Call shader.use() before layout.use()");
            this._vertexBuffer.bind();
            if (uploadBuffer) this._vertexBuffer.upload(count);
            gl.bindVertexArray(this._vao);
        }
    }
    class GraphicsDiagnostics {
        static clear() {
            GraphicsDiagnostics.DrawCallCount = 0;
            GraphicsDiagnostics.DrawnImagesCount = 0;
        }
    }
    GraphicsDiagnostics.DrawCallCount = 0;
    GraphicsDiagnostics.DrawnImagesCount = 0;
    class LineRenderer {
        constructor(){
            this.type = "ex.line";
            this.priority = 0;
            this._maxLines = 10922;
            this._vertexIndex = 0;
            this._lineCount = 0;
        }
        initialize(gl, context) {
            this._gl = gl;
            this._context = context;
            this._shader = new Shader({
                gl: gl,
                vertexSource: line_vertex,
                fragmentSource: line_fragment
            });
            this._shader.compile();
            this._shader.use();
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            this._vertexBuffer = new VertexBuffer({
                gl: gl,
                size: 12 * this._maxLines,
                type: "dynamic"
            });
            this._layout = new VertexLayout({
                gl: gl,
                vertexBuffer: this._vertexBuffer,
                shader: this._shader,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_color",
                        4
                    ]
                ]
            });
        }
        dispose() {
            this._vertexBuffer.dispose();
            this._shader.dispose();
            this._context = null;
            this._gl = null;
        }
        draw(start, end, color) {
            // Force a render if the batch is full
            if (this._isFull()) this.flush();
            this._lineCount++;
            const transform = this._context.getTransform();
            const finalStart = transform.multiply(start);
            const finalEnd = transform.multiply(end);
            const vertexBuffer = this._vertexBuffer.bufferData;
            // Start
            vertexBuffer[this._vertexIndex++] = finalStart.x;
            vertexBuffer[this._vertexIndex++] = finalStart.y;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            // End
            vertexBuffer[this._vertexIndex++] = finalEnd.x;
            vertexBuffer[this._vertexIndex++] = finalEnd.y;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
        }
        _isFull() {
            if (this._lineCount >= this._maxLines) return true;
            return false;
        }
        hasPendingDraws() {
            return this._lineCount !== 0;
        }
        flush() {
            // nothing to draw early exit
            if (this._lineCount === 0) return;
            const gl = this._gl;
            this._shader.use();
            this._layout.use(true);
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            gl.drawArrays(gl.LINES, 0, this._lineCount * 2); // 2 verts per line
            GraphicsDiagnostics.DrawnImagesCount += this._lineCount;
            GraphicsDiagnostics.DrawCallCount++;
            // reset
            this._vertexIndex = 0;
            this._lineCount = 0;
        }
    }
    /* harmony default export */ const point_vertex = "#version 300 es\r\nin vec2 a_position;\r\nin vec4 a_color;\r\nin float a_size;\r\nout lowp vec4 v_color;\r\nuniform mat4 u_matrix;\r\n\r\nvoid main() {\r\n  gl_Position = u_matrix * vec4(a_position, 0.0, 1.0);\r\n  gl_PointSize = a_size * 2.0;\r\n  v_color = a_color;\r\n}";
    /* harmony default export */ const point_fragment = '#version 300 es\r\n\r\nprecision mediump float;\r\nin lowp vec4 v_color;\r\n\r\nout vec4 fragColor;\r\n\r\nvoid main() {\r\n  float r = 0.0, delta = 0.0, alpha = 1.0;\r\n  vec2 cxy = 2.0 * gl_PointCoord - 1.0;\r\n  r = dot(cxy, cxy);\r\n\r\n  delta = fwidth(r);\r\n  alpha = 1.0 - smoothstep(1.0 - delta, 1.0 + delta, r);\r\n  // "premultiply" the color by alpha\r\n  vec4 color = v_color;\r\n  color.a = color.a * alpha;\r\n  color.rgb = color.rgb * color.a;\r\n  fragColor = color;\r\n}';
    class PointRenderer {
        constructor(){
            this.type = "ex.point";
            this.priority = 0;
            this._maxPoints = 10922;
            this._pointCount = 0;
            this._vertexIndex = 0;
        }
        initialize(gl, context) {
            this._gl = gl;
            this._context = context;
            this._shader = new Shader({
                gl: gl,
                vertexSource: point_vertex,
                fragmentSource: point_fragment
            });
            this._shader.compile();
            this._shader.use();
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            this._buffer = new VertexBuffer({
                gl: gl,
                size: 7 * this._maxPoints,
                type: "dynamic"
            });
            this._layout = new VertexLayout({
                gl: gl,
                shader: this._shader,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_color",
                        4
                    ],
                    [
                        "a_size",
                        1
                    ]
                ]
            });
        }
        dispose() {
            this._buffer.dispose();
            this._shader.dispose();
            this._context = null;
            this._gl = null;
        }
        draw(point, color, size) {
            // Force a render if the batch is full
            if (this._isFull()) this.flush();
            this._pointCount++;
            const transform = this._context.getTransform();
            const opacity = this._context.opacity;
            const snapToPixel = this._context.snapToPixel;
            const finalPoint = transform.multiply(point);
            if (snapToPixel) {
                finalPoint.x = ~~(finalPoint.x + pixelSnapEpsilon);
                finalPoint.y = ~~(finalPoint.y + pixelSnapEpsilon);
            }
            const vertexBuffer = this._buffer.bufferData;
            vertexBuffer[this._vertexIndex++] = finalPoint.x;
            vertexBuffer[this._vertexIndex++] = finalPoint.y;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a * opacity;
            vertexBuffer[this._vertexIndex++] = size * Math.max(transform.getScaleX(), transform.getScaleY());
        }
        _isFull() {
            if (this._pointCount >= this._maxPoints) return true;
            return false;
        }
        hasPendingDraws() {
            return this._pointCount !== 0;
        }
        flush() {
            // nothing to draw early exit
            if (this._pointCount === 0) return;
            const gl = this._gl;
            this._shader.use();
            this._layout.use(true);
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            gl.drawArrays(gl.POINTS, 0, this._pointCount);
            GraphicsDiagnostics.DrawnImagesCount += this._pointCount;
            GraphicsDiagnostics.DrawCallCount++;
            this._pointCount = 0;
            this._vertexIndex = 0;
        }
    }
    /* harmony default export */ const screen_vertex = "#version 300 es\r\nin vec2 a_position;\r\n\r\nin vec2 a_texcoord;\r\nout vec2 v_texcoord;\r\n\r\nvoid main() {\r\n  gl_Position = vec4(a_position, 0.0, 1.0);\r\n\r\n  // Pass the texcoord to the fragment shader.\r\n  v_texcoord = a_texcoord;\r\n}";
    /* harmony default export */ const screen_fragment = "#version 300 es\r\nprecision mediump float;\r\n\r\n// Passed in from the vertex shader.\r\nin vec2 v_texcoord;\r\n\r\n// The texture.\r\nuniform sampler2D u_texture;\r\n\r\nout vec4 fragColor;\r\n\r\nvoid main() {\r\n   fragColor = texture(u_texture, v_texcoord);\r\n}";
    /**
 * This is responsible for painting the entire screen during the render passes
 */ class ScreenPassPainter {
        constructor(gl){
            this._gl = gl;
            this._shader = new Shader({
                gl: gl,
                vertexSource: screen_vertex,
                fragmentSource: screen_fragment
            });
            this._shader.compile();
            // Setup memory layout
            this._buffer = new VertexBuffer({
                gl: gl,
                type: "static",
                // clip space quad + uv since we don't need a camera
                data: new Float32Array([
                    -1,
                    -1,
                    0,
                    0,
                    -1,
                    1,
                    0,
                    1,
                    1,
                    -1,
                    1,
                    0,
                    1,
                    -1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    1,
                    1,
                    1,
                    1,
                    1
                ])
            });
            this._layout = new VertexLayout({
                gl: gl,
                shader: this._shader,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_texcoord",
                        2
                    ]
                ]
            });
            this._buffer.upload();
        }
        renderWithPostProcessor(postprocessor) {
            const gl = this._gl;
            postprocessor.getShader().use();
            postprocessor.getLayout().use();
            gl.drawArrays(gl.TRIANGLES, 0, 6);
        }
        renderToScreen() {
            const gl = this._gl;
            this._shader.use();
            this._layout.use();
            gl.drawArrays(gl.TRIANGLES, 0, 6);
        }
    }
    /**
 * Helper that defines and index buffer for quad geometry
 *
 * Index buffers allow you to save space in vertex buffers when you share vertices in geometry
 * it is almost always worth it in terms of performance to use an index buffer.
 */ class QuadIndexBuffer {
        /**
     * @param gl WebGL2RenderingContext this layout will be attached to, these cannot be reused across contexts.
     * @param numberOfQuads Specify the max number of quads you want to draw
     * @param useUint16 Optionally force a uint16 buffer
     */ constructor(gl, numberOfQuads, useUint16){
            this._logger = Logger.getInstance();
            this._gl = gl;
            this.buffer = gl.createBuffer();
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.buffer);
            const totalVertices = numberOfQuads * 6;
            if (!useUint16) this.bufferData = new Uint32Array(totalVertices);
            else {
                // fall back to using gl.UNSIGNED_SHORT or tell the user they are out of luck
                const maxUint16 = 65535;
                const maxUint16Index = Math.floor((maxUint16 - 1) / 4); // max quads
                this.bufferGlType = gl.UNSIGNED_SHORT;
                this.bufferData = new Uint16Array(totalVertices);
                // TODO Should we error if this happens?? maybe not might crash mid game
                if (numberOfQuads > maxUint16Index) this._logger.warn(`Total quads exceeds hardware index buffer limit (uint16), max(${maxUint16Index}) requested quads(${numberOfQuads})`);
            }
            let currentQuad = 0;
            for(let i = 0; i < totalVertices; i += 6){
                // first triangle
                this.bufferData[i + 0] = currentQuad + 0;
                this.bufferData[i + 1] = currentQuad + 1;
                this.bufferData[i + 2] = currentQuad + 2;
                // second triangle
                this.bufferData[i + 3] = currentQuad + 2;
                this.bufferData[i + 4] = currentQuad + 1;
                this.bufferData[i + 5] = currentQuad + 3;
                currentQuad += 4;
            }
            gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.bufferData, gl.STATIC_DRAW);
        }
        get size() {
            return this.bufferData.length;
        }
        /**
     * Upload data to the GPU
     */ upload() {
            const gl = this._gl;
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.buffer);
            gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.bufferData, gl.STATIC_DRAW);
        }
        /**
     * Bind this index buffer
     */ bind() {
            const gl = this._gl;
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.buffer);
        }
        dispose() {
            const gl = this._gl;
            gl.deleteBuffer(this.buffer);
            this._gl = null;
        }
    }
    /* harmony default export */ const image_renderer_frag = "#version 300 es\r\nprecision mediump float;\r\n\r\n// UV coord\r\nin vec2 v_texcoord;\r\n\r\n// Texture index\r\nin lowp float v_textureIndex;\r\n\r\n// Textures in the current draw\r\nuniform sampler2D u_textures[%%count%%];\r\n\r\nuniform bool u_pixelart;\r\n\r\n// Opacity\r\nin float v_opacity;\r\n\r\nin vec4 v_tint;\r\n\r\nin vec2 v_res;\r\n\r\nout vec4 fragColor;\r\n\r\n// Inigo Quilez pixel art filter https://jorenjoestar.github.io/post/pixel_art_filtering/\r\nvec2 uv_iq(in vec2 uv, in vec2 texture_size) {\r\n  vec2 pixel = uv * texture_size;\r\n  \r\n  vec2 seam=floor(pixel+.5);\r\n  vec2 dudv=fwidth(pixel);\r\n  pixel=seam+clamp((pixel-seam)/dudv,-.5,.5);\r\n  \r\n  return pixel/texture_size;\r\n}\r\n\r\nvoid main(){\r\n  // In order to support the most efficient sprite batching, we have multiple\r\n  // textures loaded into the gpu (usually 8) this picker logic skips over textures\r\n  // that do not apply to a particular sprite.\r\n  \r\n  vec4 color=vec4(1.,0,0,1.);\r\n  \r\n  // GLSL is templated out to pick the right texture and set the vec4 color\r\n  %%texture_picker%%\r\n  \r\n  color.rgb=color.rgb*v_opacity;\r\n  color.a=color.a*v_opacity;\r\n  fragColor=color*v_tint;\r\n}";
    /* harmony default export */ const image_renderer_vert = "#version 300 es\r\nin vec2 a_position;\r\n\r\n// Opacity\r\nin float a_opacity;\r\nout float v_opacity;\r\n\r\n// UV coordinate\r\nin vec2 a_texcoord;\r\nout vec2 v_texcoord;\r\n\r\n// Texture res\r\nin vec2 a_res;\r\nout vec2 v_res;\r\n\r\n// Texture number\r\nin lowp float a_textureIndex;\r\nout lowp float v_textureIndex;\r\n\r\nin vec4 a_tint;\r\nout vec4 v_tint;\r\n\r\nuniform mat4 u_matrix;\r\n\r\nvoid main(){\r\n  // Set the vertex position using the ortho transform matrix\r\n  gl_Position=u_matrix*vec4(a_position,0.,1.);\r\n  \r\n  // Pass through the Opacity to the fragment shader\r\n  v_opacity=a_opacity;\r\n  // Pass through the UV coord to the fragment shader\r\n  v_texcoord=a_texcoord;\r\n\r\n  v_res = a_res;\r\n\r\n  // Pass through the texture number to the fragment shader\r\n  v_textureIndex=a_textureIndex;\r\n  // Pass through the tint\r\n  v_tint=a_tint;\r\n}";
    class ImageRenderer {
        constructor(options){
            this.type = "ex.image";
            this.priority = 0;
            this._maxImages = 10922; // max(uint16) / 6 verts
            this._maxTextures = 0;
            // Per flush vars
            this._imageCount = 0;
            this._textures = [];
            this._textureIndex = 0;
            this._textureToIndex = new Map();
            this._images = new Set();
            this._vertexIndex = 0;
            this._imageToWidth = new Map();
            this._imageToHeight = new Map();
            this._view = [
                0,
                0,
                0,
                0
            ];
            this._dest = [
                0,
                0
            ];
            this._quad = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ];
            this.pixelArtSampler = options.pixelArtSampler;
            this.uvPadding = options.uvPadding;
        }
        initialize(gl, context) {
            this._gl = gl;
            this._context = context;
            // Transform shader source
            // FIXME: PIXEL 6 complains `ERROR: Expression too complex.` if we use it's reported max texture units, 125 seems to work for now...
            this._maxTextures = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), 125);
            const transformedFrag = this._transformFragmentSource(image_renderer_frag, this._maxTextures);
            // Compile shader
            this._shader = new Shader({
                gl: gl,
                fragmentSource: transformedFrag,
                vertexSource: image_renderer_vert
            });
            this._shader.compile();
            // setup uniforms
            this._shader.use();
            this._shader.setUniformMatrix("u_matrix", context.ortho);
            // Initialize texture slots to [0, 1, 2, 3, 4, .... maxGPUTextures]
            this._shader.setUniformIntArray("u_textures", [
                ...Array(this._maxTextures)
            ].map((_, i)=>i));
            // Setup memory layout
            this._buffer = new VertexBuffer({
                gl: gl,
                size: 48 * this._maxImages,
                type: "dynamic"
            });
            this._layout = new VertexLayout({
                gl: gl,
                shader: this._shader,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_opacity",
                        1
                    ],
                    [
                        "a_res",
                        2
                    ],
                    [
                        "a_texcoord",
                        2
                    ],
                    [
                        "a_textureIndex",
                        1
                    ],
                    [
                        "a_tint",
                        4
                    ]
                ]
            });
            // Setup index buffer
            this._quads = new QuadIndexBuffer(gl, this._maxImages, true);
        }
        dispose() {
            this._buffer.dispose();
            this._quads.dispose();
            this._shader.dispose();
            this._textures.length = 0;
            this._context = null;
            this._gl = null;
        }
        _transformFragmentSource(source, maxTextures) {
            let newSource = source.replace("%%count%%", maxTextures.toString());
            let texturePickerBuilder = "";
            for(let i = 0; i < maxTextures; i++){
                if (i === 0) texturePickerBuilder += `if (v_textureIndex <= ${i}.5) {\n`;
                else texturePickerBuilder += `   else if (v_textureIndex <= ${i}.5) {\n`;
                texturePickerBuilder += `      vec2 uv = u_pixelart ? uv_iq(v_texcoord, v_res) : v_texcoord;\n`;
                texturePickerBuilder += `      color = texture(u_textures[${i}], uv);\n`;
                texturePickerBuilder += `   }\n`;
            }
            newSource = newSource.replace("%%texture_picker%%", texturePickerBuilder);
            return newSource;
        }
        _addImageAsTexture(image) {
            if (this._images.has(image)) return;
            const maybeFiltering = image.getAttribute(ImageSourceAttributeConstants.Filtering);
            const filtering = maybeFiltering ? parseImageFiltering(maybeFiltering) : null;
            const wrapX = parseImageWrapping(image.getAttribute(ImageSourceAttributeConstants.WrappingX));
            const wrapY = parseImageWrapping(image.getAttribute(ImageSourceAttributeConstants.WrappingY));
            const force = image.getAttribute("forceUpload") === "true" ? true : false;
            const texture = this._context.textureLoader.load(image, {
                filtering: filtering,
                wrapping: {
                    x: wrapX,
                    y: wrapY
                }
            }, force);
            // remove force attribute after upload
            image.removeAttribute("forceUpload");
            if (this._textures.indexOf(texture) === -1) {
                this._textures.push(texture);
                this._textureToIndex.set(texture, this._textureIndex++);
                this._images.add(image);
            }
        }
        _bindTextures(gl) {
            // Bind textures in the correct order
            for(let i = 0; i < this._maxTextures; i++){
                gl.activeTexture(gl.TEXTURE0 + i);
                gl.bindTexture(gl.TEXTURE_2D, this._textures[i] || this._textures[0]);
            }
        }
        _getTextureIdForImage(image) {
            var _a;
            if (image) {
                const maybeTexture = this._context.textureLoader.get(image);
                return (_a = this._textureToIndex.get(maybeTexture)) !== null && _a !== void 0 ? _a : -1; //this._textures.indexOf(maybeTexture);
            }
            return -1;
        }
        _isFull() {
            if (this._imageCount >= this._maxImages) return true;
            if (this._textures.length >= this._maxTextures) return true;
            return false;
        }
        _getImageWidth(image) {
            let maybeWidth = this._imageToWidth.get(image);
            if (maybeWidth === undefined) {
                maybeWidth = image.width;
                this._imageToWidth.set(image, maybeWidth);
            }
            return maybeWidth;
        }
        _getImageHeight(image) {
            let maybeHeight = this._imageToHeight.get(image);
            if (maybeHeight === undefined) {
                maybeHeight = image.height;
                this._imageToHeight.set(image, maybeHeight);
            }
            return maybeHeight;
        }
        draw(image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight) {
            var _a, _b, _c, _d;
            // Force a render if the batch is full
            if (this._isFull()) this.flush();
            this._imageCount++;
            // This creates and uploads the texture if not already done
            this._addImageAsTexture(image);
            const maybeImageWidth = this._getImageWidth(image);
            const maybeImageHeight = this._getImageHeight(image);
            let width = maybeImageWidth || swidth || 0;
            let height = maybeImageHeight || sheight || 0;
            this._view[2] = (_a = swidth !== null && swidth !== void 0 ? swidth : maybeImageWidth) !== null && _a !== void 0 ? _a : 0;
            this._view[3] = (_b = sheight !== null && sheight !== void 0 ? sheight : maybeImageHeight) !== null && _b !== void 0 ? _b : 0;
            this._dest[0] = sx !== null && sx !== void 0 ? sx : 1;
            this._dest[1] = sy !== null && sy !== void 0 ? sy : 1;
            // If destination is specified, update view and dest
            if (dx !== undefined && dy !== undefined && dwidth !== undefined && dheight !== undefined) {
                this._view[0] = sx !== null && sx !== void 0 ? sx : 1;
                this._view[1] = sy !== null && sy !== void 0 ? sy : 1;
                this._view[2] = (_c = swidth !== null && swidth !== void 0 ? swidth : maybeImageWidth) !== null && _c !== void 0 ? _c : 0;
                this._view[3] = (_d = sheight !== null && sheight !== void 0 ? sheight : maybeImageHeight) !== null && _d !== void 0 ? _d : 0;
                this._dest[0] = dx;
                this._dest[1] = dy;
                width = dwidth;
                height = dheight;
            }
            sx = this._view[0];
            sy = this._view[1];
            const sw = this._view[2];
            const sh = this._view[3];
            // transform based on current context
            const transform = this._context.getTransform();
            const opacity = this._context.opacity;
            const snapToPixel = this._context.snapToPixel;
            // top left
            this._quad[0] = this._dest[0];
            this._quad[1] = this._dest[1];
            // top right
            this._quad[2] = this._dest[0] + width;
            this._quad[3] = this._dest[1];
            // bottom left
            this._quad[4] = this._dest[0];
            this._quad[5] = this._dest[1] + height;
            // bottom right
            this._quad[6] = this._dest[0] + width;
            this._quad[7] = this._dest[1] + height;
            transform.multiplyQuadInPlace(this._quad);
            if (snapToPixel) {
                this._quad[0] = ~~(this._quad[0] + sign(this._quad[0]) * pixelSnapEpsilon);
                this._quad[1] = ~~(this._quad[1] + sign(this._quad[1]) * pixelSnapEpsilon);
                this._quad[2] = ~~(this._quad[2] + sign(this._quad[2]) * pixelSnapEpsilon);
                this._quad[3] = ~~(this._quad[3] + sign(this._quad[3]) * pixelSnapEpsilon);
                this._quad[4] = ~~(this._quad[4] + sign(this._quad[4]) * pixelSnapEpsilon);
                this._quad[5] = ~~(this._quad[5] + sign(this._quad[5]) * pixelSnapEpsilon);
                this._quad[6] = ~~(this._quad[6] + sign(this._quad[6]) * pixelSnapEpsilon);
                this._quad[7] = ~~(this._quad[7] + sign(this._quad[7]) * pixelSnapEpsilon);
            }
            const tint = this._context.tint;
            const textureId = this._getTextureIdForImage(image);
            const imageWidth = maybeImageWidth || width;
            const imageHeight = maybeImageHeight || height;
            const uvx0 = (sx + this.uvPadding) / imageWidth;
            const uvy0 = (sy + this.uvPadding) / imageHeight;
            const uvx1 = (sx + sw - this.uvPadding) / imageWidth;
            const uvy1 = (sy + sh - this.uvPadding) / imageHeight;
            const txWidth = maybeImageWidth;
            const txHeight = maybeImageHeight;
            // update data
            const vertexBuffer = this._layout.vertexBuffer.bufferData;
            // (0, 0) - 0
            vertexBuffer[this._vertexIndex++] = this._quad[0];
            vertexBuffer[this._vertexIndex++] = this._quad[1];
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = txWidth;
            vertexBuffer[this._vertexIndex++] = txHeight;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = textureId;
            vertexBuffer[this._vertexIndex++] = tint.r / 255;
            vertexBuffer[this._vertexIndex++] = tint.g / 255;
            vertexBuffer[this._vertexIndex++] = tint.b / 255;
            vertexBuffer[this._vertexIndex++] = tint.a;
            // (0, 1) - 1
            vertexBuffer[this._vertexIndex++] = this._quad[4];
            vertexBuffer[this._vertexIndex++] = this._quad[5];
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = txWidth;
            vertexBuffer[this._vertexIndex++] = txHeight;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = textureId;
            vertexBuffer[this._vertexIndex++] = tint.r / 255;
            vertexBuffer[this._vertexIndex++] = tint.g / 255;
            vertexBuffer[this._vertexIndex++] = tint.b / 255;
            vertexBuffer[this._vertexIndex++] = tint.a;
            // (1, 0) - 2
            vertexBuffer[this._vertexIndex++] = this._quad[2];
            vertexBuffer[this._vertexIndex++] = this._quad[3];
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = txWidth;
            vertexBuffer[this._vertexIndex++] = txHeight;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = textureId;
            vertexBuffer[this._vertexIndex++] = tint.r / 255;
            vertexBuffer[this._vertexIndex++] = tint.g / 255;
            vertexBuffer[this._vertexIndex++] = tint.b / 255;
            vertexBuffer[this._vertexIndex++] = tint.a;
            // (1, 1) - 3
            vertexBuffer[this._vertexIndex++] = this._quad[6];
            vertexBuffer[this._vertexIndex++] = this._quad[7];
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = txWidth;
            vertexBuffer[this._vertexIndex++] = txHeight;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = textureId;
            vertexBuffer[this._vertexIndex++] = tint.r / 255;
            vertexBuffer[this._vertexIndex++] = tint.g / 255;
            vertexBuffer[this._vertexIndex++] = tint.b / 255;
            vertexBuffer[this._vertexIndex++] = tint.a;
        }
        hasPendingDraws() {
            return this._imageCount !== 0;
        }
        flush() {
            // nothing to draw early exit
            if (this._imageCount === 0) return;
            const gl = this._gl;
            // Bind the shader
            this._shader.use();
            // Bind the memory layout and upload data
            this._layout.use(true, 48 * this._imageCount); // 4 verts * 12 components
            // Update ortho matrix uniform
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            // Turn on pixel art aa sampler
            this._shader.setUniformBoolean("u_pixelart", this.pixelArtSampler);
            // Bind textures to
            this._bindTextures(gl);
            // Bind index buffer
            this._quads.bind();
            // Draw all the quads
            gl.drawElements(gl.TRIANGLES, this._imageCount * 6, this._quads.bufferGlType, 0);
            GraphicsDiagnostics.DrawnImagesCount += this._imageCount;
            GraphicsDiagnostics.DrawCallCount++;
            // Reset
            this._imageCount = 0;
            this._vertexIndex = 0;
            this._textures.length = 0;
            this._textureIndex = 0;
            this._textureToIndex.clear();
            this._images.clear();
            this._imageToWidth.clear();
            this._imageToHeight.clear();
        }
    }
    /* harmony default export */ const rectangle_renderer_frag = "#version 300 es\r\n\r\nprecision mediump float;\r\n\r\n// UV coord\r\nin vec2 v_uv;\r\n\r\nin vec2 v_size; // in pixels\r\n\r\n// Color coord to blend with image\r\nin lowp vec4 v_color;\r\n\r\n// Stroke color if used\r\nin lowp vec4 v_strokeColor;\r\n\r\n// Stroke thickness if used\r\nin lowp float v_strokeThickness; // in pixels\r\n\r\n// Opacity\r\nin float v_opacity;\r\n\r\nout vec4 fragColor;\r\n\r\nvoid main() {\r\n    // modified from https://stackoverflow.com/questions/59197671/glsl-rounded-rectangle-with-variable-border\r\n    vec2 uv = v_uv;\r\n    vec2 fragCoord = uv * v_size;\r\n    float maxX = v_size.x - v_strokeThickness;\r\n    float minX = v_strokeThickness;\r\n    float maxY = v_size.y - v_strokeThickness;\r\n    float minY = v_strokeThickness;\r\n\r\n    if (fragCoord.x < maxX && fragCoord.x > minX &&\r\n        fragCoord.y < maxY && fragCoord.y > minY) {\r\n      fragColor = v_color;\r\n    } else {\r\n      fragColor = v_strokeColor;\r\n    }\r\n    fragColor.a *= v_opacity;\r\n    fragColor.rgb *= fragColor.a;\r\n\r\n    // vec2 v2CenteredPos     = abs(fragCoord - v_size.xy / 2.0);\r\n    // vec2 v2HalfShapeSizePx = v_size.xy/2.0 - v_strokeThickness/2.0;\r\n\r\n    // float fHalfBorderDist      = 0.0;\r\n    // float fHalfBorderThickness = 0.0;\r\n\r\n    // if (fragCoord.x > max(v_radius, v_strokeThickness) && \r\n    //     fragCoord.x < v_size.x - max(v_radius, v_strokeThickness))\r\n    // {\r\n    //     fHalfBorderDist      = v2CenteredPos.y - v2HalfShapeSizePx.y;\r\n    //     fHalfBorderThickness = v_strokeThickness / 2.0;\r\n    // }\r\n    // else if (fragCoord.y > max(v_radius, v_strokeThickness) && \r\n    //          fragCoord.y < v_size.y - max(v_radius, v_strokeThickness))\r\n    // {\r\n    //     fHalfBorderDist      = v2CenteredPos.x - v2HalfShapeSizePx.x;\r\n    //     fHalfBorderThickness = v_strokeThickness / 2.0;\r\n    // }\r\n    // else\r\n    // {\r\n    //     vec2 edgeVec = max(vec2(0.0), v_radius - vec2(\r\n    //         uv.x > 0.5 ? v_size.x - fragCoord.x : fragCoord.x,\r\n    //         uv.y > 0.5 ? v_size.y - fragCoord.y : fragCoord.y));\r\n        \r\n    //     float ellipse_ab    = v_radius-v_strokeThickness;\r\n    //     vec2 ellipse_isect = (v_strokeThickness > v_radius || v_strokeThickness > v_radius) ? vec2(0.0) :\r\n    //                             edgeVec.xy * ellipse_ab*ellipse_ab / length(ellipse_ab*edgeVec.yx); \r\n            \r\n    //     fHalfBorderThickness = (v_radius - length(ellipse_isect)) / 2.0;\r\n    //     fHalfBorderDist      = length(edgeVec) - (v_radius - fHalfBorderThickness);\r\n    // }\r\n\r\n    // vec4 v4FromColor = v_strokeColor;\r\n    // v4FromColor.rgb *= v4FromColor.a;\r\n    // vec4 v4ToColor   = vec4(0.0); // background color is transparent\r\n    // if (fHalfBorderDist < 0.0) {\r\n    //     v4ToColor = v_color;\r\n    //     v4ToColor.rgb *= v4ToColor.a;\r\n    // }\r\n\r\n    // float mixPct = abs(fHalfBorderDist) - fHalfBorderThickness;\r\n\r\n    // vec4 finalColor = mix(v4FromColor, v4ToColor, mixPct);\r\n    // gl_FragColor = finalColor;\r\n}";
    /* harmony default export */ const rectangle_renderer_vert = "#version 300 es\r\nin vec2 a_position;\r\n\r\n// UV coordinate\r\nin vec2 a_uv;\r\nout vec2 v_uv;\r\n\r\nin vec2 a_size;\r\nout vec2 v_size;\r\n\r\n// Opacity \r\nin float a_opacity;\r\nout float v_opacity;\r\n\r\nin vec4 a_color;\r\nout vec4 v_color;\r\n\r\nin vec4 a_strokeColor;\r\nout vec4 v_strokeColor;\r\n\r\nin float a_strokeThickness;\r\nout float v_strokeThickness;\r\n\r\nuniform mat4 u_matrix;\r\n\r\n\r\nvoid main() {\r\n   // Set the vertex position using the ortho transform matrix\r\n   gl_Position = u_matrix * vec4(a_position, 0.0, 1.0);\r\n\r\n   // Pass through UV coords\r\n   v_uv = a_uv;\r\n   // Pass through size\r\n   v_size = a_size;\r\n   // Pass through the Opacity to the fragment shader\r\n   v_opacity = a_opacity;\r\n   // Pass through the color to the fragment shader\r\n   v_color = a_color;\r\n   // Pass through the stroke color to the fragment shader\r\n   v_strokeColor = a_strokeColor;\r\n   // Pass through the stroke thickenss to the fragment shader\r\n   v_strokeThickness = a_strokeThickness;\r\n}";
    class RectangleRenderer {
        constructor(){
            this.type = "ex.rectangle";
            this.priority = 0;
            this._maxRectangles = 10922; // max(uint16) / 6 verts
            this._rectangleCount = 0;
            this._vertexIndex = 0;
        }
        initialize(gl, context) {
            this._gl = gl;
            this._context = context;
            // https://stackoverflow.com/questions/59197671/glsl-rounded-rectangle-with-variable-border
            this._shader = new Shader({
                gl: gl,
                fragmentSource: rectangle_renderer_frag,
                vertexSource: rectangle_renderer_vert
            });
            this._shader.compile();
            // setup uniforms
            this._shader.use();
            this._shader.setUniformMatrix("u_matrix", context.ortho);
            this._buffer = new VertexBuffer({
                gl: gl,
                size: 64 * this._maxRectangles,
                type: "dynamic"
            });
            this._layout = new VertexLayout({
                gl: gl,
                shader: this._shader,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_uv",
                        2
                    ],
                    [
                        "a_size",
                        2
                    ],
                    [
                        "a_opacity",
                        1
                    ],
                    [
                        "a_color",
                        4
                    ],
                    [
                        "a_strokeColor",
                        4
                    ],
                    [
                        "a_strokeThickness",
                        1
                    ]
                ]
            });
            this._quads = new QuadIndexBuffer(gl, this._maxRectangles, true);
        }
        dispose() {
            this._buffer.dispose();
            this._quads.dispose();
            this._shader.dispose();
            this._context = null;
            this._gl = null;
        }
        _isFull() {
            if (this._rectangleCount >= this._maxRectangles) return true;
            return false;
        }
        draw(...args) {
            if (args[0] instanceof Vector && args[1] instanceof Vector) this.drawLine.apply(this, args);
            else this.drawRectangle.apply(this, args);
        }
        drawLine(start, end, color, thickness = 1) {
            if (this._isFull()) this.flush();
            this._rectangleCount++;
            // transform based on current context
            const transform = this._context.getTransform();
            const opacity = this._context.opacity;
            const snapToPixel = this._context.snapToPixel;
            const dir = end.sub(start);
            const length = dir.size;
            const normal = dir.normalize().perpendicular();
            const halfThick = thickness / 2;
            /**
         *    +---------------------^----------------------+
         *    |                     | (normal)             |
         *   (startx, starty)------------------>(endx, endy)
         *    |                                            |
         *    + -------------------------------------------+
         */ const startTop = transform.multiply(normal.scale(halfThick).add(start));
            const startBottom = transform.multiply(normal.scale(-halfThick).add(start));
            const endTop = transform.multiply(normal.scale(halfThick).add(end));
            const endBottom = transform.multiply(normal.scale(-halfThick).add(end));
            if (snapToPixel) {
                startTop.x = ~~(startTop.x + pixelSnapEpsilon);
                startTop.y = ~~(startTop.y + pixelSnapEpsilon);
                endTop.x = ~~(endTop.x + pixelSnapEpsilon);
                endTop.y = ~~(endTop.y + pixelSnapEpsilon);
                startBottom.x = ~~(startBottom.x + pixelSnapEpsilon);
                startBottom.y = ~~(startBottom.y + pixelSnapEpsilon);
                endBottom.x = ~~(endBottom.x + pixelSnapEpsilon);
                endBottom.y = ~~(endBottom.y + pixelSnapEpsilon);
            }
            // TODO uv could be static vertex buffer
            const uvx0 = 0;
            const uvy0 = 0;
            const uvx1 = 1;
            const uvy1 = 1;
            const stroke = Color.Transparent;
            const strokeThickness = 0;
            const width = 1;
            // update data
            const vertexBuffer = this._layout.vertexBuffer.bufferData;
            // (0, 0) - 0
            vertexBuffer[this._vertexIndex++] = startTop.x;
            vertexBuffer[this._vertexIndex++] = startTop.y;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = length;
            vertexBuffer[this._vertexIndex++] = thickness;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / width;
            // (0, 1) - 1
            vertexBuffer[this._vertexIndex++] = startBottom.x;
            vertexBuffer[this._vertexIndex++] = startBottom.y;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = length;
            vertexBuffer[this._vertexIndex++] = thickness;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / width;
            // (1, 0) - 2
            vertexBuffer[this._vertexIndex++] = endTop.x;
            vertexBuffer[this._vertexIndex++] = endTop.y;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = length;
            vertexBuffer[this._vertexIndex++] = thickness;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / width;
            // (1, 1) - 3
            vertexBuffer[this._vertexIndex++] = endBottom.x;
            vertexBuffer[this._vertexIndex++] = endBottom.y;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = length;
            vertexBuffer[this._vertexIndex++] = thickness;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / width;
        }
        drawRectangle(pos, width, height, color, stroke = Color.Transparent, strokeThickness = 0) {
            if (this._isFull()) this.flush();
            this._rectangleCount++;
            // transform based on current context
            const transform = this._context.getTransform();
            const opacity = this._context.opacity;
            const snapToPixel = this._context.snapToPixel;
            const topLeft = transform.multiply(pos.add(vec(0, 0)));
            const topRight = transform.multiply(pos.add(vec(width, 0)));
            const bottomRight = transform.multiply(pos.add(vec(width, height)));
            const bottomLeft = transform.multiply(pos.add(vec(0, height)));
            if (snapToPixel) {
                topLeft.x = ~~(topLeft.x + pixelSnapEpsilon);
                topLeft.y = ~~(topLeft.y + pixelSnapEpsilon);
                topRight.x = ~~(topRight.x + pixelSnapEpsilon);
                topRight.y = ~~(topRight.y + pixelSnapEpsilon);
                bottomLeft.x = ~~(bottomLeft.x + pixelSnapEpsilon);
                bottomLeft.y = ~~(bottomLeft.y + pixelSnapEpsilon);
                bottomRight.x = ~~(bottomRight.x + pixelSnapEpsilon);
                bottomRight.y = ~~(bottomRight.y + pixelSnapEpsilon);
            }
            // TODO uv could be static vertex buffer
            const uvx0 = 0;
            const uvy0 = 0;
            const uvx1 = 1;
            const uvy1 = 1;
            // update data
            const vertexBuffer = this._layout.vertexBuffer.bufferData;
            // (0, 0) - 0
            vertexBuffer[this._vertexIndex++] = topLeft.x;
            vertexBuffer[this._vertexIndex++] = topLeft.y;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = width;
            vertexBuffer[this._vertexIndex++] = height;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness;
            // (0, 1) - 1
            vertexBuffer[this._vertexIndex++] = bottomLeft.x;
            vertexBuffer[this._vertexIndex++] = bottomLeft.y;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = width;
            vertexBuffer[this._vertexIndex++] = height;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness;
            // (1, 0) - 2
            vertexBuffer[this._vertexIndex++] = topRight.x;
            vertexBuffer[this._vertexIndex++] = topRight.y;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = width;
            vertexBuffer[this._vertexIndex++] = height;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness;
            // (1, 1) - 3
            vertexBuffer[this._vertexIndex++] = bottomRight.x;
            vertexBuffer[this._vertexIndex++] = bottomRight.y;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = width;
            vertexBuffer[this._vertexIndex++] = height;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness;
        }
        hasPendingDraws() {
            return this._rectangleCount !== 0;
        }
        flush() {
            // nothing to draw early exit
            if (this._rectangleCount === 0) return;
            const gl = this._gl;
            // Bind the shader
            this._shader.use();
            // Bind the memory layout and upload data
            this._layout.use(true);
            // Update ortho matrix uniform
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            // Bind index buffer
            this._quads.bind();
            // Draw all the quads
            gl.drawElements(gl.TRIANGLES, this._rectangleCount * 6, this._quads.bufferGlType, 0);
            GraphicsDiagnostics.DrawnImagesCount += this._rectangleCount;
            GraphicsDiagnostics.DrawCallCount++;
            // Reset
            this._rectangleCount = 0;
            this._vertexIndex = 0;
        }
    }
    /* harmony default export */ const circle_renderer_frag = "#version 300 es\r\nprecision highp float;\r\n\r\n// UV coord\r\nin vec2 v_uv;\r\n\r\n// Color coord to blend with image\r\nin lowp vec4 v_color;\r\n\r\n// Stroke color if used\r\nin lowp vec4 v_strokeColor;\r\n\r\n// Stroke thickness if used\r\nin lowp float v_strokeThickness;\r\n\r\n// Opacity\r\nin float v_opacity;\r\n\r\nout vec4 fragColor;\r\n\r\nvoid main() {\r\n  // make (0, 0) the center the uv \r\n  vec2 uv = v_uv * 2.0 - 1.0;\r\n\r\n  vec4 color = v_color;\r\n  vec4 strokeColor = v_strokeColor;\r\n\r\n  // circle border is at radius 1.0 \r\n  // dist is > 0 when inside the circle \r\n  float d = length(uv);\r\n  float dist = 1.0 - length(uv);\r\n\r\n  // Fade based on fwidth\r\n  float fade = fwidth(dot(uv, uv));\r\n\r\n  // if dist is greater than 0 step to 1;\r\n  // when we cross this 0 threshold add a smooth fade\r\n  float fill = smoothstep(-fade/2.0, fade/2.0, dist);\r\n\r\n  // if dist is greater than the stroke thickness step to 1\r\n  float stroke = 1.0 - smoothstep(v_strokeThickness, v_strokeThickness + fade, dist);\r\n\r\n  strokeColor.a *= fill * stroke;\r\n  strokeColor.rgb *= strokeColor.a;\r\n\r\n  color.a *= fill * (1.0 - stroke);\r\n  color.rgb *= color.a;\r\n\r\n  vec4 finalColor = mix(vec4(0.0), (color + strokeColor), fill);\r\n  finalColor.rgb = finalColor.rgb * v_opacity;\r\n  finalColor.a = finalColor.a * v_opacity;\r\n  fragColor = finalColor;\r\n}";
    /* harmony default export */ const circle_renderer_vert = "#version 300 es\r\nin vec2 a_position;\r\n\r\n// UV coordinate\r\nin vec2 a_uv;\r\nout vec2 v_uv;\r\n\r\n// Opacity \r\nin float a_opacity;\r\nout float v_opacity;\r\n\r\nin vec4 a_color;\r\nout vec4 v_color;\r\n\r\nin vec4 a_strokeColor;\r\nout vec4 v_strokeColor;\r\n\r\nin float a_strokeThickness;\r\nout float v_strokeThickness;\r\n\r\nuniform mat4 u_matrix;\r\n\r\n\r\nvoid main() {\r\n   // Set the vertex position using the ortho transform matrix\r\n   gl_Position = u_matrix * vec4(a_position, 0.0, 1.0);\r\n\r\n   // Pass through UV coords\r\n   v_uv = a_uv;\r\n   // Pass through the Opacity to the fragment shader\r\n   v_opacity = a_opacity;\r\n   // Pass through the color to the fragment shader\r\n   v_color = a_color;\r\n   // Pass through the stroke color to the fragment shader\r\n   v_strokeColor = a_strokeColor;\r\n   // Pass through the stroke thickenss to the fragment shader\r\n   v_strokeThickness = a_strokeThickness;\r\n}";
    class CircleRenderer {
        constructor(){
            this.type = "ex.circle";
            this.priority = 0;
            this._maxCircles = 10922; // max(uint16) / 6 verts
            this._circleCount = 0;
            this._vertexIndex = 0;
        }
        initialize(gl, context) {
            this._gl = gl;
            this._context = context;
            this._shader = new Shader({
                gl: gl,
                fragmentSource: circle_renderer_frag,
                vertexSource: circle_renderer_vert
            });
            this._shader.compile();
            // setup uniforms
            this._shader.use();
            this._shader.setUniformMatrix("u_matrix", context.ortho);
            this._buffer = new VertexBuffer({
                gl: gl,
                size: 56 * this._maxCircles,
                type: "dynamic"
            });
            this._layout = new VertexLayout({
                gl: gl,
                shader: this._shader,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_uv",
                        2
                    ],
                    [
                        "a_opacity",
                        1
                    ],
                    [
                        "a_color",
                        4
                    ],
                    [
                        "a_strokeColor",
                        4
                    ],
                    [
                        "a_strokeThickness",
                        1
                    ]
                ]
            });
            this._quads = new QuadIndexBuffer(gl, this._maxCircles, true);
        }
        dispose() {
            this._buffer.dispose();
            this._quads.dispose();
            this._shader.dispose();
            this._context = null;
            this._gl = null;
        }
        _isFull() {
            if (this._circleCount >= this._maxCircles) return true;
            return false;
        }
        draw(pos, radius, color, stroke = Color.Transparent, strokeThickness = 0) {
            if (this._isFull()) this.flush();
            this._circleCount++;
            // transform based on current context
            const transform = this._context.getTransform();
            const opacity = this._context.opacity;
            const snapToPixel = this._context.snapToPixel;
            const topLeft = transform.multiply(pos.add(vec(-radius, -radius)));
            const topRight = transform.multiply(pos.add(vec(radius, -radius)));
            const bottomRight = transform.multiply(pos.add(vec(radius, radius)));
            const bottomLeft = transform.multiply(pos.add(vec(-radius, radius)));
            if (snapToPixel) {
                topLeft.x = ~~(topLeft.x + pixelSnapEpsilon);
                topLeft.y = ~~(topLeft.y + pixelSnapEpsilon);
                topRight.x = ~~(topRight.x + pixelSnapEpsilon);
                topRight.y = ~~(topRight.y + pixelSnapEpsilon);
                bottomLeft.x = ~~(bottomLeft.x + pixelSnapEpsilon);
                bottomLeft.y = ~~(bottomLeft.y + pixelSnapEpsilon);
                bottomRight.x = ~~(bottomRight.x + pixelSnapEpsilon);
                bottomRight.y = ~~(bottomRight.y + pixelSnapEpsilon);
            }
            // TODO UV could be static vertex buffer
            const uvx0 = 0;
            const uvy0 = 0;
            const uvx1 = 1;
            const uvy1 = 1;
            // update data
            const vertexBuffer = this._layout.vertexBuffer.bufferData;
            // (0, 0) - 0
            vertexBuffer[this._vertexIndex++] = topLeft.x;
            vertexBuffer[this._vertexIndex++] = topLeft.y;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / radius;
            // (0, 1) - 1
            vertexBuffer[this._vertexIndex++] = bottomLeft.x;
            vertexBuffer[this._vertexIndex++] = bottomLeft.y;
            vertexBuffer[this._vertexIndex++] = uvx0;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / radius;
            // (1, 0) - 2
            vertexBuffer[this._vertexIndex++] = topRight.x;
            vertexBuffer[this._vertexIndex++] = topRight.y;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy0;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / radius;
            // (1, 1) - 3
            vertexBuffer[this._vertexIndex++] = bottomRight.x;
            vertexBuffer[this._vertexIndex++] = bottomRight.y;
            vertexBuffer[this._vertexIndex++] = uvx1;
            vertexBuffer[this._vertexIndex++] = uvy1;
            vertexBuffer[this._vertexIndex++] = opacity;
            vertexBuffer[this._vertexIndex++] = color.r / 255;
            vertexBuffer[this._vertexIndex++] = color.g / 255;
            vertexBuffer[this._vertexIndex++] = color.b / 255;
            vertexBuffer[this._vertexIndex++] = color.a;
            vertexBuffer[this._vertexIndex++] = stroke.r / 255;
            vertexBuffer[this._vertexIndex++] = stroke.g / 255;
            vertexBuffer[this._vertexIndex++] = stroke.b / 255;
            vertexBuffer[this._vertexIndex++] = stroke.a;
            vertexBuffer[this._vertexIndex++] = strokeThickness / radius;
        }
        hasPendingDraws() {
            return this._circleCount !== 0;
        }
        flush() {
            // nothing to draw early exit
            if (this._circleCount === 0) return;
            const gl = this._gl;
            // Bind the shader
            this._shader.use();
            // Bind the memory layout and upload data
            this._layout.use(true);
            // Update ortho matrix uniform
            this._shader.setUniformMatrix("u_matrix", this._context.ortho);
            // Bind index buffer
            this._quads.bind();
            // Draw all the quads
            gl.drawElements(gl.TRIANGLES, this._circleCount * 6, this._quads.bufferGlType, 0);
            GraphicsDiagnostics.DrawnImagesCount += this._circleCount;
            GraphicsDiagnostics.DrawCallCount++;
            // Reset
            this._circleCount = 0;
            this._vertexIndex = 0;
        }
    }
    class Pool {
        constructor(builder, recycler, maxObjects = 100){
            this.builder = builder;
            this.recycler = recycler;
            this.maxObjects = maxObjects;
            this.totalAllocations = 0;
            this.index = 0;
            this.objects = [];
            this.disableWarnings = false;
            this._logger = Logger.getInstance();
        }
        dispose() {
            this.objects.length = 0;
        }
        preallocate() {
            for(let i = 0; i < this.maxObjects; i++)this.objects[i] = this.builder();
        }
        /**
     * Use many instances out of the in the context and return all to the pool.
     *
     * By returning values out of the context they will be un-hooked from the pool and are free to be passed to consumers
     * @param context
     */ using(context) {
            const result = context(this);
            if (result) return this.done(...result);
            return this.done();
        }
        /**
     * Use a single instance out of th pool and immediately return it to the pool
     * @param context
     */ borrow(context) {
            const object = this.get();
            context(object);
            this.index--;
        }
        /**
     * Retrieve a value from the pool, will allocate a new instance if necessary or recycle from the pool
     */ get() {
            if (this.index === this.maxObjects) {
                if (!this.disableWarnings) this._logger.warn("Max pooled objects reached, possible memory leak? Doubling");
                this.maxObjects = this.maxObjects * 2;
            }
            if (this.objects[this.index]) // Pool has an available object already constructed
            return this.recycler(this.objects[this.index++]);
            else {
                // New allocation
                this.totalAllocations++;
                const object = this.objects[this.index++] = this.builder();
                return object;
            }
        }
        done(...objects) {
            // All objects in pool now considered "free"
            this.index = 0;
            for (const object of objects){
                const poolIndex = this.objects.indexOf(object);
                // Build a new object to take the pool place
                this.objects[poolIndex] = this.builder();
                this.totalAllocations++;
            }
            return objects;
        }
    }
    class DrawCall {
        constructor(){
            this.z = 0;
            this.priority = 0;
            this.transform = AffineMatrix.identity();
            this.state = {
                z: 0,
                opacity: 1,
                tint: Color.White,
                material: null
            };
        }
    }
    const defaultVertexSource = `#version 300 es
in vec2 a_position;

in vec2 a_uv;
out vec2 v_uv;

in vec2 a_screenuv;
out vec2 v_screenuv;

uniform mat4 u_matrix;
uniform mat4 u_transform;

void main() {
  // Set the vertex position using the ortho & transform matrix
  gl_Position = u_matrix * u_transform * vec4(a_position, 0.0, 1.0);

  // Pass through the UV coord to the fragment shader
  v_uv = a_uv;
  v_screenuv = a_screenuv;
}
`;
    class Material {
        constructor(options){
            this._logger = Logger.getInstance();
            this._color = Color.Transparent;
            this._initialized = false;
            this._images = new Map();
            this._textures = new Map();
            const { color: color, name: name, vertexSource: vertexSource, fragmentSource: fragmentSource, graphicsContext: graphicsContext, images: images } = options;
            this._name = name !== null && name !== void 0 ? name : "anonymous material";
            this._vertexSource = vertexSource !== null && vertexSource !== void 0 ? vertexSource : defaultVertexSource;
            this._fragmentSource = fragmentSource;
            this._color = color !== null && color !== void 0 ? color : this._color;
            if (!graphicsContext) throw Error(`Material ${name} must be provided an excalibur webgl graphics context`);
            if (graphicsContext instanceof ExcaliburGraphicsContextWebGL) {
                this._graphicsContext = graphicsContext;
                this._initialize(graphicsContext);
            } else this._logger.warn(`Material ${name} was created in 2D Canvas mode, currently only WebGL is supported`);
            if (images) for(const key in images)this.addImageSource(key, images[key]);
        }
        _initialize(graphicsContextWebGL) {
            if (this._initialized) return;
            const gl = graphicsContextWebGL.__gl;
            // max texture slots - 2 for the graphic texture and screen texture
            this._maxTextureSlots = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS) - 2;
            this._shader = graphicsContextWebGL.createShader({
                vertexSource: this._vertexSource,
                fragmentSource: this._fragmentSource
            });
            this._shader.compile();
            this._initialized = true;
        }
        get name() {
            var _a;
            return (_a = this._name) !== null && _a !== void 0 ? _a : "anonymous material";
        }
        get isUsingScreenTexture() {
            return this._fragmentSource.includes("u_screen_texture");
        }
        update(callback) {
            if (this._shader) {
                this._shader.use();
                callback(this._shader);
            }
        }
        getShader() {
            return this._shader;
        }
        addImageSource(textureUniformName, image) {
            if (this._images.size < this._maxTextureSlots) this._images.set(textureUniformName, image);
            else this._logger.warn(`Max number texture slots ${this._maxTextureSlots} have been reached for material "${this.name}", ` + `no more textures will be uploaded due to hardware constraints.`);
        }
        removeImageSource(textureName) {
            const image = this._images.get(textureName);
            this._graphicsContext.textureLoader.delete(image.image);
            this._images.delete(textureName);
        }
        _loadImageSource(image) {
            const imageElement = image.image;
            const maybeFiltering = imageElement.getAttribute(ImageSourceAttributeConstants.Filtering);
            const filtering = maybeFiltering ? parseImageFiltering(maybeFiltering) : null;
            const wrapX = parseImageWrapping(imageElement.getAttribute(ImageSourceAttributeConstants.WrappingX));
            const wrapY = parseImageWrapping(imageElement.getAttribute(ImageSourceAttributeConstants.WrappingY));
            const force = imageElement.getAttribute("forceUpload") === "true" ? true : false;
            const texture = this._graphicsContext.textureLoader.load(imageElement, {
                filtering: filtering,
                wrapping: {
                    x: wrapX,
                    y: wrapY
                }
            }, force);
            // remove force attribute after upload
            imageElement.removeAttribute("forceUpload");
            if (!this._textures.has(image)) this._textures.set(image, texture);
            return texture;
        }
        uploadAndBind(gl, startingTextureSlot = 2) {
            let textureSlot = startingTextureSlot;
            for (const [textureName, image] of this._images.entries()){
                if (!image.isLoaded()) {
                    this._logger.warnOnce(`Image named ${textureName} in material ${this.name} not loaded, nothing will be uploaded to the shader.` + ` Did you forget to add this to a loader? https://excaliburjs.com/docs/loaders/`);
                    continue;
                } // skip unloaded images, maybe warn
                const texture = this._loadImageSource(image);
                gl.activeTexture(gl.TEXTURE0 + textureSlot);
                gl.bindTexture(gl.TEXTURE_2D, texture);
                this._shader.trySetUniformInt(textureName, textureSlot);
                textureSlot++;
            }
        }
        use() {
            if (this._initialized) {
                // bind the shader
                this._shader.use();
                // Apply standard uniforms
                this._shader.trySetUniformFloatColor("u_color", this._color);
            } else throw Error(`Material ${this.name} not yet initialized, use the ExcaliburGraphicsContext.createMaterial() to work around this.`);
        }
    }
    class MaterialRenderer {
        constructor(){
            this.type = "ex.material";
            this.priority = 0;
            this._textures = [];
        }
        initialize(gl, context) {
            this._gl = gl;
            this._context = context;
            // Setup memory layout
            this._buffer = new VertexBuffer({
                gl: gl,
                size: 24,
                type: "dynamic"
            });
            // Setup a vertex layout/buffer to the material
            this._layout = new VertexLayout({
                gl: gl,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_uv",
                        2
                    ],
                    [
                        "a_screenuv",
                        2
                    ]
                ],
                suppressWarnings: true
            });
            // Setup index buffer
            this._quads = new QuadIndexBuffer(gl, 1, true);
        }
        dispose() {
            this._buffer.dispose();
            this._quads.dispose();
            this._textures.length = 0;
            this._context = null;
            this._gl = null;
        }
        draw(image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight) {
            var _a, _b, _c, _d;
            const gl = this._gl;
            // Extract context info
            const material = this._context.material;
            const transform = this._context.getTransform();
            const opacity = this._context.opacity;
            // material shader
            const shader = material.getShader();
            // construct geometry, or hold on to it in the material?
            // geometry primitive for drawing rectangles?
            // update data
            const vertexBuffer = this._layout.vertexBuffer.bufferData;
            let vertexIndex = 0;
            let width = (image === null || image === void 0 ? void 0 : image.width) || swidth || 0;
            let height = (image === null || image === void 0 ? void 0 : image.height) || sheight || 0;
            let view = [
                0,
                0,
                (_a = swidth !== null && swidth !== void 0 ? swidth : image === null || image === void 0 ? void 0 : image.width) !== null && _a !== void 0 ? _a : 0,
                (_b = sheight !== null && sheight !== void 0 ? sheight : image === null || image === void 0 ? void 0 : image.height) !== null && _b !== void 0 ? _b : 0
            ];
            let dest = [
                sx !== null && sx !== void 0 ? sx : 1,
                sy !== null && sy !== void 0 ? sy : 1
            ];
            // If destination is specified, update view and dest
            if (dx !== undefined && dy !== undefined && dwidth !== undefined && dheight !== undefined) {
                view = [
                    sx !== null && sx !== void 0 ? sx : 1,
                    sy !== null && sy !== void 0 ? sy : 1,
                    (_c = swidth !== null && swidth !== void 0 ? swidth : image === null || image === void 0 ? void 0 : image.width) !== null && _c !== void 0 ? _c : 0,
                    (_d = sheight !== null && sheight !== void 0 ? sheight : image === null || image === void 0 ? void 0 : image.height) !== null && _d !== void 0 ? _d : 0
                ];
                dest = [
                    dx,
                    dy
                ];
                width = dwidth;
                height = dheight;
            }
            sx = view[0];
            sy = view[1];
            const sw = view[2];
            const sh = view[3];
            const topLeft = vec(dest[0], dest[1]);
            const topRight = vec(dest[0] + width, dest[1]);
            const bottomLeft = vec(dest[0], dest[1] + height);
            const bottomRight = vec(dest[0] + width, dest[1] + height);
            const imageWidth = image.width || width;
            const imageHeight = image.height || height;
            const uvx0 = sx / imageWidth;
            const uvy0 = sy / imageHeight;
            const uvx1 = (sx + sw - 0.01) / imageWidth;
            const uvy1 = (sy + sh - 0.01) / imageHeight;
            const topLeftScreen = transform.getPosition();
            const bottomRightScreen = topLeftScreen.add(bottomRight);
            const screenUVX0 = topLeftScreen.x / this._context.width;
            const screenUVY0 = topLeftScreen.y / this._context.height;
            const screenUVX1 = bottomRightScreen.x / this._context.width;
            const screenUVY1 = bottomRightScreen.y / this._context.height;
            // (0, 0) - 0
            vertexBuffer[vertexIndex++] = topLeft.x;
            vertexBuffer[vertexIndex++] = topLeft.y;
            vertexBuffer[vertexIndex++] = uvx0;
            vertexBuffer[vertexIndex++] = uvy0;
            vertexBuffer[vertexIndex++] = screenUVX0;
            vertexBuffer[vertexIndex++] = screenUVY0;
            // (0, 1) - 1
            vertexBuffer[vertexIndex++] = bottomLeft.x;
            vertexBuffer[vertexIndex++] = bottomLeft.y;
            vertexBuffer[vertexIndex++] = uvx0;
            vertexBuffer[vertexIndex++] = uvy1;
            vertexBuffer[vertexIndex++] = screenUVX0;
            vertexBuffer[vertexIndex++] = screenUVY1;
            // (1, 0) - 2
            vertexBuffer[vertexIndex++] = topRight.x;
            vertexBuffer[vertexIndex++] = topRight.y;
            vertexBuffer[vertexIndex++] = uvx1;
            vertexBuffer[vertexIndex++] = uvy0;
            vertexBuffer[vertexIndex++] = screenUVX1;
            vertexBuffer[vertexIndex++] = screenUVY0;
            // (1, 1) - 3
            vertexBuffer[vertexIndex++] = bottomRight.x;
            vertexBuffer[vertexIndex++] = bottomRight.y;
            vertexBuffer[vertexIndex++] = uvx1;
            vertexBuffer[vertexIndex++] = uvy1;
            vertexBuffer[vertexIndex++] = screenUVX1;
            vertexBuffer[vertexIndex++] = screenUVY1;
            // This creates and uploads the texture if not already done
            const texture = this._addImageAsTexture(image);
            // apply material
            material.use();
            this._layout.shader = shader;
            // apply layout and geometry
            this._layout.use(true);
            // apply time in ms since the page (performance.now())
            shader.trySetUniformFloat("u_time_ms", performance.now());
            // apply opacity
            shader.trySetUniformFloat("u_opacity", opacity);
            // apply resolution
            shader.trySetUniformFloatVector("u_resolution", vec(this._context.width, this._context.height));
            // apply graphic resolution
            shader.trySetUniformFloatVector("u_graphic_resolution", vec(imageWidth, imageHeight));
            // apply size
            shader.trySetUniformFloatVector("u_size", vec(sw, sh));
            // apply orthographic projection
            shader.trySetUniformMatrix("u_matrix", this._context.ortho);
            // apply geometry transform
            shader.trySetUniformMatrix("u_transform", transform.to4x4());
            // bind graphic image texture 'uniform sampler2D u_graphic;'
            gl.activeTexture(gl.TEXTURE0 + 0);
            gl.bindTexture(gl.TEXTURE_2D, texture);
            shader.trySetUniformInt("u_graphic", 0);
            // bind the screen texture
            gl.activeTexture(gl.TEXTURE0 + 1);
            gl.bindTexture(gl.TEXTURE_2D, this._context.materialScreenTexture);
            shader.trySetUniformInt("u_screen_texture", 1);
            // bind any additional textures in the material
            material.uploadAndBind(gl);
            // bind quad index buffer
            this._quads.bind();
            // Draw a single quad
            gl.drawElements(gl.TRIANGLES, 6, this._quads.bufferGlType, 0);
            GraphicsDiagnostics.DrawnImagesCount++;
            GraphicsDiagnostics.DrawCallCount++;
        }
        _addImageAsTexture(image) {
            const maybeFiltering = image.getAttribute(ImageSourceAttributeConstants.Filtering);
            const filtering = maybeFiltering ? parseImageFiltering(maybeFiltering) : null;
            const wrapX = parseImageWrapping(image.getAttribute(ImageSourceAttributeConstants.WrappingX));
            const wrapY = parseImageWrapping(image.getAttribute(ImageSourceAttributeConstants.WrappingY));
            const force = image.getAttribute("forceUpload") === "true" ? true : false;
            const texture = this._context.textureLoader.load(image, {
                filtering: filtering,
                wrapping: {
                    x: wrapX,
                    y: wrapY
                }
            }, force);
            // remove force attribute after upload
            image.removeAttribute("forceUpload");
            if (this._textures.indexOf(texture) === -1) this._textures.push(texture);
            return texture;
        }
        hasPendingDraws() {
            return false;
        }
        flush() {
        // flush does not do anything, material renderer renders immediately per draw
        }
    }
    // renderers
    const pixelSnapEpsilon = 0.0001;
    class ExcaliburGraphicsContextWebGLDebug {
        constructor(_webglCtx){
            this._webglCtx = _webglCtx;
            this._debugText = new DebugText();
        }
        /**
     * Draw a debugging rectangle to the context
     * @param x
     * @param y
     * @param width
     * @param height
     */ drawRect(x, y, width, height, rectOptions = {
            color: Color.Black
        }) {
            this.drawLine(vec(x, y), vec(x + width, y), {
                ...rectOptions
            });
            this.drawLine(vec(x + width, y), vec(x + width, y + height), {
                ...rectOptions
            });
            this.drawLine(vec(x + width, y + height), vec(x, y + height), {
                ...rectOptions
            });
            this.drawLine(vec(x, y + height), vec(x, y), {
                ...rectOptions
            });
        }
        /**
     * Draw a debugging line to the context
     * @param start
     * @param end
     * @param lineOptions
     */ drawLine(start, end, lineOptions = {
            color: Color.Black
        }) {
            this._webglCtx.draw("ex.line", start, end, lineOptions.color);
        }
        /**
     * Draw a debugging point to the context
     * @param point
     * @param pointOptions
     */ drawPoint(point, pointOptions = {
            color: Color.Black,
            size: 5
        }) {
            this._webglCtx.draw("ex.point", point, pointOptions.color, pointOptions.size);
        }
        drawText(text, pos) {
            this._debugText.write(this._webglCtx, text, pos);
        }
    }
    class ExcaliburGraphicsContextWebGL {
        get z() {
            return this._state.current.z;
        }
        set z(value) {
            this._state.current.z = value;
        }
        get opacity() {
            return this._state.current.opacity;
        }
        set opacity(value) {
            this._state.current.opacity = value;
        }
        get tint() {
            return this._state.current.tint;
        }
        set tint(color) {
            this._state.current.tint = color;
        }
        get width() {
            return this.__gl.canvas.width;
        }
        get height() {
            return this.__gl.canvas.height;
        }
        get ortho() {
            return this._ortho;
        }
        /**
     * Checks the underlying webgl implementation if the requested internal resolution is supported
     * @param dim
     */ checkIfResolutionSupported(dim) {
            // Slight hack based on this thread https://groups.google.com/g/webgl-dev-list/c/AHONvz3oQTo
            let supported = true;
            if (dim.width > 4096 || dim.height > 4096) supported = false;
            return supported;
        }
        constructor(options){
            this._logger = Logger.getInstance();
            this._renderers = new Map();
            this._isDrawLifecycle = false;
            this.useDrawSorting = true;
            this._drawCallPool = new Pool(()=>new DrawCall(), (instance)=>{
                instance.priority = 0;
                instance.z = 0;
                instance.renderer = undefined;
                instance.args = undefined;
                return instance;
            }, 4000);
            this._drawCallIndex = 0;
            this._drawCalls = new Array(4000).fill(null);
            // Postprocessing is a tuple with 2 render targets, these are flip-flopped during the postprocessing process
            this._postProcessTargets = [];
            this._postprocessors = [];
            this._transform = new TransformStack();
            this._state = new StateStack();
            /**
         * Snaps the drawing x/y coordinate to the nearest whole pixel
         */ this.snapToPixel = false;
            /**
         * Native context smoothing
         */ this.smoothing = false;
            /**
         * Whether the pixel art sampler is enabled for smooth sub pixel anti-aliasing
         */ this.pixelArtSampler = false;
            /**
         * UV padding in pixels to use in internal image rendering to prevent texture bleed
         *
         */ this.uvPadding = .01;
            this.backgroundColor = Color.ExcaliburBlue;
            this.multiSampleAntialiasing = true;
            this.transparency = true;
            this._isContextLost = false;
            this._disposed = false;
            this._imageToWidth = new Map();
            this._imageToHeight = new Map();
            this.debug = new ExcaliburGraphicsContextWebGLDebug(this);
            this._totalPostProcessorTime = 0;
            const { canvasElement: canvasElement, context: context, enableTransparency: enableTransparency, antialiasing: antialiasing, uvPadding: uvPadding, multiSampleAntialiasing: multiSampleAntialiasing, pixelArtSampler: pixelArtSampler, powerPreference: powerPreference, snapToPixel: snapToPixel, backgroundColor: backgroundColor, useDrawSorting: useDrawSorting, handleContextLost: handleContextLost, handleContextRestored: handleContextRestored } = options;
            this.__gl = context !== null && context !== void 0 ? context : canvasElement.getContext("webgl2", {
                antialias: antialiasing !== null && antialiasing !== void 0 ? antialiasing : this.smoothing,
                premultipliedAlpha: false,
                alpha: enableTransparency !== null && enableTransparency !== void 0 ? enableTransparency : this.transparency,
                depth: false,
                powerPreference: powerPreference !== null && powerPreference !== void 0 ? powerPreference : "high-performance"
            });
            if (!this.__gl) throw Error("Failed to retrieve webgl context from browser");
            if (handleContextLost) this.__gl.canvas.addEventListener("webglcontextlost", handleContextLost, false);
            if (handleContextRestored) this.__gl.canvas.addEventListener("webglcontextrestored", handleContextRestored, false);
            this.__gl.canvas.addEventListener("webglcontextlost", ()=>{
                this._isContextLost = true;
            });
            this.__gl.canvas.addEventListener("webglcontextrestored", ()=>{
                this._isContextLost = false;
            });
            this.textureLoader = new TextureLoader(this.__gl);
            this.snapToPixel = snapToPixel !== null && snapToPixel !== void 0 ? snapToPixel : this.snapToPixel;
            this.smoothing = antialiasing !== null && antialiasing !== void 0 ? antialiasing : this.smoothing;
            this.transparency = enableTransparency !== null && enableTransparency !== void 0 ? enableTransparency : this.transparency;
            this.pixelArtSampler = pixelArtSampler !== null && pixelArtSampler !== void 0 ? pixelArtSampler : this.pixelArtSampler;
            this.uvPadding = uvPadding !== null && uvPadding !== void 0 ? uvPadding : this.uvPadding;
            this.multiSampleAntialiasing = typeof multiSampleAntialiasing === "boolean" ? multiSampleAntialiasing : this.multiSampleAntialiasing;
            this.samples = typeof multiSampleAntialiasing === "object" ? multiSampleAntialiasing.samples : undefined;
            this.backgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : this.backgroundColor;
            this.useDrawSorting = useDrawSorting !== null && useDrawSorting !== void 0 ? useDrawSorting : this.useDrawSorting;
            this._drawCallPool.disableWarnings = true;
            this._drawCallPool.preallocate();
            this._init();
        }
        dispose() {
            if (!this._disposed) {
                this._disposed = true;
                this.textureLoader.dispose();
                for (const renderer of this._renderers.values())renderer.dispose();
                this._renderers.clear();
                this._drawCallPool.dispose();
                this._drawCalls.length = 0;
                this.__gl = null;
            }
        }
        _init() {
            const gl = this.__gl;
            // Setup viewport and view matrix
            this._ortho = Matrix.ortho(0, gl.canvas.width, gl.canvas.height, 0, 400, -400);
            gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
            // Clear background
            gl.clearColor(this.backgroundColor.r / 255, this.backgroundColor.g / 255, this.backgroundColor.b / 255, this.backgroundColor.a);
            gl.clear(gl.COLOR_BUFFER_BIT);
            // Enable alpha blending
            // https://www.realtimerendering.com/blog/gpus-prefer-premultiplication/
            gl.enable(gl.BLEND);
            gl.blendEquation(gl.FUNC_ADD);
            gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
            gl.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD);
            gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
            // Setup builtin renderers
            this.register(new ImageRenderer({
                uvPadding: this.uvPadding,
                pixelArtSampler: this.pixelArtSampler
            }));
            this.register(new MaterialRenderer());
            this.register(new RectangleRenderer());
            this.register(new CircleRenderer());
            this.register(new PointRenderer());
            this.register(new LineRenderer());
            this.materialScreenTexture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, this.materialScreenTexture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
            gl.bindTexture(gl.TEXTURE_2D, null);
            this._screenRenderer = new ScreenPassPainter(gl);
            this._renderTarget = new RenderTarget({
                gl: gl,
                transparency: this.transparency,
                width: gl.canvas.width,
                height: gl.canvas.height
            });
            this._postProcessTargets = [
                new RenderTarget({
                    gl: gl,
                    transparency: this.transparency,
                    width: gl.canvas.width,
                    height: gl.canvas.height
                }),
                new RenderTarget({
                    gl: gl,
                    transparency: this.transparency,
                    width: gl.canvas.width,
                    height: gl.canvas.height
                })
            ];
            this._msaaTarget = new RenderTarget({
                gl: gl,
                transparency: this.transparency,
                width: gl.canvas.width,
                height: gl.canvas.height,
                antialias: this.multiSampleAntialiasing,
                samples: this.samples
            });
        }
        register(renderer) {
            this._renderers.set(renderer.type, renderer);
            renderer.initialize(this.__gl, this);
        }
        get(rendererName) {
            return this._renderers.get(rendererName);
        }
        _isCurrentRenderer(renderer) {
            if (!this._currentRenderer || this._currentRenderer === renderer) return true;
            return false;
        }
        beginDrawLifecycle() {
            this._isDrawLifecycle = true;
        }
        endDrawLifecycle() {
            this._isDrawLifecycle = false;
        }
        draw(rendererName, ...args) {
            if (!this._isDrawLifecycle) this._logger.warnOnce(`Attempting to draw outside the the drawing lifecycle (preDraw/postDraw) is not supported and is a source of bugs/errors.\n` + `If you want to do custom drawing, use Actor.graphics, or any onPreDraw or onPostDraw handler.`);
            if (this._isContextLost) {
                this._logger.errorOnce(`Unable to draw ${rendererName}, the webgl context is lost`);
                return;
            }
            const renderer = this._renderers.get(rendererName);
            if (renderer) {
                if (this.useDrawSorting) {
                    const drawCall = this._drawCallPool.get();
                    drawCall.z = this._state.current.z;
                    drawCall.priority = renderer.priority;
                    drawCall.renderer = rendererName;
                    this.getTransform().clone(drawCall.transform);
                    drawCall.state.z = this._state.current.z;
                    drawCall.state.opacity = this._state.current.opacity;
                    drawCall.state.tint = this._state.current.tint;
                    drawCall.state.material = this._state.current.material;
                    drawCall.args = args;
                    this._drawCalls[this._drawCallIndex++] = drawCall;
                } else {
                    // Set the current renderer if not defined
                    if (!this._currentRenderer) this._currentRenderer = renderer;
                    if (!this._isCurrentRenderer(renderer)) // switching graphics means we must flush the previous
                    this._currentRenderer.flush();
                    // If we are still using the same renderer we can add to the current batch
                    renderer.draw(...args);
                    this._currentRenderer = renderer;
                }
            } else throw Error(`No renderer with name ${rendererName} has been registered`);
        }
        resetTransform() {
            this._transform.current = AffineMatrix.identity();
        }
        updateViewport(resolution) {
            const gl = this.__gl;
            this._ortho = this._ortho = Matrix.ortho(0, resolution.width, resolution.height, 0, 400, -400);
            this._renderTarget.setResolution(gl.canvas.width, gl.canvas.height);
            this._msaaTarget.setResolution(gl.canvas.width, gl.canvas.height);
            this._postProcessTargets[0].setResolution(gl.canvas.width, gl.canvas.height);
            this._postProcessTargets[1].setResolution(gl.canvas.width, gl.canvas.height);
        }
        _getImageWidth(image) {
            let maybeWidth = this._imageToWidth.get(image);
            if (maybeWidth === undefined) {
                maybeWidth = image.width;
                this._imageToWidth.set(image, maybeWidth);
            }
            return maybeWidth;
        }
        _getImageHeight(image) {
            let maybeHeight = this._imageToHeight.get(image);
            if (maybeHeight === undefined) {
                maybeHeight = image.height;
                this._imageToHeight.set(image, maybeHeight);
            }
            return maybeHeight;
        }
        drawImage(image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight) {
            if (swidth === 0 || sheight === 0) return; // zero dimension dest exit early
            else if (dwidth === 0 || dheight === 0) return; // zero dimension dest exit early
            else if (this._getImageWidth(image) === 0 || this._getImageHeight(image) === 0) return; // zero dimension source exit early
            if (!image) {
                Logger.getInstance().warn("Cannot draw a null or undefined image");
                // tslint:disable-next-line: no-console
                if (console.trace) // tslint:disable-next-line: no-console
                console.trace();
                return;
            }
            if (this._state.current.material) this.draw("ex.material", image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight);
            else this.draw("ex.image", image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight);
        }
        drawLine(start, end, color, thickness = 1) {
            this.draw("ex.rectangle", start, end, color, thickness);
        }
        drawRectangle(pos, width, height, color, stroke, strokeThickness) {
            this.draw("ex.rectangle", pos, width, height, color, stroke, strokeThickness);
        }
        drawCircle(pos, radius, color, stroke, thickness) {
            this.draw("ex.circle", pos, radius, color, stroke, thickness);
        }
        save() {
            this._transform.save();
            this._state.save();
        }
        restore() {
            this._transform.restore();
            this._state.restore();
        }
        translate(x, y) {
            this._transform.translate(this.snapToPixel ? ~~(x + pixelSnapEpsilon) : x, this.snapToPixel ? ~~(y + pixelSnapEpsilon) : y);
        }
        rotate(angle) {
            this._transform.rotate(angle);
        }
        scale(x, y) {
            this._transform.scale(x, y);
        }
        transform(matrix) {
            this._transform.current = matrix;
        }
        getTransform() {
            return this._transform.current;
        }
        multiply(m) {
            this._transform.current.multiply(m, this._transform.current);
        }
        addPostProcessor(postprocessor) {
            this._postprocessors.push(postprocessor);
            postprocessor.initialize(this.__gl);
        }
        removePostProcessor(postprocessor) {
            const index = this._postprocessors.indexOf(postprocessor);
            if (index !== -1) this._postprocessors.splice(index, 1);
        }
        clearPostProcessors() {
            this._postprocessors.length = 0;
        }
        updatePostProcessors(delta) {
            for (const postprocessor of this._postprocessors){
                const shader = postprocessor.getShader();
                shader.use();
                const uniforms = shader.getUniforms();
                this._totalPostProcessorTime += delta;
                if (uniforms.find((u)=>u.name === "u_time_ms")) shader.setUniformFloat("u_time_ms", this._totalPostProcessorTime);
                if (uniforms.find((u)=>u.name === "u_elapsed_ms")) shader.setUniformFloat("u_elapsed_ms", delta);
                if (uniforms.find((u)=>u.name === "u_resolution")) shader.setUniformFloatVector("u_resolution", vec(this.width, this.height));
                if (postprocessor.onUpdate) postprocessor.onUpdate(delta);
            }
        }
        set material(material) {
            this._state.current.material = material;
        }
        get material() {
            return this._state.current.material;
        }
        /**
     * Creates and initializes the material which compiles the internal shader
     * @param options
     * @returns Material
     */ createMaterial(options) {
            const material = new Material({
                ...options,
                graphicsContext: this
            });
            return material;
        }
        createShader(options) {
            const gl = this.__gl;
            const { vertexSource: vertexSource, fragmentSource: fragmentSource } = options;
            const shader = new Shader({
                gl: gl,
                vertexSource: vertexSource,
                fragmentSource: fragmentSource
            });
            shader.compile();
            return shader;
        }
        clear() {
            const gl = this.__gl;
            const currentTarget = this.multiSampleAntialiasing ? this._msaaTarget : this._renderTarget;
            currentTarget.use();
            gl.clearColor(this.backgroundColor.r / 255, this.backgroundColor.g / 255, this.backgroundColor.b / 255, this.backgroundColor.a);
            // Clear the context with the newly set color. This is
            // the function call that actually does the drawing.
            gl.clear(gl.COLOR_BUFFER_BIT);
        }
        /**
     * Flushes all batched rendering to the screen
     */ flush() {
            if (this._isContextLost) {
                this._logger.errorOnce(`Unable to flush the webgl context is lost`);
                return;
            }
            // render target captures all draws and redirects to the render target
            let currentTarget = this.multiSampleAntialiasing ? this._msaaTarget : this._renderTarget;
            currentTarget.use();
            if (this.useDrawSorting) {
                // null out unused draw calls
                for(let i = this._drawCallIndex; i < this._drawCalls.length; i++)this._drawCalls[i] = null;
                // sort draw calls
                // Find the original order of the first instance of the draw call
                const originalSort = new Map();
                for (const [name] of this._renderers){
                    let firstIndex = 0;
                    for(firstIndex = 0; firstIndex < this._drawCallIndex; firstIndex++){
                        if (this._drawCalls[firstIndex].renderer === name) break;
                    }
                    originalSort.set(name, firstIndex);
                }
                this._drawCalls.sort((a, b)=>{
                    if (a === null || b === null) return 0;
                    const zIndex = a.z - b.z;
                    const originalSortOrder = originalSort.get(a.renderer) - originalSort.get(b.renderer);
                    const priority = a.priority - b.priority;
                    if (zIndex === 0) {
                        if (priority === 0) return originalSortOrder; // use the original order to inform draw call packing to maximally preserve painter order
                        return priority;
                    }
                    return zIndex;
                });
                const oldTransform = this._transform.current;
                const oldState = this._state.current;
                if (this._drawCalls.length && this._drawCallIndex) {
                    let currentRendererName = this._drawCalls[0].renderer;
                    let currentRenderer = this._renderers.get(currentRendererName);
                    for(let i = 0; i < this._drawCallIndex; i++){
                        // hydrate the state for renderers
                        this._transform.current = this._drawCalls[i].transform;
                        this._state.current = this._drawCalls[i].state;
                        if (this._drawCalls[i].renderer !== currentRendererName) {
                            // switching graphics renderer means we must flush the previous
                            currentRenderer.flush();
                            currentRendererName = this._drawCalls[i].renderer;
                            currentRenderer = this._renderers.get(currentRendererName);
                        }
                        // ! hack to grab screen texture before materials run because they might want it
                        if (currentRenderer instanceof MaterialRenderer && this.material.isUsingScreenTexture) {
                            currentTarget.copyToTexture(this.materialScreenTexture);
                            currentTarget.use();
                        }
                        // If we are still using the same renderer we can add to the current batch
                        currentRenderer.draw(...this._drawCalls[i].args);
                    }
                    if (currentRenderer.hasPendingDraws()) currentRenderer.flush();
                }
                // reset state
                this._transform.current = oldTransform;
                this._state.current = oldState;
                // reclaim draw calls
                this._drawCallPool.done();
                this._drawCallIndex = 0;
                this._imageToHeight.clear();
                this._imageToWidth.clear();
            } else {
                // This is the final flush at the moment to draw any leftover pending draw
                for (const renderer of this._renderers.values())if (renderer.hasPendingDraws()) renderer.flush();
            }
            currentTarget.disable();
            // post process step
            if (this._postprocessors.length > 0) {
                const source = currentTarget.toRenderSource();
                source.use();
            }
            // flip flop render targets for post processing
            for(let i = 0; i < this._postprocessors.length; i++){
                currentTarget = this._postProcessTargets[i % 2];
                this._postProcessTargets[i % 2].use();
                this._screenRenderer.renderWithPostProcessor(this._postprocessors[i]);
                this._postProcessTargets[i % 2].toRenderSource().use();
            }
            // Final blit to the screen
            currentTarget.blitToScreen();
        }
    }
    const ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon = 0.0001;
    class ExcaliburGraphicsContext2DCanvasDebug {
        constructor(_ex){
            this._ex = _ex;
            this._debugText = new DebugText();
        }
        /**
     * Draw a debug rectangle to the context
     * @param x
     * @param y
     * @param width
     * @param height
     */ drawRect(x, y, width, height) {
            this._ex.__ctx.save();
            this._ex.__ctx.strokeStyle = "red";
            this._ex.__ctx.strokeRect(this._ex.snapToPixel ? ~~(x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : x, this._ex.snapToPixel ? ~~(y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : y, this._ex.snapToPixel ? ~~(width + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : width, this._ex.snapToPixel ? ~~(height + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : height);
            this._ex.__ctx.restore();
        }
        drawLine(start, end, lineOptions = {
            color: Color.Black
        }) {
            this._ex.__ctx.save();
            this._ex.__ctx.beginPath();
            this._ex.__ctx.strokeStyle = lineOptions.color.toString();
            this._ex.__ctx.moveTo(this._ex.snapToPixel ? ~~(start.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : start.x, this._ex.snapToPixel ? ~~(start.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : start.y);
            this._ex.__ctx.lineTo(this._ex.snapToPixel ? ~~(end.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : end.x, this._ex.snapToPixel ? ~~(end.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : end.y);
            this._ex.__ctx.lineWidth = 2;
            this._ex.__ctx.stroke();
            this._ex.__ctx.closePath();
            this._ex.__ctx.restore();
        }
        drawPoint(point, pointOptions = {
            color: Color.Black,
            size: 5
        }) {
            this._ex.__ctx.save();
            this._ex.__ctx.beginPath();
            this._ex.__ctx.fillStyle = pointOptions.color.toString();
            this._ex.__ctx.arc(this._ex.snapToPixel ? ~~(point.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : point.x, this._ex.snapToPixel ? ~~(point.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : point.y, pointOptions.size, 0, Math.PI * 2);
            this._ex.__ctx.fill();
            this._ex.__ctx.closePath();
            this._ex.__ctx.restore();
        }
        drawText(text, pos) {
            this._debugText.write(this._ex, text, pos);
        }
    }
    class ExcaliburGraphicsContext2DCanvas {
        get width() {
            return this.__ctx.canvas.width;
        }
        get height() {
            return this.__ctx.canvas.height;
        }
        get opacity() {
            return this._state.current.opacity;
        }
        set opacity(value) {
            this._state.current.opacity = value;
        }
        get tint() {
            return this._state.current.tint;
        }
        set tint(color) {
            this._state.current.tint = color;
        }
        get smoothing() {
            return this.__ctx.imageSmoothingEnabled;
        }
        set smoothing(value) {
            this.__ctx.imageSmoothingEnabled = value;
        }
        constructor(options){
            /**
         * Unused in Canvas implementation
         */ this.useDrawSorting = false;
            /**
         * Unused in Canvas implementation
         */ this.z = 0;
            this.backgroundColor = Color.ExcaliburBlue;
            this._state = new StateStack();
            this.snapToPixel = false;
            this.debug = new ExcaliburGraphicsContext2DCanvasDebug(this);
            const { canvasElement: canvasElement, context: context, enableTransparency: enableTransparency, snapToPixel: snapToPixel, antialiasing: smoothing, backgroundColor: backgroundColor } = options;
            this.__ctx = context !== null && context !== void 0 ? context : canvasElement.getContext("2d", {
                alpha: enableTransparency !== null && enableTransparency !== void 0 ? enableTransparency : true
            });
            if (!this.__ctx) throw new Error("Cannot build new ExcaliburGraphicsContext2D for some reason!");
            this.backgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : this.backgroundColor;
            this.snapToPixel = snapToPixel !== null && snapToPixel !== void 0 ? snapToPixel : this.snapToPixel;
            this.smoothing = smoothing !== null && smoothing !== void 0 ? smoothing : this.smoothing;
        }
        resetTransform() {
            this.__ctx.resetTransform();
        }
        updateViewport(_resolution) {
        // pass
        }
        drawImage(image, sx, sy, swidth, sheight, dx, dy, dwidth, dheight) {
            if (swidth === 0 || sheight === 0) return; // zero dimension dest exit early
            else if (dwidth === 0 || dheight === 0) return; // zero dimension dest exit early
            else if (image.width === 0 || image.height === 0) return; // zero dimension source exit early
            this.__ctx.globalAlpha = this.opacity;
            const args = [
                image,
                sx,
                sy,
                swidth,
                sheight,
                dx,
                dy,
                dwidth,
                dheight
            ].filter((a)=>a !== undefined).map((a)=>typeof a === "number" && this.snapToPixel ? ~~a : a);
            this.__ctx.drawImage.apply(this.__ctx, args);
            GraphicsDiagnostics.DrawCallCount++;
            GraphicsDiagnostics.DrawnImagesCount = 1;
        }
        drawLine(start, end, color, thickness = 1) {
            this.__ctx.save();
            this.__ctx.beginPath();
            this.__ctx.strokeStyle = color.toString();
            this.__ctx.moveTo(this.snapToPixel ? ~~(start.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : start.x, this.snapToPixel ? ~~(start.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : start.y);
            this.__ctx.lineTo(this.snapToPixel ? ~~(end.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : end.x, this.snapToPixel ? ~~(end.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : end.y);
            this.__ctx.lineWidth = thickness;
            this.__ctx.stroke();
            this.__ctx.closePath();
            this.__ctx.restore();
        }
        drawRectangle(pos, width, height, color) {
            this.__ctx.save();
            this.__ctx.fillStyle = color.toString();
            this.__ctx.fillRect(this.snapToPixel ? ~~(pos.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : pos.x, this.snapToPixel ? ~~(pos.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : pos.y, this.snapToPixel ? ~~(width + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : width, this.snapToPixel ? ~~(height + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : height);
            this.__ctx.restore();
        }
        drawCircle(pos, radius, color, stroke, thickness) {
            this.__ctx.save();
            this.__ctx.beginPath();
            if (stroke) this.__ctx.strokeStyle = stroke.toString();
            if (thickness) this.__ctx.lineWidth = thickness;
            this.__ctx.fillStyle = color.toString();
            this.__ctx.arc(this.snapToPixel ? ~~(pos.x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : pos.x, this.snapToPixel ? ~~(pos.y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : pos.y, radius, 0, Math.PI * 2);
            this.__ctx.fill();
            if (stroke) this.__ctx.stroke();
            this.__ctx.closePath();
            this.__ctx.restore();
        }
        /**
     * Save the current state of the canvas to the stack (transforms and opacity)
     */ save() {
            this.__ctx.save();
            this._state.save();
        }
        /**
     * Restore the state of the canvas from the stack
     */ restore() {
            this.__ctx.restore();
            this._state.restore();
        }
        /**
     * Translate the origin of the context by an x and y
     * @param x
     * @param y
     */ translate(x, y) {
            this.__ctx.translate(this.snapToPixel ? ~~(x + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : x, this.snapToPixel ? ~~(y + ExcaliburGraphicsContext2DCanvas_pixelSnapEpsilon) : y);
        }
        /**
     * Rotate the context about the current origin
     */ rotate(angle) {
            this.__ctx.rotate(angle);
        }
        /**
     * Scale the context by an x and y factor
     * @param x
     * @param y
     */ scale(x, y) {
            this.__ctx.scale(x, y);
        }
        getTransform() {
            throw new Error("Not implemented");
        }
        multiply(_m) {
            this.__ctx.setTransform(this.__ctx.getTransform().multiply(_m.toDOMMatrix()));
        }
        addPostProcessor(_postprocessor) {
        // pass
        }
        removePostProcessor(_postprocessor) {
        // pass
        }
        clearPostProcessors() {
        // pass
        }
        updatePostProcessors(delta) {
        // pass
        }
        beginDrawLifecycle() {
        // pass
        }
        endDrawLifecycle() {
        // pass
        }
        set material(material) {
            this._state.current.material = material;
        }
        get material() {
            return this._state.current.material;
        }
        createMaterial(options) {
            // pass
            return null;
        }
        clear() {
            // Clear frame
            this.__ctx.clearRect(0, 0, this.width, this.height);
            this.__ctx.fillStyle = this.backgroundColor.toString();
            this.__ctx.fillRect(0, 0, this.width, this.height);
            GraphicsDiagnostics.clear();
        }
        /**
     * Flushes the batched draw calls to the screen
     */ flush() {
        // pass
        }
        dispose() {
            this.__ctx = null;
        }
    }
    /**
 * Enum representing the different display modes available to Excalibur.
 */ var DisplayMode;
    (function(DisplayMode) {
        /**
     * Default, use a specified resolution for the game. Like 800x600 pixels for example.
     */ DisplayMode["Fixed"] = "Fixed";
        /**
     * Fit the aspect ratio given by the game resolution within the container at all times will fill any gaps with canvas.
     * The displayed area outside the aspect ratio is not guaranteed to be on the screen, only the [[Screen.contentArea]]
     * is guaranteed to be on screen.
     */ DisplayMode["FitContainerAndFill"] = "FitContainerAndFill";
        /**
     * Fit the aspect ratio given by the game resolution the screen at all times will fill the screen.
     * This displayed area outside the aspect ratio is not guaranteed to be on the screen, only the [[Screen.contentArea]]
     * is guaranteed to be on screen.
     */ DisplayMode["FitScreenAndFill"] = "FitScreenAndFill";
        /**
     * Fit the viewport to the parent element maintaining aspect ratio given by the game resolution, but zooms in to avoid the black bars
     * (letterbox) that would otherwise be present in [[FitContainer]].
     *
     * **warning** This will clip some drawable area from the user because of the zoom,
     * use [[Screen.contentArea]] to know the safe to draw area.
     */ DisplayMode["FitContainerAndZoom"] = "FitContainerAndZoom";
        /**
     * Fit the viewport to the device screen maintaining aspect ratio given by the game resolution, but zooms in to avoid the black bars
     * (letterbox) that would otherwise be present in [[FitScreen]].
     *
     * **warning** This will clip some drawable area from the user because of the zoom,
     * use [[Screen.contentArea]] to know the safe to draw area.
     */ DisplayMode["FitScreenAndZoom"] = "FitScreenAndZoom";
        /**
     * Fit to screen using as much space as possible while maintaining aspect ratio and resolution.
     * This is not the same as [[Screen.goFullScreen]] but behaves in a similar way maintaining aspect ratio.
     *
     * You may want to center your game here is an example
     * ```html
     * <!-- html -->
     * <body>
     * <main>
     *   <canvas id="game"></canvas>
     * </main>
     * </body>
     * ```
     *
     * ```css
     * // css
     * main {
     *   display: flex;
     *   align-items: center;
     *   justify-content: center;
     *   height: 100%;
     *   width: 100%;
     * }
     * ```
     */ DisplayMode["FitScreen"] = "FitScreen";
        /**
     * Fill the entire screen's css width/height for the game resolution dynamically. This means the resolution of the game will
     * change dynamically as the window is resized. This is not the same as [[Screen.goFullScreen]]
     */ DisplayMode["FillScreen"] = "FillScreen";
        /**
     * Fit to parent element width/height using as much space as possible while maintaining aspect ratio and resolution.
     */ DisplayMode["FitContainer"] = "FitContainer";
        /**
     * Use the parent DOM container's css width/height for the game resolution dynamically
     */ DisplayMode["FillContainer"] = "FillContainer";
    })(DisplayMode || (DisplayMode = {}));
    /**
 * Convenience class for quick resolutions
 * Mostly sourced from https://emulation.gametechwiki.com/index.php/Resolution
 */ class Resolution {
        /* istanbul ignore next */ static get SVGA() {
            return {
                width: 800,
                height: 600
            };
        }
        /* istanbul ignore next */ static get Standard() {
            return {
                width: 1920,
                height: 1080
            };
        }
        /* istanbul ignore next */ static get Atari2600() {
            return {
                width: 160,
                height: 192
            };
        }
        /* istanbul ignore next */ static get GameBoy() {
            return {
                width: 160,
                height: 144
            };
        }
        /* istanbul ignore next */ static get GameBoyAdvance() {
            return {
                width: 240,
                height: 160
            };
        }
        /* istanbul ignore next */ static get NintendoDS() {
            return {
                width: 256,
                height: 192
            };
        }
        /* istanbul ignore next */ static get NES() {
            return {
                width: 256,
                height: 224
            };
        }
        /* istanbul ignore next */ static get SNES() {
            return {
                width: 256,
                height: 244
            };
        }
    }
    const ScreenEvents = {
        ScreenResize: "resize",
        PixelRatioChange: "pixelratio",
        FullScreenChange: "fullscreen"
    };
    /**
 * The Screen handles all aspects of interacting with the screen for Excalibur.
 */ class Screen {
        constructor(options){
            var _a, _b, _c, _d;
            /**
         * Listen to screen events [[ScreenEvents]]
         */ this.events = new EventEmitter();
            this._antialiasing = true;
            this._canvasImageRendering = "auto";
            this._resolutionStack = [];
            this._viewportStack = [];
            this._pixelRatioOverride = null;
            this._isFullScreen = false;
            this._isDisposed = false;
            this._logger = Logger.getInstance();
            this._fullscreenChangeHandler = ()=>{
                if (this._isDisposed) return;
                this._isFullScreen = !this._isFullScreen;
                this._logger.debug("Fullscreen Change", this._isFullScreen);
                this.events.emit("fullscreen", {
                    fullscreen: this.isFullScreen
                });
            };
            this._pixelRatioChangeHandler = ()=>{
                if (this._isDisposed) return;
                this._logger.debug("Pixel Ratio Change", window.devicePixelRatio);
                this._listenForPixelRatio();
                this._devicePixelRatio = this._calculateDevicePixelRatio();
                this.applyResolutionAndViewport();
                this.events.emit("pixelratio", {
                    pixelRatio: this.pixelRatio
                });
            };
            this._resizeHandler = ()=>{
                if (this._isDisposed) return;
                const parent = this.parent;
                this._logger.debug("View port resized");
                this._setResolutionAndViewportByDisplayMode(parent);
                this.applyResolutionAndViewport();
                // Emit resize event
                this.events.emit("resize", {
                    resolution: this.resolution,
                    viewport: this.viewport
                });
            };
            // Asking the window.devicePixelRatio is expensive we do it once
            this._devicePixelRatio = this._calculateDevicePixelRatio();
            this._contentArea = new BoundingBox();
            this._unsafeArea = new BoundingBox();
            this.viewport = options.viewport;
            this.resolution = (_a = options.resolution) !== null && _a !== void 0 ? _a : {
                ...this.viewport
            };
            this._contentResolution = this.resolution;
            this._displayMode = (_b = options.displayMode) !== null && _b !== void 0 ? _b : DisplayMode.Fixed;
            this._canvas = options.canvas;
            this.graphicsContext = options.context;
            this._antialiasing = (_c = options.antialiasing) !== null && _c !== void 0 ? _c : this._antialiasing;
            this._canvasImageRendering = (_d = options.canvasImageRendering) !== null && _d !== void 0 ? _d : this._canvasImageRendering;
            this._browser = options.browser;
            this._pixelRatioOverride = options.pixelRatio;
            this._applyDisplayMode();
            this._listenForPixelRatio();
            this._canvas.addEventListener("fullscreenchange", this._fullscreenChangeHandler);
            this.applyResolutionAndViewport();
        }
        _listenForPixelRatio() {
            if (this._mediaQueryList && !this._mediaQueryList.addEventListener) // Safari <=13.1 workaround, remove any existing handlers
            this._mediaQueryList.removeListener(this._pixelRatioChangeHandler);
            this._mediaQueryList = this._browser.window.nativeComponent.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
            // Safari <=13.1 workaround
            if (this._mediaQueryList.addEventListener) this._mediaQueryList.addEventListener("change", this._pixelRatioChangeHandler, {
                once: true
            });
            else this._mediaQueryList.addListener(this._pixelRatioChangeHandler);
        }
        dispose() {
            if (!this._isDisposed) {
                // Clean up handlers
                this._isDisposed = true;
                this.events.clear();
                this._browser.window.off("resize", this._resizeHandler);
                this._browser.window.clear();
                if (this._resizeObserver) this._resizeObserver.disconnect();
                this.parent.removeEventListener("resize", this._resizeHandler);
                // Safari <=13.1 workaround
                if (this._mediaQueryList.removeEventListener) this._mediaQueryList.removeEventListener("change", this._pixelRatioChangeHandler);
                else this._mediaQueryList.removeListener(this._pixelRatioChangeHandler);
                this._canvas.removeEventListener("fullscreenchange", this._fullscreenChangeHandler);
                this._canvas = null;
            }
        }
        _calculateDevicePixelRatio() {
            if (window.devicePixelRatio < 1) return 1;
            const devicePixelRatio = window.devicePixelRatio || 1;
            return devicePixelRatio;
        }
        /**
     * Returns the computed pixel ratio, first using any override, then the device pixel ratio
     */ get pixelRatio() {
            if (this._pixelRatioOverride) return this._pixelRatioOverride;
            return this._devicePixelRatio;
        }
        /**
     * Get or set the pixel ratio override
     *
     * You will need to call applyResolutionAndViewport() affect change on the screen
     */ get pixelRatioOverride() {
            return this._pixelRatioOverride;
        }
        set pixelRatioOverride(value) {
            this._pixelRatioOverride = value;
        }
        get isHiDpi() {
            return this.pixelRatio !== 1;
        }
        get displayMode() {
            return this._displayMode;
        }
        get canvas() {
            return this._canvas;
        }
        get parent() {
            switch(this.displayMode){
                case DisplayMode.FillContainer:
                case DisplayMode.FitContainer:
                case DisplayMode.FitContainerAndFill:
                case DisplayMode.FitContainerAndZoom:
                    return this.canvas.parentElement || document.body;
                default:
                    return window;
            }
        }
        get resolution() {
            return this._resolution;
        }
        set resolution(resolution) {
            this._resolution = resolution;
        }
        /**
     * Returns screen dimensions in pixels or percentage
     */ get viewport() {
            if (this._viewport) return this._viewport;
            return this._resolution;
        }
        set viewport(viewport) {
            this._viewport = viewport;
        }
        get aspectRatio() {
            return this._resolution.width / this._resolution.height;
        }
        get scaledWidth() {
            return this._resolution.width * this.pixelRatio;
        }
        get scaledHeight() {
            return this._resolution.height * this.pixelRatio;
        }
        setCurrentCamera(camera) {
            this._camera = camera;
        }
        pushResolutionAndViewport() {
            this._resolutionStack.push(this.resolution);
            this._viewportStack.push(this.viewport);
            this.resolution = {
                ...this.resolution
            };
            this.viewport = {
                ...this.viewport
            };
        }
        peekViewport() {
            return this._viewportStack[this._viewportStack.length - 1];
        }
        peekResolution() {
            return this._resolutionStack[this._resolutionStack.length - 1];
        }
        popResolutionAndViewport() {
            if (this._resolutionStack.length && this._viewportStack.length) {
                this.resolution = this._resolutionStack.pop();
                this.viewport = this._viewportStack.pop();
            }
        }
        applyResolutionAndViewport() {
            if (this.graphicsContext instanceof ExcaliburGraphicsContextWebGL) {
                const scaledResolutionSupported = this.graphicsContext.checkIfResolutionSupported({
                    width: this.scaledWidth,
                    height: this.scaledHeight
                });
                if (!scaledResolutionSupported) {
                    this._logger.warnOnce(`The currently configured resolution (${this.resolution.width}x${this.resolution.height}) and pixel ratio (${this.pixelRatio})` + " are too large for the platform WebGL implementation, this may work but cause WebGL rendering to behave oddly." + " Try reducing the resolution or disabling Hi DPI scaling to avoid this" + " (read more here https://excaliburjs.com/docs/screens#understanding-viewport--resolution).");
                    // Attempt to recover if the user hasn't configured a specific ratio for up scaling
                    if (!this.pixelRatioOverride) {
                        let currentPixelRatio = Math.max(1, this.pixelRatio - .5);
                        let newResolutionSupported = false;
                        while(currentPixelRatio > 1 && !newResolutionSupported){
                            currentPixelRatio = Math.max(1, currentPixelRatio - .5);
                            const width = this._resolution.width * currentPixelRatio;
                            const height = this._resolution.height * currentPixelRatio;
                            newResolutionSupported = this.graphicsContext.checkIfResolutionSupported({
                                width: width,
                                height: height
                            });
                        }
                        this.pixelRatioOverride = currentPixelRatio;
                        this._logger.warnOnce("Scaled resolution too big attempted recovery!" + ` Pixel ratio was automatically reduced to (${this.pixelRatio}) to avoid 4k texture limit.` + " Setting `ex.Engine({pixelRatio: ...}) will override any automatic recalculation, do so at your own risk.` " + " (read more here https://excaliburjs.com/docs/screens#understanding-viewport--resolution).");
                    }
                }
            }
            this._canvas.width = this.scaledWidth;
            this._canvas.height = this.scaledHeight;
            if (this._canvasImageRendering === "auto") this._canvas.style.imageRendering = "auto";
            else {
                this._canvas.style.imageRendering = "pixelated";
                // Fall back to 'crisp-edges' if 'pixelated' is not supported
                // Currently for firefox https://developer.mozilla.org/en-US/docs/Web/CSS/image-rendering
                if (this._canvas.style.imageRendering === "") this._canvas.style.imageRendering = "crisp-edges";
            }
            const widthUnit = this.viewport.widthUnit === "percent" ? "%" : "px";
            const heightUnit = this.viewport.heightUnit === "percent" ? "%" : "px";
            this._canvas.style.width = this.viewport.width + widthUnit;
            this._canvas.style.height = this.viewport.height + heightUnit;
            // After messing with the canvas width/height the graphics context is invalidated and needs to have some properties reset
            this.graphicsContext.updateViewport(this.resolution);
            this.graphicsContext.resetTransform();
            this.graphicsContext.smoothing = this._antialiasing;
            if (this.graphicsContext instanceof ExcaliburGraphicsContext2DCanvas) this.graphicsContext.scale(this.pixelRatio, this.pixelRatio);
        }
        get antialiasing() {
            return this._antialiasing;
        }
        set antialiasing(isSmooth) {
            this._antialiasing = isSmooth;
            this.graphicsContext.smoothing = this._antialiasing;
        }
        /**
     * Returns true if excalibur is fullscreen using the browser fullscreen api
     */ get isFullScreen() {
            return this._isFullScreen;
        }
        /**
     * Requests to go fullscreen using the browser fullscreen api, requires user interaction to be successful.
     * For example, wire this to a user click handler.
     *
     * Optionally specify a target element id to go fullscreen, by default the game canvas is used
     * @param elementId
     */ goFullScreen(elementId) {
            if (elementId) {
                const maybeElement = document.getElementById(elementId);
                if (maybeElement) {
                    if (!maybeElement.getAttribute("ex-fullscreen-listener")) {
                        maybeElement.setAttribute("ex-fullscreen-listener", "true");
                        maybeElement.addEventListener("fullscreenchange", this._fullscreenChangeHandler);
                    }
                    const fullscreenPromise = maybeElement.requestFullscreen();
                    return fullscreenPromise;
                }
            }
            return this._canvas.requestFullscreen();
        }
        /**
     * Requests to exit fullscreen using the browser fullscreen api
     */ exitFullScreen() {
            return document.exitFullscreen();
        }
        _viewportToPixels(viewport) {
            return {
                width: viewport.widthUnit === "percent" ? this.canvas.offsetWidth : viewport.width,
                height: viewport.heightUnit === "percent" ? this.canvas.offsetHeight : viewport.height
            };
        }
        /**
     * Takes a coordinate in normal html page space, for example from a pointer move event, and translates it to
     * Excalibur screen space.
     *
     * Excalibur screen space starts at the top left (0, 0) corner of the viewport, and extends to the
     * bottom right corner (resolutionX, resolutionY). When using *AndFill suffixed display modes screen space
     * (0, 0) is the top left of the safe content area bounding box not the viewport.
     * @param point
     */ pageToScreenCoordinates(point) {
            let newX = point.x;
            let newY = point.y;
            if (!this._isFullScreen) {
                newX -= getPosition(this._canvas).x;
                newY -= getPosition(this._canvas).y;
            }
            const viewport = this._viewportToPixels(this.viewport);
            // if fullscreen api on it centers with black bars
            // we need to adjust the screen to world coordinates in this case
            if (this._isFullScreen) {
                if (window.innerWidth / this.aspectRatio < window.innerHeight) {
                    const screenHeight = window.innerWidth / this.aspectRatio;
                    const screenMarginY = (window.innerHeight - screenHeight) / 2;
                    newY = (newY - screenMarginY) / screenHeight * viewport.height;
                    newX = newX / window.innerWidth * viewport.width;
                } else {
                    const screenWidth = window.innerHeight * this.aspectRatio;
                    const screenMarginX = (window.innerWidth - screenWidth) / 2;
                    newX = (newX - screenMarginX) / screenWidth * viewport.width;
                    newY = newY / window.innerHeight * viewport.height;
                }
            }
            newX = newX / viewport.width * this.resolution.width;
            newY = newY / viewport.height * this.resolution.height;
            // offset by content area
            newX = newX - this.contentArea.left;
            newY = newY - this.contentArea.top;
            return new Vector(newX, newY);
        }
        /**
     * Takes a coordinate in Excalibur screen space, and translates it to normal html page space. For example,
     * this is where html elements might live if you want to position them relative to Excalibur.
     *
     * Excalibur screen space starts at the top left (0, 0) corner of the viewport, and extends to the
     * bottom right corner (resolutionX, resolutionY)
     * @param point
     */ screenToPageCoordinates(point) {
            let newX = point.x;
            let newY = point.y;
            // no need to offset by content area, drawing is already offset by this
            const viewport = this._viewportToPixels(this.viewport);
            newX = newX / this.resolution.width * viewport.width;
            newY = newY / this.resolution.height * viewport.height;
            if (this._isFullScreen) {
                if (window.innerWidth / this.aspectRatio < window.innerHeight) {
                    const screenHeight = window.innerWidth / this.aspectRatio;
                    const screenMarginY = (window.innerHeight - screenHeight) / 2;
                    newY = newY / viewport.height * screenHeight + screenMarginY;
                    newX = newX / viewport.width * window.innerWidth;
                } else {
                    const screenWidth = window.innerHeight * this.aspectRatio;
                    const screenMarginX = (window.innerWidth - screenWidth) / 2;
                    newX = newX / viewport.width * screenWidth + screenMarginX;
                    newY = newY / viewport.height * window.innerHeight;
                }
            }
            if (!this._isFullScreen) {
                newX += getPosition(this._canvas).x;
                newY += getPosition(this._canvas).y;
            }
            return new Vector(newX, newY);
        }
        /**
     * Takes a coordinate in Excalibur screen space, and translates it to Excalibur world space.
     *
     * World space is where [[Entity|entities]] in Excalibur live by default [[CoordPlane.World]]
     * and extends infinitely out relative from the [[Camera]].
     * @param point  Screen coordinate to convert
     */ screenToWorldCoordinates(point) {
            // offset by content area
            point = point.add(vec(this.contentArea.left, this.contentArea.top));
            // the only difference between screen & world is the camera transform
            if (this._camera) return this._camera.inverse.multiply(point);
            return point.sub(vec(this.resolution.width / 2, this.resolution.height / 2));
        }
        /**
     * Takes a coordinate in Excalibur world space, and translates it to Excalibur screen space.
     *
     * Screen space is where [[ScreenElement|screen elements]] and [[Entity|entities]] with [[CoordPlane.Screen]] live.
     * @param point  World coordinate to convert
     */ worldToScreenCoordinates(point) {
            if (this._camera) return this._camera.transform.multiply(point);
            return point.add(vec(this.resolution.width / 2, this.resolution.height / 2));
        }
        pageToWorldCoordinates(point) {
            const screen = this.pageToScreenCoordinates(point);
            return this.screenToWorldCoordinates(screen);
        }
        worldToPageCoordinates(point) {
            const screen = this.worldToScreenCoordinates(point);
            return this.screenToPageCoordinates(screen);
        }
        /**
     * Returns a BoundingBox of the top left corner of the screen
     * and the bottom right corner of the screen.
     *
     * World bounds are in world coordinates, useful for culling objects offscreen that are in world space
     */ getWorldBounds() {
            const bounds = BoundingBox.fromDimension(this.resolution.width, this.resolution.height, Vector.Half).scale(vec(1 / this._camera.zoom, 1 / this._camera.zoom)).rotate(this._camera.rotation).translate(this._camera.drawPos);
            return bounds;
        }
        /**
     * Returns a BoundingBox of the top left corner of the screen and the bottom right corner of the screen.
     *
     * Screen bounds are in screen coordinates, useful for culling objects offscreen that are in screen space
     */ getScreenBounds() {
            const bounds = BoundingBox.fromDimension(this.resolution.width, this.resolution.height, Vector.Zero, Vector.Zero);
            return bounds;
        }
        /**
     * The width of the game canvas in pixels (physical width component of the
     * resolution of the canvas element)
     */ get canvasWidth() {
            return this.canvas.width;
        }
        /**
     * Returns half width of the game canvas in pixels (half physical width component)
     */ get halfCanvasWidth() {
            return this.canvas.width / 2;
        }
        /**
     * The height of the game canvas in pixels, (physical height component of
     * the resolution of the canvas element)
     */ get canvasHeight() {
            return this.canvas.height;
        }
        /**
     * Returns half height of the game canvas in pixels (half physical height component)
     */ get halfCanvasHeight() {
            return this.canvas.height / 2;
        }
        /**
     * Returns the width of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get drawWidth() {
            if (this._camera) return this.resolution.width / this._camera.zoom;
            return this.resolution.width;
        }
        /**
     * Returns half the width of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get halfDrawWidth() {
            return this.drawWidth / 2;
        }
        /**
     * Returns the height of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get drawHeight() {
            if (this._camera) return this.resolution.height / this._camera.zoom;
            return this.resolution.height;
        }
        /**
     * Returns half the height of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get halfDrawHeight() {
            return this.drawHeight / 2;
        }
        /**
     * Returns screen center coordinates including zoom and device pixel ratio.
     */ get center() {
            return vec(this.halfDrawWidth, this.halfDrawHeight);
        }
        /**
     * Returns the content area in screen space where it is safe to place content
     */ get contentArea() {
            return this._contentArea;
        }
        /**
     * Returns the unsafe area in screen space, this is the full screen and some space may not be onscreen.
     */ get unsafeArea() {
            return this._unsafeArea;
        }
        _computeFit() {
            document.body.style.margin = "0px";
            document.body.style.overflow = "hidden";
            const aspect = this.aspectRatio;
            let adjustedWidth = 0;
            let adjustedHeight = 0;
            if (window.innerWidth / aspect < window.innerHeight) {
                adjustedWidth = window.innerWidth;
                adjustedHeight = window.innerWidth / aspect;
            } else {
                adjustedWidth = window.innerHeight * aspect;
                adjustedHeight = window.innerHeight;
            }
            this.viewport = {
                width: adjustedWidth,
                height: adjustedHeight
            };
            this._contentArea = BoundingBox.fromDimension(this.resolution.width, this.resolution.height, Vector.Zero);
            this._unsafeArea = BoundingBox.fromDimension(this.resolution.width, this.resolution.height, Vector.Zero);
            this.events.emit("resize", {
                resolution: this.resolution,
                viewport: this.viewport
            });
        }
        _computeFitScreenAndFill() {
            document.body.style.margin = "0px";
            document.body.style.overflow = "hidden";
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            this._computeFitAndFill(vw, vh);
            this.events.emit("resize", {
                resolution: this.resolution,
                viewport: this.viewport
            });
        }
        _computeFitContainerAndFill() {
            this.canvas.style.width = "100%";
            this.canvas.style.height = "100%";
            this._computeFitAndFill(this.canvas.offsetWidth, this.canvas.offsetHeight, {
                width: 100,
                widthUnit: "percent",
                height: 100,
                heightUnit: "percent"
            });
            this.events.emit("resize", {
                resolution: this.resolution,
                viewport: this.viewport
            });
        }
        _computeFitAndFill(vw, vh, viewport) {
            this.viewport = viewport !== null && viewport !== void 0 ? viewport : {
                width: vw,
                height: vh
            };
            // if the current screen aspectRatio is less than the original aspectRatio
            if (vw / vh <= this._contentResolution.width / this._contentResolution.height) {
                // compute new resolution to match the original aspect ratio
                this.resolution = {
                    width: vw * this._contentResolution.width / vw,
                    height: vw * this._contentResolution.width / vw * vh / vw
                };
                const clip = (this.resolution.height - this._contentResolution.height) / 2;
                this._contentArea = new BoundingBox({
                    top: clip,
                    left: 0,
                    right: this._contentResolution.width,
                    bottom: this.resolution.height - clip
                });
                this._unsafeArea = new BoundingBox({
                    top: -clip,
                    left: 0,
                    right: this._contentResolution.width,
                    bottom: this.resolution.height + clip
                });
            } else {
                this.resolution = {
                    width: vh * this._contentResolution.height / vh * vw / vh,
                    height: vh * this._contentResolution.height / vh
                };
                const clip = (this.resolution.width - this._contentResolution.width) / 2;
                this._contentArea = new BoundingBox({
                    top: 0,
                    left: clip,
                    right: this.resolution.width - clip,
                    bottom: this._contentResolution.height
                });
                this._unsafeArea = new BoundingBox({
                    top: 0,
                    left: -clip,
                    right: this.resolution.width + clip,
                    bottom: this._contentResolution.height
                });
            }
        }
        _computeFitScreenAndZoom() {
            document.body.style.margin = "0px";
            document.body.style.overflow = "hidden";
            this.canvas.style.position = "absolute";
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            this._computeFitAndZoom(vw, vh);
            this.events.emit("resize", {
                resolution: this.resolution,
                viewport: this.viewport
            });
        }
        _computeFitContainerAndZoom() {
            this.canvas.style.width = "100%";
            this.canvas.style.height = "100%";
            this.canvas.style.position = "relative";
            const parent = this.canvas.parentElement;
            parent.style.overflow = "hidden";
            const { offsetWidth: vw, offsetHeight: vh } = this.canvas;
            this._computeFitAndZoom(vw, vh);
            this.events.emit("resize", {
                resolution: this.resolution,
                viewport: this.viewport
            });
        }
        _computeFitAndZoom(vw, vh) {
            const aspect = this.aspectRatio;
            let adjustedWidth = 0;
            let adjustedHeight = 0;
            if (vw / aspect < vh) {
                adjustedWidth = vw;
                adjustedHeight = vw / aspect;
            } else {
                adjustedWidth = vh * aspect;
                adjustedHeight = vh;
            }
            const scaleX = vw / adjustedWidth;
            const scaleY = vh / adjustedHeight;
            const maxScaleFactor = Math.max(scaleX, scaleY);
            const zoomedWidth = adjustedWidth * maxScaleFactor;
            const zoomedHeight = adjustedHeight * maxScaleFactor;
            // Center zoomed dimension if bigger than the screen
            if (zoomedWidth > vw) this.canvas.style.left = -(zoomedWidth - vw) / 2 + "px";
            else this.canvas.style.left = "";
            if (zoomedHeight > vh) this.canvas.style.top = -(zoomedHeight - vh) / 2 + "px";
            else this.canvas.style.top = "";
            this.viewport = {
                width: zoomedWidth,
                height: zoomedHeight
            };
            const bounds = BoundingBox.fromDimension(this.viewport.width, this.viewport.height, Vector.Zero);
            // return safe area
            if (this.viewport.width > vw) {
                const clip = (this.viewport.width - vw) / this.viewport.width * this.resolution.width;
                bounds.top = 0;
                bounds.left = clip / 2;
                bounds.right = this.resolution.width - clip / 2;
                bounds.bottom = this.resolution.height;
            }
            if (this.viewport.height > vh) {
                const clip = (this.viewport.height - vh) / this.viewport.height * this.resolution.height;
                bounds.top = clip / 2;
                bounds.left = 0;
                bounds.bottom = this.resolution.height - clip / 2;
                bounds.right = this.resolution.width;
            }
            this._contentArea = bounds;
        }
        _computeFitContainer() {
            const aspect = this.aspectRatio;
            let adjustedWidth = 0;
            let adjustedHeight = 0;
            let widthUnit = "pixel";
            let heightUnit = "pixel";
            const parent = this.canvas.parentElement;
            if (parent.clientWidth / aspect < parent.clientHeight) {
                this.canvas.style.width = "100%";
                adjustedWidth = 100;
                widthUnit = "percent";
                adjustedHeight = this.canvas.offsetWidth / aspect;
            } else {
                this.canvas.style.height = "100%";
                adjustedHeight = 100;
                heightUnit = "percent";
                adjustedWidth = this.canvas.offsetHeight * aspect;
            }
            this.viewport = {
                width: adjustedWidth,
                widthUnit: widthUnit,
                height: adjustedHeight,
                heightUnit: heightUnit
            };
            this._contentArea = BoundingBox.fromDimension(this.resolution.width, this.resolution.height, Vector.Zero);
            this.events.emit("resize", {
                resolution: this.resolution,
                viewport: this.viewport
            });
        }
        _applyDisplayMode() {
            this._setResolutionAndViewportByDisplayMode(this.parent);
            // watch resizing
            if (this.parent instanceof Window) this._browser.window.on("resize", this._resizeHandler);
            else {
                this._resizeObserver = new ResizeObserver(()=>{
                    this._resizeHandler();
                });
                this._resizeObserver.observe(this.parent);
            }
            this.parent.addEventListener("resize", this._resizeHandler);
        }
        /**
     * Sets the resolution and viewport based on the selected display mode.
     */ _setResolutionAndViewportByDisplayMode(parent) {
            if (this.displayMode === DisplayMode.FillContainer) {
                this.canvas.style.width = "100%";
                this.canvas.style.height = "100%";
                this.viewport = {
                    width: 100,
                    widthUnit: "percent",
                    height: 100,
                    heightUnit: "percent"
                };
                this.resolution = {
                    width: this.canvas.offsetWidth,
                    height: this.canvas.offsetHeight
                };
            }
            if (this.displayMode === DisplayMode.FillScreen) {
                document.body.style.margin = "0px";
                document.body.style.overflow = "hidden";
                this.resolution = {
                    width: parent.innerWidth,
                    height: parent.innerHeight
                };
                this.viewport = this.resolution;
            }
            this._contentArea = BoundingBox.fromDimension(this.resolution.width, this.resolution.height, Vector.Zero);
            if (this.displayMode === DisplayMode.FitScreen) this._computeFit();
            if (this.displayMode === DisplayMode.FitContainer) this._computeFitContainer();
            if (this.displayMode === DisplayMode.FitScreenAndFill) this._computeFitScreenAndFill();
            if (this.displayMode === DisplayMode.FitContainerAndFill) this._computeFitContainerAndFill();
            if (this.displayMode === DisplayMode.FitScreenAndZoom) this._computeFitScreenAndZoom();
            if (this.displayMode === DisplayMode.FitContainerAndZoom) this._computeFitContainerAndZoom();
        }
    }
    /**
 * Internal class used to build instances of AudioContext
 */ /* istanbul ignore next */ class AudioContextFactory {
        static create() {
            if (!this._INSTANCE) {
                if (window.AudioContext || window.webkitAudioContext) this._INSTANCE = new AudioContext();
            }
            return this._INSTANCE;
        }
    }
    AudioContextFactory._INSTANCE = null;
    /**
 * Patch for detecting legacy web audio in browsers
 * @internal
 * @param source
 */ function isLegacyWebAudioSource(source) {
        return !!source.playbackState;
    }
    class WebAudio {
        /**
     * Play an empty sound to unlock Safari WebAudio context. Call this function
     * right after a user interaction event.
     * @source https://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     */ static unlock() {
            const promise = new Promise((resolve, reject)=>{
                if (WebAudio._UNLOCKED || !AudioContextFactory.create()) return resolve(true);
                const unlockTimeoutTimer = setTimeout(()=>{
                    Logger.getInstance().warn("Excalibur was unable to unlock the audio context, audio probably will not play in this browser.");
                    resolve(false);
                }, 200);
                const audioContext = AudioContextFactory.create();
                audioContext.resume().then(()=>{
                    // create empty buffer and play it
                    const buffer = audioContext.createBuffer(1, 1, 22050);
                    const source = audioContext.createBufferSource();
                    let ended = false;
                    source.buffer = buffer;
                    source.connect(audioContext.destination);
                    source.onended = ()=>ended = true;
                    source.start(0);
                    // by checking the play state after some time, we know if we're really unlocked
                    setTimeout(()=>{
                        if (isLegacyWebAudioSource(source)) {
                            if (source.playbackState === source.PLAYING_STATE || source.playbackState === source.FINISHED_STATE) WebAudio._UNLOCKED = true;
                        } else if (audioContext.currentTime > 0 || ended) WebAudio._UNLOCKED = true;
                    }, 0);
                    clearTimeout(unlockTimeoutTimer);
                    resolve(true);
                }, ()=>{
                    reject();
                });
            });
            return promise;
        }
        static isUnlocked() {
            return this._UNLOCKED;
        }
    }
    WebAudio._UNLOCKED = false;
    /**
 * A Raster is a Graphic that needs to be first painted to a HTMLCanvasElement before it can be drawn to the
 * [[ExcaliburGraphicsContext]]. This is useful for generating custom images using the 2D canvas api.
 *
 * Implementors must implement the [[Raster.execute]] method to rasterize their drawing.
 */ class Raster extends Graphic {
        constructor(options){
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            super(omit(options, [
                "width",
                "height"
            ])); // rasters do some special sauce with width/height
            this.filtering = null;
            this.lineCap = "butt";
            this.quality = 1;
            this._dirty = true;
            this._smoothing = false;
            this._color = watch(Color.Black, ()=>this.flagDirty());
            this._lineWidth = 1;
            this._lineDash = [];
            this._padding = 0;
            if (options) {
                this.quality = (_a = options.quality) !== null && _a !== void 0 ? _a : this.quality;
                this.color = (_b = options.color) !== null && _b !== void 0 ? _b : Color.Black;
                this.strokeColor = options === null || options === void 0 ? void 0 : options.strokeColor;
                this.smoothing = (_c = options.smoothing) !== null && _c !== void 0 ? _c : this.smoothing;
                this.lineWidth = (_d = options.lineWidth) !== null && _d !== void 0 ? _d : this.lineWidth;
                this.lineDash = (_e = options.lineDash) !== null && _e !== void 0 ? _e : this.lineDash;
                this.lineCap = (_f = options.lineCap) !== null && _f !== void 0 ? _f : this.lineCap;
                this.padding = (_g = options.padding) !== null && _g !== void 0 ? _g : this.padding;
                this.filtering = (_h = options.filtering) !== null && _h !== void 0 ? _h : this.filtering;
            }
            this._bitmap = document.createElement("canvas");
            // get the default canvas width/height as a fallback
            const bitmapWidth = (_j = options === null || options === void 0 ? void 0 : options.width) !== null && _j !== void 0 ? _j : this._bitmap.width;
            const bitmapHeight = (_k = options === null || options === void 0 ? void 0 : options.height) !== null && _k !== void 0 ? _k : this._bitmap.height;
            this.width = bitmapWidth;
            this.height = bitmapHeight;
            const maybeCtx = this._bitmap.getContext("2d");
            if (!maybeCtx) /* istanbul ignore next */ throw new Error("Browser does not support 2d canvas drawing, cannot create Raster graphic");
            else this._ctx = maybeCtx;
        }
        cloneRasterOptions() {
            return {
                color: this.color ? this.color.clone() : null,
                strokeColor: this.strokeColor ? this.strokeColor.clone() : null,
                smoothing: this.smoothing,
                lineWidth: this.lineWidth,
                lineDash: this.lineDash,
                lineCap: this.lineCap,
                quality: this.quality,
                padding: this.padding
            };
        }
        /**
     * Gets whether the graphic is dirty, this means there are changes that haven't been re-rasterized
     */ get dirty() {
            return this._dirty;
        }
        /**
     * Flags the graphic as dirty, meaning it must be re-rasterized before draw.
     * This should be called any time the graphics state changes such that it affects the outputted drawing
     */ flagDirty() {
            this._dirty = true;
        }
        /**
     * Gets or sets the current width of the Raster graphic. Setting the width will cause the raster
     * to be flagged dirty causing a re-raster on the next draw.
     *
     * Any `padding`s or `quality` set will be factored into the width
     */ get width() {
            return Math.abs(this._getTotalWidth() * this.scale.x);
        }
        set width(value) {
            value /= Math.abs(this.scale.x);
            this._bitmap.width = value;
            this._originalWidth = value;
            this.flagDirty();
        }
        /**
     * Gets or sets the current height of the Raster graphic. Setting the height will cause the raster
     * to be flagged dirty causing a re-raster on the next draw.
     *
     * Any `padding` or `quality` set will be factored into the height
     */ get height() {
            return Math.abs(this._getTotalHeight() * this.scale.y);
        }
        set height(value) {
            value /= Math.abs(this.scale.y);
            this._bitmap.height = value;
            this._originalHeight = value;
            this.flagDirty();
        }
        _getTotalWidth() {
            var _a;
            return (((_a = this._originalWidth) !== null && _a !== void 0 ? _a : this._bitmap.width) + this.padding * 2) * 1;
        }
        _getTotalHeight() {
            var _a;
            return (((_a = this._originalHeight) !== null && _a !== void 0 ? _a : this._bitmap.height) + this.padding * 2) * 1;
        }
        /**
     * Returns the local bounds of the Raster including the padding
     */ get localBounds() {
            return BoundingBox.fromDimension(this._getTotalWidth() * this.scale.x, this._getTotalHeight() * this.scale.y, Vector.Zero);
        }
        /**
     * Gets or sets the smoothing (anti-aliasing of the graphic). Setting the height will cause the raster
     * to be flagged dirty causing a re-raster on the next draw.
     */ get smoothing() {
            return this._smoothing;
        }
        set smoothing(value) {
            this._smoothing = value;
            this.flagDirty();
        }
        /**
     * Gets or sets the fillStyle of the Raster graphic. Setting the fillStyle will cause the raster to be
     * flagged dirty causing a re-raster on the next draw.
     */ get color() {
            return this._color;
        }
        set color(value) {
            this.flagDirty();
            this._color = watch(value, ()=>this.flagDirty());
        }
        /**
     * Gets or sets the strokeStyle of the Raster graphic. Setting the strokeStyle will cause the raster to be
     * flagged dirty causing a re-raster on the next draw.
     */ get strokeColor() {
            return this._strokeColor;
        }
        set strokeColor(value) {
            this.flagDirty();
            this._strokeColor = watch(value, ()=>this.flagDirty());
        }
        /**
     * Gets or sets the line width of the Raster graphic. Setting the lineWidth will cause the raster to be
     * flagged dirty causing a re-raster on the next draw.
     */ get lineWidth() {
            return this._lineWidth;
        }
        set lineWidth(value) {
            this._lineWidth = value;
            this.flagDirty();
        }
        get lineDash() {
            return this._lineDash;
        }
        set lineDash(value) {
            this._lineDash = value;
            this.flagDirty();
        }
        get padding() {
            return this._padding;
        }
        set padding(value) {
            this._padding = value;
            this.flagDirty();
        }
        /**
     * Rasterize the graphic to a bitmap making it usable as in excalibur. Rasterize is called automatically if
     * the graphic is [[Raster.dirty]] on the next [[Graphic.draw]] call
     */ rasterize() {
            this._dirty = false;
            this._ctx.clearRect(0, 0, this._getTotalWidth(), this._getTotalHeight());
            this._ctx.save();
            this._applyRasterProperties(this._ctx);
            this.execute(this._ctx);
            this._ctx.restore();
        }
        _applyRasterProperties(ctx) {
            var _a, _b, _c;
            this._bitmap.width = this._getTotalWidth() * this.quality;
            this._bitmap.height = this._getTotalHeight() * this.quality;
            // Do a bad thing to pass the filtering as an attribute
            this._bitmap.setAttribute("filtering", this.filtering);
            this._bitmap.setAttribute("forceUpload", "true");
            ctx.scale(this.quality, this.quality);
            ctx.translate(this.padding, this.padding);
            ctx.imageSmoothingEnabled = this.smoothing;
            ctx.lineWidth = this.lineWidth;
            ctx.setLineDash((_a = this.lineDash) !== null && _a !== void 0 ? _a : ctx.getLineDash());
            ctx.lineCap = this.lineCap;
            ctx.strokeStyle = (_b = this.strokeColor) === null || _b === void 0 ? void 0 : _b.toString();
            ctx.fillStyle = (_c = this.color) === null || _c === void 0 ? void 0 : _c.toString();
        }
        _drawImage(ex, x, y) {
            if (this._dirty) this.rasterize();
            ex.scale(1 / this.quality, 1 / this.quality);
            ex.drawImage(this._bitmap, x, y);
        }
    }
    /**
 * A canvas [[Graphic]] to provide an adapter between the 2D Canvas API and the [[ExcaliburGraphicsContext]].
 *
 * The [[Canvas]] works by re-rastering a draw handler to a HTMLCanvasElement for every draw which is then passed
 * to the [[ExcaliburGraphicsContext]] implementation as a rendered image.
 *
 * **Low performance API**
 */ class Canvas extends Raster {
        /**
     * Return the 2D graphics context of this canvas
     */ get ctx() {
            return this._ctx;
        }
        constructor(_options){
            super(_options);
            this._options = _options;
        }
        clone() {
            return new Canvas({
                ...this._options,
                ...this.cloneGraphicOptions(),
                ...this.cloneRasterOptions()
            });
        }
        execute(ctx) {
            var _a, _b;
            if ((_a = this._options) === null || _a === void 0 ? void 0 : _a.draw) (_b = this._options) === null || _b === void 0 || _b.draw(ctx);
            if (!this._options.cache) this.flagDirty();
        }
    }
    class ExResponse {
    }
    ExResponse.type = {
        any: "",
        blob: "blob",
        json: "json",
        text: "text",
        document: "document",
        arraybuffer: "arraybuffer"
    };
    class StateMachine {
        constructor(){
            this.states = new Map();
        }
        get currentState() {
            return this._currentState;
        }
        set currentState(state) {
            this._currentState = state;
        }
        static create(machineDescription, data) {
            const machine = new StateMachine();
            machine.data = data;
            for(const stateName in machineDescription.states)machine.states.set(stateName, {
                name: stateName,
                ...machineDescription.states[stateName]
            });
            // validate transitions are states
            for (const state of machine.states.values())for (const transitionState of state.transitions){
                if (transitionState === "*") continue;
                if (!machine.states.has(transitionState)) throw Error(`Invalid state machine, state [${state.name}] has a transition to another state that doesn't exist [${transitionState}]`);
            }
            machine.currentState = machine.startState = machine.states.get(machineDescription.start);
            return machine;
        }
        in(state) {
            return this.currentState.name === state;
        }
        go(stateName, eventData) {
            var _a, _b;
            if (this.currentState.transitions.includes(stateName) || this.currentState.transitions.includes("*")) {
                const potentialNewState = this.states.get(stateName);
                if (this.currentState.onExit) {
                    const canExit = (_a = this.currentState) === null || _a === void 0 ? void 0 : _a.onExit({
                        to: potentialNewState.name,
                        data: this.data
                    });
                    if (canExit === false) return false;
                }
                if (potentialNewState === null || potentialNewState === void 0 ? void 0 : potentialNewState.onEnter) {
                    const canEnter = potentialNewState === null || potentialNewState === void 0 ? void 0 : potentialNewState.onEnter({
                        from: this.currentState.name,
                        eventData: eventData,
                        data: this.data
                    });
                    if (canEnter === false) return false;
                }
                // console.log(`${this.currentState.name} => ${potentialNewState.name} (${eventData})`);
                this.currentState = potentialNewState;
                if ((_b = this.currentState) === null || _b === void 0 ? void 0 : _b.onState) this.currentState.onState();
                return true;
            }
            return false;
        }
        update(elapsedMs) {
            if (this.currentState.onUpdate) this.currentState.onUpdate(this.data, elapsedMs);
        }
        save(saveKey) {
            localStorage.setItem(saveKey, JSON.stringify({
                currentState: this.currentState.name,
                data: this.data
            }));
        }
        restore(saveKey) {
            const state = JSON.parse(localStorage.getItem(saveKey));
            this.currentState = this.states.get(state.currentState);
            this.data = state.data;
        }
    }
    /**
 * Internal class representing a Web Audio AudioBufferSourceNode instance
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_Audio_API
 */ class WebAudioInstance {
        _createNewBufferSource() {
            this._instance = this._audioContext.createBufferSource();
            this._instance.buffer = this._src;
            this._instance.loop = this.loop;
            this._instance.playbackRate.value = this._playbackRate;
            this._instance.connect(this._volumeNode);
            this._volumeNode.connect(this._audioContext.destination);
        }
        _handleEnd() {
            if (!this.loop) this._instance.onended = ()=>{
                this._playingFuture.resolve(true);
            };
        }
        set loop(value) {
            this._loop = value;
            if (this._instance) {
                this._instance.loop = value;
                if (!this.loop) this._instance.onended = ()=>{
                    this._playingFuture.resolve(true);
                };
            }
        }
        get loop() {
            return this._loop;
        }
        set volume(value) {
            value = clamp(value, 0, 1.0);
            this._volume = value;
            if (this._stateMachine.in("PLAYING") && this._volumeNode.gain.setTargetAtTime) // https://developer.mozilla.org/en-US/docs/Web/API/AudioParam/setTargetAtTime
            // After each .1 seconds timestep, the target value will ~63.2% closer to the target value.
            // This exponential ramp provides a more pleasant transition in gain
            this._volumeNode.gain.setTargetAtTime(value, this._audioContext.currentTime, 0.1);
            else this._volumeNode.gain.value = value;
        }
        get volume() {
            return this._volume;
        }
        /**
     * Returns the set duration to play, otherwise returns the total duration if unset
     */ get duration() {
            var _a;
            return (_a = this._duration) !== null && _a !== void 0 ? _a : this.getTotalPlaybackDuration();
        }
        /**
     * Set the duration that this audio should play.
     *
     * Note: if you seek to a specific point the duration will start from that point, for example
     *
     * If you have a 10 second clip, seek to 5 seconds, then set the duration to 2, it will play the clip from 5-7 seconds.
     */ set duration(duration) {
            this._duration = duration;
        }
        constructor(_src){
            this._src = _src;
            this._audioContext = AudioContextFactory.create();
            this._volumeNode = this._audioContext.createGain();
            this._playingFuture = new Future();
            this._stateMachine = StateMachine.create({
                start: "STOPPED",
                states: {
                    PLAYING: {
                        onEnter: ({ data: data })=>{
                            // Buffer nodes are single use
                            this._createNewBufferSource();
                            this._handleEnd();
                            if (this.loop) // when looping don't set a duration
                            this._instance.start(0, data.pausedAt * this._playbackRate);
                            else this._instance.start(0, data.pausedAt * this._playbackRate, this.duration);
                            data.startedAt = this._audioContext.currentTime - data.pausedAt;
                            data.pausedAt = 0;
                        },
                        onState: ()=>this._playStarted(),
                        onExit: ({ to: to })=>{
                            // If you've exited early only resolve if explicitly STOPPED
                            if (to === "STOPPED") this._playingFuture.resolve(true);
                            // Whenever you're not playing... you stop!
                            this._instance.onended = null; // disconnect the wired on-end handler
                            this._instance.disconnect();
                            this._instance.stop(0);
                            this._instance = null;
                        },
                        transitions: [
                            "STOPPED",
                            "PAUSED",
                            "SEEK"
                        ]
                    },
                    SEEK: {
                        onEnter: ({ eventData: position, data: data })=>{
                            data.pausedAt = (position !== null && position !== void 0 ? position : 0) / this._playbackRate;
                            data.startedAt = 0;
                        },
                        transitions: [
                            "*"
                        ]
                    },
                    STOPPED: {
                        onEnter: ({ data: data })=>{
                            data.pausedAt = 0;
                            data.startedAt = 0;
                            this._playingFuture.resolve(true);
                        },
                        transitions: [
                            "PLAYING",
                            "PAUSED",
                            "SEEK"
                        ]
                    },
                    PAUSED: {
                        onEnter: ({ data: data })=>{
                            // Playback rate will be a scale factor of how fast/slow the audio is being played
                            // default is 1.0
                            // we need to invert it to get the time scale
                            data.pausedAt = this._audioContext.currentTime - data.startedAt;
                        },
                        transitions: [
                            "PLAYING",
                            "STOPPED",
                            "SEEK"
                        ]
                    }
                }
            }, {
                startedAt: 0,
                pausedAt: 0
            });
            this._volume = 1;
            this._loop = false;
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            this._playStarted = ()=>{};
            this._playbackRate = 1.0;
            this._createNewBufferSource();
        }
        isPlaying() {
            return this._stateMachine.in("PLAYING");
        }
        isPaused() {
            return this._stateMachine.in("PAUSED") || this._stateMachine.in("SEEK");
        }
        isStopped() {
            return this._stateMachine.in("STOPPED");
        }
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        play(playStarted = ()=>{}) {
            this._playStarted = playStarted;
            this._stateMachine.go("PLAYING");
            return this._playingFuture.promise;
        }
        pause() {
            this._stateMachine.go("PAUSED");
        }
        stop() {
            this._stateMachine.go("STOPPED");
        }
        seek(position) {
            this._stateMachine.go("PAUSED");
            this._stateMachine.go("SEEK", position);
        }
        getTotalPlaybackDuration() {
            return this._src.duration;
        }
        getPlaybackPosition() {
            const { pausedAt: pausedAt, startedAt: startedAt } = this._stateMachine.data;
            if (pausedAt) return pausedAt * this._playbackRate;
            if (startedAt) return (this._audioContext.currentTime - startedAt) * this._playbackRate;
            return 0;
        }
        set playbackRate(playbackRate) {
            this._instance.playbackRate.value = this._playbackRate = playbackRate;
        }
        get playbackRate() {
            return this._instance.playbackRate.value;
        }
    }
    var EventTypes;
    (function(EventTypes) {
        EventTypes["Kill"] = "kill";
        EventTypes["PreKill"] = "prekill";
        EventTypes["PostKill"] = "postkill";
        EventTypes["PreDraw"] = "predraw";
        EventTypes["PostDraw"] = "postdraw";
        EventTypes["PreDebugDraw"] = "predebugdraw";
        EventTypes["PostDebugDraw"] = "postdebugdraw";
        EventTypes["PreUpdate"] = "preupdate";
        EventTypes["PostUpdate"] = "postupdate";
        EventTypes["PreFrame"] = "preframe";
        EventTypes["PostFrame"] = "postframe";
        EventTypes["PreCollision"] = "precollision";
        EventTypes["CollisionStart"] = "collisionstart";
        EventTypes["CollisionEnd"] = "collisionend";
        EventTypes["PostCollision"] = "postcollision";
        EventTypes["Initialize"] = "initialize";
        EventTypes["Activate"] = "activate";
        EventTypes["Deactivate"] = "deactivate";
        EventTypes["ExitViewport"] = "exitviewport";
        EventTypes["EnterViewport"] = "enterviewport";
        EventTypes["ExitTrigger"] = "exit";
        EventTypes["EnterTrigger"] = "enter";
        EventTypes["Connect"] = "connect";
        EventTypes["Disconnect"] = "disconnect";
        EventTypes["Button"] = "button";
        EventTypes["Axis"] = "axis";
        EventTypes["Visible"] = "visible";
        EventTypes["Hidden"] = "hidden";
        EventTypes["Start"] = "start";
        EventTypes["Stop"] = "stop";
        EventTypes["PointerUp"] = "pointerup";
        EventTypes["PointerDown"] = "pointerdown";
        EventTypes["PointerMove"] = "pointermove";
        EventTypes["PointerEnter"] = "pointerenter";
        EventTypes["PointerLeave"] = "pointerleave";
        EventTypes["PointerCancel"] = "pointercancel";
        EventTypes["PointerWheel"] = "pointerwheel";
        EventTypes["Up"] = "up";
        EventTypes["Down"] = "down";
        EventTypes["Move"] = "move";
        EventTypes["Enter"] = "enter";
        EventTypes["Leave"] = "leave";
        EventTypes["Cancel"] = "cancel";
        EventTypes["Wheel"] = "wheel";
        EventTypes["Press"] = "press";
        EventTypes["Release"] = "release";
        EventTypes["Hold"] = "hold";
        EventTypes["PointerDragStart"] = "pointerdragstart";
        EventTypes["PointerDragEnd"] = "pointerdragend";
        EventTypes["PointerDragEnter"] = "pointerdragenter";
        EventTypes["PointerDragLeave"] = "pointerdragleave";
        EventTypes["PointerDragMove"] = "pointerdragmove";
        EventTypes["ActionStart"] = "actionstart";
        EventTypes["ActionComplete"] = "actioncomplete";
    })(EventTypes || (EventTypes = {}));
    /**
 * Base event type in Excalibur that all other event types derive from. Not all event types are thrown on all Excalibur game objects,
 * some events are unique to a type, others are not.
 *
 */ class GameEvent {
        constructor(){
            this._bubbles = true;
        }
        /**
     * If set to false, prevents event from propagating to other actors. If true it will be propagated
     * to all actors that apply.
     */ get bubbles() {
            return this._bubbles;
        }
        set bubbles(value) {
            this._bubbles = value;
        }
        /**
     * Prevents event from bubbling
     */ stopPropagation() {
            this.bubbles = false;
        }
    }
    /**
 * The 'kill' event is emitted on actors when it is killed. The target is the actor that was killed.
 */ class KillEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * The 'prekill' event is emitted directly before an actor is killed.
 */ class PreKillEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * The 'postkill' event is emitted directly after the actor is killed.
 */ class PostKillEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * The 'start' event is emitted on engine when has started and is ready for interaction.
 */ class GameStartEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * The 'stop' event is emitted on engine when has been stopped and will no longer take input, update or draw.
 */ class GameStopEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * The 'predraw' event is emitted on actors, scenes, and engine before drawing starts. Actors' predraw happens inside their graphics
 * transform so that all drawing takes place with the actor as the origin.
 *
 */ class PreDrawEvent extends GameEvent {
        constructor(ctx, delta, target){
            super();
            this.ctx = ctx;
            this.delta = delta;
            this.target = target;
        }
    }
    /**
 * The 'postdraw' event is emitted on actors, scenes, and engine after drawing finishes. Actors' postdraw happens inside their graphics
 * transform so that all drawing takes place with the actor as the origin.
 *
 */ class PostDrawEvent extends GameEvent {
        constructor(ctx, delta, target){
            super();
            this.ctx = ctx;
            this.delta = delta;
            this.target = target;
        }
    }
    /**
 * The 'pretransformdraw' event is emitted on actors/entities before any graphics transforms have taken place.
 * Useful if you need to completely customize the draw or modify the transform before drawing in the draw step (for example needing
 * latest camera positions)
 *
 */ class PreTransformDrawEvent extends GameEvent {
        constructor(ctx, delta, target){
            super();
            this.ctx = ctx;
            this.delta = delta;
            this.target = target;
        }
    }
    /**
 * The 'posttransformdraw' event is emitted on actors/entities after all graphics have been draw and transforms reset.
 * Useful if you need to completely custom the draw after everything is done.
 *
 */ class PostTransformDrawEvent extends GameEvent {
        constructor(ctx, delta, target){
            super();
            this.ctx = ctx;
            this.delta = delta;
            this.target = target;
        }
    }
    /**
 * The 'predebugdraw' event is emitted on actors, scenes, and engine before debug drawing starts.
 */ class PreDebugDrawEvent extends GameEvent {
        constructor(ctx, target){
            super();
            this.ctx = ctx;
            this.target = target;
        }
    }
    /**
 * The 'postdebugdraw' event is emitted on actors, scenes, and engine after debug drawing starts.
 */ class PostDebugDrawEvent extends GameEvent {
        constructor(ctx, target){
            super();
            this.ctx = ctx;
            this.target = target;
        }
    }
    /**
 * The 'preupdate' event is emitted on actors, scenes, camera, and engine before the update starts.
 */ class PreUpdateEvent extends GameEvent {
        constructor(engine, delta, target){
            super();
            this.engine = engine;
            this.delta = delta;
            this.target = target;
        }
    }
    /**
 * The 'postupdate' event is emitted on actors, scenes, camera, and engine after the update ends.
 */ class PostUpdateEvent extends GameEvent {
        constructor(engine, delta, target){
            super();
            this.engine = engine;
            this.delta = delta;
            this.target = target;
        }
    }
    /**
 * The 'preframe' event is emitted on the engine, before the frame begins.
 */ class PreFrameEvent extends GameEvent {
        constructor(engine, prevStats){
            super();
            this.engine = engine;
            this.prevStats = prevStats;
            this.target = engine;
        }
    }
    /**
 * The 'postframe' event is emitted on the engine, after a frame ends.
 */ class PostFrameEvent extends GameEvent {
        constructor(engine, stats){
            super();
            this.engine = engine;
            this.stats = stats;
            this.target = engine;
        }
    }
    /**
 * Event received when a gamepad is connected to Excalibur. [[Gamepads]] receives this event.
 */ class GamepadConnectEvent extends GameEvent {
        constructor(index, gamepad){
            super();
            this.index = index;
            this.gamepad = gamepad;
            this.target = gamepad;
        }
    }
    /**
 * Event received when a gamepad is disconnected from Excalibur. [[Gamepads]] receives this event.
 */ class GamepadDisconnectEvent extends GameEvent {
        constructor(index, gamepad){
            super();
            this.index = index;
            this.gamepad = gamepad;
            this.target = gamepad;
        }
    }
    /**
 * Gamepad button event. See [[Gamepads]] for information on responding to controller input. [[Gamepad]] instances receive this event;
 */ class GamepadButtonEvent extends GameEvent {
        /**
     * @param button  The Gamepad button
     * @param value   A numeric value between 0 and 1
     */ constructor(button, value, target){
            super();
            this.button = button;
            this.value = value;
            this.target = target;
        }
    }
    /**
 * Gamepad axis event. See [[Gamepads]] for information on responding to controller input. [[Gamepad]] instances receive this event;
 */ class GamepadAxisEvent extends GameEvent {
        /**
     * @param axis  The Gamepad axis
     * @param value A numeric value between -1 and 1
     */ constructor(axis, value, target){
            super();
            this.axis = axis;
            this.value = value;
            this.target = target;
        }
    }
    /**
 * Event received by the [[Engine]] when the browser window is visible on a screen.
 */ class VisibleEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * Event received by the [[Engine]] when the browser window is hidden from all screens.
 */ class HiddenEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * Event thrown on an [[Actor|actor]] when a collision will occur this frame if it resolves
 */ class PreCollisionEvent extends GameEvent {
        /**
     * @param actor         The actor the event was thrown on
     * @param other         The actor that will collided with the current actor
     * @param side          The side that will be collided with the current actor
     * @param intersection  Intersection vector
     */ constructor(actor, other, side, intersection, contact){
            super();
            this.other = other;
            this.side = side;
            this.intersection = intersection;
            this.contact = contact;
            this.target = actor;
        }
    }
    /**
 * Event thrown on an [[Actor|actor]] when a collision has been resolved (body reacted) this frame
 */ class PostCollisionEvent extends GameEvent {
        /**
     * @param actor         The actor the event was thrown on
     * @param other         The actor that did collide with the current actor
     * @param side          The side that did collide with the current actor
     * @param intersection  Intersection vector
     */ constructor(actor, other, side, intersection, contact){
            super();
            this.other = other;
            this.side = side;
            this.intersection = intersection;
            this.contact = contact;
            this.target = actor;
        }
        get actor() {
            return this.target;
        }
        set actor(actor) {
            this.target = actor;
        }
    }
    class ContactStartEvent {
        constructor(target, other, side, contact){
            this.target = target;
            this.other = other;
            this.side = side;
            this.contact = contact;
        }
    }
    class ContactEndEvent {
        constructor(target, other, side, lastContact){
            this.target = target;
            this.other = other;
            this.side = side;
            this.lastContact = lastContact;
        }
    }
    class CollisionPreSolveEvent {
        constructor(target, other, side, intersection, contact){
            this.target = target;
            this.other = other;
            this.side = side;
            this.intersection = intersection;
            this.contact = contact;
        }
    }
    class CollisionPostSolveEvent {
        constructor(target, other, side, intersection, contact){
            this.target = target;
            this.other = other;
            this.side = side;
            this.intersection = intersection;
            this.contact = contact;
        }
    }
    /**
 * Event thrown the first time an [[Actor|actor]] collides with another, after an actor is in contact normal collision events are fired.
 */ class CollisionStartEvent extends GameEvent {
        /**
     *
     * @param actor
     * @param other
     * @param side
     * @param contact
     */ constructor(actor, other, side, contact){
            super();
            this.other = other;
            this.side = side;
            this.contact = contact;
            this.target = actor;
        }
        get actor() {
            return this.target;
        }
        set actor(actor) {
            this.target = actor;
        }
    }
    /**
 * Event thrown when the [[Actor|actor]] is no longer colliding with another
 */ class CollisionEndEvent extends GameEvent {
        /**
     *
     */ constructor(actor, other, side, lastContact){
            super();
            this.other = other;
            this.side = side;
            this.lastContact = lastContact;
            this.target = actor;
        }
        get actor() {
            return this.target;
        }
        set actor(actor) {
            this.target = actor;
        }
    }
    /**
 * Event thrown on an [[Actor]], [[Scene]], and [[Engine]] only once before the first update call
 */ class InitializeEvent extends GameEvent {
        /**
     * @param engine  The reference to the current engine
     */ constructor(engine, target){
            super();
            this.engine = engine;
            this.target = target;
        }
    }
    /**
 * Event thrown on a [[Scene]] on activation
 */ class ActivateEvent extends GameEvent {
        /**
     * @param context  The context for the scene activation
     */ constructor(context, target){
            super();
            this.context = context;
            this.target = target;
        }
    }
    /**
 * Event thrown on a [[Scene]] on deactivation
 */ class DeactivateEvent extends GameEvent {
        /**
     * @param context  The context for the scene deactivation
     */ constructor(context, target){
            super();
            this.context = context;
            this.target = target;
        }
    }
    /**
 * Event thrown on an [[Actor]] when the graphics bounds completely leaves the screen.
 */ class ExitViewPortEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    /**
 * Event thrown on an [[Actor]] when any part of the graphics bounds are on screen.
 */ class EnterViewPortEvent extends GameEvent {
        constructor(target){
            super();
            this.target = target;
        }
    }
    class EnterTriggerEvent extends GameEvent {
        constructor(target, actor){
            super();
            this.target = target;
            this.actor = actor;
        }
    }
    class ExitTriggerEvent extends GameEvent {
        constructor(target, actor){
            super();
            this.target = target;
            this.actor = actor;
        }
    }
    /**
 * Event thrown on an [[Actor]] when an action starts.
 */ class ActionStartEvent extends GameEvent {
        constructor(action, target){
            super();
            this.action = action;
            this.target = target;
        }
    }
    /**
 * Event thrown on an [[Actor]] when an action completes.
 */ class ActionCompleteEvent extends GameEvent {
        constructor(action, target){
            super();
            this.action = action;
            this.target = target;
        }
    }
    class MediaEvent extends GameEvent {
        /**
     * Media event cannot bubble
     */ set bubbles(_value) {
        // stubbed
        }
        /**
     * Media event cannot bubble
     */ get bubbles() {
            return false;
        }
        /**
     * Media event cannot bubble, so they have no path
     */ get _path() {
            return null;
        }
        /**
     * Media event cannot bubble, so they have no path
     */ set _path(_val) {
        // stubbed
        }
        constructor(target, _name = "MediaEvent"){
            super();
            this.target = target;
            this._name = _name;
        }
        /**
     * Prevents event from bubbling
     */ stopPropagation() {
        /**
         * Stub
         */ }
        /**
     * Action, that calls when event happens
     */ action() {
        /**
         * Stub
         */ }
        /**
     * Propagate event further through event path
     */ propagate() {
        /**
         * Stub
         */ }
        layPath(_actor) {
        /**
         * Stub
         */ }
    }
    class NativeSoundEvent extends MediaEvent {
        constructor(target, track){
            super(target, "NativeSoundEvent");
            this.track = track;
        }
    }
    class NativeSoundProcessedEvent extends MediaEvent {
        constructor(target, _processedData){
            super(target, "NativeSoundProcessedEvent");
            this._processedData = _processedData;
            this.data = this._processedData;
        }
    }
    /**
 * Whether or not the browser can play this file as HTML5 Audio
 */ function canPlayFile(file) {
        try {
            const a = new Audio();
            const filetype = /.*\.([A-Za-z0-9]+)(?:(?:\?|\#).*)*$/;
            const type = file.match(filetype)[1];
            if (a.canPlayType("audio/" + type)) return true;
            else return false;
        } catch (e) {
            Logger.getInstance().warn("Cannot determine audio support, assuming no support for the Audio Tag", e);
            return false;
        }
    }
    const SoundEvents = {
        VolumeChange: "volumechange",
        Processed: "processed",
        Pause: "pause",
        Stop: "stop",
        PlaybackEnd: "playbackend",
        Resume: "resume",
        PlaybackStart: "playbackstart"
    };
    /**
 * The [[Sound]] object allows games built in Excalibur to load audio
 * components, from soundtracks to sound effects. [[Sound]] is an [[Loadable]]
 * which means it can be passed to a [[Loader]] to pre-load before a game or level.
 */ class Sound {
        /**
     * Indicates whether the clip should loop when complete
     * @param value  Set the looping flag
     */ set loop(value) {
            this._loop = value;
            for (const track of this._tracks)track.loop = this._loop;
            this.logger.debug("Set loop for all instances of sound", this.path, "to", this._loop);
        }
        get loop() {
            return this._loop;
        }
        set volume(value) {
            this._volume = value;
            for (const track of this._tracks)track.volume = this._volume;
            this.events.emit("volumechange", new NativeSoundEvent(this));
            this.logger.debug("Set loop for all instances of sound", this.path, "to", this._volume);
        }
        get volume() {
            return this._volume;
        }
        /**
     * Get the duration that this audio should play. If unset the total natural playback duration will be used.
     */ get duration() {
            return this._duration;
        }
        /**
     * Set the duration that this audio should play. If unset the total natural playback duration will be used.
     *
     * Note: if you seek to a specific point the duration will start from that point, for example
     *
     * If you have a 10 second clip, seek to 5 seconds, then set the duration to 2, it will play the clip from 5-7 seconds.
     */ set duration(duration) {
            this._duration = duration;
        }
        /**
     * Return array of Current AudioInstances playing or being paused
     */ get instances() {
            return this._tracks;
        }
        get path() {
            return this._resource.path;
        }
        set path(val) {
            this._resource.path = val;
        }
        /**
     * Should excalibur add a cache busting querystring? By default false.
     * Must be set before loading
     */ get bustCache() {
            return this._resource.bustCache;
        }
        set bustCache(val) {
            this._resource.bustCache = val;
        }
        /**
     * @param paths A list of audio sources (clip.wav, clip.mp3, clip.ogg) for this audio clip. This is done for browser compatibility.
     */ constructor(...paths){
            this.events = new EventEmitter();
            this.logger = Logger.getInstance();
            this._loop = false;
            this._volume = 1;
            this._isStopped = false;
            // private _isPaused = false;
            this._tracks = [];
            this._wasPlayingOnHidden = false;
            this._playbackRate = 1.0;
            this._audioContext = AudioContextFactory.create();
            this._resource = new Resource("", ExResponse.type.arraybuffer);
            /**
         * Chrome : MP3, WAV, Ogg
         * Firefox : WAV, Ogg,
         * IE : MP3, WAV coming soon
         * Safari MP3, WAV, Ogg
         */ for (const path of paths)if (canPlayFile(path)) {
                this.path = path;
                break;
            }
            if (!this.path) {
                this.logger.warn("This browser does not support any of the audio files specified:", paths.join(", "));
                this.logger.warn("Attempting to use", paths[0]);
                this.path = paths[0]; // select the first specified
            }
        }
        isLoaded() {
            return !!this.data;
        }
        async load() {
            var _a, _b;
            if (this.data) return this.data;
            const arraybuffer = await this._resource.load();
            const audiobuffer = await this.decodeAudio(arraybuffer.slice(0));
            this._duration = (_b = (_a = this._duration) !== null && _a !== void 0 ? _a : audiobuffer === null || audiobuffer === void 0 ? void 0 : audiobuffer.duration) !== null && _b !== void 0 ? _b : undefined;
            this.events.emit("processed", new NativeSoundProcessedEvent(this, audiobuffer));
            return this.data = audiobuffer;
        }
        async decodeAudio(data) {
            try {
                return await this._audioContext.decodeAudioData(data.slice(0));
            } catch (e) {
                this.logger.error("Unable to decode  this browser may not fully support this format, or the file may be corrupt, if this is an mp3 try removing id3 tags and album art from the file.");
                return await Promise.reject();
            }
        }
        wireEngine(engine) {
            if (engine) {
                this._engine = engine;
                this._engine.on("hidden", ()=>{
                    if (engine.pauseAudioWhenHidden && this.isPlaying()) {
                        this._wasPlayingOnHidden = true;
                        this.pause();
                    }
                });
                this._engine.on("visible", ()=>{
                    if (engine.pauseAudioWhenHidden && this._wasPlayingOnHidden) {
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        this.play();
                        this._wasPlayingOnHidden = false;
                    }
                });
                this._engine.on("start", ()=>{
                    this._isStopped = false;
                });
                this._engine.on("stop", ()=>{
                    this.stop();
                    this._isStopped = true;
                });
            }
        }
        /**
     * Returns how many instances of the sound are currently playing
     */ instanceCount() {
            return this._tracks.length;
        }
        /**
     * Whether or not the sound is playing right now
     */ isPlaying() {
            return this._tracks.some((t)=>t.isPlaying());
        }
        isPaused() {
            return this._tracks.some((t)=>t.isPaused());
        }
        isStopped() {
            return this._tracks.some((t)=>t.isStopped());
        }
        /**
     * Play the sound, returns a promise that resolves when the sound is done playing
     * An optional volume argument can be passed in to play the sound. Max volume is 1.0
     */ play(volume) {
            if (!this.isLoaded()) {
                this.logger.warn("Cannot start playing. Resource", this.path, "is not loaded yet");
                return Promise.resolve(true);
            }
            if (this._isStopped) {
                this.logger.warn("Cannot start playing. Engine is in a stopped state.");
                return Promise.resolve(false);
            }
            this.volume = volume || this.volume;
            if (this.isPaused()) return this._resumePlayback();
            else return this._startPlayback();
        }
        /**
     * Stop the sound, and do not rewind
     */ pause() {
            if (!this.isPlaying()) return;
            for (const track of this._tracks)track.pause();
            this.events.emit("pause", new NativeSoundEvent(this));
            this.logger.debug("Paused all instances of sound", this.path);
        }
        /**
     * Stop the sound if it is currently playing and rewind the track. If the sound is not playing, rewinds the track.
     */ stop() {
            for (const track of this._tracks)track.stop();
            this.events.emit("stop", new NativeSoundEvent(this));
            this._tracks.length = 0;
            this.logger.debug("Stopped all instances of sound", this.path);
        }
        get playbackRate() {
            return this._playbackRate;
        }
        set playbackRate(playbackRate) {
            this._playbackRate = playbackRate;
            this._tracks.forEach((t)=>{
                t.playbackRate = this._playbackRate;
            });
        }
        seek(position, trackId = 0) {
            if (this._tracks.length === 0) this._getTrackInstance(this.data);
            this._tracks[trackId].seek(position);
        }
        getTotalPlaybackDuration() {
            if (!this.isLoaded()) {
                this.logger.warnOnce(`Sound from ${this.path} is not loaded, cannot return total playback duration.` + `Did you forget to add Sound to a loader? https://excaliburjs.com/docs/loaders/`);
                return 0;
            }
            return this.data.duration;
        }
        /**
     * Return the current playback time of the playing track in seconds from the start.
     *
     * Optionally specify the track to query if multiple are playing at once.
     * @param trackId
     */ getPlaybackPosition(trackId = 0) {
            if (this._tracks.length) return this._tracks[trackId].getPlaybackPosition();
            return 0;
        }
        /**
     * Get Id of provided AudioInstance in current trackList
     * @param track [[Audio]] which Id is to be given
     */ getTrackId(track) {
            return this._tracks.indexOf(track);
        }
        async _resumePlayback() {
            if (this.isPaused) {
                const resumed = [];
                // ensure we resume *current* tracks (if paused)
                for (const track of this._tracks)resumed.push(track.play().then(()=>{
                    this._tracks.splice(this.getTrackId(track), 1);
                    return true;
                }));
                this.events.emit("resume", new NativeSoundEvent(this));
                this.logger.debug("Resuming paused instances for sound", this.path, this._tracks);
                // resolve when resumed tracks are done
                await Promise.all(resumed);
            }
            return true;
        }
        /**
     * Starts playback, returns a promise that resolves when playback is complete
     */ async _startPlayback() {
            const track = this._getTrackInstance(this.data);
            const complete = await track.play(()=>{
                this.events.emit("playbackstart", new NativeSoundEvent(this, track));
                this.logger.debug("Playing new instance for sound", this.path);
            });
            this.events.emit("playbackend", new NativeSoundEvent(this, track));
            // cleanup any done tracks
            const trackId = this.getTrackId(track);
            if (trackId !== -1) this._tracks.splice(trackId, 1);
            return complete;
        }
        _getTrackInstance(data) {
            const newTrack = new WebAudioInstance(data);
            newTrack.loop = this.loop;
            newTrack.volume = this.volume;
            newTrack.duration = this.duration;
            newTrack.playbackRate = this._playbackRate;
            this._tracks.push(newTrack);
            return newTrack;
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
    }
    const LoaderEvents = {
        // Add event types here
        BeforeLoad: "beforeload",
        AfterLoad: "afterload",
        UserAction: "useraction",
        LoadResourceStart: "loadresourcestart",
        LoadResourceEnd: "loadresourceend"
    };
    /**
 * Returns true if the constructor is for an Excalibur Loader
 */ function isLoaderConstructor(x) {
        var _a, _b;
        return !!(x === null || x === void 0 ? void 0 : x.prototype) && !!((_b = (_a = x === null || x === void 0 ? void 0 : x.prototype) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name);
    }
    class DefaultLoader {
        get resources() {
            return this._resources;
        }
        /**
     * @param options Optionally provide the list of resources you want to load at constructor time
     */ constructor(options){
            var _a;
            this.events = new EventEmitter();
            this.canvas = new Canvas({
                filtering: ImageFiltering.Blended,
                smoothing: true,
                cache: false,
                draw: this.onDraw.bind(this)
            });
            this._resources = [];
            this._numLoaded = 0;
            this._totalTimeMs = 0;
            this._loadingFuture = new Future();
            if (options && ((_a = options.loadables) === null || _a === void 0 ? void 0 : _a.length)) this.addResources(options.loadables);
        }
        /**
     * Called by the engine before loading
     * @param engine
     */ onInitialize(engine) {
            this.engine = engine;
            this.canvas.width = this.engine.screen.resolution.width;
            this.canvas.height = this.engine.screen.resolution.height;
        }
        /**
     * Return a promise that resolves when the user interacts with the loading screen in some way, usually a click.
     *
     * It's important to implement this in order to unlock the audio context in the browser. Browsers automatically prevent
     * audio from playing until the user performs an action.
     *
     */ async onUserAction() {
            return await Promise.resolve();
        }
        /**
     * Overridable lifecycle method, called directly before loading starts
     */ async onBeforeLoad() {
        // override me
        }
        /**
     * Overridable lifecycle method, called after loading has completed
     */ async onAfterLoad() {
            // override me
            await delay(500, this.engine.clock); // avoid a flicker
        }
        /**
     * Add a resource to the loader to load
     * @param loadable  Resource to add
     */ addResource(loadable) {
            this._resources.push(loadable);
        }
        /**
     * Add a list of resources to the loader to load
     * @param loadables  The list of resources to load
     */ addResources(loadables) {
            let i = 0;
            const len = loadables.length;
            for(i; i < len; i++)this.addResource(loadables[i]);
        }
        markResourceComplete() {
            this._numLoaded++;
        }
        /**
     * Returns the progress of the loader as a number between [0, 1] inclusive.
     */ get progress() {
            const total = this._resources.length;
            return total > 0 ? clamp(this._numLoaded, 0, total) / total : 1;
        }
        /**
     * Returns true if the loader has completely loaded all resources
     */ isLoaded() {
            return this._numLoaded === this._resources.length;
        }
        /**
     * Optionally override the onUpdate
     * @param engine
     * @param elapsedMilliseconds
     */ onUpdate(engine, elapsedMilliseconds) {
            this._totalTimeMs += elapsedMilliseconds;
        // override me
        }
        /**
     * Optionally override the onDraw
     */ onDraw(ctx) {
            const seconds = this._totalTimeMs / 1000;
            ctx.fillStyle = Color.Black.toRGBA();
            ctx.fillRect(0, 0, this.engine.screen.resolution.width, this.engine.screen.resolution.height);
            ctx.save();
            ctx.translate(this.engine.screen.resolution.width / 2, this.engine.screen.resolution.height / 2);
            const speed = seconds * 10;
            ctx.strokeStyle = "white";
            ctx.lineWidth = 10;
            ctx.lineCap = "round";
            ctx.arc(0, 0, 40, speed, speed + Math.PI * 3 / 2);
            ctx.stroke();
            ctx.fillStyle = "white";
            ctx.font = "16px sans-serif";
            const text = (this.progress * 100).toFixed(0) + "%";
            const textbox = ctx.measureText(text);
            const width = Math.abs(textbox.actualBoundingBoxLeft) + Math.abs(textbox.actualBoundingBoxRight);
            const height = Math.abs(textbox.actualBoundingBoxAscent) + Math.abs(textbox.actualBoundingBoxDescent);
            ctx.fillText(text, -width / 2, height / 2); // center
            ctx.restore();
        }
        areResourcesLoaded() {
            return this._loadingFuture.promise;
        }
        /**
     * Not meant to be overridden
     *
     * Begin loading all of the supplied resources, returning a promise
     * that resolves when loading of all is complete AND the user has interacted with the loading screen
     */ async load() {
            await this.onBeforeLoad();
            this.events.emit("beforeload");
            this.canvas.flagDirty();
            await Promise.all(this._resources.map(async (r)=>{
                this.events.emit("loadresourcestart", r);
                await r.load().finally(()=>{
                    // capture progress
                    this._numLoaded++;
                    this.canvas.flagDirty();
                    this.events.emit("loadresourceend", r);
                });
            }));
            // Wire all sound to the engine
            for (const resource of this._resources)if (resource instanceof Sound) resource.wireEngine(this.engine);
            this._loadingFuture.resolve();
            this.canvas.flagDirty();
            // Unlock browser AudioContext in after user gesture
            // See: https://github.com/excaliburjs/Excalibur/issues/262
            // See: https://github.com/excaliburjs/Excalibur/issues/1031
            await this.onUserAction();
            this.events.emit("useraction");
            await WebAudio.unlock();
            await this.onAfterLoad();
            this.events.emit("afterload");
            return this.data = this._resources;
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
    }
    /* istanbul ignore next */ /**
 * Draw a line on canvas context
 * @param ctx The canvas context
 * @param color The color of the line
 * @param x1 The start x coordinate
 * @param y1 The start y coordinate
 * @param x2 The ending x coordinate
 * @param y2 The ending y coordinate
 * @param thickness The line thickness
 * @param cap The [[LineCapStyle]] (butt, round, or square)
 */ function line(ctx, color = Color.Red, x1, y1, x2, y2, thickness = 1, cap = "butt") {
        ctx.save();
        ctx.beginPath();
        ctx.lineWidth = thickness;
        ctx.lineCap = cap;
        ctx.strokeStyle = color.toString();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }
    /* istanbul ignore next */ /**
 * Draw the vector as a point onto the canvas.
 */ function point(ctx, color = Color.Red, point) {
        ctx.beginPath();
        ctx.strokeStyle = color.toString();
        ctx.arc(point.x, point.y, 5, 0, Math.PI * 2);
        ctx.closePath();
        ctx.stroke();
    }
    /**
 * Draw the vector as a line onto the canvas starting a origin point.
 */ /* istanbul ignore next */ /**
 *
 */ function vector(ctx, color, origin, vector, scale = 1.0) {
        const c = color ? color.toString() : "blue";
        const v = vector.scale(scale);
        ctx.beginPath();
        ctx.strokeStyle = c;
        ctx.moveTo(origin.x, origin.y);
        ctx.lineTo(origin.x + v.x, origin.y + v.y);
        ctx.closePath();
        ctx.stroke();
    }
    /**
 * Draw a round rectangle on a canvas context
 * @param ctx The canvas context
 * @param x The top-left x coordinate
 * @param y The top-left y coordinate
 * @param width The width of the rectangle
 * @param height The height of the rectangle
 * @param radius The border radius of the rectangle
 * @param stroke The [[Color]] to stroke rectangle with
 * @param fill The [[Color]] to fill rectangle with
 */ function roundRect(ctx, x, y, width, height, radius = 5, stroke = Color.White, fill = null) {
        let br;
        if (typeof radius === "number") br = {
            tl: radius,
            tr: radius,
            br: radius,
            bl: radius
        };
        else {
            const defaultRadius = {
                tl: 0,
                tr: 0,
                br: 0,
                bl: 0
            };
            for(const prop in defaultRadius)if (defaultRadius.hasOwnProperty(prop)) {
                const side = prop;
                br[side] = radius[side] || defaultRadius[side];
            }
        }
        ctx.beginPath();
        ctx.moveTo(x + br.tl, y);
        ctx.lineTo(x + width - br.tr, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + br.tr);
        ctx.lineTo(x + width, y + height - br.br);
        ctx.quadraticCurveTo(x + width, y + height, x + width - br.br, y + height);
        ctx.lineTo(x + br.bl, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - br.bl);
        ctx.lineTo(x, y + br.tl);
        ctx.quadraticCurveTo(x, y, x + br.tl, y);
        ctx.closePath();
        if (fill) {
            ctx.fillStyle = fill.toString();
            ctx.fill();
        }
        if (stroke) {
            ctx.strokeStyle = stroke.toString();
            ctx.stroke();
        }
    }
    /**
 *
 */ function circle(ctx, x, y, radius, stroke = Color.White, fill = null) {
        ctx.beginPath();
        ctx.arc(x, y, radius, 0, Math.PI * 2);
        ctx.closePath();
        if (fill) {
            ctx.fillStyle = fill.toString();
            ctx.fill();
        }
        if (stroke) {
            ctx.strokeStyle = stroke.toString();
            ctx.stroke();
        }
    }
    /* harmony default export */ const Loader_logo = "data:image/png;base64,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";
    // EXTERNAL MODULE: ./Director/Loader.css
    var Director_Loader = $2c23f148d58cd887$var$__webpack_require__(8851);
    /**
 * Pre-loading assets
 *
 * The loader provides a mechanism to preload multiple resources at
 * one time. The loader must be passed to the engine in order to
 * trigger the loading progress bar.
 *
 * The [[Loader]] itself implements [[Loadable]] so you can load loaders.
 *
 * ## Example: Pre-loading resources for a game
 *
 * ```js
 * // create a loader
 * var loader = new ex.Loader();
 *
 * // create a resource dictionary (best practice is to keep a separate file)
 * var resources = {
 *   TextureGround: new ex.Texture("/images/textures/ground.png"),
 *   SoundDeath: new ex.Sound("/sound/death.wav", "/sound/death.mp3")
 * };
 *
 * // loop through dictionary and add to loader
 * for (var loadable in resources) {
 *   if (resources.hasOwnProperty(loadable)) {
 *     loader.addResource(resources[loadable]);
 *   }
 * }
 *
 * // start game
 * game.start(loader).then(function () {
 *   console.log("Game started!");
 * });
 * ```
 *
 * ## Customize the Loader
 *
 * The loader can be customized to show different, text, logo, background color, and button.
 *
 * ```typescript
 * const loader = new ex.Loader([playerTexture]);
 *
 * // The loaders button text can simply modified using this
 * loader.playButtonText = 'Start the best game ever';
 *
 * // The logo can be changed by inserting a base64 image string here
 *
 * loader.logo = 'data:image/png;base64,iVBORw...';
 * loader.logoWidth = 15;
 * loader.logoHeight = 14;
 *
 * // The background color can be changed like so by supplying a valid CSS color string
 *
 * loader.backgroundColor = 'red'
 * loader.backgroundColor = '#176BAA'
 *
 * // To build a completely new button
 * loader.startButtonFactory = () => {
 *     let myButton = document.createElement('button');
 *     myButton.textContent = 'The best button';
 *     return myButton;
 * };
 *
 * engine.start(loader).then(() => {});
 * ```
 */ class Loader extends DefaultLoader {
        get _image() {
            if (!this._imageElement) {
                this._imageElement = new Image();
                this._imageElement.onload = ()=>this._imageLoaded.resolve();
                this._imageElement.src = this.logo;
            }
            return this._imageElement;
        }
        get playButtonRootElement() {
            return this._playButtonRootElement;
        }
        get playButtonElement() {
            return this._playButtonElement;
        }
        get _playButton() {
            const existingRoot = document.getElementById("excalibur-play-root");
            if (existingRoot) this._playButtonRootElement = existingRoot;
            if (!this._playButtonRootElement) {
                this._playButtonRootElement = document.createElement("div");
                this._playButtonRootElement.id = "excalibur-play-root";
                this._playButtonRootElement.style.position = "absolute";
                document.body.appendChild(this._playButtonRootElement);
            }
            if (!this._styleBlock) {
                this._styleBlock = document.createElement("style");
                this._styleBlock.textContent = this._playButtonStyles;
                document.head.appendChild(this._styleBlock);
            }
            if (!this._playButtonElement) {
                this._playButtonElement = this.startButtonFactory();
                this._playButtonRootElement.appendChild(this._playButtonElement);
            }
            return this._playButtonElement;
        }
        constructor(loadablesOrOptions){
            const options = Array.isArray(loadablesOrOptions) ? {
                loadables: loadablesOrOptions
            } : loadablesOrOptions;
            super(options);
            this._logger = Logger.getInstance();
            this._originalOptions = {
                loadables: []
            };
            this.events = new EventEmitter();
            this._playButtonShown = false;
            // logo drawing stuff
            // base64 string encoding of the excalibur logo (logo-white.png)
            this.logo = Loader_logo;
            this.logoWidth = 468;
            this.logoHeight = 118;
            /**
         * Gets or sets the color of the loading bar, default is [[Color.White]]
         */ this.loadingBarColor = Color.White;
            /**
         * Gets or sets the background color of the loader as a hex string
         */ this.backgroundColor = "#176BAA";
            this._imageLoaded = new Future();
            this.suppressPlayButton = false;
            /** Loads the css from Loader.css */ this._playButtonStyles = Director_Loader /* default */ .A.toString();
            /**
         * Get/set play button text
         */ this.playButtonText = "Play game";
            /**
         * Return a html button element for excalibur to use as a play button
         */ this.startButtonFactory = ()=>{
                let buttonElement = document.getElementById("excalibur-play");
                if (!buttonElement) buttonElement = document.createElement("button");
                buttonElement.id = "excalibur-play";
                buttonElement.textContent = this.playButtonText;
                buttonElement.style.display = "none";
                return buttonElement;
            };
            this._configuredPixelRatio = null;
            this._originalOptions = {
                ...Loader._DEFAULT_LOADER_OPTIONS,
                ...options
            };
        }
        onInitialize(engine) {
            this.engine = engine;
            this.screen = engine.screen;
            this.canvas.width = this.engine.canvas.width;
            this.canvas.height = this.engine.canvas.height;
            this.screen.events.on("resize", ()=>{
                this.canvas.width = this.engine.canvas.width;
                this.canvas.height = this.engine.canvas.height;
            });
        }
        /**
     * Shows the play button and returns a promise that resolves when clicked
     */ async showPlayButton() {
            var _a, _b;
            if (this.suppressPlayButton) {
                this.hidePlayButton();
                // Delay is to give the logo a chance to show, otherwise don't delay
                await delay(500, (_a = this.engine) === null || _a === void 0 ? void 0 : _a.clock);
            } else {
                const resizeHandler = ()=>{
                    try {
                        this._positionPlayButton();
                    } catch (_a) {
                    // swallow if can't position
                    }
                };
                if ((_b = this.engine) === null || _b === void 0 ? void 0 : _b.browser) this.engine.browser.window.on("resize", resizeHandler);
                this._playButtonShown = true;
                this._playButton.style.display = "block";
                document.body.addEventListener("keyup", (evt)=>{
                    if (evt.key === "Enter") this._playButton.click();
                });
                this._positionPlayButton();
                const playButtonClicked = new Promise((resolve)=>{
                    const startButtonHandler = (e)=>{
                        var _a;
                        // We want to stop propagation to keep bubbling to the engine pointer handlers
                        e.stopPropagation();
                        // Hide Button after click
                        this.hidePlayButton();
                        if ((_a = this.engine) === null || _a === void 0 ? void 0 : _a.browser) this.engine.browser.window.off("resize", resizeHandler);
                        if (this._originalOptions.fullscreenAfterLoad) try {
                            this._logger.info("requesting fullscreen");
                            if (this._originalOptions.fullscreenContainer instanceof HTMLElement) this._originalOptions.fullscreenContainer.requestFullscreen();
                            else this.engine.screen.goFullScreen(this._originalOptions.fullscreenContainer);
                        } catch (error) {
                            this._logger.error("could not go fullscreen", error);
                        }
                        resolve();
                    };
                    this._playButton.addEventListener("click", startButtonHandler);
                    this._playButton.addEventListener("touchend", startButtonHandler);
                    this._playButton.addEventListener("pointerup", startButtonHandler);
                });
                return await playButtonClicked;
            }
        }
        hidePlayButton() {
            this._playButtonShown = false;
            this._playButton.style.display = "none";
        }
        /**
     * Clean up generated elements for the loader
     */ dispose() {
            if (this._playButtonRootElement.parentElement) {
                this._playButtonRootElement.removeChild(this._playButtonElement);
                document.body.removeChild(this._playButtonRootElement);
                document.head.removeChild(this._styleBlock);
                this._playButtonRootElement = null;
                this._playButtonElement = null;
                this._styleBlock = null;
            }
        }
        async onUserAction() {
            var _a;
            // short delay in showing the button for aesthetics
            await delay(200, (_a = this.engine) === null || _a === void 0 ? void 0 : _a.clock);
            this.canvas.flagDirty();
            // show play button
            await this.showPlayButton();
        }
        async onBeforeLoad() {
            const image = this._image;
            await this._imageLoaded.promise;
            await (image === null || image === void 0 ? void 0 : image.decode()); // decode logo if it exists
        }
        // eslint-disable-next-line require-await
        async onAfterLoad() {
            this.screen.pixelRatioOverride = this._configuredPixelRatio;
            this.screen.popResolutionAndViewport();
            this.screen.applyResolutionAndViewport();
            this.dispose();
        }
        _positionPlayButton() {
            if (this.engine) {
                const { x: left, y: top, width: screenWidth, height: screenHeight } = this.engine.canvas.getBoundingClientRect();
                if (this._playButtonRootElement) {
                    const buttonWidth = this._playButton.clientWidth;
                    const buttonHeight = this._playButton.clientHeight;
                    if (this.playButtonPosition) {
                        this._playButtonRootElement.style.left = `${this.playButtonPosition.x}px`;
                        this._playButtonRootElement.style.top = `${this.playButtonPosition.y}px`;
                    } else {
                        this._playButtonRootElement.style.left = `${left + screenWidth / 2 - buttonWidth / 2}px`;
                        this._playButtonRootElement.style.top = `${top + screenHeight / 2 - buttonHeight / 2 + 100}px`;
                    }
                }
            }
        }
        /**
     * Loader draw function. Draws the default Excalibur loading screen.
     * Override `logo`, `logoWidth`, `logoHeight` and `backgroundColor` properties
     * to customize the drawing, or just override entire method.
     */ onDraw(ctx) {
            const canvasHeight = this.engine.canvasHeight / this.engine.pixelRatio;
            const canvasWidth = this.engine.canvasWidth / this.engine.pixelRatio;
            this._positionPlayButton();
            ctx.fillStyle = this.backgroundColor;
            ctx.fillRect(0, 0, canvasWidth, canvasHeight);
            let logoY = canvasHeight / 2;
            const width = Math.min(this.logoWidth, canvasWidth * 0.75);
            let logoX = canvasWidth / 2 - width / 2;
            if (this.logoPosition) {
                logoX = this.logoPosition.x;
                logoY = this.logoPosition.y;
            }
            const imageHeight = Math.floor(width * (this.logoHeight / this.logoWidth)); // OG height/width factor
            const oldAntialias = this.engine.getAntialiasing();
            this.engine.setAntialiasing(true);
            if (!this.logoPosition) ctx.drawImage(this._image, 0, 0, this.logoWidth, this.logoHeight, logoX, logoY - imageHeight - 20, width, imageHeight);
            else ctx.drawImage(this._image, 0, 0, this.logoWidth, this.logoHeight, logoX, logoY, width, imageHeight);
            // loading box
            if (!this.suppressPlayButton && this._playButtonShown) {
                this.engine.setAntialiasing(oldAntialias);
                return;
            }
            let loadingX = logoX;
            let loadingY = logoY;
            if (this.loadingBarPosition) {
                loadingX = this.loadingBarPosition.x;
                loadingY = this.loadingBarPosition.y;
            }
            ctx.lineWidth = 2;
            roundRect(ctx, loadingX, loadingY, width, 20, 10, this.loadingBarColor);
            const progress = width * this.progress;
            const margin = 5;
            const progressWidth = progress - margin * 2;
            const height = 20 - margin * 2;
            roundRect(ctx, loadingX + margin, loadingY + margin, progressWidth > 10 ? progressWidth : 10, height, 5, null, this.loadingBarColor);
            this.engine.setAntialiasing(oldAntialias);
        }
    }
    Loader._DEFAULT_LOADER_OPTIONS = {
        loadables: [],
        fullscreenAfterLoad: false,
        fullscreenContainer: undefined
    };
    /**
 * This is the list of features that will be used to log the supported
 * features to the console when Detector.logBrowserFeatures() is called.
 */ const REPORTED_FEATURES = {
        webgl: "WebGL",
        webaudio: "WebAudio",
        gamepadapi: "Gamepad API"
    };
    /**
 * Excalibur internal feature detection helper class
 */ class Detector {
        constructor(){
            this._features = null;
            this.failedTests = [];
            // critical browser features required for ex to run
            this._criticalTests = {
                // Test canvas/2d context support
                canvasSupport: function() {
                    const elem = document.createElement("canvas");
                    return !!(elem.getContext && elem.getContext("2d"));
                },
                // Test array buffer support ex uses for downloading binary data
                arrayBufferSupport: function() {
                    const xhr = new XMLHttpRequest();
                    xhr.open("GET", "/");
                    try {
                        xhr.responseType = "arraybuffer";
                    } catch (e) {
                        return false;
                    }
                    return xhr.responseType === "arraybuffer";
                },
                // Test data urls ex uses for sprites
                dataUrlSupport: function() {
                    const canvas = document.createElement("canvas");
                    return canvas.toDataURL("image/png").indexOf("data:image/png") === 0;
                },
                // Test object url support for loading
                objectUrlSupport: function() {
                    return "URL" in window && "revokeObjectURL" in URL && "createObjectURL" in URL;
                },
                // RGBA support for colors
                rgbaSupport: function() {
                    const style = document.createElement("a").style;
                    style.cssText = "background-color:rgba(150,255,150,.5)";
                    return ("" + style.backgroundColor).indexOf("rgba") > -1;
                }
            };
            // warnings excalibur performance will be degraded
            this._warningTest = {
                webAudioSupport: function() {
                    return !!(window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.msAudioContext || window.oAudioContext);
                },
                webglSupport: function() {
                    const elem = document.createElement("canvas");
                    return !!(elem.getContext && elem.getContext("webgl"));
                }
            };
            this._features = this._loadBrowserFeatures();
        }
        /**
     * Returns a map of currently supported browser features. This method
     * treats the features as a singleton and will only calculate feature
     * support if it has not previously been done.
     */ getBrowserFeatures() {
            if (this._features === null) this._features = this._loadBrowserFeatures();
            return this._features;
        }
        /**
     * Report on non-critical browser support for debugging purposes.
     * Use native browser console colors for visibility.
     */ logBrowserFeatures() {
            let msg = "%cSUPPORTED BROWSER FEATURES\n==========================%c\n";
            const args = [
                "font-weight: bold; color: navy",
                "font-weight: normal; color: inherit"
            ];
            const supported = this.getBrowserFeatures();
            for (const feature of Object.keys(REPORTED_FEATURES)){
                if (supported[feature]) {
                    msg += "(%c\u2713%c)"; // (✓)
                    args.push("font-weight: bold; color: green");
                    args.push("font-weight: normal; color: inherit");
                } else {
                    msg += "(%c\u2717%c)"; // (✗)
                    args.push("font-weight: bold; color: red");
                    args.push("font-weight: normal; color: inherit");
                }
                msg += " " + REPORTED_FEATURES[feature] + "\n";
            }
            args.unshift(msg);
            // eslint-disable-next-line no-console
            console.log.apply(console, args);
        }
        /**
     * Executes several IIFE's to get a constant reference to supported
     * features within the current execution context.
     */ _loadBrowserFeatures() {
            return {
                // IIFE to check canvas support
                canvas: (()=>{
                    return this._criticalTests.canvasSupport();
                })(),
                // IIFE to check arraybuffer support
                arraybuffer: (()=>{
                    return this._criticalTests.arrayBufferSupport();
                })(),
                // IIFE to check dataurl support
                dataurl: (()=>{
                    return this._criticalTests.dataUrlSupport();
                })(),
                // IIFE to check objecturl support
                objecturl: (()=>{
                    return this._criticalTests.objectUrlSupport();
                })(),
                // IIFE to check rgba support
                rgba: (()=>{
                    return this._criticalTests.rgbaSupport();
                })(),
                // IIFE to check webaudio support
                webaudio: (()=>{
                    return this._warningTest.webAudioSupport();
                })(),
                // IIFE to check webgl support
                webgl: (()=>{
                    return this._warningTest.webglSupport();
                })(),
                // IIFE to check gamepadapi support
                gamepadapi: (()=>{
                    return !!navigator.getGamepads;
                })()
            };
        }
        test() {
            // Critical test will for ex not to run
            let failedCritical = false;
            for(const test in this._criticalTests)if (!this._criticalTests[test].call(this)) {
                this.failedTests.push(test);
                Logger.getInstance().error("Critical browser feature missing, Excalibur requires:", test);
                failedCritical = true;
            }
            if (failedCritical) return false;
            // Warning tests do not for ex to return false to compatibility
            for(const warning in this._warningTest)if (!this._warningTest[warning]()) Logger.getInstance().warn("Warning browser feature missing, Excalibur will have reduced performance:", warning);
            return true;
        }
    }
    /**
 * An enum that describes the types of collisions bodies can participate in
 */ var CollisionType;
    (function(CollisionType) {
        /**
     * Bodies with the `PreventCollision` setting do not participate in any
     * collisions and do not raise collision events.
     */ CollisionType["PreventCollision"] = "PreventCollision";
        /**
     * Bodies with the `Passive` setting only raise collision events, but are not
     * influenced or moved by other bodies and do not influence or move other bodies.
     * This is useful for use in trigger type behavior.
     */ CollisionType["Passive"] = "Passive";
        /**
     * Bodies with the `Active` setting raise collision events and participate
     * in collisions with other bodies and will be push or moved by bodies sharing
     * the `Active` or `Fixed` setting.
     */ CollisionType["Active"] = "Active";
        /**
     * Bodies with the `Fixed` setting raise collision events and participate in
     * collisions with other bodies. Actors with the `Fixed` setting will not be
     * pushed or moved by other bodies sharing the `Fixed`. Think of Fixed
     * bodies as "immovable/unstoppable" objects. If two `Fixed` bodies meet they will
     * not be pushed or moved by each other, they will not interact except to throw
     * collision events.
     */ CollisionType["Fixed"] = "Fixed";
    })(CollisionType || (CollisionType = {}));
    /**
 * Enum representing the coordinate plane for the position 2D vector in the [[TransformComponent]]
 */ var CoordPlane;
    (function(CoordPlane) {
        /**
     * The world coordinate plane (default) represents world space, any entities drawn with world
     * space move when the camera moves.
     */ CoordPlane["World"] = "world";
        /**
     * The screen coordinate plane represents screen space, entities drawn in screen space are pinned
     * to screen coordinates ignoring the camera.
     */ CoordPlane["Screen"] = "screen";
    })(CoordPlane || (CoordPlane = {}));
    class VectorView extends Vector {
        constructor(options){
            super(0, 0);
            this._getX = options.getX;
            this._getY = options.getY;
            this._setX = options.setX;
            this._setY = options.setY;
        }
        get x() {
            return this._x = this._getX();
        }
        set x(val) {
            this._setX(val);
            this._x = val;
        }
        get y() {
            return this._y = this._getY();
        }
        set y(val) {
            this._setY(val);
            this._y = val;
        }
    }
    /**
 * Wraps a vector and watches for changes in the x/y, modifies the original vector.
 */ class WatchVector extends Vector {
        constructor(original, change){
            super(original.x, original.y);
            this.original = original;
            this.change = change;
        }
        get x() {
            return this._x = this.original.x;
        }
        set x(newX) {
            this.change(newX, this._y);
            this._x = this.original.x = newX;
        }
        get y() {
            return this._y = this.original.y;
        }
        set y(newY) {
            this.change(this._x, newY);
            this._y = this.original.y = newY;
        }
    }
    class transform_Transform {
        constructor(){
            this._parent = null;
            this._children = [];
            this._pos = vec(0, 0);
            this._rotation = 0;
            this._scale = vec(1, 1);
            this._isDirty = false;
            this._isInverseDirty = false;
            this._matrix = AffineMatrix.identity();
            this._inverse = AffineMatrix.identity();
        }
        get parent() {
            return this._parent;
        }
        set parent(transform) {
            if (this._parent) {
                const index = this._parent._children.indexOf(this);
                if (index > -1) this._parent._children.splice(index, 1);
            }
            this._parent = transform;
            if (this._parent) this._parent._children.push(this);
            this.flagDirty();
        }
        get children() {
            return this._children;
        }
        set pos(v) {
            if (!v.equals(this._pos)) {
                this._pos.x = v.x;
                this._pos.y = v.y;
                this.flagDirty();
            }
        }
        get pos() {
            return new WatchVector(this._pos, (x, y)=>{
                if (x !== this._pos.x || y !== this._pos.y) this.flagDirty();
            });
        }
        set globalPos(v) {
            let localPos = v.clone();
            if (this.parent) localPos = this.parent.inverse.multiply(v);
            if (!localPos.equals(this._pos)) {
                this._pos = localPos;
                this.flagDirty();
            }
        }
        get globalPos() {
            return new VectorView({
                getX: ()=>this.matrix.data[4],
                getY: ()=>this.matrix.data[5],
                setX: (x)=>{
                    if (this.parent) {
                        const { x: newX } = this.parent.inverse.multiply(vec(x, this.pos.y));
                        this.pos.x = newX;
                    } else this.pos.x = x;
                    if (x !== this.matrix.data[4]) this.flagDirty();
                },
                setY: (y)=>{
                    if (this.parent) {
                        const { y: newY } = this.parent.inverse.multiply(vec(this.pos.x, y));
                        this.pos.y = newY;
                    } else this.pos.y = y;
                    if (y !== this.matrix.data[5]) this.flagDirty();
                }
            });
        }
        set rotation(rotation) {
            const canonRotation = canonicalizeAngle(rotation);
            if (canonRotation !== this._rotation) this.flagDirty();
            this._rotation = canonRotation;
        }
        get rotation() {
            return this._rotation;
        }
        set globalRotation(rotation) {
            let inverseRotation = 0;
            if (this.parent) inverseRotation = this.parent.globalRotation;
            const canonRotation = canonicalizeAngle(rotation + inverseRotation);
            if (canonRotation !== this._rotation) this.flagDirty();
            this._rotation = canonRotation;
        }
        get globalRotation() {
            if (this.parent) return this.matrix.getRotation();
            return this.rotation;
        }
        set scale(v) {
            if (v.x !== this._scale.x || v.y !== this._scale.y) {
                this._scale.x = v.x;
                this._scale.y = v.y;
                this.flagDirty();
            }
        }
        get scale() {
            return new WatchVector(this._scale, (x, y)=>{
                if (x !== this._scale.x || y !== this._scale.y) this.flagDirty();
            });
        }
        set globalScale(v) {
            let inverseScale = vec(1, 1);
            if (this.parent) inverseScale = this.parent.globalScale;
            this.scale = v.scale(vec(1 / inverseScale.x, 1 / inverseScale.y));
        }
        get globalScale() {
            return new VectorView({
                getX: ()=>this.parent ? this.matrix.getScaleX() : this.scale.x,
                getY: ()=>this.parent ? this.matrix.getScaleY() : this.scale.y,
                setX: (x)=>{
                    if (this.parent) {
                        const globalScaleX = this.parent.globalScale.x;
                        this.scale.x = x / globalScaleX;
                    } else this.scale.x = x;
                },
                setY: (y)=>{
                    if (this.parent) {
                        const globalScaleY = this.parent.globalScale.y;
                        this.scale.y = y / globalScaleY;
                    } else this.scale.y = y;
                }
            });
        }
        get matrix() {
            if (this._isDirty) {
                if (this.parent === null) this._matrix = this._calculateMatrix();
                else this._matrix = this.parent.matrix.multiply(this._calculateMatrix());
                this._isDirty = false;
            }
            return this._matrix;
        }
        get inverse() {
            if (this._isInverseDirty) {
                this._inverse = this.matrix.inverse();
                this._isInverseDirty = false;
            }
            return this._inverse;
        }
        _calculateMatrix() {
            const matrix = AffineMatrix.identity().translate(this.pos.x, this.pos.y).rotate(this.rotation).scale(this.scale.x, this.scale.y);
            return matrix;
        }
        flagDirty() {
            this._isDirty = true;
            this._isInverseDirty = true;
            for(let i = 0; i < this._children.length; i++)this._children[i].flagDirty();
        }
        apply(point) {
            return this.matrix.multiply(point);
        }
        applyInverse(point) {
            return this.inverse.multiply(point);
        }
        setTransform(pos, rotation, scale) {
            this._pos.x = pos.x;
            this._pos.y = pos.y;
            this._rotation = canonicalizeAngle(rotation);
            this._scale.x = scale.x;
            this._scale.y = scale.y;
            this.flagDirty();
        }
        /**
     * Clones the current transform
     * **Warning does not clone the parent**
     * @param dest
     */ clone(dest) {
            const target = dest !== null && dest !== void 0 ? dest : new transform_Transform();
            this._pos.clone(target._pos);
            target._rotation = this._rotation;
            this._scale.clone(target._scale);
            target.flagDirty();
            return target;
        }
    }
    /**
 *
 */ function isComponentCtor(value) {
        return !!value && !!value.prototype && !!value.prototype.constructor;
    }
    /**
 * Type guard to check if a component implements clone
 * @param x
 */ function hasClone(x) {
        return !!(x === null || x === void 0 ? void 0 : x.clone);
    }
    /**
 * Components are containers for state in Excalibur, the are meant to convey capabilities that an Entity possesses
 *
 * Implementations of Component must have a zero-arg constructor to support dependencies
 *
 * ```typescript
 * class MyComponent extends ex.Component {
 *   // zero arg support required if you want to use component dependencies
 *   constructor(public optionalPos?: ex.Vector) {}
 * }
 * ```
 */ class Component {
        constructor(){
            // TODO maybe generate a unique id?
            /**
         * Current owning [[Entity]], if any, of this component. Null if not added to any [[Entity]]
         */ this.owner = undefined;
        }
        /**
     * Clones any properties on this component, if that property value has a `clone()` method it will be called
     */ clone() {
            const newComponent = new this.constructor();
            for(const prop in this)if (this.hasOwnProperty(prop)) {
                const val = this[prop];
                if (hasClone(val) && prop !== "owner" && prop !== "clone") newComponent[prop] = val.clone();
                else newComponent[prop] = val;
            }
            return newComponent;
        }
    }
    /**
 * Simple Observable implementation
 * @template T is the typescript Type that defines the data being observed
 */ class Observable {
        constructor(){
            this.observers = [];
            this.subscriptions = [];
        }
        /**
     * Register an observer to listen to this observable
     * @param observer
     */ register(observer) {
            this.observers.push(observer);
        }
        /**
     * Register a callback to listen to this observable
     * @param func
     */ subscribe(func) {
            this.subscriptions.push(func);
        }
        /**
     * Remove an observer from the observable
     * @param observer
     */ unregister(observer) {
            const i = this.observers.indexOf(observer);
            if (i !== -1) this.observers.splice(i, 1);
        }
        /**
     * Remove a callback that is listening to this observable
     * @param func
     */ unsubscribe(func) {
            const i = this.subscriptions.indexOf(func);
            if (i !== -1) this.subscriptions.splice(i, 1);
        }
        /**
     * Broadcasts a message to all observers and callbacks
     * @param message
     */ notifyAll(message) {
            const observersLength = this.observers.length;
            for(let i = 0; i < observersLength; i++)this.observers[i].notify(message);
            const subscriptionsLength = this.subscriptions.length;
            for(let i = 0; i < subscriptionsLength; i++)this.subscriptions[i](message);
        }
        /**
     * Removes all observers and callbacks
     */ clear() {
            this.observers.length = 0;
            this.subscriptions.length = 0;
        }
    }
    class TransformComponent extends Component {
        constructor(){
            super(...arguments);
            this._logger = Logger.getInstance();
            this._parentComponent = null;
            this._transform = new transform_Transform();
            this._addChildTransform = (child)=>{
                const childTxComponent = child.get(TransformComponent);
                if (childTxComponent) {
                    childTxComponent._transform.parent = this._transform;
                    childTxComponent._parentComponent = this;
                }
            };
            /**
         * Observable that emits when the z index changes on this component
         */ this.zIndexChanged$ = new Observable();
            this._z = 0;
            this._coordPlane = CoordPlane.World;
        }
        get() {
            return this._transform;
        }
        onAdd(owner) {
            for (const child of owner.children)this._addChildTransform(child);
            owner.childrenAdded$.subscribe((child)=>this._addChildTransform(child));
            owner.childrenRemoved$.subscribe((child)=>{
                const childTxComponent = child.get(TransformComponent);
                if (childTxComponent) {
                    childTxComponent._transform.parent = null;
                    childTxComponent._parentComponent = null;
                }
            });
        }
        onRemove(_previousOwner) {
            this._transform.parent = null;
            this._parentComponent = null;
        }
        /**
     * The z-index ordering of the entity, a higher values are drawn on top of lower values.
     * For example z=99 would be drawn on top of z=0.
     */ get z() {
            return this._z;
        }
        set z(val) {
            const oldz = this._z;
            this._z = val;
            if (oldz !== val) this.zIndexChanged$.notifyAll(val);
        }
        /**
     * The [[CoordPlane|coordinate plane|]] for this transform for the entity.
     */ get coordPlane() {
            if (this._parentComponent) return this._parentComponent.coordPlane;
            return this._coordPlane;
        }
        set coordPlane(value) {
            var _a;
            if (!this._parentComponent) this._coordPlane = value;
            else this._logger.warn(`Cannot set coordinate plane on child entity ${(_a = this.owner) === null || _a === void 0 ? void 0 : _a.name}, children inherit their coordinate plane from their parents.`);
        }
        get pos() {
            return this._transform.pos;
        }
        set pos(v) {
            this._transform.pos = v;
        }
        get globalPos() {
            return this._transform.globalPos;
        }
        set globalPos(v) {
            this._transform.globalPos = v;
        }
        get rotation() {
            return this._transform.rotation;
        }
        set rotation(rotation) {
            this._transform.rotation = rotation;
        }
        get globalRotation() {
            return this._transform.globalRotation;
        }
        set globalRotation(rotation) {
            this._transform.globalRotation = rotation;
        }
        get scale() {
            return this._transform.scale;
        }
        set scale(v) {
            this._transform.scale = v;
        }
        get globalScale() {
            return this._transform.globalScale;
        }
        set globalScale(v) {
            this._transform.globalScale = v;
        }
        applyInverse(v) {
            return this._transform.applyInverse(v);
        }
        apply(v) {
            return this._transform.apply(v);
        }
        clone() {
            const component = new TransformComponent();
            component._transform = this._transform.clone();
            component._z = this._z;
            return component;
        }
    }
    class MotionComponent extends Component {
        constructor(){
            super(...arguments);
            /**
         * The velocity of an entity in pixels per second
         */ this.vel = Vector.Zero;
            /**
         * The acceleration of entity in pixels per second^2
         */ this.acc = Vector.Zero;
            /**
         * The scale rate of change in scale units per second
         */ this.scaleFactor = Vector.Zero;
            /**
         * The angular velocity which is how quickly the entity is rotating in radians per second
         */ this.angularVelocity = 0;
            /**
         * The amount of torque applied to the entity, angular acceleration is torque * inertia
         */ this.torque = 0;
            /**
         * Inertia can be thought of as the resistance to motion
         */ this.inertia = 1;
        }
    }
    /**
 * Static class for managing collision groups in excalibur, there is a maximum of 32 collision groups possible in excalibur
 */ class CollisionGroupManager {
        /**
     * Create a new named collision group up to a max of 32.
     * @param name Name for the collision group
     * @param mask Optionally provide your own 32-bit mask, if none is provide the manager will generate one
     */ static create(name, mask) {
            if (this._CURRENT_GROUP > this._MAX_GROUPS) throw new Error(`Cannot have more than ${this._MAX_GROUPS} collision groups`);
            if (this._GROUPS.get(name)) {
                const existingGroup = this._GROUPS.get(name);
                if (existingGroup.mask === mask) return existingGroup;
                throw new Error(`Collision group ${name} already exists with a different mask!`);
            }
            const group = new CollisionGroup(name, this._CURRENT_BIT, mask !== undefined ? mask : ~this._CURRENT_BIT);
            this._CURRENT_BIT = this._CURRENT_BIT << 1 | 0;
            this._CURRENT_GROUP++;
            this._GROUPS.set(name, group);
            return group;
        }
        /**
     * Get all collision groups currently tracked by excalibur
     */ static get groups() {
            return Array.from(this._GROUPS.values());
        }
        /**
     * Get a collision group by it's name
     * @param name
     */ static groupByName(name) {
            return this._GROUPS.get(name);
        }
        /**
     * Resets the managers internal group management state
     */ static reset() {
            this._GROUPS = new Map();
            this._CURRENT_BIT = this._STARTING_BIT;
            this._CURRENT_GROUP = 1;
        }
    }
    // using bitmasking the maximum number of groups is 32, because that is the highest 32bit integer that JS can present.
    CollisionGroupManager._STARTING_BIT = 1;
    CollisionGroupManager._MAX_GROUPS = 32;
    CollisionGroupManager._CURRENT_GROUP = 1;
    CollisionGroupManager._CURRENT_BIT = CollisionGroupManager._STARTING_BIT;
    CollisionGroupManager._GROUPS = new Map();
    /**
 * CollisionGroups indicate like members that do not collide with each other. Use [[CollisionGroupManager]] to create [[CollisionGroup]]s
 *
 * For example:
 *
 * Players have collision group "player"
 *
 * ![Player Collision Group](/assets/images/docs/CollisionGroupsPlayer.png)
 *
 * Enemies have collision group "enemy"
 *
 * ![Enemy Collision Group](/assets/images/docs/CollisionGroupsEnemy.png)
 *
 * Blocks have collision group "ground"
 *
 * ![Ground collision group](/assets/images/docs/CollisionGroupsGround.png)
 *
 * Players don't collide with each other, but enemies and blocks. Likewise, enemies don't collide with each other but collide
 * with players and blocks.
 *
 * This is done with bitmasking, see the following pseudo-code
 *
 * PlayerGroup = `0b001`
 * PlayerGroupMask = `0b110`
 *
 * EnemyGroup = `0b010`
 * EnemyGroupMask = `0b101`
 *
 * BlockGroup = `0b100`
 * BlockGroupMask = `0b011`
 *
 * Should Players collide? No because the bitwise mask evaluates to 0
 * `(player1.group & player2.mask) === 0`
 * `(0b001 & 0b110) === 0`
 *
 * Should Players and Enemies collide? Yes because the bitwise mask is non-zero
 * `(player1.group & enemy1.mask) === 1`
 * `(0b001 & 0b101) === 1`
 *
 * Should Players and Blocks collide? Yes because the bitwise mask is non-zero
 * `(player1.group & blocks1.mask) === 1`
 * `(0b001 & 0b011) === 1`
 */ class CollisionGroup {
        /**
     * STOP!!** It is preferred that [[CollisionGroupManager.create]] is used to create collision groups
     *  unless you know how to construct the proper bitmasks. See https://github.com/excaliburjs/Excalibur/issues/1091 for more info.
     * @param name Name of the collision group
     * @param category 32 bit category for the group, should be a unique power of 2. For example `0b001` or `0b010`
     * @param mask 32 bit mask of category, or `~category` generally. For a category of `0b001`, the mask would be `0b110`
     */ constructor(name, category, mask){
            this._name = name;
            this._category = category;
            this._mask = mask;
        }
        /**
     * Get the name of the collision group
     */ get name() {
            return this._name;
        }
        /**
     * Get the category of the collision group, a 32 bit number which should be a unique power of 2
     */ get category() {
            return this._category;
        }
        /**
     * Get the mask for this collision group
     */ get mask() {
            return this._mask;
        }
        /**
     * Evaluates whether 2 collision groups can collide
     *
     * This means the mask has the same bit set the other category and vice versa
     * @param other  CollisionGroup
     */ canCollide(other) {
            const overlap1 = this.category & other.mask;
            const overlap2 = this.mask & other.category;
            return overlap1 !== 0 && overlap2 !== 0;
        }
        /**
     * Inverts the collision group. For example, if before the group specified "players",
     * inverting would specify all groups except players
     * @returns CollisionGroup
     */ invert() {
            const group = CollisionGroupManager.create("~(" + this.name + ")", ~this.mask | 0);
            group._category = ~this.category;
            return group;
        }
        /**
     * Combine collision groups with each other. The new group includes all of the previous groups.
     * @param collisionGroups
     */ static combine(collisionGroups) {
            const combinedName = collisionGroups.map((c)=>c.name).join("+");
            const combinedCategory = collisionGroups.reduce((current, g)=>g.category | current, 0);
            const combinedMask = ~combinedCategory;
            return CollisionGroupManager.create(combinedName, combinedMask);
        }
        /**
     * Creates a collision group that collides with the listed groups
     * @param collisionGroups
     */ static collidesWith(collisionGroups) {
            const combinedName = `collidesWith(${collisionGroups.map((c)=>c.name).join("+")})`;
            const combinedMask = collisionGroups.reduce((current, g)=>g.category | current, 0);
            return CollisionGroupManager.create(combinedName, combinedMask);
        }
        toString() {
            return `
category: ${this.category.toString(2).padStart(32, "0")}
mask:     ${(this.mask >>> 0).toString(2).padStart(32, "0")}
    `;
        }
    }
    /**
 * The `All` [[CollisionGroup]] is a special group that collides with all other groups including itself,
 * it is the default collision group on colliders.
 */ CollisionGroup.All = new CollisionGroup("Collide with all groups", -1, -1);
    /**
 * Models a potential collision between 2 colliders
 */ class Pair {
        constructor(colliderA, colliderB){
            this.colliderA = colliderA;
            this.colliderB = colliderB;
            this.id = null;
            this.id = Pair.calculatePairHash(colliderA.id, colliderB.id);
        }
        /**
     * Returns whether a it is allowed for 2 colliders in a Pair to collide
     * @param colliderA
     * @param colliderB
     */ static canCollide(colliderA, colliderB) {
            var _a, _b;
            const bodyA = (_a = colliderA === null || colliderA === void 0 ? void 0 : colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
            const bodyB = (_b = colliderB === null || colliderB === void 0 ? void 0 : colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
            // Prevent self collision
            if (colliderA.id === colliderB.id) return false;
            // Colliders with the same owner do not collide (composite colliders)
            if (colliderA.owner && colliderB.owner && colliderA.owner.id === colliderB.owner.id) return false;
            // if the pair has a member with zero dimension don't collide
            if (colliderA.localBounds.hasZeroDimensions() || colliderB.localBounds.hasZeroDimensions()) return false;
            // Body's needed for collision in the current state
            // TODO can we collide without a body?
            if (!bodyA || !bodyB) return false;
            // If both are in the same collision group short circuit
            if (!bodyA.group.canCollide(bodyB.group)) return false;
            // if both are fixed short circuit
            if (bodyA.collisionType === CollisionType.Fixed && bodyB.collisionType === CollisionType.Fixed) return false;
            // if the either is prevent collision short circuit
            if (bodyB.collisionType === CollisionType.PreventCollision || bodyA.collisionType === CollisionType.PreventCollision) return false;
            // if either is dead short circuit
            if (!bodyA.active || !bodyB.active) return false;
            return true;
        }
        /**
     * Returns whether or not it is possible for the pairs to collide
     */ get canCollide() {
            const colliderA = this.colliderA;
            const colliderB = this.colliderB;
            return Pair.canCollide(colliderA, colliderB);
        }
        /**
     * Runs the collision intersection logic on the members of this pair
     */ collide() {
            return this.colliderA.collide(this.colliderB);
        }
        /**
     * Check if the collider is part of the pair
     * @param collider
     */ hasCollider(collider) {
            return collider === this.colliderA || collider === this.colliderB;
        }
        /**
     * Calculates the unique pair hash id for this collision pair (owning id)
     */ static calculatePairHash(idA, idB) {
            if (idA.value < idB.value) return `#${idA.value}+${idB.value}`;
            else return `#${idB.value}+${idA.value}`;
        }
    }
    /**
 * A 1 dimensional projection on an axis, used to test overlaps
 */ class Projection {
        constructor(min, max){
            this.min = min;
            this.max = max;
        }
        overlaps(projection) {
            return this.max > projection.min && projection.max > this.min;
        }
        getOverlap(projection) {
            if (this.overlaps(projection)) {
                if (this.max > projection.max) return projection.max - this.min;
                else return this.max - projection.min;
            }
            return 0;
        }
    }
    /**
 * Dynamic Tree Node used for tracking bounds within the tree
 */ class TreeNode {
        constructor(parent){
            this.parent = parent;
            this.parent = parent || null;
            this.data = null;
            this.bounds = new BoundingBox();
            this.left = null;
            this.right = null;
            this.height = 0;
        }
        isLeaf() {
            return !this.left && !this.right;
        }
    }
    /**
 * The DynamicTrees provides a spatial partitioning data structure for quickly querying for overlapping bounding boxes for
 * all tracked bodies. The worst case performance of this is O(n*log(n)) where n is the number of bodies in the tree.
 *
 * Internally the bounding boxes are organized as a balanced binary tree of bounding boxes, where the leaf nodes are tracked bodies.
 * Every non-leaf node is a bounding box that contains child bounding boxes.
 */ class DynamicTree {
        constructor(_config, worldBounds = new BoundingBox(-Number.MAX_VALUE, -Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE)){
            this._config = _config;
            this.worldBounds = worldBounds;
            this.root = null;
            this.nodes = {};
        }
        /**
     * Inserts a node into the dynamic tree
     */ _insert(leaf) {
            // If there are no nodes in the tree, make this the root leaf
            if (this.root === null) {
                this.root = leaf;
                this.root.parent = null;
                return;
            }
            // Search the tree for a node that is not a leaf and find the best place to insert
            const leafAABB = leaf.bounds;
            let currentRoot = this.root;
            while(!currentRoot.isLeaf()){
                const left = currentRoot.left;
                const right = currentRoot.right;
                const area = currentRoot.bounds.getPerimeter();
                const combinedAABB = currentRoot.bounds.combine(leafAABB);
                const combinedArea = combinedAABB.getPerimeter();
                // Calculate cost heuristic for creating a new parent and leaf
                const cost = 2 * combinedArea;
                // Minimum cost of pushing the leaf down the tree
                const inheritanceCost = 2 * (combinedArea - area);
                // Cost of descending
                let leftCost = 0;
                const leftCombined = leafAABB.combine(left.bounds);
                let newArea;
                let oldArea;
                if (left.isLeaf()) leftCost = leftCombined.getPerimeter() + inheritanceCost;
                else {
                    oldArea = left.bounds.getPerimeter();
                    newArea = leftCombined.getPerimeter();
                    leftCost = newArea - oldArea + inheritanceCost;
                }
                let rightCost = 0;
                const rightCombined = leafAABB.combine(right.bounds);
                if (right.isLeaf()) rightCost = rightCombined.getPerimeter() + inheritanceCost;
                else {
                    oldArea = right.bounds.getPerimeter();
                    newArea = rightCombined.getPerimeter();
                    rightCost = newArea - oldArea + inheritanceCost;
                }
                // cost is acceptable
                if (cost < leftCost && cost < rightCost) break;
                // Descend to the depths
                if (leftCost < rightCost) currentRoot = left;
                else currentRoot = right;
            }
            // Create the new parent node and insert into the tree
            const oldParent = currentRoot.parent;
            const newParent = new TreeNode(oldParent);
            newParent.bounds = leafAABB.combine(currentRoot.bounds);
            newParent.height = currentRoot.height + 1;
            if (oldParent !== null) {
                // The sibling node was not the root
                if (oldParent.left === currentRoot) oldParent.left = newParent;
                else oldParent.right = newParent;
                newParent.left = currentRoot;
                newParent.right = leaf;
                currentRoot.parent = newParent;
                leaf.parent = newParent;
            } else {
                // The sibling node was the root
                newParent.left = currentRoot;
                newParent.right = leaf;
                currentRoot.parent = newParent;
                leaf.parent = newParent;
                this.root = newParent;
            }
            // Walk up the tree fixing heights and AABBs
            let currentNode = leaf.parent;
            while(currentNode){
                currentNode = this._balance(currentNode);
                if (!currentNode.left) throw new Error("Parent of current leaf cannot have a null left child" + currentNode);
                if (!currentNode.right) throw new Error("Parent of current leaf cannot have a null right child" + currentNode);
                currentNode.height = 1 + Math.max(currentNode.left.height, currentNode.right.height);
                currentNode.bounds = currentNode.left.bounds.combine(currentNode.right.bounds);
                currentNode = currentNode.parent;
            }
        }
        /**
     * Removes a node from the dynamic tree
     */ _remove(leaf) {
            if (leaf === this.root) {
                this.root = null;
                return;
            }
            const parent = leaf.parent;
            const grandParent = parent.parent;
            let sibling;
            if (parent.left === leaf) sibling = parent.right;
            else sibling = parent.left;
            if (grandParent) {
                if (grandParent.left === parent) grandParent.left = sibling;
                else grandParent.right = sibling;
                sibling.parent = grandParent;
                let currentNode = grandParent;
                while(currentNode){
                    currentNode = this._balance(currentNode);
                    currentNode.bounds = currentNode.left.bounds.combine(currentNode.right.bounds);
                    currentNode.height = 1 + Math.max(currentNode.left.height, currentNode.right.height);
                    currentNode = currentNode.parent;
                }
            } else {
                this.root = sibling;
                sibling.parent = null;
            }
        }
        /**
     * Tracks a body in the dynamic tree
     */ trackCollider(collider) {
            const node = new TreeNode();
            node.data = collider;
            node.bounds = collider.bounds;
            node.bounds.left -= 2;
            node.bounds.top -= 2;
            node.bounds.right += 2;
            node.bounds.bottom += 2;
            this.nodes[collider.id.value] = node;
            this._insert(node);
        }
        /**
     * Updates the dynamic tree given the current bounds of each body being tracked
     */ updateCollider(collider) {
            var _a;
            const node = this.nodes[collider.id.value];
            if (!node) return false;
            const b = collider.bounds;
            // if the body is outside the world no longer update it
            if (!this.worldBounds.contains(b)) {
                Logger.getInstance().warn("Collider with id " + collider.id.value + " is outside the world bounds and will no longer be tracked for physics");
                this.untrackCollider(collider);
                return false;
            }
            if (node.bounds.contains(b)) return false;
            this._remove(node);
            b.left -= this._config.boundsPadding;
            b.top -= this._config.boundsPadding;
            b.right += this._config.boundsPadding;
            b.bottom += this._config.boundsPadding;
            // THIS IS CAUSING UNNECESSARY CHECKS
            if (collider.owner) {
                const body = (_a = collider.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
                if (body) {
                    const multdx = body.vel.x * 32 / 1000 * this._config.velocityMultiplier;
                    const multdy = body.vel.y * 32 / 1000 * this._config.velocityMultiplier;
                    if (multdx < 0) b.left += multdx;
                    else b.right += multdx;
                    if (multdy < 0) b.top += multdy;
                    else b.bottom += multdy;
                }
            }
            node.bounds = b;
            this._insert(node);
            return true;
        }
        /**
     * Untracks a body from the dynamic tree
     */ untrackCollider(collider) {
            const node = this.nodes[collider.id.value];
            if (!node) return;
            this._remove(node);
            this.nodes[collider.id.value] = null;
            delete this.nodes[collider.id.value];
        }
        /**
     * Balances the tree about a node
     */ _balance(node) {
            if (node === null) throw new Error("Cannot balance at null node");
            if (node.isLeaf() || node.height < 2) return node;
            const left = node.left;
            const right = node.right;
            const a = node;
            const b = left;
            const c = right;
            const d = left.left;
            const e = left.right;
            const f = right.left;
            const g = right.right;
            const balance = c.height - b.height;
            // Rotate c node up
            if (balance > 1) {
                // Swap the right node with it's parent
                c.left = a;
                c.parent = a.parent;
                a.parent = c;
                // The original node's old parent should point to the right node
                // this is mega confusing
                if (c.parent) {
                    if (c.parent.left === a) c.parent.left = c;
                    else c.parent.right = c;
                } else this.root = c;
                // Rotate
                if (f.height > g.height) {
                    c.right = f;
                    a.right = g;
                    g.parent = a;
                    a.bounds = b.bounds.combine(g.bounds);
                    c.bounds = a.bounds.combine(f.bounds);
                    a.height = 1 + Math.max(b.height, g.height);
                    c.height = 1 + Math.max(a.height, f.height);
                } else {
                    c.right = g;
                    a.right = f;
                    f.parent = a;
                    a.bounds = b.bounds.combine(f.bounds);
                    c.bounds = a.bounds.combine(g.bounds);
                    a.height = 1 + Math.max(b.height, f.height);
                    c.height = 1 + Math.max(a.height, g.height);
                }
                return c;
            }
            // Rotate left node up
            if (balance < -1) {
                // swap
                b.left = a;
                b.parent = a.parent;
                a.parent = b;
                // node's old parent should point to b
                if (b.parent) {
                    if (b.parent.left === a) b.parent.left = b;
                    else {
                        if (b.parent.right !== a) throw "Error rotating Dynamic Tree";
                        b.parent.right = b;
                    }
                } else this.root = b;
                // rotate
                if (d.height > e.height) {
                    b.right = d;
                    a.left = e;
                    e.parent = a;
                    a.bounds = c.bounds.combine(e.bounds);
                    b.bounds = a.bounds.combine(d.bounds);
                    a.height = 1 + Math.max(c.height, e.height);
                    b.height = 1 + Math.max(a.height, d.height);
                } else {
                    b.right = e;
                    a.left = d;
                    d.parent = a;
                    a.bounds = c.bounds.combine(d.bounds);
                    b.bounds = a.bounds.combine(e.bounds);
                    a.height = 1 + Math.max(c.height, d.height);
                    b.height = 1 + Math.max(a.height, e.height);
                }
                return b;
            }
            return node;
        }
        /**
     * Returns the internal height of the tree, shorter trees are better. Performance drops as the tree grows
     */ getHeight() {
            if (this.root === null) return 0;
            return this.root.height;
        }
        /**
     * Queries the Dynamic Axis Aligned Tree for bodies that could be colliding with the provided body.
     *
     * In the query callback, it will be passed a potential collider. Returning true from this callback indicates
     * that you are complete with your query and you do not want to continue. Returning false will continue searching
     * the tree until all possible colliders have been returned.
     */ query(collider, callback) {
            const bounds = collider.bounds;
            const helper = (currentNode)=>{
                if (currentNode && currentNode.bounds.overlaps(bounds)) {
                    if (currentNode.isLeaf() && currentNode.data !== collider) {
                        if (callback.call(collider, currentNode.data)) return true;
                    } else return helper(currentNode.left) || helper(currentNode.right);
                }
                return false;
            };
            helper(this.root);
        }
        /**
     * Queries the Dynamic Axis Aligned Tree for bodies that could be intersecting. By default the raycast query uses an infinitely
     * long ray to test the tree specified by `max`.
     *
     * In the query callback, it will be passed a potential body that intersects with the raycast. Returning true from this
     * callback indicates that your are complete with your query and do not want to continue. Return false will continue searching
     * the tree until all possible bodies that would intersect with the ray have been returned.
     */ rayCastQuery(ray, max = Infinity, callback) {
            const helper = (currentNode)=>{
                if (currentNode && currentNode.bounds.rayCast(ray, max)) {
                    if (currentNode.isLeaf()) {
                        if (callback.call(ray, currentNode.data)) // ray hit a leaf! return the body
                        return true;
                    } else // ray hit but not at a leaf, recurse deeper
                    return helper(currentNode.left) || helper(currentNode.right);
                }
                return false; // ray missed
            };
            helper(this.root);
        }
        getNodes() {
            const helper = (currentNode)=>{
                if (currentNode) return [
                    currentNode
                ].concat(helper(currentNode.left), helper(currentNode.right));
                else return [];
            };
            return helper(this.root);
        }
        debug(ex) {
            // draw all the nodes in the Dynamic Tree
            const helper = (currentNode)=>{
                if (currentNode) {
                    if (currentNode.isLeaf()) currentNode.bounds.draw(ex, Color.Green);
                    else currentNode.bounds.draw(ex, Color.White);
                    if (currentNode.left) helper(currentNode.left);
                    if (currentNode.right) helper(currentNode.right);
                }
            };
            helper(this.root);
        }
    }
    /**
 * A 2D ray that can be cast into the scene to do collision detection
 */ class Ray {
        /**
     * @param pos The starting position for the ray
     * @param dir The vector indicating the direction of the ray
     */ constructor(pos, dir){
            this.pos = pos;
            this.dir = dir.normalize();
        }
        /**
     * Tests a whether this ray intersects with a line segment. Returns a number greater than or equal to 0 on success.
     * This number indicates the mathematical intersection time.
     * @param line  The line to test
     */ intersect(line) {
            const numerator = line.begin.sub(this.pos);
            // Test is line and ray are parallel and non intersecting
            if (this.dir.cross(line.getSlope()) === 0 && numerator.cross(this.dir) !== 0) return -1;
            // Lines are parallel
            const divisor = this.dir.cross(line.getSlope());
            if (divisor === 0) return -1;
            const t = numerator.cross(line.getSlope()) / divisor;
            if (t >= 0) {
                const u = numerator.cross(this.dir) / divisor / line.getLength();
                if (u >= 0 && u <= 1) return t;
            }
            return -1;
        }
        intersectPoint(line) {
            const time = this.intersect(line);
            if (time < 0) return null;
            return this.getPoint(time);
        }
        /**
     * Returns the point of intersection given the intersection time
     */ getPoint(time) {
            return this.pos.add(this.dir.scale(time));
        }
    }
    /**
 * Responsible for performing the collision broadphase (locating potential collisions) and
 * the narrowphase (actual collision contacts)
 */ class DynamicTreeCollisionProcessor {
        constructor(_config){
            this._config = _config;
            this._pairs = new Set();
            this._collisionPairCache = [];
            this._colliders = [];
            this._dynamicCollisionTree = new DynamicTree(_config.dynamicTree);
        }
        getColliders() {
            return this._colliders;
        }
        rayCast(ray, options) {
            var _a, _b, _c;
            const results = [];
            const maxDistance = (_a = options === null || options === void 0 ? void 0 : options.maxDistance) !== null && _a !== void 0 ? _a : Infinity;
            const collisionGroup = options === null || options === void 0 ? void 0 : options.collisionGroup;
            const collisionMask = !collisionGroup ? (_b = options === null || options === void 0 ? void 0 : options.collisionMask) !== null && _b !== void 0 ? _b : CollisionGroup.All.category : collisionGroup.category;
            const searchAllColliders = (_c = options === null || options === void 0 ? void 0 : options.searchAllColliders) !== null && _c !== void 0 ? _c : false;
            this._dynamicCollisionTree.rayCastQuery(ray, maxDistance, (collider)=>{
                const owner = collider.owner;
                const maybeBody = owner.get(BodyComponent);
                if ((options === null || options === void 0 ? void 0 : options.ignoreCollisionGroupAll) && maybeBody.group === CollisionGroup.All) return false;
                const canCollide = (collisionMask & maybeBody.group.category) !== 0;
                // Early exit if not the right group
                if ((maybeBody === null || maybeBody === void 0 ? void 0 : maybeBody.group) && !canCollide) return false;
                const hit = collider.rayCast(ray, maxDistance);
                if (hit) {
                    if (options === null || options === void 0 ? void 0 : options.filter) {
                        if (options.filter(hit)) {
                            results.push(hit);
                            if (!searchAllColliders) // returning true exits the search
                            return true;
                        }
                    } else {
                        results.push(hit);
                        if (!searchAllColliders) // returning true exits the search
                        return true;
                    }
                }
                return false;
            });
            return results;
        }
        /**
     * Tracks a physics body for collisions
     */ track(target) {
            if (!target) {
                Logger.getInstance().warn("Cannot track null collider");
                return;
            }
            if (target instanceof CompositeCollider) {
                const colliders = target.getColliders();
                for (const c of colliders){
                    c.owner = target.owner;
                    this._colliders.push(c);
                    this._dynamicCollisionTree.trackCollider(c);
                }
            } else {
                this._colliders.push(target);
                this._dynamicCollisionTree.trackCollider(target);
            }
        }
        /**
     * Untracks a physics body
     */ untrack(target) {
            if (!target) {
                Logger.getInstance().warn("Cannot untrack a null collider");
                return;
            }
            if (target instanceof CompositeCollider) {
                const colliders = target.getColliders();
                for (const c of colliders){
                    const index = this._colliders.indexOf(c);
                    if (index !== -1) this._colliders.splice(index, 1);
                    this._dynamicCollisionTree.untrackCollider(c);
                }
            } else {
                const index = this._colliders.indexOf(target);
                if (index !== -1) this._colliders.splice(index, 1);
                this._dynamicCollisionTree.untrackCollider(target);
            }
        }
        _pairExists(colliderA, colliderB) {
            // if the collision pair has been calculated already short circuit
            const hash = Pair.calculatePairHash(colliderA.id, colliderB.id);
            return this._pairs.has(hash);
        }
        /**
     * Detects potential collision pairs in a broadphase approach with the dynamic AABB tree strategy
     */ broadphase(targets, delta, stats) {
            const seconds = delta / 1000;
            // Retrieve the list of potential colliders, exclude killed, prevented, and self
            const potentialColliders = targets.filter((other)=>{
                var _a, _b;
                const body = (_a = other.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
                return ((_b = other.owner) === null || _b === void 0 ? void 0 : _b.active) && body.collisionType !== CollisionType.PreventCollision;
            });
            // clear old list of collision pairs
            this._collisionPairCache = [];
            this._pairs.clear();
            // check for normal collision pairs
            let collider;
            for(let j = 0, l = potentialColliders.length; j < l; j++){
                collider = potentialColliders[j];
                // Query the collision tree for potential colliders
                this._dynamicCollisionTree.query(collider, (other)=>{
                    if (!this._pairExists(collider, other) && Pair.canCollide(collider, other)) {
                        const pair = new Pair(collider, other);
                        this._pairs.add(pair.id);
                        this._collisionPairCache.push(pair);
                    }
                    // Always return false, to query whole tree. Returning true in the query method stops searching
                    return false;
                });
            }
            if (stats) stats.physics.pairs = this._collisionPairCache.length;
            // Check dynamic tree for fast moving objects
            // Fast moving objects are those moving at least there smallest bound per frame
            if (this._config.continuous.checkForFastBodies) for (const collider of potentialColliders){
                const body = collider.owner.get(BodyComponent);
                // Skip non-active objects. Does not make sense on other collision types
                if (body.collisionType !== CollisionType.Active) continue;
                // Maximum travel distance next frame
                const updateDistance = body.vel.size * seconds + // velocity term
                body.acc.size * 0.5 * seconds * seconds; // acc term
                // Find the minimum dimension
                const minDimension = Math.min(collider.bounds.height, collider.bounds.width);
                if (this._config.continuous.disableMinimumSpeedForFastBody || updateDistance > minDimension / 2) {
                    if (stats) stats.physics.fastBodies++;
                    // start with the oldPos because the integration for actors has already happened
                    // objects resting on a surface may be slightly penetrating in the current position
                    const updateVec = body.globalPos.sub(body.oldPos);
                    const centerPoint = collider.center;
                    const furthestPoint = collider.getFurthestPoint(body.vel);
                    const origin = furthestPoint.sub(updateVec);
                    const ray = new Ray(origin, body.vel);
                    // back the ray up by -2x surfaceEpsilon to account for fast moving objects starting on the surface
                    ray.pos = ray.pos.add(ray.dir.scale(-2 * this._config.continuous.surfaceEpsilon));
                    let minCollider;
                    let minTranslate = new Vector(Infinity, Infinity);
                    this._dynamicCollisionTree.rayCastQuery(ray, updateDistance + this._config.continuous.surfaceEpsilon * 2, (other)=>{
                        if (!this._pairExists(collider, other) && Pair.canCollide(collider, other)) {
                            const hit = other.rayCast(ray, updateDistance + this._config.continuous.surfaceEpsilon * 10);
                            if (hit) {
                                const translate = hit.point.sub(origin);
                                if (translate.size < minTranslate.size) {
                                    minTranslate = translate;
                                    minCollider = other;
                                }
                            }
                        }
                        return false;
                    });
                    if (minCollider && Vector.isValid(minTranslate)) {
                        const pair = new Pair(collider, minCollider);
                        if (!this._pairs.has(pair.id)) {
                            this._pairs.add(pair.id);
                            this._collisionPairCache.push(pair);
                        }
                        // move the fast moving object to the other body
                        // need to push into the surface by ex.Physics.surfaceEpsilon
                        const shift = centerPoint.sub(furthestPoint);
                        body.globalPos = origin.add(shift).add(minTranslate).add(ray.dir.scale(10 * this._config.continuous.surfaceEpsilon)); // needed to push the shape slightly into contact
                        collider.update(body.transform.get());
                        if (stats) stats.physics.fastBodyCollisions++;
                    }
                }
            }
            // return cache
            return this._collisionPairCache;
        }
        /**
     * Applies narrow phase on collision pairs to find actual area intersections
     * Adds actual colliding pairs to stats' Frame data
     */ narrowphase(pairs, stats) {
            let contacts = [];
            for(let i = 0; i < pairs.length; i++){
                const newContacts = pairs[i].collide();
                contacts = contacts.concat(newContacts);
                if (stats && newContacts.length > 0) for (const c of newContacts)stats.physics.contacts.set(c.id, c);
            }
            if (stats) stats.physics.collisions += contacts.length;
            return contacts;
        }
        /**
     * Update the dynamic tree positions
     */ update(targets) {
            let updated = 0;
            const len = targets.length;
            for(let i = 0; i < len; i++)if (this._dynamicCollisionTree.updateCollider(targets[i])) updated++;
            return updated;
        }
        debug(ex) {
            this._dynamicCollisionTree.debug(ex);
        }
    }
    /**
 * A collision collider specifies the geometry that can detect when other collision colliders intersect
 * for the purposes of colliding 2 objects in excalibur.
 */ class Collider {
        constructor(){
            this.id = createId("collider", Collider._ID++);
            /**
         * Composite collider if any this collider is attached to
         *
         * **WARNING** do not tamper with this property
         */ this.composite = null;
            this.events = new EventEmitter();
            /**
         * Pixel offset of the collision collider relative to the collider, by default (0, 0) meaning the collider is positioned
         * on top of the collider.
         */ this.offset = Vector.Zero;
        }
        /**
     * Returns a boolean indicating whether this body collided with
     * or was in stationary contact with
     * the body of the other [[Collider]]
     */ touching(other) {
            const contact = this.collide(other);
            if (contact) return true;
            return false;
        }
    }
    Collider._ID = 0;
    /**
 * Possible collision resolution strategies
 *
 * The default is [[SolverStrategy.Arcade]] which performs simple axis aligned arcade style physics. This is useful for things
 * like platformers or top down games.
 *
 * More advanced rigid body physics are enabled by setting [[SolverStrategy.Realistic]] which allows for complicated
 * simulated physical interactions.
 */ var SolverStrategy;
    (function(SolverStrategy) {
        SolverStrategy["Arcade"] = "arcade";
        SolverStrategy["Realistic"] = "realistic";
    })(SolverStrategy || (SolverStrategy = {}));
    /**
 * Possible broadphase collision pair identification strategies
 *
 * The default strategy is [[BroadphaseStrategy.DynamicAABBTree]] which uses a binary tree of axis-aligned bounding boxes to identify
 * potential collision pairs which is O(nlog(n)) faster.
 * @deprecated Unused in Excalibur, will be removed in v0.30
 */ var BroadphaseStrategy;
    (function(BroadphaseStrategy) {
        BroadphaseStrategy[BroadphaseStrategy["DynamicAABBTree"] = 0] = "DynamicAABBTree";
    })(BroadphaseStrategy || (BroadphaseStrategy = {}));
    /**
 * Possible numerical integrators for position and velocity
 * @deprecated Unused in Excalibur, will be removed in v0.30
 */ var Integrator;
    (function(Integrator) {
        Integrator[Integrator["Euler"] = 0] = "Euler";
    })(Integrator || (Integrator = {}));
    /**
 * The [[Physics]] object is the global configuration object for all Excalibur physics.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ /* istanbul ignore next */ class Physics {
        /**
     * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
     */ static get gravity() {
            return Physics.acc;
        }
        static set gravity(v) {
            Physics.acc = v;
        }
        /**
     * Configures Excalibur to use "arcade" physics. Arcade physics which performs simple axis aligned arcade style physics.
     * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
     */ static useArcadePhysics() {
            Physics.collisionResolutionStrategy = SolverStrategy.Arcade;
        }
        /**
     * Configures Excalibur to use rigid body physics. Rigid body physics allows for complicated
     * simulated physical interactions.
     * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
     */ static useRealisticPhysics() {
            Physics.collisionResolutionStrategy = SolverStrategy.Realistic;
        }
    }
    /**
 * Global acceleration that is applied to all vanilla actors that have a [[CollisionType.Active|active]] collision type.
 * Global acceleration won't effect [[Label|labels]], [[ScreenElement|ui actors]], or [[Trigger|triggers]] in Excalibur.
 *
 * This is a great way to globally simulate effects like gravity.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.acc = new Vector(0, 0);
    /**
 * Globally switches all Excalibur physics behavior on or off.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.enabled = true;
    /**
 * Gets or sets the broadphase pair identification strategy.
 *
 * The default strategy is [[BroadphaseStrategy.DynamicAABBTree]] which uses a binary tree of axis-aligned bounding boxes to identify
 * potential collision pairs which is O(nlog(n)) faster.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.broadphaseStrategy = BroadphaseStrategy.DynamicAABBTree;
    /**
 * Gets or sets the global collision resolution strategy (narrowphase).
 *
 * The default is [[SolverStrategy.Arcade]] which performs simple axis aligned arcade style physics.
 *
 * More advanced rigid body physics are enabled by setting [[SolverStrategy.Realistic]] which allows for complicated
 * simulated physical interactions.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.collisionResolutionStrategy = SolverStrategy.Arcade;
    /**
 * The default mass to use if none is specified
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.defaultMass = 10;
    /**
 * Gets or sets the position and velocity positional integrator, currently only Euler is supported.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.integrator = Integrator.Euler;
    /**
 * Factor to add to the RigidBody BoundingBox, bounding box (dimensions += vel * dynamicTreeVelocityMultiplier);
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.dynamicTreeVelocityMultiplier = 2;
    /**
 * Pad RigidBody BoundingBox by a constant amount
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.boundsPadding = 5;
    /**
 * Number of position iterations (overlap) to run in the solver
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.positionIterations = 3;
    /**
 * Number of velocity iteration (response) to run in the solver
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.velocityIterations = 8;
    /**
 * Amount of overlap to tolerate in pixels
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.slop = 1;
    /**
 * Amount of positional overlap correction to apply each position iteration of the solver
 * O - meaning no correction, 1 - meaning correct all overlap
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.steeringFactor = 0.2;
    /**
 * Warm start set to true re-uses impulses from previous frames back in the solver
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.warmStart = true;
    /**
 * By default bodies do not sleep
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.bodiesCanSleepByDefault = false;
    /**
 * Surface epsilon is used to help deal with surface penetration
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.surfaceEpsilon = 0.1;
    /**
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.sleepEpsilon = 0.07;
    /**
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.wakeThreshold = Physics.sleepEpsilon * 3;
    /**
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.sleepBias = 0.9;
    /**
 * Enable fast moving body checking, this enables checking for collision pairs via raycast for fast moving objects to prevent
 * bodies from tunneling through one another.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.checkForFastBodies = true;
    /**
 * Disable minimum fast moving body raycast, by default if ex.Physics.checkForFastBodies = true Excalibur will only check if the
 * body is moving at least half of its minimum dimension in an update. If ex.Physics.disableMinimumSpeedForFastBody is set to true,
 * Excalibur will always perform the fast body raycast regardless of speed.
 * @deprecated Use engine args to configure Physics `new ex.Engine({physics: {...}})`, will be removed in v0.30
 */ Physics.disableMinimumSpeedForFastBody = false;
    /**
 * Tells the Arcade collision solver to prefer certain contacts over others
 */ var ContactSolveBias;
    (function(ContactSolveBias) {
        ContactSolveBias["None"] = "none";
        ContactSolveBias["VerticalFirst"] = "vertical-first";
        ContactSolveBias["HorizontalFirst"] = "horizontal-first";
    })(ContactSolveBias || (ContactSolveBias = {}));
    /**
 * Vertical First contact solve bias Used by the [[ArcadeSolver]] to sort contacts
 */ const VerticalFirst = {
        "vertical": 1,
        "horizontal": 2
    };
    /**
 * Horizontal First contact solve bias Used by the [[ArcadeSolver]] to sort contacts
 */ const HorizontalFirst = {
        "horizontal": 1,
        "vertical": 2
    };
    /**
 * None value, [[ArcadeSolver]] sorts contacts using distance by default
 */ const None = {
        "horizontal": 0,
        "vertical": 0
    };
    const DefaultPhysicsConfig = {
        enabled: true,
        gravity: vec(0, 0),
        solver: SolverStrategy.Arcade,
        colliders: {
            compositeStrategy: "together"
        },
        continuous: {
            checkForFastBodies: true,
            disableMinimumSpeedForFastBody: false,
            surfaceEpsilon: 0.1
        },
        bodies: {
            canSleepByDefault: false,
            sleepEpsilon: 0.07,
            wakeThreshold: 0.07 * 3,
            sleepBias: 0.9,
            defaultMass: 10
        },
        dynamicTree: {
            boundsPadding: 5,
            velocityMultiplier: 2
        },
        arcade: {
            contactSolveBias: ContactSolveBias.None
        },
        realistic: {
            positionIterations: 3,
            velocityIterations: 8,
            slop: 1,
            steeringFactor: 0.2,
            warmStart: true
        }
    };
    /**
 * @deprecated will be removed in v0.30
 */ function DeprecatedStaticToConfig() {
        return {
            enabled: Physics.enabled,
            gravity: Physics.gravity,
            solver: Physics.collisionResolutionStrategy,
            continuous: {
                checkForFastBodies: Physics.checkForFastBodies,
                disableMinimumSpeedForFastBody: Physics.disableMinimumSpeedForFastBody,
                surfaceEpsilon: Physics.surfaceEpsilon
            },
            colliders: {
                compositeStrategy: "together"
            },
            bodies: {
                canSleepByDefault: Physics.bodiesCanSleepByDefault,
                sleepEpsilon: Physics.sleepEpsilon,
                wakeThreshold: Physics.wakeThreshold,
                sleepBias: Physics.sleepBias,
                defaultMass: Physics.defaultMass
            },
            dynamicTree: {
                boundsPadding: Physics.boundsPadding,
                velocityMultiplier: Physics.dynamicTreeVelocityMultiplier
            },
            arcade: {
                contactSolveBias: ContactSolveBias.None
            },
            realistic: {
                positionIterations: Physics.positionIterations,
                velocityIterations: Physics.velocityIterations,
                slop: Physics.slop,
                steeringFactor: Physics.steeringFactor,
                warmStart: Physics.warmStart
            }
        };
    }
    class CompositeCollider extends Collider {
        /**
     * Treat composite collider's member colliders as either separate colliders for the purposes of onCollisionStart/onCollision
     * or as a single collider together.
     *
     * This property can be overridden on individual [[CompositeColliders]].
     *
     * For composites without gaps or small groups of colliders, you probably want 'together'
     *
     * For composites with deliberate gaps, like a platforming level layout, you probably want 'separate'
     *
     * Default is 'together' if unset
     */ set compositeStrategy(value) {
            this._compositeStrategy = value;
        }
        get compositeStrategy() {
            return this._compositeStrategy;
        }
        constructor(colliders){
            super();
            this._collisionProcessor = new DynamicTreeCollisionProcessor(DefaultPhysicsConfig);
            this._dynamicAABBTree = new DynamicTree(DefaultPhysicsConfig.dynamicTree);
            this._colliders = [];
            for (const c of colliders)this.addCollider(c);
        }
        clearColliders() {
            this._colliders = [];
        }
        addCollider(collider) {
            let colliders;
            if (collider instanceof CompositeCollider) {
                colliders = collider.getColliders();
                colliders.forEach((c)=>c.offset.addEqual(collider.offset));
            } else colliders = [
                collider
            ];
            // Flatten composites
            for (const c of colliders){
                c.events.pipe(this.events);
                c.composite = this;
                this._colliders.push(c);
                this._collisionProcessor.track(c);
                this._dynamicAABBTree.trackCollider(c);
            }
        }
        removeCollider(collider) {
            collider.events.pipe(this.events);
            collider.composite = null;
            removeItemFromArray(collider, this._colliders);
            this._collisionProcessor.untrack(collider);
            this._dynamicAABBTree.untrackCollider(collider);
        }
        getColliders() {
            return this._colliders;
        }
        get worldPos() {
            var _a, _b;
            return ((_b = (_a = this._transform) === null || _a === void 0 ? void 0 : _a.pos) !== null && _b !== void 0 ? _b : Vector.Zero).add(this.offset);
        }
        get center() {
            var _a, _b;
            return ((_b = (_a = this._transform) === null || _a === void 0 ? void 0 : _a.pos) !== null && _b !== void 0 ? _b : Vector.Zero).add(this.offset);
        }
        get bounds() {
            var _a, _b;
            // TODO cache this
            const colliders = this.getColliders();
            const results = colliders.reduce((acc, collider)=>acc.combine(collider.bounds), (_b = (_a = colliders[0]) === null || _a === void 0 ? void 0 : _a.bounds) !== null && _b !== void 0 ? _b : new BoundingBox().translate(this.worldPos));
            return results.translate(this.offset);
        }
        get localBounds() {
            var _a, _b;
            // TODO cache this
            const colliders = this.getColliders();
            const results = colliders.reduce((acc, collider)=>acc.combine(collider.localBounds), (_b = (_a = colliders[0]) === null || _a === void 0 ? void 0 : _a.localBounds) !== null && _b !== void 0 ? _b : new BoundingBox());
            return results;
        }
        get axes() {
            // TODO cache this
            const colliders = this.getColliders();
            let axes = [];
            for (const collider of colliders)axes = axes.concat(collider.axes);
            return axes;
        }
        getFurthestPoint(direction) {
            const colliders = this.getColliders();
            const furthestPoints = [];
            for (const collider of colliders)furthestPoints.push(collider.getFurthestPoint(direction));
            // Pick best point from all colliders
            let bestPoint = furthestPoints[0];
            let maxDistance = -Number.MAX_VALUE;
            for (const point of furthestPoints){
                const distance = point.dot(direction);
                if (distance > maxDistance) {
                    bestPoint = point;
                    maxDistance = distance;
                }
            }
            return bestPoint;
        }
        getInertia(mass) {
            const colliders = this.getColliders();
            let totalInertia = 0;
            for (const collider of colliders)totalInertia += collider.getInertia(mass);
            return totalInertia;
        }
        collide(other) {
            let otherColliders = [
                other
            ];
            if (other instanceof CompositeCollider) otherColliders = other.getColliders();
            const pairs = [];
            for (const c of otherColliders)this._dynamicAABBTree.query(c, (potentialCollider)=>{
                pairs.push(new Pair(c, potentialCollider));
                return false;
            });
            let contacts = [];
            for (const p of pairs)contacts = contacts.concat(p.collide());
            return contacts;
        }
        getClosestLineBetween(other) {
            const colliders = this.getColliders();
            const lines = [];
            if (other instanceof CompositeCollider) {
                const otherColliders = other.getColliders();
                for (const colliderA of colliders)for (const colliderB of otherColliders){
                    const maybeLine = colliderA.getClosestLineBetween(colliderB);
                    if (maybeLine) lines.push(maybeLine);
                }
            } else for (const collider of colliders){
                const maybeLine = other.getClosestLineBetween(collider);
                if (maybeLine) lines.push(maybeLine);
            }
            if (lines.length) {
                let minLength = lines[0].getLength();
                let minLine = lines[0];
                for (const line of lines){
                    const length = line.getLength();
                    if (length < minLength) {
                        minLength = length;
                        minLine = line;
                    }
                }
                return minLine;
            }
            return null;
        }
        contains(point) {
            const colliders = this.getColliders();
            for (const collider of colliders){
                if (collider.contains(point)) return true;
            }
            return false;
        }
        rayCast(ray, max) {
            const colliders = this.getColliders();
            const hits = [];
            for (const collider of colliders){
                const hit = collider.rayCast(ray, max);
                if (hit) hits.push(hit);
            }
            if (hits.length) {
                let minHit = hits[0];
                let minDistance = minHit.point.dot(ray.dir);
                for (const hit of hits){
                    const distance = ray.dir.dot(hit.point);
                    if (distance < minDistance) {
                        minHit = hit;
                        minDistance = distance;
                    }
                }
                return minHit;
            }
            return null;
        }
        project(axis) {
            const colliders = this.getColliders();
            const projections = [];
            for (const collider of colliders){
                const proj = collider.project(axis);
                if (proj) projections.push(proj);
            }
            // Merge all proj's on the same axis
            if (projections.length) {
                const newProjection = new Projection(projections[0].min, projections[0].max);
                for (const proj of projections){
                    newProjection.min = Math.min(proj.min, newProjection.min);
                    newProjection.max = Math.max(proj.max, newProjection.max);
                }
                return newProjection;
            }
            return null;
        }
        update(transform) {
            if (transform) {
                const colliders = this.getColliders();
                for (const collider of colliders){
                    collider.owner = this.owner;
                    collider.update(transform);
                }
            }
        }
        debug(ex, color, options) {
            const colliders = this.getColliders();
            ex.save();
            ex.translate(this.offset.x, this.offset.y);
            for (const collider of colliders)collider.debug(ex, color, options);
            ex.restore();
        }
        clone() {
            const result = new CompositeCollider(this._colliders.map((c)=>c.clone()));
            result.offset = this.offset.clone();
            return result;
        }
    }
    /**
 * A 2D line segment
 */ class LineSegment {
        /**
     * @param begin  The starting point of the line segment
     * @param end  The ending point of the line segment
     */ constructor(begin, end){
            this.begin = begin;
            this.end = end;
        }
        /**
     * Gets the raw slope (m) of the line. Will return (+/-)Infinity for vertical lines.
     */ get slope() {
            return (this.end.y - this.begin.y) / (this.end.x - this.begin.x);
        }
        /**
     * Gets the Y-intercept (b) of the line. Will return (+/-)Infinity if there is no intercept.
     */ get intercept() {
            return this.begin.y - this.slope * this.begin.x;
        }
        /**
     * Gets the normal of the line
     */ normal() {
            if (this._normal) return this._normal;
            return this._normal = this.end.sub(this.begin).normal();
        }
        dir() {
            if (this._dir) return this._dir;
            return this._dir = this.end.sub(this.begin);
        }
        getPoints() {
            return [
                this.begin,
                this.end
            ];
        }
        /**
     * Returns the slope of the line in the form of a vector of length 1
     */ getSlope() {
            if (this._slope) return this._slope;
            const begin = this.begin;
            const end = this.end;
            const distance = begin.distance(end);
            return this._slope = end.sub(begin).scale(1 / distance);
        }
        /**
     * Returns the edge of the line as vector, the length of the vector is the length of the edge
     */ getEdge() {
            const begin = this.begin;
            const end = this.end;
            return end.sub(begin);
        }
        /**
     * Returns the length of the line segment in pixels
     */ getLength() {
            if (this._length) return this._length;
            const begin = this.begin;
            const end = this.end;
            const distance = begin.distance(end);
            return this._length = distance;
        }
        /**
     * Returns the midpoint of the edge
     */ get midpoint() {
            return this.begin.add(this.end).scale(0.5);
        }
        /**
     * Flips the direction of the line segment
     */ flip() {
            return new LineSegment(this.end, this.begin);
        }
        /**
     * Tests if a given point is below the line, points in the normal direction above the line are considered above.
     * @param point
     */ below(point) {
            const above2 = (this.end.x - this.begin.x) * (point.y - this.begin.y) - (this.end.y - this.begin.y) * (point.x - this.begin.x);
            return above2 >= 0;
        }
        /**
     * Returns the clip point
     * @param sideVector Vector that traces the line
     * @param length Length to clip along side
     */ clip(sideVector, length) {
            let dir = sideVector;
            dir = dir.normalize();
            const near = dir.dot(this.begin) - length;
            const far = dir.dot(this.end) - length;
            const results = [];
            if (near <= 0) results.push(this.begin);
            if (far <= 0) results.push(this.end);
            if (near * far < 0) {
                const clipTime = near / (near - far);
                results.push(this.begin.add(this.end.sub(this.begin).scale(clipTime)));
            }
            if (results.length !== 2) return null;
            return new LineSegment(results[0], results[1]);
        }
        /**
     * Find the perpendicular distance from the line to a point
     * https://en.wikipedia.org/wiki/Distance_from_a_point_to_a_line
     * @param point
     */ distanceToPoint(point, signed = false) {
            const x0 = point.x;
            const y0 = point.y;
            const l = this.getLength();
            const dy = this.end.y - this.begin.y;
            const dx = this.end.x - this.begin.x;
            const distance = (dy * x0 - dx * y0 + this.end.x * this.begin.y - this.end.y * this.begin.x) / l;
            return signed ? distance : Math.abs(distance);
        }
        /**
     * Find the perpendicular line from the line to a point
     * https://en.wikipedia.org/wiki/Distance_from_a_point_to_a_line
     * (a - p) - ((a - p) * n)n
     * a is a point on the line
     * p is the arbitrary point above the line
     * n is a unit vector in direction of the line
     * @param point
     */ findVectorToPoint(point) {
            const aMinusP = this.begin.sub(point);
            const n = this.getSlope();
            return aMinusP.sub(n.scale(aMinusP.dot(n)));
        }
        /**
     * Finds a point on the line given only an X or a Y value. Given an X value, the function returns
     * a new point with the calculated Y value and vice-versa.
     * @param x The known X value of the target point
     * @param y The known Y value of the target point
     * @returns A new point with the other calculated axis value
     */ findPoint(x = null, y = null) {
            const m = this.slope;
            const b = this.intercept;
            if (x !== null) return new Vector(x, m * x + b);
            else if (y !== null) return new Vector((y - b) / m, y);
            else throw new Error("You must provide an X or a Y value");
        }
        /**
     * @see http://stackoverflow.com/a/11908158/109458
     */ hasPoint() {
            let currPoint;
            let threshold = 0;
            if (typeof arguments[0] === "number" && typeof arguments[1] === "number") {
                currPoint = new Vector(arguments[0], arguments[1]);
                threshold = arguments[2] || 0;
            } else if (arguments[0] instanceof Vector) {
                currPoint = arguments[0];
                threshold = arguments[1] || 0;
            } else throw "Could not determine the arguments for Vector.hasPoint";
            const dxc = currPoint.x - this.begin.x;
            const dyc = currPoint.y - this.begin.y;
            const dx1 = this.end.x - this.begin.x;
            const dy1 = this.end.y - this.begin.y;
            const cross = dxc * dy1 - dyc * dx1;
            // check whether point lines on the line
            if (Math.abs(cross) > threshold) return false;
            // check whether point lies in-between start and end
            if (Math.abs(dx1) >= Math.abs(dy1)) return dx1 > 0 ? this.begin.x <= currPoint.x && currPoint.x <= this.end.x : this.end.x <= currPoint.x && currPoint.x <= this.begin.x;
            else return dy1 > 0 ? this.begin.y <= currPoint.y && currPoint.y <= this.end.y : this.end.y <= currPoint.y && currPoint.y <= this.begin.y;
        }
    }
    /**
 * Finds the closes line between 2 line segments, were the magnitude of u, v are the lengths of each segment
 * L1 = P(s) = p0 + s * u, where s is time and p0 is the start of the line
 * L2 = Q(t) = q0 + t * v, where t is time and q0 is the start of the line
 * @param p0 Point where L1 begins
 * @param u Direction and length of L1
 * @param q0 Point were L2 begins
 * @param v Direction and length of L2
 */ function ClosestLine(p0, u, q0, v) {
        // Distance between 2 lines http://geomalgorithms.com/a07-_distance.html
        // w(s, t) = P(s) - Q(t)
        // The w(s, t) that has the minimum distance we will say is w(sClosest, tClosest) = wClosest
        //
        // wClosest is the vector that is uniquely perpendicular to the 2 line directions u & v.
        // wClosest = w0 + sClosest * u - tClosest * v, where w0 is p0 - q0
        //
        // The closest point between 2 lines then satisfies this pair of equations
        // 1: u * wClosest = 0
        // 2: v * wClosest = 0
        //
        // Substituting wClosest into the equations we get
        //
        // 1: (u * u) * sClosest - (u * v) tClosest = -u * w0
        // 2: (v * u) * sClosest - (v * v) tClosest = -v * w0
        // simplify w0
        const w0 = p0.sub(q0);
        // simplify (u * u);
        const a = u.dot(u);
        // simplify (u * v);
        const b = u.dot(v);
        // simplify (v * v)
        const c = v.dot(v);
        // simplify (u * w0)
        const d = u.dot(w0);
        // simplify (v * w0)
        const e = v.dot(w0);
        // denominator ac - b^2
        const denom = a * c - b * b;
        let sDenom = denom;
        let tDenom = denom;
        // if denom is 0 they are parallel, use any point from either as the start in this case p0
        if (denom === 0 || denom <= 0.01) {
            const tClosestParallel = d / b;
            return new LineSegment(p0, q0.add(v.scale(tClosestParallel)));
        }
        // Solve for sClosest for infinite line
        let sClosest = b * e - c * d; // / denom;
        // Solve for tClosest for infinite line
        let tClosest = a * e - b * d; // / denom;
        // Solve for segments candidate edges, if sClosest and tClosest are outside their segments
        if (sClosest < 0) {
            sClosest = 0;
            tClosest = e;
            tDenom = c;
        } else if (sClosest > sDenom) {
            sClosest = sDenom;
            tClosest = e + b;
            tDenom = c;
        }
        if (tClosest < 0) {
            tClosest = 0;
            if (-d < 0) sClosest = 0;
            else if (-d > a) sClosest = sDenom;
            else {
                sClosest = -d;
                sDenom = a;
            }
        } else if (tClosest > tDenom) {
            tClosest = tDenom;
            if (-d + b < 0) sClosest = 0;
            else if (-d + b > a) sClosest = sDenom;
            else {
                sClosest = -d + b;
                sDenom = a;
            }
        }
        sClosest = Math.abs(sClosest) < 0.001 ? 0 : sClosest / sDenom;
        tClosest = Math.abs(tClosest) < 0.001 ? 0 : tClosest / tDenom;
        return new LineSegment(p0.add(u.scale(sClosest)), q0.add(v.scale(tClosest)));
    }
    const ClosestLineJumpTable = {
        PolygonPolygonClosestLine (polygonA, polygonB) {
            // Find the 2 closest faces on each polygon
            const otherWorldPos = polygonB.worldPos;
            const otherDirection = otherWorldPos.sub(polygonA.worldPos);
            const thisDirection = otherDirection.negate();
            const rayTowardsOther = new Ray(polygonA.worldPos, otherDirection);
            const rayTowardsThis = new Ray(otherWorldPos, thisDirection);
            const thisPoint = polygonA.rayCast(rayTowardsOther).point.add(rayTowardsOther.dir.scale(0.1));
            const otherPoint = polygonB.rayCast(rayTowardsThis).point.add(rayTowardsThis.dir.scale(0.1));
            const thisFace = polygonA.getClosestFace(thisPoint);
            const otherFace = polygonB.getClosestFace(otherPoint);
            // L1 = P(s) = p0 + s * u, where s is time and p0 is the start of the line
            const p0 = thisFace.face.begin;
            const u = thisFace.face.getEdge();
            // L2 = Q(t) = q0 + t * v, where t is time and q0 is the start of the line
            const q0 = otherFace.face.begin;
            const v = otherFace.face.getEdge();
            return ClosestLine(p0, u, q0, v);
        },
        PolygonEdgeClosestLine (polygon, edge) {
            // Find the 2 closest faces on each polygon
            const otherWorldPos = edge.worldPos;
            const otherDirection = otherWorldPos.sub(polygon.worldPos);
            const rayTowardsOther = new Ray(polygon.worldPos, otherDirection);
            const thisPoint = polygon.rayCast(rayTowardsOther).point.add(rayTowardsOther.dir.scale(0.1));
            const thisFace = polygon.getClosestFace(thisPoint);
            // L1 = P(s) = p0 + s * u, where s is time and p0 is the start of the line
            const p0 = thisFace.face.begin;
            const u = thisFace.face.getEdge();
            // L2 = Q(t) = q0 + t * v, where t is time and q0 is the start of the line
            const edgeLine = edge.asLine();
            const edgeStart = edgeLine.begin;
            const edgeVector = edgeLine.getEdge();
            const q0 = edgeStart;
            const v = edgeVector;
            return ClosestLine(p0, u, q0, v);
        },
        PolygonCircleClosestLine (polygon, circle) {
            // https://math.stackexchange.com/questions/1919177/how-to-find-point-on-line-closest-to-sphere
            // Find the 2 closest faces on each polygon
            const otherWorldPos = circle.worldPos;
            const otherDirection = otherWorldPos.sub(polygon.worldPos);
            const rayTowardsOther = new Ray(polygon.worldPos, otherDirection.normalize());
            const thisPoint = polygon.rayCast(rayTowardsOther).point.add(rayTowardsOther.dir.scale(0.1));
            const thisFace = polygon.getClosestFace(thisPoint);
            // L1 = P(s) = p0 + s * u, where s is time and p0 is the start of the line
            const p0 = thisFace.face.begin;
            const u = thisFace.face.getEdge();
            // Time of minimum distance
            let t = (u.x * (otherWorldPos.x - p0.x) + u.y * (otherWorldPos.y - p0.y)) / (u.x * u.x + u.y * u.y);
            // If time of minimum is past the edge clamp
            if (t > 1) t = 1;
            else if (t < 0) t = 0;
            // Minimum distance
            const d = Math.sqrt(Math.pow(p0.x + u.x * t - otherWorldPos.x, 2) + Math.pow(p0.y + u.y * t - otherWorldPos.y, 2)) - circle.radius;
            const circlex = (p0.x + u.x * t - otherWorldPos.x) * circle.radius / (circle.radius + d);
            const circley = (p0.y + u.y * t - otherWorldPos.y) * circle.radius / (circle.radius + d);
            return new LineSegment(u.scale(t).add(p0), new Vector(otherWorldPos.x + circlex, otherWorldPos.y + circley));
        },
        CircleCircleClosestLine (circleA, circleB) {
            // Find the 2 closest faces on each polygon
            const otherWorldPos = circleB.worldPos;
            const otherDirection = otherWorldPos.sub(circleA.worldPos);
            const thisWorldPos = circleA.worldPos;
            const thisDirection = thisWorldPos.sub(circleB.worldPos);
            const rayTowardsOther = new Ray(circleA.worldPos, otherDirection);
            const rayTowardsThis = new Ray(circleB.worldPos, thisDirection);
            const thisPoint = circleA.rayCast(rayTowardsOther);
            const otherPoint = circleB.rayCast(rayTowardsThis);
            return new LineSegment(thisPoint.point, otherPoint.point);
        },
        CircleEdgeClosestLine (circle, edge) {
            // https://math.stackexchange.com/questions/1919177/how-to-find-point-on-line-closest-to-sphere
            const circleWorldPos = circle.worldPos;
            // L1 = P(s) = p0 + s * u, where s is time and p0 is the start of the line
            const edgeLine = edge.asLine();
            const edgeStart = edgeLine.begin;
            const edgeVector = edgeLine.getEdge();
            const p0 = edgeStart;
            const u = edgeVector;
            // Time of minimum distance
            let t = (u.x * (circleWorldPos.x - p0.x) + u.y * (circleWorldPos.y - p0.y)) / (u.x * u.x + u.y * u.y);
            // If time of minimum is past the edge clamp to edge
            if (t > 1) t = 1;
            else if (t < 0) t = 0;
            // Minimum distance
            const d = Math.sqrt(Math.pow(p0.x + u.x * t - circleWorldPos.x, 2) + Math.pow(p0.y + u.y * t - circleWorldPos.y, 2)) - circle.radius;
            const circlex = (p0.x + u.x * t - circleWorldPos.x) * circle.radius / (circle.radius + d);
            const circley = (p0.y + u.y * t - circleWorldPos.y) * circle.radius / (circle.radius + d);
            return new LineSegment(u.scale(t).add(p0), new Vector(circleWorldPos.x + circlex, circleWorldPos.y + circley));
        },
        EdgeEdgeClosestLine (edgeA, edgeB) {
            // L1 = P(s) = p0 + s * u, where s is time and p0 is the start of the line
            const edgeLineA = edgeA.asLine();
            const edgeStartA = edgeLineA.begin;
            const edgeVectorA = edgeLineA.getEdge();
            const p0 = edgeStartA;
            const u = edgeVectorA;
            // L2 = Q(t) = q0 + t * v, where t is time and q0 is the start of the line
            const edgeLineB = edgeB.asLine();
            const edgeStartB = edgeLineB.begin;
            const edgeVectorB = edgeLineB.getEdge();
            const q0 = edgeStartB;
            const v = edgeVectorB;
            return ClosestLine(p0, u, q0, v);
        }
    };
    /**
 * This is a circle collider for the excalibur rigid body physics simulation
 */ class CircleCollider extends Collider {
        get worldPos() {
            return this._globalMatrix.getPosition();
        }
        /**
     * Get the radius of the circle
     */ get radius() {
            var _a;
            const tx = this._transform;
            const scale = (_a = tx === null || tx === void 0 ? void 0 : tx.globalScale) !== null && _a !== void 0 ? _a : Vector.One;
            // This is a trade off, the alternative is retooling circles to support ellipse collisions
            return this._naturalRadius * Math.min(scale.x, scale.y);
        }
        /**
     * Set the radius of the circle
     */ set radius(val) {
            var _a;
            const tx = this._transform;
            const scale = (_a = tx === null || tx === void 0 ? void 0 : tx.globalScale) !== null && _a !== void 0 ? _a : Vector.One;
            // This is a trade off, the alternative is retooling circles to support ellipse collisions
            this._naturalRadius = val / Math.min(scale.x, scale.y);
        }
        constructor(options){
            super();
            /**
         * Position of the circle relative to the collider, by default (0, 0).
         */ this.offset = Vector.Zero;
            this._globalMatrix = AffineMatrix.identity();
            this.offset = options.offset || Vector.Zero;
            this.radius = options.radius || 0;
            this._globalMatrix.translate(this.offset.x, this.offset.y);
        }
        /**
     * Returns a clone of this shape, not associated with any collider
     */ clone() {
            return new CircleCollider({
                offset: this.offset.clone(),
                radius: this.radius
            });
        }
        /**
     * Get the center of the collider in world coordinates
     */ get center() {
            return this._globalMatrix.getPosition();
        }
        /**
     * Tests if a point is contained in this collider
     */ contains(point) {
            var _a, _b;
            const pos = (_b = (_a = this._transform) === null || _a === void 0 ? void 0 : _a.pos) !== null && _b !== void 0 ? _b : this.offset;
            const distance = pos.distance(point);
            if (distance <= this.radius) return true;
            return false;
        }
        /**
     * Casts a ray at the Circle collider and returns the nearest point of collision
     * @param ray
     */ rayCast(ray, max = Infinity) {
            var _a, _b;
            //https://en.wikipedia.org/wiki/Line%E2%80%93sphere_intersection
            const c = this.center;
            const dir = ray.dir;
            const orig = ray.pos;
            const discriminant = Math.sqrt(Math.pow(dir.dot(orig.sub(c)), 2) - Math.pow(orig.sub(c).distance(), 2) + Math.pow(this.radius, 2));
            if (discriminant < 0) // no intersection
            return null;
            else {
                let toi = 0;
                // tangent case
                if (discriminant === 0) {
                    toi = -dir.dot(orig.sub(c));
                    if (toi > 0 && toi < max) {
                        const point = ray.getPoint(toi);
                        return {
                            point: point,
                            normal: point.sub(c).normalize(),
                            collider: this,
                            body: (_a = this.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent),
                            distance: toi
                        };
                    }
                    return null;
                } else {
                    const toi1 = -dir.dot(orig.sub(c)) + discriminant;
                    const toi2 = -dir.dot(orig.sub(c)) - discriminant;
                    const positiveToi = [];
                    if (toi1 >= 0) positiveToi.push(toi1);
                    if (toi2 >= 0) positiveToi.push(toi2);
                    const minToi = Math.min(...positiveToi);
                    if (minToi <= max) {
                        const point = ray.getPoint(minToi);
                        return {
                            point: point,
                            normal: point.sub(c).normalize(),
                            collider: this,
                            body: (_b = this.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent),
                            distance: minToi
                        };
                    }
                    return null;
                }
            }
        }
        getClosestLineBetween(shape) {
            if (shape instanceof CircleCollider) return ClosestLineJumpTable.CircleCircleClosestLine(this, shape);
            else if (shape instanceof PolygonCollider) return ClosestLineJumpTable.PolygonCircleClosestLine(shape, this).flip();
            else if (shape instanceof EdgeCollider) return ClosestLineJumpTable.CircleEdgeClosestLine(this, shape).flip();
            else throw new Error(`Polygon could not collide with unknown CollisionShape ${typeof shape}`);
        }
        /**
     * @inheritdoc
     */ collide(collider) {
            if (collider instanceof CircleCollider) return CollisionJumpTable.CollideCircleCircle(this, collider);
            else if (collider instanceof PolygonCollider) return CollisionJumpTable.CollideCirclePolygon(this, collider);
            else if (collider instanceof EdgeCollider) return CollisionJumpTable.CollideCircleEdge(this, collider);
            else throw new Error(`Circle could not collide with unknown CollisionShape ${typeof collider}`);
        }
        /**
     * Find the point on the collider furthest in the direction specified
     */ getFurthestPoint(direction) {
            return this.center.add(direction.normalize().scale(this.radius));
        }
        /**
     * Find the local point on the shape in the direction specified
     * @param direction
     */ getFurthestLocalPoint(direction) {
            const dir = direction.normalize();
            return dir.scale(this.radius);
        }
        /**
     * Get the axis aligned bounding box for the circle collider in world coordinates
     */ get bounds() {
            var _a, _b, _c;
            const tx = this._transform;
            const scale = (_a = tx === null || tx === void 0 ? void 0 : tx.globalScale) !== null && _a !== void 0 ? _a : Vector.One;
            const rotation = (_b = tx === null || tx === void 0 ? void 0 : tx.globalRotation) !== null && _b !== void 0 ? _b : 0;
            const pos = (_c = tx === null || tx === void 0 ? void 0 : tx.globalPos) !== null && _c !== void 0 ? _c : Vector.Zero;
            return new BoundingBox(this.offset.x - this._naturalRadius, this.offset.y - this._naturalRadius, this.offset.x + this._naturalRadius, this.offset.y + this._naturalRadius).rotate(rotation).scale(scale).translate(pos);
        }
        /**
     * Get the axis aligned bounding box for the circle collider in local coordinates
     */ get localBounds() {
            return new BoundingBox(this.offset.x - this._naturalRadius, this.offset.y - this._naturalRadius, this.offset.x + this._naturalRadius, this.offset.y + this._naturalRadius);
        }
        /**
     * Get axis not implemented on circles, since there are infinite axis in a circle
     */ get axes() {
            return [];
        }
        /**
     * Returns the moment of inertia of a circle given it's mass
     * https://en.wikipedia.org/wiki/List_of_moments_of_inertia
     */ getInertia(mass) {
            return mass * this.radius * this.radius / 2;
        }
        /* istanbul ignore next */ update(transform) {
            var _a;
            this._transform = transform;
            const globalMat = (_a = transform.matrix) !== null && _a !== void 0 ? _a : this._globalMatrix;
            globalMat.clone(this._globalMatrix);
            this._globalMatrix.translate(this.offset.x, this.offset.y);
        }
        /**
     * Project the circle along a specified axis
     */ project(axis) {
            const scalars = [];
            const point = this.center;
            const dotProduct = point.dot(axis);
            scalars.push(dotProduct);
            scalars.push(dotProduct + this.radius);
            scalars.push(dotProduct - this.radius);
            return new Projection(Math.min.apply(Math, scalars), Math.max.apply(Math, scalars));
        }
        debug(ex, color, options) {
            var _a, _b, _c, _d;
            const { lineWidth: lineWidth } = {
                lineWidth: 1,
                ...options
            };
            const tx = this._transform;
            const scale = (_a = tx === null || tx === void 0 ? void 0 : tx.globalScale) !== null && _a !== void 0 ? _a : Vector.One;
            const rotation = (_b = tx === null || tx === void 0 ? void 0 : tx.globalRotation) !== null && _b !== void 0 ? _b : 0;
            const pos = (_c = tx === null || tx === void 0 ? void 0 : tx.globalPos) !== null && _c !== void 0 ? _c : Vector.Zero;
            ex.save();
            ex.translate(pos.x, pos.y);
            ex.rotate(rotation);
            ex.scale(scale.x, scale.y);
            ex.drawCircle((_d = this.offset) !== null && _d !== void 0 ? _d : Vector.Zero, this._naturalRadius, Color.Transparent, color, lineWidth);
            ex.restore();
        }
    }
    /**
 * Collision contacts are used internally by Excalibur to resolve collision between colliders. This
 * Pair prevents collisions from being evaluated more than one time
 */ class CollisionContact {
        constructor(colliderA, colliderB, mtv, normal, tangent, points, localPoints, info){
            var _a, _b, _c, _d, _e, _f;
            this._canceled = false;
            this.colliderA = colliderA;
            this.colliderB = colliderB;
            this.mtv = mtv;
            this.normal = normal;
            this.tangent = tangent;
            this.points = points;
            this.localPoints = localPoints;
            this.info = info;
            this.id = Pair.calculatePairHash(colliderA.id, colliderB.id);
            if (colliderA.composite || colliderB.composite) {
                // Add on the parent composite pair for start/end contact if 'together
                const colliderAId = ((_a = colliderA.composite) === null || _a === void 0 ? void 0 : _a.compositeStrategy) === "separate" ? colliderA.id : (_c = (_b = colliderA.composite) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : colliderA.id;
                const colliderBId = ((_d = colliderB.composite) === null || _d === void 0 ? void 0 : _d.compositeStrategy) === "separate" ? colliderB.id : (_f = (_e = colliderB.composite) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : colliderB.id;
                this.id += "|" + Pair.calculatePairHash(colliderAId, colliderBId);
            }
        }
        /**
     * Match contact awake state, except if body's are Fixed
     */ matchAwake() {
            const bodyA = this.colliderA.owner.get(BodyComponent);
            const bodyB = this.colliderB.owner.get(BodyComponent);
            if (bodyA && bodyB) {
                if (bodyA.sleeping !== bodyB.sleeping) {
                    if (bodyA.sleeping && bodyA.collisionType !== CollisionType.Fixed && bodyB.sleepMotion >= bodyA.wakeThreshold) bodyA.setSleeping(false);
                    if (bodyB.sleeping && bodyB.collisionType !== CollisionType.Fixed && bodyA.sleepMotion >= bodyB.wakeThreshold) bodyB.setSleeping(false);
                }
            }
        }
        isCanceled() {
            return this._canceled;
        }
        cancel() {
            this._canceled = true;
        }
    }
    class SeparatingAxis {
        static findPolygonPolygonSeparation(polyA, polyB) {
            let bestSeparation = -Number.MAX_VALUE;
            let bestSide = null;
            let bestAxis = null;
            let bestSideIndex = -1;
            let bestOtherPoint = null;
            const sides = polyA.getSides();
            const localSides = polyA.getLocalSides();
            for(let i = 0; i < sides.length; i++){
                const side = sides[i];
                const axis = side.normal();
                const vertB = polyB.getFurthestPoint(axis.negate());
                // Separation on side i's axis
                // We are looking for the largest separation between poly A's sides
                const vertSeparation = side.distanceToPoint(vertB, true);
                if (vertSeparation > bestSeparation) {
                    bestSeparation = vertSeparation;
                    bestSide = side;
                    bestAxis = axis;
                    bestSideIndex = i;
                    bestOtherPoint = vertB;
                }
            }
            return {
                collider: polyA,
                separation: bestAxis ? bestSeparation : 99,
                axis: bestAxis,
                side: bestSide,
                localSide: localSides[bestSideIndex],
                sideId: bestSideIndex,
                point: bestOtherPoint,
                localPoint: bestAxis ? polyB.getFurthestLocalPoint(bestAxis.negate()) : null
            };
        }
        static findCirclePolygonSeparation(circle, polygon) {
            const axes = polygon.axes;
            const pc = polygon.center;
            // Special SAT with circles
            const polyDir = pc.sub(circle.worldPos);
            const closestPointOnPoly = polygon.getFurthestPoint(polyDir.negate());
            axes.push(closestPointOnPoly.sub(circle.worldPos).normalize());
            let minOverlap = Number.MAX_VALUE;
            let minAxis = null;
            let minIndex = -1;
            for(let i = 0; i < axes.length; i++){
                const proj1 = polygon.project(axes[i]);
                const proj2 = circle.project(axes[i]);
                const overlap = proj1.getOverlap(proj2);
                if (overlap <= 0) return null;
                else if (overlap < minOverlap) {
                    minOverlap = overlap;
                    minAxis = axes[i];
                    minIndex = i;
                }
            }
            if (minIndex < 0) return null;
            return minAxis.normalize().scale(minOverlap);
        }
    }
    const CollisionJumpTable = {
        CollideCircleCircle (circleA, circleB) {
            const circleAPos = circleA.worldPos;
            const circleBPos = circleB.worldPos;
            const combinedRadius = circleA.radius + circleB.radius;
            const distance = circleAPos.distance(circleBPos);
            if (distance > combinedRadius) return [];
            // negative means overlap
            const separation = combinedRadius - distance;
            // Normal points from A -> B
            const normal = circleBPos.sub(circleAPos).normalize();
            const tangent = normal.perpendicular();
            const mvt = normal.scale(separation);
            const point = circleA.getFurthestPoint(normal);
            const local = circleA.getFurthestLocalPoint(normal);
            const info = {
                collider: circleA,
                separation: separation,
                axis: normal,
                point: point
            };
            return [
                new CollisionContact(circleA, circleB, mvt, normal, tangent, [
                    point
                ], [
                    local
                ], info)
            ];
        },
        CollideCirclePolygon (circle, polygon) {
            var _a, _b;
            let minAxis = SeparatingAxis.findCirclePolygonSeparation(circle, polygon);
            if (!minAxis) return [];
            // make sure that the minAxis is pointing away from circle
            const samedir = minAxis.dot(polygon.center.sub(circle.center));
            minAxis = samedir < 0 ? minAxis.negate() : minAxis;
            const point = circle.getFurthestPoint(minAxis);
            const xf = (_b = (_a = circle.owner) === null || _a === void 0 ? void 0 : _a.get(TransformComponent)) !== null && _b !== void 0 ? _b : new TransformComponent();
            const local = xf.applyInverse(point);
            const normal = minAxis.normalize();
            const info = {
                collider: circle,
                separation: -minAxis.size,
                axis: normal,
                point: point,
                localPoint: local,
                side: polygon.findSide(normal.negate()),
                localSide: polygon.findLocalSide(normal.negate())
            };
            return [
                new CollisionContact(circle, polygon, minAxis, normal, normal.perpendicular(), [
                    point
                ], [
                    local
                ], info)
            ];
        },
        CollideCircleEdge (circle, edge) {
            // TODO not sure this actually abides by local/world collisions
            // Are edge.begin and edge.end local space or world space? I think they should be local
            // center of the circle in world pos
            const cc = circle.center;
            // vector in the direction of the edge
            const edgeWorld = edge.asLine();
            const e = edgeWorld.end.sub(edgeWorld.begin);
            // amount of overlap with the circle's center along the edge direction
            const u = e.dot(edgeWorld.end.sub(cc));
            const v = e.dot(cc.sub(edgeWorld.begin));
            const side = edge.asLine();
            const localSide = edge.asLocalLine();
            // Potential region A collision (circle is on the left side of the edge, before the beginning)
            if (v <= 0) {
                const da = edgeWorld.begin.sub(cc);
                const dda = da.dot(da); // quick and dirty way of calc'n distance in r^2 terms saves some sqrts
                // save some sqrts
                if (dda > circle.radius * circle.radius) return []; // no collision
                const normal = da.normalize();
                const separation = circle.radius - Math.sqrt(dda);
                const info = {
                    collider: circle,
                    separation: separation,
                    axis: normal,
                    point: side.begin,
                    side: side,
                    localSide: localSide
                };
                return [
                    new CollisionContact(circle, edge, normal.scale(separation), normal, normal.perpendicular(), [
                        side.begin
                    ], [
                        localSide.begin
                    ], info)
                ];
            }
            // Potential region B collision (circle is on the right side of the edge, after the end)
            if (u <= 0) {
                const db = edgeWorld.end.sub(cc);
                const ddb = db.dot(db);
                if (ddb > circle.radius * circle.radius) return [];
                const normal = db.normalize();
                const separation = circle.radius - Math.sqrt(ddb);
                const info = {
                    collider: circle,
                    separation: separation,
                    axis: normal,
                    point: side.end,
                    side: side,
                    localSide: localSide
                };
                return [
                    new CollisionContact(circle, edge, normal.scale(separation), normal, normal.perpendicular(), [
                        side.end
                    ], [
                        localSide.end
                    ], info)
                ];
            }
            // Otherwise potential region AB collision (circle is in the middle of the edge between the beginning and end)
            const den = e.dot(e);
            const pointOnEdge = edgeWorld.begin.scale(u).add(edgeWorld.end.scale(v)).scale(1 / den);
            const d = cc.sub(pointOnEdge);
            const dd = d.dot(d);
            if (dd > circle.radius * circle.radius) return []; // no collision
            let normal = e.perpendicular();
            // flip correct direction
            if (normal.dot(cc.sub(edgeWorld.begin)) < 0) {
                normal.x = -normal.x;
                normal.y = -normal.y;
            }
            normal = normal.normalize();
            const separation = circle.radius - Math.sqrt(dd);
            const mvt = normal.scale(separation);
            const info = {
                collider: circle,
                separation: separation,
                axis: normal,
                point: pointOnEdge,
                side: side,
                localSide: localSide
            };
            return [
                new CollisionContact(circle, edge, mvt, normal.negate(), normal.negate().perpendicular(), [
                    pointOnEdge
                ], [
                    pointOnEdge.sub(edge.worldPos)
                ], info)
            ];
        },
        CollideEdgeEdge () {
            // Edge-edge collision doesn't make sense
            return [];
        },
        CollidePolygonEdge (polygon, edge) {
            var _a;
            const pc = polygon.center;
            const ec = edge.center;
            const dir = ec.sub(pc).normalize();
            // build a temporary polygon from the edge to use SAT
            const linePoly = new PolygonCollider({
                points: [
                    edge.begin,
                    edge.end,
                    edge.end.add(dir.scale(100)),
                    edge.begin.add(dir.scale(100))
                ],
                offset: edge.offset
            });
            linePoly.owner = edge.owner;
            const tx = (_a = edge.owner) === null || _a === void 0 ? void 0 : _a.get(TransformComponent);
            if (tx) linePoly.update(edge.owner.get(TransformComponent).get());
            // Gross hack but poly-poly works well
            const contact = this.CollidePolygonPolygon(polygon, linePoly);
            if (contact.length) {
                // Fudge the contact back to edge
                contact[0].colliderB = edge;
                contact[0].id = Pair.calculatePairHash(polygon.id, edge.id);
            }
            return contact;
        },
        CollidePolygonPolygon (polyA, polyB) {
            var _a, _b, _c, _d;
            // Multi contact from SAT
            // https://gamedev.stackexchange.com/questions/111390/multiple-contacts-for-sat-collision-detection
            // do a SAT test to find a min axis if it exists
            const separationA = SeparatingAxis.findPolygonPolygonSeparation(polyA, polyB);
            // If there is no overlap from boxA's perspective we can end early
            if (separationA.separation > 0) return [];
            const separationB = SeparatingAxis.findPolygonPolygonSeparation(polyB, polyA);
            // If there is no overlap from boxB's perspective exit now
            if (separationB.separation > 0) return [];
            // Separations are both negative, we want to pick the least negative (minimal movement)
            const separation = separationA.separation > separationB.separation ? separationA : separationB;
            // The incident side is the most opposite from the axes of collision on the other collider
            const other = separation.collider === polyA ? polyB : polyA;
            const incident = other.findSide(separation.axis.negate());
            // Clip incident side by the perpendicular lines at each end of the reference side
            // https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm
            const reference = separation.side;
            const refDir = reference.dir().normalize();
            // Find our contact points by clipping the incident by the collision side
            const clipRight = incident.clip(refDir.negate(), -refDir.dot(reference.begin));
            let clipLeft = null;
            if (clipRight) clipLeft = clipRight.clip(refDir, refDir.dot(reference.end));
            // If there is no left there is no collision
            if (clipLeft) {
                // We only want clip points below the reference edge, discard the others
                const points = clipLeft.getPoints().filter((p)=>{
                    return reference.below(p);
                });
                let normal = separation.axis;
                let tangent = normal.perpendicular();
                // Point Contact A -> B
                if (polyB.center.sub(polyA.center).dot(normal) < 0) {
                    normal = normal.negate();
                    tangent = normal.perpendicular();
                }
                // Points are clipped from incident which is the other collider
                // Store those as locals
                let localPoints = [];
                if (separation.collider === polyA) {
                    const xf = (_b = (_a = polyB.owner) === null || _a === void 0 ? void 0 : _a.get(TransformComponent)) !== null && _b !== void 0 ? _b : new TransformComponent();
                    localPoints = points.map((p)=>xf.applyInverse(p));
                } else {
                    const xf = (_d = (_c = polyA.owner) === null || _c === void 0 ? void 0 : _c.get(TransformComponent)) !== null && _d !== void 0 ? _d : new TransformComponent();
                    localPoints = points.map((p)=>xf.applyInverse(p));
                }
                return [
                    new CollisionContact(polyA, polyB, normal.scale(-separation.separation), normal, tangent, points, localPoints, separation)
                ];
            }
            return [];
        },
        FindContactSeparation (contact, localPoint) {
            var _a, _b, _c, _d;
            const shapeA = contact.colliderA;
            const txA = (_b = (_a = contact.colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(TransformComponent)) !== null && _b !== void 0 ? _b : new TransformComponent();
            const shapeB = contact.colliderB;
            const txB = (_d = (_c = contact.colliderB.owner) === null || _c === void 0 ? void 0 : _c.get(TransformComponent)) !== null && _d !== void 0 ? _d : new TransformComponent();
            // both are circles
            if (shapeA instanceof CircleCollider && shapeB instanceof CircleCollider) {
                const combinedRadius = shapeA.radius + shapeB.radius;
                const distance = txA.pos.distance(txB.pos);
                const separation = combinedRadius - distance;
                return -separation;
            }
            // both are polygons
            if (shapeA instanceof PolygonCollider && shapeB instanceof PolygonCollider) {
                if (contact.info.localSide) {
                    let side;
                    let worldPoint;
                    if (contact.info.collider === shapeA) {
                        side = new LineSegment(txA.apply(contact.info.localSide.begin), txA.apply(contact.info.localSide.end));
                        worldPoint = txB.apply(localPoint);
                    } else {
                        side = new LineSegment(txB.apply(contact.info.localSide.begin), txB.apply(contact.info.localSide.end));
                        worldPoint = txA.apply(localPoint);
                    }
                    return side.distanceToPoint(worldPoint, true);
                }
            }
            // polygon v circle
            if (shapeA instanceof PolygonCollider && shapeB instanceof CircleCollider || shapeB instanceof PolygonCollider && shapeA instanceof CircleCollider) {
                const worldPoint = txA.apply(localPoint);
                if (contact.info.side) return contact.info.side.distanceToPoint(worldPoint, true);
            }
            // polygon v edge
            if (shapeA instanceof EdgeCollider && shapeB instanceof PolygonCollider || shapeB instanceof EdgeCollider && shapeA instanceof PolygonCollider) {
                let worldPoint;
                if (contact.info.collider === shapeA) worldPoint = txB.apply(localPoint);
                else worldPoint = txA.apply(localPoint);
                if (contact.info.side) return contact.info.side.distanceToPoint(worldPoint, true);
            }
            // circle v edge
            if (shapeA instanceof CircleCollider && shapeB instanceof EdgeCollider || shapeB instanceof CircleCollider && shapeA instanceof EdgeCollider) {
                // Local point is always on the edge which is always shapeB
                const worldPoint = txB.apply(localPoint);
                let circlePoint;
                if (shapeA instanceof CircleCollider) circlePoint = shapeA.getFurthestPoint(contact.normal);
                const dist = worldPoint.distance(circlePoint);
                if (contact.info.side) return dist > 0 ? -dist : 0;
            }
            return 0;
        }
    };
    /**
 * Edge is a single line collider to create collisions with a single line.
 */ class EdgeCollider extends Collider {
        constructor(options){
            var _a;
            super();
            this._globalMatrix = AffineMatrix.identity();
            this.begin = options.begin || Vector.Zero;
            this.end = options.end || Vector.Zero;
            this.offset = (_a = options.offset) !== null && _a !== void 0 ? _a : Vector.Zero;
        }
        /**
     * Returns a clone of this Edge, not associated with any collider
     */ clone() {
            return new EdgeCollider({
                begin: this.begin.clone(),
                end: this.end.clone()
            });
        }
        get worldPos() {
            var _a;
            const tx = this._transform;
            return (_a = tx === null || tx === void 0 ? void 0 : tx.globalPos.add(this.offset)) !== null && _a !== void 0 ? _a : this.offset;
        }
        /**
     * Get the center of the collision area in world coordinates
     */ get center() {
            const begin = this._getTransformedBegin();
            const end = this._getTransformedEnd();
            const pos = begin.average(end);
            return pos;
        }
        _getTransformedBegin() {
            return this._globalMatrix.multiply(this.begin);
        }
        _getTransformedEnd() {
            return this._globalMatrix.multiply(this.end);
        }
        /**
     * Returns the slope of the line in the form of a vector
     */ getSlope() {
            const begin = this._getTransformedBegin();
            const end = this._getTransformedEnd();
            const distance = begin.distance(end);
            return end.sub(begin).scale(1 / distance);
        }
        /**
     * Returns the length of the line segment in pixels
     */ getLength() {
            const begin = this._getTransformedBegin();
            const end = this._getTransformedEnd();
            const distance = begin.distance(end);
            return distance;
        }
        /**
     * Tests if a point is contained in this collision area
     */ contains() {
            return false;
        }
        /**
     * @inheritdoc
     */ rayCast(ray, max = Infinity) {
            var _a;
            const numerator = this._getTransformedBegin().sub(ray.pos);
            // Test is line and ray are parallel and non intersecting
            if (ray.dir.cross(this.getSlope()) === 0 && numerator.cross(ray.dir) !== 0) return null;
            // Lines are parallel
            const divisor = ray.dir.cross(this.getSlope());
            if (divisor === 0) return null;
            const t = numerator.cross(this.getSlope()) / divisor;
            if (t >= 0 && t <= max) {
                const u = numerator.cross(ray.dir) / divisor / this.getLength();
                if (u >= 0 && u <= 1) return {
                    distance: t,
                    normal: this.asLine().normal(),
                    collider: this,
                    body: (_a = this.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent),
                    point: ray.getPoint(t)
                };
            }
            return null;
        }
        /**
     * Returns the closes line between this and another collider, from this -> collider
     * @param shape
     */ getClosestLineBetween(shape) {
            if (shape instanceof CircleCollider) return ClosestLineJumpTable.CircleEdgeClosestLine(shape, this);
            else if (shape instanceof PolygonCollider) return ClosestLineJumpTable.PolygonEdgeClosestLine(shape, this).flip();
            else if (shape instanceof EdgeCollider) return ClosestLineJumpTable.EdgeEdgeClosestLine(this, shape);
            else throw new Error(`Polygon could not collide with unknown CollisionShape ${typeof shape}`);
        }
        /**
     * @inheritdoc
     */ collide(shape) {
            if (shape instanceof CircleCollider) return CollisionJumpTable.CollideCircleEdge(shape, this);
            else if (shape instanceof PolygonCollider) return CollisionJumpTable.CollidePolygonEdge(shape, this);
            else if (shape instanceof EdgeCollider) return CollisionJumpTable.CollideEdgeEdge();
            else throw new Error(`Edge could not collide with unknown CollisionShape ${typeof shape}`);
        }
        /**
     * Find the point on the collider furthest in the direction specified
     */ getFurthestPoint(direction) {
            const transformedBegin = this._getTransformedBegin();
            const transformedEnd = this._getTransformedEnd();
            if (direction.dot(transformedBegin) > 0) return transformedBegin;
            else return transformedEnd;
        }
        _boundsFromBeginEnd(begin, end, padding = 10) {
            // A perfectly vertical or horizontal edge would have a bounds 0 width or height
            // this causes problems for the collision system so we give them some padding
            return new BoundingBox(Math.min(begin.x, end.x) - padding, Math.min(begin.y, end.y) - padding, Math.max(begin.x, end.x) + padding, Math.max(begin.y, end.y) + padding);
        }
        /**
     * Get the axis aligned bounding box for the edge collider in world space
     */ get bounds() {
            const transformedBegin = this._getTransformedBegin();
            const transformedEnd = this._getTransformedEnd();
            return this._boundsFromBeginEnd(transformedBegin, transformedEnd);
        }
        /**
     * Get the axis aligned bounding box for the edge collider in local space
     */ get localBounds() {
            return this._boundsFromBeginEnd(this.begin, this.end);
        }
        /**
     * Returns this edge represented as a line in world coordinates
     */ asLine() {
            return new LineSegment(this._getTransformedBegin(), this._getTransformedEnd());
        }
        /**
     * Return this edge as a line in local line coordinates (relative to the position)
     */ asLocalLine() {
            return new LineSegment(this.begin, this.end);
        }
        /**
     * Get the axis associated with the edge
     */ get axes() {
            const e = this._getTransformedEnd().sub(this._getTransformedBegin());
            const edgeNormal = e.normal();
            const axes = [];
            axes.push(edgeNormal);
            axes.push(edgeNormal.negate());
            axes.push(edgeNormal.normal());
            axes.push(edgeNormal.normal().negate());
            return axes;
        }
        /**
     * Get the moment of inertia for an edge
     * https://en.wikipedia.org/wiki/List_of_moments_of_inertia
     */ getInertia(mass) {
            const length = this.end.sub(this.begin).distance() / 2;
            return mass * length * length;
        }
        /**
     * @inheritdoc
     */ update(transform) {
            var _a;
            this._transform = transform;
            const globalMat = (_a = transform.matrix) !== null && _a !== void 0 ? _a : this._globalMatrix;
            globalMat.clone(this._globalMatrix);
            this._globalMatrix.translate(this.offset.x, this.offset.y);
        }
        /**
     * Project the edge along a specified axis
     */ project(axis) {
            const scalars = [];
            const points = [
                this._getTransformedBegin(),
                this._getTransformedEnd()
            ];
            const len = points.length;
            for(let i = 0; i < len; i++)scalars.push(points[i].dot(axis));
            return new Projection(Math.min.apply(Math, scalars), Math.max.apply(Math, scalars));
        }
        debug(ex, color) {
            const begin = this._getTransformedBegin();
            const end = this._getTransformedEnd();
            ex.drawLine(begin, end, color, 2);
            ex.drawCircle(begin, 2, color);
            ex.drawCircle(end, 2, color);
        }
    }
    class Debug {
        static registerGraphicsContext(ctx) {
            Debug._ctx = ctx;
        }
        static draw(debugDrawCall) {
            this._drawCalls.push(debugDrawCall);
        }
        static drawPoint(point, options) {
            Debug.draw((ctx)=>{
                ctx.debug.drawPoint(point, options);
            });
        }
        static drawLine(start, end, options) {
            Debug.draw((ctx)=>{
                ctx.debug.drawLine(start, end, options);
            });
        }
        static drawLines(points, options) {
            if (points.length > 1) Debug.draw((ctx)=>{
                for(let i = 0; i < points.length - 1; i++)ctx.debug.drawLine(points[i], points[i + 1], options);
            });
        }
        static drawText(text, pos) {
            Debug.draw((ctx)=>{
                ctx.debug.drawText(text, pos);
            });
        }
        static drawPolygon(points, options) {
            if (points.length > 1) Debug.draw((ctx)=>{
                const firstPoint = points[0];
                const polygon = [
                    ...points,
                    firstPoint
                ];
                for(let i = 0; i < polygon.length - 1; i++)ctx.debug.drawLine(polygon[i], polygon[i + 1], options);
            });
        }
        static drawCircle(center, radius, options) {
            const { color: color, strokeColor: strokeColor, width: width } = {
                color: Color.Black,
                strokeColor: undefined,
                width: undefined,
                ...options
            };
            Debug.draw((ctx)=>{
                ctx.drawCircle(center, radius, color, strokeColor, width);
            });
        }
        static drawBounds(boundingBox, options) {
            Debug.draw((ctx)=>{
                ctx.debug.drawRect(boundingBox.left, boundingBox.top, boundingBox.width, boundingBox.height, options);
            });
        }
        static drawRay(ray, options) {
            const { distance: distance, color: color } = {
                color: Color.Blue,
                distance: 10,
                ...options
            };
            Debug.draw((ctx)=>{
                const start = ray.pos;
                const end = ray.pos.add(ray.dir.scale(distance));
                ctx.debug.drawLine(start, end, {
                    color: color
                });
            });
        }
        static flush(ctx) {
            ctx.save();
            ctx.z = Debug.z;
            for (const drawCall of Debug._drawCalls)drawCall(ctx);
            ctx.restore();
            Debug.clear();
        }
        static clear() {
            Debug._drawCalls.length = 0;
        }
    }
    Debug._drawCalls = [];
    Debug.z = Infinity;
    /**
 * Polygon collider for detecting collisions
 */ class PolygonCollider extends Collider {
        flagDirty() {
            this._localBoundsDirty = true;
            this._localSidesDirty = true;
            this._transformedPointsDirty = true;
            this._sidesDirty = true;
        }
        /**
     * Points in the polygon in order around the perimeter in local coordinates. These are relative from the body transform position.
     * Excalibur stores these in counter-clockwise order
     */ set points(points) {
            this._points = points;
            this.flagDirty();
        }
        /**
     * Points in the polygon in order around the perimeter in local coordinates. These are relative from the body transform position.
     * Excalibur stores these in counter-clockwise order
     */ get points() {
            return this._points;
        }
        constructor(options){
            var _a, _b;
            super();
            this._logger = Logger.getInstance();
            this._transformedPoints = [];
            this._sides = [];
            this._localSides = [];
            this._globalMatrix = AffineMatrix.identity();
            this._transformedPointsDirty = true;
            this._sidesDirty = true;
            this._localSidesDirty = true;
            this._localBoundsDirty = true;
            this.offset = (_a = options.offset) !== null && _a !== void 0 ? _a : Vector.Zero;
            this._globalMatrix.translate(this.offset.x, this.offset.y);
            this.points = (_b = options.points) !== null && _b !== void 0 ? _b : [];
            const counterClockwise = this._isCounterClockwiseWinding(this.points);
            if (!counterClockwise) this.points.reverse();
            if (!this.isConvex()) {
                if (!options.suppressConvexWarning) this._logger.warn("Excalibur only supports convex polygon colliders and will not behave properly.Call PolygonCollider.triangulate() to build a new collider composed of smaller convex triangles");
            }
            // calculate initial transformation
            this._calculateTransformation();
        }
        _isCounterClockwiseWinding(points) {
            // https://stackoverflow.com/a/1165943
            let sum = 0;
            for(let i = 0; i < points.length; i++)sum += (points[(i + 1) % points.length].x - points[i].x) * (points[(i + 1) % points.length].y + points[i].y);
            return sum < 0;
        }
        /**
     * Returns if the polygon collider is convex, Excalibur does not handle non-convex collision shapes.
     * Call [[Polygon.triangulate]] to generate a [[CompositeCollider]] from this non-convex shape
     */ isConvex() {
            // From SO: https://stackoverflow.com/a/45372025
            if (this.points.length < 3) return false;
            let oldPoint = this.points[this.points.length - 2];
            let newPoint = this.points[this.points.length - 1];
            let direction = Math.atan2(newPoint.y - oldPoint.y, newPoint.x - oldPoint.x);
            let oldDirection = 0;
            let orientation = 0;
            let angleSum = 0;
            for (const [i, point] of this.points.entries()){
                oldPoint = newPoint;
                oldDirection = direction;
                newPoint = point;
                direction = Math.atan2(newPoint.y - oldPoint.y, newPoint.x - oldPoint.x);
                if (oldPoint.equals(newPoint)) return false; // repeat point
                let angle = direction - oldDirection;
                if (angle <= -Math.PI) angle += Math.PI * 2;
                else if (angle > Math.PI) angle -= Math.PI * 2;
                if (i === 0) {
                    if (angle === 0.0) return false;
                    orientation = angle > 0 ? 1 : -1;
                } else {
                    if (orientation * angle <= 0) return false;
                }
                angleSum += angle;
            }
            return Math.abs(Math.round(angleSum / (Math.PI * 2))) === 1;
        }
        /**
     * Tessellates the polygon into a triangle fan as a [[CompositeCollider]] of triangle polygons
     */ tessellate() {
            const polygons = [];
            for(let i = 1; i < this.points.length - 2; i++)polygons.push([
                this.points[0],
                this.points[i + 1],
                this.points[i + 2]
            ]);
            polygons.push([
                this.points[0],
                this.points[1],
                this.points[2]
            ]);
            return new CompositeCollider(polygons.map((points)=>Shape.Polygon(points)));
        }
        /**
     * Triangulate the polygon collider using the "Ear Clipping" algorithm.
     * Returns a new [[CompositeCollider]] made up of smaller triangles.
     */ triangulate() {
            // https://www.youtube.com/watch?v=hTJFcHutls8
            if (this.points.length < 3) throw Error("Invalid polygon");
            const triangles = [];
            // algorithm likes clockwise
            const vertices = [
                ...this.points
            ].reverse();
            let vertexCount = vertices.length;
            /**
         * Returns the previous index based on the current vertex
         */ function getPrevIndex(index) {
                return index === 0 ? vertexCount - 1 : index - 1;
            }
            /**
         * Retrieves the next index based on the current vertex
         */ function getNextIndex(index) {
                return index === vertexCount - 1 ? 0 : index + 1;
            }
            /**
         * Whether or not the angle at this vertex index is convex
         */ function isConvex(index) {
                const prev = getPrevIndex(index);
                const next = getNextIndex(index);
                const va = vertices[prev];
                const vb = vertices[index];
                const vc = vertices[next];
                // Check convexity
                const leftArm = va.sub(vb);
                const rightArm = vc.sub(vb);
                // Positive cross product is convex
                if (leftArm.cross(rightArm) < 0) return false;
                return true;
            }
            const convexVertices = vertices.map((_, i)=>isConvex(i));
            /**
         * Quick test for point in triangle
         */ function isPointInTriangle(point, a, b, c) {
                const ab = b.sub(a);
                const bc = c.sub(b);
                const ca = a.sub(c);
                const ap = point.sub(a);
                const bp = point.sub(b);
                const cp = point.sub(c);
                const cross1 = ab.cross(ap);
                const cross2 = bc.cross(bp);
                const cross3 = ca.cross(cp);
                if (cross1 > 0 || cross2 > 0 || cross3 > 0) return false;
                return true;
            }
            /**
         * Calculate the area of the triangle
         */ // function triangleArea(a: Vector, b: Vector, c: Vector) {
            //   return Math.abs(a.x * (b.y - c.y) + b.x * (c.y - a.y) + c.x * (a.y - c.y))/2;
            // }
            /**
         * Find the next suitable ear tip
         */ function findEarTip() {
                for(let i = 0; i < vertexCount; i++)if (convexVertices[i]) {
                    const prev = getPrevIndex(i);
                    const next = getNextIndex(i);
                    const va = vertices[prev];
                    const vb = vertices[i];
                    const vc = vertices[next];
                    let isEar = true;
                    // Check that if any vertices are in the triangle a, b, c
                    for(let j = 0; j < vertexCount; j++){
                        // We can skip these verts because they are the triangle we are testing
                        if (j === i || j === prev || j === next) continue;
                        const point = vertices[j];
                        if (isPointInTriangle(point, va, vb, vc)) {
                            isEar = false;
                            break;
                        }
                    }
                    // Add ear to polygon list and remove from list
                    if (isEar) return i;
                }
                // Fall back to any convex vertex
                for(let i = 0; i < vertexCount; i++){
                    if (convexVertices[i]) return i;
                }
                // bail and return the first one?
                return 0;
            }
            /**
         * Cut the ear and produce a triangle, update internal state
         */ function cutEarTip(index) {
                const prev = getPrevIndex(index);
                const next = getNextIndex(index);
                const va = vertices[prev];
                const vb = vertices[index];
                const vc = vertices[next];
                // Clockwise winding
                // if (triangleArea(va, vb, vc) > 0) {
                triangles.push([
                    va,
                    vb,
                    vc
                ]);
                // }
                vertices.splice(index, 1);
                convexVertices.splice(index, 1);
                vertexCount--;
            }
            // Loop over all the vertices finding ears
            while(vertexCount > 3){
                const earIndex = findEarTip();
                cutEarTip(earIndex);
                // reclassify vertices
                for(let i = 0; i < vertexCount; i++)convexVertices[i] = isConvex(i);
            }
            // Last triangle after the loop
            triangles.push([
                vertices[0],
                vertices[1],
                vertices[2]
            ]);
            // FIXME: there is a colinear triangle that sneaks in here sometimes
            return new CompositeCollider(triangles.map((points)=>Shape.Polygon(points, Vector.Zero, true)));
        }
        /**
     * Returns a clone of this ConvexPolygon, not associated with any collider
     */ clone() {
            return new PolygonCollider({
                offset: this.offset.clone(),
                points: this.points.map((p)=>p.clone())
            });
        }
        /**
     * Returns the world position of the collider, which is the current body transform plus any defined offset
     */ get worldPos() {
            if (this._transform) return this._transform.pos.add(this.offset);
            return this.offset;
        }
        /**
     * Get the center of the collider in world coordinates
     */ get center() {
            return this.bounds.center;
        }
        /**
     * Calculates the underlying transformation from the body relative space to world space
     */ _calculateTransformation() {
            const points = this.points;
            const len = points.length;
            this._transformedPoints.length = 0; // clear out old transform
            for(let i = 0; i < len; i++)this._transformedPoints[i] = this._globalMatrix.multiply(points[i].clone());
        }
        /**
     * Gets the points that make up the polygon in world space, from actor relative space (if specified)
     */ getTransformedPoints() {
            if (this._transformedPointsDirty) {
                this._calculateTransformation();
                this._transformedPointsDirty = false;
            }
            return this._transformedPoints;
        }
        /**
     * Gets the sides of the polygon in world space
     */ getSides() {
            if (this._sidesDirty) {
                const lines = [];
                const points = this.getTransformedPoints();
                const len = points.length;
                for(let i = 0; i < len; i++)// This winding is important
                lines.push(new LineSegment(points[i], points[(i + 1) % len]));
                this._sides = lines;
                this._sidesDirty = false;
            }
            return this._sides;
        }
        /**
     * Returns the local coordinate space sides
     */ getLocalSides() {
            if (this._localSidesDirty) {
                const lines = [];
                const points = this.points;
                const len = points.length;
                for(let i = 0; i < len; i++)// This winding is important
                lines.push(new LineSegment(points[i], points[(i + 1) % len]));
                this._localSides = lines;
                this._localSidesDirty = false;
            }
            return this._localSides;
        }
        /**
     * Given a direction vector find the world space side that is most in that direction
     * @param direction
     */ findSide(direction) {
            const sides = this.getSides();
            let bestSide = sides[0];
            let maxDistance = -Number.MAX_VALUE;
            for(let side = 0; side < sides.length; side++){
                const currentSide = sides[side];
                const sideNormal = currentSide.normal();
                const mostDirection = sideNormal.dot(direction);
                if (mostDirection > maxDistance) {
                    bestSide = currentSide;
                    maxDistance = mostDirection;
                }
            }
            return bestSide;
        }
        /**
     * Given a direction vector find the local space side that is most in that direction
     * @param direction
     */ findLocalSide(direction) {
            const sides = this.getLocalSides();
            let bestSide = sides[0];
            let maxDistance = -Number.MAX_VALUE;
            for(let side = 0; side < sides.length; side++){
                const currentSide = sides[side];
                const sideNormal = currentSide.normal();
                const mostDirection = sideNormal.dot(direction);
                if (mostDirection > maxDistance) {
                    bestSide = currentSide;
                    maxDistance = mostDirection;
                }
            }
            return bestSide;
        }
        /**
     * Get the axis associated with the convex polygon
     */ get axes() {
            const axes = [];
            const sides = this.getSides();
            for(let i = 0; i < sides.length; i++)axes.push(sides[i].normal());
            return axes;
        }
        /**
     * Updates the transform for the collision geometry
     *
     * Collision geometry (points/bounds) will not change until this is called.
     * @param transform
     */ update(transform) {
            var _a;
            if (transform) {
                this._transform = transform;
                this._transformedPointsDirty = true;
                this._sidesDirty = true;
                // This change means an update must be performed in order for geometry to update
                const globalMat = (_a = transform.matrix) !== null && _a !== void 0 ? _a : this._globalMatrix;
                globalMat.clone(this._globalMatrix);
                this._globalMatrix.translate(this.offset.x, this.offset.y);
            }
        }
        /**
     * Tests if a point is contained in this collider in world space
     */ contains(point) {
            // Always cast to the right, as long as we cast in a consistent fixed direction we
            // will be fine
            const testRay = new Ray(point, new Vector(1, 0));
            const intersectCount = this.getSides().reduce(function(accum, side) {
                if (testRay.intersect(side) >= 0) return accum + 1;
                return accum;
            }, 0);
            if (intersectCount % 2 === 0) return false;
            return true;
        }
        getClosestLineBetween(collider) {
            if (collider instanceof CircleCollider) return ClosestLineJumpTable.PolygonCircleClosestLine(this, collider);
            else if (collider instanceof PolygonCollider) return ClosestLineJumpTable.PolygonPolygonClosestLine(this, collider);
            else if (collider instanceof EdgeCollider) return ClosestLineJumpTable.PolygonEdgeClosestLine(this, collider);
            else throw new Error(`Polygon could not collide with unknown CollisionShape ${typeof collider}`);
        }
        /**
     * Returns a collision contact if the 2 colliders collide, otherwise collide will
     * return null.
     * @param collider
     */ collide(collider) {
            if (collider instanceof CircleCollider) return CollisionJumpTable.CollideCirclePolygon(collider, this);
            else if (collider instanceof PolygonCollider) return CollisionJumpTable.CollidePolygonPolygon(this, collider);
            else if (collider instanceof EdgeCollider) return CollisionJumpTable.CollidePolygonEdge(this, collider);
            else throw new Error(`Polygon could not collide with unknown CollisionShape ${typeof collider}`);
        }
        /**
     * Find the point on the collider furthest in the direction specified
     */ getFurthestPoint(direction) {
            const pts = this.getTransformedPoints();
            let furthestPoint = null;
            let maxDistance = -Number.MAX_VALUE;
            for(let i = 0; i < pts.length; i++){
                const distance = direction.dot(pts[i]);
                if (distance > maxDistance) {
                    maxDistance = distance;
                    furthestPoint = pts[i];
                }
            }
            return furthestPoint;
        }
        /**
     * Find the local point on the collider furthest in the direction specified
     * @param direction
     */ getFurthestLocalPoint(direction) {
            const pts = this.points;
            let furthestPoint = pts[0];
            let maxDistance = -Number.MAX_VALUE;
            for(let i = 0; i < pts.length; i++){
                const distance = direction.dot(pts[i]);
                if (distance > maxDistance) {
                    maxDistance = distance;
                    furthestPoint = pts[i];
                }
            }
            return furthestPoint;
        }
        /**
     * Finds the closes face to the point using perpendicular distance
     * @param point point to test against polygon
     */ getClosestFace(point) {
            const sides = this.getSides();
            let min = Number.POSITIVE_INFINITY;
            let faceIndex = -1;
            let distance = -1;
            for(let i = 0; i < sides.length; i++){
                const dist = sides[i].distanceToPoint(point);
                if (dist < min) {
                    min = dist;
                    faceIndex = i;
                    distance = dist;
                }
            }
            if (faceIndex !== -1) return {
                distance: sides[faceIndex].normal().scale(distance),
                face: sides[faceIndex]
            };
            return null;
        }
        /**
     * Get the axis aligned bounding box for the polygon collider in world coordinates
     */ get bounds() {
            return this.localBounds.transform(this._globalMatrix);
        }
        /**
     * Get the axis aligned bounding box for the polygon collider in local coordinates
     */ get localBounds() {
            if (this._localBoundsDirty) {
                this._localBounds = BoundingBox.fromPoints(this.points);
                this._localBoundsDirty = false;
            }
            return this._localBounds;
        }
        /**
     * Get the moment of inertia for an arbitrary polygon
     * https://en.wikipedia.org/wiki/List_of_moments_of_inertia
     */ getInertia(mass) {
            if (this._cachedMass === mass && this._cachedInertia) return this._cachedInertia;
            let numerator = 0;
            let denominator = 0;
            const points = this.points;
            for(let i = 0; i < points.length; i++){
                const iplusone = (i + 1) % points.length;
                const crossTerm = points[iplusone].cross(points[i]);
                numerator += crossTerm * (points[i].dot(points[i]) + points[i].dot(points[iplusone]) + points[iplusone].dot(points[iplusone]));
                denominator += crossTerm;
            }
            this._cachedMass = mass;
            return this._cachedInertia = mass / 6 * (numerator / denominator);
        }
        /**
     * Casts a ray into the polygon and returns a vector representing the point of contact (in world space) or null if no collision.
     */ rayCast(ray, max = Infinity) {
            var _a;
            // find the minimum contact time greater than 0
            // contact times less than 0 are behind the ray and we don't want those
            const sides = this.getSides();
            const len = sides.length;
            let minContactTime = Number.MAX_VALUE;
            let contactSide;
            let contactIndex = -1;
            for(let i = 0; i < len; i++){
                const contactTime = ray.intersect(sides[i]);
                if (contactTime >= 0 && contactTime < minContactTime && contactTime <= max) {
                    minContactTime = contactTime;
                    contactSide = sides[i];
                    contactIndex = i;
                }
            }
            // contact was found
            if (contactIndex >= 0) return {
                collider: this,
                distance: minContactTime,
                body: (_a = this.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent),
                point: ray.getPoint(minContactTime),
                normal: contactSide.normal()
            };
            // no contact found
            return null;
        }
        /**
     * Project the edges of the polygon along a specified axis
     */ project(axis) {
            const points = this.getTransformedPoints();
            const len = points.length;
            let min = Number.MAX_VALUE;
            let max = -Number.MAX_VALUE;
            for(let i = 0; i < len; i++){
                const scalar = points[i].dot(axis);
                min = Math.min(min, scalar);
                max = Math.max(max, scalar);
            }
            return new Projection(min, max);
        }
        debug(ex, color, options) {
            const points = this.getTransformedPoints();
            Debug.drawPolygon(points, {
                color: color
            });
        }
    }
    /**
 * Excalibur helper for defining colliders quickly
 */ class Shape {
        /**
     * Creates a box collider, under the hood defines a [[PolygonCollider]] collider
     * @param width Width of the box
     * @param height Height of the box
     * @param anchor Anchor of the box (default (.5, .5)) which positions the box relative to the center of the collider's position
     * @param offset Optional offset relative to the collider in local coordinates
     */ static Box(width, height, anchor = Vector.Half, offset = Vector.Zero) {
            return new PolygonCollider({
                points: new BoundingBox(-width * anchor.x, -height * anchor.y, width - width * anchor.x, height - height * anchor.y).getPoints(),
                offset: offset
            });
        }
        /**
     * Creates a new [[PolygonCollider|arbitrary polygon]] collider
     *
     * PolygonColliders are useful for creating convex polygon shapes
     * @param points Points specified in counter clockwise
     * @param offset Optional offset relative to the collider in local coordinates
     */ static Polygon(points, offset = Vector.Zero, suppressConvexWarning = false) {
            return new PolygonCollider({
                points: points,
                offset: offset,
                suppressConvexWarning: suppressConvexWarning
            });
        }
        /**
     * Creates a new [[CircleCollider|circle]] collider
     *
     * Circle colliders are useful for balls, or to make collisions more forgiving on sharp edges
     * @param radius Radius of the circle collider
     * @param offset Optional offset relative to the collider in local coordinates
     */ static Circle(radius, offset = Vector.Zero) {
            return new CircleCollider({
                radius: radius,
                offset: offset
            });
        }
        /**
     * Creates a new [[EdgeCollider|edge]] collider
     *
     * Edge colliders are useful for  floors, walls, and other barriers
     * @param begin Beginning of the edge in local coordinates to the collider
     * @param end Ending of the edge in local coordinates to the collider
     */ static Edge(begin, end) {
            return new EdgeCollider({
                begin: begin,
                end: end
            });
        }
        /**
     * Creates a new capsule shaped [[CompositeCollider]] using 2 circles and a box
     *
     * Capsule colliders are useful for platformers with incline or jagged floors to have a smooth
     * player experience.
     * @param width
     * @param height
     * @param offset Optional offset
     */ static Capsule(width, height, offset = Vector.Zero) {
            const logger = Logger.getInstance();
            if (width === height) logger.warn("A capsule collider with equal width and height is a circle, consider using a ex.Shape.Circle or ex.CircleCollider");
            const vertical = height >= width;
            if (vertical) {
                // height > width, if equal maybe use a circle
                const capsule = new CompositeCollider([
                    Shape.Circle(width / 2, vec(0, -height / 2 + width / 2).add(offset)),
                    Shape.Box(width, height - width, Vector.Half, offset),
                    Shape.Circle(width / 2, vec(0, height / 2 - width / 2).add(offset))
                ]);
                return capsule;
            } else {
                // width > height, if equal maybe use a circle
                const capsule = new CompositeCollider([
                    Shape.Circle(height / 2, vec(-width / 2 + height / 2, 0).add(offset)),
                    Shape.Box(width - height, height, Vector.Half, offset),
                    Shape.Circle(height / 2, vec(width / 2 - height / 2, 0).add(offset))
                ]);
                return capsule;
            }
        }
    }
    class ColliderComponent extends Component {
        constructor(collider){
            super();
            this.events = new EventEmitter();
            /**
         * Observable that notifies when a collider is added to the body
         */ this.$colliderAdded = new Observable();
            /**
         * Observable that notifies when a collider is removed from the body
         */ this.$colliderRemoved = new Observable();
            this._collidersToRemove = [];
            this.set(collider);
        }
        /**
     * Get the current collider geometry
     */ get() {
            return this._collider;
        }
        /**
     * Set the collider geometry
     * @param collider
     * @returns the collider you set
     */ set(collider) {
            this.clear();
            if (collider) {
                this._collider = collider;
                this._collider.owner = this.owner;
                collider.events.pipe(this.events);
                this.$colliderAdded.notifyAll(collider);
                this.update();
            }
            return collider;
        }
        /**
     * Remove collider geometry from collider component
     */ clear() {
            if (this._collider) {
                this._collidersToRemove.push(this._collider);
                this._collider = null;
            }
        }
        processColliderRemoval() {
            for (const collider of this._collidersToRemove){
                collider.events.unpipe(this.events);
                this.$colliderRemoved.notifyAll(collider);
                collider.owner = null;
            }
        }
        clone() {
            const clone = new ColliderComponent(this._collider.clone());
            return clone;
        }
        /**
     * Return world space bounds
     */ get bounds() {
            var _a, _b;
            return (_b = (_a = this._collider) === null || _a === void 0 ? void 0 : _a.bounds) !== null && _b !== void 0 ? _b : new BoundingBox();
        }
        /**
     * Return local space bounds
     */ get localBounds() {
            var _a, _b;
            return (_b = (_a = this._collider) === null || _a === void 0 ? void 0 : _a.localBounds) !== null && _b !== void 0 ? _b : new BoundingBox();
        }
        /**
     * Update the collider's transformed geometry
     */ update() {
            var _a;
            const tx = (_a = this.owner) === null || _a === void 0 ? void 0 : _a.get(TransformComponent);
            if (this._collider) {
                this._collider.owner = this.owner;
                if (tx) this._collider.update(tx.get());
            }
        }
        /**
     * Collide component with another
     * @param other
     */ collide(other) {
            let colliderA = this._collider;
            let colliderB = other._collider;
            if (!colliderA || !colliderB) return [];
            // If we have a composite left hand side :(
            // Might bite us, but to avoid updating all the handlers make composite always left side
            let flipped = false;
            if (colliderB instanceof CompositeCollider) {
                colliderA = colliderB;
                colliderB = this._collider;
                flipped = true;
            }
            if (this._collider) {
                const contacts = colliderA.collide(colliderB);
                if (contacts) {
                    if (flipped) contacts.forEach((contact)=>{
                        contact.mtv = contact.mtv.negate();
                        contact.normal = contact.normal.negate();
                        contact.tangent = contact.normal.perpendicular();
                        contact.colliderA = this._collider;
                        contact.colliderB = other._collider;
                    });
                    return contacts;
                }
                return [];
            }
            return [];
        }
        onAdd(entity) {
            if (this._collider) this.update();
            // Wire up the collider events to the owning entity
            this.events.on("precollision", (evt)=>{
                const precollision = evt;
                entity.events.emit("precollision", new PreCollisionEvent(precollision.target.owner, precollision.other.owner, precollision.side, precollision.intersection, precollision.contact));
                if (entity instanceof Actor) entity.onPreCollisionResolve(precollision.target, precollision.other, precollision.side, precollision.contact);
            });
            this.events.on("postcollision", (evt)=>{
                const postcollision = evt;
                entity.events.emit("postcollision", new PostCollisionEvent(postcollision.target.owner, postcollision.other.owner, postcollision.side, postcollision.intersection, postcollision.contact));
                if (entity instanceof Actor) entity.onPostCollisionResolve(postcollision.target, postcollision.other, postcollision.side, postcollision.contact);
            });
            this.events.on("collisionstart", (evt)=>{
                const start = evt;
                entity.events.emit("collisionstart", new CollisionStartEvent(start.target.owner, start.other.owner, start.side, start.contact));
                if (entity instanceof Actor) entity.onCollisionStart(start.target, start.other, start.side, start.contact);
            });
            this.events.on("collisionend", (evt)=>{
                const end = evt;
                entity.events.emit("collisionend", new CollisionEndEvent(end.target.owner, end.other.owner, end.side, end.lastContact));
                if (entity instanceof Actor) entity.onCollisionEnd(end.target, end.other, end.side, end.lastContact);
            });
        }
        onRemove() {
            this.events.clear();
            this.$colliderRemoved.notifyAll(this._collider);
        }
        /**
     * Sets up a box geometry based on the current bounds of the associated actor of this physics body.
     *
     * If no width/height are specified the body will attempt to use the associated actor's width/height.
     *
     * By default, the box is center is at (0, 0) which means it is centered around the actors anchor.
     */ useBoxCollider(width, height, anchor = Vector.Half, center = Vector.Zero) {
            const collider = Shape.Box(width, height, anchor, center);
            return this.set(collider);
        }
        /**
     * Sets up a [[PolygonCollider|polygon]] collision geometry based on a list of of points relative
     *  to the anchor of the associated actor
     * of this physics body.
     *
     * Only [convex polygon](https://en.wikipedia.org/wiki/Convex_polygon) definitions are supported.
     *
     * By default, the box is center is at (0, 0) which means it is centered around the actors anchor.
     */ usePolygonCollider(points, center = Vector.Zero) {
            const poly = Shape.Polygon(points, center);
            return this.set(poly);
        }
        /**
     * Sets up a [[Circle|circle collision geometry]] as the only collider with a specified radius in pixels.
     *
     * By default, the box is center is at (0, 0) which means it is centered around the actors anchor.
     */ useCircleCollider(radius, center = Vector.Zero) {
            const collider = Shape.Circle(radius, center);
            return this.set(collider);
        }
        /**
     * Sets up an [[Edge|edge collision geometry]] with a start point and an end point relative to the anchor of the associated actor
     * of this physics body.
     *
     * By default, the box is center is at (0, 0) which means it is centered around the actors anchor.
     */ useEdgeCollider(begin, end) {
            const collider = Shape.Edge(begin, end);
            return this.set(collider);
        }
        /**
     * Setups up a [[CompositeCollider]] which can define any arbitrary set of excalibur colliders
     * @param colliders
     */ useCompositeCollider(colliders) {
            return this.set(new CompositeCollider(colliders));
        }
    }
    var DegreeOfFreedom;
    (function(DegreeOfFreedom) {
        DegreeOfFreedom["Rotation"] = "rotation";
        DegreeOfFreedom["X"] = "x";
        DegreeOfFreedom["Y"] = "y";
    })(DegreeOfFreedom || (DegreeOfFreedom = {}));
    /**
 * Body describes all the physical properties pos, vel, acc, rotation, angular velocity for the purpose of
 * of physics simulation.
 */ class BodyComponent extends Component {
        constructor(options){
            var _a, _b, _c;
            super();
            this.dependencies = [
                TransformComponent,
                MotionComponent
            ];
            this.id = createId("body", BodyComponent._ID++);
            this.events = new EventEmitter();
            this.oldTransform = new transform_Transform();
            /**
         * Indicates whether the old transform has been captured at least once for interpolation
         * @internal
         */ this.__oldTransformCaptured = false;
            /**
         * Enable or disabled the fixed update interpolation, by default interpolation is on.
         */ this.enableFixedUpdateInterpolate = true;
            /**
         * Collision type for the rigidbody physics simulation, by default [[CollisionType.PreventCollision]]
         */ this.collisionType = CollisionType.PreventCollision;
            /**
         * The collision group for the body's colliders, by default body colliders collide with everything
         */ this.group = CollisionGroup.All;
            this._sleeping = false;
            /**
         * The also known as coefficient of restitution of this actor, represents the amount of energy preserved after collision or the
         * bounciness. If 1, it is 100% bouncy, 0 it completely absorbs.
         */ this.bounciness = 0.2;
            /**
         * The coefficient of friction on this actor
         */ this.friction = 0.99;
            /**
         * Should use global gravity [[Physics.gravity]] in it's physics simulation, default is true
         */ this.useGravity = true;
            /**
         * Degrees of freedom to limit
         *
         * Note: this only limits responses in the realistic solver, if velocity/angularVelocity is set the actor will still respond
         */ this.limitDegreeOfFreedom = [];
            /**
         * The velocity of the actor last frame (vx, vy) in pixels/second
         */ this.oldVel = new Vector(0, 0);
            /**
         * Gets/sets the acceleration of the actor from the last frame. This does not include the global acc [[Physics.acc]].
         */ this.oldAcc = Vector.Zero;
            if (options) {
                this.collisionType = (_a = options.type) !== null && _a !== void 0 ? _a : this.collisionType;
                this.group = (_b = options.group) !== null && _b !== void 0 ? _b : this.group;
                this.useGravity = (_c = options.useGravity) !== null && _c !== void 0 ? _c : this.useGravity;
                this._bodyConfig = {
                    ...DefaultPhysicsConfig.bodies,
                    ...options.config
                };
            } else this._bodyConfig = {
                ...DefaultPhysicsConfig.bodies
            };
            this.updatePhysicsConfig(this._bodyConfig);
            this._mass = BodyComponent._DEFAULT_CONFIG.defaultMass;
        }
        get matrix() {
            return this.transform.get().matrix;
        }
        /**
     * Called by excalibur to update physics config defaults if they change
     * @param config
     */ updatePhysicsConfig(config) {
            this._bodyConfig = {
                ...DefaultPhysicsConfig.bodies,
                ...config
            };
            this.canSleep = this._bodyConfig.canSleepByDefault;
            this.sleepMotion = this._bodyConfig.sleepEpsilon * 5;
            this.wakeThreshold = this._bodyConfig.wakeThreshold;
        }
        /**
     * Called by excalibur to update defaults
     * @param config
     */ static updateDefaultPhysicsConfig(config) {
            BodyComponent._DEFAULT_CONFIG = config;
        }
        get mass() {
            return this._mass;
        }
        set mass(newMass) {
            this._mass = newMass;
            this._cachedInertia = undefined;
            this._cachedInverseInertia = undefined;
        }
        /**
     * The inverse mass (1/mass) of the body. If [[CollisionType.Fixed]] this is 0, meaning "infinite" mass
     */ get inverseMass() {
            return this.collisionType === CollisionType.Fixed ? 0 : 1 / this.mass;
        }
        /**
     * Whether this body is sleeping or not
     */ get sleeping() {
            return this._sleeping;
        }
        /**
     * Set the sleep state of the body
     * @param sleeping
     */ setSleeping(sleeping) {
            this._sleeping = sleeping;
            if (!sleeping) // Give it a kick to keep it from falling asleep immediately
            this.sleepMotion = this._bodyConfig.sleepEpsilon * 5;
            else {
                this.vel = Vector.Zero;
                this.acc = Vector.Zero;
                this.angularVelocity = 0;
                this.sleepMotion = 0;
            }
        }
        /**
     * Update body's [[BodyComponent.sleepMotion]] for the purpose of sleeping
     */ updateMotion() {
            if (this._sleeping) this.setSleeping(true);
            const currentMotion = this.vel.size * this.vel.size + Math.abs(this.angularVelocity * this.angularVelocity);
            const bias = this._bodyConfig.sleepBias;
            this.sleepMotion = bias * this.sleepMotion + (1 - bias) * currentMotion;
            this.sleepMotion = clamp(this.sleepMotion, 0, 10 * this._bodyConfig.sleepEpsilon);
            if (this.canSleep && this.sleepMotion < this._bodyConfig.sleepEpsilon) this.setSleeping(true);
        }
        /**
     * Get the moment of inertia from the [[ColliderComponent]]
     */ get inertia() {
            if (this._cachedInertia) return this._cachedInertia;
            // Inertia is a property of the geometry, so this is a little goofy but seems to be okay?
            const collider = this.owner.get(ColliderComponent);
            if (collider) {
                collider.$colliderAdded.subscribe(()=>{
                    this._cachedInertia = null;
                });
                collider.$colliderRemoved.subscribe(()=>{
                    this._cachedInertia = null;
                });
                const maybeCollider = collider.get();
                if (maybeCollider) return this._cachedInertia = maybeCollider.getInertia(this.mass);
            }
            return 0;
        }
        /**
     * Get the inverse moment of inertial from the [[ColliderComponent]]. If [[CollisionType.Fixed]] this is 0, meaning "infinite" mass
     */ get inverseInertia() {
            if (this._cachedInverseInertia) return this._cachedInverseInertia;
            return this._cachedInverseInertia = this.collisionType === CollisionType.Fixed ? 0 : 1 / this.inertia;
        }
        /**
     * Returns if the owner is active
     */ get active() {
            var _a;
            return !!((_a = this.owner) === null || _a === void 0 ? void 0 : _a.active);
        }
        /**
     * @deprecated Use globalP0s
     */ get center() {
            return this.globalPos;
        }
        get transform() {
            var _a;
            return (_a = this.owner) === null || _a === void 0 ? void 0 : _a.get(TransformComponent);
        }
        get motion() {
            var _a;
            return (_a = this.owner) === null || _a === void 0 ? void 0 : _a.get(MotionComponent);
        }
        get pos() {
            return this.transform.pos;
        }
        set pos(val) {
            this.transform.pos = val;
        }
        /**
     * The (x, y) position of the actor this will be in the middle of the actor if the
     * [[Actor.anchor]] is set to (0.5, 0.5) which is default.
     * If you want the (x, y) position to be the top left of the actor specify an anchor of (0, 0).
     */ get globalPos() {
            return this.transform.globalPos;
        }
        set globalPos(val) {
            this.transform.globalPos = val;
        }
        /**
     * The position of the actor last frame (x, y) in pixels
     */ get oldPos() {
            return this.oldTransform.pos;
        }
        /**
     * The current velocity vector (vx, vy) of the actor in pixels/second
     */ get vel() {
            return this.motion.vel;
        }
        set vel(val) {
            this.motion.vel = val;
        }
        /**
     * The current acceleration vector (ax, ay) of the actor in pixels/second/second. An acceleration pointing down such as (0, 100) may
     * be useful to simulate a gravitational effect.
     */ get acc() {
            return this.motion.acc;
        }
        set acc(val) {
            this.motion.acc = val;
        }
        /**
     * The current torque applied to the actor
     */ get torque() {
            return this.motion.torque;
        }
        set torque(val) {
            this.motion.torque = val;
        }
        /**
     * Gets/sets the rotation of the body from the last frame.
     */ get oldRotation() {
            return this.oldTransform.rotation;
        }
        /**
     * The rotation of the body in radians
     */ get rotation() {
            return this.transform.globalRotation;
        }
        set rotation(val) {
            this.transform.globalRotation = val;
        }
        /**
     * The scale vector of the actor
     */ get scale() {
            return this.transform.globalScale;
        }
        set scale(val) {
            this.transform.globalScale = val;
        }
        /**
     * The scale of the actor last frame
     */ get oldScale() {
            return this.oldTransform.scale;
        }
        /**
     * The scale rate of change of the actor in scale/second
     */ get scaleFactor() {
            return this.motion.scaleFactor;
        }
        set scaleFactor(scaleFactor) {
            this.motion.scaleFactor = scaleFactor;
        }
        /**
     * Get the angular velocity in radians/second
     */ get angularVelocity() {
            return this.motion.angularVelocity;
        }
        /**
     * Set the angular velocity in radians/second
     */ set angularVelocity(value) {
            this.motion.angularVelocity = value;
        }
        /**
     * Apply a specific impulse to the body
     * @param point
     * @param impulse
     */ applyImpulse(point, impulse) {
            if (this.collisionType !== CollisionType.Active) return; // only active objects participate in the simulation
            const finalImpulse = impulse.scale(this.inverseMass);
            if (this.limitDegreeOfFreedom.includes(DegreeOfFreedom.X)) finalImpulse.x = 0;
            if (this.limitDegreeOfFreedom.includes(DegreeOfFreedom.Y)) finalImpulse.y = 0;
            this.vel.addEqual(finalImpulse);
            if (!this.limitDegreeOfFreedom.includes(DegreeOfFreedom.Rotation)) {
                const distanceFromCenter = point.sub(this.globalPos);
                this.angularVelocity += this.inverseInertia * distanceFromCenter.cross(impulse);
            }
        }
        /**
     * Apply only linear impulse to the body
     * @param impulse
     */ applyLinearImpulse(impulse) {
            if (this.collisionType !== CollisionType.Active) return; // only active objects participate in the simulation
            const finalImpulse = impulse.scale(this.inverseMass);
            if (this.limitDegreeOfFreedom.includes(DegreeOfFreedom.X)) finalImpulse.x = 0;
            if (this.limitDegreeOfFreedom.includes(DegreeOfFreedom.Y)) finalImpulse.y = 0;
            this.vel = this.vel.add(finalImpulse);
        }
        /**
     * Apply only angular impulse to the body
     * @param point
     * @param impulse
     */ applyAngularImpulse(point, impulse) {
            if (this.collisionType !== CollisionType.Active) return; // only active objects participate in the simulation
            if (!this.limitDegreeOfFreedom.includes(DegreeOfFreedom.Rotation)) {
                const distanceFromCenter = point.sub(this.globalPos);
                this.angularVelocity += this.inverseInertia * distanceFromCenter.cross(impulse);
            }
        }
        /**
     * Sets the old versions of pos, vel, acc, and scale.
     */ captureOldTransform() {
            // Capture old values before integration step updates them
            this.__oldTransformCaptured = true;
            const tx = this.transform.get();
            tx.clone(this.oldTransform);
            this.oldTransform.parent = tx.parent; // also grab parent
            this.oldVel.setTo(this.vel.x, this.vel.y);
            this.oldAcc.setTo(this.acc.x, this.acc.y);
        }
        clone() {
            const component = super.clone();
            return component;
        }
    }
    BodyComponent._ID = 0;
    BodyComponent._DEFAULT_CONFIG = {
        ...DefaultPhysicsConfig.bodies
    };
    /**
 * AddedComponent message
 */ class AddedComponent {
        constructor(data){
            this.data = data;
            this.type = "Component Added";
        }
    }
    /**
 * Type guard to know if message is f an Added Component
 */ function isAddedComponent(x) {
        return !!x && x.type === "Component Added";
    }
    /**
 * RemovedComponent message
 */ class RemovedComponent {
        constructor(data){
            this.data = data;
            this.type = "Component Removed";
        }
    }
    /**
 * Type guard to know if message is for a Removed Component
 */ function isRemovedComponent(x) {
        return !!x && x.type === "Component Removed";
    }
    const EntityEvents = {
        Initialize: "initialize",
        PreUpdate: "preupdate",
        PostUpdate: "postupdate",
        Kill: "kill"
    };
    /**
 * An Entity is the base type of anything that can have behavior in Excalibur, they are part of the built in entity component system
 *
 * Entities can be strongly typed with the components they contain
 *
 * ```typescript
 * const entity = new Entity<ComponentA | ComponentB>();
 * entity.components.a; // Type ComponentA
 * entity.components.b; // Type ComponentB
 * ```
 */ class Entity {
        constructor(componentsOrOptions, name){
            /**
         * The unique identifier for the entity
         */ this.id = Entity._ID++;
            this.name = `Entity#${this.id}`;
            /**
         * Listen to or emit events for an entity
         */ this.events = new EventEmitter();
            this._tags = new Set();
            this.componentAdded$ = new Observable;
            this.componentRemoved$ = new Observable;
            this.tagAdded$ = new Observable;
            this.tagRemoved$ = new Observable;
            /**
         * Current components on the entity
         *
         * **Do not modify**
         *
         * Use addComponent/removeComponent otherwise the ECS will not be notified of changes.
         */ this.components = new Map();
            this._componentsToRemove = [];
            this._instanceOfComponentCacheDirty = true;
            this._instanceOfComponentCache = new Map();
            /**
         * The current scene that the entity is in, if any
         */ this.scene = null;
            /**
         * Whether this entity is active, if set to false it will be reclaimed
         */ this.active = true;
            this._parent = null;
            this.childrenAdded$ = new Observable();
            this.childrenRemoved$ = new Observable();
            this._children = [];
            this._isInitialized = false;
            let componentsToAdd;
            let nameToAdd;
            if (Array.isArray(componentsOrOptions)) {
                componentsToAdd = componentsOrOptions;
                nameToAdd = name;
            } else if (componentsOrOptions && typeof componentsOrOptions === "object") {
                const { components: components, name: name } = componentsOrOptions;
                componentsToAdd = components;
                nameToAdd = name;
            }
            if (nameToAdd) this.name = nameToAdd;
            if (componentsToAdd) for (const component of componentsToAdd)this.addComponent(component);
        // this.addComponent(this.tagsComponent);
        }
        /**
     * Kill the entity, means it will no longer be updated. Kills are deferred to the end of the update.
     * If parented it will be removed from the parent when killed.
     */ kill() {
            if (this.active) {
                this.active = false;
                this.unparent();
            }
            this.emit("kill", new KillEvent(this));
        }
        isKilled() {
            return !this.active;
        }
        /**
     * Specifically get the tags on the entity from [[TagsComponent]]
     */ get tags() {
            return this._tags;
        }
        /**
     * Check if a tag exists on the entity
     * @param tag name to check for
     */ hasTag(tag) {
            return this._tags.has(tag);
        }
        /**
     * Adds a tag to an entity
     * @param tag
     */ addTag(tag) {
            this._tags.add(tag);
            this.tagAdded$.notifyAll(tag);
            return this;
        }
        /**
     * Removes a tag on the entity
     *
     * Removals are deferred until the end of update
     * @param tag
     */ removeTag(tag) {
            this._tags.delete(tag);
            this.tagRemoved$.notifyAll(tag);
            return this;
        }
        /**
     * The types of the components on the Entity
     */ get types() {
            return Array.from(this.components.keys());
        }
        /**
     * Returns all component instances on entity
     */ getComponents() {
            return Array.from(this.components.values());
        }
        /**
     * Verifies that an entity has all the required types
     * @param requiredTypes
     */ hasAll(requiredTypes) {
            for(let i = 0; i < requiredTypes.length; i++){
                if (!this.components.has(requiredTypes[i])) return false;
            }
            return true;
        }
        /**
     * Verifies that an entity has all the required tags
     * @param requiredTags
     */ hasAllTags(requiredTags) {
            for(let i = 0; i < requiredTags.length; i++){
                if (!this.tags.has(requiredTags[i])) return false;
            }
            return true;
        }
        _getCachedInstanceOfType(type) {
            if (this._instanceOfComponentCacheDirty) {
                this._instanceOfComponentCacheDirty = false;
                this._instanceOfComponentCache.clear();
            }
            if (this._instanceOfComponentCache.has(type)) return this._instanceOfComponentCache.get(type);
            for (const instance of this.components.values())if (instance instanceof type) {
                this._instanceOfComponentCache.set(type, instance);
                return instance;
            }
            return undefined;
        }
        get(type) {
            const maybeComponent = this._getCachedInstanceOfType(type);
            return maybeComponent !== null && maybeComponent !== void 0 ? maybeComponent : this.components.get(type);
        }
        get parent() {
            return this._parent;
        }
        /**
     * Get the direct children of this entity
     */ get children() {
            return this._children;
        }
        /**
     * Unparents this entity, if there is a parent. Otherwise it does nothing.
     */ unparent() {
            if (this._parent) {
                this._parent.removeChild(this);
                this._parent = null;
            }
        }
        /**
     * Adds an entity to be a child of this entity
     * @param entity
     */ addChild(entity) {
            if (entity.parent === null) {
                if (this.getAncestors().includes(entity)) throw new Error("Cycle detected, cannot add entity");
                this._children.push(entity);
                entity._parent = this;
                this.childrenAdded$.notifyAll(entity);
            } else throw new Error("Entity already has a parent, cannot add without unparenting");
            return this;
        }
        /**
     * Remove an entity from children if it exists
     * @param entity
     */ removeChild(entity) {
            if (entity.parent === this) {
                removeItemFromArray(entity, this._children);
                entity._parent = null;
                this.childrenRemoved$.notifyAll(entity);
            }
            return this;
        }
        /**
     * Removes all children from this entity
     */ removeAllChildren() {
            // Avoid modifying the array issue by walking backwards
            for(let i = this.children.length - 1; i >= 0; i--)this.removeChild(this.children[i]);
            return this;
        }
        /**
     * Returns a list of parent entities starting with the topmost parent. Includes the current entity.
     */ getAncestors() {
            const result = [
                this
            ];
            let current = this.parent;
            while(current){
                result.push(current);
                current = current.parent;
            }
            return result.reverse();
        }
        /**
     * Returns a list of all the entities that descend from this entity. Includes the current entity.
     */ getDescendants() {
            let result = [
                this
            ];
            let queue = [
                this
            ];
            while(queue.length > 0){
                const curr = queue.pop();
                if (curr) {
                    queue = queue.concat(curr.children);
                    result = result.concat(curr.children);
                }
            }
            return result;
        }
        /**
     * Creates a deep copy of the entity and a copy of all its components
     */ clone() {
            const newEntity = new Entity();
            for (const c of this.types){
                const componentInstance = this.get(c);
                if (componentInstance) newEntity.addComponent(componentInstance.clone());
            }
            for (const child of this.children)newEntity.addChild(child.clone());
            return newEntity;
        }
        /**
     * Adds a copy of all the components from another template entity as a "prefab"
     * @param templateEntity Entity to use as a template
     * @param force Force component replacement if it already exists on the target entity
     */ addTemplate(templateEntity, force = false) {
            for (const c of templateEntity.getComponents())this.addComponent(c.clone(), force);
            for (const child of templateEntity.children)this.addChild(child.clone().addTemplate(child));
            return this;
        }
        /**
     * Adds a component to the entity
     * @param component Component or Entity to add copy of components from
     * @param force Optionally overwrite any existing components of the same type
     */ addComponent(component, force = false) {
            this._instanceOfComponentCacheDirty = true;
            // if component already exists, skip if not forced
            if (this.has(component.constructor)) {
                if (force) // Remove existing component type if exists when forced
                this.removeComponent(component.constructor, true);
                else // early exit component exits
                return this;
            }
            // TODO circular dependencies will be a problem
            if (component.dependencies && component.dependencies.length) for (const ctor of component.dependencies)this.addComponent(new ctor());
            component.owner = this;
            this.components.set(component.constructor, component);
            if (component.onAdd) component.onAdd(this);
            this.componentAdded$.notifyAll(component);
            return this;
        }
        /**
     * Removes a component from the entity, by default removals are deferred to the end of entity update to avoid consistency issues
     *
     * Components can be force removed with the `force` flag, the removal is not deferred and happens immediately
     * @param typeOrInstance
     * @param force
     */ removeComponent(typeOrInstance, force = false) {
            let type;
            if (isComponentCtor(typeOrInstance)) type = typeOrInstance;
            else type = typeOrInstance.constructor;
            if (force) {
                const componentToRemove = this.components.get(type);
                if (componentToRemove) {
                    this.componentRemoved$.notifyAll(componentToRemove);
                    componentToRemove.owner = undefined;
                    if (componentToRemove.onRemove) componentToRemove.onRemove(this);
                }
                this.components.delete(type); // remove after the notify to preserve typing
                this._instanceOfComponentCacheDirty = true;
            } else this._componentsToRemove.push(type);
            return this;
        }
        clearComponents() {
            const components = this.types;
            for (const c of components)this.removeComponent(c);
        }
        /**
     * @hidden
     * @internal
     */ processComponentRemoval() {
            for (const type of this._componentsToRemove)this.removeComponent(type, true);
            this._componentsToRemove.length = 0;
        }
        /**
     * Check if a component type exists
     * @param type
     */ has(type) {
            return this.components.has(type);
        }
        /**
     * Gets whether the actor is Initialized
     */ get isInitialized() {
            return this._isInitialized;
        }
        /**
     * Initializes this entity, meant to be called by the Scene before first update not by users of Excalibur.
     *
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     * @internal
     */ _initialize(engine) {
            if (!this.isInitialized) {
                this.onInitialize(engine);
                this.events.emit("initialize", new InitializeEvent(engine, this));
                this._isInitialized = true;
            }
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPreUpdate]] lifecycle event
     * @internal
     */ _preupdate(engine, delta) {
            this.events.emit("preupdate", new PreUpdateEvent(engine, delta, this));
            this.onPreUpdate(engine, delta);
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPostUpdate]] lifecycle event
     * @internal
     */ _postupdate(engine, delta) {
            this.events.emit("postupdate", new PostUpdateEvent(engine, delta, this));
            this.onPostUpdate(engine, delta);
        }
        /**
     * `onInitialize` is called before the first update of the entity. This method is meant to be
     * overridden.
     *
     * Synonymous with the event handler `.on('initialize', (evt) => {...})`
     */ onInitialize(engine) {
        // Override me
        }
        /**
     * Safe to override onPreUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPreUpdate` is called directly before an entity is updated.
     */ onPreUpdate(engine, delta) {
        // Override me
        }
        /**
     * Safe to override onPostUpdate lifecycle event handler. Synonymous with `.on('postupdate', (evt) =>{...})`
     *
     * `onPostUpdate` is called directly after an entity is updated.
     */ onPostUpdate(engine, delta) {
        // Override me
        }
        /**
     *
     * Entity update lifecycle, called internally
     * @internal
     * @param engine
     * @param delta
     */ update(engine, delta) {
            this._initialize(engine);
            this._preupdate(engine, delta);
            for (const child of this.children)child.update(engine, delta);
            this._postupdate(engine, delta);
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            if (handler) this.events.off(eventName, handler);
            else this.events.off(eventName);
        }
    }
    Entity._ID = 0;
    var AnimationDirection;
    (function(AnimationDirection) {
        /**
     * Animation is playing forwards
     */ AnimationDirection["Forward"] = "forward";
        /**
     * Animation is playing backwards
     */ AnimationDirection["Backward"] = "backward";
    })(AnimationDirection || (AnimationDirection = {}));
    var AnimationStrategy;
    (function(AnimationStrategy) {
        /**
     * Animation ends without displaying anything
     */ AnimationStrategy["End"] = "end";
        /**
     * Animation loops to the first frame after the last frame
     */ AnimationStrategy["Loop"] = "loop";
        /**
     * Animation plays to the last frame, then backwards to the first frame, then repeats
     */ AnimationStrategy["PingPong"] = "pingpong";
        /**
     * Animation ends stopping on the last frame
     */ AnimationStrategy["Freeze"] = "freeze";
    })(AnimationStrategy || (AnimationStrategy = {}));
    const AnimationEvents = {
        Frame: "frame",
        Loop: "loop",
        End: "end"
    };
    /**
 * Create an Animation given a list of [[Frame|frames]] in [[AnimationOptions]]
 *
 * To create an Animation from a [[SpriteSheet]], use [[Animation.fromSpriteSheet]]
 */ class Animation extends Graphic {
        constructor(options){
            var _a, _b, _c;
            super(options);
            this.events = new EventEmitter();
            this.frames = [];
            this.strategy = AnimationStrategy.Loop;
            this.frameDuration = 100;
            this._idempotencyToken = -1;
            this._firstTick = true;
            this._currentFrame = 0;
            this._timeLeftInFrame = 0;
            this._pingPongDirection = 1;
            this._done = false;
            this._playing = true;
            this._speed = 1;
            this._reversed = false;
            this.frames = options.frames;
            this.speed = (_a = options.speed) !== null && _a !== void 0 ? _a : this.speed;
            this.strategy = (_b = options.strategy) !== null && _b !== void 0 ? _b : this.strategy;
            this.frameDuration = options.totalDuration ? options.totalDuration / this.frames.length : (_c = options.frameDuration) !== null && _c !== void 0 ? _c : this.frameDuration;
            if (options.reverse) this.reverse();
            this.goToFrame(0);
        }
        clone() {
            return new Animation({
                frames: this.frames.map((f)=>({
                        ...f
                    })),
                frameDuration: this.frameDuration,
                speed: this.speed,
                reverse: this._reversed,
                strategy: this.strategy,
                ...this.cloneGraphicOptions()
            });
        }
        get width() {
            const maybeFrame = this.currentFrame;
            if (maybeFrame) return Math.abs(maybeFrame.graphic.width * this.scale.x);
            return 0;
        }
        get height() {
            const maybeFrame = this.currentFrame;
            if (maybeFrame) return Math.abs(maybeFrame.graphic.height * this.scale.y);
            return 0;
        }
        /**
     * Create an Animation from a [[SpriteSheet]], a list of indices into the sprite sheet, a duration per frame
     * and optional [[AnimationStrategy]]
     *
     * Example:
     * ```typescript
     * const spriteSheet = SpriteSheet.fromImageSource({...});
     *
     * const anim = Animation.fromSpriteSheet(spriteSheet, range(0, 5), 200, AnimationStrategy.Loop);
     * ```
     * @param spriteSheet
     * @param frameIndices
     * @param durationPerFrameMs
     * @param strategy
     */ static fromSpriteSheet(spriteSheet, frameIndices, durationPerFrameMs, strategy = AnimationStrategy.Loop) {
            const maxIndex = spriteSheet.sprites.length - 1;
            const invalidIndices = frameIndices.filter((index)=>index < 0 || index > maxIndex);
            if (invalidIndices.length) Animation._LOGGER.warn(`Indices into SpriteSheet were provided that don\'t exist: ${invalidIndices.join(",")} no frame will be shown`);
            return new Animation({
                frames: spriteSheet.sprites.filter((_, index)=>frameIndices.indexOf(index) > -1).map((f)=>({
                        graphic: f,
                        duration: durationPerFrameMs
                    })),
                strategy: strategy
            });
        }
        /**
     * Create an [[Animation]] from a [[SpriteSheet]] given a list of coordinates
     *
     * Example:
     * ```typescript
     * const spriteSheet = SpriteSheet.fromImageSource({...});
     *
     * const anim = Animation.fromSpriteSheetCoordinates({
     *  spriteSheet,
     *  frameCoordinates: [
     *    {x: 0, y: 5, duration: 100, options { flipHorizontal: true }},
     *    {x: 1, y: 5, duration: 200},
     *    {x: 2, y: 5, duration: 100},
     *    {x: 3, y: 5, duration: 500}
     *  ],
     *  strategy: AnimationStrategy.PingPong
     * });
     * ```
     * @param options
     * @returns Animation
     */ static fromSpriteSheetCoordinates(options) {
            const { spriteSheet: spriteSheet, frameCoordinates: frameCoordinates, durationPerFrameMs: durationPerFrameMs, speed: speed, strategy: strategy, reverse: reverse } = options;
            const defaultDuration = durationPerFrameMs !== null && durationPerFrameMs !== void 0 ? durationPerFrameMs : 100;
            const frames = [];
            for (const coord of frameCoordinates){
                const { x: x, y: y, duration: duration, options: options } = coord;
                const sprite = spriteSheet.getSprite(x, y, options);
                if (sprite) frames.push({
                    graphic: sprite,
                    duration: duration !== null && duration !== void 0 ? duration : defaultDuration
                });
                else Animation._LOGGER.warn(`Skipping frame! SpriteSheet does not have coordinate (${x}, ${y}), please check your SpriteSheet to confirm that sprite exists`);
            }
            return new Animation({
                frames: frames,
                strategy: strategy,
                speed: speed,
                reverse: reverse
            });
        }
        /**
     * Current animation speed
     *
     * 1 meaning normal 1x speed.
     * 2 meaning 2x speed and so on.
     */ get speed() {
            return this._speed;
        }
        /**
     * Current animation speed
     *
     * 1 meaning normal 1x speed.
     * 2 meaning 2x speed and so on.
     */ set speed(val) {
            this._speed = clamp(Math.abs(val), 0, Infinity);
        }
        /**
     * Returns the current Frame of the animation
     *
     * Use [[Animation.currentFrameIndex]] to get the frame number and
     * [[Animation.goToFrame]] to set the current frame index
     */ get currentFrame() {
            if (this._currentFrame >= 0 && this._currentFrame < this.frames.length) return this.frames[this._currentFrame];
            return null;
        }
        /**
     * Returns the current frame index of the animation
     *
     * Use [[Animation.currentFrame]] to grab the current [[Frame]] object
     */ get currentFrameIndex() {
            return this._currentFrame;
        }
        /**
     * Returns the amount of time in milliseconds left in the current frame
     */ get currentFrameTimeLeft() {
            return this._timeLeftInFrame;
        }
        /**
     * Returns `true` if the animation is playing
     */ get isPlaying() {
            return this._playing;
        }
        /**
     * Reverses the play direction of the Animation, this preserves the current frame
     */ reverse() {
            // Don't mutate with the original frame list, create a copy
            this.frames = this.frames.slice().reverse();
            this._reversed = !this._reversed;
        }
        /**
     * Returns the current play direction of the animation
     */ get direction() {
            // Keep logically consistent with ping-pong direction
            // If ping-pong is forward = 1 and reversed is true then we are logically reversed
            const reversed = this._reversed && this._pingPongDirection === 1 ? true : false;
            return reversed ? AnimationDirection.Backward : AnimationDirection.Forward;
        }
        /**
     * Plays or resumes the animation from the current frame
     */ play() {
            this._playing = true;
        }
        /**
     * Pauses the animation on the current frame
     */ pause() {
            this._playing = false;
            this._firstTick = true; // firstTick must be set to emit the proper frame event
        }
        /**
     * Reset the animation back to the beginning, including if the animation were done
     */ reset() {
            this._done = false;
            this._firstTick = true;
            this._currentFrame = 0;
            this._timeLeftInFrame = this.frameDuration;
            const maybeFrame = this.frames[this._currentFrame];
            if (maybeFrame) this._timeLeftInFrame = (maybeFrame === null || maybeFrame === void 0 ? void 0 : maybeFrame.duration) || this.frameDuration;
        }
        /**
     * Returns `true` if the animation can end
     */ get canFinish() {
            switch(this.strategy){
                case AnimationStrategy.End:
                case AnimationStrategy.Freeze:
                    return true;
                default:
                    return false;
            }
        }
        /**
     * Returns `true` if the animation is done, for looping type animations
     * `ex.AnimationStrategy.PingPong` and `ex.AnimationStrategy.Loop` this will always return `false`
     *
     * See the `ex.Animation.canFinish()` method to know if an animation type can end
     */ get done() {
            return this._done;
        }
        /**
     * Jump the animation immediately to a specific frame if it exists
     *
     * Optionally specify an override for the duration of the frame, useful for
     * keeping multiple animations in sync with one another.
     * @param frameNumber
     * @param duration
     */ goToFrame(frameNumber, duration) {
            this._currentFrame = frameNumber;
            this._timeLeftInFrame = duration !== null && duration !== void 0 ? duration : this.frameDuration;
            const maybeFrame = this.frames[this._currentFrame];
            if (maybeFrame && !this._done) {
                this._timeLeftInFrame = duration !== null && duration !== void 0 ? duration : (maybeFrame === null || maybeFrame === void 0 ? void 0 : maybeFrame.duration) || this.frameDuration;
                this.events.emit("frame", {
                    ...maybeFrame,
                    frameIndex: this.currentFrameIndex
                });
            }
        }
        _nextFrame() {
            const currentFrame = this._currentFrame;
            if (this._done) return currentFrame;
            let next = -1;
            switch(this.strategy){
                case AnimationStrategy.Loop:
                    next = (currentFrame + 1) % this.frames.length;
                    if (next === 0) this.events.emit("loop", this);
                    break;
                case AnimationStrategy.End:
                    next = currentFrame + 1;
                    if (next >= this.frames.length) {
                        this._done = true;
                        this._currentFrame = this.frames.length;
                        this.events.emit("end", this);
                    }
                    break;
                case AnimationStrategy.Freeze:
                    next = clamp(currentFrame + 1, 0, this.frames.length - 1);
                    if (next >= this.frames.length - 1) {
                        this._done = true;
                        this.events.emit("end", this);
                    }
                    break;
                case AnimationStrategy.PingPong:
                    if (currentFrame + this._pingPongDirection >= this.frames.length) {
                        this._pingPongDirection = -1;
                        this.events.emit("loop", this);
                    }
                    if (currentFrame + this._pingPongDirection < 0) {
                        this._pingPongDirection = 1;
                        this.events.emit("loop", this);
                    }
                    next = currentFrame + this._pingPongDirection % this.frames.length;
                    break;
            }
            return next;
        }
        /**
     * Called internally by Excalibur to update the state of the animation potential update the current frame
     * @param elapsedMilliseconds Milliseconds elapsed
     * @param idempotencyToken Prevents double ticking in a frame by passing a unique token to the frame
     */ tick(elapsedMilliseconds, idempotencyToken = 0) {
            if (this._idempotencyToken === idempotencyToken) return;
            this._idempotencyToken = idempotencyToken;
            if (!this._playing) return;
            // if it's the first frame emit frame event
            if (this._firstTick) {
                this._firstTick = false;
                this.events.emit("frame", {
                    ...this.currentFrame,
                    frameIndex: this.currentFrameIndex
                });
            }
            this._timeLeftInFrame -= elapsedMilliseconds * this._speed;
            if (this._timeLeftInFrame <= 0) this.goToFrame(this._nextFrame());
        }
        _drawImage(ctx, x, y) {
            if (this.currentFrame) this.currentFrame.graphic.draw(ctx, x, y);
        }
    }
    Animation._LOGGER = Logger.getInstance();
    class GraphicsGroup extends Graphic {
        constructor(options){
            var _a;
            super(options);
            this._logger = Logger.getInstance();
            this.useAnchor = true;
            this.members = [];
            this.members = options.members;
            this.useAnchor = (_a = options.useAnchor) !== null && _a !== void 0 ? _a : this.useAnchor;
            this._updateDimensions();
        }
        clone() {
            return new GraphicsGroup({
                members: [
                    ...this.members
                ],
                ...this.cloneGraphicOptions()
            });
        }
        _updateDimensions() {
            const bb = this.localBounds;
            this.width = bb.width;
            this.height = bb.height;
            return bb;
        }
        get localBounds() {
            let bb = new BoundingBox();
            for (const member of this.members)if (member instanceof Graphic) bb = member.localBounds.combine(bb);
            else {
                const { graphic: graphic, offset: pos, useBounds: useBounds } = member;
                const shouldUseBounds = useBounds === undefined ? true : useBounds;
                if (graphic) {
                    if (shouldUseBounds) bb = graphic.localBounds.translate(pos).combine(bb);
                } else this._logger.warnOnce(`Graphics group member has an null or undefined graphic, member definition: ${JSON.stringify(member)}.`);
            }
            return bb;
        }
        _isAnimationOrGroup(graphic) {
            return graphic instanceof Animation || graphic instanceof GraphicsGroup;
        }
        tick(elapsedMilliseconds, idempotencyToken) {
            for (const member of this.members){
                let graphic;
                if (member instanceof Graphic) graphic = member;
                else graphic = member.graphic;
                if (this._isAnimationOrGroup(graphic)) graphic.tick(elapsedMilliseconds, idempotencyToken);
            }
        }
        reset() {
            for (const member of this.members){
                let graphic;
                if (member instanceof Graphic) graphic = member;
                else graphic = member.graphic;
                if (this._isAnimationOrGroup(graphic)) graphic.reset();
            }
        }
        _preDraw(ex, x, y) {
            this._updateDimensions();
            super._preDraw(ex, this.useAnchor ? x : 0, this.useAnchor ? y : 0);
        }
        _drawImage(ex, x, y) {
            const pos = Vector.Zero;
            for (const member of this.members){
                let graphic;
                if (member instanceof Graphic) graphic = member;
                else {
                    graphic = member.graphic;
                    member.offset.clone(pos);
                }
                if (!graphic) continue;
                ex.save();
                ex.translate(x, y);
                graphic.draw(ex, pos.x, pos.y);
                if (this.showDebug) /* istanbul ignore next */ ex.debug.drawRect(0, 0, this.width, this.height);
                ex.restore();
            }
        }
    }
    /**
 * Type guard for checking if a Graphic HasTick (used for graphics that change over time like animations)
 * @param graphic
 */ function hasGraphicsTick(graphic) {
        return !!graphic.tick;
    }
    /**
 * Component to manage drawings, using with the position component
 */ class GraphicsComponent extends Component {
        /**
     * Offset to apply to graphics by default
     */ get offset() {
            return new WatchVector(this._offset, ()=>{
                this.recalculateBounds();
            });
        }
        set offset(value) {
            this._offset = value;
            this.recalculateBounds();
        }
        /**
     * Anchor to apply to graphics by default
     */ get anchor() {
            return new WatchVector(this._anchor, ()=>{
                this.recalculateBounds();
            });
        }
        set anchor(value) {
            this._anchor = value;
            this.recalculateBounds();
        }
        constructor(options){
            super();
            this._logger = Logger.getInstance();
            this._current = "default";
            this._graphics = {};
            this._options = {};
            this.material = null;
            /**
         * Sets or gets wether any drawing should be visible in this component
         */ this.visible = true;
            /**
         * Sets or gets wither all drawings should have an opacity applied
         */ this.opacity = 1;
            this._offset = Vector.Zero;
            this._anchor = Vector.Half;
            /**
         * Flip all graphics horizontally along the y-axis
         */ this.flipHorizontal = false;
            /**
         * Flip all graphics vertically along the x-axis
         */ this.flipVertical = false;
            /**
         * If set to true graphics added to the component will be copied. This can effect performance, but is useful if you don't want
         * changes to a graphic to effect all the places it is used.
         */ this.copyGraphics = false;
            this._localBounds = null;
            // Defaults
            options = {
                visible: this.visible,
                graphics: {},
                ...options
            };
            const { current: current, anchor: anchor, opacity: opacity, visible: visible, graphics: graphics, offset: offset, copyGraphics: copyGraphics, onPreDraw: onPreDraw, onPostDraw: onPostDraw, onPreTransformDraw: onPreTransformDraw, onPostTransformDraw: onPostTransformDraw } = options;
            for (const [key, graphicOrOptions] of Object.entries(graphics))if (graphicOrOptions instanceof Graphic) this._graphics[key] = graphicOrOptions;
            else {
                this._graphics[key] = graphicOrOptions.graphic;
                this._options[key] = graphicOrOptions.options;
            }
            this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
            this.opacity = opacity !== null && opacity !== void 0 ? opacity : this.opacity;
            this.anchor = anchor !== null && anchor !== void 0 ? anchor : this.anchor;
            this.copyGraphics = copyGraphics !== null && copyGraphics !== void 0 ? copyGraphics : this.copyGraphics;
            this.onPreDraw = onPreDraw !== null && onPreDraw !== void 0 ? onPreDraw : this.onPreDraw;
            this.onPostDraw = onPostDraw !== null && onPostDraw !== void 0 ? onPostDraw : this.onPostDraw;
            this.onPreDraw = onPreTransformDraw !== null && onPreTransformDraw !== void 0 ? onPreTransformDraw : this.onPreTransformDraw;
            this.onPostTransformDraw = onPostTransformDraw !== null && onPostTransformDraw !== void 0 ? onPostTransformDraw : this.onPostTransformDraw;
            this.visible = !!visible;
            this._current = current !== null && current !== void 0 ? current : this._current;
            if (current && this._graphics[current]) this.use(current);
        }
        getGraphic(name) {
            return this._graphics[name];
        }
        getOptions(name) {
            return this._options[name];
        }
        /**
     * Get registered graphics names
     */ getNames() {
            return Object.keys(this._graphics);
        }
        /**
     * Returns the currently displayed graphic
     */ get current() {
            return this._graphics[this._current];
        }
        /**
     * Returns the currently displayed graphic offsets
     */ get currentOptions() {
            return this._options[this._current];
        }
        /**
     * Returns all graphics associated with this component
     */ get graphics() {
            return this._graphics;
        }
        /**
     * Returns all graphics options associated with this component
     */ get options() {
            return this._options;
        }
        add(nameOrGraphic, graphicOrOptions, options) {
            let name = "default";
            let graphicToSet = null;
            let optionsToSet = undefined;
            if (typeof nameOrGraphic === "string" && graphicOrOptions instanceof Graphic) {
                name = nameOrGraphic;
                graphicToSet = graphicOrOptions;
                optionsToSet = options;
            }
            if (nameOrGraphic instanceof Graphic && !(graphicOrOptions instanceof Graphic)) {
                graphicToSet = nameOrGraphic;
                optionsToSet = graphicOrOptions;
            }
            this._graphics[name] = this.copyGraphics ? graphicToSet.clone() : graphicToSet;
            this._options[name] = this.copyGraphics ? {
                ...optionsToSet
            } : optionsToSet;
            if (name === "default") this.use("default");
            return graphicToSet;
        }
        /**
     * Removes a registered graphic, if the removed graphic is the current it will switch to the default
     * @param name
     */ remove(name) {
            delete this._graphics[name];
            delete this._options[name];
            if (this._current === name) {
                this._current = "default";
                this.recalculateBounds();
            }
        }
        /**
     * Shows a graphic, will be removed
     * @param nameOrGraphic
     * @param options
     * @deprecated will be removed in v0.30.0, use `graphics.use(...)`
     */ show(nameOrGraphic, options) {
            return this.use(nameOrGraphic, options);
        }
        /**
     * Use a graphic only, will set the default graphic. Returns the new [[Graphic]]
     *
     * Optionally override the stored options
     * @param nameOrGraphic
     * @param options
     */ use(nameOrGraphic, options) {
            var _a;
            if (nameOrGraphic instanceof Graphic) {
                let graphic = nameOrGraphic;
                if (this.copyGraphics) graphic = nameOrGraphic.clone();
                this._current = "default";
                this._graphics[this._current] = graphic;
                this._options[this._current] = options;
            } else {
                this._current = nameOrGraphic;
                this._options[this._current] = options;
                if (!(this._current in this._graphics)) this._logger.warn(`Graphic ${this._current} is not registered with the graphics component owned by ${(_a = this.owner) === null || _a === void 0 ? void 0 : _a.name}. Nothing will be drawn.`);
            }
            this.recalculateBounds();
            return this.current;
        }
        /**
     * Hide currently shown graphic
     */ hide() {
            this._current = "ex.none";
        }
        set localBounds(bounds) {
            this._localBounds = bounds;
        }
        recalculateBounds() {
            let bb = new BoundingBox();
            const graphic = this._graphics[this._current];
            const options = this._options[this._current];
            if (!graphic) {
                this._localBounds = bb;
                return;
            }
            let anchor = this.anchor;
            let offset = this.offset;
            if (options === null || options === void 0 ? void 0 : options.anchor) anchor = options.anchor;
            if (options === null || options === void 0 ? void 0 : options.offset) offset = options.offset;
            const bounds = graphic.localBounds;
            const offsetX = -bounds.width * anchor.x + offset.x;
            const offsetY = -bounds.height * anchor.y + offset.y;
            if (graphic instanceof GraphicsGroup && !graphic.useAnchor) bb = graphic === null || graphic === void 0 ? void 0 : graphic.localBounds.combine(bb);
            else bb = graphic === null || graphic === void 0 ? void 0 : graphic.localBounds.translate(vec(offsetX, offsetY)).combine(bb);
            this._localBounds = bb;
        }
        /**
     * Get local bounds of graphics component
     */ get localBounds() {
            if (!this._localBounds || this._localBounds.hasZeroDimensions()) this.recalculateBounds();
            return this._localBounds;
        }
        /**
     * Get world bounds of graphics component
     */ get bounds() {
            let bounds = this.localBounds;
            if (this.owner) {
                const tx = this.owner.get(TransformComponent);
                if (tx) bounds = bounds.transform(tx.get().matrix);
            }
            return bounds;
        }
        /**
     * Update underlying graphics if necessary, called internally
     * @param elapsed
     * @internal
     */ update(elapsed, idempotencyToken = 0) {
            const graphic = this.current;
            if (graphic && hasGraphicsTick(graphic)) graphic.tick(elapsed, idempotencyToken);
        }
        clone() {
            const graphics = new GraphicsComponent();
            graphics._graphics = {
                ...this._graphics
            };
            graphics._options = {
                ...this._options
            };
            graphics.offset = this.offset.clone();
            graphics.opacity = this.opacity;
            graphics.anchor = this.anchor.clone();
            graphics.copyGraphics = this.copyGraphics;
            graphics.onPreDraw = this.onPreDraw;
            graphics.onPostDraw = this.onPostDraw;
            graphics.visible = this.visible;
            return graphics;
        }
    }
    /**
 * A Rectangle [[Graphic]] for drawing rectangles to the [[ExcaliburGraphicsContext]]
 */ class Rectangle extends Raster {
        constructor(options){
            super(options);
            this.width = options.width;
            this.height = options.height;
            this.rasterize();
        }
        clone() {
            return new Rectangle({
                width: this.width,
                height: this.height,
                ...this.cloneGraphicOptions(),
                ...this.cloneRasterOptions()
            });
        }
        execute(ctx) {
            if (this.color) ctx.fillRect(0, 0, this.width, this.height);
            if (this.strokeColor) ctx.strokeRect(0, 0, this.width, this.height);
        }
    }
    /**
 * A circle [[Graphic]] for drawing circles to the [[ExcaliburGraphicsContext]]
 *
 * Circles default to [[ImageFiltering.Blended]]
 */ class Circle extends Raster {
        get radius() {
            return this._radius;
        }
        set radius(value) {
            this._radius = value;
            this.width = this._radius * 2;
            this.height = this._radius * 2;
            this.flagDirty();
        }
        constructor(options){
            var _a, _b, _c;
            super(options);
            this._radius = 0;
            const lineWidth = (_a = options.lineWidth) !== null && _a !== void 0 ? _a : options.strokeColor ? 1 : 0; // default lineWidth in canvas is 1px
            this.padding = (_b = options.padding) !== null && _b !== void 0 ? _b : 2 + lineWidth / 2; // default 2 padding for circles looks nice
            this.radius = options.radius;
            this.filtering = (_c = options.filtering) !== null && _c !== void 0 ? _c : ImageFiltering.Blended;
            this.rasterize();
        }
        clone() {
            return new Circle({
                radius: this.radius,
                ...this.cloneGraphicOptions(),
                ...this.cloneRasterOptions()
            });
        }
        execute(ctx) {
            if (this.radius > 0) {
                ctx.beginPath();
                ctx.arc(this.radius, this.radius, this.radius, 0, Math.PI * 2);
                if (this.color) ctx.fill();
                if (this.strokeColor) ctx.stroke();
            }
        }
    }
    /**
 * Add this component to optionally configure how the pointer
 * system detects pointer events.
 *
 * By default the collider shape is used and graphics bounds is not.
 *
 * If both collider shape and graphics bounds are enabled it will fire events if either or
 * are intersecting the pointer.
 */ class PointerComponent extends Component {
        constructor(options){
            var _a, _b;
            super();
            /**
         * Use any existing Collider component geometry for pointer events. This is useful if you want
         * user pointer events only to trigger on the same collision geometry used in the collider component
         * for collision resolution. Default is `true`.
         */ this.useColliderShape = true;
            /**
         * Use any existing Graphics component bounds for pointers. This is useful if you want the axis aligned
         * bounds around the graphic to trigger pointer events. Default is `true`.
         */ this.useGraphicsBounds = true;
            this.useColliderShape = (_a = options === null || options === void 0 ? void 0 : options.useColliderShape) !== null && _a !== void 0 ? _a : this.useColliderShape;
            this.useGraphicsBounds = (_b = options === null || options === void 0 ? void 0 : options.useGraphicsBounds) !== null && _b !== void 0 ? _b : this.useGraphicsBounds;
            this.localBounds = options === null || options === void 0 ? void 0 : options.localBounds;
        }
    }
    /**
 * Standard easing functions for motion in Excalibur, defined on a domain of [0, duration] and a range from [+startValue,+endValue]
 * Given a time, the function will return a value from positive startValue to positive endValue.
 *
 * ```js
 * function Linear (t) {
 *    return t * t;
 * }
 *
 * // accelerating from zero velocity
 * function EaseInQuad (t) {
 *    return t * t;
 * }
 *
 * // decelerating to zero velocity
 * function EaseOutQuad (t) {
 *    return t * (2 - t);
 * }
 *
 * // acceleration until halfway, then deceleration
 * function EaseInOutQuad (t) {
 *    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
 * }
 *
 * // accelerating from zero velocity
 * function EaseInCubic (t) {
 *    return t * t * t;
 * }
 *
 * // decelerating to zero velocity
 * function EaseOutCubic (t) {
 *    return (--t) * t * t + 1;
 * }
 *
 * // acceleration until halfway, then deceleration
 * function EaseInOutCubic (t) {
 *    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
 * }
 * ```
 */ class EasingFunctions {
        static CreateReversibleEasingFunction(easing) {
            return (time, start, end, duration)=>{
                if (end < start) return start - (easing(time, end, start, duration) - end);
                else return easing(time, start, end, duration);
            };
        }
        static CreateVectorEasingFunction(easing) {
            return (time, start, end, duration)=>{
                return new Vector(easing(time, start.x, end.x, duration), easing(time, start.y, end.y, duration));
            };
        }
    }
    EasingFunctions.Linear = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        return endValue * currentTime / duration + startValue;
    });
    EasingFunctions.EaseInQuad = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        currentTime /= duration;
        return endValue * currentTime * currentTime + startValue;
    });
    EasingFunctions.EaseOutQuad = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        currentTime /= duration;
        return -endValue * currentTime * (currentTime - 2) + startValue;
    });
    EasingFunctions.EaseInOutQuad = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        currentTime /= duration / 2;
        if (currentTime < 1) return endValue / 2 * currentTime * currentTime + startValue;
        currentTime--;
        return -endValue / 2 * (currentTime * (currentTime - 2) - 1) + startValue;
    });
    EasingFunctions.EaseInCubic = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        currentTime /= duration;
        return endValue * currentTime * currentTime * currentTime + startValue;
    });
    EasingFunctions.EaseOutCubic = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        currentTime /= duration;
        currentTime--;
        return endValue * (currentTime * currentTime * currentTime + 1) + startValue;
    });
    EasingFunctions.EaseInOutCubic = EasingFunctions.CreateReversibleEasingFunction((currentTime, startValue, endValue, duration)=>{
        endValue = endValue - startValue;
        currentTime /= duration / 2;
        if (currentTime < 1) return endValue / 2 * currentTime * currentTime * currentTime + startValue;
        currentTime -= 2;
        return endValue / 2 * (currentTime * currentTime * currentTime + 2) + startValue;
    });
    /**
 * Action Queues represent an ordered sequence of actions
 *
 * Action queues are part of the [[ActionContext|Action API]] and
 * store the list of actions to be executed for an [[Actor]].
 *
 * Actors implement [[Actor.actions]] which can be manipulated by
 * advanced users to adjust the actions currently being executed in the
 * queue.
 */ class ActionQueue {
        constructor(entity){
            this._actions = [];
            this._currentAction = null;
            this._completedActions = [];
            this._entity = entity;
        }
        /**
     * Add an action to the sequence
     * @param action
     */ add(action) {
            this._actions.push(action);
        }
        /**
     * Remove an action by reference from the sequence
     * @param action
     */ remove(action) {
            const index = this._actions.indexOf(action);
            this._actions.splice(index, 1);
        }
        /**
     * Removes all actions from this sequence
     */ clearActions() {
            this._actions.length = 0;
            this._completedActions.length = 0;
            if (this._currentAction) this._currentAction.stop();
        }
        /**
     *
     * @returns The total list of actions in this sequence complete or not
     */ getActions() {
            return this._actions.concat(this._completedActions);
        }
        /**
     *
     * @returns `true` if there are more actions to process in the sequence
     */ hasNext() {
            return this._actions.length > 0;
        }
        /**
     * @returns `true` if the current sequence of actions is done
     */ isComplete() {
            return this._actions.length === 0;
        }
        /**
     * Resets the sequence of actions, this is used to restart a sequence from the beginning
     */ reset() {
            this._actions = this.getActions();
            const len = this._actions.length;
            for(let i = 0; i < len; i++)this._actions[i].reset();
            this._completedActions = [];
        }
        /**
     * Update the queue which updates actions and handles completing actions
     * @param elapsedMs
     */ update(elapsedMs) {
            if (this._actions.length > 0) {
                if (this._currentAction !== this._actions[0]) {
                    this._currentAction = this._actions[0];
                    this._entity.emit("actionstart", new ActionStartEvent(this._currentAction, this._entity));
                }
                this._currentAction.update(elapsedMs);
                if (this._currentAction.isComplete(this._entity)) {
                    this._entity.emit("actioncomplete", new ActionCompleteEvent(this._currentAction, this._entity));
                    const complete = this._actions.shift();
                    if (complete) this._completedActions.push(complete);
                }
            }
        }
    }
    class Repeat {
        constructor(entity, repeatBuilder, repeat){
            this._stopped = false;
            this._repeatBuilder = repeatBuilder;
            this._repeatContext = new ActionContext(entity);
            this._actionQueue = this._repeatContext.getQueue();
            this._repeat = repeat;
            this._originalRepeat = repeat;
            this._repeatBuilder(this._repeatContext);
            this._repeat--; // current execution is the first repeat
        }
        update(delta) {
            if (this._actionQueue.isComplete()) {
                this._actionQueue.clearActions();
                this._repeatBuilder(this._repeatContext);
                this._repeat--;
            }
            this._actionQueue.update(delta);
        }
        isComplete() {
            return this._stopped || this._repeat <= 0 && this._actionQueue.isComplete();
        }
        stop() {
            this._stopped = true;
        }
        reset() {
            this._repeat = this._originalRepeat;
        }
    }
    /**
 * RepeatForever Action implementation, it is recommended you use the fluent action
 * context API.
 *
 *
 */ class RepeatForever {
        constructor(entity, repeatBuilder){
            this._stopped = false;
            this._repeatBuilder = repeatBuilder;
            this._repeatContext = new ActionContext(entity);
            this._actionQueue = this._repeatContext.getQueue();
            this._repeatBuilder(this._repeatContext);
        }
        update(delta) {
            if (this._stopped) return;
            if (this._actionQueue.isComplete()) {
                this._actionQueue.clearActions();
                this._repeatBuilder(this._repeatContext);
            }
            this._actionQueue.update(delta);
        }
        isComplete() {
            return this._stopped;
        }
        stop() {
            this._stopped = true;
            this._actionQueue.clearActions();
        }
        reset() {
            return;
        }
    }
    class MoveBy {
        constructor(entity, offsetX, offsetY, speed){
            this._started = false;
            this._stopped = false;
            this._entity = entity;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._speed = speed;
            this._offset = new Vector(offsetX, offsetY);
            if (speed <= 0) {
                Logger.getInstance().error("Attempted to moveBy with speed less than or equal to zero : " + speed);
                throw new Error("Speed must be greater than 0 pixels per second");
            }
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._start = new Vector(this._tx.pos.x, this._tx.pos.y);
                this._end = this._start.add(this._offset);
                this._distance = this._offset.size;
                this._dir = this._end.sub(this._start).normalize();
            }
            if (this.isComplete(this._entity)) {
                this._tx.pos = vec(this._end.x, this._end.y);
                this._motion.vel = vec(0, 0);
            } else this._motion.vel = this._dir.scale(this._speed);
        }
        isComplete(entity) {
            const tx = entity.get(TransformComponent);
            return this._stopped || tx.pos.distance(this._start) >= this._distance;
        }
        stop() {
            this._motion.vel = vec(0, 0);
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    class MoveTo {
        constructor(entity, destx, desty, speed){
            this.entity = entity;
            this._started = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._end = new Vector(destx, desty);
            this._speed = speed;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._start = new Vector(this._tx.pos.x, this._tx.pos.y);
                this._distance = this._start.distance(this._end);
                this._dir = this._end.sub(this._start).normalize();
            }
            const m = this._dir.scale(this._speed);
            this._motion.vel = vec(m.x, m.y);
            if (this.isComplete(this.entity)) {
                this._tx.pos = vec(this._end.x, this._end.y);
                this._motion.vel = vec(0, 0);
            }
        }
        isComplete(entity) {
            const tx = entity.get(TransformComponent);
            return this._stopped || new Vector(tx.pos.x, tx.pos.y).distance(this._start) >= this._distance;
        }
        stop() {
            this._motion.vel = vec(0, 0);
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    /**
 * An enum that describes the strategies that rotation actions can use
 */ var RotationType;
    (function(RotationType) {
        /**
     * Rotation via `ShortestPath` will use the smallest angle
     * between the starting and ending points. This strategy is the default behavior.
     */ RotationType[RotationType["ShortestPath"] = 0] = "ShortestPath";
        /**
     * Rotation via `LongestPath` will use the largest angle
     * between the starting and ending points.
     */ RotationType[RotationType["LongestPath"] = 1] = "LongestPath";
        /**
     * Rotation via `Clockwise` will travel in a clockwise direction,
     * regardless of the starting and ending points.
     */ RotationType[RotationType["Clockwise"] = 2] = "Clockwise";
        /**
     * Rotation via `CounterClockwise` will travel in a counterclockwise direction,
     * regardless of the starting and ending points.
     */ RotationType[RotationType["CounterClockwise"] = 3] = "CounterClockwise";
    })(RotationType || (RotationType = {}));
    class RotateTo {
        constructor(entity, angleRadians, speed, rotationType){
            this._started = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._end = angleRadians;
            this._speed = speed;
            this._rotationType = rotationType || RotationType.ShortestPath;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._start = this._tx.rotation;
                this._currentNonCannonAngle = this._tx.rotation;
                const distance1 = Math.abs(this._end - this._start);
                const distance2 = TwoPI - distance1;
                if (distance1 > distance2) {
                    this._shortDistance = distance2;
                    this._longDistance = distance1;
                } else {
                    this._shortDistance = distance1;
                    this._longDistance = distance2;
                }
                this._shortestPathIsPositive = (this._start - this._end + TwoPI) % TwoPI >= Math.PI;
                switch(this._rotationType){
                    case RotationType.ShortestPath:
                        this._distance = this._shortDistance;
                        if (this._shortestPathIsPositive) this._direction = 1;
                        else this._direction = -1;
                        break;
                    case RotationType.LongestPath:
                        this._distance = this._longDistance;
                        if (this._shortestPathIsPositive) this._direction = -1;
                        else this._direction = 1;
                        break;
                    case RotationType.Clockwise:
                        this._direction = 1;
                        if (this._shortestPathIsPositive) this._distance = this._shortDistance;
                        else this._distance = this._longDistance;
                        break;
                    case RotationType.CounterClockwise:
                        this._direction = -1;
                        if (!this._shortestPathIsPositive) this._distance = this._shortDistance;
                        else this._distance = this._longDistance;
                        break;
                }
            }
            this._motion.angularVelocity = this._direction * this._speed;
            this._currentNonCannonAngle += this._direction * this._speed * (_delta / 1000);
            if (this.isComplete()) {
                this._tx.rotation = this._end;
                this._motion.angularVelocity = 0;
                this._stopped = true;
            }
        }
        isComplete() {
            const distanceTraveled = Math.abs(this._currentNonCannonAngle - this._start);
            return this._stopped || distanceTraveled >= Math.abs(this._distance);
        }
        stop() {
            this._motion.angularVelocity = 0;
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    class RotateBy {
        constructor(entity, angleRadiansOffset, speed, rotationType){
            this._started = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._speed = speed;
            this._offset = angleRadiansOffset;
            this._rotationType = rotationType || RotationType.ShortestPath;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._start = this._tx.rotation;
                this._currentNonCannonAngle = this._tx.rotation;
                this._end = this._start + this._offset;
                const distance1 = Math.abs(this._end - this._start);
                const distance2 = TwoPI - distance1;
                if (distance1 > distance2) {
                    this._shortDistance = distance2;
                    this._longDistance = distance1;
                } else {
                    this._shortDistance = distance1;
                    this._longDistance = distance2;
                }
                this._shortestPathIsPositive = (this._start - this._end + TwoPI) % TwoPI >= Math.PI;
                switch(this._rotationType){
                    case RotationType.ShortestPath:
                        this._distance = this._shortDistance;
                        if (this._shortestPathIsPositive) this._direction = 1;
                        else this._direction = -1;
                        break;
                    case RotationType.LongestPath:
                        this._distance = this._longDistance;
                        if (this._shortestPathIsPositive) this._direction = -1;
                        else this._direction = 1;
                        break;
                    case RotationType.Clockwise:
                        this._direction = 1;
                        if (this._shortDistance >= 0) this._distance = this._shortDistance;
                        else this._distance = this._longDistance;
                        break;
                    case RotationType.CounterClockwise:
                        this._direction = -1;
                        if (this._shortDistance <= 0) this._distance = this._shortDistance;
                        else this._distance = this._longDistance;
                        break;
                }
            }
            this._motion.angularVelocity = this._direction * this._speed;
            this._currentNonCannonAngle += this._direction * this._speed * (_delta / 1000);
            if (this.isComplete()) {
                this._tx.rotation = this._end;
                this._motion.angularVelocity = 0;
                this._stopped = true;
            }
        }
        isComplete() {
            const distanceTraveled = Math.abs(this._currentNonCannonAngle - this._start);
            return this._stopped || distanceTraveled >= Math.abs(this._distance);
        }
        stop() {
            this._motion.angularVelocity = 0;
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
            this._start = undefined;
            this._currentNonCannonAngle = undefined;
            this._distance = undefined;
        }
    }
    class ScaleTo {
        constructor(entity, scaleX, scaleY, speedX, speedY){
            this._started = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._endX = scaleX;
            this._endY = scaleY;
            this._speedX = speedX;
            this._speedY = speedY;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._startX = this._tx.scale.x;
                this._startY = this._tx.scale.y;
                this._distanceX = Math.abs(this._endX - this._startX);
                this._distanceY = Math.abs(this._endY - this._startY);
            }
            if (!(Math.abs(this._tx.scale.x - this._startX) >= this._distanceX)) {
                const directionX = this._endY < this._startY ? -1 : 1;
                this._motion.scaleFactor.x = this._speedX * directionX;
            } else this._motion.scaleFactor.x = 0;
            if (!(Math.abs(this._tx.scale.y - this._startY) >= this._distanceY)) {
                const directionY = this._endY < this._startY ? -1 : 1;
                this._motion.scaleFactor.y = this._speedY * directionY;
            } else this._motion.scaleFactor.y = 0;
            if (this.isComplete()) {
                this._tx.scale = vec(this._endX, this._endY);
                this._motion.scaleFactor.x = 0;
                this._motion.scaleFactor.y = 0;
            }
        }
        isComplete() {
            return this._stopped || Math.abs(this._tx.scale.x - this._startX) >= this._distanceX - 0.01 && Math.abs(this._tx.scale.y - this._startY) >= this._distanceY - 0.01;
        }
        stop() {
            this._motion.scaleFactor.x = 0;
            this._motion.scaleFactor.y = 0;
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    class ScaleBy {
        constructor(entity, scaleOffsetX, scaleOffsetY, speed){
            this._started = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._offset = new Vector(scaleOffsetX, scaleOffsetY);
            this._speedX = this._speedY = speed;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._startScale = this._tx.scale.clone();
                this._endScale = this._startScale.add(this._offset);
                this._distanceX = Math.abs(this._endScale.x - this._startScale.x);
                this._distanceY = Math.abs(this._endScale.y - this._startScale.y);
                this._directionX = this._endScale.x < this._startScale.x ? -1 : 1;
                this._directionY = this._endScale.y < this._startScale.y ? -1 : 1;
            }
            this._motion.scaleFactor.x = this._speedX * this._directionX;
            this._motion.scaleFactor.y = this._speedY * this._directionY;
            if (this.isComplete()) {
                this._tx.scale = this._endScale;
                this._motion.scaleFactor.x = 0;
                this._motion.scaleFactor.y = 0;
            }
        }
        isComplete() {
            return this._stopped || Math.abs(this._tx.scale.x - this._startScale.x) >= this._distanceX - 0.01 && Math.abs(this._tx.scale.y - this._startScale.y) >= this._distanceY - 0.01;
        }
        stop() {
            this._motion.scaleFactor.x = 0;
            this._motion.scaleFactor.y = 0;
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    class CallMethod {
        constructor(method){
            this._method = null;
            this._hasBeenCalled = false;
            this._method = method;
        }
        update(_delta) {
            this._method();
            this._hasBeenCalled = true;
        }
        isComplete() {
            return this._hasBeenCalled;
        }
        reset() {
            this._hasBeenCalled = false;
        }
        stop() {
            this._hasBeenCalled = true;
        }
    }
    class EaseTo {
        constructor(entity, x, y, duration, easingFcn){
            this.easingFcn = easingFcn;
            this._currentLerpTime = 0;
            this._lerpDuration = 1000; // 1 second
            this._lerpStart = new Vector(0, 0);
            this._lerpEnd = new Vector(0, 0);
            this._initialized = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._lerpDuration = duration;
            this._lerpEnd = new Vector(x, y);
        }
        _initialize() {
            this._lerpStart = new Vector(this._tx.pos.x, this._tx.pos.y);
            this._currentLerpTime = 0;
        }
        update(delta) {
            if (!this._initialized) {
                this._initialize();
                this._initialized = true;
            }
            // Need to update lerp time first, otherwise the first update will always be zero
            this._currentLerpTime += delta;
            let newX = this._tx.pos.x;
            let newY = this._tx.pos.y;
            if (this._currentLerpTime < this._lerpDuration) {
                if (this._lerpEnd.x < this._lerpStart.x) newX = this._lerpStart.x - (this.easingFcn(this._currentLerpTime, this._lerpEnd.x, this._lerpStart.x, this._lerpDuration) - this._lerpEnd.x);
                else newX = this.easingFcn(this._currentLerpTime, this._lerpStart.x, this._lerpEnd.x, this._lerpDuration);
                if (this._lerpEnd.y < this._lerpStart.y) newY = this._lerpStart.y - (this.easingFcn(this._currentLerpTime, this._lerpEnd.y, this._lerpStart.y, this._lerpDuration) - this._lerpEnd.y);
                else newY = this.easingFcn(this._currentLerpTime, this._lerpStart.y, this._lerpEnd.y, this._lerpDuration);
                // Given the lerp position figure out the velocity in pixels per second
                this._motion.vel = vec((newX - this._tx.pos.x) / (delta / 1000), (newY - this._tx.pos.y) / (delta / 1000));
            } else {
                this._tx.pos = vec(this._lerpEnd.x, this._lerpEnd.y);
                this._motion.vel = Vector.Zero;
            }
        }
        isComplete() {
            return this._stopped || this._currentLerpTime >= this._lerpDuration;
        }
        reset() {
            this._initialized = false;
            this._stopped = false;
            this._currentLerpTime = 0;
        }
        stop() {
            this._motion.vel = vec(0, 0);
            this._stopped = true;
        }
    }
    class EaseBy {
        constructor(entity, offsetX, offsetY, duration, easingFcn){
            this.easingFcn = easingFcn;
            this._currentLerpTime = 0;
            this._lerpDuration = 1000; // 1 second
            this._lerpStart = new Vector(0, 0);
            this._lerpEnd = new Vector(0, 0);
            this._initialized = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._lerpDuration = duration;
            this._offset = new Vector(offsetX, offsetY);
        }
        _initialize() {
            this._lerpStart = new Vector(this._tx.pos.x, this._tx.pos.y);
            this._currentLerpTime = 0;
            this._lerpEnd = this._lerpStart.add(this._offset);
        }
        update(delta) {
            if (!this._initialized) {
                this._initialize();
                this._initialized = true;
            }
            // Need to update lerp time first, otherwise the first update will always be zero
            this._currentLerpTime += delta;
            let newX = this._tx.pos.x;
            let newY = this._tx.pos.y;
            if (this._currentLerpTime < this._lerpDuration) {
                if (this._lerpEnd.x < this._lerpStart.x) newX = this._lerpStart.x - (this.easingFcn(this._currentLerpTime, this._lerpEnd.x, this._lerpStart.x, this._lerpDuration) - this._lerpEnd.x);
                else newX = this.easingFcn(this._currentLerpTime, this._lerpStart.x, this._lerpEnd.x, this._lerpDuration);
                if (this._lerpEnd.y < this._lerpStart.y) newY = this._lerpStart.y - (this.easingFcn(this._currentLerpTime, this._lerpEnd.y, this._lerpStart.y, this._lerpDuration) - this._lerpEnd.y);
                else newY = this.easingFcn(this._currentLerpTime, this._lerpStart.y, this._lerpEnd.y, this._lerpDuration);
                // Given the lerp position figure out the velocity in pixels per second
                this._motion.vel = vec((newX - this._tx.pos.x) / (delta / 1000), (newY - this._tx.pos.y) / (delta / 1000));
            } else {
                this._tx.pos = vec(this._lerpEnd.x, this._lerpEnd.y);
                this._motion.vel = Vector.Zero;
            }
        }
        isComplete() {
            return this._stopped || this._currentLerpTime >= this._lerpDuration;
        }
        reset() {
            this._initialized = false;
            this._stopped = false;
            this._currentLerpTime = 0;
        }
        stop() {
            this._motion.vel = vec(0, 0);
            this._stopped = true;
        }
    }
    class Blink {
        constructor(entity, timeVisible, timeNotVisible, numBlinks = 1){
            this._timeVisible = 0;
            this._timeNotVisible = 0;
            this._elapsedTime = 0;
            this._totalTime = 0;
            this._stopped = false;
            this._started = false;
            this._graphics = entity.get(GraphicsComponent);
            this._timeVisible = timeVisible;
            this._timeNotVisible = timeNotVisible;
            this._duration = (timeVisible + timeNotVisible) * numBlinks;
        }
        update(delta) {
            if (!this._started) {
                this._started = true;
                this._elapsedTime = 0;
                this._totalTime = 0;
            }
            if (!this._graphics) return;
            this._elapsedTime += delta;
            this._totalTime += delta;
            if (this._graphics.visible && this._elapsedTime >= this._timeVisible) {
                this._graphics.visible = false;
                this._elapsedTime = 0;
            }
            if (!this._graphics.visible && this._elapsedTime >= this._timeNotVisible) {
                this._graphics.visible = true;
                this._elapsedTime = 0;
            }
            if (this.isComplete()) this._graphics.visible = true;
        }
        isComplete() {
            return this._stopped || this._totalTime >= this._duration;
        }
        stop() {
            if (this._graphics) this._graphics.visible = true;
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
            this._elapsedTime = 0;
            this._totalTime = 0;
        }
    }
    class Fade {
        constructor(entity, endOpacity, speed){
            this._multiplier = 1;
            this._started = false;
            this._stopped = false;
            this._graphics = entity.get(GraphicsComponent);
            this._endOpacity = endOpacity;
            this._speed = this._ogspeed = speed;
        }
        update(delta) {
            if (!this._graphics) return;
            if (!this._started) {
                this._started = true;
                this._speed = this._ogspeed;
                // determine direction when we start
                if (this._endOpacity < this._graphics.opacity) this._multiplier = -1;
                else this._multiplier = 1;
            }
            if (this._speed > 0) this._graphics.opacity += this._multiplier * (Math.abs(this._graphics.opacity - this._endOpacity) * delta) / this._speed;
            this._speed -= delta;
            if (this.isComplete()) this._graphics.opacity = this._endOpacity;
            Logger.getInstance().debug("[Action fade] Actor opacity:", this._graphics.opacity);
        }
        isComplete() {
            return this._stopped || Math.abs(this._graphics.opacity - this._endOpacity) < 0.05;
        }
        stop() {
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    class Delay {
        constructor(delay){
            this._elapsedTime = 0;
            this._started = false;
            this._stopped = false;
            this._delay = delay;
        }
        update(delta) {
            if (!this._started) this._started = true;
            this._elapsedTime += delta;
        }
        isComplete() {
            return this._stopped || this._elapsedTime >= this._delay;
        }
        stop() {
            this._stopped = true;
        }
        reset() {
            this._elapsedTime = 0;
            this._started = false;
            this._stopped = false;
        }
    }
    class Die {
        constructor(entity){
            this._stopped = false;
            this._entity = entity;
        }
        update(_delta) {
            this._entity.get(ActionsComponent).clearActions();
            this._entity.kill();
            this._stopped = true;
        }
        isComplete() {
            return this._stopped;
        }
        stop() {
            return;
        }
        reset() {
            return;
        }
    }
    class Follow {
        constructor(entity, entityToFollow, followDistance){
            this._started = false;
            this._stopped = false;
            this._tx = entity.get(TransformComponent);
            this._motion = entity.get(MotionComponent);
            this._followTx = entityToFollow.get(TransformComponent);
            this._followMotion = entityToFollow.get(MotionComponent);
            this._current = new Vector(this._tx.pos.x, this._tx.pos.y);
            this._end = new Vector(this._followTx.pos.x, this._followTx.pos.y);
            this._maximumDistance = followDistance !== undefined ? followDistance : this._current.distance(this._end);
            this._speed = 0;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._distanceBetween = this._current.distance(this._end);
                this._dir = this._end.sub(this._current).normalize();
            }
            const actorToFollowSpeed = Math.sqrt(Math.pow(this._followMotion.vel.x, 2) + Math.pow(this._followMotion.vel.y, 2));
            if (actorToFollowSpeed !== 0) this._speed = actorToFollowSpeed;
            this._current = vec(this._tx.pos.x, this._tx.pos.y);
            this._end = vec(this._followTx.pos.x, this._followTx.pos.y);
            this._distanceBetween = this._current.distance(this._end);
            this._dir = this._end.sub(this._current).normalize();
            if (this._distanceBetween >= this._maximumDistance) {
                const m = this._dir.scale(this._speed);
                this._motion.vel = vec(m.x, m.y);
            } else this._motion.vel = vec(0, 0);
            if (this.isComplete()) {
                this._tx.pos = vec(this._end.x, this._end.y);
                this._motion.vel = vec(0, 0);
            }
        }
        stop() {
            this._motion.vel = vec(0, 0);
            this._stopped = true;
        }
        isComplete() {
            // the actor following should never stop unless specified to do so
            return this._stopped;
        }
        reset() {
            this._started = false;
            this._stopped = false;
        }
    }
    class Meet {
        constructor(actor, actorToMeet, speed){
            this._started = false;
            this._stopped = false;
            this._speedWasSpecified = false;
            this._tx = actor.get(TransformComponent);
            this._motion = actor.get(MotionComponent);
            this._meetTx = actorToMeet.get(TransformComponent);
            this._meetMotion = actorToMeet.get(MotionComponent);
            this._current = new Vector(this._tx.pos.x, this._tx.pos.y);
            this._end = new Vector(this._meetTx.pos.x, this._meetTx.pos.y);
            this._speed = speed || 0;
            if (speed !== undefined) this._speedWasSpecified = true;
        }
        update(_delta) {
            if (!this._started) {
                this._started = true;
                this._distanceBetween = this._current.distance(this._end);
                this._dir = this._end.sub(this._current).normalize();
            }
            const actorToMeetSpeed = Math.sqrt(Math.pow(this._meetMotion.vel.x, 2) + Math.pow(this._meetMotion.vel.y, 2));
            if (actorToMeetSpeed !== 0 && !this._speedWasSpecified) this._speed = actorToMeetSpeed;
            this._current = vec(this._tx.pos.x, this._tx.pos.y);
            this._end = vec(this._meetTx.pos.x, this._meetTx.pos.y);
            this._distanceBetween = this._current.distance(this._end);
            this._dir = this._end.sub(this._current).normalize();
            const m = this._dir.scale(this._speed);
            this._motion.vel = vec(m.x, m.y);
            if (this.isComplete()) {
                this._tx.pos = vec(this._end.x, this._end.y);
                this._motion.vel = vec(0, 0);
            }
        }
        isComplete() {
            return this._stopped || this._distanceBetween <= 1;
        }
        stop() {
            this._motion.vel = vec(0, 0);
            this._stopped = true;
        }
        reset() {
            this._started = false;
            this._stopped = false;
            this._distanceBetween = undefined;
        }
    }
    /**
 * The fluent Action API allows you to perform "actions" on
 * [[Actor|Actors]] such as following, moving, rotating, and
 * more. You can implement your own actions by implementing
 * the [[Action]] interface.
 */ class ActionContext {
        constructor(entity){
            this._entity = entity;
            this._queue = new ActionQueue(entity);
        }
        getQueue() {
            return this._queue;
        }
        update(elapsedMs) {
            this._queue.update(elapsedMs);
        }
        /**
     * Clears all queued actions from the Actor
     */ clearActions() {
            this._queue.clearActions();
        }
        runAction(action) {
            action.reset();
            this._queue.add(action);
            return this;
        }
        easeTo(...args) {
            var _a, _b;
            let x = 0;
            let y = 0;
            let duration = 0;
            let easingFcn = EasingFunctions.Linear;
            if (args[0] instanceof Vector) {
                x = args[0].x;
                y = args[0].y;
                duration = args[1];
                easingFcn = (_a = args[2]) !== null && _a !== void 0 ? _a : easingFcn;
            } else {
                x = args[0];
                y = args[1];
                duration = args[2];
                easingFcn = (_b = args[3]) !== null && _b !== void 0 ? _b : easingFcn;
            }
            this._queue.add(new EaseTo(this._entity, x, y, duration, easingFcn));
            return this;
        }
        easeBy(...args) {
            var _a, _b;
            let offsetX = 0;
            let offsetY = 0;
            let duration = 0;
            let easingFcn = EasingFunctions.Linear;
            if (args[0] instanceof Vector) {
                offsetX = args[0].x;
                offsetY = args[0].y;
                duration = args[1];
                easingFcn = (_a = args[2]) !== null && _a !== void 0 ? _a : easingFcn;
            } else {
                offsetX = args[0];
                offsetY = args[1];
                duration = args[2];
                easingFcn = (_b = args[3]) !== null && _b !== void 0 ? _b : easingFcn;
            }
            this._queue.add(new EaseBy(this._entity, offsetX, offsetY, duration, easingFcn));
            return this;
        }
        moveTo(xOrPos, yOrSpeed, speedOrUndefined) {
            let x = 0;
            let y = 0;
            let speed = 0;
            if (xOrPos instanceof Vector) {
                x = xOrPos.x;
                y = xOrPos.y;
                speed = yOrSpeed;
            } else {
                x = xOrPos;
                y = yOrSpeed;
                speed = speedOrUndefined;
            }
            this._queue.add(new MoveTo(this._entity, x, y, speed));
            return this;
        }
        moveBy(xOffsetOrVector, yOffsetOrSpeed, speedOrUndefined) {
            let xOffset = 0;
            let yOffset = 0;
            let speed = 0;
            if (xOffsetOrVector instanceof Vector) {
                xOffset = xOffsetOrVector.x;
                yOffset = xOffsetOrVector.y;
                speed = yOffsetOrSpeed;
            } else {
                xOffset = xOffsetOrVector;
                yOffset = yOffsetOrSpeed;
                speed = speedOrUndefined;
            }
            this._queue.add(new MoveBy(this._entity, xOffset, yOffset, speed));
            return this;
        }
        /**
     * This method will rotate an actor to the specified angle at the speed
     * specified (in radians per second) and return back the actor. This
     * method is part of the actor 'Action' fluent API allowing action chaining.
     * @param angleRadians  The angle to rotate to in radians
     * @param speed         The angular velocity of the rotation specified in radians per second
     * @param rotationType  The [[RotationType]] to use for this rotation
     */ rotateTo(angleRadians, speed, rotationType) {
            this._queue.add(new RotateTo(this._entity, angleRadians, speed, rotationType));
            return this;
        }
        /**
     * This method will rotate an actor by the specified angle offset, from it's current rotation given a certain speed
     * in radians/sec and return back the actor. This method is part
     * of the actor 'Action' fluent API allowing action chaining.
     * @param angleRadiansOffset  The angle to rotate to in radians relative to the current rotation
     * @param speed          The speed in radians/sec the actor should rotate at
     * @param rotationType  The [[RotationType]] to use for this rotation, default is shortest path
     */ rotateBy(angleRadiansOffset, speed, rotationType) {
            this._queue.add(new RotateBy(this._entity, angleRadiansOffset, speed, rotationType));
            return this;
        }
        scaleTo(sizeXOrVector, sizeYOrSpeed, speedXOrUndefined, speedYOrUndefined) {
            let sizeX = 1;
            let sizeY = 1;
            let speedX = 0;
            let speedY = 0;
            if (sizeXOrVector instanceof Vector && sizeYOrSpeed instanceof Vector) {
                sizeX = sizeXOrVector.x;
                sizeY = sizeXOrVector.y;
                speedX = sizeYOrSpeed.x;
                speedY = sizeYOrSpeed.y;
            }
            if (typeof sizeXOrVector === "number" && typeof sizeYOrSpeed === "number") {
                sizeX = sizeXOrVector;
                sizeY = sizeYOrSpeed;
                speedX = speedXOrUndefined;
                speedY = speedYOrUndefined;
            }
            this._queue.add(new ScaleTo(this._entity, sizeX, sizeY, speedX, speedY));
            return this;
        }
        scaleBy(sizeOffsetXOrVector, sizeOffsetYOrSpeed, speed) {
            let sizeOffsetX = 1;
            let sizeOffsetY = 1;
            if (sizeOffsetXOrVector instanceof Vector) {
                sizeOffsetX = sizeOffsetXOrVector.x;
                sizeOffsetY = sizeOffsetXOrVector.y;
                speed = sizeOffsetYOrSpeed;
            }
            if (typeof sizeOffsetXOrVector === "number" && typeof sizeOffsetYOrSpeed === "number") {
                sizeOffsetX = sizeOffsetXOrVector;
                sizeOffsetY = sizeOffsetYOrSpeed;
            }
            this._queue.add(new ScaleBy(this._entity, sizeOffsetX, sizeOffsetY, speed));
            return this;
        }
        /**
     * This method will cause an actor to blink (become visible and not
     * visible). Optionally, you may specify the number of blinks. Specify the amount of time
     * the actor should be visible per blink, and the amount of time not visible.
     * This method is part of the actor 'Action' fluent API allowing action chaining.
     * @param timeVisible     The amount of time to stay visible per blink in milliseconds
     * @param timeNotVisible  The amount of time to stay not visible per blink in milliseconds
     * @param numBlinks       The number of times to blink
     */ blink(timeVisible, timeNotVisible, numBlinks = 1) {
            this._queue.add(new Blink(this._entity, timeVisible, timeNotVisible, numBlinks));
            return this;
        }
        /**
     * This method will cause an actor's opacity to change from its current value
     * to the provided value by a specified time (in milliseconds). This method is
     * part of the actor 'Action' fluent API allowing action chaining.
     * @param opacity  The ending opacity
     * @param time     The time it should take to fade the actor (in milliseconds)
     */ fade(opacity, time) {
            this._queue.add(new Fade(this._entity, opacity, time));
            return this;
        }
        /**
     * This method will delay the next action from executing for a certain
     * amount of time (in milliseconds). This method is part of the actor
     * 'Action' fluent API allowing action chaining.
     * @param time  The amount of time to delay the next action in the queue from executing in milliseconds
     */ delay(time) {
            this._queue.add(new Delay(time));
            return this;
        }
        /**
     * This method will add an action to the queue that will remove the actor from the
     * scene once it has completed its previous  Any actions on the
     * action queue after this action will not be executed.
     */ die() {
            this._queue.add(new Die(this._entity));
            return this;
        }
        /**
     * This method allows you to call an arbitrary method as the next action in the
     * action queue. This is useful if you want to execute code in after a specific
     * action, i.e An actor arrives at a destination after traversing a path
     */ callMethod(method) {
            this._queue.add(new CallMethod(method));
            return this;
        }
        /**
     * This method will cause the actor to repeat all of the actions built in
     * the `repeatBuilder` callback. If the number of repeats
     * is not specified it will repeat forever. This method is part of
     * the actor 'Action' fluent API allowing action chaining
     *
     * ```typescript
     * // Move up in a zig-zag by repeated moveBy's
     * actor.actions.repeat(repeatCtx => {
     * repeatCtx.moveBy(10, 0, 10);
     * repeatCtx.moveBy(0, 10, 10);
     * }, 5);
     * ```
     * @param repeatBuilder The builder to specify the repeatable list of actions
     * @param times  The number of times to repeat all the previous actions in the action queue. If nothing is specified the actions
     * will repeat forever
     */ repeat(repeatBuilder, times) {
            if (!times) {
                this.repeatForever(repeatBuilder);
                return this;
            }
            this._queue.add(new Repeat(this._entity, repeatBuilder, times));
            return this;
        }
        /**
     * This method will cause the actor to repeat all of the actions built in
     * the `repeatBuilder` callback. If the number of repeats
     * is not specified it will repeat forever. This method is part of
     * the actor 'Action' fluent API allowing action chaining
     *
     * ```typescript
     * // Move up in a zig-zag by repeated moveBy's
     * actor.actions.repeat(repeatCtx => {
     * repeatCtx.moveBy(10, 0, 10);
     * repeatCtx.moveBy(0, 10, 10);
     * }, 5);
     * ```
     * @param repeatBuilder The builder to specify the repeatable list of actions
     */ repeatForever(repeatBuilder) {
            this._queue.add(new RepeatForever(this._entity, repeatBuilder));
            return this;
        }
        /**
     * This method will cause the entity to follow another at a specified distance
     * @param entity           The entity to follow
     * @param followDistance  The distance to maintain when following, if not specified the actor will follow at the current distance.
     */ follow(entity, followDistance) {
            if (followDistance === undefined) this._queue.add(new Follow(this._entity, entity));
            else this._queue.add(new Follow(this._entity, entity, followDistance));
            return this;
        }
        /**
     * This method will cause the entity to move towards another until they
     * collide "meet" at a specified speed.
     * @param entity  The entity to meet
     * @param speed  The speed in pixels per second to move, if not specified it will match the speed of the other actor
     */ meet(entity, speed) {
            if (speed === undefined) this._queue.add(new Meet(this._entity, entity));
            else this._queue.add(new Meet(this._entity, entity, speed));
            return this;
        }
        /**
     * Returns a promise that resolves when the current action queue up to now
     * is finished.
     */ toPromise() {
            const temp = new Promise((resolve)=>{
                this._queue.add(new CallMethod(()=>{
                    resolve();
                }));
            });
            return temp;
        }
    }
    class ActionsComponent extends Component {
        constructor(){
            super(...arguments);
            this.dependencies = [
                TransformComponent,
                MotionComponent
            ];
            this._ctx = null;
        }
        onAdd(entity) {
            this._ctx = new ActionContext(entity);
        }
        onRemove() {
            this._ctx = null;
        }
        _getCtx() {
            if (!this._ctx) throw new Error("Actions component not attached to an entity, no context available");
            return this._ctx;
        }
        /**
     * Returns the internal action queue
     * @returns action queue
     */ getQueue() {
            if (!this._ctx) throw new Error("Actions component not attached to an entity, no queue available");
            return this._ctx.getQueue();
        }
        runAction(action) {
            if (!this._ctx) throw new Error("Actions component not attached to an entity, cannot run action");
            return this._ctx.runAction(action);
        }
        /**
     * Updates the internal action context, performing action and moving through the internal queue
     * @param elapsedMs
     */ update(elapsedMs) {
            var _a;
            return (_a = this._ctx) === null || _a === void 0 ? void 0 : _a.update(elapsedMs);
        }
        /**
     * Clears all queued actions from the Actor
     */ clearActions() {
            var _a;
            (_a = this._ctx) === null || _a === void 0 || _a.clearActions();
        }
        easeTo(...args) {
            return this._getCtx().easeTo.apply(this._ctx, args);
        }
        easeBy(...args) {
            return this._getCtx().easeBy.apply(this._ctx, args);
        }
        moveTo(xOrPos, yOrSpeed, speedOrUndefined) {
            return this._getCtx().moveTo.apply(this._ctx, [
                xOrPos,
                yOrSpeed,
                speedOrUndefined
            ]);
        }
        moveBy(xOffsetOrVector, yOffsetOrSpeed, speedOrUndefined) {
            return this._getCtx().moveBy.apply(this._ctx, [
                xOffsetOrVector,
                yOffsetOrSpeed,
                speedOrUndefined
            ]);
        }
        /**
     * This method will rotate an actor to the specified angle at the speed
     * specified (in radians per second) and return back the actor. This
     * method is part of the actor 'Action' fluent API allowing action chaining.
     * @param angleRadians  The angle to rotate to in radians
     * @param speed         The angular velocity of the rotation specified in radians per second
     * @param rotationType  The [[RotationType]] to use for this rotation
     */ rotateTo(angleRadians, speed, rotationType) {
            return this._getCtx().rotateTo(angleRadians, speed, rotationType);
        }
        /**
     * This method will rotate an actor by the specified angle offset, from it's current rotation given a certain speed
     * in radians/sec and return back the actor. This method is part
     * of the actor 'Action' fluent API allowing action chaining.
     * @param angleRadiansOffset  The angle to rotate to in radians relative to the current rotation
     * @param speed          The speed in radians/sec the actor should rotate at
     * @param rotationType  The [[RotationType]] to use for this rotation, default is shortest path
     */ rotateBy(angleRadiansOffset, speed, rotationType) {
            return this._getCtx().rotateBy(angleRadiansOffset, speed, rotationType);
        }
        scaleTo(sizeXOrVector, sizeYOrSpeed, speedXOrUndefined, speedYOrUndefined) {
            return this._getCtx().scaleTo.apply(this._ctx, [
                sizeXOrVector,
                sizeYOrSpeed,
                speedXOrUndefined,
                speedYOrUndefined
            ]);
        }
        scaleBy(sizeOffsetXOrVector, sizeOffsetYOrSpeed, speed) {
            return this._getCtx().scaleBy.apply(this._ctx, [
                sizeOffsetXOrVector,
                sizeOffsetYOrSpeed,
                speed
            ]);
        }
        /**
     * This method will cause an actor to blink (become visible and not
     * visible). Optionally, you may specify the number of blinks. Specify the amount of time
     * the actor should be visible per blink, and the amount of time not visible.
     * This method is part of the actor 'Action' fluent API allowing action chaining.
     * @param timeVisible     The amount of time to stay visible per blink in milliseconds
     * @param timeNotVisible  The amount of time to stay not visible per blink in milliseconds
     * @param numBlinks       The number of times to blink
     */ blink(timeVisible, timeNotVisible, numBlinks) {
            return this._getCtx().blink(timeVisible, timeNotVisible, numBlinks);
        }
        /**
     * This method will cause an actor's opacity to change from its current value
     * to the provided value by a specified time (in milliseconds). This method is
     * part of the actor 'Action' fluent API allowing action chaining.
     * @param opacity  The ending opacity
     * @param time     The time it should take to fade the actor (in milliseconds)
     */ fade(opacity, time) {
            return this._getCtx().fade(opacity, time);
        }
        /**
     * This method will delay the next action from executing for a certain
     * amount of time (in milliseconds). This method is part of the actor
     * 'Action' fluent API allowing action chaining.
     * @param time  The amount of time to delay the next action in the queue from executing in milliseconds
     */ delay(time) {
            return this._getCtx().delay(time);
        }
        /**
     * This method will add an action to the queue that will remove the actor from the
     * scene once it has completed its previous  Any actions on the
     * action queue after this action will not be executed.
     */ die() {
            return this._getCtx().die();
        }
        /**
     * This method allows you to call an arbitrary method as the next action in the
     * action queue. This is useful if you want to execute code in after a specific
     * action, i.e An actor arrives at a destination after traversing a path
     */ callMethod(method) {
            return this._getCtx().callMethod(method);
        }
        /**
     * This method will cause the actor to repeat all of the actions built in
     * the `repeatBuilder` callback. If the number of repeats
     * is not specified it will repeat forever. This method is part of
     * the actor 'Action' fluent API allowing action chaining
     *
     * ```typescript
     * // Move up in a zig-zag by repeated moveBy's
     * actor.actions.repeat(repeatCtx => {
     * repeatCtx.moveBy(10, 0, 10);
     * repeatCtx.moveBy(0, 10, 10);
     * }, 5);
     * ```
     * @param repeatBuilder The builder to specify the repeatable list of actions
     * @param times  The number of times to repeat all the previous actions in the action queue. If nothing is specified the actions
     * will repeat forever
     */ repeat(repeatBuilder, times) {
            return this._getCtx().repeat(repeatBuilder, times);
        }
        /**
     * This method will cause the actor to repeat all of the actions built in
     * the `repeatBuilder` callback. If the number of repeats
     * is not specified it will repeat forever. This method is part of
     * the actor 'Action' fluent API allowing action chaining
     *
     * ```typescript
     * // Move up in a zig-zag by repeated moveBy's
     * actor.actions.repeat(repeatCtx => {
     * repeatCtx.moveBy(10, 0, 10);
     * repeatCtx.moveBy(0, 10, 10);
     * }, 5);
     * ```
     * @param repeatBuilder The builder to specify the repeatable list of actions
     */ repeatForever(repeatBuilder) {
            return this._getCtx().repeatForever(repeatBuilder);
        }
        /**
     * This method will cause the entity to follow another at a specified distance
     * @param entity           The entity to follow
     * @param followDistance  The distance to maintain when following, if not specified the actor will follow at the current distance.
     */ follow(entity, followDistance) {
            return this._getCtx().follow(entity, followDistance);
        }
        /**
     * This method will cause the entity to move towards another until they
     * collide "meet" at a specified speed.
     * @param entity  The entity to meet
     * @param speed  The speed in pixels per second to move, if not specified it will match the speed of the other actor
     */ meet(entity, speed) {
            return this._getCtx().meet(entity, speed);
        }
        /**
     * Returns a promise that resolves when the current action queue up to now
     * is finished.
     */ toPromise() {
            return this._getCtx().toPromise();
        }
    }
    /**
 * Enum representing the different font size units
 * https://developer.mozilla.org/en-US/docs/Web/CSS/font-size
 */ var FontUnit;
    (function(FontUnit) {
        /**
     * Em is a scalable unit, 1 em is equal to the current font size of the current element, parent elements can effect em values
     */ FontUnit["Em"] = "em";
        /**
     * Rem is similar to the Em, it is a scalable unit. 1 rem is equal to the font size of the root element
     */ FontUnit["Rem"] = "rem";
        /**
     * Pixel is a unit of length in screen pixels
     */ FontUnit["Px"] = "px";
        /**
     * Point is a physical unit length (1/72 of an inch)
     */ FontUnit["Pt"] = "pt";
        /**
     * Percent is a scalable unit similar to Em, the only difference is the Em units scale faster when Text-Size stuff
     */ FontUnit["Percent"] = "%";
    })(FontUnit || (FontUnit = {}));
    /**
 * Enum representing the different horizontal text alignments
 */ var TextAlign;
    (function(TextAlign) {
        /**
     * The text is left-aligned.
     */ TextAlign["Left"] = "left";
        /**
     * The text is right-aligned.
     */ TextAlign["Right"] = "right";
        /**
     * The text is centered.
     */ TextAlign["Center"] = "center";
        /**
     * The text is aligned at the normal start of the line (left-aligned for left-to-right locales,
     * right-aligned for right-to-left locales).
     */ TextAlign["Start"] = "start";
        /**
     * The text is aligned at the normal end of the line (right-aligned for left-to-right locales,
     * left-aligned for right-to-left locales).
     */ TextAlign["End"] = "end";
    })(TextAlign || (TextAlign = {}));
    /**
 * Enum representing the different baseline text alignments
 */ var BaseAlign;
    (function(BaseAlign) {
        /**
     * The text baseline is the top of the em square.
     */ BaseAlign["Top"] = "top";
        /**
     * The text baseline is the hanging baseline.  Currently unsupported; this will act like
     * alphabetic.
     */ BaseAlign["Hanging"] = "hanging";
        /**
     * The text baseline is the middle of the em square.
     */ BaseAlign["Middle"] = "middle";
        /**
     * The text baseline is the normal alphabetic baseline.
     */ BaseAlign["Alphabetic"] = "alphabetic";
        /**
     * The text baseline is the ideographic baseline; this is the bottom of
     * the body of the characters, if the main body of characters protrudes
     * beneath the alphabetic baseline.  Currently unsupported; this will
     * act like alphabetic.
     */ BaseAlign["Ideographic"] = "ideographic";
        /**
     * The text baseline is the bottom of the bounding box.  This differs
     * from the ideographic baseline in that the ideographic baseline
     * doesn't consider descenders.
     */ BaseAlign["Bottom"] = "bottom";
    })(BaseAlign || (BaseAlign = {}));
    /**
 * Enum representing the different possible font styles
 */ var FontStyle;
    (function(FontStyle) {
        FontStyle["Normal"] = "normal";
        FontStyle["Italic"] = "italic";
        FontStyle["Oblique"] = "oblique";
    })(FontStyle || (FontStyle = {}));
    /**
 * Enum representing the text direction, useful for other languages, or writing text in reverse
 */ var Direction;
    (function(Direction) {
        Direction["LeftToRight"] = "ltr";
        Direction["RightToLeft"] = "rtl";
    })(Direction || (Direction = {}));
    class FontTextInstance {
        constructor(font, text, color, maxWidth){
            this.font = font;
            this.text = text;
            this.color = color;
            this.maxWidth = maxWidth;
            this._textFragments = [];
            this.disposed = false;
            this._dirty = true;
            this.canvas = document.createElement("canvas");
            this.ctx = this.canvas.getContext("2d");
            this.dimensions = this.measureText(text);
            this._setDimension(this.dimensions, this.ctx);
            this._lastHashCode = this.getHashCode();
        }
        measureText(text, maxWidth) {
            if (this.disposed) throw Error("Accessing disposed text instance! " + this.text);
            let lines = null;
            if (maxWidth != null) lines = this._getLinesFromText(text, maxWidth);
            else lines = text.split("\n");
            const maxWidthLine = lines.reduce((a, b)=>{
                return a.length > b.length ? a : b;
            });
            this._applyFont(this.ctx); // font must be applied to the context to measure it
            const metrics = this.ctx.measureText(maxWidthLine);
            let textHeight = Math.abs(metrics.actualBoundingBoxAscent) + Math.abs(metrics.actualBoundingBoxDescent);
            // TODO line height makes the text bounds wonky
            const lineAdjustedHeight = textHeight * lines.length;
            textHeight = lineAdjustedHeight;
            const bottomBounds = lineAdjustedHeight - Math.abs(metrics.actualBoundingBoxAscent);
            const x = 0;
            const y = 0;
            const measurement = new BoundingBox({
                left: x - Math.abs(metrics.actualBoundingBoxLeft) - this.font.padding,
                top: y - Math.abs(metrics.actualBoundingBoxAscent) - this.font.padding,
                bottom: y + bottomBounds + this.font.padding,
                right: x + Math.abs(metrics.actualBoundingBoxRight) + this.font.padding
            });
            return measurement;
        }
        _setDimension(textBounds, bitmap) {
            let lineHeightRatio = 1;
            if (this.font.lineHeight) lineHeightRatio = this.font.lineHeight / this.font.size;
            // Changing the width and height clears the context properties
            // We double the bitmap width to account for all possible alignment
            // We scale by "quality" so we render text without jaggies
            bitmap.canvas.width = (textBounds.width + this.font.padding * 2) * 2 * this.font.quality;
            bitmap.canvas.height = (textBounds.height + this.font.padding * 2) * 2 * this.font.quality * lineHeightRatio;
        }
        static getHashCode(font, text, color) {
            var _a;
            const hash = text + "__hashcode__" + font.fontString + font.showDebug + font.textAlign + font.baseAlign + font.direction + font.lineHeight + JSON.stringify(font.shadow) + (font.padding.toString() + font.smoothing.toString() + font.lineWidth.toString() + font.lineDash.toString() + ((_a = font.strokeColor) === null || _a === void 0 ? void 0 : _a.toString()) + (color ? color.toString() : font.color.toString()));
            return hash;
        }
        getHashCode(includeColor = true) {
            return FontTextInstance.getHashCode(this.font, this.text, includeColor ? this.color : undefined);
        }
        _applyRasterProperties(ctx) {
            var _a, _b;
            ctx.translate(this.font.padding, this.font.padding);
            ctx.imageSmoothingEnabled = this.font.smoothing;
            ctx.lineWidth = this.font.lineWidth;
            ctx.setLineDash((_a = this.font.lineDash) !== null && _a !== void 0 ? _a : ctx.getLineDash());
            ctx.strokeStyle = (_b = this.font.strokeColor) === null || _b === void 0 ? void 0 : _b.toString();
            ctx.fillStyle = this.color.toString();
        }
        _applyFont(ctx) {
            ctx.resetTransform();
            ctx.translate(this.font.padding + ctx.canvas.width / 2, this.font.padding + ctx.canvas.height / 2);
            ctx.scale(this.font.quality, this.font.quality);
            ctx.textAlign = this.font.textAlign;
            ctx.textBaseline = this.font.baseAlign;
            ctx.font = this.font.fontString;
            ctx.direction = this.font.direction;
            if (this.font.shadow) {
                ctx.shadowColor = this.font.shadow.color.toString();
                ctx.shadowBlur = this.font.shadow.blur;
                ctx.shadowOffsetX = this.font.shadow.offset.x;
                ctx.shadowOffsetY = this.font.shadow.offset.y;
            }
        }
        _drawText(ctx, lines, lineHeight) {
            this._applyRasterProperties(ctx);
            this._applyFont(ctx);
            for(let i = 0; i < lines.length; i++){
                const line = lines[i];
                if (this.color) ctx.fillText(line, 0, i * lineHeight);
                if (this.font.strokeColor) ctx.strokeText(line, 0, i * lineHeight);
            }
            if (this.font.showDebug) {
                // Horizontal line
                /* istanbul ignore next */ line(ctx, Color.Green, -ctx.canvas.width / 2, 0, ctx.canvas.width / 2, 0, 2);
                // Vertical line
                /* istanbul ignore next */ line(ctx, Color.Red, 0, -ctx.canvas.height / 2, 0, ctx.canvas.height / 2, 2);
            }
        }
        _splitTextBitmap(bitmap) {
            const textImages = [];
            let currentX = 0;
            let currentY = 0;
            // 4k is the max for mobile devices
            const width = Math.min(4096, bitmap.canvas.width);
            const height = Math.min(4096, bitmap.canvas.height);
            // Splits the original bitmap into 4k max chunks
            while(currentX < bitmap.canvas.width){
                while(currentY < bitmap.canvas.height){
                    // create new bitmap
                    const canvas = document.createElement("canvas");
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext("2d");
                    // draw current slice to new bitmap in < 4k chunks
                    ctx.drawImage(bitmap.canvas, currentX, currentY, width, height, 0, 0, width, height);
                    textImages.push({
                        x: currentX,
                        y: currentY,
                        canvas: canvas
                    });
                    currentY += height;
                }
                currentX += width;
                currentY = 0;
            }
            return textImages;
        }
        flagDirty() {
            this._dirty = true;
        }
        render(ex, x, y, maxWidth) {
            var _a;
            if (this.disposed) throw Error("Accessing disposed text instance! " + this.text);
            this._ex = ex;
            const hashCode = this.getHashCode();
            if (this._lastHashCode !== hashCode) this._dirty = true;
            // Calculate image chunks
            if (this._dirty) {
                this.dimensions = this.measureText(this.text, maxWidth);
                this._setDimension(this.dimensions, this.ctx);
                const lines = this._getLinesFromText(this.text, maxWidth);
                const lineHeight = (_a = this.font.lineHeight) !== null && _a !== void 0 ? _a : this.dimensions.height / lines.length;
                // draws the text to the main bitmap
                this._drawText(this.ctx, lines, lineHeight);
                // clear any out old fragments
                if (ex instanceof ExcaliburGraphicsContextWebGL) for (const frag of this._textFragments)ex.textureLoader.delete(frag.canvas);
                // splits to < 4k fragments for large text
                this._textFragments = this._splitTextBitmap(this.ctx);
                if (ex instanceof ExcaliburGraphicsContextWebGL) for (const frag of this._textFragments)ex.textureLoader.load(frag.canvas, {
                    filtering: this.font.filtering
                }, true);
                this._lastHashCode = hashCode;
                this._dirty = false;
            }
            // draws the bitmap fragments to excalibur graphics context
            for (const frag of this._textFragments)ex.drawImage(frag.canvas, 0, 0, frag.canvas.width, frag.canvas.height, frag.x / this.font.quality + x - this.ctx.canvas.width / this.font.quality / 2, frag.y / this.font.quality + y - this.ctx.canvas.height / this.font.quality / 2, frag.canvas.width / this.font.quality, frag.canvas.height / this.font.quality);
        }
        dispose() {
            this.disposed = true;
            this.dimensions = undefined;
            this.canvas = undefined;
            this.ctx = undefined;
            if (this._ex instanceof ExcaliburGraphicsContextWebGL) for (const frag of this._textFragments)this._ex.textureLoader.delete(frag.canvas);
            this._textFragments.length = 0;
        }
        _getLinesFromText(text, maxWidth) {
            if (this._cachedText === text && this._cachedRenderWidth === maxWidth) return this._cachedLines;
            const lines = text.split("\n");
            if (maxWidth == null) return lines;
            // If the current line goes past the maxWidth, append a new line without modifying the underlying text.
            for(let i = 0; i < lines.length; i++){
                let line = lines[i];
                let newLine = "";
                if (this.measureText(line).width > maxWidth) {
                    while(this.measureText(line).width > maxWidth){
                        newLine = line[line.length - 1] + newLine;
                        line = line.slice(0, -1); // Remove last character from line
                    }
                    // Update the array with our new values
                    lines[i] = line;
                    lines[i + 1] = newLine;
                }
            }
            this._cachedText = text;
            this._cachedLines = lines;
            this._cachedRenderWidth = maxWidth;
            return lines;
        }
    }
    class FontCache {
        static measureText(text, font, maxWidth) {
            const hash = FontTextInstance.getHashCode(font, text);
            if (FontCache._MEASURE_CACHE.has(hash)) return FontCache._MEASURE_CACHE.get(hash);
            FontCache._LOGGER.debug("Font text measurement cache miss");
            const measurement = font.measureTextWithoutCache(text, maxWidth);
            FontCache._MEASURE_CACHE.set(hash, measurement);
            return measurement;
        }
        static getTextInstance(text, font, color) {
            const hash = FontTextInstance.getHashCode(font, text, color);
            let textInstance = FontCache._TEXT_CACHE.get(hash);
            if (!textInstance) {
                textInstance = new FontTextInstance(font, text, color);
                FontCache._TEXT_CACHE.set(hash, textInstance);
                FontCache._LOGGER.debug("Font text instance cache miss");
            }
            // Cache the bitmap for certain amount of time
            FontCache._TEXT_USAGE.set(textInstance, performance.now());
            return textInstance;
        }
        static checkAndClearCache() {
            const deferred = [];
            const currentHashCodes = new Set();
            for (const [textInstance, time] of FontCache._TEXT_USAGE.entries())// if bitmap hasn't been used in 100 ms clear it
            if (time + FontCache.FONT_TIMEOUT < performance.now()) {
                FontCache._LOGGER.debug(`Text cache entry timed out ${textInstance.text}`);
                deferred.push(textInstance);
                textInstance.dispose();
            } else {
                const hash = textInstance.getHashCode(false);
                currentHashCodes.add(hash);
            }
            // Deferred removal of text instances
            deferred.forEach((t)=>{
                FontCache._TEXT_USAGE.delete(t);
            });
            // Regenerate text instance cache
            this._TEXT_CACHE.clear();
            for (const [textInstance] of this._TEXT_USAGE.entries())this._TEXT_CACHE.set(textInstance.getHashCode(), textInstance);
            // Regenerated measurement cache
            const newTextMeasurementCache = new Map();
            for (const current of currentHashCodes)if (FontCache._MEASURE_CACHE.has(current)) newTextMeasurementCache.set(current, FontCache._MEASURE_CACHE.get(current));
            this._MEASURE_CACHE.clear();
            this._MEASURE_CACHE = newTextMeasurementCache;
        }
        static get cacheSize() {
            return FontCache._TEXT_USAGE.size;
        }
        /**
     * Force clear all cached text bitmaps
     */ static clearCache() {
            for (const [textInstance] of FontCache._TEXT_USAGE.entries())textInstance.dispose();
            FontCache._TEXT_USAGE.clear();
            FontCache._TEXT_CACHE.clear();
            FontCache._MEASURE_CACHE.clear();
        }
    }
    FontCache.FONT_TIMEOUT = 500;
    FontCache._LOGGER = Logger.getInstance();
    FontCache._TEXT_USAGE = new Map();
    FontCache._TEXT_CACHE = new Map();
    FontCache._MEASURE_CACHE = new Map();
    /**
 * Represents a system or web font in Excalibur
 *
 * If no options specified, the system sans-serif 10 pixel is used
 *
 * If loading a custom web font be sure to have the font loaded before you use it https://erikonarheim.com/posts/dont-test-fonts/
 */ class Font extends Graphic {
        constructor(options = {}){
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
            super(options); // <- Graphics properties
            /**
         * Set the font filtering mode, by default set to [[ImageFiltering.Blended]] regardless of the engine default smoothing
         *
         * If you have a pixel style font that may be a reason to switch this to [[ImageFiltering.Pixel]]
         */ this.filtering = ImageFiltering.Blended;
            /**
         * Font quality determines the size of the underlying raster text, higher quality means less jagged edges.
         * If quality is set to 1, then just enough raster bitmap is generated to render the text.
         *
         * You can think of quality as how zoomed in to the text you can get before seeing jagged edges.
         *
         * (Default 2)
         */ this.quality = 2;
            // Raster properties for fonts
            this.padding = 2;
            this.smoothing = false;
            this.lineWidth = 1;
            this.lineDash = [];
            this.color = Color.Black;
            this.family = "sans-serif";
            this.style = FontStyle.Normal;
            this.bold = false;
            this.unit = FontUnit.Px;
            this.textAlign = TextAlign.Left;
            this.baseAlign = BaseAlign.Top;
            this.direction = Direction.LeftToRight;
            /**
         * Font line height in pixels, default line height if unset
         */ this.lineHeight = undefined;
            this.size = 10;
            this.shadow = null;
            this._textBounds = new BoundingBox();
            this._textMeasurement = new FontTextInstance(this, "", Color.Black);
            // Raster properties
            this.smoothing = (_a = options === null || options === void 0 ? void 0 : options.smoothing) !== null && _a !== void 0 ? _a : this.smoothing;
            this.padding = (_b = options === null || options === void 0 ? void 0 : options.padding) !== null && _b !== void 0 ? _b : this.padding;
            this.color = (_c = options === null || options === void 0 ? void 0 : options.color) !== null && _c !== void 0 ? _c : this.color;
            this.strokeColor = (_d = options === null || options === void 0 ? void 0 : options.strokeColor) !== null && _d !== void 0 ? _d : this.strokeColor;
            this.lineDash = (_e = options === null || options === void 0 ? void 0 : options.lineDash) !== null && _e !== void 0 ? _e : this.lineDash;
            this.lineWidth = (_f = options === null || options === void 0 ? void 0 : options.lineWidth) !== null && _f !== void 0 ? _f : this.lineWidth;
            this.filtering = (_g = options === null || options === void 0 ? void 0 : options.filtering) !== null && _g !== void 0 ? _g : this.filtering;
            // Font specific properties
            this.family = (_h = options === null || options === void 0 ? void 0 : options.family) !== null && _h !== void 0 ? _h : this.family;
            this.style = (_j = options === null || options === void 0 ? void 0 : options.style) !== null && _j !== void 0 ? _j : this.style;
            this.bold = (_k = options === null || options === void 0 ? void 0 : options.bold) !== null && _k !== void 0 ? _k : this.bold;
            this.size = (_l = options === null || options === void 0 ? void 0 : options.size) !== null && _l !== void 0 ? _l : this.size;
            this.unit = (_m = options === null || options === void 0 ? void 0 : options.unit) !== null && _m !== void 0 ? _m : this.unit;
            this.textAlign = (_o = options === null || options === void 0 ? void 0 : options.textAlign) !== null && _o !== void 0 ? _o : this.textAlign;
            this.baseAlign = (_p = options === null || options === void 0 ? void 0 : options.baseAlign) !== null && _p !== void 0 ? _p : this.baseAlign;
            this.direction = (_q = options === null || options === void 0 ? void 0 : options.direction) !== null && _q !== void 0 ? _q : this.direction;
            this.lineHeight = (_r = options === null || options === void 0 ? void 0 : options.lineHeight) !== null && _r !== void 0 ? _r : this.lineHeight;
            this.quality = (_s = options === null || options === void 0 ? void 0 : options.quality) !== null && _s !== void 0 ? _s : this.quality;
            if (options === null || options === void 0 ? void 0 : options.shadow) {
                this.shadow = {};
                this.shadow.blur = (_t = options.shadow.blur) !== null && _t !== void 0 ? _t : this.shadow.blur;
                this.shadow.offset = (_u = options.shadow.offset) !== null && _u !== void 0 ? _u : this.shadow.offset;
                this.shadow.color = (_v = options.shadow.color) !== null && _v !== void 0 ? _v : this.shadow.color;
            }
        }
        clone() {
            return new Font({
                ...this.cloneGraphicOptions(),
                size: this.size,
                unit: this.unit,
                family: this.family,
                style: this.style,
                bold: this.bold,
                textAlign: this.textAlign,
                baseAlign: this.baseAlign,
                direction: this.direction,
                shadow: this.shadow ? {
                    blur: this.shadow.blur,
                    offset: this.shadow.offset,
                    color: this.shadow.color
                } : null
            });
        }
        get fontString() {
            return `${this.style} ${this.bold ? "bold" : ""} ${this.size}${this.unit} ${this.family}`;
        }
        get localBounds() {
            return this._textBounds;
        }
        _drawImage(_ex, _x, _y) {
        // TODO weird vestigial drawimage
        }
        _rotate(ex) {
            var _a;
            // TODO this needs to change depending on the bounding box...
            const origin = (_a = this.origin) !== null && _a !== void 0 ? _a : this._textBounds.center;
            ex.translate(origin.x, origin.y);
            ex.rotate(this.rotation);
            ex.translate(-origin.x, -origin.y);
        }
        _flip(ex) {
            if (this.flipHorizontal) {
                ex.translate(this._textBounds.width / this.scale.x, 0);
                ex.scale(-1, 1);
            }
            if (this.flipVertical) {
                ex.translate(0, -this._textBounds.height / 2 / this.scale.y);
                ex.scale(1, -1);
            }
        }
        measureTextWithoutCache(text, maxWidth) {
            return this._textMeasurement.measureText(text, maxWidth);
        }
        /**
     * Returns a BoundingBox that is the total size of the text including multiple lines
     *
     * Does not include any padding or adjustment
     * @param text
     * @returns BoundingBox
     */ measureText(text, maxWidth) {
            return FontCache.measureText(text, this, maxWidth);
        }
        _postDraw(ex) {
            ex.restore();
        }
        render(ex, text, colorOverride, x, y, maxWidth) {
            const textInstance = FontCache.getTextInstance(text, this, colorOverride);
            // Apply affine transformations
            this._textBounds = textInstance.dimensions;
            this._preDraw(ex, x, y);
            textInstance.render(ex, x, y, maxWidth);
            this._postDraw(ex);
        }
    }
    /**
 * Represent Text graphics in excalibur
 *
 * Useful for in game labels, ui, or overlays
 */ class Text extends Graphic {
        constructor(options){
            var _a, _b;
            super(options);
            this._text = "";
            this._textWidth = 0;
            this._textHeight = 0;
            // This order is important font, color, then text
            this.font = (_a = options.font) !== null && _a !== void 0 ? _a : new Font();
            this.color = (_b = options.color) !== null && _b !== void 0 ? _b : this.color;
            this.text = options.text;
            this.maxWidth = options.maxWidth;
        }
        clone() {
            var _a, _b;
            return new Text({
                text: this.text.slice(),
                color: (_b = (_a = this.color) === null || _a === void 0 ? void 0 : _a.clone()) !== null && _b !== void 0 ? _b : Color.Black,
                font: this.font.clone(),
                maxWidth: this.maxWidth
            });
        }
        get text() {
            return this._text;
        }
        set text(value) {
            this._text = value;
            this._calculateDimension();
        }
        get font() {
            return this._font;
        }
        set font(font) {
            this._font = font;
        }
        get width() {
            if (this._textWidth === 0) this._calculateDimension();
            return this._textWidth * this.scale.x;
        }
        get height() {
            if (this._textHeight === 0) this._calculateDimension();
            return this._textHeight * this.scale.y;
        }
        _calculateDimension() {
            const { width: width, height: height } = this.font.measureText(this._text, this.maxWidth);
            this._textWidth = width;
            this._textHeight = height;
        }
        get localBounds() {
            return this.font.measureText(this._text, this.maxWidth).scale(this.scale);
        }
        _rotate(_ex) {
        // None this is delegated to font
        // This override erases the default behavior
        }
        _flip(_ex) {
        // None this is delegated to font
        // This override erases the default behavior
        }
        _preDraw(ex, x, y) {
            if (this.isStale() || this.font.isStale()) {
                this.font.flipHorizontal = this.flipHorizontal;
                this.font.flipVertical = this.flipVertical;
                this.font.rotation = this.rotation;
                this.font.origin = this.origin;
                this.font.opacity = this.opacity;
            }
            this.font.tint = this.tint;
            super._preDraw(ex, x, y);
        }
        _drawImage(ex, x, y) {
            var _a;
            let color = Color.Black;
            if (this.font instanceof Font) color = (_a = this.color) !== null && _a !== void 0 ? _a : this.font.color;
            const { width: width, height: height } = this.font.measureText(this._text, this.maxWidth);
            this._textWidth = width;
            this._textHeight = height;
            this.font.render(ex, this._text, color, x, y, this.maxWidth);
            if (this.font.showDebug) {
                ex.debug.drawRect(x - width, y - height, width * 2, height * 2);
                if (this.maxWidth != null) ex.debug.drawRect(x, y, this.maxWidth, this.height, {
                    color: Color.Yellow
                });
            }
        }
    }
    /**
 * Type guard for checking if something is an Actor
 * @param x
 */ function isActor(x) {
        return x instanceof Actor;
    }
    const ActorEvents = {
        CollisionStart: "collisionstart",
        CollisionEnd: "collisionend",
        PreCollision: "precollision",
        PostCollision: "postcollision",
        Kill: "kill",
        PreKill: "prekill",
        PostKill: "postkill",
        PreDraw: "predraw",
        PostDraw: "postdraw",
        PreTransformDraw: "pretransformdraw",
        PostTransformDraw: "posttransformdraw",
        PreDebugDraw: "predebugdraw",
        PostDebugDraw: "postdebugdraw",
        PointerUp: "pointerup",
        PointerDown: "pointerdown",
        PointerEnter: "pointerenter",
        PointerLeave: "pointerleave",
        PointerMove: "pointermove",
        PointerCancel: "pointercancel",
        Wheel: "pointerwheel",
        PointerDrag: "pointerdragstart",
        PointerDragEnd: "pointerdragend",
        PointerDragEnter: "pointerdragenter",
        PointerDragLeave: "pointerdragleave",
        PointerDragMove: "pointerdragmove",
        EnterViewPort: "enterviewport",
        ExitViewPort: "exitviewport",
        ActionStart: "actionstart",
        ActionComplete: "actioncomplete"
    };
    /**
 * The most important primitive in Excalibur is an `Actor`. Anything that
 * can move on the screen, collide with another `Actor`, respond to events,
 * or interact with the current scene, must be an actor. An `Actor` **must**
 * be part of a [[Scene]] for it to be drawn to the screen.
 */ class Actor extends Entity {
        /**
     * Gets the position vector of the actor in pixels
     */ get pos() {
            return this.transform.pos;
        }
        /**
     * Sets the position vector of the actor in pixels
     */ set pos(thePos) {
            this.transform.pos = thePos.clone();
        }
        /**
     * Gets the position vector of the actor from the last frame
     */ get oldPos() {
            return this.body.oldPos;
        }
        /**
     * Sets the position vector of the actor in the last frame
     */ set oldPos(thePos) {
            this.body.oldPos.setTo(thePos.x, thePos.y);
        }
        /**
     * Gets the velocity vector of the actor in pixels/sec
     */ get vel() {
            return this.motion.vel;
        }
        /**
     * Sets the velocity vector of the actor in pixels/sec
     */ set vel(theVel) {
            this.motion.vel = theVel.clone();
        }
        /**
     * Gets the velocity vector of the actor from the last frame
     */ get oldVel() {
            return this.body.oldVel;
        }
        /**
     * Sets the velocity vector of the actor from the last frame
     */ set oldVel(theVel) {
            this.body.oldVel.setTo(theVel.x, theVel.y);
        }
        /**
     * Gets the acceleration vector of the actor in pixels/second/second. An acceleration pointing down such as (0, 100) may be
     * useful to simulate a gravitational effect.
     */ get acc() {
            return this.motion.acc;
        }
        /**
     * Sets the acceleration vector of teh actor in pixels/second/second
     */ set acc(theAcc) {
            this.motion.acc = theAcc.clone();
        }
        /**
     * Sets the acceleration of the actor from the last frame. This does not include the global acc [[Physics.acc]].
     */ set oldAcc(theAcc) {
            this.body.oldAcc.setTo(theAcc.x, theAcc.y);
        }
        /**
     * Gets the acceleration of the actor from the last frame. This does not include the global acc [[Physics.acc]].
     */ get oldAcc() {
            return this.body.oldAcc;
        }
        /**
     * Gets the rotation of the actor in radians. 1 radian = 180/PI Degrees.
     */ get rotation() {
            return this.transform.rotation;
        }
        /**
     * Sets the rotation of the actor in radians. 1 radian = 180/PI Degrees.
     */ set rotation(theAngle) {
            this.transform.rotation = theAngle;
        }
        /**
     * Gets the rotational velocity of the actor in radians/second
     */ get angularVelocity() {
            return this.motion.angularVelocity;
        }
        /**
     * Sets the rotational velocity of the actor in radians/sec
     */ set angularVelocity(angularVelocity) {
            this.motion.angularVelocity = angularVelocity;
        }
        get scale() {
            return this.get(TransformComponent).scale;
        }
        set scale(scale) {
            this.get(TransformComponent).scale = scale;
        }
        /**
     * The anchor to apply all actor related transformations like rotation,
     * translation, and scaling. By default the anchor is in the center of
     * the actor. By default it is set to the center of the actor (.5, .5)
     *
     * An anchor of (.5, .5) will ensure that drawings are centered.
     *
     * Use `anchor.setTo` to set the anchor to a different point using
     * values between 0 and 1. For example, anchoring to the top-left would be
     * `Actor.anchor.setTo(0, 0)` and top-right would be `Actor.anchor.setTo(0, 1)`.
     */ get anchor() {
            return this._anchor;
        }
        set anchor(vec) {
            this._anchor = watch(vec, (v)=>this._handleAnchorChange(v));
            this._handleAnchorChange(vec);
        }
        _handleAnchorChange(v) {
            if (this.graphics) this.graphics.anchor = v;
        }
        /**
     * The offset in pixels to apply to all actor graphics
     *
     * Default offset of (0, 0)
     */ get offset() {
            return this._offset;
        }
        set offset(vec) {
            this._offset = watch(vec, (v)=>this._handleOffsetChange(v));
            this._handleOffsetChange(vec);
        }
        _handleOffsetChange(v) {
            if (this.graphics) this.graphics.offset = v;
        }
        /**
     * Indicates whether the actor is physically in the viewport
     */ get isOffScreen() {
            return this.hasTag("ex.offscreen");
        }
        get draggable() {
            return this._draggable;
        }
        set draggable(isDraggable) {
            if (isDraggable) {
                if (isDraggable && !this._draggable) {
                    this.events.on("pointerdragstart", this._pointerDragStartHandler);
                    this.events.on("pointerdragend", this._pointerDragEndHandler);
                    this.events.on("pointerdragmove", this._pointerDragMoveHandler);
                    this.events.on("pointerdragleave", this._pointerDragLeaveHandler);
                } else if (!isDraggable && this._draggable) {
                    this.events.off("pointerdragstart", this._pointerDragStartHandler);
                    this.events.off("pointerdragend", this._pointerDragEndHandler);
                    this.events.off("pointerdragmove", this._pointerDragMoveHandler);
                    this.events.off("pointerdragleave", this._pointerDragLeaveHandler);
                }
                this._draggable = isDraggable;
            }
        }
        /**
     * Sets the color of the actor's current graphic
     */ get color() {
            return this._color;
        }
        set color(v) {
            this._color = v.clone();
            const currentGraphic = this.graphics.current;
            if (currentGraphic instanceof Raster || currentGraphic instanceof Text) currentGraphic.color = this._color;
        }
        // #endregion
        /**
     *
     * @param config
     */ constructor(config){
            super();
            this.events = new EventEmitter();
            this._anchor = watch(Vector.Half, (v)=>this._handleAnchorChange(v));
            this._offset = watch(Vector.Zero, (v)=>this._handleOffsetChange(v));
            /**
         * Convenience reference to the global logger
         */ this.logger = Logger.getInstance();
            /**
         * Draggable helper
         */ this._draggable = false;
            this._dragging = false;
            this._pointerDragStartHandler = ()=>{
                this._dragging = true;
            };
            this._pointerDragEndHandler = ()=>{
                this._dragging = false;
            };
            this._pointerDragMoveHandler = (pe)=>{
                if (this._dragging) this.pos = pe.worldPos;
            };
            this._pointerDragLeaveHandler = (pe)=>{
                if (this._dragging) this.pos = pe.worldPos;
            };
            const { name: name, x: x, y: y, pos: pos, coordPlane: coordPlane, scale: scale, width: width, height: height, radius: radius, collider: collider, vel: vel, acc: acc, rotation: rotation, angularVelocity: angularVelocity, z: z, color: color, visible: visible, opacity: opacity, anchor: anchor, offset: offset, collisionType: collisionType, collisionGroup: collisionGroup } = {
                ...config
            };
            this.name = name !== null && name !== void 0 ? name : this.name;
            this.anchor = anchor !== null && anchor !== void 0 ? anchor : Actor.defaults.anchor.clone();
            this.offset = offset !== null && offset !== void 0 ? offset : Vector.Zero;
            this.transform = new TransformComponent();
            this.addComponent(this.transform);
            this.pos = pos !== null && pos !== void 0 ? pos : vec(x !== null && x !== void 0 ? x : 0, y !== null && y !== void 0 ? y : 0);
            this.rotation = rotation !== null && rotation !== void 0 ? rotation : 0;
            this.scale = scale !== null && scale !== void 0 ? scale : vec(1, 1);
            this.z = z !== null && z !== void 0 ? z : 0;
            this.transform.coordPlane = coordPlane !== null && coordPlane !== void 0 ? coordPlane : CoordPlane.World;
            this.pointer = new PointerComponent;
            this.addComponent(this.pointer);
            this.graphics = new GraphicsComponent({
                anchor: this.anchor,
                offset: this.offset,
                opacity: opacity
            });
            this.addComponent(this.graphics);
            this.motion = new MotionComponent;
            this.addComponent(this.motion);
            this.vel = vel !== null && vel !== void 0 ? vel : Vector.Zero;
            this.acc = acc !== null && acc !== void 0 ? acc : Vector.Zero;
            this.angularVelocity = angularVelocity !== null && angularVelocity !== void 0 ? angularVelocity : 0;
            this.actions = new ActionsComponent;
            this.addComponent(this.actions);
            this.body = new BodyComponent;
            this.addComponent(this.body);
            this.body.collisionType = collisionType !== null && collisionType !== void 0 ? collisionType : CollisionType.Passive;
            if (collisionGroup) this.body.group = collisionGroup;
            if (collider) {
                this.collider = new ColliderComponent(collider);
                this.addComponent(this.collider);
            } else if (radius) {
                this.collider = new ColliderComponent(Shape.Circle(radius));
                this.addComponent(this.collider);
            } else if (width > 0 && height > 0) {
                this.collider = new ColliderComponent(Shape.Box(width, height, this.anchor));
                this.addComponent(this.collider);
            } else {
                this.collider = new ColliderComponent();
                this.addComponent(this.collider); // no collider
            }
            this.graphics.visible = visible !== null && visible !== void 0 ? visible : true;
            if (color) {
                this.color = color;
                if (width && height) this.graphics.add(new Rectangle({
                    color: color,
                    width: width,
                    height: height
                }));
                else if (radius) this.graphics.add(new Circle({
                    color: color,
                    radius: radius
                }));
            }
        }
        clone() {
            const clone = new Actor({
                color: this.color.clone(),
                anchor: this.anchor.clone(),
                offset: this.offset.clone()
            });
            clone.clearComponents();
            clone.processComponentRemoval();
            // Clone builtins, order is important, same as ctor
            clone.addComponent(clone.transform = this.transform.clone(), true);
            clone.addComponent(clone.pointer = this.pointer.clone(), true);
            clone.addComponent(clone.graphics = this.graphics.clone(), true);
            clone.addComponent(clone.motion = this.motion.clone(), true);
            clone.addComponent(clone.actions = this.actions.clone(), true);
            clone.addComponent(clone.body = this.body.clone(), true);
            clone.addComponent(clone.collider = this.collider.clone(), true);
            const builtInComponents = [
                this.transform,
                this.pointer,
                this.graphics,
                this.motion,
                this.actions,
                this.body,
                this.collider
            ];
            // Clone non-builtin the current actors components
            const components = this.getComponents();
            for (const c of components)if (!builtInComponents.includes(c)) clone.addComponent(c.clone(), true);
            return clone;
        }
        /**
     * `onInitialize` is called before the first update of the actor. This method is meant to be
     * overridden. This is where initialization of child actors should take place.
     *
     * Synonymous with the event handler `.on('initialize', (evt) => {...})`
     */ onInitialize(engine) {
        // Override me
        }
        /**
     * Initializes this actor and all it's child actors, meant to be called by the Scene before first update not by users of Excalibur.
     *
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     * @internal
     */ _initialize(engine) {
            super._initialize(engine);
            for (const child of this.children)child._initialize(engine);
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        // #endregion
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _prekill handler for [[onPreKill]] lifecycle event
     * @internal
     */ _prekill(scene) {
            this.events.emit("prekill", new PreKillEvent(this));
            this.onPreKill(scene);
        }
        /**
     * Safe to override onPreKill lifecycle event handler. Synonymous with `.on('prekill', (evt) =>{...})`
     *
     * `onPreKill` is called directly before an actor is killed and removed from its current [[Scene]].
     */ onPreKill(scene) {
        // Override me
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _prekill handler for [[onPostKill]] lifecycle event
     * @internal
     */ _postkill(scene) {
            this.events.emit("postkill", new PostKillEvent(this));
            this.onPostKill(scene);
        }
        /**
     * Safe to override onPostKill lifecycle event handler. Synonymous with `.on('postkill', (evt) => {...})`
     *
     * `onPostKill` is called directly after an actor is killed and remove from its current [[Scene]].
     */ onPostKill(scene) {
        // Override me
        }
        /**
     * If the current actor is a member of the scene, this will remove
     * it from the scene graph. It will no longer be drawn or updated.
     */ kill() {
            if (this.scene) {
                this._prekill(this.scene);
                this.events.emit("kill", new KillEvent(this));
                super.kill();
                this._postkill(this.scene);
            } else this.logger.warn(`Cannot kill actor named "${this.name}", it was never added to the Scene`);
        }
        /**
     * If the current actor is killed, it will now not be killed.
     */ unkill() {
            this.active = true;
        }
        /**
     * Indicates wether the actor has been killed.
     */ isKilled() {
            return !this.active;
        }
        /**
     * Gets the z-index of an actor. The z-index determines the relative order an actor is drawn in.
     * Actors with a higher z-index are drawn on top of actors with a lower z-index
     */ get z() {
            return this.get(TransformComponent).z;
        }
        /**
     * Sets the z-index of an actor and updates it in the drawing list for the scene.
     * The z-index determines the relative order an actor is drawn in.
     * Actors with a higher z-index are drawn on top of actors with a lower z-index
     * @param newZ new z-index to assign
     */ set z(newZ) {
            this.get(TransformComponent).z = newZ;
        }
        /**
     * Get the center point of an actor (global position)
     */ get center() {
            const globalPos = this.getGlobalPos();
            return new Vector(globalPos.x + this.width / 2 - this.anchor.x * this.width, globalPos.y + this.height / 2 - this.anchor.y * this.height);
        }
        /**
     * Get the local center point of an actor
     */ get localCenter() {
            return new Vector(this.pos.x + this.width / 2 - this.anchor.x * this.width, this.pos.y + this.height / 2 - this.anchor.y * this.height);
        }
        get width() {
            return this.collider.localBounds.width * this.getGlobalScale().x;
        }
        get height() {
            return this.collider.localBounds.height * this.getGlobalScale().y;
        }
        /**
     * Gets this actor's rotation taking into account any parent relationships
     * @returns Rotation angle in radians
     */ getGlobalRotation() {
            return this.get(TransformComponent).globalRotation;
        }
        /**
     * Gets an actor's world position taking into account parent relationships, scaling, rotation, and translation
     * @returns Position in world coordinates
     */ getGlobalPos() {
            return this.get(TransformComponent).globalPos;
        }
        /**
     * Gets the global scale of the Actor
     */ getGlobalScale() {
            return this.get(TransformComponent).globalScale;
        }
        // #region Collision
        /**
     * Tests whether the x/y specified are contained in the actor
     * @param x  X coordinate to test (in world coordinates)
     * @param y  Y coordinate to test (in world coordinates)
     * @param recurse checks whether the x/y are contained in any child actors (if they exist).
     */ contains(x, y, recurse = false) {
            const point = vec(x, y);
            const collider = this.get(ColliderComponent);
            collider.update();
            const geom = collider.get();
            if (!geom) return false;
            const containment = geom.contains(point);
            if (recurse) return containment || this.children.some((child)=>{
                return child.contains(x, y, true);
            });
            return containment;
        }
        /**
     * Returns true if the two actor.collider's surfaces are less than or equal to the distance specified from each other
     * @param actor     Actor to test
     * @param distance  Distance in pixels to test
     */ within(actor, distance) {
            const collider = this.get(ColliderComponent);
            const otherCollider = actor.get(ColliderComponent);
            const me = collider.get();
            const other = otherCollider.get();
            if (me && other) return me.getClosestLineBetween(other).getLength() <= distance;
            return false;
        }
        // #endregion
        // #region Update
        /**
     * Called by the Engine, updates the state of the actor
     * @internal
     * @param engine The reference to the current game engine
     * @param delta  The time elapsed since the last update in milliseconds
     */ update(engine, delta) {
            this._initialize(engine);
            this._preupdate(engine, delta);
            this._postupdate(engine, delta);
        }
        /**
     * Safe to override onPreUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPreUpdate` is called directly before an actor is updated.
     */ onPreUpdate(engine, delta) {
        // Override me
        }
        /**
     * Safe to override onPostUpdate lifecycle event handler. Synonymous with `.on('postupdate', (evt) =>{...})`
     *
     * `onPostUpdate` is called directly after an actor is updated.
     */ onPostUpdate(engine, delta) {
        // Override me
        }
        /**
     * Fires before every collision resolution for a confirmed contact
     * @param self
     * @param other
     * @param side
     * @param contact
     */ onPreCollisionResolve(self1, other, side, contact) {
        // Override me
        }
        /**
     * Fires after every resolution for a confirmed contact.
     * @param self
     * @param other
     * @param side
     * @param contact
     */ onPostCollisionResolve(self1, other, side, contact) {
        // Override me
        }
        /**
     * Fires once when 2 entities with a ColliderComponent first start colliding or touching, if the Colliders stay in contact this
     * does not continue firing until they separate and re-collide.
     * @param self
     * @param other
     * @param side
     * @param contact
     */ onCollisionStart(self1, other, side, contact) {
        // Override me
        }
        /**
     * Fires once when 2 entities with a ColliderComponent separate after having been in contact.
     * @param self
     * @param other
     * @param side
     * @param lastContact
     */ onCollisionEnd(self1, other, side, lastContact) {
        // Override me
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPreUpdate]] lifecycle event
     * @internal
     */ _preupdate(engine, delta) {
            this.events.emit("preupdate", new PreUpdateEvent(engine, delta, this));
            this.onPreUpdate(engine, delta);
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPostUpdate]] lifecycle event
     * @internal
     */ _postupdate(engine, delta) {
            this.events.emit("postupdate", new PostUpdateEvent(engine, delta, this));
            this.onPostUpdate(engine, delta);
        }
    }
    // #region Properties
    /**
 * Set defaults for all Actors
 */ Actor.defaults = {
        anchor: Vector.Half
    };
    /**
 * Type guard to detect a screen element
 */ function isScreenElement(actor) {
        return actor instanceof ScreenElement;
    }
    /**
 * Helper [[Actor]] primitive for drawing UI's, optimized for UI drawing. Does
 * not participate in collisions. Drawn on top of all other actors.
 */ class ScreenElement extends Actor {
        constructor(config){
            var _a, _b;
            super({
                ...config
            });
            this.get(TransformComponent).coordPlane = CoordPlane.Screen;
            this.anchor = (_a = config === null || config === void 0 ? void 0 : config.anchor) !== null && _a !== void 0 ? _a : vec(0, 0);
            this.body.collisionType = (_b = config === null || config === void 0 ? void 0 : config.collisionType) !== null && _b !== void 0 ? _b : CollisionType.PreventCollision;
            this.pointer.useGraphicsBounds = true;
            this.pointer.useColliderShape = false;
            if (!(config === null || config === void 0 ? void 0 : config.collider) && (config === null || config === void 0 ? void 0 : config.width) > 0 && (config === null || config === void 0 ? void 0 : config.height) > 0) this.collider.useBoxCollider(this.width, this.height, this.anchor);
        }
        _initialize(engine) {
            this._engine = engine;
            super._initialize(engine);
        }
        contains(x, y, useWorld = true) {
            if (useWorld) return super.contains(x, y);
            const coords = this._engine.worldToScreenCoordinates(new Vector(x, y));
            return super.contains(coords.x, coords.y);
        }
    }
    /**
 * The Excalibur timer hooks into the internal timer and fires callbacks,
 * after a certain interval, optionally repeating.
 */ class Timer {
        get complete() {
            return this._complete;
        }
        constructor(fcn, interval, repeats, numberOfRepeats, randomRange, random){
            this._logger = Logger.getInstance();
            this.id = 0;
            this._elapsedTime = 0;
            this._totalTimeAlive = 0;
            this._running = false;
            this._numberOfTicks = 0;
            this.interval = 10;
            this.repeats = false;
            this.maxNumberOfRepeats = -1;
            this.randomRange = [
                0,
                0
            ];
            this._baseInterval = 10;
            this._generateRandomInterval = ()=>{
                return this._baseInterval + this.random.integer(this.randomRange[0], this.randomRange[1]);
            };
            this._complete = false;
            this.scene = null;
            if (typeof fcn !== "function") {
                const options = fcn;
                fcn = options.fcn;
                interval = options.interval;
                repeats = options.repeats;
                numberOfRepeats = options.numberOfRepeats;
                randomRange = options.randomRange;
                random = options.random;
            }
            if (!!numberOfRepeats && numberOfRepeats >= 0) {
                this.maxNumberOfRepeats = numberOfRepeats;
                if (!repeats) throw new Error("repeats must be set to true if numberOfRepeats is set");
            }
            this.id = Timer._MAX_ID++;
            this._callbacks = [];
            this._baseInterval = this.interval = interval;
            if (!!randomRange) {
                if (randomRange[0] > randomRange[1]) throw new Error("min value must be lower than max value for range");
                //We use the instance of ex.Random to generate the range
                this.random = random !== null && random !== void 0 ? random : new Random();
                this.randomRange = randomRange;
                this.interval = this._generateRandomInterval();
                this.on(()=>{
                    this.interval = this._generateRandomInterval();
                });
            }
            this.repeats = repeats || this.repeats;
            if (fcn) this.on(fcn);
        }
        /**
     * Adds a new callback to be fired after the interval is complete
     * @param fcn The callback to be added to the callback list, to be fired after the interval is complete.
     */ on(fcn) {
            this._callbacks.push(fcn);
        }
        /**
     * Removes a callback from the callback list to be fired after the interval is complete.
     * @param fcn The callback to be removed from the callback list, to be fired after the interval is complete.
     */ off(fcn) {
            const index = this._callbacks.indexOf(fcn);
            this._callbacks.splice(index, 1);
        }
        /**
     * Updates the timer after a certain number of milliseconds have elapsed. This is used internally by the engine.
     * @param delta  Number of elapsed milliseconds since the last update.
     */ update(delta) {
            if (this._running) {
                this._totalTimeAlive += delta;
                this._elapsedTime += delta;
                if (this.maxNumberOfRepeats > -1 && this._numberOfTicks >= this.maxNumberOfRepeats) {
                    this._complete = true;
                    this._running = false;
                    this._elapsedTime = 0;
                }
                if (!this.complete && this._elapsedTime >= this.interval) {
                    this._callbacks.forEach((c)=>{
                        c.call(this);
                    });
                    this._numberOfTicks++;
                    if (this.repeats) this._elapsedTime = 0;
                    else {
                        this._complete = true;
                        this._running = false;
                        this._elapsedTime = 0;
                    }
                }
            }
        }
        /**
     * Resets the timer so that it can be reused, and optionally reconfigure the timers interval.
     *
     * Warning** you may need to call `timer.start()` again if the timer had completed
     * @param newInterval If specified, sets a new non-negative interval in milliseconds to refire the callback
     * @param newNumberOfRepeats If specified, sets a new non-negative upper limit to the number of time this timer executes
     */ reset(newInterval, newNumberOfRepeats) {
            if (!!newInterval && newInterval >= 0) this._baseInterval = this.interval = newInterval;
            if (!!this.maxNumberOfRepeats && this.maxNumberOfRepeats >= 0) {
                this.maxNumberOfRepeats = newNumberOfRepeats;
                if (!this.repeats) throw new Error("repeats must be set to true if numberOfRepeats is set");
            }
            this._complete = false;
            this._elapsedTime = 0;
            this._numberOfTicks = 0;
        }
        get timesRepeated() {
            return this._numberOfTicks;
        }
        getTimeRunning() {
            return this._totalTimeAlive;
        }
        /**
     * @returns milliseconds until the next action callback, if complete will return 0
     */ get timeToNextAction() {
            if (this.complete) return 0;
            return this.interval - this._elapsedTime;
        }
        /**
     * @returns milliseconds elapsed toward the next action
     */ get timeElapsedTowardNextAction() {
            return this._elapsedTime;
        }
        get isRunning() {
            return this._running;
        }
        /**
     * Pauses the timer, time will no longer increment towards the next call
     */ pause() {
            this._running = false;
            return this;
        }
        /**
     * Resumes the timer, time will now increment towards the next call.
     */ resume() {
            this._running = true;
            return this;
        }
        /**
     * Starts the timer, if the timer was complete it will restart the timer and reset the elapsed time counter
     */ start() {
            if (!this.scene) this._logger.warn("Cannot start a timer not part of a scene, timer wont start until added");
            this._running = true;
            if (this.complete) {
                this._complete = false;
                this._elapsedTime = 0;
                this._numberOfTicks = 0;
            }
            return this;
        }
        /**
     * Stops the timer and resets the elapsed time counter towards the next action invocation
     */ stop() {
            this._running = false;
            this._elapsedTime = 0;
            this._numberOfTicks = 0;
            return this;
        }
        /**
     * Cancels the timer, preventing any further executions.
     */ cancel() {
            this.pause();
            if (this.scene) this.scene.cancelTimer(this);
        }
    }
    Timer._MAX_ID = 0;
    class ParallaxComponent extends Component {
        constructor(parallaxFactor){
            super();
            this.parallaxFactor = vec(1.0, 1.0);
            this.parallaxFactor = parallaxFactor !== null && parallaxFactor !== void 0 ? parallaxFactor : this.parallaxFactor;
        }
    }
    /**
 * Provide arbitrary drawing for the purposes of debugging your game
 *
 * Will only show when the Engine is set to debug mode [[Engine.showDebug]] or [[Engine.toggleDebug]]
 *
 */ class DebugGraphicsComponent extends Component {
        constructor(draw, useTransform = true){
            super();
            this.draw = draw;
            this.useTransform = useTransform;
        }
    }
    const TileMapEvents = {
        PreUpdate: "preupdate",
        PostUpdate: "postupdate",
        PreDraw: "predraw",
        PostDraw: "postdraw",
        PointerUp: "pointerup",
        PointerDown: "pointerdown",
        PointerMove: "pointermove",
        PointerCancel: "pointercancel"
    };
    /**
 * The TileMap provides a mechanism for doing flat 2D tiles rendered in a grid.
 *
 * TileMaps are useful for top down or side scrolling grid oriented games.
 */ class TileMap extends Entity {
        flagCollidersDirty() {
            this._collidersDirty = true;
        }
        flagTilesDirty() {
            for(let i = 0; i < this.tiles.length; i++)if (this.tiles[i]) this.tiles[i].flagDirty();
        }
        get x() {
            var _a;
            return (_a = this.transform.pos.x) !== null && _a !== void 0 ? _a : 0;
        }
        set x(val) {
            var _a;
            if ((_a = this.transform) === null || _a === void 0 ? void 0 : _a.pos) this.get(TransformComponent).pos = vec(val, this.y);
        }
        get y() {
            var _a, _b;
            return (_b = (_a = this.transform) === null || _a === void 0 ? void 0 : _a.pos.y) !== null && _b !== void 0 ? _b : 0;
        }
        set y(val) {
            var _a;
            if ((_a = this.transform) === null || _a === void 0 ? void 0 : _a.pos) this.transform.pos = vec(this.x, val);
        }
        get z() {
            var _a;
            return (_a = this.transform.z) !== null && _a !== void 0 ? _a : 0;
        }
        set z(val) {
            if (this.transform) this.transform.z = val;
        }
        get rotation() {
            var _a, _b;
            return (_b = (_a = this.transform) === null || _a === void 0 ? void 0 : _a.rotation) !== null && _b !== void 0 ? _b : 0;
        }
        set rotation(val) {
            if (this.transform) this.transform.rotation = val;
        }
        get scale() {
            var _a, _b;
            return (_b = (_a = this.transform) === null || _a === void 0 ? void 0 : _a.scale) !== null && _b !== void 0 ? _b : Vector.One;
        }
        set scale(val) {
            var _a;
            if ((_a = this.transform) === null || _a === void 0 ? void 0 : _a.scale) this.transform.scale = val;
        }
        get pos() {
            return this.transform.pos;
        }
        set pos(val) {
            this.transform.pos = val;
        }
        get vel() {
            return this._motion.vel;
        }
        set vel(val) {
            this._motion.vel = val;
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        /**
     * @param options
     */ constructor(options){
            var _a, _b, _c;
            super([], options.name);
            this.events = new EventEmitter();
            this._token = 0;
            this.logger = Logger.getInstance();
            this.tiles = [];
            this._rows = [];
            this._cols = [];
            this.renderFromTopOfGraphic = false;
            this.meshingLookBehind = 10;
            this._collidersDirty = true;
            this._forwardPointerEventToTile = (eventType)=>(evt)=>{
                    const tile = this.getTileByPoint(evt.worldPos);
                    if (tile) tile.events.emit(eventType, evt);
                };
            this._originalOffsets = new WeakMap();
            this.meshingLookBehind = (_a = options.meshingLookBehind) !== null && _a !== void 0 ? _a : this.meshingLookBehind;
            this.addComponent(new TransformComponent());
            this.addComponent(new MotionComponent());
            this.addComponent(new BodyComponent({
                type: CollisionType.Fixed
            }));
            this.addComponent(new GraphicsComponent({
                onPostDraw: (ctx, delta)=>this.draw(ctx, delta)
            }));
            this.addComponent(new DebugGraphicsComponent((ctx, debugFlags)=>this.debug(ctx, debugFlags), false));
            this.addComponent(new ColliderComponent());
            this.addComponent(new PointerComponent);
            this.pointer = this.get(PointerComponent);
            this._graphics = this.get(GraphicsComponent);
            this.transform = this.get(TransformComponent);
            this._motion = this.get(MotionComponent);
            this.collider = this.get(ColliderComponent);
            this._composite = this.collider.useCompositeCollider([]);
            this.transform.pos = (_b = options.pos) !== null && _b !== void 0 ? _b : Vector.Zero;
            this._oldPos = this.transform.pos.clone();
            this._oldScale = this.transform.scale.clone();
            this.renderFromTopOfGraphic = (_c = options.renderFromTopOfGraphic) !== null && _c !== void 0 ? _c : this.renderFromTopOfGraphic;
            this.tileWidth = options.tileWidth;
            this.tileHeight = options.tileHeight;
            this.rows = options.rows;
            this.columns = options.columns;
            this.tiles = new Array(this.rows * this.columns);
            this._rows = new Array(this.rows);
            this._cols = new Array(this.columns);
            let currentCol = [];
            for(let i = 0; i < this.columns; i++){
                for(let j = 0; j < this.rows; j++){
                    const tile = new Tile({
                        x: i,
                        y: j,
                        map: this
                    });
                    tile.map = this;
                    this.tiles[i + j * this.columns] = tile;
                    currentCol.push(tile);
                    if (!this._rows[j]) this._rows[j] = [];
                    this._rows[j].push(tile);
                }
                this._cols[i] = currentCol;
                currentCol = [];
            }
            this._setupPointerToTile();
            this._graphics.localBounds = new BoundingBox({
                left: 0,
                top: 0,
                right: this.columns * this.tileWidth * this.scale.x,
                bottom: this.rows * this.tileHeight * this.scale.y
            });
        }
        _initialize(engine) {
            super._initialize(engine);
            this._engine = engine;
        }
        _setupPointerToTile() {
            this.events.on("pointerup", this._forwardPointerEventToTile("pointerup"));
            this.events.on("pointerdown", this._forwardPointerEventToTile("pointerdown"));
            this.events.on("pointermove", this._forwardPointerEventToTile("pointermove"));
            this.events.on("pointercancel", this._forwardPointerEventToTile("pointercancel"));
        }
        _getOrSetColliderOriginalOffset(collider) {
            if (!this._originalOffsets.has(collider)) {
                const originalOffset = collider.offset;
                this._originalOffsets.set(collider, originalOffset);
                return originalOffset;
            } else return this._originalOffsets.get(collider);
        }
        /**
     * Tiles colliders based on the solid tiles in the tilemap.
     */ _updateColliders() {
            this.collider.$colliderRemoved.notifyAll(this._composite);
            this._composite.clearColliders();
            const colliders = [];
            this._composite = this.collider.useCompositeCollider([]);
            let current;
            /**
         * Returns wether or not the 2 boxes share an edge and are the same height
         * @param prev
         * @param next
         * @returns true if they share and edge, false if not
         */ const shareEdges = (prev, next)=>{
                if (prev && next) // same top/bottom
                return prev.top === next.top && prev.bottom === next.bottom && // Shared right/left edge
                prev.right === next.left;
                return false;
            };
            /**
         * Potentially merges the current collider into a list of previous ones, mutating the list
         * If checkAndCombine returns true, the collider was successfully merged and should be thrown away
         * @param current current collider to test
         * @param colliders List of colliders to consider merging with
         * @param maxLookBack The amount of colliders to look back for combination
         * @returns false when no combination found, true when successfully combined
         */ const checkAndCombine = (current, colliders, maxLookBack = this.meshingLookBehind)=>{
                if (!current) return false;
                // walk backwards through the list of colliders and combine with the first that shares an edge
                for(let i = colliders.length - 1; i >= 0; i--){
                    if (maxLookBack-- < 0) // blunt the O(n^2) algorithm a bit
                    return false;
                    const prev = colliders[i];
                    if (shareEdges(prev, current)) {
                        colliders[i] = prev.combine(current);
                        return true;
                    }
                }
                return false;
            };
            // ? configurable bias perhaps, horizontal strips vs. vertical ones
            // Bad tile collider packing algorithm
            for(let i = 0; i < this.columns; i++){
                // Scan column for colliders
                for(let j = 0; j < this.rows; j++){
                    const tile = this.tiles[i + j * this.columns];
                    // Current tile in column is solid build up current collider
                    if (tile.solid) {
                        // Use custom collider otherwise bounding box
                        if (tile.getColliders().length > 0) {
                            // tile with custom collider interrupting the current run
                            for (const collider of tile.getColliders()){
                                const originalOffset = this._getOrSetColliderOriginalOffset(collider);
                                collider.offset = vec(tile.x * this.tileWidth * this.scale.x, tile.y * this.tileHeight * this.scale.y).add(originalOffset);
                                collider.owner = this;
                                this._composite.addCollider(collider);
                            }
                            //we push any current collider before nulling the current run
                            if (current && !checkAndCombine(current, colliders)) colliders.push(current);
                            current = null;
                        // Use the bounding box
                        } else if (!current) // no current run, start one
                        current = tile.defaultGeometry;
                        else // combine with current run
                        current = current.combine(tile.defaultGeometry);
                    } else {
                        // Not solid skip and cut off the current collider
                        // End of run check and combine
                        if (current && !checkAndCombine(current, colliders)) colliders.push(current);
                        current = null;
                    }
                }
                // After a column is complete check to see if it can be merged into the last one
                // Eno of run check and combine
                if (current && !checkAndCombine(current, colliders)) // else new collider if no combination
                colliders.push(current);
                current = null;
            }
            for (const c of colliders){
                const collider = Shape.Box(c.width, c.height, Vector.Zero, vec(c.left - this.pos.x, c.top - this.pos.y));
                collider.owner = this;
                this._composite.addCollider(collider);
            }
            this.collider.update();
            // Notify that colliders have been updated
            this.collider.$colliderAdded.notifyAll(this._composite);
        }
        /**
     * Returns the [[Tile]] by index (row major order)
     */ getTileByIndex(index) {
            return this.tiles[index];
        }
        /**
     * Returns the [[Tile]] by its x and y integer coordinates
     *
     * For example, if I want the tile in fifth column (x), and second row (y):
     * `getTile(4, 1)` 0 based, so 0 is the first in row/column
     */ getTile(x, y) {
            if (x < 0 || y < 0 || x >= this.columns || y >= this.rows) return null;
            return this.tiles[x + y * this.columns];
        }
        /**
     * Returns the [[Tile]] by testing a point in world coordinates,
     * returns `null` if no Tile was found.
     */ getTileByPoint(point) {
            const { x: x, y: y } = this._getTileCoordinates(point);
            const tile = this.getTile(x, y);
            if (x >= 0 && y >= 0 && x < this.columns && y < this.rows && tile) return tile;
            return null;
        }
        _getTileCoordinates(point) {
            // Convert to Tile Space point
            point = this.transform.applyInverse(point);
            const x = Math.floor(point.x / this.tileWidth);
            const y = Math.floor(point.y / this.tileHeight);
            return {
                x: x,
                y: y
            };
        }
        getRows() {
            return this._rows;
        }
        getColumns() {
            return this._cols;
        }
        /**
     * Returns the on screen tiles for a tilemap, this will overshoot by a small amount because of the internal quad tree data structure.
     *
     * Useful if you need to perform specific logic on onscreen tiles
     */ getOnScreenTiles() {
            let worldBounds = this._engine.screen.getWorldBounds();
            const maybeParallax = this.get(ParallaxComponent);
            if (maybeParallax && this.isInitialized) {
                let pos = this.pos;
                const oneMinusFactor = Vector.One.sub(maybeParallax.parallaxFactor);
                const parallaxOffset = this._engine.currentScene.camera.pos.scale(oneMinusFactor);
                pos = pos.sub(parallaxOffset);
                // adjust world bounds by parallax factor
                worldBounds = worldBounds.translate(pos);
            }
            const bounds = this.transform.coordPlane === CoordPlane.Screen ? this._engine.screen.getScreenBounds() : worldBounds;
            const topLeft = this._getTileCoordinates(bounds.topLeft);
            const topRight = this._getTileCoordinates(bounds.topRight);
            const bottomRight = this._getTileCoordinates(bounds.bottomRight);
            const bottomLeft = this._getTileCoordinates(bounds.bottomLeft);
            const tileStartX = Math.min(clamp(topLeft.x, 0, this.columns - 1), clamp(topRight.x, 0, this.columns - 1));
            const tileStartY = Math.min(clamp(topLeft.y, 0, this.rows - 1), clamp(topRight.y, 0, this.rows - 1));
            const tileEndX = Math.max(clamp(bottomRight.x, 0, this.columns - 1), clamp(bottomLeft.x, 0, this.columns - 1));
            const tileEndY = Math.max(clamp(bottomRight.y, 0, this.rows - 1), clamp(bottomLeft.y, 0, this.rows - 1));
            const tiles = [];
            for(let x = tileStartX; x <= tileEndX; x++)for(let y = tileStartY; y <= tileEndY; y++)tiles.push(this.getTile(x, y));
            return tiles;
        }
        update(engine, delta) {
            this._initialize(engine);
            this.onPreUpdate(engine, delta);
            this.emit("preupdate", new PreUpdateEvent(engine, delta, this));
            if (!this._oldPos.equals(this.pos) || this._oldRotation !== this.rotation || !this._oldScale.equals(this.scale)) {
                this.flagCollidersDirty();
                this.flagTilesDirty();
            }
            if (this._collidersDirty) {
                this._collidersDirty = false;
                this._updateColliders();
            }
            this._token++;
            this.pos.clone(this._oldPos);
            this._oldRotation = this.rotation;
            this.scale.clone(this._oldScale);
            this.transform.pos = this.pos;
            this.onPostUpdate(engine, delta);
            this.emit("postupdate", new PostUpdateEvent(engine, delta, this));
        }
        /**
     * Draws the tile map to the screen. Called by the [[Scene]].
     * @param ctx ExcaliburGraphicsContext
     * @param delta  The number of milliseconds since the last draw
     */ draw(ctx, delta) {
            if (!this.isInitialized) return;
            this.emit("predraw", new PreDrawEvent(ctx, delta, this)); // TODO fix event
            let graphics, graphicsIndex, graphicsLen;
            const tiles = this.getOnScreenTiles();
            for(let i = 0; i < tiles.length; i++){
                const tile = tiles[i];
                // get non-negative tile sprites
                const offsets = tile.getGraphicsOffsets();
                graphics = tile.getGraphics();
                for(graphicsIndex = 0, graphicsLen = graphics.length; graphicsIndex < graphicsLen; graphicsIndex++){
                    // draw sprite, warning if sprite doesn't exist
                    const graphic = graphics[graphicsIndex];
                    const offset = offsets[graphicsIndex];
                    if (graphic) {
                        if (hasGraphicsTick(graphic)) graphic === null || graphic === void 0 || graphic.tick(delta, this._token);
                        const offsetY = this.renderFromTopOfGraphic ? 0 : graphic.height - this.tileHeight;
                        graphic.draw(ctx, tile.x * this.tileWidth + offset.x, tile.y * this.tileHeight - offsetY + offset.y);
                    }
                }
            }
            this.emit("postdraw", new PostDrawEvent(ctx, delta, this));
        }
        debug(gfx, debugFlags) {
            const { showAll: showAll, showGrid: showGrid, gridColor: gridColor, gridWidth: gridWidth, showSolidBounds: showColliderBounds, solidBoundsColor: colliderBoundsColor, showColliderGeometry: showColliderGeometry } = debugFlags.tilemap;
            const { geometryColor: geometryColor, geometryLineWidth: geometryLineWidth, geometryPointSize: geometryPointSize } = debugFlags.collider;
            const width = this.tileWidth * this.columns * this.scale.x;
            const height = this.tileHeight * this.rows * this.scale.y;
            const pos = this.pos;
            if (showGrid || showAll) {
                for(let r = 0; r < this.rows + 1; r++){
                    const yOffset = vec(0, r * this.tileHeight * this.scale.y);
                    gfx.drawLine(pos.add(yOffset), pos.add(vec(width, yOffset.y)), gridColor, gridWidth);
                }
                for(let c = 0; c < this.columns + 1; c++){
                    const xOffset = vec(c * this.tileWidth * this.scale.x, 0);
                    gfx.drawLine(pos.add(xOffset), pos.add(vec(xOffset.x, height)), gridColor, gridWidth);
                }
            }
            if (showAll || showColliderBounds || showColliderGeometry) {
                const colliders = this._composite.getColliders();
                gfx.save();
                gfx.translate(this.pos.x, this.pos.y);
                gfx.scale(this.scale.x, this.scale.y);
                for (const collider of colliders){
                    const bounds = collider.localBounds;
                    const pos = collider.worldPos.sub(this.pos);
                    if (showColliderBounds) gfx.drawRectangle(pos, bounds.width, bounds.height, colliderBoundsColor);
                }
                gfx.restore();
                if (showColliderGeometry) for (const collider of colliders)collider.debug(gfx, geometryColor, {
                    lineWidth: geometryLineWidth,
                    pointSize: geometryPointSize
                });
            }
            if (showAll || showColliderBounds) {
                gfx.save();
                gfx.z = 999;
                if (showColliderBounds) for(let i = 0; i < this.tiles.length; i++)this.tiles[i].bounds.draw(gfx);
                gfx.restore();
            }
        }
    }
    /**
 * TileMap Tile
 *
 * A light-weight object that occupies a space in a collision map. Generally
 * created by a [[TileMap]].
 *
 * Tiles can draw multiple sprites. Note that the order of drawing is the order
 * of the sprites in the array so the last one will be drawn on top. You can
 * use transparency to create layers this way.
 */ class Tile {
        /**
     * Return the world position of the top left corner of the tile
     */ get pos() {
            if (this._posDirty) {
                this._recalculate();
                this._posDirty = false;
            }
            return this._pos;
        }
        /**
     * Width of the tile in pixels
     */ get width() {
            return this._width;
        }
        /**
     * Height of the tile in pixels
     */ get height() {
            return this._height;
        }
        /**
     * Wether this tile should be treated as solid by the tilemap
     */ get solid() {
            return this._solid;
        }
        /**
     * Wether this tile should be treated as solid by the tilemap
     */ set solid(val) {
            var _a;
            (_a = this.map) === null || _a === void 0 || _a.flagCollidersDirty();
            this._solid = val;
        }
        /**
     * Current list of graphics for this tile
     */ getGraphics() {
            return this._graphics;
        }
        /**
     * Current list of offsets for this tile's graphics
     */ getGraphicsOffsets() {
            return this._offsets;
        }
        /**
     * Add another [[Graphic]] to this TileMap tile
     * @param graphic
     */ addGraphic(graphic, options) {
            this._graphics.push(graphic);
            if (options === null || options === void 0 ? void 0 : options.offset) this._offsets.push(options.offset);
            else this._offsets.push(Vector.Zero);
        }
        /**
     * Remove an instance of a [[Graphic]] from this tile
     */ removeGraphic(graphic) {
            const index = this._graphics.indexOf(graphic);
            if (index > -1) {
                this._graphics.splice(index, 1);
                this._offsets.splice(index, 1);
            }
        }
        /**
     * Clear all graphics from this tile
     */ clearGraphics() {
            this._graphics.length = 0;
            this._offsets.length = 0;
        }
        /**
     * Returns the list of colliders
     */ getColliders() {
            return this._colliders;
        }
        /**
     * Adds a custom collider to the [[Tile]] to use instead of it's bounds
     *
     * If no collider is set but [[Tile.solid]] is set, the tile bounds are used as a collider.
     *
     * **Note!** the [[Tile.solid]] must be set to true for it to act as a "fixed" collider
     * @param collider
     */ addCollider(collider) {
            this._colliders.push(collider);
            this.map.flagCollidersDirty();
        }
        /**
     * Removes a collider from the [[Tile]]
     * @param collider
     */ removeCollider(collider) {
            const index = this._colliders.indexOf(collider);
            if (index > -1) this._colliders.splice(index, 1);
            this.map.flagCollidersDirty();
        }
        /**
     * Clears all colliders from the [[Tile]]
     */ clearColliders() {
            this._colliders.length = 0;
            this.map.flagCollidersDirty();
        }
        constructor(options){
            var _a, _b;
            this._posDirty = false;
            this.events = new EventEmitter();
            this._solid = false;
            this._graphics = [];
            this._offsets = [];
            /**
         * Current list of colliders for this tile
         */ this._colliders = [];
            /**
         * Arbitrary data storage per tile, useful for any game specific data
         */ this.data = new Map();
            this.x = options.x;
            this.y = options.y;
            this.map = options.map;
            this._width = options.map.tileWidth * this.map.scale.x;
            this._height = options.map.tileHeight * this.map.scale.y;
            this.solid = (_a = options.solid) !== null && _a !== void 0 ? _a : this.solid;
            this._graphics = (_b = options.graphics) !== null && _b !== void 0 ? _b : [];
            this._recalculate();
        }
        flagDirty() {
            return this._posDirty = true;
        }
        _recalculate() {
            const geometryPos = this.map.pos.add(vec(this.x * this.map.tileWidth, this.y * this.map.tileHeight));
            this._geometry = new BoundingBox(geometryPos.x, geometryPos.y, geometryPos.x + this.map.tileWidth, geometryPos.y + this.map.tileHeight);
            this._width = this.map.tileWidth * this.map.scale.x;
            this._height = this.map.tileHeight * this.map.scale.y;
            this._pos = this.map.pos.add(vec(this.x * this._width, this.y * this._height));
            this._bounds = new BoundingBox(this._pos.x, this._pos.y, this._pos.x + this._width, this._pos.y + this._height);
            if (this.map.rotation) this._bounds = this._bounds.rotate(this.map.rotation, this.map.pos);
            this._posDirty = false;
        }
        /**
     * Tile bounds in world space
     */ get bounds() {
            if (this._posDirty) this._recalculate();
            return this._bounds;
        }
        get defaultGeometry() {
            return this._geometry;
        }
        /**
     * Tile position in world space
     */ get center() {
            if (this._posDirty) this._recalculate();
            return new Vector(this._pos.x + this._width / 2, this._pos.y + this._height / 2);
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            if (handler) this.events.off(eventName, handler);
            else this.events.off(eventName);
        }
    }
    /**
 * Container to house convenience strategy methods
 * @internal
 */ class StrategyContainer {
        constructor(camera){
            this.camera = camera;
        }
        /**
     * Creates and adds the [[LockCameraToActorStrategy]] on the current camera.
     * @param actor The actor to lock the camera to
     */ lockToActor(actor) {
            this.camera.addStrategy(new LockCameraToActorStrategy(actor));
        }
        /**
     * Creates and adds the [[LockCameraToActorAxisStrategy]] on the current camera
     * @param actor The actor to lock the camera to
     * @param axis The axis to follow the actor on
     */ lockToActorAxis(actor, axis) {
            this.camera.addStrategy(new LockCameraToActorAxisStrategy(actor, axis));
        }
        /**
     * Creates and adds the [[ElasticToActorStrategy]] on the current camera
     * If cameraElasticity < cameraFriction < 1.0, the behavior will be a dampened spring that will slowly end at the target without bouncing
     * If cameraFriction < cameraElasticity < 1.0, the behavior will be an oscillating spring that will over
     * correct and bounce around the target
     * @param actor Target actor to elastically follow
     * @param cameraElasticity [0 - 1.0] The higher the elasticity the more force that will drive the camera towards the target
     * @param cameraFriction [0 - 1.0] The higher the friction the more that the camera will resist motion towards the target
     */ elasticToActor(actor, cameraElasticity, cameraFriction) {
            this.camera.addStrategy(new ElasticToActorStrategy(actor, cameraElasticity, cameraFriction));
        }
        /**
     * Creates and adds the [[RadiusAroundActorStrategy]] on the current camera
     * @param actor Target actor to follow when it is "radius" pixels away
     * @param radius Number of pixels away before the camera will follow
     */ radiusAroundActor(actor, radius) {
            this.camera.addStrategy(new RadiusAroundActorStrategy(actor, radius));
        }
        /**
     * Creates and adds the [[LimitCameraBoundsStrategy]] on the current camera
     * @param box The bounding box to limit the camera to.
     */ limitCameraBounds(box) {
            this.camera.addStrategy(new LimitCameraBoundsStrategy(box));
        }
    }
    /**
 * Camera axis enum
 */ var Axis;
    (function(Axis) {
        Axis[Axis["X"] = 0] = "X";
        Axis[Axis["Y"] = 1] = "Y";
    })(Axis || (Axis = {}));
    /**
 * Lock a camera to the exact x/y position of an actor.
 */ class LockCameraToActorStrategy {
        constructor(target){
            this.target = target;
            this.action = (target, camera, engine, delta)=>{
                const center = target.center;
                return center;
            };
        }
    }
    /**
 * Lock a camera to a specific axis around an actor.
 */ class LockCameraToActorAxisStrategy {
        constructor(target, axis){
            this.target = target;
            this.axis = axis;
            this.action = (target, cam, _eng, _delta)=>{
                const center = target.center;
                const currentFocus = cam.getFocus();
                if (this.axis === Axis.X) return new Vector(center.x, currentFocus.y);
                else return new Vector(currentFocus.x, center.y);
            };
        }
    }
    /**
 * Using [Hook's law](https://en.wikipedia.org/wiki/Hooke's_law), elastically move the camera towards the target actor.
 */ class ElasticToActorStrategy {
        /**
     * If cameraElasticity < cameraFriction < 1.0, the behavior will be a dampened spring that will slowly end at the target without bouncing
     * If cameraFriction < cameraElasticity < 1.0, the behavior will be an oscillating spring that will over
     * correct and bounce around the target
     * @param target Target actor to elastically follow
     * @param cameraElasticity [0 - 1.0] The higher the elasticity the more force that will drive the camera towards the target
     * @param cameraFriction [0 - 1.0] The higher the friction the more that the camera will resist motion towards the target
     */ constructor(target, cameraElasticity, cameraFriction){
            this.target = target;
            this.cameraElasticity = cameraElasticity;
            this.cameraFriction = cameraFriction;
            this.action = (target, cam, _eng, _delta)=>{
                const position = target.center;
                let focus = cam.getFocus();
                let cameraVel = cam.vel.clone();
                // Calculate the stretch vector, using the spring equation
                // F = kX
                // https://en.wikipedia.org/wiki/Hooke's_law
                // Apply to the current camera velocity
                const stretch = position.sub(focus).scale(this.cameraElasticity); // stretch is X
                cameraVel = cameraVel.add(stretch);
                // Calculate the friction (-1 to apply a force in the opposition of motion)
                // Apply to the current camera velocity
                const friction = cameraVel.scale(-1).scale(this.cameraFriction);
                cameraVel = cameraVel.add(friction);
                // Update position by velocity deltas
                focus = focus.add(cameraVel);
                return focus;
            };
        }
    }
    class RadiusAroundActorStrategy {
        /**
     *
     * @param target Target actor to follow when it is "radius" pixels away
     * @param radius Number of pixels away before the camera will follow
     */ constructor(target, radius){
            this.target = target;
            this.radius = radius;
            this.action = (target, cam, _eng, _delta)=>{
                const position = target.center;
                const focus = cam.getFocus();
                const direction = position.sub(focus);
                const distance = direction.size;
                if (distance >= this.radius) {
                    const offset = distance - this.radius;
                    return focus.add(direction.normalize().scale(offset));
                }
                return focus;
            };
        }
    }
    /**
 * Prevent a camera from going beyond the given camera dimensions.
 */ class LimitCameraBoundsStrategy {
        constructor(target){
            this.target = target;
            /**
         * Useful for limiting the camera to a [[TileMap]]'s dimensions, or a specific area inside the map.
         *
         * Note that this strategy does not perform any movement by itself.
         * It only sets the camera position to within the given bounds when the camera has gone beyond them.
         * Thus, it is a good idea to combine it with other camera strategies and set this strategy as the last one.
         *
         * Make sure that the camera bounds are at least as large as the viewport size.
         * @param target The bounding box to limit the camera to
         */ this.boundSizeChecked = false; // Check and warn only once
            this.action = (target, cam, _eng, _delta)=>{
                const focus = cam.getFocus();
                if (!this.boundSizeChecked) {
                    if (target.bottom - target.top < _eng.drawHeight || target.right - target.left < _eng.drawWidth) Logger.getInstance().warn("Camera bounds should not be smaller than the engine viewport");
                    this.boundSizeChecked = true;
                }
                let focusX = focus.x;
                let focusY = focus.y;
                if (focus.x < target.left + _eng.halfDrawWidth) focusX = target.left + _eng.halfDrawWidth;
                else if (focus.x > target.right - _eng.halfDrawWidth) focusX = target.right - _eng.halfDrawWidth;
                if (focus.y < target.top + _eng.halfDrawHeight) focusY = target.top + _eng.halfDrawHeight;
                else if (focus.y > target.bottom - _eng.halfDrawHeight) focusY = target.bottom - _eng.halfDrawHeight;
                return vec(focusX, focusY);
            };
        }
    }
    const CameraEvents = {
        Initialize: "initialize",
        PreUpdate: "preupdate",
        PostUpdate: "postupdate"
    };
    /**
 * Cameras
 *
 * [[Camera]] is the base class for all Excalibur cameras. Cameras are used
 * to move around your game and set focus. They are used to determine
 * what is "off screen" and can be used to scale the game.
 *
 */ class Camera {
        constructor(){
            this.events = new EventEmitter();
            this.transform = AffineMatrix.identity();
            this.inverse = AffineMatrix.identity();
            this._cameraStrategies = [];
            this.strategy = new StrategyContainer(this);
            /**
         * Get or set current zoom of the camera, defaults to 1
         */ this._z = 1;
            /**
         * Get or set rate of change in zoom, defaults to 0
         */ this.dz = 0;
            /**
         * Get or set zoom acceleration
         */ this.az = 0;
            /**
         * Current rotation of the camera
         */ this.rotation = 0;
            this._angularVelocity = 0;
            /**
         * Get or set the camera's position
         */ this._posChanged = false;
            this._pos = watchAny(Vector.Zero, ()=>this._posChanged = true);
            /**
         * Interpolated camera position if more draws are running than updates
         *
         * Enabled when `Engine.fixedUpdateFps` is enabled, in all other cases this will be the same as pos
         */ this.drawPos = this.pos.clone();
            this._oldPos = this.pos.clone();
            /**
         * Get or set the camera's velocity
         */ this.vel = Vector.Zero;
            /**
         * Get or set the camera's acceleration
         */ this.acc = Vector.Zero;
            this._cameraMoving = false;
            this._currentLerpTime = 0;
            this._lerpDuration = 1000; // 1 second
            this._lerpStart = null;
            this._lerpEnd = null;
            //camera effects
            this._isShaking = false;
            this._shakeMagnitudeX = 0;
            this._shakeMagnitudeY = 0;
            this._shakeDuration = 0;
            this._elapsedShakeTime = 0;
            this._xShake = 0;
            this._yShake = 0;
            this._isZooming = false;
            this._zoomStart = 1;
            this._zoomEnd = 1;
            this._currentZoomTime = 0;
            this._zoomDuration = 0;
            this._zoomEasing = EasingFunctions.EaseInOutCubic;
            this._easing = EasingFunctions.EaseInOutCubic;
            this._halfWidth = 0;
            this._halfHeight = 0;
            this._viewport = null;
            this._isInitialized = false;
            this._snapPos = vec(0, 0);
        }
        get zoom() {
            return this._z;
        }
        set zoom(val) {
            this._z = val;
            if (this._engine) {
                this._halfWidth = this._engine.halfDrawWidth;
                this._halfHeight = this._engine.halfDrawHeight;
            }
        }
        /**
     * Get or set the camera's angular velocity
     */ get angularVelocity() {
            return this._angularVelocity;
        }
        set angularVelocity(value) {
            this._angularVelocity = value;
        }
        get pos() {
            return this._pos;
        }
        set pos(vec) {
            this._pos = watchAny(vec, ()=>this._posChanged = true);
            this._posChanged = true;
        }
        /**
     * Get the camera's x position
     */ get x() {
            return this.pos.x;
        }
        /**
     * Set the camera's x position (cannot be set when following an [[Actor]] or when moving)
     */ set x(value) {
            if (!this._follow && !this._cameraMoving) this.pos = vec(value, this.pos.y);
        }
        /**
     * Get the camera's y position
     */ get y() {
            return this.pos.y;
        }
        /**
     * Set the camera's y position (cannot be set when following an [[Actor]] or when moving)
     */ set y(value) {
            if (!this._follow && !this._cameraMoving) this.pos = vec(this.pos.x, value);
        }
        /**
     * Get or set the camera's x velocity
     */ get dx() {
            return this.vel.x;
        }
        set dx(value) {
            this.vel = vec(value, this.vel.y);
        }
        /**
     * Get or set the camera's y velocity
     */ get dy() {
            return this.vel.y;
        }
        set dy(value) {
            this.vel = vec(this.vel.x, value);
        }
        /**
     * Get or set the camera's x acceleration
     */ get ax() {
            return this.acc.x;
        }
        set ax(value) {
            this.acc = vec(value, this.acc.y);
        }
        /**
     * Get or set the camera's y acceleration
     */ get ay() {
            return this.acc.y;
        }
        set ay(value) {
            this.acc = vec(this.acc.x, value);
        }
        /**
     * Returns the focal point of the camera, a new point giving the x and y position of the camera
     */ getFocus() {
            return this.pos;
        }
        /**
     * This moves the camera focal point to the specified position using specified easing function. Cannot move when following an Actor.
     * @param pos The target position to move to
     * @param duration The duration in milliseconds the move should last
     * @param [easingFn] An optional easing function ([[ex.EasingFunctions.EaseInOutCubic]] by default)
     * @returns A [[Promise]] that resolves when movement is finished, including if it's interrupted.
     *          The [[Promise]] value is the [[Vector]] of the target position. It will be rejected if a move cannot be made.
     */ move(pos, duration, easingFn = EasingFunctions.EaseInOutCubic) {
            if (typeof easingFn !== "function") throw "Please specify an EasingFunction";
            // cannot move when following an actor
            if (this._follow) return Promise.reject(pos);
            // resolve existing promise, if any
            if (this._lerpPromise && this._lerpResolve) this._lerpResolve(pos);
            this._lerpPromise = new Promise((resolve)=>{
                this._lerpResolve = resolve;
            });
            this._lerpStart = this.getFocus().clone();
            this._lerpDuration = duration;
            this._lerpEnd = pos;
            this._currentLerpTime = 0;
            this._cameraMoving = true;
            this._easing = easingFn;
            return this._lerpPromise;
        }
        /**
     * Sets the camera to shake at the specified magnitudes for the specified duration
     * @param magnitudeX  The x magnitude of the shake
     * @param magnitudeY  The y magnitude of the shake
     * @param duration    The duration of the shake in milliseconds
     */ shake(magnitudeX, magnitudeY, duration) {
            this._isShaking = true;
            this._shakeMagnitudeX = magnitudeX;
            this._shakeMagnitudeY = magnitudeY;
            this._shakeDuration = duration;
        }
        /**
     * Zooms the camera in or out by the specified scale over the specified duration.
     * If no duration is specified, it take effect immediately.
     * @param scale    The scale of the zoom
     * @param duration The duration of the zoom in milliseconds
     */ zoomOverTime(scale, duration = 0, easingFn = EasingFunctions.EaseInOutCubic) {
            this._zoomPromise = new Promise((resolve)=>{
                this._zoomResolve = resolve;
            });
            if (duration) {
                this._isZooming = true;
                this._zoomEasing = easingFn;
                this._currentZoomTime = 0;
                this._zoomDuration = duration;
                this._zoomStart = this.zoom;
                this._zoomEnd = scale;
            } else {
                this._isZooming = false;
                this.zoom = scale;
                return Promise.resolve(true);
            }
            return this._zoomPromise;
        }
        /**
     * Gets the bounding box of the viewport of this camera in world coordinates
     */ get viewport() {
            if (this._viewport) return this._viewport;
            return new BoundingBox(0, 0, 0, 0);
        }
        /**
     * Adds a new camera strategy to this camera
     * @param cameraStrategy Instance of an [[CameraStrategy]]
     */ addStrategy(cameraStrategy) {
            this._cameraStrategies.push(cameraStrategy);
        }
        /**
     * Removes a camera strategy by reference
     * @param cameraStrategy Instance of an [[CameraStrategy]]
     */ removeStrategy(cameraStrategy) {
            removeItemFromArray(cameraStrategy, this._cameraStrategies);
        }
        /**
     * Clears all camera strategies from the camera
     */ clearAllStrategies() {
            this._cameraStrategies.length = 0;
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPreUpdate]] lifecycle event
     * @internal
     */ _preupdate(engine, delta) {
            this.events.emit("preupdate", new PreUpdateEvent(engine, delta, this));
            this.onPreUpdate(engine, delta);
        }
        /**
     * Safe to override onPreUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPreUpdate` is called directly before a scene is updated.
     */ onPreUpdate(engine, delta) {
        // Overridable
        }
        /**
     *  It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPostUpdate]] lifecycle event
     * @internal
     */ _postupdate(engine, delta) {
            this.events.emit("postupdate", new PostUpdateEvent(engine, delta, this));
            this.onPostUpdate(engine, delta);
        }
        /**
     * Safe to override onPostUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPostUpdate` is called directly after a scene is updated.
     */ onPostUpdate(engine, delta) {
        // Overridable
        }
        get isInitialized() {
            return this._isInitialized;
        }
        _initialize(engine) {
            if (!this.isInitialized) {
                this._engine = engine;
                this._screen = engine.screen;
                const currentRes = this._screen.contentArea;
                let center = vec(currentRes.width / 2, currentRes.height / 2);
                if (!this._engine.loadingComplete) {
                    // If there was a loading screen, we peek the configured resolution
                    const res = this._screen.peekResolution();
                    if (res) center = vec(res.width / 2, res.height / 2);
                }
                this._halfWidth = center.x;
                this._halfHeight = center.y;
                // If the user has not set the camera pos, apply default center screen position
                if (!this._posChanged) this.pos = center;
                this.pos.clone(this.drawPos);
                // First frame bootstrap
                // Ensure camera tx is correct
                // Run update twice to ensure properties are init'd
                this.updateTransform(this.pos);
                // Run strategies for first frame
                this.runStrategies(engine, engine.clock.elapsed());
                // Setup the first frame viewport
                this.updateViewport();
                // It's important to update the camera after strategies
                // This prevents jitter
                this.updateTransform(this.pos);
                this.pos.clone(this._oldPos);
                this.onInitialize(engine);
                this.events.emit("initialize", new InitializeEvent(engine, this));
                this._isInitialized = true;
            }
        }
        /**
     * Safe to override onPostUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPostUpdate` is called directly after a scene is updated.
     */ onInitialize(engine) {
        // Overridable
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        runStrategies(engine, delta) {
            for (const s of this._cameraStrategies)this.pos = s.action.call(s, s.target, this, engine, delta);
        }
        updateViewport() {
            // recalculate viewport
            this._viewport = new BoundingBox(this.x - this._halfWidth, this.y - this._halfHeight, this.x + this._halfWidth, this.y + this._halfHeight);
        }
        update(engine, delta) {
            this._initialize(engine);
            this._preupdate(engine, delta);
            this.pos.clone(this._oldPos);
            // Update placements based on linear algebra
            this.pos = this.pos.add(this.vel.scale(delta / 1000));
            this.zoom += this.dz * delta / 1000;
            this.vel = this.vel.add(this.acc.scale(delta / 1000));
            this.dz += this.az * delta / 1000;
            this.rotation += this.angularVelocity * delta / 1000;
            if (this._isZooming) {
                if (this._currentZoomTime < this._zoomDuration) {
                    const zoomEasing = this._zoomEasing;
                    const newZoom = zoomEasing(this._currentZoomTime, this._zoomStart, this._zoomEnd, this._zoomDuration);
                    this.zoom = newZoom;
                    this._currentZoomTime += delta;
                } else {
                    this._isZooming = false;
                    this.zoom = this._zoomEnd;
                    this._currentZoomTime = 0;
                    this._zoomResolve(true);
                }
            }
            if (this._cameraMoving) {
                if (this._currentLerpTime < this._lerpDuration) {
                    const moveEasing = EasingFunctions.CreateVectorEasingFunction(this._easing);
                    const lerpPoint = moveEasing(this._currentLerpTime, this._lerpStart, this._lerpEnd, this._lerpDuration);
                    this.pos = lerpPoint;
                    this._currentLerpTime += delta;
                } else {
                    this.pos = this._lerpEnd;
                    const end = this._lerpEnd.clone();
                    this._lerpStart = null;
                    this._lerpEnd = null;
                    this._currentLerpTime = 0;
                    this._cameraMoving = false;
                    // Order matters here, resolve should be last so any chain promises have a clean slate
                    this._lerpResolve(end);
                }
            }
            if (this._isDoneShaking()) {
                this._isShaking = false;
                this._elapsedShakeTime = 0;
                this._shakeMagnitudeX = 0;
                this._shakeMagnitudeY = 0;
                this._shakeDuration = 0;
                this._xShake = 0;
                this._yShake = 0;
            } else {
                this._elapsedShakeTime += delta;
                this._xShake = (Math.random() * this._shakeMagnitudeX | 0) + 1;
                this._yShake = (Math.random() * this._shakeMagnitudeY | 0) + 1;
            }
            this.runStrategies(engine, delta);
            this.updateViewport();
            // It's important to update the camera after strategies
            // This prevents jitter
            this.updateTransform(this.pos);
            this._postupdate(engine, delta);
        }
        /**
     * Applies the relevant transformations to the game canvas to "move" or apply effects to the Camera
     * @param ctx Canvas context to apply transformations
     */ draw(ctx) {
            // default to the current position
            this.pos.clone(this.drawPos);
            // interpolation if fixed update is on
            // must happen on the draw, because more draws are potentially happening than updates
            if (this._engine.fixedUpdateFps) {
                const blend = this._engine.currentFrameLagMs / (1000 / this._engine.fixedUpdateFps);
                const interpolatedPos = this.pos.scale(blend).add(this._oldPos.scale(1.0 - blend));
                interpolatedPos.clone(this.drawPos);
                this.updateTransform(interpolatedPos);
            }
            // Snap camera to pixel
            if (ctx.snapToPixel) {
                const snapPos = this.drawPos.clone(this._snapPos);
                snapPos.x = ~~(snapPos.x + pixelSnapEpsilon * sign(snapPos.x));
                snapPos.y = ~~(snapPos.y + pixelSnapEpsilon * sign(snapPos.y));
                snapPos.clone(this.drawPos);
                this.updateTransform(snapPos);
            }
            ctx.multiply(this.transform);
        }
        updateTransform(pos) {
            // center the camera
            const newCanvasWidth = this._screen.resolution.width / this.zoom;
            const newCanvasHeight = this._screen.resolution.height / this.zoom;
            const cameraPos = vec(-pos.x + newCanvasWidth / 2 + this._xShake, -pos.y + newCanvasHeight / 2 + this._yShake);
            // Calculate camera transform
            this.transform.reset();
            this.transform.scale(this.zoom, this.zoom);
            // rotate about the focus
            this.transform.translate(newCanvasWidth / 2, newCanvasHeight / 2);
            this.transform.rotate(this.rotation);
            this.transform.translate(-newCanvasWidth / 2, -newCanvasHeight / 2);
            this.transform.translate(cameraPos.x, cameraPos.y);
            this.transform.inverse(this.inverse);
        }
        _isDoneShaking() {
            return !this._isShaking || this._elapsedShakeTime >= this._shakeDuration;
        }
    }
    const TriggerEvents = {
        ExitTrigger: "exit",
        EnterTrigger: "enter"
    };
    const triggerDefaults = {
        pos: Vector.Zero,
        width: 10,
        height: 10,
        visible: false,
        action: ()=>{
            return;
        },
        filter: ()=>true,
        repeat: -1
    };
    /**
 * Triggers are a method of firing arbitrary code on collision. These are useful
 * as 'buttons', 'switches', or to trigger effects in a game. By default triggers
 * are invisible, and can only be seen when [[Trigger.visible]] is set to `true`.
 */ class Trigger extends Actor {
        /**
     *
     * @param opts Trigger options
     */ constructor(opts){
            super({
                x: opts.pos.x,
                y: opts.pos.y,
                width: opts.width,
                height: opts.height
            });
            this.events = new EventEmitter();
            /**
         * Action to fire when triggered by collision
         */ this.action = ()=>{
                return;
            };
            /**
         * Filter to add additional granularity to action dispatch, if a filter is specified the action will only fire when
         * filter return true for the collided actor.
         */ this.filter = ()=>true;
            /**
         * Number of times to repeat before killing the trigger,
         */ this.repeat = -1;
            opts = {
                ...triggerDefaults,
                ...opts
            };
            this.filter = opts.filter || this.filter;
            this.repeat = opts.repeat || this.repeat;
            this.action = opts.action || this.action;
            if (opts.target) this.target = opts.target;
            this.graphics.visible = opts.visible;
            this.body.collisionType = CollisionType.Passive;
            this.events.on("collisionstart", (evt)=>{
                if (this.filter(evt.other)) {
                    this.events.emit("enter", new EnterTriggerEvent(this, evt.other));
                    this._dispatchAction();
                    // remove trigger if its done, -1 repeat forever
                    if (this.repeat === 0) this.kill();
                }
            });
            this.events.on("collisionend", (evt)=>{
                if (this.filter(evt.other)) this.events.emit("exit", new ExitTriggerEvent(this, evt.other));
            });
        }
        set target(target) {
            this._target = target;
            this.filter = (actor)=>actor === target;
        }
        get target() {
            return this._target;
        }
        _initialize(engine) {
            super._initialize(engine);
        }
        _dispatchAction() {
            if (this.repeat !== 0) {
                this.action.call(this);
                this.repeat--;
            }
        }
    }
    /**
 * Higher priorities run earlier than others in the system update
 */ const SystemPriority = {
        Highest: -Infinity,
        Higher: -5,
        Average: 0,
        Lower: 5,
        Lowest: Infinity
    };
    /**
 * Enum that determines whether to run the system in the update or draw phase
 */ var SystemType;
    (function(SystemType) {
        SystemType["Update"] = "update";
        SystemType["Draw"] = "draw";
    })(SystemType || (SystemType = {}));
    /**
 * An Excalibur [[System]] that updates entities of certain types.
 * Systems are scene specific
 *
 *
 *
 * Excalibur Systems currently require at least 1 Component type to operated
 *
 * Multiple types are declared as a type union
 * For example:
 *
 * ```typescript
 * class MySystem extends System<ComponentA | ComponentB> {
 *   public readonly types = ['a', 'b'] as const;
 *   public readonly systemType = SystemType.Update;
 *   public update(entities: Entity<ComponentA | ComponentB>) {
 *      ...
 *   }
 * }
 * ```
 */ class System {
        constructor(){
            /**
         * System can execute in priority order, by default all systems are priority 0. Lower values indicated higher priority.
         * For a system to execute before all other a lower priority value (-1 for example) must be set.
         * For a system to execute after all other a higher priority value (10 for example) must be set.
         */ this.priority = SystemPriority.Average;
        }
    }
    // Add/Remove entities and components
    class EntityManager {
        constructor(_world){
            this._world = _world;
            this.entities = [];
            this._entityIndex = {};
            this._entitiesToRemove = [];
        }
        /**
     * Runs the entity lifecycle
     * @param scene
     * @param elapsed
     */ updateEntities(scene, elapsed) {
            for (const entity of this.entities){
                entity.update(scene.engine, elapsed);
                if (!entity.active) this.removeEntity(entity);
            }
        }
        findEntitiesForRemoval() {
            for (const entity of this.entities)if (!entity.active) this.removeEntity(entity);
        }
        /**
     * Adds an entity to be tracked by the EntityManager
     * @param entity
     */ addEntity(entity) {
            entity.active = true;
            entity.scene = this._world.scene;
            if (entity && !this._entityIndex[entity.id]) {
                this._entityIndex[entity.id] = entity;
                this.entities.push(entity);
                this._world.queryManager.addEntity(entity);
                // if entity has children
                entity.children.forEach((c)=>{
                    c.scene = entity.scene;
                    this.addEntity(c);
                });
                entity.childrenAdded$.register({
                    notify: (e)=>{
                        this.addEntity(e);
                    }
                });
                entity.childrenRemoved$.register({
                    notify: (e)=>{
                        this.removeEntity(e, false);
                    }
                });
            }
        }
        removeEntity(idOrEntity, deferred = true) {
            var _a, _b;
            let id = 0;
            if (idOrEntity instanceof Entity) id = idOrEntity.id;
            else id = idOrEntity;
            const entity = this._entityIndex[id];
            if (entity && entity.active) entity.active = false;
            if (entity && deferred) {
                this._entitiesToRemove.push(entity);
                return;
            }
            delete this._entityIndex[id];
            if (entity) {
                entity.scene = null;
                removeItemFromArray(entity, this.entities);
                this._world.queryManager.removeEntity(entity);
                // if entity has children
                entity.children.forEach((c)=>{
                    c.scene = null;
                    this.removeEntity(c, deferred);
                });
                entity.childrenAdded$.clear();
                entity.childrenRemoved$.clear();
                // stats
                if ((_b = (_a = this._world) === null || _a === void 0 ? void 0 : _a.scene) === null || _b === void 0 ? void 0 : _b.engine) this._world.scene.engine.stats.currFrame.actors.killed++;
            }
        }
        processEntityRemovals() {
            for (const entity of this._entitiesToRemove){
                if (entity.active) continue;
                this.removeEntity(entity, false);
            }
            this._entitiesToRemove.length = 0;
        }
        processComponentRemovals() {
            for (const entity of this.entities)entity.processComponentRemoval();
        }
        getById(id) {
            return this._entityIndex[id];
        }
        getByName(name) {
            return this.entities.filter((e)=>e.name === name);
        }
        clear() {
            for(let i = this.entities.length - 1; i >= 0; i--)this.removeEntity(this.entities[i]);
        }
    }
    /**
 * Represents query for entities that match a list of types that is cached and observable
 *
 * Queries can be strongly typed by supplying a type union in the optional type parameter
 * ```typescript
 * const queryAB = new ex.Query<ComponentTypeA | ComponentTypeB>(['A', 'B']);
 * ```
 */ class Query {
        constructor(requiredComponents){
            this.requiredComponents = requiredComponents;
            this.components = new Set();
            this.entities = [];
            /**
         * This fires right after the component is added
         */ this.entityAdded$ = new Observable();
            /**
         * This fires right before the component is actually removed from the entity, it will still be available for cleanup purposes
         */ this.entityRemoved$ = new Observable();
            if (requiredComponents.length === 0) throw new Error("Cannot create query without components");
            for (const type of requiredComponents)this.components.add(type);
            this.id = Query.createId(requiredComponents);
        }
        static createId(requiredComponents) {
            // TODO what happens if a user defines the same type name as a built in type
            // ! TODO this could be dangerous depending on the bundler's settings for names
            // Maybe some kind of hash function is better here?
            return requiredComponents.slice().map((c)=>c.name).sort().join("-");
        }
        /**
     * Potentially adds an entity to a query index, returns true if added, false if not
     * @param entity
     */ checkAndAdd(entity) {
            if (!this.entities.includes(entity) && entity.hasAll(Array.from(this.components))) {
                this.entities.push(entity);
                this.entityAdded$.notifyAll(entity);
                return true;
            }
            return false;
        }
        removeEntity(entity) {
            const index = this.entities.indexOf(entity);
            if (index > -1) {
                this.entities.splice(index, 1);
                this.entityRemoved$.notifyAll(entity);
            }
        }
        /**
     * Returns a list of entities that match the query
     * @param sort Optional sorting function to sort entities returned from the query
     */ getEntities(sort) {
            if (sort) this.entities.sort(sort);
            return this.entities;
        }
    }
    class TagQuery {
        constructor(requiredTags){
            this.requiredTags = requiredTags;
            this.tags = new Set();
            this.entities = [];
            /**
         * This fires right after the component is added
         */ this.entityAdded$ = new Observable();
            /**
         * This fires right before the component is actually removed from the entity, it will still be available for cleanup purposes
         */ this.entityRemoved$ = new Observable();
            if (requiredTags.length === 0) throw new Error("Cannot create tag query without tags");
            for (const tag of requiredTags)this.tags.add(tag);
            this.id = TagQuery.createId(requiredTags);
        }
        static createId(requiredComponents) {
            return requiredComponents.slice().sort().join("-");
        }
        checkAndAdd(entity) {
            if (!this.entities.includes(entity) && entity.hasAllTags(Array.from(this.tags))) {
                this.entities.push(entity);
                this.entityAdded$.notifyAll(entity);
                return true;
            }
            return false;
        }
        removeEntity(entity) {
            const index = this.entities.indexOf(entity);
            if (index > -1) {
                this.entities.splice(index, 1);
                this.entityRemoved$.notifyAll(entity);
            }
        }
        /**
     * Returns a list of entities that match the query
     * @param sort Optional sorting function to sort entities returned from the query
     */ getEntities(sort) {
            if (sort) this.entities.sort(sort);
            return this.entities;
        }
    }
    /**
 * The query manager is responsible for updating all queries when entities/components change
 */ class QueryManager {
        constructor(_world){
            this._world = _world;
            this._queries = new Map();
            this._addComponentHandlers = new Map();
            this._removeComponentHandlers = new Map();
            this._componentToQueriesIndex = new Map();
            this._tagQueries = new Map();
            this._addTagHandlers = new Map();
            this._removeTagHandlers = new Map();
            this._tagToQueriesIndex = new Map();
            this._createAddComponentHandler = (entity)=>(c)=>{
                    this.addComponent(entity, c);
                };
            this._createRemoveComponentHandler = (entity)=>(c)=>{
                    this.removeComponent(entity, c);
                };
            this._createAddTagHandler = (entity)=>(tag)=>{
                    this.addTag(entity, tag);
                };
            this._createRemoveTagHandler = (entity)=>(tag)=>{
                    this.removeTag(entity, tag);
                };
        }
        createQuery(requiredComponents) {
            const id = Query.createId(requiredComponents);
            if (this._queries.has(id)) // short circuit if query is already created
            return this._queries.get(id);
            const query = new Query(requiredComponents);
            this._queries.set(query.id, query);
            // index maintenance
            for (const component of requiredComponents){
                const queries = this._componentToQueriesIndex.get(component);
                if (!queries) this._componentToQueriesIndex.set(component, [
                    query
                ]);
                else queries.push(query);
            }
            for (const entity of this._world.entities)this.addEntity(entity);
            return query;
        }
        createTagQuery(requiredTags) {
            const id = TagQuery.createId(requiredTags);
            if (this._tagQueries.has(id)) // short circuit if query is already created
            return this._tagQueries.get(id);
            const query = new TagQuery(requiredTags);
            this._tagQueries.set(query.id, query);
            // index maintenance
            for (const tag of requiredTags){
                const queries = this._tagToQueriesIndex.get(tag);
                if (!queries) this._tagToQueriesIndex.set(tag, [
                    query
                ]);
                else queries.push(query);
            }
            for (const entity of this._world.entities)this.addEntity(entity);
            return query;
        }
        /**
     * Scans queries and locates any that need this entity added
     * @param entity
     */ addEntity(entity) {
            const maybeAddComponent = this._addComponentHandlers.get(entity);
            const maybeRemoveComponent = this._removeComponentHandlers.get(entity);
            const addComponent = maybeAddComponent !== null && maybeAddComponent !== void 0 ? maybeAddComponent : this._createAddComponentHandler(entity);
            const removeComponent = maybeRemoveComponent !== null && maybeRemoveComponent !== void 0 ? maybeRemoveComponent : this._createRemoveComponentHandler(entity);
            this._addComponentHandlers.set(entity, addComponent);
            this._removeComponentHandlers.set(entity, removeComponent);
            const maybeAddTag = this._addTagHandlers.get(entity);
            const maybeRemoveTag = this._removeTagHandlers.get(entity);
            const addTag = maybeAddTag !== null && maybeAddTag !== void 0 ? maybeAddTag : this._createAddTagHandler(entity);
            const removeTag = maybeRemoveTag !== null && maybeRemoveTag !== void 0 ? maybeRemoveTag : this._createRemoveTagHandler(entity);
            this._addTagHandlers.set(entity, addTag);
            this._removeTagHandlers.set(entity, removeTag);
            for (const query of this._queries.values())query.checkAndAdd(entity);
            for (const tagQuery of this._tagQueries.values())tagQuery.checkAndAdd(entity);
            entity.componentAdded$.subscribe(addComponent);
            entity.componentRemoved$.subscribe(removeComponent);
            entity.tagAdded$.subscribe(addTag);
            entity.tagRemoved$.subscribe(removeTag);
        }
        /**
     * Scans queries and locates any that need this entity removed
     * @param entity
     */ removeEntity(entity) {
            // Handle components
            const addComponent = this._addComponentHandlers.get(entity);
            const removeComponent = this._removeComponentHandlers.get(entity);
            for (const query of this._queries.values())query.removeEntity(entity);
            if (addComponent) entity.componentAdded$.unsubscribe(addComponent);
            if (removeComponent) entity.componentRemoved$.unsubscribe(removeComponent);
            // Handle tags
            const addTag = this._addTagHandlers.get(entity);
            const removeTag = this._removeTagHandlers.get(entity);
            for (const tagQuery of this._tagQueries.values())tagQuery.removeEntity(entity);
            if (addTag) entity.tagAdded$.unsubscribe(addTag);
            if (removeTag) entity.tagRemoved$.unsubscribe(removeTag);
        }
        /**
     * Updates any queries when a component is added to an entity
     * @param entity
     * @param component
     */ addComponent(entity, component) {
            var _a;
            const queries = (_a = this._componentToQueriesIndex.get(component.constructor)) !== null && _a !== void 0 ? _a : [];
            for (const query of queries)query.checkAndAdd(entity);
        }
        /**
     * Updates any queries when a component is removed from an entity
     * @param entity
     * @param component
     */ removeComponent(entity, component) {
            var _a;
            const queries = (_a = this._componentToQueriesIndex.get(component.constructor)) !== null && _a !== void 0 ? _a : [];
            for (const query of queries)query.removeEntity(entity);
        }
        /**
     * Updates any queries when a tag is added to an entity
     * @param entity
     * @param tag
     */ addTag(entity, tag) {
            var _a;
            const queries = (_a = this._tagToQueriesIndex.get(tag)) !== null && _a !== void 0 ? _a : [];
            for (const query of queries)query.checkAndAdd(entity);
        }
        /**
     * Updates any queries when a component is removed from an entity
     * @param entity
     * @param tag
     */ removeTag(entity, tag) {
            var _a;
            const queries = (_a = this._tagToQueriesIndex.get(tag)) !== null && _a !== void 0 ? _a : [];
            for (const query of queries)query.removeEntity(entity);
        }
    }
    /**
 *
 */ function isSystemConstructor(x) {
        var _a, _b;
        return !!(x === null || x === void 0 ? void 0 : x.prototype) && !!((_b = (_a = x === null || x === void 0 ? void 0 : x.prototype) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name);
    }
    /**
 * The SystemManager is responsible for keeping track of all systems in a scene.
 * Systems are scene specific
 */ class SystemManager {
        constructor(_world){
            this._world = _world;
            /**
         * List of systems, to add a new system call [[SystemManager.addSystem]]
         */ this.systems = [];
            this.initialized = false;
        }
        /**
     * Get a system registered in the manager by type
     * @param systemType
     */ get(systemType) {
            return this.systems.find((s)=>s instanceof systemType);
        }
        /**
     * Adds a system to the manager, it will now be updated every frame
     * @param systemOrCtor
     */ addSystem(systemOrCtor) {
            let system;
            if (systemOrCtor instanceof System) system = systemOrCtor;
            else system = new systemOrCtor(this._world);
            this.systems.push(system);
            this.systems.sort((a, b)=>a.priority - b.priority);
            // If systems are added and the manager has already been init'd
            // then immediately init the system
            if (this.initialized && system.initialize) system.initialize(this._world, this._world.scene);
        }
        /**
     * Removes a system from the manager, it will no longer be updated
     * @param system
     */ removeSystem(system) {
            removeItemFromArray(system, this.systems);
        }
        /**
     * Initialize all systems in the manager
     *
     * Systems added after initialize() will be initialized on add
     */ initialize() {
            if (!this.initialized) {
                this.initialized = true;
                for (const s of this.systems)if (s.initialize) s.initialize(this._world, this._world.scene);
            }
        }
        /**
     * Updates all systems
     * @param type whether this is an update or draw system
     * @param scene context reference
     * @param delta time in milliseconds
     */ updateSystems(type, scene, delta) {
            const systems = this.systems.filter((s)=>s.systemType === type);
            for (const s of systems)if (s.preupdate) s.preupdate(scene, delta);
            for (const s of systems)s.update(delta);
            for (const s of systems)if (s.postupdate) s.postupdate(scene, delta);
        }
        clear() {
            for(let i = this.systems.length - 1; i >= 0; i--)this.removeSystem(this.systems[i]);
        }
    }
    /**
 * The World is a self-contained entity component system for a particular context.
 */ class World {
        /**
     * The context type is passed to the system updates
     * @param scene
     */ constructor(scene){
            this.scene = scene;
            this.queryManager = new QueryManager(this);
            this.entityManager = new EntityManager(this);
            this.systemManager = new SystemManager(this);
        }
        /**
     * Query the ECS world for entities that match your components
     * @param requiredTypes
     */ query(requiredTypes) {
            return this.queryManager.createQuery(requiredTypes);
        }
        queryTags(requiredTags) {
            return this.queryManager.createTagQuery(requiredTags);
        }
        /**
     * Update systems by type and time elapsed in milliseconds
     */ update(type, delta) {
            if (type === SystemType.Update) this.entityManager.updateEntities(this.scene, delta);
            this.systemManager.updateSystems(type, this.scene, delta);
            this.entityManager.findEntitiesForRemoval();
            this.entityManager.processComponentRemovals();
            this.entityManager.processEntityRemovals();
        }
        add(entityOrSystem) {
            if (entityOrSystem instanceof Entity) this.entityManager.addEntity(entityOrSystem);
            if (entityOrSystem instanceof System || isSystemConstructor(entityOrSystem)) this.systemManager.addSystem(entityOrSystem);
        }
        /**
     * Get a system out of the ECS world
     */ get(system) {
            return this.systemManager.get(system);
        }
        remove(entityOrSystem, deferred = true) {
            if (entityOrSystem instanceof Entity) this.entityManager.removeEntity(entityOrSystem, deferred);
            if (entityOrSystem instanceof System) this.systemManager.removeSystem(entityOrSystem);
        }
        get entities() {
            return this.entityManager.entities;
        }
        clearEntities() {
            this.entityManager.clear();
        }
        clearSystems() {
            this.systemManager.clear();
        }
    }
    class EulerIntegrator {
        static integrate(transform, motion, totalAcc, elapsedMs) {
            const seconds = elapsedMs / 1000;
            // This code looks a little wild, but it's to avoid creating any new Vector instances
            // integration is done in a tight loop so this is key to avoid GC'ing
            motion.vel.addEqual(totalAcc.scale(seconds, EulerIntegrator._ACC));
            transform.pos.add(motion.vel.scale(seconds, EulerIntegrator._VEL), EulerIntegrator._POS).addEqual(totalAcc.scale(0.5 * seconds * seconds, EulerIntegrator._VEL_ACC));
            motion.angularVelocity += motion.torque * (1.0 / motion.inertia) * seconds;
            const rotation = transform.rotation + motion.angularVelocity * seconds;
            transform.scale.add(motion.scaleFactor.scale(seconds, this._SCALE_FACTOR), EulerIntegrator._SCALE);
            const tx = transform.get();
            tx.setTransform(EulerIntegrator._POS, rotation, EulerIntegrator._SCALE);
        }
    }
    // Scratch vectors to avoid allocation
    EulerIntegrator._POS = new Vector(0, 0);
    EulerIntegrator._SCALE = new Vector(1, 1);
    EulerIntegrator._ACC = new Vector(0, 0);
    EulerIntegrator._VEL = new Vector(0, 0);
    EulerIntegrator._VEL_ACC = new Vector(0, 0);
    EulerIntegrator._SCALE_FACTOR = new Vector(0, 0);
    class MotionSystem extends System {
        constructor(world, physics){
            super();
            this.world = world;
            this.physics = physics;
            this.systemType = SystemType.Update;
            this.priority = SystemPriority.Higher;
            this._physicsConfigDirty = false;
            physics.$configUpdate.subscribe(()=>this._physicsConfigDirty = true);
            this.query = this.world.query([
                TransformComponent,
                MotionComponent
            ]);
        }
        update(elapsedMs) {
            let transform;
            let motion;
            const entities = this.query.entities;
            for(let i = 0; i < entities.length; i++){
                transform = entities[i].get(TransformComponent);
                motion = entities[i].get(MotionComponent);
                const optionalBody = entities[i].get(BodyComponent);
                if (this._physicsConfigDirty && optionalBody) optionalBody.updatePhysicsConfig(this.physics.config.bodies);
                if (optionalBody === null || optionalBody === void 0 ? void 0 : optionalBody.sleeping) continue;
                const totalAcc = motion.acc.clone();
                if ((optionalBody === null || optionalBody === void 0 ? void 0 : optionalBody.collisionType) === CollisionType.Active && (optionalBody === null || optionalBody === void 0 ? void 0 : optionalBody.useGravity)) totalAcc.addEqual(this.physics.config.gravity);
                optionalBody === null || optionalBody === void 0 || optionalBody.captureOldTransform();
                // Update transform and motion based on Euler linear algebra
                EulerIntegrator.integrate(transform, motion, totalAcc, elapsedMs);
            }
            this._physicsConfigDirty = false;
        }
    }
    /**
 * ArcadeSolver is the default in Excalibur. It solves collisions so that there is no overlap between contacts,
 * and negates velocity along the collision normal.
 *
 * This is usually the type of collisions used for 2D games that don't need a more realistic collision simulation.
 *
 */ class ArcadeSolver {
        constructor(config){
            this.config = config;
            this.directionMap = new Map();
            this.distanceMap = new Map();
        }
        solve(contacts) {
            // Events and init
            this.preSolve(contacts);
            // Remove any canceled contacts
            contacts = contacts.filter((c)=>!c.isCanceled());
            // Locate collision bias order
            let bias;
            switch(this.config.contactSolveBias){
                case ContactSolveBias.HorizontalFirst:
                    bias = HorizontalFirst;
                    break;
                case ContactSolveBias.VerticalFirst:
                    bias = VerticalFirst;
                    break;
                default:
                    bias = None;
            }
            // Sort by bias (None, VerticalFirst, HorizontalFirst) to avoid artifacts with seams
            // Sort contacts by distance to avoid artifacts with seams
            // It's important to solve in a specific order
            contacts.sort((a, b)=>{
                const aDir = this.directionMap.get(a.id);
                const bDir = this.directionMap.get(b.id);
                const aDist = this.distanceMap.get(a.id);
                const bDist = this.distanceMap.get(b.id);
                return bias[aDir] - bias[bDir] || aDist - bDist;
            });
            for (const contact of contacts){
                // Solve position first in arcade
                this.solvePosition(contact);
                // Solve velocity second in arcade
                this.solveVelocity(contact);
            }
            // Events and any contact house-keeping the solver needs
            this.postSolve(contacts);
            return contacts;
        }
        preSolve(contacts) {
            const epsilon = .0001;
            for (const contact of contacts){
                if (Math.abs(contact.mtv.x) < epsilon && Math.abs(contact.mtv.y) < epsilon) {
                    // Cancel near 0 mtv collisions
                    contact.cancel();
                    continue;
                }
                const side = Side.fromDirection(contact.mtv);
                const mtv = contact.mtv.negate();
                const distance = contact.colliderA.worldPos.squareDistance(contact.colliderB.worldPos);
                this.distanceMap.set(contact.id, distance);
                this.directionMap.set(contact.id, side === Side.Left || side === Side.Right ? "horizontal" : "vertical");
                // Publish collision events on both participants
                contact.colliderA.events.emit("precollision", new PreCollisionEvent(contact.colliderA, contact.colliderB, side, mtv, contact));
                contact.colliderB.events.emit("precollision", new PreCollisionEvent(contact.colliderB, contact.colliderA, Side.getOpposite(side), mtv.negate(), contact));
            }
        }
        postSolve(contacts) {
            var _a, _b;
            for (const contact of contacts){
                if (contact.isCanceled()) continue;
                const colliderA = contact.colliderA;
                const colliderB = contact.colliderB;
                const bodyA = (_a = colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
                const bodyB = (_b = colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
                if (bodyA && bodyB) {
                    if (bodyA.collisionType === CollisionType.Passive || bodyB.collisionType === CollisionType.Passive) continue;
                }
                const side = Side.fromDirection(contact.mtv);
                const mtv = contact.mtv.negate();
                // Publish collision events on both participants
                contact.colliderA.events.emit("postcollision", new PostCollisionEvent(contact.colliderA, contact.colliderB, side, mtv, contact));
                contact.colliderB.events.emit("postcollision", new PostCollisionEvent(contact.colliderB, contact.colliderA, Side.getOpposite(side), mtv.negate(), contact));
            }
        }
        solvePosition(contact) {
            var _a, _b;
            const epsilon = .0001;
            // if bounds no longer intersect skip to the next
            // this removes jitter from overlapping/stacked solid tiles or a wall of solid tiles
            if (!contact.colliderA.bounds.overlaps(contact.colliderB.bounds, epsilon)) {
                // Cancel the contact to prevent and solving
                contact.cancel();
                return;
            }
            if (Math.abs(contact.mtv.x) < epsilon && Math.abs(contact.mtv.y) < epsilon) {
                // Cancel near 0 mtv collisions
                contact.cancel();
                return;
            }
            let mtv = contact.mtv;
            const colliderA = contact.colliderA;
            const colliderB = contact.colliderB;
            const bodyA = (_a = colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
            const bodyB = (_b = colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
            if (bodyA && bodyB) {
                if (bodyA.collisionType === CollisionType.Passive || bodyB.collisionType === CollisionType.Passive) return;
                if (bodyA.collisionType === CollisionType.Active && bodyB.collisionType === CollisionType.Active) // split overlaps if both are Active
                mtv = mtv.scale(0.5);
                // Resolve overlaps
                if (bodyA.collisionType === CollisionType.Active) {
                    bodyA.globalPos.x -= mtv.x;
                    bodyA.globalPos.y -= mtv.y;
                    colliderA.update(bodyA.transform.get());
                }
                if (bodyB.collisionType === CollisionType.Active) {
                    bodyB.globalPos.x += mtv.x;
                    bodyB.globalPos.y += mtv.y;
                    colliderB.update(bodyB.transform.get());
                }
            }
        }
        solveVelocity(contact) {
            var _a, _b;
            if (contact.isCanceled()) return;
            const colliderA = contact.colliderA;
            const colliderB = contact.colliderB;
            const bodyA = (_a = colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
            const bodyB = (_b = colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
            if (bodyA && bodyB) {
                if (bodyA.collisionType === CollisionType.Passive || bodyB.collisionType === CollisionType.Passive) return;
                const normal = contact.normal;
                const opposite = normal.negate();
                if (bodyA.collisionType === CollisionType.Active) // only adjust velocity if the contact normal is opposite to the current velocity
                // this avoids catching edges on a platform when sliding off
                {
                    if (bodyA.vel.normalize().dot(opposite) < 0) {
                        // Cancel out velocity opposite direction of collision normal
                        const velAdj = normal.scale(normal.dot(bodyA.vel.negate()));
                        bodyA.vel = bodyA.vel.add(velAdj);
                    }
                }
                if (bodyB.collisionType === CollisionType.Active) // only adjust velocity if the contact normal is opposite to the current velocity
                // this avoids catching edges on a platform
                {
                    if (bodyB.vel.normalize().dot(normal) < 0) {
                        const velAdj = opposite.scale(opposite.dot(bodyB.vel.negate()));
                        bodyB.vel = bodyB.vel.add(velAdj);
                    }
                }
            }
        }
    }
    /**
 * Holds information about contact points, meant to be reused over multiple frames of contact
 */ class ContactConstraintPoint {
        constructor(point, local, contact){
            this.point = point;
            this.local = local;
            this.contact = contact;
            /**
         * Impulse accumulated over time in normal direction
         */ this.normalImpulse = 0;
            /**
         * Impulse accumulated over time in the tangent direction
         */ this.tangentImpulse = 0;
            /**
         * Effective mass seen in the normal direction
         */ this.normalMass = 0;
            /**
         * Effective mass seen in the tangent direction
         */ this.tangentMass = 0;
            /**
         * Direction from center of mass of bodyA to contact point
         */ this.aToContact = new Vector(0, 0);
            /**
         * Direction from center of mass of bodyB to contact point
         */ this.bToContact = new Vector(0, 0);
            /**
         * Original contact velocity combined with bounciness
         */ this.originalVelocityAndRestitution = 0;
            this.update();
        }
        /**
     * Updates the contact information
     */ update() {
            var _a, _b;
            const bodyA = (_a = this.contact.colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
            const bodyB = (_b = this.contact.colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
            if (bodyA && bodyB) {
                const normal = this.contact.normal;
                const tangent = this.contact.tangent;
                this.aToContact = this.point.sub(bodyA.globalPos);
                this.bToContact = this.point.sub(bodyB.globalPos);
                const aToContactNormal = this.aToContact.cross(normal);
                const bToContactNormal = this.bToContact.cross(normal);
                this.normalMass = bodyA.inverseMass + bodyB.inverseMass + bodyA.inverseInertia * aToContactNormal * aToContactNormal + bodyB.inverseInertia * bToContactNormal * bToContactNormal;
                const aToContactTangent = this.aToContact.cross(tangent);
                const bToContactTangent = this.bToContact.cross(tangent);
                this.tangentMass = bodyA.inverseMass + bodyB.inverseMass + bodyA.inverseInertia * aToContactTangent * aToContactTangent + bodyB.inverseInertia * bToContactTangent * bToContactTangent;
            }
            return this;
        }
        /**
     * Returns the relative velocity between bodyA and bodyB
     */ getRelativeVelocity() {
            var _a, _b;
            const bodyA = (_a = this.contact.colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
            const bodyB = (_b = this.contact.colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
            if (bodyA && bodyB) {
                // Relative velocity in linear terms
                // Angular to linear velocity formula -> omega = velocity/radius so omega x radius = velocity
                const velA = bodyA.vel.add(Vector.cross(bodyA.angularVelocity, this.aToContact));
                const velB = bodyB.vel.add(Vector.cross(bodyB.angularVelocity, this.bToContact));
                return velB.sub(velA);
            }
            return Vector.Zero;
        }
    }
    class RealisticSolver {
        constructor(config){
            this.config = config;
            this.lastFrameContacts = new Map();
            // map contact id to contact points
            this.idToContactConstraint = new Map();
        }
        getContactConstraints(id) {
            var _a;
            return (_a = this.idToContactConstraint.get(id)) !== null && _a !== void 0 ? _a : [];
        }
        solve(contacts) {
            // Events and init
            this.preSolve(contacts);
            // Remove any canceled contacts
            contacts = contacts.filter((c)=>!c.isCanceled());
            // Solve velocity first
            this.solveVelocity(contacts);
            // Solve position last because non-overlap is the most important
            this.solvePosition(contacts);
            // Events and any contact house-keeping the solver needs
            this.postSolve(contacts);
            return contacts;
        }
        preSolve(contacts) {
            var _a, _b, _c;
            const epsilon = .0001;
            for (const contact of contacts){
                if (Math.abs(contact.mtv.x) < epsilon && Math.abs(contact.mtv.y) < epsilon) {
                    // Cancel near 0 mtv collisions
                    contact.cancel();
                    continue;
                }
                // Publish collision events on both participants
                const side = Side.fromDirection(contact.mtv);
                contact.colliderA.events.emit("precollision", new PreCollisionEvent(contact.colliderA, contact.colliderB, side, contact.mtv, contact));
                contact.colliderA.events.emit("beforecollisionresolve", new CollisionPreSolveEvent(contact.colliderA, contact.colliderB, side, contact.mtv, contact));
                contact.colliderB.events.emit("precollision", new PreCollisionEvent(contact.colliderB, contact.colliderA, Side.getOpposite(side), contact.mtv.negate(), contact));
                contact.colliderB.events.emit("beforecollisionresolve", new CollisionPreSolveEvent(contact.colliderB, contact.colliderA, Side.getOpposite(side), contact.mtv.negate(), contact));
                // Match awake state for sleeping
                contact.matchAwake();
            }
            // Keep track of contacts that done
            const finishedContactIds = Array.from(this.idToContactConstraint.keys());
            for (const contact of contacts){
                // Remove all current contacts that are not done
                const index = finishedContactIds.indexOf(contact.id);
                if (index > -1) finishedContactIds.splice(index, 1);
                const contactPoints = (_a = this.idToContactConstraint.get(contact.id)) !== null && _a !== void 0 ? _a : [];
                let pointIndex = 0;
                const bodyA = contact.colliderA.owner.get(BodyComponent);
                const bodyB = contact.colliderB.owner.get(BodyComponent);
                if (bodyA && bodyB) for (const point of contact.points){
                    const normal = contact.normal;
                    const tangent = contact.tangent;
                    const aToContact = point.sub(bodyA.globalPos);
                    const bToContact = point.sub(bodyB.globalPos);
                    const aToContactNormal = aToContact.cross(normal);
                    const bToContactNormal = bToContact.cross(normal);
                    const normalMass = bodyA.inverseMass + bodyB.inverseMass + bodyA.inverseInertia * aToContactNormal * aToContactNormal + bodyB.inverseInertia * bToContactNormal * bToContactNormal;
                    const aToContactTangent = aToContact.cross(tangent);
                    const bToContactTangent = bToContact.cross(tangent);
                    const tangentMass = bodyA.inverseMass + bodyB.inverseMass + bodyA.inverseInertia * aToContactTangent * aToContactTangent + bodyB.inverseInertia * bToContactTangent * bToContactTangent;
                    // Preserve normal/tangent impulse by re-using the contact point if it's close
                    if (contactPoints[pointIndex] && ((_c = (_b = contactPoints[pointIndex]) === null || _b === void 0 ? void 0 : _b.point) === null || _c === void 0 ? void 0 : _c.squareDistance(point)) < 4) {
                        contactPoints[pointIndex].point = point;
                        contactPoints[pointIndex].local = contact.localPoints[pointIndex];
                    } else // new contact if it's not close or doesn't exist
                    contactPoints[pointIndex] = new ContactConstraintPoint(point, contact.localPoints[pointIndex], contact);
                    // Update contact point calculations
                    contactPoints[pointIndex].aToContact = aToContact;
                    contactPoints[pointIndex].bToContact = bToContact;
                    contactPoints[pointIndex].normalMass = 1.0 / normalMass;
                    contactPoints[pointIndex].tangentMass = 1.0 / tangentMass;
                    // Calculate relative velocity before solving to accurately do restitution
                    const restitution = bodyA.bounciness > bodyB.bounciness ? bodyA.bounciness : bodyB.bounciness;
                    const relativeVelocity = contact.normal.dot(contactPoints[pointIndex].getRelativeVelocity());
                    contactPoints[pointIndex].originalVelocityAndRestitution = 0;
                    if (relativeVelocity < -0.1) contactPoints[pointIndex].originalVelocityAndRestitution = -restitution * relativeVelocity;
                    pointIndex++;
                }
                this.idToContactConstraint.set(contact.id, contactPoints);
            }
            // Clean up any contacts that did not occur last frame
            for (const id of finishedContactIds)this.idToContactConstraint.delete(id);
            // Warm contacts with accumulated impulse
            // Useful for tall stacks
            if (this.config.warmStart) this.warmStart(contacts);
            else for (const contact of contacts){
                const contactPoints = this.getContactConstraints(contact.id);
                for (const point of contactPoints){
                    point.normalImpulse = 0;
                    point.tangentImpulse = 0;
                }
            }
        }
        postSolve(contacts) {
            for (const contact of contacts){
                const bodyA = contact.colliderA.owner.get(BodyComponent);
                const bodyB = contact.colliderB.owner.get(BodyComponent);
                if (bodyA && bodyB) {
                    // Skip post solve for active+passive collisions
                    if (bodyA.collisionType === CollisionType.Passive || bodyB.collisionType === CollisionType.Passive) continue;
                    // Update motion values for sleeping
                    bodyA.updateMotion();
                    bodyB.updateMotion();
                }
                // Publish collision events on both participants
                const side = Side.fromDirection(contact.mtv);
                contact.colliderA.events.emit("postcollision", new PostCollisionEvent(contact.colliderA, contact.colliderB, side, contact.mtv, contact));
                contact.colliderA.events.emit("aftercollisionresolve", new CollisionPostSolveEvent(contact.colliderA, contact.colliderB, side, contact.mtv, contact));
                contact.colliderB.events.emit("postcollision", new PostCollisionEvent(contact.colliderB, contact.colliderA, Side.getOpposite(side), contact.mtv.negate(), contact));
                contact.colliderB.events.emit("aftercollisionresolve", new CollisionPostSolveEvent(contact.colliderB, contact.colliderA, Side.getOpposite(side), contact.mtv.negate(), contact));
            }
            // Store contacts
            this.lastFrameContacts.clear();
            for (const c of contacts)this.lastFrameContacts.set(c.id, c);
        }
        /**
     * Warm up body's based on previous frame contact points
     * @param contacts
     */ warmStart(contacts) {
            var _a, _b, _c;
            for (const contact of contacts){
                const bodyA = (_a = contact.colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
                const bodyB = (_b = contact.colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
                if (bodyA && bodyB) {
                    const contactPoints = (_c = this.idToContactConstraint.get(contact.id)) !== null && _c !== void 0 ? _c : [];
                    for (const point of contactPoints)if (this.config.warmStart) {
                        const normalImpulse = contact.normal.scale(point.normalImpulse);
                        const tangentImpulse = contact.tangent.scale(point.tangentImpulse);
                        const impulse = normalImpulse.add(tangentImpulse);
                        bodyA.applyImpulse(point.point, impulse.negate());
                        bodyB.applyImpulse(point.point, impulse);
                    } else {
                        point.normalImpulse = 0;
                        point.tangentImpulse = 0;
                    }
                }
            }
        }
        /**
     * Iteratively solve the position overlap constraint
     * @param contacts
     */ solvePosition(contacts) {
            var _a, _b, _c;
            for(let i = 0; i < this.config.positionIterations; i++)for (const contact of contacts){
                const bodyA = (_a = contact.colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
                const bodyB = (_b = contact.colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
                if (bodyA && bodyB) {
                    // Skip solving active+passive
                    if (bodyA.collisionType === CollisionType.Passive || bodyB.collisionType === CollisionType.Passive) continue;
                    const constraints = (_c = this.idToContactConstraint.get(contact.id)) !== null && _c !== void 0 ? _c : [];
                    for (const point of constraints){
                        const normal = contact.normal;
                        const separation = CollisionJumpTable.FindContactSeparation(contact, point.local);
                        const steeringConstant = this.config.steeringFactor; //0.2;
                        const maxCorrection = -5;
                        const slop = this.config.slop; //1;
                        // Clamp to avoid over-correction
                        // Remember that we are shooting for 0 overlap in the end
                        const steeringForce = clamp(steeringConstant * (separation + slop), maxCorrection, 0);
                        const impulse = normal.scale(-steeringForce * point.normalMass);
                        // This is a pseudo impulse, meaning we aren't doing a real impulse calculation
                        // We adjust position and rotation instead of doing the velocity
                        if (bodyA.collisionType === CollisionType.Active) {
                            // TODO make applyPseudoImpulse function?
                            const impulseForce = impulse.negate().scale(bodyA.inverseMass);
                            if (bodyA.limitDegreeOfFreedom.includes(DegreeOfFreedom.X)) impulseForce.x = 0;
                            if (bodyA.limitDegreeOfFreedom.includes(DegreeOfFreedom.Y)) impulseForce.y = 0;
                            bodyA.globalPos = bodyA.globalPos.add(impulseForce);
                            if (!bodyA.limitDegreeOfFreedom.includes(DegreeOfFreedom.Rotation)) bodyA.rotation -= point.aToContact.cross(impulse) * bodyA.inverseInertia;
                        }
                        if (bodyB.collisionType === CollisionType.Active) {
                            const impulseForce = impulse.scale(bodyB.inverseMass);
                            if (bodyB.limitDegreeOfFreedom.includes(DegreeOfFreedom.X)) impulseForce.x = 0;
                            if (bodyB.limitDegreeOfFreedom.includes(DegreeOfFreedom.Y)) impulseForce.y = 0;
                            bodyB.globalPos = bodyB.globalPos.add(impulseForce);
                            if (!bodyB.limitDegreeOfFreedom.includes(DegreeOfFreedom.Rotation)) bodyB.rotation += point.bToContact.cross(impulse) * bodyB.inverseInertia;
                        }
                    }
                }
            }
        }
        solveVelocity(contacts) {
            var _a, _b, _c;
            for(let i = 0; i < this.config.velocityIterations; i++)for (const contact of contacts){
                const bodyA = (_a = contact.colliderA.owner) === null || _a === void 0 ? void 0 : _a.get(BodyComponent);
                const bodyB = (_b = contact.colliderB.owner) === null || _b === void 0 ? void 0 : _b.get(BodyComponent);
                if (bodyA && bodyB) {
                    // Skip solving active+passive
                    if (bodyA.collisionType === CollisionType.Passive || bodyB.collisionType === CollisionType.Passive) continue;
                    const friction = Math.min(bodyA.friction, bodyB.friction);
                    const constraints = (_c = this.idToContactConstraint.get(contact.id)) !== null && _c !== void 0 ? _c : [];
                    // Friction constraint
                    for (const point of constraints){
                        const relativeVelocity = point.getRelativeVelocity();
                        // Negate velocity in tangent direction to simulate friction
                        const tangentVelocity = -relativeVelocity.dot(contact.tangent);
                        let impulseDelta = tangentVelocity * point.tangentMass;
                        // Clamping based in Erin Catto's GDC 2006 talk
                        // Correct clamping https://github.com/erincatto/box2d-lite/blob/master/docs/GDC2006_Catto_Erin_PhysicsTutorial.pdf
                        // Accumulated fiction impulse is always between -uMaxFriction < dT < uMaxFriction
                        // But deltas can vary
                        const maxFriction = friction * point.normalImpulse;
                        const newImpulse = clamp(point.tangentImpulse + impulseDelta, -maxFriction, maxFriction);
                        impulseDelta = newImpulse - point.tangentImpulse;
                        point.tangentImpulse = newImpulse;
                        const impulse = contact.tangent.scale(impulseDelta);
                        bodyA.applyImpulse(point.point, impulse.negate());
                        bodyB.applyImpulse(point.point, impulse);
                    }
                    // Bounce constraint
                    for (const point of constraints){
                        // Need to recalc relative velocity because the previous step could have changed vel
                        const relativeVelocity = point.getRelativeVelocity();
                        // Compute impulse in normal direction
                        const normalVelocity = relativeVelocity.dot(contact.normal);
                        // Per Erin it is a mistake to apply the restitution inside the iteration
                        // From Erin Catto's Box2D we keep original contact velocity and adjust by small impulses
                        let impulseDelta = -point.normalMass * (normalVelocity - point.originalVelocityAndRestitution);
                        // Clamping based in Erin Catto's GDC 2014 talk
                        // Accumulated impulse stored in the contact is always positive (dV > 0)
                        // But deltas can be negative
                        const newImpulse = Math.max(point.normalImpulse + impulseDelta, 0);
                        impulseDelta = newImpulse - point.normalImpulse;
                        point.normalImpulse = newImpulse;
                        const impulse = contact.normal.scale(impulseDelta);
                        bodyA.applyImpulse(point.point, impulse.negate());
                        bodyB.applyImpulse(point.point, impulse);
                    }
                }
            }
        }
    }
    class CollisionSystem extends System {
        get _processor() {
            return this._physics.collisionProcessor;
        }
        constructor(world, _physics){
            super();
            this._physics = _physics;
            this.systemType = SystemType.Update;
            this.priority = SystemPriority.Higher;
            this._configDirty = false;
            this._lastFrameContacts = new Map();
            this._currentFrameContacts = new Map();
            this._arcadeSolver = new ArcadeSolver(_physics.config.arcade);
            this._realisticSolver = new RealisticSolver(_physics.config.realistic);
            this._physics.$configUpdate.subscribe(()=>this._configDirty = true);
            this._trackCollider = (c)=>this._processor.track(c);
            this._untrackCollider = (c)=>this._processor.untrack(c);
            this.query = world.query([
                TransformComponent,
                MotionComponent,
                ColliderComponent
            ]);
            this.query.entityAdded$.subscribe((e)=>{
                const colliderComponent = e.get(ColliderComponent);
                colliderComponent.$colliderAdded.subscribe(this._trackCollider);
                colliderComponent.$colliderRemoved.subscribe(this._untrackCollider);
                const collider = colliderComponent.get();
                if (collider) this._processor.track(collider);
            });
            this.query.entityRemoved$.subscribe((e)=>{
                const colliderComponent = e.get(ColliderComponent);
                const collider = colliderComponent.get();
                if (colliderComponent && collider) this._processor.untrack(collider);
            });
        }
        initialize(world, scene) {
            this._engine = scene.engine;
        }
        update(elapsedMs) {
            var _a, _b, _c, _d;
            if (!this._physics.config.enabled) return;
            // Collect up all the colliders and update them
            let colliders = [];
            for (const entity of this.query.entities){
                const colliderComp = entity.get(ColliderComponent);
                const collider = colliderComp === null || colliderComp === void 0 ? void 0 : colliderComp.get();
                if (colliderComp && ((_a = colliderComp.owner) === null || _a === void 0 ? void 0 : _a.active) && collider) {
                    colliderComp.update();
                    if (collider instanceof CompositeCollider) {
                        const compositeColliders = collider.getColliders();
                        if (!collider.compositeStrategy) collider.compositeStrategy = this._physics.config.colliders.compositeStrategy;
                        colliders = colliders.concat(compositeColliders);
                    } else colliders.push(collider);
                }
            }
            // Update the spatial partitioning data structures
            // TODO if collider invalid it will break the processor
            // TODO rename "update" to something more specific
            this._processor.update(colliders);
            // Run broadphase on all colliders and locates potential collisions
            const pairs = this._processor.broadphase(colliders, elapsedMs);
            this._currentFrameContacts.clear();
            // Given possible pairs find actual contacts
            let contacts = this._processor.narrowphase(pairs, (_d = (_c = (_b = this._engine) === null || _b === void 0 ? void 0 : _b.debug) === null || _c === void 0 ? void 0 : _c.stats) === null || _d === void 0 ? void 0 : _d.currFrame);
            const solver = this.getSolver();
            // Solve, this resolves the position/velocity so entities aren't overlapping
            contacts = solver.solve(contacts);
            // Record contacts for start/end
            for (const contact of contacts){
                if (contact.isCanceled()) continue;
                // Process composite ids, things with the same composite id are treated as the same collider for start/end
                const index = contact.id.indexOf("|");
                if (index > 0) {
                    const compositeId = contact.id.substring(index + 1);
                    this._currentFrameContacts.set(compositeId, contact);
                } else this._currentFrameContacts.set(contact.id, contact);
            }
            // Emit contact start/end events
            this.runContactStartEnd();
            // reset the last frame cache
            this._lastFrameContacts.clear();
            // Keep track of collisions contacts that have started or ended
            this._lastFrameContacts = new Map(this._currentFrameContacts);
            // Process deferred collider removals
            for (const entity of this.query.entities){
                const collider = entity.get(ColliderComponent);
                if (collider) collider.processColliderRemoval();
            }
        }
        getSolver() {
            if (this._configDirty) {
                this._configDirty = false;
                this._arcadeSolver = new ArcadeSolver(this._physics.config.arcade);
                this._realisticSolver = new RealisticSolver(this._physics.config.realistic);
            }
            return this._physics.config.solver === SolverStrategy.Realistic ? this._realisticSolver : this._arcadeSolver;
        }
        debug(ex) {
            this._processor.debug(ex);
        }
        runContactStartEnd() {
            // If composite colliders are 'together' collisions may have a duplicate id because we want to treat those as a singular start/end
            for (const [id, c] of this._currentFrameContacts)// find all new contacts
            if (!this._lastFrameContacts.has(id)) {
                const colliderA = c.colliderA;
                const colliderB = c.colliderB;
                const side = Side.fromDirection(c.mtv);
                const opposite = Side.getOpposite(side);
                colliderA.events.emit("collisionstart", new CollisionStartEvent(colliderA, colliderB, side, c));
                colliderA.events.emit("contactstart", new ContactStartEvent(colliderA, colliderB, side, c));
                colliderB.events.emit("collisionstart", new CollisionStartEvent(colliderB, colliderA, opposite, c));
                colliderB.events.emit("contactstart", new ContactStartEvent(colliderB, colliderA, opposite, c));
            }
            // find all contacts that have ceased
            for (const [id, c] of this._lastFrameContacts)if (!this._currentFrameContacts.has(id)) {
                const colliderA = c.colliderA;
                const colliderB = c.colliderB;
                const side = Side.fromDirection(c.mtv);
                const opposite = Side.getOpposite(side);
                colliderA.events.emit("collisionend", new CollisionEndEvent(colliderA, colliderB, side, c));
                colliderA.events.emit("contactend", new ContactEndEvent(colliderA, colliderB, side, c));
                colliderB.events.emit("collisionend", new CollisionEndEvent(colliderB, colliderA, opposite, c));
                colliderB.events.emit("contactend", new ContactEndEvent(colliderB, colliderA, opposite, c));
            }
        }
    }
    /**
 * Configurable helper extends base type and makes all properties available as option bag arguments
 * @internal
 * @param base
 */ function Configurable(base) {
        return class extends base {
            assign(props) {
                //set the value of every property that was passed in,
                //if the constructor previously set this value, it will be overridden here
                for(const k in props)// eslint-disable-next-line
                if (typeof this[k] !== "function") // eslint-disable-next-line
                this[k] = props[k];
            }
            constructor(...args){
                super(...args);
                //get the number of arguments that aren't undefined. TS passes a value to all parameters
                //of whatever ctor is the implementation, so args.length doesn't work here.
                const size = args.filter(function(value) {
                    return value !== undefined;
                }).length;
                if (size === 1 && args[0] && typeof args[0] === "object" && !(args[0] instanceof Array)) this.assign(args[0]);
            }
        };
    }
    /**
 * An enum that represents the types of emitter nozzles
 */ var EmitterType;
    (function(EmitterType) {
        /**
     * Constant for the circular emitter type
     */ EmitterType[EmitterType["Circle"] = 0] = "Circle";
        /**
     * Constant for the rectangular emitter type
     */ EmitterType[EmitterType["Rectangle"] = 1] = "Rectangle";
    })(EmitterType || (EmitterType = {}));
    /**
 * @hidden
 */ class ParticleImpl extends Entity {
        constructor(emitterOrConfig, life, opacity, beginColor, endColor, position, velocity, acceleration, startSize, endSize, particleSprite){
            super();
            this.position = new Vector(0, 0);
            this.velocity = new Vector(0, 0);
            this.acceleration = new Vector(0, 0);
            this.particleRotationalVelocity = 0;
            this.currentRotation = 0;
            this.focus = null;
            this.focusAccel = 0;
            this.opacity = 1;
            this.beginColor = Color.White;
            this.endColor = Color.White;
            // Life is counted in ms
            this.life = 300;
            this.fadeFlag = false;
            // Color transitions
            this._rRate = 1;
            this._gRate = 1;
            this._bRate = 1;
            this._aRate = 0;
            this._currentColor = Color.White;
            this.emitter = null;
            this.particleSize = 5;
            this.particleSprite = null;
            this.sizeRate = 0;
            this.elapsedMultiplier = 0;
            this.visible = true;
            this.isOffscreen = false;
            let emitter = emitterOrConfig;
            if (emitter && !(emitterOrConfig instanceof ParticleEmitter)) {
                const config = emitterOrConfig;
                emitter = config.emitter;
                life = config.life;
                opacity = config.opacity;
                endColor = config.endColor;
                beginColor = config.beginColor;
                position = config.position;
                velocity = config.velocity;
                acceleration = config.acceleration;
                startSize = config.startSize;
                endSize = config.endSize;
                particleSprite = config.particleSprite;
            }
            this.emitter = emitter;
            this.life = life || this.life;
            this.opacity = opacity || this.opacity;
            this.endColor = endColor || this.endColor.clone();
            this.beginColor = beginColor || this.beginColor.clone();
            this._currentColor = this.beginColor.clone();
            this.particleSprite = particleSprite;
            if (this.emitter.particleTransform === ParticleTransform.Global) {
                const globalPos = this.emitter.transform.globalPos;
                this.position = (position || this.position).add(globalPos);
                this.velocity = (velocity || this.velocity).rotate(this.emitter.transform.globalRotation);
            } else {
                this.velocity = velocity || this.velocity;
                this.position = position || this.position;
            }
            this.acceleration = acceleration || this.acceleration;
            this._rRate = (this.endColor.r - this.beginColor.r) / this.life;
            this._gRate = (this.endColor.g - this.beginColor.g) / this.life;
            this._bRate = (this.endColor.b - this.beginColor.b) / this.life;
            this._aRate = this.opacity / this.life;
            this.startSize = startSize || 0;
            this.endSize = endSize || 0;
            if (this.endSize > 0 && this.startSize > 0) {
                this.sizeRate = (this.endSize - this.startSize) / this.life;
                this.particleSize = this.startSize;
            }
            this.addComponent(this.transform = new TransformComponent());
            this.addComponent(this.graphics = new GraphicsComponent());
            this.transform.pos = this.position;
            this.transform.rotation = this.currentRotation;
            this.transform.scale = vec(1, 1); // TODO wut
            this.transform.z = this.emitter.z;
            if (this.particleSprite) {
                this.graphics.opacity = this.opacity;
                this.graphics.use(this.particleSprite);
            } else {
                this.graphics.localBounds = BoundingBox.fromDimension(this.particleSize, this.particleSize, Vector.Half);
                this.graphics.onPostDraw = (ctx)=>{
                    ctx.save();
                    this.graphics.opacity = this.opacity;
                    const tmpColor = this._currentColor.clone();
                    tmpColor.a = 1;
                    ctx.debug.drawPoint(vec(0, 0), {
                        color: tmpColor,
                        size: this.particleSize
                    });
                    ctx.restore();
                };
            }
        }
        kill() {
            this.emitter.removeParticle(this);
        }
        update(engine, delta) {
            this.life = this.life - delta;
            this.elapsedMultiplier = this.elapsedMultiplier + delta;
            if (this.life < 0) this.kill();
            if (this.fadeFlag) this.opacity = clamp(this._aRate * this.life, 0.0001, 1);
            if (this.startSize > 0 && this.endSize > 0) this.particleSize = clamp(this.sizeRate * delta + this.particleSize, Math.min(this.startSize, this.endSize), Math.max(this.startSize, this.endSize));
            this._currentColor.r = clamp(this._currentColor.r + this._rRate * delta, 0, 255);
            this._currentColor.g = clamp(this._currentColor.g + this._gRate * delta, 0, 255);
            this._currentColor.b = clamp(this._currentColor.b + this._bRate * delta, 0, 255);
            this._currentColor.a = clamp(this.opacity, 0.0001, 1);
            if (this.focus) {
                const accel = this.focus.sub(this.position).normalize().scale(this.focusAccel).scale(delta / 1000);
                this.velocity = this.velocity.add(accel);
            } else this.velocity = this.velocity.add(this.acceleration.scale(delta / 1000));
            this.position = this.position.add(this.velocity.scale(delta / 1000));
            if (this.particleRotationalVelocity) this.currentRotation = (this.currentRotation + this.particleRotationalVelocity * delta / 1000) % (2 * Math.PI);
            this.transform.pos = this.position;
            this.transform.rotation = this.currentRotation;
            this.transform.scale = vec(1, 1); // todo wut
            this.graphics.opacity = this.opacity;
        }
    }
    /**
 * Particle is used in a [[ParticleEmitter]]
 */ class Particle extends Configurable(ParticleImpl) {
        constructor(emitterOrConfig, life, opacity, beginColor, endColor, position, velocity, acceleration, startSize, endSize, particleSprite){
            super(emitterOrConfig, life, opacity, beginColor, endColor, position, velocity, acceleration, startSize, endSize, particleSprite);
        }
    }
    var ParticleTransform;
    (function(ParticleTransform) {
        /**
     * [[ParticleTransform.Global]] is the default and emits particles as if
     * they were world space objects, useful for most effects.
     */ ParticleTransform["Global"] = "global";
        /**
     * [[ParticleTransform.Local]] particles are children of the emitter and move relative to the emitter
     * as they would in a parent/child actor relationship.
     */ ParticleTransform["Local"] = "local";
    })(ParticleTransform || (ParticleTransform = {}));
    /**
 * Using a particle emitter is a great way to create interesting effects
 * in your game, like smoke, fire, water, explosions, etc. `ParticleEmitter`
 * extend [[Actor]] allowing you to use all of the features that come with.
 */ class ParticleEmitter extends Actor {
        /**
     * Gets the opacity of each particle from 0 to 1.0
     */ get opacity() {
            return this.graphics.opacity;
        }
        /**
     * Gets the opacity of each particle from 0 to 1.0
     */ set opacity(opacity) {
            this.graphics.opacity = opacity;
        }
        /**
     * Gets or sets the sprite that a particle should use
     */ get particleSprite() {
            return this._sprite;
        }
        set particleSprite(val) {
            if (val) this._sprite = val;
        }
        /**
     * @param config particle emitter options bag
     */ constructor(config){
            var _a, _b;
            super({
                width: (_a = config.width) !== null && _a !== void 0 ? _a : 0,
                height: (_b = config.height) !== null && _b !== void 0 ? _b : 0
            });
            this._particlesToEmit = 0;
            this.numParticles = 0;
            /**
         * Gets or sets the isEmitting flag
         */ this.isEmitting = true;
            /**
         * Gets or sets the backing particle collection
         */ this.particles = [];
            /**
         * Gets or sets the backing deadParticle collection
         */ this.deadParticles = [];
            /**
         * Gets or sets the minimum particle velocity
         */ this.minVel = 0;
            /**
         * Gets or sets the maximum particle velocity
         */ this.maxVel = 0;
            /**
         * Gets or sets the acceleration vector for all particles
         */ this.acceleration = new Vector(0, 0);
            /**
         * Gets or sets the minimum angle in radians
         */ this.minAngle = 0;
            /**
         * Gets or sets the maximum angle in radians
         */ this.maxAngle = 0;
            /**
         * Gets or sets the emission rate for particles (particles/sec)
         */ this.emitRate = 1; //particles/sec
            /**
         * Gets or sets the life of each particle in milliseconds
         */ this.particleLife = 2000;
            /**
         * Gets or sets the fade flag which causes particles to gradually fade out over the course of their life.
         */ this.fadeFlag = false;
            /**
         * Gets or sets the optional focus where all particles should accelerate towards
         */ this.focus = null;
            /**
         * Gets or sets the acceleration for focusing particles if a focus has been specified
         */ this.focusAccel = null;
            /**
         * Gets or sets the optional starting size for the particles
         */ this.startSize = null;
            /**
         * Gets or sets the optional ending size for the particles
         */ this.endSize = null;
            /**
         * Gets or sets the minimum size of all particles
         */ this.minSize = 5;
            /**
         * Gets or sets the maximum size of all particles
         */ this.maxSize = 5;
            /**
         * Gets or sets the beginning color of all particles
         */ this.beginColor = Color.White;
            /**
         * Gets or sets the ending color of all particles
         */ this.endColor = Color.White;
            this._sprite = null;
            /**
         * Gets or sets the emitter type for the particle emitter
         */ this.emitterType = EmitterType.Rectangle;
            /**
         * Gets or sets the emitter radius, only takes effect when the [[emitterType]] is [[EmitterType.Circle]]
         */ this.radius = 0;
            /**
         * Gets or sets the particle rotational speed velocity
         */ this.particleRotationalVelocity = 0;
            /**
         * Indicates whether particles should start with a random rotation
         */ this.randomRotation = false;
            /**
         * Gets or sets the emitted particle transform style, [[ParticleTransform.Global]] is the default and emits particles as if
         * they were world space objects, useful for most effects.
         *
         * If set to [[ParticleTransform.Local]] particles are children of the emitter and move relative to the emitter
         * as they would in a parent/child actor relationship.
         */ this.particleTransform = ParticleTransform.Global;
            const { x: x, y: y, z: z, pos: pos, isEmitting: isEmitting, minVel: minVel, maxVel: maxVel, acceleration: acceleration, minAngle: minAngle, maxAngle: maxAngle, emitRate: emitRate, particleLife: particleLife, opacity: opacity, fadeFlag: fadeFlag, focus: focus, focusAccel: focusAccel, startSize: startSize, endSize: endSize, minSize: minSize, maxSize: maxSize, beginColor: beginColor, endColor: endColor, particleSprite: particleSprite, emitterType: emitterType, radius: radius, particleRotationalVelocity: particleRotationalVelocity, particleTransform: particleTransform, randomRotation: randomRotation, random: random } = {
                ...config
            };
            this.pos = pos !== null && pos !== void 0 ? pos : vec(x !== null && x !== void 0 ? x : 0, y !== null && y !== void 0 ? y : 0);
            this.z = z !== null && z !== void 0 ? z : 0;
            this.isEmitting = isEmitting !== null && isEmitting !== void 0 ? isEmitting : this.isEmitting;
            this.minVel = minVel !== null && minVel !== void 0 ? minVel : this.minVel;
            this.maxVel = maxVel !== null && maxVel !== void 0 ? maxVel : this.maxVel;
            this.acceleration = acceleration !== null && acceleration !== void 0 ? acceleration : this.acceleration;
            this.minAngle = minAngle !== null && minAngle !== void 0 ? minAngle : this.minAngle;
            this.maxAngle = maxAngle !== null && maxAngle !== void 0 ? maxAngle : this.maxAngle;
            this.emitRate = emitRate !== null && emitRate !== void 0 ? emitRate : this.emitRate;
            this.particleLife = particleLife !== null && particleLife !== void 0 ? particleLife : this.particleLife;
            this.opacity = opacity !== null && opacity !== void 0 ? opacity : this.opacity;
            this.fadeFlag = fadeFlag !== null && fadeFlag !== void 0 ? fadeFlag : this.fadeFlag;
            this.focus = focus !== null && focus !== void 0 ? focus : this.focus;
            this.focusAccel = focusAccel !== null && focusAccel !== void 0 ? focusAccel : this.focusAccel;
            this.startSize = startSize !== null && startSize !== void 0 ? startSize : this.startSize;
            this.endSize = endSize !== null && endSize !== void 0 ? endSize : this.endSize;
            this.minSize = minSize !== null && minSize !== void 0 ? minSize : this.minSize;
            this.maxSize = maxSize !== null && maxSize !== void 0 ? maxSize : this.maxSize;
            this.beginColor = beginColor !== null && beginColor !== void 0 ? beginColor : this.beginColor;
            this.endColor = endColor !== null && endColor !== void 0 ? endColor : this.endColor;
            this.particleSprite = particleSprite !== null && particleSprite !== void 0 ? particleSprite : this.particleSprite;
            this.emitterType = emitterType !== null && emitterType !== void 0 ? emitterType : this.emitterType;
            this.radius = radius !== null && radius !== void 0 ? radius : this.radius;
            this.particleRotationalVelocity = particleRotationalVelocity !== null && particleRotationalVelocity !== void 0 ? particleRotationalVelocity : this.particleRotationalVelocity;
            this.randomRotation = randomRotation !== null && randomRotation !== void 0 ? randomRotation : this.randomRotation;
            this.particleTransform = particleTransform !== null && particleTransform !== void 0 ? particleTransform : this.particleTransform;
            this.body.collisionType = CollisionType.PreventCollision;
            this.random = random !== null && random !== void 0 ? random : new Random();
        }
        removeParticle(particle) {
            this.deadParticles.push(particle);
        }
        /**
     * Causes the emitter to emit particles
     * @param particleCount  Number of particles to emit right now
     */ emitParticles(particleCount) {
            var _a;
            for(let i = 0; i < particleCount; i++){
                const p = this._createParticle();
                this.particles.push(p);
                if ((_a = this === null || this === void 0 ? void 0 : this.scene) === null || _a === void 0 ? void 0 : _a.world) {
                    if (this.particleTransform === ParticleTransform.Global) this.scene.world.add(p);
                    else this.addChild(p);
                }
            }
        }
        clearParticles() {
            this.particles.length = 0;
        }
        // Creates a new particle given the constraints of the emitter
        _createParticle() {
            // todo implement emitter constraints;
            let ranX = 0;
            let ranY = 0;
            const angle = randomInRange(this.minAngle, this.maxAngle, this.random);
            const vel = randomInRange(this.minVel, this.maxVel, this.random);
            const size = this.startSize || randomInRange(this.minSize, this.maxSize, this.random);
            const dx = vel * Math.cos(angle);
            const dy = vel * Math.sin(angle);
            if (this.emitterType === EmitterType.Rectangle) {
                ranX = randomInRange(0, this.width, this.random);
                ranY = randomInRange(0, this.height, this.random);
            } else if (this.emitterType === EmitterType.Circle) {
                const radius = randomInRange(0, this.radius, this.random);
                ranX = radius * Math.cos(angle);
                ranY = radius * Math.sin(angle);
            }
            const p = new Particle(this, this.particleLife, this.opacity, this.beginColor, this.endColor, new Vector(ranX, ranY), new Vector(dx, dy), this.acceleration, this.startSize, this.endSize, this.particleSprite);
            p.fadeFlag = this.fadeFlag;
            p.particleSize = size;
            p.particleRotationalVelocity = this.particleRotationalVelocity;
            if (this.randomRotation) p.currentRotation = randomInRange(0, Math.PI * 2, this.random);
            if (this.focus) {
                p.focus = this.focus.add(new Vector(this.pos.x, this.pos.y));
                p.focusAccel = this.focusAccel;
            }
            return p;
        }
        update(engine, delta) {
            var _a;
            super.update(engine, delta);
            if (this.isEmitting) {
                this._particlesToEmit += this.emitRate * (delta / 1000);
                if (this._particlesToEmit > 1.0) {
                    this.emitParticles(Math.floor(this._particlesToEmit));
                    this._particlesToEmit = this._particlesToEmit - Math.floor(this._particlesToEmit);
                }
            }
            // deferred removal
            for(let i = 0; i < this.deadParticles.length; i++){
                removeItemFromArray(this.deadParticles[i], this.particles);
                if ((_a = this === null || this === void 0 ? void 0 : this.scene) === null || _a === void 0 ? void 0 : _a.world) this.scene.world.remove(this.deadParticles[i], false);
            }
            this.deadParticles.length = 0;
        }
    }
    /**
 * Blend 2 transforms for interpolation, will interpolate from the context of newTx's parent if it exists
 */ function blendTransform(oldTx, newTx, blend, target) {
        if (oldTx.parent !== newTx.parent) {
            // Caller expects a local transform
            // Adjust old tx to be local to the new parent whatever that is
            const oldTxWithNewParent = oldTx.clone();
            const oldGlobalPos = oldTx.globalPos.clone();
            const oldGlobalScale = oldTx.globalScale.clone();
            const oldGlobalRotation = oldTx.globalRotation;
            oldTxWithNewParent.parent = newTx.parent;
            oldTxWithNewParent.globalPos = oldGlobalPos;
            oldTxWithNewParent.globalScale = oldGlobalScale;
            oldTxWithNewParent.globalRotation = oldGlobalRotation;
            oldTx = oldTxWithNewParent;
        }
        let interpolatedPos = newTx.pos;
        let interpolatedScale = newTx.scale;
        let interpolatedRotation = newTx.rotation;
        interpolatedPos = newTx.pos.scale(blend).add(oldTx.pos.scale(1.0 - blend));
        interpolatedScale = newTx.scale.scale(blend).add(oldTx.scale.scale(1.0 - blend));
        // Rotational lerp https://stackoverflow.com/a/30129248
        const cosine = (1.0 - blend) * Math.cos(oldTx.rotation) + blend * Math.cos(newTx.rotation);
        const sine = (1.0 - blend) * Math.sin(oldTx.rotation) + blend * Math.sin(newTx.rotation);
        interpolatedRotation = Math.atan2(sine, cosine);
        const tx = target !== null && target !== void 0 ? target : new transform_Transform();
        tx.setTransform(interpolatedPos, interpolatedRotation, interpolatedScale);
        return tx;
    }
    /**
 *
 */ function blendGlobalTransform(oldTx, newTx, blend, target) {
        let interpolatedPos = newTx.globalPos;
        let interpolatedScale = newTx.globalScale;
        let interpolatedRotation = newTx.globalRotation;
        interpolatedPos = newTx.globalPos.scale(blend).add(oldTx.globalPos.scale(1.0 - blend));
        interpolatedScale = newTx.globalScale.scale(blend).add(oldTx.globalScale.scale(1.0 - blend));
        // Rotational lerp https://stackoverflow.com/a/30129248
        const cosine = (1.0 - blend) * Math.cos(oldTx.globalRotation) + blend * Math.cos(newTx.globalRotation);
        const sine = (1.0 - blend) * Math.sin(oldTx.globalRotation) + blend * Math.sin(newTx.globalRotation);
        interpolatedRotation = Math.atan2(sine, cosine);
        const tx = target !== null && target !== void 0 ? target : new Transform();
        tx.setTransform(interpolatedPos, interpolatedRotation, interpolatedScale);
        return tx;
    }
    // this import seems to bomb wallaby
    class GraphicsSystem extends System {
        get sortedTransforms() {
            return this._sortedTransforms;
        }
        constructor(world){
            super();
            this.world = world;
            this.systemType = SystemType.Draw;
            this.priority = SystemPriority.Average;
            this._token = 0;
            this._sortedTransforms = [];
            this._zHasChanged = false;
            this._zIndexUpdate = ()=>{
                this._zHasChanged = true;
            };
            this._targetInterpolationTransform = new transform_Transform();
            this.query = this.world.query([
                TransformComponent,
                GraphicsComponent
            ]);
            this.query.entityAdded$.subscribe((e)=>{
                const tx = e.get(TransformComponent);
                this._sortedTransforms.push(tx);
                tx.zIndexChanged$.subscribe(this._zIndexUpdate);
                this._zHasChanged = true;
            });
            this.query.entityRemoved$.subscribe((e)=>{
                const tx = e.get(TransformComponent);
                tx.zIndexChanged$.unsubscribe(this._zIndexUpdate);
                const index = this._sortedTransforms.indexOf(tx);
                if (index > -1) this._sortedTransforms.splice(index, 1);
            });
        }
        initialize(world, scene) {
            this._camera = scene.camera;
            this._engine = scene.engine;
        }
        preupdate() {
            // Graphics context could be switched to fallback in a new frame
            this._graphicsContext = this._engine.graphicsContext;
            if (this._zHasChanged) {
                this._sortedTransforms.sort((a, b)=>{
                    return a.z - b.z;
                });
                this._zHasChanged = false;
            }
        }
        update(delta) {
            this._token++;
            let graphics;
            FontCache.checkAndClearCache();
            // This is a performance enhancement, most things are in world space
            // so if we can only do this once saves a ton of transform updates
            this._graphicsContext.save();
            if (this._camera) this._camera.draw(this._graphicsContext);
            for (const transform of this._sortedTransforms){
                const entity = transform.owner;
                // If the entity is offscreen skip
                if (entity.hasTag("ex.offscreen")) continue;
                graphics = entity.get(GraphicsComponent);
                // Exit if graphics set to not visible
                if (!graphics.visible) continue;
                // Optionally run the onPreTransformDraw graphics lifecycle draw
                if (graphics.onPreTransformDraw) graphics.onPreTransformDraw(this._graphicsContext, delta);
                entity.events.emit("pretransformdraw", new PreTransformDrawEvent(this._graphicsContext, delta, entity));
                // This optionally sets our camera based on the entity coord plan (world vs. screen)
                if (transform.coordPlane === CoordPlane.Screen) this._graphicsContext.restore();
                this._graphicsContext.save();
                if (transform.coordPlane === CoordPlane.Screen) this._graphicsContext.translate(this._engine.screen.contentArea.left, this._engine.screen.contentArea.top);
                // Tick any graphics state (but only once) for animations and graphics groups
                graphics.update(delta, this._token);
                // Apply parallax
                const parallax = entity.get(ParallaxComponent);
                if (parallax) {
                    // We use the Tiled formula
                    // https://doc.mapeditor.org/en/latest/manual/layers/#parallax-scrolling-factor
                    // cameraPos * (1 - parallaxFactor)
                    const oneMinusFactor = Vector.One.sub(parallax.parallaxFactor);
                    const parallaxOffset = this._camera.drawPos.scale(oneMinusFactor);
                    this._graphicsContext.translate(parallaxOffset.x, parallaxOffset.y);
                }
                // Position the entity + estimate lag
                this._applyTransform(entity);
                // If there is a material enable it on the context
                if (graphics.material) this._graphicsContext.material = graphics.material;
                // Optionally run the onPreDraw graphics lifecycle draw
                if (graphics.onPreDraw) graphics.onPreDraw(this._graphicsContext, delta);
                entity.events.emit("predraw", new PreDrawEvent(this._graphicsContext, delta, entity));
                // TODO remove this hack on the particle redo
                // Remove this line after removing the wallaby import
                const particleOpacity = entity instanceof Particle ? entity.opacity : 1;
                this._graphicsContext.opacity *= graphics.opacity * particleOpacity;
                // Draw the graphics component
                this._drawGraphicsComponent(graphics, transform);
                // Optionally run the onPostDraw graphics lifecycle draw
                if (graphics.onPostDraw) graphics.onPostDraw(this._graphicsContext, delta);
                entity.events.emit("postdraw", new PostDrawEvent(this._graphicsContext, delta, entity));
                this._graphicsContext.restore();
                // Reset the transform back to the original world space
                if (transform.coordPlane === CoordPlane.Screen) {
                    this._graphicsContext.save();
                    if (this._camera) this._camera.draw(this._graphicsContext);
                }
                // Optionally run the onPreTransformDraw graphics lifecycle draw
                if (graphics.onPostTransformDraw) graphics.onPostTransformDraw(this._graphicsContext, delta);
                entity.events.emit("posttransformdraw", new PostTransformDrawEvent(this._graphicsContext, delta, entity));
            }
            this._graphicsContext.restore();
        }
        _drawGraphicsComponent(graphicsComponent, transformComponent) {
            var _a, _b;
            if (graphicsComponent.visible) {
                const flipHorizontal = graphicsComponent.flipHorizontal;
                const flipVertical = graphicsComponent.flipVertical;
                const graphic = graphicsComponent.current;
                const options = (_a = graphicsComponent.currentOptions) !== null && _a !== void 0 ? _a : {};
                if (graphic) {
                    let anchor = graphicsComponent.anchor;
                    let offset = graphicsComponent.offset;
                    let scaleX = 1;
                    let scaleY = 1;
                    // handle specific overrides
                    if (options === null || options === void 0 ? void 0 : options.anchor) anchor = options.anchor;
                    if (options === null || options === void 0 ? void 0 : options.offset) offset = options.offset;
                    const globalScale = transformComponent.globalScale;
                    scaleX *= graphic.scale.x * globalScale.x;
                    scaleY *= graphic.scale.y * globalScale.y;
                    // See https://github.com/excaliburjs/Excalibur/pull/619 for discussion on this formula
                    const offsetX = -graphic.width * anchor.x + offset.x * scaleX;
                    const offsetY = -graphic.height * anchor.y + offset.y * scaleY;
                    const oldFlipHorizontal = graphic.flipHorizontal;
                    const oldFlipVertical = graphic.flipVertical;
                    if (flipHorizontal || flipVertical) {
                        // flip any currently flipped graphics
                        graphic.flipHorizontal = flipHorizontal ? !oldFlipHorizontal : oldFlipHorizontal;
                        graphic.flipVertical = flipVertical ? !oldFlipVertical : oldFlipVertical;
                    }
                    graphic === null || graphic === void 0 || graphic.draw(this._graphicsContext, offsetX, offsetY);
                    if (flipHorizontal || flipVertical) {
                        graphic.flipHorizontal = oldFlipHorizontal;
                        graphic.flipVertical = oldFlipVertical;
                    }
                    // TODO move debug code out?
                    if (((_b = this._engine) === null || _b === void 0 ? void 0 : _b.isDebug) && this._engine.debug.graphics.showBounds) {
                        const offset = vec(offsetX, offsetY);
                        if (graphic instanceof GraphicsGroup) for (const member of graphic.members){
                            let g;
                            let pos = Vector.Zero;
                            if (member instanceof Graphic) g = member;
                            else {
                                g = member.graphic;
                                pos = member.offset;
                            }
                            if (graphic.useAnchor) g === null || g === void 0 || g.localBounds.translate(offset.add(pos)).draw(this._graphicsContext, this._engine.debug.graphics.boundsColor);
                            else g === null || g === void 0 || g.localBounds.translate(pos).draw(this._graphicsContext, this._engine.debug.graphics.boundsColor);
                        }
                        else /* istanbul ignore next */ graphic === null || graphic === void 0 || graphic.localBounds.translate(offset).draw(this._graphicsContext, this._engine.debug.graphics.boundsColor);
                    }
                }
            }
        }
        /**
     * This applies the current entity transform to the graphics context
     * @param entity
     */ _applyTransform(entity) {
            const ancestors = entity.getAncestors();
            for (const ancestor of ancestors){
                const transform = ancestor === null || ancestor === void 0 ? void 0 : ancestor.get(TransformComponent);
                const optionalBody = ancestor === null || ancestor === void 0 ? void 0 : ancestor.get(BodyComponent);
                let tx = transform.get();
                if (optionalBody) {
                    if (this._engine.fixedUpdateFps && optionalBody.__oldTransformCaptured && optionalBody.enableFixedUpdateInterpolate) {
                        // Interpolate graphics if needed
                        const blend = this._engine.currentFrameLagMs / (1000 / this._engine.fixedUpdateFps);
                        tx = blendTransform(optionalBody.oldTransform, transform.get(), blend, this._targetInterpolationTransform);
                    }
                }
                if (transform) {
                    this._graphicsContext.z = transform.z;
                    this._graphicsContext.translate(tx.pos.x, tx.pos.y);
                    this._graphicsContext.scale(tx.scale.x, tx.scale.y);
                    this._graphicsContext.rotate(tx.rotation);
                }
            }
        }
    }
    class DebugSystem extends System {
        constructor(world){
            super();
            this.world = world;
            this.systemType = SystemType.Draw;
            this.priority = SystemPriority.Lowest;
            this.query = this.world.query([
                TransformComponent
            ]);
        }
        initialize(world, scene) {
            this._graphicsContext = scene.engine.graphicsContext;
            this._camera = scene.camera;
            this._engine = scene.engine;
            this._collisionSystem = world.systemManager.get(CollisionSystem);
        }
        update() {
            var _a;
            if (!this._engine.isDebug) return;
            const filterSettings = this._engine.debug.filter;
            let id;
            let name;
            const entitySettings = this._engine.debug.entity;
            let tx;
            const txSettings = this._engine.debug.transform;
            let motion;
            const motionSettings = this._engine.debug.motion;
            let colliderComp;
            const colliderSettings = this._engine.debug.collider;
            const physicsSettings = this._engine.debug.physics;
            let graphics;
            const graphicsSettings = this._engine.debug.graphics;
            let debugDraw;
            let body;
            const bodySettings = this._engine.debug.body;
            const cameraSettings = this._engine.debug.camera;
            for (const entity of this.query.entities){
                if (entity.hasTag("offscreen")) continue;
                if (entity instanceof Particle) continue;
                if (filterSettings.useFilter) {
                    const allIds = filterSettings.ids.length === 0;
                    const idMatch = allIds || filterSettings.ids.includes(entity.id);
                    if (!idMatch) continue;
                    const allNames = filterSettings.nameQuery === "";
                    const nameMatch = allNames || entity.name.includes(filterSettings.nameQuery);
                    if (!nameMatch) continue;
                }
                let cursor = Vector.Zero;
                const lineHeight = vec(0, 16);
                id = entity.id;
                name = entity.name;
                tx = entity.get(TransformComponent);
                // This optionally sets our camera based on the entity coord plan (world vs. screen)
                this._pushCameraTransform(tx);
                this._graphicsContext.save();
                if (tx.coordPlane === CoordPlane.Screen) this._graphicsContext.translate(this._engine.screen.contentArea.left, this._engine.screen.contentArea.top);
                this._graphicsContext.z = txSettings.debugZIndex;
                this._applyTransform(entity);
                if (tx) {
                    if (txSettings.showAll || txSettings.showPosition) this._graphicsContext.debug.drawPoint(Vector.Zero, {
                        size: 4,
                        color: txSettings.positionColor
                    });
                    if (txSettings.showAll || txSettings.showPositionLabel) {
                        this._graphicsContext.debug.drawText(`pos${tx.pos.toString(2)}`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (txSettings.showAll || txSettings.showZIndex) {
                        this._graphicsContext.debug.drawText(`z(${tx.z.toFixed(1)})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (entitySettings.showAll || entitySettings.showId) {
                        this._graphicsContext.debug.drawText(`id(${id}) ${entity.parent ? "child of id(" + ((_a = entity.parent) === null || _a === void 0 ? void 0 : _a.id) + ")" : ""}`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (entitySettings.showAll || entitySettings.showName) {
                        this._graphicsContext.debug.drawText(`name(${name})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (txSettings.showAll || txSettings.showRotation) {
                        this._graphicsContext.drawLine(Vector.Zero, Vector.fromAngle(tx.rotation).scale(50).add(Vector.Zero), txSettings.rotationColor, 2);
                        this._graphicsContext.debug.drawText(`rot deg(${toDegrees(tx.rotation).toFixed(2)})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (txSettings.showAll || txSettings.showScale) this._graphicsContext.drawLine(Vector.Zero, tx.scale.add(Vector.Zero), txSettings.scaleColor, 2);
                }
                graphics = entity.get(GraphicsComponent);
                if (graphics) {
                    if (graphicsSettings.showAll || graphicsSettings.showBounds) {
                        const bounds = graphics.localBounds;
                        bounds.draw(this._graphicsContext, graphicsSettings.boundsColor);
                    }
                }
                debugDraw = entity.get(DebugGraphicsComponent);
                if (debugDraw) {
                    if (!debugDraw.useTransform) this._graphicsContext.restore();
                    debugDraw.draw(this._graphicsContext, this._engine.debug);
                    if (!debugDraw.useTransform) {
                        this._graphicsContext.save();
                        this._applyTransform(entity);
                    }
                }
                body = entity.get(BodyComponent);
                if (body) {
                    if (bodySettings.showAll || bodySettings.showCollisionGroup) {
                        this._graphicsContext.debug.drawText(`collision group(${body.group.name})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (bodySettings.showAll || bodySettings.showCollisionType) {
                        this._graphicsContext.debug.drawText(`collision type(${body.collisionType})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (bodySettings.showAll || bodySettings.showMass) {
                        this._graphicsContext.debug.drawText(`mass(${body.mass})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (bodySettings.showAll || bodySettings.showMotion) {
                        this._graphicsContext.debug.drawText(`motion(${body.sleepMotion})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                    if (bodySettings.showAll || bodySettings.showSleeping) {
                        this._graphicsContext.debug.drawText(`sleeping(${body.canSleep ? body.sleeping : "cant sleep"})`, cursor);
                        cursor = cursor.add(lineHeight);
                    }
                }
                this._graphicsContext.restore();
                // World space
                this._graphicsContext.save();
                if (tx.coordPlane === CoordPlane.Screen) this._graphicsContext.translate(this._engine.screen.contentArea.left, this._engine.screen.contentArea.top);
                this._graphicsContext.z = txSettings.debugZIndex;
                motion = entity.get(MotionComponent);
                if (motion) {
                    if (motionSettings.showAll || motionSettings.showVelocity) {
                        this._graphicsContext.debug.drawText(`vel${motion.vel.toString(2)}`, cursor.add(tx.globalPos));
                        this._graphicsContext.drawLine(tx.globalPos, tx.globalPos.add(motion.vel), motionSettings.velocityColor, 2);
                        cursor = cursor.add(lineHeight);
                    }
                    if (motionSettings.showAll || motionSettings.showAcceleration) this._graphicsContext.drawLine(tx.globalPos, tx.globalPos.add(motion.acc), motionSettings.accelerationColor, 2);
                }
                // Colliders live in world space already so after the restore()
                colliderComp = entity.get(ColliderComponent);
                if (colliderComp) {
                    const collider = colliderComp.get();
                    if ((colliderSettings.showAll || colliderSettings.showGeometry) && collider) collider.debug(this._graphicsContext, colliderSettings.geometryColor, {
                        lineWidth: colliderSettings.geometryLineWidth,
                        pointSize: colliderSettings.geometryPointSize
                    });
                    if (colliderSettings.showAll || colliderSettings.showBounds) {
                        if (collider instanceof CompositeCollider) {
                            const colliders = collider.getColliders();
                            for (const collider of colliders){
                                const bounds = collider.bounds;
                                const pos = vec(bounds.left, bounds.top);
                                this._graphicsContext.debug.drawRect(pos.x, pos.y, bounds.width, bounds.height, {
                                    color: colliderSettings.boundsColor
                                });
                                if (colliderSettings.showAll || colliderSettings.showOwner) this._graphicsContext.debug.drawText(`owner id(${collider.owner.id})`, pos);
                            }
                            colliderComp.bounds.draw(this._graphicsContext, colliderSettings.boundsColor);
                        } else if (collider) {
                            const bounds = colliderComp.bounds;
                            const pos = vec(bounds.left, bounds.top);
                            this._graphicsContext.debug.drawRect(pos.x, pos.y, bounds.width, bounds.height, {
                                color: colliderSettings.boundsColor
                            });
                            if (colliderSettings.showAll || colliderSettings.showOwner) this._graphicsContext.debug.drawText(`owner id(${colliderComp.owner.id})`, pos);
                        }
                    }
                }
                this._graphicsContext.restore();
                this._popCameraTransform(tx);
            }
            this._graphicsContext.save();
            this._camera.draw(this._graphicsContext);
            if (physicsSettings.showAll || physicsSettings.showBroadphaseSpacePartitionDebug) this._collisionSystem.debug(this._graphicsContext);
            if (physicsSettings.showAll || physicsSettings.showCollisionContacts || physicsSettings.showCollisionNormals) for (const [_, contact] of this._engine.debug.stats.currFrame.physics.contacts){
                if (physicsSettings.showAll || physicsSettings.showCollisionContacts) for (const point of contact.points)this._graphicsContext.debug.drawPoint(point, {
                    size: physicsSettings.contactSize,
                    color: physicsSettings.collisionContactColor
                });
                if (physicsSettings.showAll || physicsSettings.showCollisionNormals) for (const point of contact.points)this._graphicsContext.debug.drawLine(point, contact.normal.scale(30).add(point), {
                    color: physicsSettings.collisionNormalColor
                });
            }
            this._graphicsContext.restore();
            if (cameraSettings) {
                this._graphicsContext.save();
                this._camera.draw(this._graphicsContext);
                if (cameraSettings.showAll || cameraSettings.showFocus) this._graphicsContext.drawCircle(this._camera.pos, 4, cameraSettings.focusColor);
                if (cameraSettings.showAll || cameraSettings.showZoom) this._graphicsContext.debug.drawText(`zoom(${this._camera.zoom})`, this._camera.pos);
                this._graphicsContext.restore();
            }
            this._graphicsContext.flush();
        }
        postupdate(engine, elapsedMs) {
            if (this._engine.isDebug) {
                this._graphicsContext.save();
                if (this._camera) this._camera.draw(this._graphicsContext);
                Debug.flush(this._graphicsContext);
                this._graphicsContext.restore();
            }
        }
        /**
     * This applies the current entity transform to the graphics context
     * @param entity
     */ _applyTransform(entity) {
            const ancestors = entity.getAncestors();
            for (const ancestor of ancestors){
                const transform = ancestor === null || ancestor === void 0 ? void 0 : ancestor.get(TransformComponent);
                if (transform) {
                    this._graphicsContext.translate(transform.pos.x, transform.pos.y);
                    this._graphicsContext.scale(transform.scale.x, transform.scale.y);
                    this._graphicsContext.rotate(transform.rotation);
                }
            }
        }
        /**
     * Applies the current camera transform if in world coordinates
     * @param transform
     */ _pushCameraTransform(transform) {
            // Establish camera offset per entity
            if (transform.coordPlane === CoordPlane.World) {
                this._graphicsContext.save();
                if (this._camera) this._camera.draw(this._graphicsContext);
            }
        }
        /**
     * Resets the current camera transform if in world coordinates
     * @param transform
     */ _popCameraTransform(transform) {
            if (transform.coordPlane === CoordPlane.World) // Apply camera world offset
            this._graphicsContext.restore();
        }
    }
    /**
 * The PointerSystem is responsible for dispatching pointer events to entities
 * that need them.
 *
 * The PointerSystem can be optionally configured by the [[PointerComponent]], by default Entities use
 * the [[Collider]]'s shape for pointer events.
 */ class PointerSystem extends System {
        constructor(world){
            super();
            this.world = world;
            this.systemType = SystemType.Update;
            this.priority = SystemPriority.Higher;
            /**
         * Optionally override component configuration for all entities
         */ this.overrideUseColliderShape = false;
            /**
         * Optionally override component configuration for all entities
         */ this.overrideUseGraphicsBounds = false;
            this.lastFrameEntityToPointers = new Map();
            this.currentFrameEntityToPointers = new Map();
            this._sortedTransforms = [];
            this._sortedEntities = [];
            this._zHasChanged = false;
            this._zIndexUpdate = ()=>{
                this._zHasChanged = true;
            };
            this.query = this.world.query([
                TransformComponent,
                PointerComponent
            ]);
            this.query.entityAdded$.subscribe((e)=>{
                const tx = e.get(TransformComponent);
                this._sortedTransforms.push(tx);
                this._sortedEntities.push(tx.owner);
                tx.zIndexChanged$.subscribe(this._zIndexUpdate);
                this._zHasChanged = true;
            });
            this.query.entityRemoved$.subscribe((e)=>{
                const tx = e.get(TransformComponent);
                tx.zIndexChanged$.unsubscribe(this._zIndexUpdate);
                const index = this._sortedTransforms.indexOf(tx);
                if (index > -1) {
                    this._sortedTransforms.splice(index, 1);
                    this._sortedEntities.splice(index, 1);
                }
            });
        }
        initialize(world, scene) {
            this._engine = scene.engine;
            this._scene = scene;
        }
        preupdate() {
            // event receiver might change per frame
            this._receivers = [
                this._engine.input.pointers,
                this._scene.input.pointers
            ];
            this._engineReceiver = this._engine.input.pointers;
            if (this._zHasChanged) {
                this._sortedTransforms.sort((a, b)=>{
                    return b.z - a.z;
                });
                this._sortedEntities = this._sortedTransforms.map((t)=>t.owner);
                this._zHasChanged = false;
            }
        }
        entityCurrentlyUnderPointer(entity, pointerId) {
            return this.currentFrameEntityToPointers.has(entity.id) && this.currentFrameEntityToPointers.get(entity.id).includes(pointerId);
        }
        entityWasUnderPointer(entity, pointerId) {
            return this.lastFrameEntityToPointers.has(entity.id) && this.lastFrameEntityToPointers.get(entity.id).includes(pointerId);
        }
        entered(entity, pointerId) {
            return this.entityCurrentlyUnderPointer(entity, pointerId) && !this.lastFrameEntityToPointers.has(entity.id);
        }
        left(entity, pointerId) {
            return !this.currentFrameEntityToPointers.has(entity.id) && this.entityWasUnderPointer(entity, pointerId);
        }
        addPointerToEntity(entity, pointerId) {
            if (!this.currentFrameEntityToPointers.has(entity.id)) {
                this.currentFrameEntityToPointers.set(entity.id, [
                    pointerId
                ]);
                return;
            }
            const pointers = this.currentFrameEntityToPointers.get(entity.id);
            this.currentFrameEntityToPointers.set(entity.id, pointers.concat(pointerId));
        }
        update() {
            // Locate all the pointer/entity mappings
            this._processPointerToEntity(this._sortedEntities);
            // Dispatch pointer events on entities
            this._dispatchEvents(this._sortedEntities);
            // Clear last frame's events
            this._receivers.forEach((r)=>r.update());
            this.lastFrameEntityToPointers.clear();
            this.lastFrameEntityToPointers = new Map(this.currentFrameEntityToPointers);
            this.currentFrameEntityToPointers.clear();
            this._receivers.forEach((r)=>r.clear());
        }
        _processPointerToEntity(entities) {
            var _a;
            let transform;
            let collider;
            let graphics;
            let pointer;
            const receiver = this._engineReceiver;
            // TODO probably a spatial partition optimization here to quickly query bounds for pointer
            // doesn't seem to cause issues tho for perf
            // Pre-process find entities under pointers
            for (const entity of entities){
                transform = entity.get(TransformComponent);
                pointer = (_a = entity.get(PointerComponent)) !== null && _a !== void 0 ? _a : new PointerComponent;
                // If pointer bounds defined
                if (pointer.localBounds) {
                    const pointerBounds = pointer.localBounds.transform(transform.get().matrix);
                    for (const [pointerId, pos] of receiver.currentFramePointerCoords.entries())if (pointerBounds.contains(transform.coordPlane === CoordPlane.World ? pos.worldPos : pos.screenPos)) this.addPointerToEntity(entity, pointerId);
                }
                // Check collider contains pointer
                collider = entity.get(ColliderComponent);
                if (collider && (pointer.useColliderShape || this.overrideUseColliderShape)) {
                    collider.update();
                    const geom = collider.get();
                    if (geom) {
                        for (const [pointerId, pos] of receiver.currentFramePointerCoords.entries())if (geom.contains(transform.coordPlane === CoordPlane.World ? pos.worldPos : pos.screenPos)) this.addPointerToEntity(entity, pointerId);
                    }
                }
                // Check graphics contains pointer
                graphics = entity.get(GraphicsComponent);
                if (graphics && (pointer.useGraphicsBounds || this.overrideUseGraphicsBounds)) {
                    const graphicBounds = graphics.localBounds.transform(transform.get().matrix);
                    for (const [pointerId, pos] of receiver.currentFramePointerCoords.entries())if (graphicBounds.contains(transform.coordPlane === CoordPlane.World ? pos.worldPos : pos.screenPos)) this.addPointerToEntity(entity, pointerId);
                }
            }
        }
        _processDownAndEmit(entity) {
            const receiver = this._engineReceiver;
            const lastDownPerPointer = new Map(); // TODO will this get confused between receivers?
            // Loop through down and dispatch to entities
            for (const event of receiver.currentFrameDown){
                if (event.active && entity.active && this.entityCurrentlyUnderPointer(entity, event.pointerId)) {
                    entity.events.emit("pointerdown", event);
                    if (receiver.isDragStart(event.pointerId)) entity.events.emit("pointerdragstart", event);
                }
                lastDownPerPointer.set(event.pointerId, event);
            }
            return lastDownPerPointer;
        }
        _processUpAndEmit(entity) {
            const receiver = this._engineReceiver;
            const lastUpPerPointer = new Map();
            // Loop through up and dispatch to entities
            for (const event of receiver.currentFrameUp){
                if (event.active && entity.active && this.entityCurrentlyUnderPointer(entity, event.pointerId)) {
                    entity.events.emit("pointerup", event);
                    if (receiver.isDragEnd(event.pointerId)) entity.events.emit("pointerdragend", event);
                }
                lastUpPerPointer.set(event.pointerId, event);
            }
            return lastUpPerPointer;
        }
        _processMoveAndEmit(entity) {
            const receiver = this._engineReceiver;
            const lastMovePerPointer = new Map();
            // Loop through move and dispatch to entities
            for (const event of receiver.currentFrameMove){
                if (event.active && entity.active && this.entityCurrentlyUnderPointer(entity, event.pointerId)) {
                    // move
                    entity.events.emit("pointermove", event);
                    if (receiver.isDragging(event.pointerId)) entity.events.emit("pointerdragmove", event);
                }
                lastMovePerPointer.set(event.pointerId, event);
            }
            return lastMovePerPointer;
        }
        _processEnterLeaveAndEmit(entity, lastUpDownMoveEvents) {
            const receiver = this._engineReceiver;
            // up, down, and move are considered for enter and leave
            for (const event of lastUpDownMoveEvents){
                // enter
                if (event.active && entity.active && this.entered(entity, event.pointerId)) {
                    entity.events.emit("pointerenter", event);
                    if (receiver.isDragging(event.pointerId)) entity.events.emit("pointerdragenter", event);
                    break;
                }
                if (event.active && entity.active && // leave can happen on move
                (this.left(entity, event.pointerId) || // or leave can happen on pointer up
                this.entityCurrentlyUnderPointer(entity, event.pointerId) && event.type === "up")) {
                    entity.events.emit("pointerleave", event);
                    if (receiver.isDragging(event.pointerId)) entity.events.emit("pointerdragleave", event);
                    break;
                }
            }
        }
        _processCancelAndEmit(entity) {
            const receiver = this._engineReceiver;
            // cancel
            for (const event of receiver.currentFrameCancel)if (event.active && entity.active && this.entityCurrentlyUnderPointer(entity, event.pointerId)) entity.events.emit("pointercancel", event);
        }
        _processWheelAndEmit(entity) {
            const receiver = this._engineReceiver;
            // wheel
            for (const event of receiver.currentFrameWheel)// Currently the wheel only fires under the primary pointer '0'
            if (event.active && entity.active && this.entityCurrentlyUnderPointer(entity, 0)) entity.events.emit("pointerwheel", event);
        }
        _dispatchEvents(entities) {
            const lastFrameEntities = new Set(this.lastFrameEntityToPointers.keys());
            const currentFrameEntities = new Set(this.currentFrameEntityToPointers.keys());
            // Filter preserves z order
            const entitiesWithEvents = entities.filter((e)=>lastFrameEntities.has(e.id) || currentFrameEntities.has(e.id));
            let lastMovePerPointer;
            let lastUpPerPointer;
            let lastDownPerPointer;
            // Dispatch events in entity z order
            for (const entity of entitiesWithEvents){
                lastDownPerPointer = this._processDownAndEmit(entity);
                lastUpPerPointer = this._processUpAndEmit(entity);
                lastMovePerPointer = this._processMoveAndEmit(entity);
                const lastUpDownMoveEvents = [
                    ...lastMovePerPointer.values(),
                    ...lastDownPerPointer.values(),
                    ...lastUpPerPointer.values()
                ];
                this._processEnterLeaveAndEmit(entity, lastUpDownMoveEvents);
                this._processCancelAndEmit(entity);
                this._processWheelAndEmit(entity);
            }
        }
    }
    class ActionsSystem extends System {
        constructor(world){
            super();
            this.world = world;
            this.systemType = SystemType.Update;
            this.priority = SystemPriority.Higher;
            this._actions = [];
            this.query = this.world.query([
                ActionsComponent
            ]);
            this.query.entityAdded$.subscribe((e)=>this._actions.push(e.get(ActionsComponent)));
            this.query.entityRemoved$.subscribe((e)=>{
                const action = e.get(ActionsComponent);
                const index = this._actions.indexOf(action);
                if (index > -1) this._actions.splice(index, 1);
            });
        }
        update(delta) {
            for (const actions of this._actions)actions.update(delta);
        }
    }
    class IsometricEntityComponent extends Component {
        /**
     * Specify the isometric map to use to position this entity's z-index
     * @param mapOrOptions
     */ constructor(mapOrOptions){
            super();
            /**
         * Vertical "height" in the isometric world
         */ this.elevation = 0;
            this.columns = mapOrOptions.columns;
            this.rows = mapOrOptions.rows;
            this.tileWidth = mapOrOptions.tileWidth;
            this.tileHeight = mapOrOptions.tileHeight;
        }
    }
    class IsometricEntitySystem extends System {
        constructor(world){
            super();
            this.world = world;
            this.systemType = SystemType.Update;
            this.priority = SystemPriority.Lower;
            this.query = this.world.query([
                TransformComponent,
                IsometricEntityComponent
            ]);
        }
        update() {
            let transform;
            let iso;
            for (const entity of this.query.entities){
                transform = entity.get(TransformComponent);
                iso = entity.get(IsometricEntityComponent);
                const maxZindexPerElevation = Math.max(iso.columns * iso.tileWidth, iso.rows * iso.tileHeight);
                const newZ = maxZindexPerElevation * iso.elevation + transform.pos.y;
                transform.z = newZ;
            }
        }
    }
    class OffscreenSystem extends System {
        constructor(world){
            super();
            this.world = world;
            this.systemType = SystemType.Draw;
            this.priority = SystemPriority.Higher;
            this.query = this.world.query([
                TransformComponent,
                GraphicsComponent
            ]);
        }
        initialize(world, scene) {
            this._camera = scene.camera;
            this._screen = scene.engine.screen;
        }
        update() {
            this._worldBounds = this._screen.getWorldBounds();
            let transform;
            let graphics;
            let maybeParallax;
            for (const entity of this.query.entities){
                graphics = entity.get(GraphicsComponent);
                transform = entity.get(TransformComponent);
                maybeParallax = entity.get(ParallaxComponent);
                let parallaxOffset;
                if (maybeParallax) {
                    // We use the Tiled formula
                    // https://doc.mapeditor.org/en/latest/manual/layers/#parallax-scrolling-factor
                    // cameraPos * (1 - parallaxFactor)
                    const oneMinusFactor = Vector.One.sub(maybeParallax.parallaxFactor);
                    parallaxOffset = this._camera.pos.scale(oneMinusFactor);
                }
                // Figure out if entities are offscreen
                const entityOffscreen = this._isOffscreen(transform, graphics, parallaxOffset);
                if (entityOffscreen && !entity.hasTag("ex.offscreen")) {
                    entity.events.emit("exitviewport", new ExitViewPortEvent(entity));
                    entity.addTag("ex.offscreen");
                }
                if (!entityOffscreen && entity.hasTag("ex.offscreen")) {
                    entity.events.emit("enterviewport", new EnterViewPortEvent(entity));
                    entity.removeTag("ex.offscreen");
                }
            }
        }
        _isOffscreen(transform, graphics, parallaxOffset) {
            if (transform.coordPlane === CoordPlane.World) {
                let bounds = graphics.localBounds;
                if (parallaxOffset) bounds = bounds.translate(parallaxOffset);
                const transformedBounds = bounds.transform(transform.get().matrix);
                const graphicsOffscreen = !this._worldBounds.overlaps(transformedBounds);
                return graphicsOffscreen;
            } else // TODO screen coordinates
            return false;
        }
    }
    class PhysicsWorld {
        get config() {
            return watchDeep(this._config, (change)=>{
                this.$configUpdate.notifyAll(change);
            });
        }
        set config(newConfig) {
            this._config = newConfig;
            this.$configUpdate.notifyAll(newConfig);
        }
        /**
     * Spatial data structure for locating potential collision pairs and ray casts
     */ get collisionProcessor() {
            if (this._configDirty) {
                this._configDirty = false;
                // preserve tracked colliders if config updates
                const colliders = this._collisionProcessor.getColliders();
                this._collisionProcessor = new DynamicTreeCollisionProcessor(this._config);
                for (const collider of colliders)this._collisionProcessor.track(collider);
            }
            return this._collisionProcessor;
        }
        constructor(config){
            this.$configUpdate = new Observable;
            this._configDirty = false;
            this.config = config;
            this.$configUpdate.subscribe((config)=>{
                this._configDirty = true;
                BodyComponent.updateDefaultPhysicsConfig(config.bodies);
            });
            this._collisionProcessor = new DynamicTreeCollisionProcessor(this.config);
        }
        /**
     * Raycast into the scene's physics world
     * @param ray
     * @param options
     */ rayCast(ray, options) {
            return this.collisionProcessor.rayCast(ray, options);
        }
    }
    const GamepadEvents = {
        GamepadConnect: "connect",
        GamepadDisconnect: "disconnect",
        GamepadButton: "button",
        GamepadAxis: "axis"
    };
    /**
 * Excalibur leverages the HTML5 Gamepad API [where it is supported](http://caniuse.com/#feat=gamepad)
 * to provide controller support for your games.
 */ class Gamepads {
        constructor(){
            this.events = new EventEmitter();
            /**
         * Whether or not to poll for Gamepad input (default: `false`)
         */ this.enabled = false;
            /**
         * Whether or not Gamepad API is supported
         */ this.supported = !!navigator.getGamepads;
            this._gamePadTimeStamps = [
                0,
                0,
                0,
                0
            ];
            this._oldPads = [];
            this._pads = [];
            this._initSuccess = false;
            this._navigator = navigator;
            this._minimumConfiguration = null;
            this._enabled = true;
        }
        init() {
            if (!this.supported) return;
            if (this._initSuccess) return;
            // In Chrome, this will return 4 undefined items until a button is pressed
            // In FF, this will not return any items until a button is pressed
            this._oldPads = this._clonePads(this._navigator.getGamepads());
            if (this._oldPads.length && this._oldPads[0]) this._initSuccess = true;
        }
        toggleEnabled(enabled) {
            this._enabled = enabled;
        }
        /**
     * Sets the minimum gamepad configuration, for example {axis: 4, buttons: 4} means
     * this game requires at minimum 4 axis inputs and 4 buttons, this is not restrictive
     * all other controllers with more axis or buttons are valid as well. If no minimum
     * configuration is set all pads are valid.
     */ setMinimumGamepadConfiguration(config) {
            this._enableAndUpdate(); // if config is used, implicitly enable
            this._minimumConfiguration = config;
        }
        /**
     * When implicitly enabled, set the enabled flag and run an update so information is updated
     */ _enableAndUpdate() {
            if (!this.enabled) {
                this.enabled = true;
                this.update();
            }
        }
        /**
     * Checks a navigator gamepad against the minimum configuration if present.
     */ _isGamepadValid(pad) {
            if (!this._minimumConfiguration) return true;
            if (!pad) return false;
            const axesLength = pad.axes.filter((value)=>{
                return true;
            }).length;
            const buttonLength = pad.buttons.filter((value)=>{
                return true;
            }).length;
            return axesLength >= this._minimumConfiguration.axis && buttonLength >= this._minimumConfiguration.buttons && pad.connected;
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            this._enableAndUpdate(); // implicitly enable
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this._enableAndUpdate(); // implicitly enable
            this.events.off(eventName, handler);
        }
        /**
     * Updates Gamepad state and publishes Gamepad events
     */ update() {
            if (!this.enabled || !this.supported) return;
            if (!this._enabled) return;
            this.init();
            const gamepads = this._navigator.getGamepads();
            for(let i = 0; i < gamepads.length; i++){
                if (!gamepads[i]) {
                    const gamepad = this.at(i);
                    // If was connected, but now isn't emit the disconnect event
                    if (gamepad.connected) this.events.emit("disconnect", new GamepadDisconnectEvent(i, gamepad));
                    // Reset connection status
                    gamepad.connected = false;
                    continue;
                } else {
                    if (!this.at(i).connected && this._isGamepadValid(gamepads[i])) this.events.emit("connect", new GamepadConnectEvent(i, this.at(i)));
                    // Set connection status
                    this.at(i).connected = true;
                }
                this.at(i).update();
                // Only supported in Chrome
                if (gamepads[i].timestamp && gamepads[i].timestamp === this._gamePadTimeStamps[i]) continue;
                this._gamePadTimeStamps[i] = gamepads[i].timestamp;
                // Add reference to navigator gamepad
                this.at(i).navigatorGamepad = gamepads[i];
                // Buttons
                let b, bi, a, ai, value;
                for(b in Buttons){
                    bi = Buttons[b];
                    if (typeof bi === "number") {
                        if (gamepads[i].buttons[bi]) {
                            value = gamepads[i].buttons[bi].value;
                            if (value !== this._oldPads[i].getButton(bi)) {
                                if (gamepads[i].buttons[bi].pressed) {
                                    this.at(i).updateButton(bi, value);
                                    this.at(i).events.emit("button", new GamepadButtonEvent(bi, value, this.at(i)));
                                } else this.at(i).updateButton(bi, 0);
                            }
                        }
                    }
                }
                // Axes
                for(a in Axes){
                    ai = Axes[a];
                    if (typeof ai === "number") {
                        value = gamepads[i].axes[ai];
                        if (value !== this._oldPads[i].getAxes(ai)) {
                            this.at(i).updateAxes(ai, value);
                            this.at(i).events.emit("axis", new GamepadAxisEvent(ai, value, this.at(i)));
                        }
                    }
                }
                this._oldPads[i] = this._clonePad(gamepads[i]);
            }
        }
        /**
     * Safely retrieves a Gamepad at a specific index and creates one if it doesn't yet exist
     */ at(index) {
            this._enableAndUpdate(); // implicitly enable gamepads when at() is called
            if (index >= this._pads.length) // Ensure there is a pad to retrieve
            for(let i = this._pads.length - 1, max = index; i < max; i++){
                this._pads.push(new Gamepad());
                this._oldPads.push(new Gamepad());
            }
            return this._pads[index];
        }
        /**
     * Returns a list of all valid gamepads that meet the minimum configuration requirement.
     */ getValidGamepads() {
            this._enableAndUpdate();
            const result = [];
            for(let i = 0; i < this._pads.length; i++)if (this._isGamepadValid(this.at(i).navigatorGamepad) && this.at(i).connected) result.push(this.at(i));
            return result;
        }
        /**
     * Gets the number of connected gamepads
     */ count() {
            return this._pads.filter((p)=>p.connected).length;
        }
        _clonePads(pads) {
            const arr = [];
            for(let i = 0, len = pads.length; i < len; i++)arr.push(this._clonePad(pads[i]));
            return arr;
        }
        /**
     * Fastest way to clone a known object is to do it yourself
     */ _clonePad(pad) {
            let i, len;
            const clonedPad = new Gamepad();
            if (!pad) return clonedPad;
            for(i = 0, len = pad.buttons.length; i < len; i++)if (pad.buttons[i]) clonedPad.updateButton(i, pad.buttons[i].value);
            for(i = 0, len = pad.axes.length; i < len; i++)clonedPad.updateAxes(i, pad.axes[i]);
            return clonedPad;
        }
    }
    /**
 * The minimum value an axis has to move before considering it a change
 */ Gamepads.MinAxisMoveThreshold = 0.05;
    /**
 * Gamepad holds state information for a connected controller. See [[Gamepads]]
 * for more information on handling controller input.
 */ class Gamepad {
        constructor(){
            this.events = new EventEmitter();
            this.connected = false;
            this._axes = new Array(4);
            this._buttons = new Array(16);
            this._buttonsUp = new Array(16);
            this._buttonsDown = new Array(16);
            for(let i = 0; i < this._buttons.length; i++)this._buttons[i] = 0;
            for(let i = 0; i < this._axes.length; i++)this._axes[i] = 0;
        }
        update() {
            // Reset buttonsDown and buttonsUp after update is complete
            this._buttonsDown = new Array(16);
            this._buttonsUp = new Array(16);
        }
        /**
     * Whether or not the given button is pressed
     * @deprecated will be removed in v0.28.0. Use isButtonHeld instead
     * @param button     The button to query
     * @param threshold  The threshold over which the button is considered to be pressed
     */ isButtonPressed(button, threshold = 1) {
            return this._buttons[button] >= threshold;
        }
        /**
     * Tests if a certain button is held down. This is persisted between frames.
     * @param button     The button to query
     * @param threshold  The threshold over which the button is considered to be pressed
     */ isButtonHeld(button, threshold = 1) {
            return this._buttons[button] >= threshold;
        }
        /**
     * Tests if a certain button was just pressed this frame. This is cleared at the end of the update frame.
     * @param button Test whether a button was just pressed
     * @param threshold  The threshold over which the button is considered to be pressed
     */ wasButtonPressed(button, threshold = 1) {
            return this._buttonsDown[button] >= threshold;
        }
        /**
     * Tests if a certain button was just released this frame. This is cleared at the end of the update frame.
     * @param button  Test whether a button was just released
     */ wasButtonReleased(button) {
            return Boolean(this._buttonsUp[button]);
        }
        /**
     * Gets the given button value between 0 and 1
     */ getButton(button) {
            return this._buttons[button];
        }
        /**
     * Gets the given axis value between -1 and 1. Values below
     * [[MinAxisMoveThreshold]] are considered 0.
     */ getAxes(axes) {
            const value = this._axes[axes];
            if (Math.abs(value) < Gamepads.MinAxisMoveThreshold) return 0;
            else return value;
        }
        updateButton(buttonIndex, value) {
            // button was just released
            if (value === 0 && this._buttons[buttonIndex]) this._buttonsUp[buttonIndex] = 1;
            else this._buttonsDown[buttonIndex] = value;
            this._buttons[buttonIndex] = value;
        }
        updateAxes(axesIndex, value) {
            this._axes[axesIndex] = value;
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
    }
    /**
 * Gamepad Buttons enumeration
 */ var Buttons;
    (function(Buttons) {
        /**
     * Face 1 button (e.g. A)
     */ Buttons[Buttons["Face1"] = 0] = "Face1";
        /**
     * Face 2 button (e.g. B)
     */ Buttons[Buttons["Face2"] = 1] = "Face2";
        /**
     * Face 3 button (e.g. X)
     */ Buttons[Buttons["Face3"] = 2] = "Face3";
        /**
     * Face 4 button (e.g. Y)
     */ Buttons[Buttons["Face4"] = 3] = "Face4";
        /**
     * Left bumper button
     */ Buttons[Buttons["LeftBumper"] = 4] = "LeftBumper";
        /**
     * Right bumper button
     */ Buttons[Buttons["RightBumper"] = 5] = "RightBumper";
        /**
     * Left trigger button
     */ Buttons[Buttons["LeftTrigger"] = 6] = "LeftTrigger";
        /**
     * Right trigger button
     */ Buttons[Buttons["RightTrigger"] = 7] = "RightTrigger";
        /**
     * Select button
     */ Buttons[Buttons["Select"] = 8] = "Select";
        /**
     * Start button
     */ Buttons[Buttons["Start"] = 9] = "Start";
        /**
     * Left analog stick press (e.g. L3)
     */ Buttons[Buttons["LeftStick"] = 10] = "LeftStick";
        /**
     * Right analog stick press (e.g. R3)
     */ Buttons[Buttons["RightStick"] = 11] = "RightStick";
        /**
     * D-pad up
     */ Buttons[Buttons["DpadUp"] = 12] = "DpadUp";
        /**
     * D-pad down
     */ Buttons[Buttons["DpadDown"] = 13] = "DpadDown";
        /**
     * D-pad left
     */ Buttons[Buttons["DpadLeft"] = 14] = "DpadLeft";
        /**
     * D-pad right
     */ Buttons[Buttons["DpadRight"] = 15] = "DpadRight";
    })(Buttons || (Buttons = {}));
    /**
 * Gamepad Axes enumeration
 */ var Axes;
    (function(Axes) {
        /**
     * Left analogue stick X direction
     */ Axes[Axes["LeftStickX"] = 0] = "LeftStickX";
        /**
     * Left analogue stick Y direction
     */ Axes[Axes["LeftStickY"] = 1] = "LeftStickY";
        /**
     * Right analogue stick X direction
     */ Axes[Axes["RightStickX"] = 2] = "RightStickX";
        /**
     * Right analogue stick Y direction
     */ Axes[Axes["RightStickY"] = 3] = "RightStickY";
    })(Axes || (Axes = {}));
    /**
 * This allows you to map multiple inputs to specific commands! This is especially useful when
 * you need to allow multiple input sources to control a specific action.
 */ class InputMapper {
        constructor(inputs){
            this.inputs = inputs;
            this._handlers = new Map();
        }
        /**
     * Executes the input map, called internally by Excalibur
     */ execute() {
            for (const [input, command] of this._handlers.entries()){
                const results = input(this.inputs);
                if (results) command(results);
            }
        }
        /**
     * This allows you to map multiple inputs to specific commands! This is useful
     *
     * The inputHandler should return a truthy value if you wish the commandHandler to fire.
     *
     * Example:
     * ```typescript
     * const moveRight = (amount: number) => { actor.vel.x = 100 * amount }
     * const moveLeft = (amount: number) => { actor.vel.x = -100 * amount }
     * const moveUp = (amount: number) => { actor.vel.y = -100 * amount }
     * const moveDown = (amount: number) => { actor.vel.y = 100 * amount }
     *
     * engine.inputMapper.on(({keyboard}) => keyboard.isHeld(ex.Keys.ArrowRight) ? 1 : 0, moveRight);
     * engine.inputMapper.on(({gamepads}) => gamepads.at(0).isButtonPressed(ex.Buttons.DpadRight) ? 1 : 0, moveRight);
     * engine.inputMapper.on(({gamepads}) => gamepads.at(0).getAxes(ex.Axes.LeftStickX) > 0 ?
     *  gamepads.at(0).getAxes(ex.Axes.LeftStickX) : 0, moveRight);
     * ```
     * @param inputHandler
     * @param commandHandler
     */ on(inputHandler, commandHandler) {
            this._handlers.set(inputHandler, commandHandler);
        }
    }
    /**
 * Checks if excalibur is in a x-origin iframe
 */ function isCrossOriginIframe() {
        try {
            // Try and listen to events on top window frame if within an iframe.
            //
            // See https://github.com/excaliburjs/Excalibur/issues/1294
            //
            // Attempt to add an event listener, which triggers a DOMException on
            // cross-origin iframes
            const noop = ()=>{
                return;
            };
            window.top.addEventListener("blur", noop);
            window.top.removeEventListener("blur", noop);
        } catch (_a) {
            return true;
        }
        return false;
    }
    /**
 * Enum representing physical input key codes
 */ var Keys;
    (function(Keys) {
        // NUMPAD
        Keys["Num0"] = "Numpad0";
        Keys["Num1"] = "Numpad1";
        Keys["Num2"] = "Numpad2";
        Keys["Num3"] = "Numpad3";
        Keys["Num4"] = "Numpad4";
        Keys["Num5"] = "Numpad5";
        Keys["Num6"] = "Numpad6";
        Keys["Num7"] = "Numpad7";
        Keys["Num8"] = "Numpad8";
        Keys["Num9"] = "Numpad9";
        Keys["NumAdd"] = "NumpadAdd";
        Keys["NumSubtract"] = "NumpadSubtract";
        Keys["NumMultiply"] = "NumpadMultiply";
        Keys["NumDivide"] = "NumpadDivide";
        // NumComma = 'NumpadComma', // not x-browser
        Keys["NumDecimal"] = "NumpadDecimal";
        Keys["Numpad0"] = "Numpad0";
        Keys["Numpad1"] = "Numpad1";
        Keys["Numpad2"] = "Numpad2";
        Keys["Numpad3"] = "Numpad3";
        Keys["Numpad4"] = "Numpad4";
        Keys["Numpad5"] = "Numpad5";
        Keys["Numpad6"] = "Numpad6";
        Keys["Numpad7"] = "Numpad7";
        Keys["Numpad8"] = "Numpad8";
        Keys["Numpad9"] = "Numpad9";
        Keys["NumpadAdd"] = "NumpadAdd";
        Keys["NumpadSubtract"] = "NumpadSubtract";
        Keys["NumpadMultiply"] = "NumpadMultiply";
        Keys["NumpadDivide"] = "NumpadDivide";
        // NumpadComma = 'NumpadComma', // not x-browser
        Keys["NumpadDecimal"] = "NumpadDecimal";
        // MODIFIERS
        Keys["NumLock"] = "NumLock";
        Keys["ShiftLeft"] = "ShiftLeft";
        Keys["ShiftRight"] = "ShiftRight";
        Keys["AltLeft"] = "AltLeft";
        Keys["AltRight"] = "AltRight";
        Keys["ControlLeft"] = "ControlLeft";
        Keys["ControlRight"] = "ControlRight";
        Keys["MetaLeft"] = "MetaLeft";
        Keys["MetaRight"] = "MetaRight";
        // NUMBERS
        Keys["Key0"] = "Digit0";
        Keys["Key1"] = "Digit1";
        Keys["Key2"] = "Digit2";
        Keys["Key3"] = "Digit3";
        Keys["Key4"] = "Digit4";
        Keys["Key5"] = "Digit5";
        Keys["Key6"] = "Digit6";
        Keys["Key7"] = "Digit7";
        Keys["Key8"] = "Digit8";
        Keys["Key9"] = "Digit9";
        Keys["Digit0"] = "Digit0";
        Keys["Digit1"] = "Digit1";
        Keys["Digit2"] = "Digit2";
        Keys["Digit3"] = "Digit3";
        Keys["Digit4"] = "Digit4";
        Keys["Digit5"] = "Digit5";
        Keys["Digit6"] = "Digit6";
        Keys["Digit7"] = "Digit7";
        Keys["Digit8"] = "Digit8";
        Keys["Digit9"] = "Digit9";
        // FUNCTION KEYS
        Keys["F1"] = "F1";
        Keys["F2"] = "F2";
        Keys["F3"] = "F3";
        Keys["F4"] = "F4";
        Keys["F5"] = "F5";
        Keys["F6"] = "F6";
        Keys["F7"] = "F7";
        Keys["F8"] = "F8";
        Keys["F9"] = "F9";
        Keys["F10"] = "F10";
        Keys["F11"] = "F11";
        Keys["F12"] = "F12";
        // LETTERS
        Keys["A"] = "KeyA";
        Keys["B"] = "KeyB";
        Keys["C"] = "KeyC";
        Keys["D"] = "KeyD";
        Keys["E"] = "KeyE";
        Keys["F"] = "KeyF";
        Keys["G"] = "KeyG";
        Keys["H"] = "KeyH";
        Keys["I"] = "KeyI";
        Keys["J"] = "KeyJ";
        Keys["K"] = "KeyK";
        Keys["L"] = "KeyL";
        Keys["M"] = "KeyM";
        Keys["N"] = "KeyN";
        Keys["O"] = "KeyO";
        Keys["P"] = "KeyP";
        Keys["Q"] = "KeyQ";
        Keys["R"] = "KeyR";
        Keys["S"] = "KeyS";
        Keys["T"] = "KeyT";
        Keys["U"] = "KeyU";
        Keys["V"] = "KeyV";
        Keys["W"] = "KeyW";
        Keys["X"] = "KeyX";
        Keys["Y"] = "KeyY";
        Keys["Z"] = "KeyZ";
        Keys["KeyA"] = "KeyA";
        Keys["KeyB"] = "KeyB";
        Keys["KeyC"] = "KeyC";
        Keys["KeyD"] = "KeyD";
        Keys["KeyE"] = "KeyE";
        Keys["KeyF"] = "KeyF";
        Keys["KeyG"] = "KeyG";
        Keys["KeyH"] = "KeyH";
        Keys["KeyI"] = "KeyI";
        Keys["KeyJ"] = "KeyJ";
        Keys["KeyK"] = "KeyK";
        Keys["KeyL"] = "KeyL";
        Keys["KeyM"] = "KeyM";
        Keys["KeyN"] = "KeyN";
        Keys["KeyO"] = "KeyO";
        Keys["KeyP"] = "KeyP";
        Keys["KeyQ"] = "KeyQ";
        Keys["KeyR"] = "KeyR";
        Keys["KeyS"] = "KeyS";
        Keys["KeyT"] = "KeyT";
        Keys["KeyU"] = "KeyU";
        Keys["KeyV"] = "KeyV";
        Keys["KeyW"] = "KeyW";
        Keys["KeyX"] = "KeyX";
        Keys["KeyY"] = "KeyY";
        Keys["KeyZ"] = "KeyZ";
        // SYMBOLS
        Keys["Semicolon"] = "Semicolon";
        Keys["Quote"] = "Quote";
        Keys["Comma"] = "Comma";
        Keys["Minus"] = "Minus";
        Keys["Period"] = "Period";
        Keys["Slash"] = "Slash";
        Keys["Equal"] = "Equal";
        Keys["BracketLeft"] = "BracketLeft";
        Keys["Backslash"] = "Backslash";
        Keys["BracketRight"] = "BracketRight";
        Keys["Backquote"] = "Backquote";
        // DIRECTIONS
        Keys["Up"] = "ArrowUp";
        Keys["Down"] = "ArrowDown";
        Keys["Left"] = "ArrowLeft";
        Keys["Right"] = "ArrowRight";
        Keys["ArrowUp"] = "ArrowUp";
        Keys["ArrowDown"] = "ArrowDown";
        Keys["ArrowLeft"] = "ArrowLeft";
        Keys["ArrowRight"] = "ArrowRight";
        // OTHER
        Keys["Space"] = "Space";
        Keys["Backspace"] = "Backspace";
        Keys["Delete"] = "Delete";
        Keys["Esc"] = "Escape";
        Keys["Escape"] = "Escape";
        Keys["Enter"] = "Enter";
        Keys["NumpadEnter"] = "NumpadEnter";
        Keys["ContextMenu"] = "ContextMenu";
    })(Keys || (Keys = {}));
    /**
 * Event thrown on a game object for a key event
 */ class KeyEvent extends GameEvent {
        /**
     * @param key  The key responsible for throwing the event
     * @param value The key's typed value the browser detected
     * @param originalEvent The original keyboard event that Excalibur handled
     */ constructor(key, value, originalEvent){
            super();
            this.key = key;
            this.value = value;
            this.originalEvent = originalEvent;
        }
    }
    const KeyEvents = {
        Press: "press",
        Hold: "hold",
        Release: "release"
    };
    /**
 * Provides keyboard support for Excalibur.
 */ class Keyboard {
        constructor(){
            this.events = new EventEmitter();
            this._enabled = true;
            /**
         * Keys that are currently held down
         */ this._keys = [];
            /**
         * Keys up in the current frame
         */ this._keysUp = [];
            /**
         * Keys down in the current frame
         */ this._keysDown = [];
            this._releaseAllKeys = (ev)=>{
                for (const code of this._keys){
                    const keyEvent = new KeyEvent(code, ev.key, ev);
                    this.events.emit("up", keyEvent);
                    this.events.emit("release", keyEvent);
                }
                this._keysUp = Array.from(new Set(this._keys.concat(this._keysUp)));
                this._keys.length = 0;
            };
            this._handleKeyDown = (ev)=>{
                if (!this._enabled) return;
                // handle macos meta key issue
                // https://github.com/excaliburjs/Excalibur/issues/2608
                if (!ev.metaKey && (this._keys.includes(Keys.MetaLeft) || this._keys.includes(Keys.MetaRight))) this._releaseAllKeys(ev);
                const code = ev.code;
                if (this._keys.indexOf(code) === -1) {
                    this._keys.push(code);
                    this._keysDown.push(code);
                    const keyEvent = new KeyEvent(code, ev.key, ev);
                    this.events.emit("down", keyEvent);
                    this.events.emit("press", keyEvent);
                }
            };
            this._handleKeyUp = (ev)=>{
                if (!this._enabled) return;
                const code = ev.code;
                const key = this._keys.indexOf(code);
                this._keys.splice(key, 1);
                this._keysUp.push(code);
                const keyEvent = new KeyEvent(code, ev.key, ev);
                // alias the old api, we may want to deprecate this in the future
                this.events.emit("up", keyEvent);
                this.events.emit("release", keyEvent);
                // handle macos meta key issue
                // https://github.com/excaliburjs/Excalibur/issues/2608
                if (ev.key === "Meta") this._releaseAllKeys(ev);
            };
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        /**
     * Initialize Keyboard event listeners
     */ init(keyboardOptions) {
            let { global: global } = keyboardOptions;
            const { grabWindowFocus: grabWindowFocus } = keyboardOptions;
            if (!global) {
                if (isCrossOriginIframe()) {
                    global = window;
                    // Workaround for iframes like for itch.io or codesandbox
                    // https://www.reddit.com/r/gamemaker/comments/kfs5cs/keyboard_inputs_no_longer_working_in_html5_game/
                    // https://forum.gamemaker.io/index.php?threads/solved-keyboard-issue-on-itch-io.87336/
                    if (grabWindowFocus) window.focus();
                    Logger.getInstance().warn("Excalibur might be in a cross-origin iframe, in order to receive keyboard events it must be in focus");
                } else global = window.top;
            }
            global.addEventListener("blur", ()=>{
                this._keys.length = 0; // empties array efficiently
            });
            // key up is on window because canvas cannot have focus
            global.addEventListener("keyup", this._handleKeyUp);
            // key down is on window because canvas cannot have focus
            global.addEventListener("keydown", this._handleKeyDown);
        }
        toggleEnabled(enabled) {
            this._enabled = enabled;
        }
        update() {
            // Reset keysDown and keysUp after update is complete
            this._keysDown.length = 0;
            this._keysUp.length = 0;
            // Emit synthetic "hold" event
            for(let i = 0; i < this._keys.length; i++)this.events.emit("hold", new KeyEvent(this._keys[i]));
        }
        /**
     * Gets list of keys being pressed down
     */ getKeys() {
            return this._keys;
        }
        /**
     * Tests if a certain key was just pressed this frame. This is cleared at the end of the update frame.
     * @param key Test whether a key was just pressed
     */ wasPressed(key) {
            return this._keysDown.indexOf(key) > -1;
        }
        /**
     * Tests if a certain key is held down. This is persisted between frames.
     * @param key  Test whether a key is held down
     */ isHeld(key) {
            return this._keys.indexOf(key) > -1;
        }
        /**
     * Tests if a certain key was just released this frame. This is cleared at the end of the update frame.
     * @param key  Test whether a key was just released
     */ wasReleased(key) {
            return this._keysUp.indexOf(key) > -1;
        }
        /**
     * Trigger a manual key event
     * @param type
     * @param key
     * @param character
     */ triggerEvent(type, key, character) {
            if (type === "down") this._handleKeyDown(new KeyboardEvent("keydown", {
                code: key,
                key: character !== null && character !== void 0 ? character : null
            }));
            if (type === "up") this._handleKeyUp(new KeyboardEvent("keyup", {
                code: key,
                key: character !== null && character !== void 0 ? character : null
            }));
        }
    }
    class GlobalCoordinates {
        static fromPagePosition(xOrPos, yOrEngine, engineOrUndefined) {
            let pageX;
            let pageY;
            let pagePos;
            let engine;
            if (arguments.length === 3) {
                pageX = xOrPos;
                pageY = yOrEngine;
                pagePos = new Vector(pageX, pageY);
                engine = engineOrUndefined;
            } else {
                pagePos = xOrPos;
                pageX = pagePos.x;
                pageY = pagePos.y;
                engine = yOrEngine;
            }
            const screenPos = engine.screen.pageToScreenCoordinates(pagePos);
            const worldPos = engine.screen.screenToWorldCoordinates(screenPos);
            return new GlobalCoordinates(worldPos, pagePos, screenPos);
        }
        constructor(worldPos, pagePos, screenPos){
            this.worldPos = worldPos;
            this.pagePos = pagePos;
            this.screenPos = screenPos;
        }
    }
    class PointerEvent {
        cancel() {
            this.active = false;
        }
        get pagePos() {
            return this.coordinates.pagePos;
        }
        get screenPos() {
            return this.coordinates.screenPos;
        }
        get worldPos() {
            return this.coordinates.worldPos;
        }
        constructor(type, pointerId, button, pointerType, coordinates, nativeEvent){
            this.type = type;
            this.pointerId = pointerId;
            this.button = button;
            this.pointerType = pointerType;
            this.coordinates = coordinates;
            this.nativeEvent = nativeEvent;
            this.active = true;
        }
    }
    class WheelEvent {
        cancel() {
            this.active = false;
        }
        constructor(x, y, pageX, pageY, screenX, screenY, index, deltaX, deltaY, deltaZ, deltaMode, ev){
            this.x = x;
            this.y = y;
            this.pageX = pageX;
            this.pageY = pageY;
            this.screenX = screenX;
            this.screenY = screenY;
            this.index = index;
            this.deltaX = deltaX;
            this.deltaY = deltaY;
            this.deltaZ = deltaZ;
            this.deltaMode = deltaMode;
            this.ev = ev;
            this.active = true;
        }
    }
    class PointerAbstraction {
        constructor(){
            this.events = new EventEmitter();
            /**
         * The last position on the document this pointer was at. Can be `null` if pointer was never active.
         */ this.lastPagePos = Vector.Zero;
            /**
         * The last position on the screen this pointer was at. Can be `null` if pointer was never active.
         */ this.lastScreenPos = Vector.Zero;
            /**
         * The last position in the game world coordinates this pointer was at. Can be `null` if pointer was never active.
         */ this.lastWorldPos = Vector.Zero;
            this._onPointerMove = (ev)=>{
                this.lastPagePos = new Vector(ev.pagePos.x, ev.pagePos.y);
                this.lastScreenPos = new Vector(ev.screenPos.x, ev.screenPos.y);
                this.lastWorldPos = new Vector(ev.worldPos.x, ev.worldPos.y);
            };
            this._onPointerDown = (ev)=>{
                this.lastPagePos = new Vector(ev.pagePos.x, ev.pagePos.y);
                this.lastScreenPos = new Vector(ev.screenPos.x, ev.screenPos.y);
                this.lastWorldPos = new Vector(ev.worldPos.x, ev.worldPos.y);
            };
            this.on("move", this._onPointerMove);
            this.on("down", this._onPointerDown);
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
    }
    var WheelDeltaMode;
    (function(WheelDeltaMode) {
        WheelDeltaMode["Pixel"] = "Pixel";
        WheelDeltaMode["Line"] = "Line";
        WheelDeltaMode["Page"] = "Page";
    })(WheelDeltaMode || (WheelDeltaMode = {}));
    /**
 * Native browser button enumeration
 */ var NativePointerButton;
    (function(NativePointerButton) {
        NativePointerButton[NativePointerButton["NoButton"] = -1] = "NoButton";
        NativePointerButton[NativePointerButton["Left"] = 0] = "Left";
        NativePointerButton[NativePointerButton["Middle"] = 1] = "Middle";
        NativePointerButton[NativePointerButton["Right"] = 2] = "Right";
        NativePointerButton[NativePointerButton["Unknown"] = 3] = "Unknown";
    })(NativePointerButton || (NativePointerButton = {}));
    /**
 * The mouse button being pressed.
 */ var PointerButton;
    (function(PointerButton) {
        PointerButton["Left"] = "Left";
        PointerButton["Middle"] = "Middle";
        PointerButton["Right"] = "Right";
        PointerButton["Unknown"] = "Unknown";
        PointerButton["NoButton"] = "NoButton";
    })(PointerButton || (PointerButton = {}));
    /**
 * The type of pointer for a [[PointerEvent]].
 */ var PointerType;
    (function(PointerType) {
        PointerType["Touch"] = "Touch";
        PointerType["Mouse"] = "Mouse";
        PointerType["Pen"] = "Pen";
        PointerType["Unknown"] = "Unknown";
    })(PointerType || (PointerType = {}));
    const PointerEvents = {
        Move: "move",
        Down: "down",
        Up: "up",
        Wheel: "wheel"
    };
    /**
 * Is this event a native touch event?
 */ function isTouchEvent(value) {
        // Guard for Safari <= 13.1
        return globalThis.TouchEvent && value instanceof globalThis.TouchEvent;
    }
    /**
 * Is this event a native pointer event
 */ function isPointerEvent(value) {
        // Guard for Safari <= 13.1
        return globalThis.PointerEvent && value instanceof globalThis.PointerEvent;
    }
    /**
 * The PointerEventProcessor is responsible for collecting all the events from the canvas and transforming them into GlobalCoordinates
 */ class PointerEventReceiver {
        constructor(target, engine){
            this.target = target;
            this.engine = engine;
            this.events = new EventEmitter();
            this.primary = new PointerAbstraction();
            this._activeNativePointerIdsToNormalized = new Map();
            this.lastFramePointerCoords = new Map();
            this.currentFramePointerCoords = new Map();
            this.currentFramePointerDown = new Map();
            this.lastFramePointerDown = new Map();
            this.currentFrameDown = [];
            this.currentFrameUp = [];
            this.currentFrameMove = [];
            this.currentFrameCancel = [];
            this.currentFrameWheel = [];
            this._enabled = true;
            this._pointers = [
                this.primary
            ];
            this._boundHandle = this._handle.bind(this);
            this._boundWheel = this._handleWheel.bind(this);
        }
        toggleEnabled(enabled) {
            this._enabled = enabled;
        }
        /**
     * Creates a new PointerEventReceiver with a new target and engine while preserving existing pointer event
     * handlers.
     * @param target
     * @param engine
     */ recreate(target, engine) {
            const eventReceiver = new PointerEventReceiver(target, engine);
            eventReceiver.primary = this.primary;
            eventReceiver._pointers = this._pointers;
            return eventReceiver;
        }
        /**
     * Locates a specific pointer by id, creates it if it doesn't exist
     * @param index
     */ at(index) {
            if (index >= this._pointers.length) // Ensure there is a pointer to retrieve
            for(let i = this._pointers.length - 1, max = index; i < max; i++)this._pointers.push(new PointerAbstraction());
            return this._pointers[index];
        }
        /**
     * The number of pointers currently being tracked by excalibur
     */ count() {
            return this._pointers.length;
        }
        /**
     * Is the specified pointer id down this frame
     * @param pointerId
     */ isDown(pointerId) {
            var _a;
            return (_a = this.currentFramePointerDown.get(pointerId)) !== null && _a !== void 0 ? _a : false;
        }
        /**
     * Was the specified pointer id down last frame
     * @param pointerId
     */ wasDown(pointerId) {
            var _a;
            return (_a = this.lastFramePointerDown.get(pointerId)) !== null && _a !== void 0 ? _a : false;
        }
        /**
     * Whether the Pointer is currently dragging.
     */ isDragging(pointerId) {
            return this.isDown(pointerId);
        }
        /**
     * Whether the Pointer just started dragging.
     */ isDragStart(pointerId) {
            return this.isDown(pointerId) && !this.wasDown(pointerId);
        }
        /**
     * Whether the Pointer just ended dragging.
     */ isDragEnd(pointerId) {
            return !this.isDown(pointerId) && this.wasDown(pointerId);
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        /**
     * Called internally by excalibur
     *
     * Updates the current frame pointer info and emits raw pointer events
     *
     * This does not emit events to entities, see PointerSystem
     */ update() {
            this.lastFramePointerDown = new Map(this.currentFramePointerDown);
            this.lastFramePointerCoords = new Map(this.currentFramePointerCoords);
            for (const event of this.currentFrameDown){
                this.emit("down", event);
                const pointer = this.at(event.pointerId);
                pointer.emit("down", event);
                this.primary.emit("pointerdown", event);
            }
            for (const event of this.currentFrameUp){
                this.emit("up", event);
                const pointer = this.at(event.pointerId);
                pointer.emit("up", event);
            }
            for (const event of this.currentFrameMove){
                this.emit("move", event);
                const pointer = this.at(event.pointerId);
                pointer.emit("move", event);
            }
            for (const event of this.currentFrameCancel){
                this.emit("cancel", event);
                const pointer = this.at(event.pointerId);
                pointer.emit("cancel", event);
            }
            for (const event of this.currentFrameWheel){
                this.emit("wheel", event);
                this.primary.emit("pointerwheel", event);
                this.primary.emit("wheel", event);
            }
        }
        /**
     * Clears the current frame event and pointer data
     */ clear() {
            for (const event of this.currentFrameUp){
                this.currentFramePointerCoords.delete(event.pointerId);
                const ids = this._activeNativePointerIdsToNormalized.entries();
                for (const [native, normalized] of ids)if (normalized === event.pointerId) this._activeNativePointerIdsToNormalized.delete(native);
            }
            this.currentFrameDown.length = 0;
            this.currentFrameUp.length = 0;
            this.currentFrameMove.length = 0;
            this.currentFrameCancel.length = 0;
            this.currentFrameWheel.length = 0;
        }
        /**
     * Initializes the pointer event receiver so that it can start listening to native
     * browser events.
     */ init(options) {
            var _a;
            if (this.engine.isDisposed()) return;
            // Disabling the touch action avoids browser/platform gestures from firing on the canvas
            // It is important on mobile to have touch action 'none'
            // https://stackoverflow.com/questions/48124372/pointermove-event-not-working-with-touch-why-not
            if (this.target === this.engine.canvas) this.engine.canvas.style.touchAction = "none";
            else document.body.style.touchAction = "none";
            // Preferred pointer events
            if (window.PointerEvent) {
                this.target.addEventListener("pointerdown", this._boundHandle);
                this.target.addEventListener("pointerup", this._boundHandle);
                this.target.addEventListener("pointermove", this._boundHandle);
                this.target.addEventListener("pointercancel", this._boundHandle);
            } else {
                // Touch Events
                this.target.addEventListener("touchstart", this._boundHandle);
                this.target.addEventListener("touchend", this._boundHandle);
                this.target.addEventListener("touchmove", this._boundHandle);
                this.target.addEventListener("touchcancel", this._boundHandle);
                // Mouse Events
                this.target.addEventListener("mousedown", this._boundHandle);
                this.target.addEventListener("mouseup", this._boundHandle);
                this.target.addEventListener("mousemove", this._boundHandle);
            }
            // MDN MouseWheelEvent
            const wheelOptions = {
                passive: !(this.engine.pageScrollPreventionMode === ScrollPreventionMode.All || this.engine.pageScrollPreventionMode === ScrollPreventionMode.Canvas)
            };
            if ("onwheel" in document.createElement("div")) // Modern Browsers
            this.target.addEventListener("wheel", this._boundWheel, wheelOptions);
            else if (document.onmousewheel !== undefined) // Webkit and IE
            this.target.addEventListener("mousewheel", this._boundWheel, wheelOptions);
            else // Remaining browser and older Firefox
            this.target.addEventListener("MozMousePixelScroll", this._boundWheel, wheelOptions);
            const grabWindowFocus = (_a = options === null || options === void 0 ? void 0 : options.grabWindowFocus) !== null && _a !== void 0 ? _a : true;
            // Handle cross origin iframe
            if (grabWindowFocus && isCrossOriginIframe()) {
                const grabFocus = ()=>{
                    window.focus();
                };
                // Preferred pointer events
                if (window.PointerEvent) this.target.addEventListener("pointerdown", grabFocus);
                else {
                    // Touch Events
                    this.target.addEventListener("touchstart", grabFocus);
                    // Mouse Events
                    this.target.addEventListener("mousedown", grabFocus);
                }
            }
        }
        detach() {
            // Preferred pointer events
            if (window.PointerEvent) {
                this.target.removeEventListener("pointerdown", this._boundHandle);
                this.target.removeEventListener("pointerup", this._boundHandle);
                this.target.removeEventListener("pointermove", this._boundHandle);
                this.target.removeEventListener("pointercancel", this._boundHandle);
            } else {
                // Touch Events
                this.target.removeEventListener("touchstart", this._boundHandle);
                this.target.removeEventListener("touchend", this._boundHandle);
                this.target.removeEventListener("touchmove", this._boundHandle);
                this.target.removeEventListener("touchcancel", this._boundHandle);
                // Mouse Events
                this.target.removeEventListener("mousedown", this._boundHandle);
                this.target.removeEventListener("mouseup", this._boundHandle);
                this.target.removeEventListener("mousemove", this._boundHandle);
            }
            if ("onwheel" in document.createElement("div")) // Modern Browsers
            this.target.removeEventListener("wheel", this._boundWheel);
            else if (document.onmousewheel !== undefined) // Webkit and IE
            this.target.addEventListener("mousewheel", this._boundWheel);
            else // Remaining browser and older Firefox
            this.target.addEventListener("MozMousePixelScroll", this._boundWheel);
        }
        /**
     * Take native pointer id and map it to index in active pointers
     * @param nativePointerId
     */ _normalizePointerId(nativePointerId) {
            // Add to the the native pointer set id
            this._activeNativePointerIdsToNormalized.set(nativePointerId, -1);
            // Native pointer ids in ascending order
            const currentPointerIds = Array.from(this._activeNativePointerIdsToNormalized.keys()).sort((a, b)=>a - b);
            // The index into sorted ids will be the new id, will always have an id
            const id = currentPointerIds.findIndex((p)=>p === nativePointerId);
            // Save the mapping so we can reverse it later
            this._activeNativePointerIdsToNormalized.set(nativePointerId, id);
            // ignore pointer because game isn't watching
            return id;
        }
        /**
     * Responsible for handling and parsing pointer events
     */ _handle(ev) {
            if (!this._enabled) return;
            ev.preventDefault();
            const eventCoords = new Map();
            let button;
            let pointerType;
            if (isTouchEvent(ev)) {
                button = PointerButton.Unknown;
                pointerType = PointerType.Touch;
                // https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
                for(let i = 0; i < ev.changedTouches.length; i++){
                    const touch = ev.changedTouches[i];
                    const coordinates = GlobalCoordinates.fromPagePosition(touch.pageX, touch.pageY, this.engine);
                    const nativePointerId = i + 1;
                    const pointerId = this._normalizePointerId(nativePointerId);
                    this.currentFramePointerCoords.set(pointerId, coordinates);
                    eventCoords.set(pointerId, coordinates);
                }
            } else {
                button = this._nativeButtonToPointerButton(ev.button);
                pointerType = PointerType.Mouse;
                const coordinates = GlobalCoordinates.fromPagePosition(ev.pageX, ev.pageY, this.engine);
                let nativePointerId = 1;
                if (isPointerEvent(ev)) {
                    nativePointerId = ev.pointerId;
                    pointerType = this._stringToPointerType(ev.pointerType);
                }
                const pointerId = this._normalizePointerId(nativePointerId);
                this.currentFramePointerCoords.set(pointerId, coordinates);
                eventCoords.set(pointerId, coordinates);
            }
            for (const [pointerId, coord] of eventCoords.entries())switch(ev.type){
                case "mousedown":
                case "pointerdown":
                case "touchstart":
                    this.currentFrameDown.push(new PointerEvent("down", pointerId, button, pointerType, coord, ev));
                    this.currentFramePointerDown.set(pointerId, true);
                    break;
                case "mouseup":
                case "pointerup":
                case "touchend":
                    this.currentFrameUp.push(new PointerEvent("up", pointerId, button, pointerType, coord, ev));
                    this.currentFramePointerDown.set(pointerId, false);
                    break;
                case "mousemove":
                case "pointermove":
                case "touchmove":
                    this.currentFrameMove.push(new PointerEvent("move", pointerId, button, pointerType, coord, ev));
                    break;
                case "touchcancel":
                case "pointercancel":
                    this.currentFrameCancel.push(new PointerEvent("cancel", pointerId, button, pointerType, coord, ev));
                    break;
            }
        }
        _handleWheel(ev) {
            if (!this._enabled) return;
            // Should we prevent page scroll because of this event
            if (this.engine.pageScrollPreventionMode === ScrollPreventionMode.All || this.engine.pageScrollPreventionMode === ScrollPreventionMode.Canvas && ev.target === this.engine.canvas) ev.preventDefault();
            const screen = this.engine.screen.pageToScreenCoordinates(vec(ev.pageX, ev.pageY));
            const world = this.engine.screen.screenToWorldCoordinates(screen);
            /**
         * A constant used to normalize wheel events across different browsers
         *
         * This normalization factor is pulled from
         * https://developer.mozilla.org/en-US/docs/Web/Events/wheel#Listening_to_this_event_across_browser
         */ const ScrollWheelNormalizationFactor = -1 / 40;
            const deltaX = ev.deltaX || ev.wheelDeltaX * ScrollWheelNormalizationFactor || 0;
            const deltaY = ev.deltaY || ev.wheelDeltaY * ScrollWheelNormalizationFactor || ev.wheelDelta * ScrollWheelNormalizationFactor || ev.detail || 0;
            const deltaZ = ev.deltaZ || 0;
            let deltaMode = WheelDeltaMode.Pixel;
            if (ev.deltaMode) {
                if (ev.deltaMode === 1) deltaMode = WheelDeltaMode.Line;
                else if (ev.deltaMode === 2) deltaMode = WheelDeltaMode.Page;
            }
            const we = new WheelEvent(world.x, world.y, ev.pageX, ev.pageY, screen.x, screen.y, 0, deltaX, deltaY, deltaZ, deltaMode, ev);
            this.currentFrameWheel.push(we);
        }
        /**
     * Triggers an excalibur pointer event in a world space pos
     *
     * Useful for testing pointers in excalibur
     * @param type
     * @param pos
     */ triggerEvent(type, pos) {
            const page = this.engine.screen.worldToPageCoordinates(pos);
            // Send an event to the event receiver
            if (window.PointerEvent) this._handle(new window.PointerEvent("pointer" + type, {
                pointerId: 0,
                clientX: page.x,
                clientY: page.y
            }));
            else // Safari hack
            this._handle(new window.MouseEvent("mouse" + type, {
                clientX: page.x,
                clientY: page.y
            }));
            // Force update pointer system
            const pointerSystem = this.engine.currentScene.world.get(PointerSystem);
            pointerSystem.preupdate(this.engine.currentScene, 1);
            pointerSystem.update(1);
        }
        _nativeButtonToPointerButton(s) {
            switch(s){
                case NativePointerButton.NoButton:
                    return PointerButton.NoButton;
                case NativePointerButton.Left:
                    return PointerButton.Left;
                case NativePointerButton.Middle:
                    return PointerButton.Middle;
                case NativePointerButton.Right:
                    return PointerButton.Right;
                case NativePointerButton.Unknown:
                    return PointerButton.Unknown;
                default:
                    return fail(s);
            }
        }
        _stringToPointerType(s) {
            switch(s){
                case "touch":
                    return PointerType.Touch;
                case "mouse":
                    return PointerType.Mouse;
                case "pen":
                    return PointerType.Pen;
                default:
                    return PointerType.Unknown;
            }
        }
    }
    class InputHost {
        constructor(options){
            this._enabled = true;
            const { pointerTarget: pointerTarget, grabWindowFocus: grabWindowFocus, engine: engine } = options;
            this.keyboard = new Keyboard();
            this.pointers = new PointerEventReceiver(pointerTarget, engine);
            this.gamepads = new Gamepads();
            this.keyboard.init({
                grabWindowFocus: grabWindowFocus
            });
            this.pointers.init({
                grabWindowFocus: grabWindowFocus
            });
            this.gamepads.init();
            this.inputMapper = new InputMapper({
                keyboard: this.keyboard,
                pointers: this.pointers,
                gamepads: this.gamepads
            });
        }
        get enabled() {
            return this._enabled;
        }
        toggleEnabled(enabled) {
            this._enabled = enabled;
            this.keyboard.toggleEnabled(this._enabled);
            this.pointers.toggleEnabled(this._enabled);
            this.gamepads.toggleEnabled(this._enabled);
        }
        update() {
            if (this._enabled) {
                this.inputMapper.execute();
                this.keyboard.update();
                this.gamepads.update();
            }
        }
    }
    class PreLoadEvent {
    }
    const SceneEvents = {
        Initialize: "initialize",
        Activate: "activate",
        Deactivate: "deactivate",
        PreUpdate: "preupdate",
        PostUpdate: "postupdate",
        PreDraw: "predraw",
        PostDraw: "postdraw",
        PreDebugDraw: "predebugdraw",
        PostDebugDraw: "postdebugdraw",
        PreLoad: "preload"
    };
    /**
 *
 */ function isSceneConstructor(x) {
        var _a, _b;
        return !!(x === null || x === void 0 ? void 0 : x.prototype) && !!((_b = (_a = x === null || x === void 0 ? void 0 : x.prototype) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name);
    }
    /**
 * [[Actor|Actors]] are composed together into groupings called Scenes in
 * Excalibur. The metaphor models the same idea behind real world
 * actors in a scene. Only actors in scenes will be updated and drawn.
 *
 * Typical usages of a scene include: levels, menus, loading screens, etc.
 */ class Scene {
        /**
     * The actors in the current scene
     */ get actors() {
            return this.world.entityManager.entities.filter((e)=>{
                return e instanceof Actor;
            });
        }
        /**
     * The entities in the current scene
     */ get entities() {
            return this.world.entityManager.entities;
        }
        /**
     * The triggers in the current scene
     */ get triggers() {
            return this.world.entityManager.entities.filter((e)=>{
                return e instanceof Trigger;
            });
        }
        /**
     * The [[TileMap]]s in the scene, if any
     */ get tileMaps() {
            return this.world.entityManager.entities.filter((e)=>{
                return e instanceof TileMap;
            });
        }
        get timers() {
            return this._timers;
        }
        constructor(){
            // Initialize systems
            this._logger = Logger.getInstance();
            this.events = new EventEmitter();
            /**
         * Gets or sets the current camera for the scene
         */ this.camera = new Camera();
            /**
         * The ECS world for the scene
         */ this.world = new World(this);
            /**
         * The Excalibur physics world for the scene. Used to interact
         * with colliders included in the scene.
         *
         * Can be used to perform scene ray casts, track colliders, broadphase, and narrowphase.
         */ this.physics = new PhysicsWorld(DefaultPhysicsConfig);
            this._isInitialized = false;
            this._timers = [];
            this._cancelQueue = [];
            // Update
            this.world.add(ActionsSystem);
            this.world.add(new MotionSystem(this.world, this.physics));
            this.world.add(new CollisionSystem(this.world, this.physics));
            this.world.add(PointerSystem);
            this.world.add(IsometricEntitySystem);
            // Draw
            this.world.add(OffscreenSystem);
            this.world.add(GraphicsSystem);
            this.world.add(DebugSystem);
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        /**
     * Event hook to provide Scenes a way of loading scene specific resources.
     *
     * This is called before the Scene.onInitialize during scene transition. It will only ever fire once for a scene.
     * @param loader
     */ onPreLoad(loader) {
        // will be overridden
        }
        /**
     * Event hook fired directly before transition, either "in" or "out" of the scene
     *
     * This overrides the Engine scene definition. However transitions specified in goToScene take highest precedence
     *
     * ```typescript
     * // Overrides all
     * Engine.goToScene('scene', { destinationIn: ..., sourceOut: ... });
     * ```
     *
     * This can be used to configure custom transitions for a scene dynamically
     */ onTransition(direction) {
            // will be overridden
            return undefined;
        }
        /**
     * This is called before the first update of the [[Scene]]. Initializes scene members like the camera. This method is meant to be
     * overridden. This is where initialization of child actors should take place.
     */ onInitialize(engine) {
        // will be overridden
        }
        /**
     * This is called when the scene is made active and started. It is meant to be overridden,
     * this is where you should setup any DOM UI or event handlers needed for the scene.
     */ onActivate(context) {
        // will be overridden
        }
        /**
     * This is called when the scene is made transitioned away from and stopped. It is meant to be overridden,
     * this is where you should cleanup any DOM UI or event handlers needed for the scene.
     */ onDeactivate(context) {
        // will be overridden
        }
        /**
     * Safe to override onPreUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPreUpdate` is called directly before a scene is updated.
     */ onPreUpdate(engine, delta) {
        // will be overridden
        }
        /**
     * Safe to override onPostUpdate lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPostUpdate` is called directly after a scene is updated.
     */ onPostUpdate(engine, delta) {
        // will be overridden
        }
        /**
     * Safe to override onPreDraw lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPreDraw` is called directly before a scene is drawn.
     *
     */ onPreDraw(ctx, delta) {
        // will be overridden
        }
        /**
     * Safe to override onPostDraw lifecycle event handler. Synonymous with `.on('preupdate', (evt) =>{...})`
     *
     * `onPostDraw` is called directly after a scene is drawn.
     *
     */ onPostDraw(ctx, delta) {
        // will be overridden
        }
        /**
     * Initializes actors in the scene
     */ _initializeChildren() {
            for (const child of this.entities)child._initialize(this.engine);
        }
        /**
     * Gets whether or not the [[Scene]] has been initialized
     */ get isInitialized() {
            return this._isInitialized;
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Initializes the scene before the first update, meant to be called by engine not by users of
     * Excalibur
     * @internal
     */ async _initialize(engine) {
            var _a;
            if (!this.isInitialized) {
                try {
                    this.engine = engine;
                    // PhysicsWorld config is watched so things will automagically update
                    this.physics.config = this.engine.physics;
                    this.input = new InputHost({
                        pointerTarget: engine.pointerScope === PointerScope.Canvas ? engine.canvas : document,
                        grabWindowFocus: engine.grabWindowFocus,
                        engine: engine
                    });
                    // Initialize camera first
                    this.camera._initialize(engine);
                    this.world.systemManager.initialize();
                    // This order is important! we want to be sure any custom init that add actors
                    // fire before the actor init
                    await this.onInitialize(engine);
                    this._initializeChildren();
                    this._logger.debug("Scene.onInitialize", this, engine);
                    this.events.emit("initialize", new InitializeEvent(engine, this));
                } catch (e) {
                    this._logger.error(`Error during scene initialization for scene ${(_a = engine.director) === null || _a === void 0 ? void 0 : _a.getSceneName(this)}!`);
                    throw e;
                }
                this._isInitialized = true;
            }
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Activates the scene with the base behavior, then calls the overridable `onActivate` implementation.
     * @internal
     */ async _activate(context) {
            var _a, _b;
            try {
                this._logger.debug("Scene.onActivate", this);
                this.input.toggleEnabled(true);
                await this.onActivate(context);
            } catch (e) {
                this._logger.error(`Error during scene activation for scene ${(_b = (_a = this.engine) === null || _a === void 0 ? void 0 : _a.director) === null || _b === void 0 ? void 0 : _b.getSceneName(this)}!`);
                throw e;
            }
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Deactivates the scene with the base behavior, then calls the overridable `onDeactivate` implementation.
     * @internal
     */ async _deactivate(context) {
            this._logger.debug("Scene.onDeactivate", this);
            this.input.toggleEnabled(false);
            await this.onDeactivate(context);
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPreUpdate]] lifecycle event
     * @internal
     */ _preupdate(engine, delta) {
            this.emit("preupdate", new PreUpdateEvent(engine, delta, this));
            this.onPreUpdate(engine, delta);
        }
        /**
     *  It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _preupdate handler for [[onPostUpdate]] lifecycle event
     * @internal
     */ _postupdate(engine, delta) {
            this.emit("postupdate", new PostUpdateEvent(engine, delta, this));
            this.onPostUpdate(engine, delta);
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _predraw handler for [[onPreDraw]] lifecycle event
     * @internal
     */ _predraw(ctx, delta) {
            this.emit("predraw", new PreDrawEvent(ctx, delta, this));
            this.onPreDraw(ctx, delta);
        }
        /**
     * It is not recommended that internal excalibur methods be overridden, do so at your own risk.
     *
     * Internal _postdraw handler for [[onPostDraw]] lifecycle event
     * @internal
     */ _postdraw(ctx, delta) {
            this.emit("postdraw", new PostDrawEvent(ctx, delta, this));
            this.onPostDraw(ctx, delta);
        }
        /**
     * Updates all the actors and timers in the scene. Called by the [[Engine]].
     * @param engine  Reference to the current Engine
     * @param delta   The number of milliseconds since the last update
     */ update(engine, delta) {
            var _a;
            if (!this.isInitialized) {
                this._logger.warnOnce(`Scene update called before initialize for scene ${(_a = engine.director) === null || _a === void 0 ? void 0 : _a.getSceneName(this)}!`);
                return;
            }
            this._preupdate(engine, delta);
            // TODO differed entity removal for timers
            let i, len;
            // Remove timers in the cancel queue before updating them
            for(i = 0, len = this._cancelQueue.length; i < len; i++)this.removeTimer(this._cancelQueue[i]);
            this._cancelQueue.length = 0;
            // Cycle through timers updating timers
            for (const timer of this._timers)timer.update(delta);
            this.world.update(SystemType.Update, delta);
            // Camera last keeps renders smooth that are based on entity/actor
            if (this.camera) this.camera.update(engine, delta);
            this._collectActorStats(engine);
            this._postupdate(engine, delta);
            this.input.update();
        }
        /**
     * Draws all the actors in the Scene. Called by the [[Engine]].
     * @param ctx    The current rendering context
     * @param delta  The number of milliseconds since the last draw
     */ draw(ctx, delta) {
            var _a;
            if (!this.isInitialized) {
                this._logger.warnOnce(`Scene draw called before initialize!`);
                return;
            }
            this._predraw(ctx, delta);
            this.world.update(SystemType.Draw, delta);
            if ((_a = this.engine) === null || _a === void 0 ? void 0 : _a.isDebug) this.debugDraw(ctx);
            this._postdraw(ctx, delta);
        }
        /**
     * Draws all the actors' debug information in the Scene. Called by the [[Engine]].
     * @param ctx  The current rendering context
     */ /* istanbul ignore next */ debugDraw(ctx) {
            this.emit("predebugdraw", new PreDebugDrawEvent(ctx, this));
            // pass
            this.emit("postdebugdraw", new PostDebugDrawEvent(ctx, this));
        }
        /**
     * Checks whether an actor is contained in this scene or not
     */ contains(actor) {
            return this.actors.indexOf(actor) > -1;
        }
        add(entity) {
            this.emit("entityadded", {
                target: entity
            });
            this.world.add(entity);
            entity.scene = this;
            if (entity instanceof Timer) {
                if (!contains(this._timers, entity)) this.addTimer(entity);
                return;
            }
        }
        /**
     * Removes an [[Entity]] (Actor, TileMap, Trigger, etc) or [[Timer]] from it's current scene
     * and adds it to this scene.
     *
     * Useful if you want to have an object be present in only 1 scene at a time.
     * @param entity
     */ transfer(entity) {
            let scene;
            if (entity instanceof Entity && entity.scene && entity.scene !== this) {
                scene = entity.scene;
                entity.scene.world.remove(entity, false);
            }
            if (entity instanceof Timer && entity.scene) {
                scene = entity.scene;
                entity.scene.removeTimer(entity);
            }
            scene === null || scene === void 0 || scene.emit("entityremoved", {
                target: entity
            });
            this.add(entity);
        }
        remove(entity) {
            if (entity instanceof Entity) {
                this.emit("entityremoved", {
                    target: entity
                });
                if (entity.active) entity.kill();
                this.world.remove(entity);
            }
            if (entity instanceof Timer) this.removeTimer(entity);
        }
        /**
     * Removes all entities and timers from the scene, optionally indicate whether deferred should or shouldn't be used.
     *
     * By default entities use deferred removal
     * @param deferred
     */ clear(deferred = true) {
            for(let i = this.entities.length - 1; i >= 0; i--)this.world.remove(this.entities[i], deferred);
            for(let i = this.timers.length - 1; i >= 0; i--)this.removeTimer(this.timers[i]);
        }
        /**
     * Adds a [[Timer]] to the scene
     * @param timer  The timer to add
     */ addTimer(timer) {
            this._timers.push(timer);
            timer.scene = this;
            return timer;
        }
        /**
     * Removes a [[Timer]] from the scene.
     * @warning Can be dangerous, use [[cancelTimer]] instead
     * @param timer  The timer to remove
     */ removeTimer(timer) {
            const i = this._timers.indexOf(timer);
            if (i !== -1) this._timers.splice(i, 1);
            return timer;
        }
        /**
     * Cancels a [[Timer]], removing it from the scene nicely
     * @param timer  The timer to cancel
     */ cancelTimer(timer) {
            this._cancelQueue.push(timer);
            return timer;
        }
        /**
     * Tests whether a [[Timer]] is active in the scene
     */ isTimerActive(timer) {
            return this._timers.indexOf(timer) > -1 && !timer.complete;
        }
        isCurrentScene() {
            if (this.engine) return this.engine.currentScene === this;
            return false;
        }
        _collectActorStats(engine) {
            const screenElements = this.actors.filter((a)=>a instanceof ScreenElement);
            for (const _ui of screenElements)engine.stats.currFrame.actors.ui++;
            for (const actor of this.actors){
                engine.stats.currFrame.actors.alive++;
                for (const child of actor.children)if (isScreenElement(child)) // TODO not true
                engine.stats.currFrame.actors.ui++;
                else engine.stats.currFrame.actors.alive++;
            }
        }
    }
    var ColorBlindnessMode;
    (function(ColorBlindnessMode) {
        ColorBlindnessMode["Protanope"] = "Protanope";
        ColorBlindnessMode["Deuteranope"] = "Deuteranope";
        ColorBlindnessMode["Tritanope"] = "Tritanope";
    })(ColorBlindnessMode || (ColorBlindnessMode = {}));
    /* harmony default export */ const color_blind_fragment = "#version 300 es\r\nprecision mediump float;\r\n// our texture\r\nuniform sampler2D u_image;\r\n// the texCoords passed in from the vertex shader.\r\nin vec2 v_texcoord;\r\n\r\n// color blind type\r\nuniform int u_type;\r\n\r\n// simulation?\r\nuniform bool u_simulate;\r\n\r\nout vec4 fragColor;\r\n\r\nvoid main() {\r\n  vec4 o =  texture(u_image, v_texcoord);\r\n  // RGB to LMS matrix conversion\r\n  float L = (17.8824 * o.r) + (43.5161 * o.g) + (4.11935 * o.b);\r\n  float M = (3.45565 * o.r) + (27.1554 * o.g) + (3.86714 * o.b);\r\n  float S = (0.0299566 * o.r) + (0.184309 * o.g) + (1.46709 * o.b);\r\n  // Simulate color blindness\r\n  float l;\r\n  float m;\r\n  float s;\r\n  //MODE CODE//\r\n  if (u_type == 0) {\r\n    // Protanope\r\n    l = 0.0 * L + 2.02344 * M + -2.52581 * S;\r\n    m = 0.0 * L + 1.0 * M + 0.0 * S;\r\n    s = 0.0 * L + 0.0 * M + 1.0 * S;;\r\n  } else if (u_type == 1) {\r\n    // Deuteranope\r\n    l = 1.0 * L + 0.0 * M + 0.0 * S;\r\n    m = 0.494207 * L + 0.0 * M + 1.24827 * S;\r\n    s = 0.0 * L + 0.0 * M + 1.0 * S;\r\n  } else if (u_type == 2) {\r\n    // Tritanope\r\n    l = 1.0 * L + 0.0 * M + 0.0 * S;\r\n    m = 0.0 * L + 1.0 * M + 0.0 * S;\r\n    s = -0.395913 * L + 0.801109 * M + 0.0 * S;\r\n  }\r\n\r\n  // LMS to RGB matrix conversion\r\n  vec4 error; // simulate the colors\r\n  error.r = (0.0809444479 * l) + (-0.130504409 * m) + (0.116721066 * s);\r\n  error.g = (-0.0102485335 * l) + (0.0540193266 * m) + (-0.113614708 * s);\r\n  error.b = (-0.000365296938 * l) + (-0.00412161469 * m) + (0.693511405 * s);\r\n  error.a = 1.0;\r\n  vec4 diff = o - error;\r\n  vec4 correction; // correct the colors\r\n  correction.r = 0.0;\r\n  correction.g =  (diff.r * 0.7) + (diff.g * 1.0);\r\n  correction.b =  (diff.r * 0.7) + (diff.b * 1.0);\r\n  correction = o + correction;\r\n  correction.a = o.a;\r\n  //SIMULATE//\r\n\r\n  // sim \r\n  if (u_simulate) {\r\n    fragColor = error.rgba;\r\n  } else {\r\n    fragColor = correction.rgba;\r\n  }\r\n}";
    /**
 * Helper that defines a whole screen renderer, just provide a fragment source!
 *
 * Currently supports 1 varying
 * - vec2 a_texcoord between 0-1 which corresponds to screen position
 */ class ScreenShader {
        constructor(gl, fragmentSource){
            this._shader = new Shader({
                gl: gl,
                vertexSource: `#version 300 es
      in vec2 a_position;
      in vec2 a_texcoord;
      out vec2 v_texcoord;

      void main() {
        gl_Position = vec4(a_position, 0.0, 1.0);
        // Pass the texcoord to the fragment shader.
        v_texcoord = a_texcoord;
      }`,
                fragmentSource: fragmentSource
            });
            this._shader.compile();
            // Setup memory layout
            this._buffer = new VertexBuffer({
                gl: gl,
                type: "static",
                // clip space quad + uv since we don't need a camera
                data: new Float32Array([
                    -1,
                    -1,
                    0,
                    0,
                    -1,
                    1,
                    0,
                    1,
                    1,
                    -1,
                    1,
                    0,
                    1,
                    -1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    1,
                    1,
                    1,
                    1,
                    1
                ])
            });
            this._layout = new VertexLayout({
                gl: gl,
                shader: this._shader,
                vertexBuffer: this._buffer,
                attributes: [
                    [
                        "a_position",
                        2
                    ],
                    [
                        "a_texcoord",
                        2
                    ]
                ]
            });
            this._buffer.upload();
        }
        getShader() {
            return this._shader;
        }
        getLayout() {
            return this._layout;
        }
    }
    class ColorBlindnessPostProcessor {
        constructor(_colorBlindnessMode, simulate = false){
            this._colorBlindnessMode = _colorBlindnessMode;
            this._simulate = false;
            this._simulate = simulate;
        }
        initialize(gl) {
            this._shader = new ScreenShader(gl, color_blind_fragment);
            this.simulate = this._simulate;
            this.colorBlindnessMode = this._colorBlindnessMode;
        }
        getShader() {
            return this._shader.getShader();
        }
        getLayout() {
            return this._shader.getLayout();
        }
        set colorBlindnessMode(colorBlindMode) {
            this._colorBlindnessMode = colorBlindMode;
            if (this._shader) {
                const shader = this._shader.getShader();
                shader.use();
                if (this._colorBlindnessMode === ColorBlindnessMode.Protanope) shader.setUniformInt("u_type", 0);
                else if (this._colorBlindnessMode === ColorBlindnessMode.Deuteranope) shader.setUniformInt("u_type", 1);
                else if (this._colorBlindnessMode === ColorBlindnessMode.Tritanope) shader.setUniformInt("u_type", 2);
            }
        }
        get colorBlindnessMode() {
            return this._colorBlindnessMode;
        }
        set simulate(value) {
            this._simulate = value;
            if (this._shader) {
                const shader = this._shader.getShader();
                shader.use();
                shader.setUniformBoolean("u_simulate", value);
            }
        }
        get simulate() {
            return this._simulate;
        }
    }
    class ColorBlindFlags {
        constructor(engine){
            this._engine = engine;
            this._colorBlindPostProcessor = new ColorBlindnessPostProcessor(ColorBlindnessMode.Protanope);
        }
        /**
     * Correct colors for a specified color blindness
     * @param colorBlindness
     */ correct(colorBlindness) {
            if (this._engine.graphicsContext instanceof ExcaliburGraphicsContextWebGL) {
                this.clear();
                this._colorBlindPostProcessor.colorBlindnessMode = colorBlindness;
                this._colorBlindPostProcessor.simulate = false;
                this._engine.graphicsContext.addPostProcessor(this._colorBlindPostProcessor);
            }
        }
        /**
     * Simulate colors for a specified color blindness
     * @param colorBlindness
     */ simulate(colorBlindness) {
            if (this._engine.graphicsContext instanceof ExcaliburGraphicsContextWebGL) {
                this.clear();
                this._colorBlindPostProcessor.colorBlindnessMode = colorBlindness;
                this._colorBlindPostProcessor.simulate = true;
                this._engine.graphicsContext.addPostProcessor(this._colorBlindPostProcessor);
            }
        }
        /**
     * Remove color blindness post processor
     */ clear() {
            this._engine.graphicsContext.removePostProcessor(this._colorBlindPostProcessor);
        }
    }
    /**
 * Debug statistics and flags for Excalibur. If polling these values, it would be
 * best to do so on the `postupdate` event for [[Engine]], after all values have been
 * updated during a frame.
 */ class DebugConfig {
        constructor(engine){
            /**
         * Performance statistics
         */ this.stats = {
                /**
             * Current frame statistics. Engine reuses this instance, use [[FrameStats.clone]] to copy frame stats.
             * Best accessed on [[postframe]] event. See [[FrameStats]]
             */ currFrame: new FrameStats(),
                /**
             * Previous frame statistics. Engine reuses this instance, use [[FrameStats.clone]] to copy frame stats.
             * Best accessed on [[preframe]] event. Best inspected on engine event `preframe`. See [[FrameStats]]
             */ prevFrame: new FrameStats()
            };
            /**
         * Filter debug context to named entities or entity ids
         */ this.filter = {
                /**
             * Toggle filter on or off (default off) must be on for DebugDraw to use filters
             */ useFilter: false,
                /**
             * Query for entities by name, if the entity name contains `nameQuery` it will be included
             */ nameQuery: "",
                /**
             * Query for Entity ids, if the id matches it will be included
             */ ids: []
            };
            /**
         * Entity debug settings
         */ this.entity = {
                showAll: false,
                showId: false,
                showName: false
            };
            /**
         * Transform component debug settings
         */ this.transform = {
                showAll: false,
                debugZIndex: 10000000,
                showPosition: false,
                showPositionLabel: false,
                positionColor: Color.Yellow,
                showZIndex: false,
                showScale: false,
                scaleColor: Color.Green,
                showRotation: false,
                rotationColor: Color.Blue
            };
            /**
         * Graphics component debug settings
         */ this.graphics = {
                showAll: false,
                showBounds: false,
                boundsColor: Color.Yellow
            };
            /**
         * Collider component debug settings
         */ this.collider = {
                showAll: false,
                showBounds: false,
                boundsColor: Color.Blue,
                showOwner: false,
                showGeometry: true,
                geometryColor: Color.Green,
                geometryLineWidth: 1,
                geometryPointSize: .5
            };
            /**
         * Physics simulation debug settings
         */ this.physics = {
                showAll: false,
                showBroadphaseSpacePartitionDebug: false,
                showCollisionNormals: false,
                collisionNormalColor: Color.Cyan,
                showCollisionContacts: true,
                contactSize: 2,
                collisionContactColor: Color.Red
            };
            /**
         * Motion component debug settings
         */ this.motion = {
                showAll: false,
                showVelocity: false,
                velocityColor: Color.Yellow,
                showAcceleration: false,
                accelerationColor: Color.Red
            };
            /**
         * Body component debug settings
         */ this.body = {
                showAll: false,
                showCollisionGroup: false,
                showCollisionType: false,
                showSleeping: false,
                showMotion: false,
                showMass: false
            };
            /**
         * Camera debug settings
         */ this.camera = {
                showAll: false,
                showFocus: false,
                focusColor: Color.Red,
                showZoom: false
            };
            this.tilemap = {
                showAll: false,
                showGrid: false,
                gridColor: Color.Red,
                gridWidth: .5,
                showSolidBounds: false,
                solidBoundsColor: Color.fromHex("#8080807F"),
                showColliderGeometry: true
            };
            this.isometric = {
                showAll: false,
                showPosition: false,
                positionColor: Color.Yellow,
                positionSize: 1,
                showGrid: false,
                gridColor: Color.Red,
                gridWidth: 1,
                showColliderGeometry: true
            };
            this._engine = engine;
            this.colorBlindMode = new ColorBlindFlags(this._engine);
        }
        /**
     * Switch the current excalibur clock with the [[TestClock]] and return
     * it in the same running state.
     *
     * This is useful when you need to debug frame by frame.
     */ useTestClock() {
            const clock = this._engine.clock;
            const wasRunning = clock.isRunning();
            clock.stop();
            const testClock = clock.toTestClock();
            if (wasRunning) testClock.start();
            this._engine.clock = testClock;
            return testClock;
        }
        /**
     * Switch the current excalibur clock with the [[StandardClock]] and
     * return it in the same running state.
     *
     * This is useful when you need to switch back to normal mode after
     * debugging.
     */ useStandardClock() {
            const currentClock = this._engine.clock;
            const wasRunning = currentClock.isRunning();
            currentClock.stop();
            const standardClock = currentClock.toStandardClock();
            if (wasRunning) standardClock.start();
            this._engine.clock = standardClock;
            return standardClock;
        }
    }
    /**
 * Implementation of a frame's stats. Meant to have values copied via [[FrameStats.reset]], avoid
 * creating instances of this every frame.
 */ class FrameStats {
        constructor(){
            this._id = 0;
            this._delta = 0;
            this._fps = 0;
            this._actorStats = {
                alive: 0,
                killed: 0,
                ui: 0,
                get remaining () {
                    return this.alive - this.killed;
                },
                get total () {
                    return this.remaining + this.ui;
                }
            };
            this._durationStats = {
                update: 0,
                draw: 0,
                get total () {
                    return this.update + this.draw;
                }
            };
            this._physicsStats = new PhysicsStats();
            this._graphicsStats = {
                drawCalls: 0,
                drawnImages: 0
            };
        }
        /**
     * Zero out values or clone other IFrameStat stats. Allows instance reuse.
     * @param [otherStats] Optional stats to clone
     */ reset(otherStats) {
            if (otherStats) {
                this.id = otherStats.id;
                this.delta = otherStats.delta;
                this.fps = otherStats.fps;
                this.actors.alive = otherStats.actors.alive;
                this.actors.killed = otherStats.actors.killed;
                this.actors.ui = otherStats.actors.ui;
                this.duration.update = otherStats.duration.update;
                this.duration.draw = otherStats.duration.draw;
                this._physicsStats.reset(otherStats.physics);
                this.graphics.drawCalls = otherStats.graphics.drawCalls;
                this.graphics.drawnImages = otherStats.graphics.drawnImages;
            } else {
                this.id = this.delta = this.fps = 0;
                this.actors.alive = this.actors.killed = this.actors.ui = 0;
                this.duration.update = this.duration.draw = 0;
                this._physicsStats.reset();
                this.graphics.drawnImages = this.graphics.drawCalls = 0;
            }
        }
        /**
     * Provides a clone of this instance.
     */ clone() {
            const fs = new FrameStats();
            fs.reset(this);
            return fs;
        }
        /**
     * Gets the frame's id
     */ get id() {
            return this._id;
        }
        /**
     * Sets the frame's id
     */ set id(value) {
            this._id = value;
        }
        /**
     * Gets the frame's delta (time since last frame)
     */ get delta() {
            return this._delta;
        }
        /**
     * Sets the frame's delta (time since last frame). Internal use only.
     * @internal
     */ set delta(value) {
            this._delta = value;
        }
        /**
     * Gets the frame's frames-per-second (FPS)
     */ get fps() {
            return this._fps;
        }
        /**
     * Sets the frame's frames-per-second (FPS). Internal use only.
     * @internal
     */ set fps(value) {
            this._fps = value;
        }
        /**
     * Gets the frame's actor statistics
     */ get actors() {
            return this._actorStats;
        }
        /**
     * Gets the frame's duration statistics
     */ get duration() {
            return this._durationStats;
        }
        /**
     * Gets the frame's physics statistics
     */ get physics() {
            return this._physicsStats;
        }
        /**
     * Gets the frame's graphics statistics
     */ get graphics() {
            return this._graphicsStats;
        }
    }
    class PhysicsStats {
        constructor(){
            this._pairs = 0;
            this._collisions = 0;
            this._contacts = new Map();
            this._fastBodies = 0;
            this._fastBodyCollisions = 0;
            this._broadphase = 0;
            this._narrowphase = 0;
        }
        /**
     * Zero out values or clone other IPhysicsStats stats. Allows instance reuse.
     * @param [otherStats] Optional stats to clone
     */ reset(otherStats) {
            if (otherStats) {
                this.pairs = otherStats.pairs;
                this.collisions = otherStats.collisions;
                this.contacts = otherStats.contacts;
                this.fastBodies = otherStats.fastBodies;
                this.fastBodyCollisions = otherStats.fastBodyCollisions;
                this.broadphase = otherStats.broadphase;
                this.narrowphase = otherStats.narrowphase;
            } else {
                this.pairs = this.collisions = this.fastBodies = 0;
                this.fastBodyCollisions = this.broadphase = this.narrowphase = 0;
                this.contacts.clear();
            }
        }
        /**
     * Provides a clone of this instance.
     */ clone() {
            const ps = new PhysicsStats();
            ps.reset(this);
            return ps;
        }
        get pairs() {
            return this._pairs;
        }
        set pairs(value) {
            this._pairs = value;
        }
        get collisions() {
            return this._collisions;
        }
        set collisions(value) {
            this._collisions = value;
        }
        get contacts() {
            return this._contacts;
        }
        set contacts(contacts) {
            this._contacts = contacts;
        }
        get fastBodies() {
            return this._fastBodies;
        }
        set fastBodies(value) {
            this._fastBodies = value;
        }
        get fastBodyCollisions() {
            return this._fastBodyCollisions;
        }
        set fastBodyCollisions(value) {
            this._fastBodyCollisions = value;
        }
        get broadphase() {
            return this._broadphase;
        }
        set broadphase(value) {
            this._broadphase = value;
        }
        get narrowphase() {
            return this._narrowphase;
        }
        set narrowphase(value) {
            this._narrowphase = value;
        }
    }
    class BrowserComponent {
        on(eventName, handler) {
            if (this._nativeHandlers[eventName]) this.off(eventName, this._nativeHandlers[eventName]);
            this._nativeHandlers[eventName] = this._decorate(handler);
            this.nativeComponent.addEventListener(eventName, this._nativeHandlers[eventName]);
        }
        off(eventName, handler) {
            if (!handler) handler = this._nativeHandlers[eventName];
            this.nativeComponent.removeEventListener(eventName, handler);
            this._nativeHandlers[eventName] = null;
        }
        _decorate(handler) {
            return (evt)=>{
                if (!this._paused) handler(evt);
            };
        }
        pause() {
            this._paused = true;
        }
        resume() {
            this._paused = false;
        }
        clear() {
            for(const event in this._nativeHandlers)this.off(event);
        }
        constructor(nativeComponent){
            this.nativeComponent = nativeComponent;
            this._paused = false;
            this._nativeHandlers = {};
        }
    }
    class BrowserEvents {
        constructor(_windowGlobal, _documentGlobal){
            this._windowGlobal = _windowGlobal;
            this._documentGlobal = _documentGlobal;
            this._windowComponent = new BrowserComponent(this._windowGlobal);
            this._documentComponent = new BrowserComponent(this._documentGlobal);
        }
        get window() {
            return this._windowComponent;
        }
        get document() {
            return this._documentComponent;
        }
        pause() {
            this.window.pause();
            this.document.pause();
        }
        resume() {
            this.window.resume();
            this.document.resume();
        }
        clear() {
            this.window.clear();
            this.document.clear();
        }
    }
    const DefaultAntialiasOptions = {
        pixelArtSampler: false,
        nativeContextAntialiasing: false,
        multiSampleAntialiasing: true,
        filtering: ImageFiltering.Blended,
        canvasImageRendering: "auto"
    };
    const DefaultPixelArtOptions = {
        pixelArtSampler: true,
        nativeContextAntialiasing: false,
        multiSampleAntialiasing: true,
        filtering: ImageFiltering.Blended,
        canvasImageRendering: "auto"
    };
    class FpsSampler {
        constructor(options){
            var _a;
            this._samplePeriod = 100;
            this._currentFrameTime = 0;
            this._frames = 0;
            this._previousSampleTime = 0;
            this._beginFrameTime = 0;
            this._fps = options.initialFps;
            this._samplePeriod = (_a = options.samplePeriod) !== null && _a !== void 0 ? _a : this._samplePeriod;
            this._currentFrameTime = 1000 / options.initialFps;
            this._nowFn = options.nowFn;
            this._previousSampleTime = this._nowFn();
        }
        /**
     * Start of code block to sample FPS for
     */ start() {
            this._beginFrameTime = this._nowFn();
        }
        /**
     * End of code block to sample FPS for
     */ end() {
            this._frames++;
            const time = this._nowFn();
            this._currentFrameTime = time - this._beginFrameTime;
            if (time >= this._previousSampleTime + this._samplePeriod) {
                this._fps = this._frames * 1000 / (time - this._previousSampleTime);
                this._previousSampleTime = time;
                this._frames = 0;
            }
        }
        /**
     * Return the currently sampled fps over the last sample period, by default every 100ms
     */ get fps() {
            return this._fps;
        }
        /**
     * Return the instantaneous fps, this can be less useful because it will fluctuate given the current frames time
     */ get instant() {
            return 1000 / this._currentFrameTime;
        }
    }
    /**
 * Abstract Clock is the base type of all Clocks
 *
 * It has a few opinions
 * 1. It manages the calculation of what "elapsed" time means and thus maximum fps
 * 2. The default timing api is implemented in now()
 *
 * To implement your own clock, extend Clock and override start/stop to start and stop the clock, then call update() with whatever
 * method is unique to your clock implementation.
 */ class Clock {
        constructor(options){
            var _a, _b, _c;
            this._onFatalException = ()=>{};
            this._maxFps = Infinity;
            this._lastTime = 0;
            this._elapsed = 1;
            this._scheduledCbs = [];
            this._totalElapsed = 0;
            this._options = options;
            this.tick = options.tick;
            this._lastTime = (_a = this.now()) !== null && _a !== void 0 ? _a : 0;
            this._maxFps = (_b = options.maxFps) !== null && _b !== void 0 ? _b : this._maxFps;
            this._onFatalException = (_c = options.onFatalException) !== null && _c !== void 0 ? _c : this._onFatalException;
            this.fpsSampler = new FpsSampler({
                initialFps: 60,
                nowFn: ()=>this.now()
            });
        }
        /**
     * Get the elapsed time for the last completed frame
     */ elapsed() {
            return this._elapsed;
        }
        /**
     * Get the current time in milliseconds
     */ now() {
            return performance.now();
        }
        toTestClock() {
            const testClock = new TestClock({
                ...this._options,
                defaultUpdateMs: 16.6
            });
            return testClock;
        }
        toStandardClock() {
            const clock = new StandardClock({
                ...this._options
            });
            return clock;
        }
        setFatalExceptionHandler(handler) {
            this._onFatalException = handler;
        }
        /**
     * Schedule a callback to fire given a timeout in milliseconds using the excalibur [[Clock]]
     *
     * This is useful to use over the built in browser `setTimeout` because callbacks will be tied to the
     * excalibur update clock, instead of browser time, this means that callbacks wont fire if the game is
     * stopped or paused.
     * @param cb callback to fire
     * @param timeoutMs Optionally specify a timeout in milliseconds from now, default is 0ms which means the next possible tick
     * @param timing Optionally specify a timeout in milliseconds from now, default is 0ms which means the next possible tick
     */ schedule(cb, timeoutMs = 0, timing = "preframe") {
            // Scheduled based on internal elapsed time
            const scheduledTime = this._totalElapsed + timeoutMs;
            this._scheduledCbs.push([
                cb,
                scheduledTime,
                timing
            ]);
        }
        /**
     * Called internally to trigger scheduled callbacks in the clock
     * @param timing
     * @internal
     */ __runScheduledCbs(timing = "preframe") {
            // walk backwards to delete items as we loop
            for(let i = this._scheduledCbs.length - 1; i > -1; i--)if (timing === this._scheduledCbs[i][2] && this._scheduledCbs[i][1] <= this._totalElapsed) {
                this._scheduledCbs[i][0](this._elapsed);
                this._scheduledCbs.splice(i, 1);
            }
        }
        update(overrideUpdateMs) {
            try {
                this.fpsSampler.start();
                // Get the time to calculate time-elapsed
                const now = this.now();
                let elapsed = now - this._lastTime || 1; // first frame
                // Constrain fps
                const fpsInterval = 1000 / this._maxFps;
                // only run frame if enough time has elapsed
                if (elapsed >= fpsInterval) {
                    let leftover = 0;
                    if (fpsInterval !== 0) {
                        leftover = elapsed % fpsInterval;
                        elapsed = elapsed - leftover; // shift elapsed to be "in phase" with the current loop fps
                    }
                    // Resolves issue #138 if the game has been paused, or blurred for
                    // more than a 200 milliseconds, reset elapsed time to 1. This improves reliability
                    // and provides more expected behavior when the engine comes back
                    // into focus
                    if (elapsed > 200) elapsed = 1;
                    // tick the mainloop and run scheduled callbacks
                    this._elapsed = overrideUpdateMs || elapsed;
                    this._totalElapsed += this._elapsed;
                    this.__runScheduledCbs("preframe");
                    this.tick(overrideUpdateMs || elapsed);
                    this.__runScheduledCbs("postframe");
                    if (fpsInterval !== 0) this._lastTime = now - leftover;
                    else this._lastTime = now;
                    this.fpsSampler.end();
                }
            } catch (e) {
                this._onFatalException(e);
                this.stop();
            }
        }
    }
    /**
 * The [[StandardClock]] implements the requestAnimationFrame browser api to run the tick()
 */ class StandardClock extends Clock {
        constructor(options){
            super(options);
            this._running = false;
        }
        isRunning() {
            return this._running;
        }
        start() {
            if (this._running) return;
            this._running = true;
            const mainloop = ()=>{
                // stop the loop
                if (!this._running) return;
                try {
                    // request next loop
                    this._requestId = window.requestAnimationFrame(mainloop);
                    this.update();
                } catch (e) {
                    window.cancelAnimationFrame(this._requestId);
                    throw e;
                }
            };
            // begin the first frame
            mainloop();
        }
        stop() {
            window.cancelAnimationFrame(this._requestId);
            this._running = false;
        }
    }
    /**
 * The TestClock is meant for debugging interactions in excalibur that require precise timing to replicate or test
 */ class TestClock extends Clock {
        constructor(options){
            super({
                ...options
            });
            this._logger = Logger.getInstance();
            this._running = false;
            this._currentTime = 0;
            this._updateMs = options.defaultUpdateMs;
        }
        /**
     * Get the current time in milliseconds
     */ now() {
            var _a;
            return (_a = this._currentTime) !== null && _a !== void 0 ? _a : 0;
        }
        isRunning() {
            return this._running;
        }
        start() {
            this._running = true;
        }
        stop() {
            this._running = false;
        }
        /**
     * Manually step the clock forward 1 tick, optionally specify an elapsed time in milliseconds
     * @param overrideUpdateMs
     */ step(overrideUpdateMs) {
            const time = overrideUpdateMs !== null && overrideUpdateMs !== void 0 ? overrideUpdateMs : this._updateMs;
            if (this._running) {
                // to be comparable to RAF this needs to be a full blown Task
                // For example, images cannot decode synchronously in a single step
                this.update(time);
                this._currentTime += time;
            } else this._logger.warn("The clock is not running, no step will be performed");
        }
        /**
     * Run a number of steps that tick the clock, optionally specify an elapsed time in milliseconds
     * @param numberOfSteps
     * @param overrideUpdateMs
     */ run(numberOfSteps, overrideUpdateMs) {
            for(let i = 0; i < numberOfSteps; i++)this.step(overrideUpdateMs !== null && overrideUpdateMs !== void 0 ? overrideUpdateMs : this._updateMs);
        }
    }
    // EXTERNAL MODULE: ./Util/Toaster.css
    var Util_Toaster = $2c23f148d58cd887$var$__webpack_require__(4296);
    /**
 * The Toaster is only meant to be called from inside Excalibur to display messages to players
 */ class Toaster {
        constructor(){
            this._toasterCss = Util_Toaster /* default */ .A.toString();
            this._isInitialized = false;
        }
        _initialize() {
            if (!this._isInitialized) {
                this._container = document.createElement("div");
                this._container.id = "ex-toast-container";
                document.body.appendChild(this._container);
                this._isInitialized = true;
                this._styleBlock = document.createElement("style");
                this._styleBlock.textContent = this._toasterCss;
                document.head.appendChild(this._styleBlock);
            }
        }
        dispose() {
            this._container.parentElement.removeChild(this._container);
            this._styleBlock.parentElement.removeChild(this._styleBlock);
            this._isInitialized = false;
        }
        _createFragment(message) {
            const toastMessage = document.createElement("span");
            toastMessage.innerText = message;
            return toastMessage;
        }
        /**
     * Display a toast message to a player
     * @param message Text of the message, messages may have a single "[LINK]" to influence placement
     * @param linkTarget Optionally specify a link location
     * @param linkName Optionally specify a name for that link location
     */ toast(message, linkTarget, linkName) {
            this._initialize();
            const toast = document.createElement("div");
            toast.className = "ex-toast-message";
            const messageFragments = message.split("[LINK]").map((message)=>this._createFragment(message));
            if (linkTarget) {
                const link = document.createElement("a");
                link.href = linkTarget;
                if (linkName) link.innerText = linkName;
                else link.innerText = linkTarget;
                messageFragments.splice(1, 0, link);
            }
            // Assembly message
            const finalMessage = document.createElement("div");
            messageFragments.forEach((message)=>{
                finalMessage.appendChild(message);
            });
            toast.appendChild(finalMessage);
            // Dismiss button
            const dismissBtn = document.createElement("button");
            dismissBtn.innerText = "x";
            dismissBtn.addEventListener("click", ()=>{
                this._container.removeChild(toast);
            });
            toast.appendChild(dismissBtn);
            // Escape to dismiss
            const keydownHandler = (evt)=>{
                if (evt.key === "Escape") try {
                    this._container.removeChild(toast);
                } catch (_a) {
                // pass
                }
                document.removeEventListener("keydown", keydownHandler);
            };
            document.addEventListener("keydown", keydownHandler);
            // Insert into container
            const first = this._container.firstChild;
            this._container.insertBefore(toast, first);
        }
    }
    const DirectorEvents = {
        NavigationStart: "navigationstart",
        Navigation: "navigation",
        NavigationEnd: "navigationend"
    };
    /**
 * The Director is responsible for managing scenes and changing scenes in Excalibur.
 *
 * It deals with transitions, scene loaders, switching scenes
 *
 * This is used internally by Excalibur, generally not mean to
 * be instantiated end users directly.
 */ class Director {
        /**
     * Gets whether the director currently transitioning between scenes
     *
     * Useful if you need to block behavior during transition
     */ get isTransitioning() {
            return this._isTransitioning;
        }
        constructor(_engine, scenes){
            this._engine = _engine;
            this.events = new EventEmitter();
            this._logger = Logger.getInstance();
            this._initialized = false;
            /**
         * All registered scenes in Excalibur
         */ this.scenes = {};
            /**
         * Holds all instantiated scenes
         */ this._sceneToInstance = new Map();
            this._sceneToLoader = new Map();
            this._sceneToTransition = new Map();
            /**
         * Used to keep track of scenes that have already been loaded so we don't load multiple times
         */ this._loadedScenes = new Set();
            this._isTransitioning = false;
            this.rootScene = this.currentScene = new Scene();
            this.add("root", this.rootScene);
            this.currentScene = this.rootScene;
            this.currentSceneName = "root";
            for(const sceneKey in scenes){
                const sceneOrOptions = scenes[sceneKey];
                this.add(sceneKey, sceneOrOptions);
                if (sceneKey === "root") {
                    this.rootScene = this.getSceneInstance("root");
                    this.currentScene = this.rootScene;
                }
            }
        }
        /**
     * Initialize the director's internal state
     */ async onInitialize() {
            if (!this._initialized) {
                this._initialized = true;
                if (this._deferredGoto) {
                    const deferredScene = this._deferredGoto;
                    const deferredTransition = this._deferredTransition;
                    this._deferredGoto = null;
                    this._deferredTransition = null;
                    await this.swapScene(deferredScene);
                    if (deferredTransition) await this.playTransition(deferredTransition);
                } else await this.swapScene("root");
            }
        }
        get isInitialized() {
            return this._initialized;
        }
        /**
     * Configures the start scene, and optionally the transition & loader for the director
     *
     * Typically this is called at the beginning of the game to the start scene and transition and never again.
     * @param startScene
     * @param options
     */ configureStart(startScene, options) {
            const maybeLoaderOrCtor = options === null || options === void 0 ? void 0 : options.loader;
            if (maybeLoaderOrCtor instanceof DefaultLoader) this.mainLoader = maybeLoaderOrCtor;
            else if (isLoaderConstructor(maybeLoaderOrCtor)) this.mainLoader = new maybeLoaderOrCtor();
            else this.mainLoader = new Loader();
            let maybeStartTransition;
            if (options) {
                const { inTransition: inTransition } = options;
                maybeStartTransition = inTransition;
            }
            this.startScene = startScene;
            // Fire and forget promise for the initial scene
            if (maybeStartTransition) // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.swapScene(this.startScene).then(()=>{
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.playTransition(maybeStartTransition);
            });
            else // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.swapScene(this.startScene);
            this.currentSceneName = this.startScene;
        }
        _getLoader(sceneName) {
            return this._sceneToLoader.get(sceneName);
        }
        _getInTransition(sceneName) {
            var _a;
            const sceneOrRoute = this.scenes[sceneName];
            if (sceneOrRoute instanceof Scene || isSceneConstructor(sceneOrRoute)) return null;
            return (_a = sceneOrRoute === null || sceneOrRoute === void 0 ? void 0 : sceneOrRoute.transitions) === null || _a === void 0 ? void 0 : _a.in;
        }
        _getOutTransition(sceneName) {
            var _a;
            const sceneOrRoute = this.scenes[sceneName];
            if (sceneOrRoute instanceof Scene || isSceneConstructor(sceneOrRoute)) return null;
            return (_a = sceneOrRoute === null || sceneOrRoute === void 0 ? void 0 : sceneOrRoute.transitions) === null || _a === void 0 ? void 0 : _a.out;
        }
        getDeferredScene() {
            const maybeDeferred = this.getSceneDefinition(this._deferredGoto);
            if (this._deferredGoto && maybeDeferred) return maybeDeferred;
            return null;
        }
        /**
     * Returns a scene by name if it exists, might be the constructor and not the instance of a scene
     * @param name
     */ getSceneDefinition(name) {
            const maybeScene = this.scenes[name];
            if (maybeScene instanceof Scene || isSceneConstructor(maybeScene)) return maybeScene;
            else if (maybeScene) return maybeScene.scene;
            return undefined;
        }
        getSceneName(scene) {
            for (const [name, sceneInstance] of this._sceneToInstance){
                if (scene === sceneInstance) return name;
            }
            return "unknown scene name";
        }
        /**
     * Returns the same Director, but asserts a scene DOES exist to the type system
     * @param name
     */ assertAdded(name) {
            return this;
        }
        /**
     * Returns the same Director, but asserts a scene DOES NOT exist to the type system
     * @param name
     */ assertRemoved(name) {
            return this;
        }
        /**
     * Adds additional Scenes to the game!
     * @param name
     * @param sceneOrRoute
     */ add(name, sceneOrRoute) {
            if (!(sceneOrRoute instanceof Scene) && !isSceneConstructor(sceneOrRoute)) {
                const { loader: loader, transitions: transitions } = sceneOrRoute;
                const { in: inTransition, out: outTransition } = transitions !== null && transitions !== void 0 ? transitions : {};
                this._sceneToTransition.set(name, {
                    in: inTransition,
                    out: outTransition
                });
                if (isLoaderConstructor(loader)) this._sceneToLoader.set(name, new loader());
                else this._sceneToLoader.set(name, loader);
            }
            if (this.scenes[name]) this._logger.warn("Scene", name, "already exists overwriting");
            this.scenes[name] = sceneOrRoute;
            return this.assertAdded(name);
        }
        remove(nameOrScene) {
            if (nameOrScene instanceof Scene || isSceneConstructor(nameOrScene)) {
                const sceneOrCtor = nameOrScene;
                // remove scene
                for(const key in this.scenes)if (this.scenes.hasOwnProperty(key)) {
                    const potentialSceneOrOptions = this.scenes[key];
                    let scene;
                    if (potentialSceneOrOptions instanceof Scene || isSceneConstructor(potentialSceneOrOptions)) scene = potentialSceneOrOptions;
                    else scene = potentialSceneOrOptions.scene;
                    if (scene === sceneOrCtor) {
                        if (key === this.currentSceneName) throw new Error(`Cannot remove a currently active scene: ${key}`);
                        this._sceneToInstance.delete(key);
                        this._sceneToTransition.delete(key);
                        this._sceneToLoader.delete(key);
                        delete this.scenes[key];
                    }
                }
            }
            if (typeof nameOrScene === "string") {
                if (nameOrScene === this.currentSceneName) throw new Error(`Cannot remove a currently active scene: ${nameOrScene}`);
                // remove scene
                this._sceneToInstance.delete(nameOrScene);
                this._sceneToTransition.delete(nameOrScene);
                this._sceneToLoader.delete(nameOrScene);
                delete this.scenes[nameOrScene];
            }
        }
        /**
     * Go to a specific scene, and optionally override loaders and transitions
     * @param destinationScene
     * @param options
     */ async goto(destinationScene, options) {
            var _a, _b, _c, _d, _e, _f;
            const maybeDest = this.getSceneInstance(destinationScene);
            if (!maybeDest) {
                this._logger.warn(`Scene ${destinationScene} does not exist! Check the name, are you sure you added it?`);
                return;
            }
            const sourceScene = this.currentSceneName;
            const engineInputEnabled = (_b = (_a = this._engine.input) === null || _a === void 0 ? void 0 : _a.enabled) !== null && _b !== void 0 ? _b : true;
            this._isTransitioning = true;
            const maybeSourceOut = (_c = this.getSceneInstance(sourceScene)) === null || _c === void 0 ? void 0 : _c.onTransition("out");
            const maybeDestinationIn = maybeDest === null || maybeDest === void 0 ? void 0 : maybeDest.onTransition("in");
            options = {
                sourceOut: (_d = this._getOutTransition(this.currentSceneName)) !== null && _d !== void 0 ? _d : maybeSourceOut,
                destinationIn: (_e = this._getInTransition(destinationScene)) !== null && _e !== void 0 ? _e : maybeDestinationIn,
                // Goto options
                ...options
            };
            const { sourceOut: sourceOut, destinationIn: destinationIn, sceneActivationData: sceneActivationData } = options;
            const outTransition = sourceOut !== null && sourceOut !== void 0 ? sourceOut : this._getOutTransition(this.currentSceneName);
            const inTransition = destinationIn !== null && destinationIn !== void 0 ? destinationIn : this._getInTransition(destinationScene);
            const hideLoader = (outTransition === null || outTransition === void 0 ? void 0 : outTransition.hideLoader) || (inTransition === null || inTransition === void 0 ? void 0 : inTransition.hideLoader);
            if (hideLoader) // Start hidden loader early and take advantage of the transition
            // Don't await and block on a hidden loader
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.maybeLoadScene(destinationScene, hideLoader);
            this._emitEvent("navigationstart", sourceScene, destinationScene);
            // Run the out transition on the current scene if present
            await this.playTransition(outTransition);
            // Run the loader if present
            await this.maybeLoadScene(destinationScene, hideLoader);
            // Give incoming transition a chance to grab info from previous
            await (inTransition === null || inTransition === void 0 ? void 0 : inTransition.onPreviousSceneDeactivate(this.currentScene));
            // Swap to the new scene
            await this.swapScene(destinationScene, sceneActivationData);
            this._emitEvent("navigation", sourceScene, destinationScene);
            // Run the in transition on the new scene if present
            await this.playTransition(inTransition);
            this._emitEvent("navigationend", sourceScene, destinationScene);
            (_f = this._engine.input) === null || _f === void 0 || _f.toggleEnabled(engineInputEnabled);
            this._isTransitioning = false;
        }
        /**
     * Retrieves a scene instance by key if it's registered.
     *
     * This will call any constructors that were given as a definition
     * @param scene
     */ getSceneInstance(scene) {
            const sceneDefinition = this.getSceneDefinition(scene);
            if (!sceneDefinition) return undefined;
            if (this._sceneToInstance.has(scene)) return this._sceneToInstance.get(scene);
            if (sceneDefinition instanceof Scene) {
                this._sceneToInstance.set(scene, sceneDefinition);
                return sceneDefinition;
            }
            const newScene = new sceneDefinition();
            this._sceneToInstance.set(scene, newScene);
            return newScene;
        }
        /**
     * Triggers scene loading if has not already been loaded
     * @param scene
     * @param hideLoader
     */ async maybeLoadScene(scene, hideLoader = false) {
            var _a;
            const loader = (_a = this._getLoader(scene)) !== null && _a !== void 0 ? _a : new DefaultLoader();
            const sceneToLoad = this.getSceneDefinition(scene);
            const sceneToLoadInstance = this.getSceneInstance(scene);
            if (sceneToLoad && sceneToLoadInstance && !this._loadedScenes.has(sceneToLoadInstance)) {
                sceneToLoadInstance.onPreLoad(loader);
                sceneToLoadInstance.events.emit("preload", {
                    loader: loader
                });
                if (hideLoader) // Don't await a hidden loader
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._engine.load(loader, hideLoader);
                else await this._engine.load(loader);
                this._loadedScenes.add(sceneToLoadInstance);
            }
        }
        /**
     * Plays a transition in the current scene
     * @param transition
     */ async playTransition(transition) {
            var _a, _b, _c, _d, _e, _f, _g;
            if (!this.isInitialized) {
                this._deferredTransition = transition;
                return;
            }
            if (transition) {
                this.currentTransition = transition;
                const currentScene = this._engine.currentScene;
                const sceneInputEnabled = (_b = (_a = currentScene.input) === null || _a === void 0 ? void 0 : _a.enabled) !== null && _b !== void 0 ? _b : true;
                (_c = currentScene.input) === null || _c === void 0 || _c.toggleEnabled(!transition.blockInput);
                (_d = this._engine.input) === null || _d === void 0 || _d.toggleEnabled(!transition.blockInput);
                await this.currentTransition.play(this._engine);
                (_e = currentScene.input) === null || _e === void 0 || _e.toggleEnabled(sceneInputEnabled);
            }
            (_f = this.currentTransition) === null || _f === void 0 || _f.kill();
            (_g = this.currentTransition) === null || _g === void 0 || _g.reset();
            this.currentTransition = null;
        }
        /**
     * Swaps the current and destination scene after performing required lifecycle events
     * @param destinationScene
     * @param data
     */ async swapScene(destinationScene, data) {
            const engine = this._engine;
            // if not yet initialized defer goToScene
            if (!this.isInitialized) {
                this._deferredGoto = destinationScene;
                return;
            }
            const maybeDest = this.getSceneInstance(destinationScene);
            if (maybeDest) {
                const previousScene = this.currentScene;
                const nextScene = maybeDest;
                this._logger.debug("Going to scene:", destinationScene);
                // only deactivate when initialized
                if (this.currentScene.isInitialized) {
                    const context = {
                        engine: engine,
                        previousScene: previousScene,
                        nextScene: nextScene
                    };
                    await this.currentScene._deactivate(context);
                    this.currentScene.events.emit("deactivate", new DeactivateEvent(context, this.currentScene));
                }
                // wait for the scene to be loaded if needed
                const destLoader = this._sceneToLoader.get(destinationScene);
                await (destLoader === null || destLoader === void 0 ? void 0 : destLoader.areResourcesLoaded());
                // set current scene to new one
                this.currentScene = nextScene;
                this.currentSceneName = destinationScene;
                engine.screen.setCurrentCamera(nextScene.camera);
                // initialize the current scene if has not been already
                await this.currentScene._initialize(engine);
                const context = {
                    engine: engine,
                    previousScene: previousScene,
                    nextScene: nextScene,
                    data: data
                };
                await this.currentScene._activate(context);
                this.currentScene.events.emit("activate", new ActivateEvent(context, this.currentScene));
            } else this._logger.error("Scene", destinationScene, "does not exist!");
        }
        _emitEvent(eventName, sourceScene, destinationScene) {
            const source = this.getSceneDefinition(sourceScene);
            const dest = this.getSceneDefinition(destinationScene);
            this.events.emit(eventName, {
                sourceScene: source,
                sourceName: sourceScene,
                destinationScene: dest,
                destinationName: destinationScene
            });
        }
    }
    /**
 * Creates a injectable context that can be retrieved later with `useContext(context)`
 *
 * Example
 * ```typescript
 *
 * const AppContext = createContext({some: 'value'});
 * context.scope(val, () => {
 *    const value = useContext(AppContext);
 * })
 *
 * ```
 */ function createContext() {
        const ctx = {
            scope: (value, cb)=>{
                ctx.value = value;
                return cb();
            },
            value: undefined
        };
        return ctx;
    }
    /**
 * Retrieves the value from the current context
 */ function useContext(context) {
        return context.value;
    }
    polyfill();
    const EngineEvents = {
        FallbackGraphicsContext: "fallbackgraphicscontext",
        Initialize: "initialize",
        Visible: "visible",
        Hidden: "hidden",
        Start: "start",
        Stop: "stop",
        PreUpdate: "preupdate",
        PostUpdate: "postupdate",
        PreFrame: "preframe",
        PostFrame: "postframe",
        PreDraw: "predraw",
        PostDraw: "postdraw"
    };
    /**
 * Enum representing the different mousewheel event bubble prevention
 */ var ScrollPreventionMode;
    (function(ScrollPreventionMode) {
        /**
     * Do not prevent any page scrolling
     */ ScrollPreventionMode[ScrollPreventionMode["None"] = 0] = "None";
        /**
     * Prevent page scroll if mouse is over the game canvas
     */ ScrollPreventionMode[ScrollPreventionMode["Canvas"] = 1] = "Canvas";
        /**
     * Prevent all page scrolling via mouse wheel
     */ ScrollPreventionMode[ScrollPreventionMode["All"] = 2] = "All";
    })(ScrollPreventionMode || (ScrollPreventionMode = {}));
    /**
 * The Excalibur Engine
 *
 * The [[Engine]] is the main driver for a game. It is responsible for
 * starting/stopping the game, maintaining state, transmitting events,
 * loading resources, and managing the scene.
 */ class Engine {
        static useEngine() {
            const value = useContext(Engine.Context);
            if (!value) throw new Error("Cannot inject engine with `useEngine()`, `useEngine()` was called outside of Engine lifecycle scope.");
            return value;
        }
        /**
     * The width of the game canvas in pixels (physical width component of the
     * resolution of the canvas element)
     */ get canvasWidth() {
            return this.screen.canvasWidth;
        }
        /**
     * Returns half width of the game canvas in pixels (half physical width component)
     */ get halfCanvasWidth() {
            return this.screen.halfCanvasWidth;
        }
        /**
     * The height of the game canvas in pixels, (physical height component of
     * the resolution of the canvas element)
     */ get canvasHeight() {
            return this.screen.canvasHeight;
        }
        /**
     * Returns half height of the game canvas in pixels (half physical height component)
     */ get halfCanvasHeight() {
            return this.screen.halfCanvasHeight;
        }
        /**
     * Returns the width of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get drawWidth() {
            return this.screen.drawWidth;
        }
        /**
     * Returns half the width of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get halfDrawWidth() {
            return this.screen.halfDrawWidth;
        }
        /**
     * Returns the height of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get drawHeight() {
            return this.screen.drawHeight;
        }
        /**
     * Returns half the height of the engine's visible drawing surface in pixels including zoom and device pixel ratio.
     */ get halfDrawHeight() {
            return this.screen.halfDrawHeight;
        }
        /**
     * Returns whether excalibur detects the current screen to be HiDPI
     */ get isHiDpi() {
            return this.screen.isHiDpi;
        }
        /**
     * Access [[stats]] that holds frame statistics.
     */ get stats() {
            return this.debug.stats;
        }
        /**
     * The current [[Scene]] being drawn and updated on screen
     */ get currentScene() {
            return this.director.currentScene;
        }
        /**
     * The current [[Scene]] being drawn and updated on screen
     */ get currentSceneName() {
            return this.director.currentSceneName;
        }
        /**
     * The default [[Scene]] of the game, use [[Engine.goToScene]] to transition to different scenes.
     */ get rootScene() {
            return this.director.rootScene;
        }
        /**
     * Contains all the scenes currently registered with Excalibur
     */ get scenes() {
            return this.director.scenes;
        }
        /**
     * Indicates whether the engine is set to fullscreen or not
     */ get isFullscreen() {
            return this.screen.isFullScreen;
        }
        /**
     * Indicates the current [[DisplayMode]] of the engine.
     */ get displayMode() {
            return this.screen.displayMode;
        }
        /**
     * Returns the calculated pixel ration for use in rendering
     */ get pixelRatio() {
            return this.screen.pixelRatio;
        }
        get isDebug() {
            return this._isDebug;
        }
        /**
     * Hints the graphics context to truncate fractional world space coordinates
     */ get snapToPixel() {
            return this.graphicsContext.snapToPixel;
        }
        set snapToPixel(shouldSnapToPixel) {
            this.graphicsContext.snapToPixel = shouldSnapToPixel;
        }
        emit(eventName, event) {
            this.events.emit(eventName, event);
        }
        on(eventName, handler) {
            return this.events.on(eventName, handler);
        }
        once(eventName, handler) {
            return this.events.once(eventName, handler);
        }
        off(eventName, handler) {
            this.events.off(eventName, handler);
        }
        /**
     * Creates a new game using the given [[EngineOptions]]. By default, if no options are provided,
     * the game will be rendered full screen (taking up all available browser window space).
     * You can customize the game rendering through [[EngineOptions]].
     *
     * Example:
     *
     * ```js
     * var game = new ex.Engine({
     *   width: 0, // the width of the canvas
     *   height: 0, // the height of the canvas
     *   enableCanvasTransparency: true, // the transparencySection of the canvas
     *   canvasElementId: '', // the DOM canvas element ID, if you are providing your own
     *   displayMode: ex.DisplayMode.FullScreen, // the display mode
     *   pointerScope: ex.PointerScope.Document, // the scope of capturing pointer (mouse/touch) events
     *   backgroundColor: ex.Color.fromHex('#2185d0') // background color of the engine
     * });
     *
     * // call game.start, which is a Promise
     * game.start().then(function () {
     *   // ready, set, go!
     * });
     * ```
     */ constructor(options){
            var _a, _b, _c, _d, _e, _f, _g, _h;
            /**
         * Anything run under scope can use `useEngine()` to inject the current engine
         * @param cb
         */ this.scope = (cb)=>Engine.Context.scope(this, cb);
            /**
         * Current Excalibur version string
         *
         * Useful for plugins or other tools that need to know what features are available
         */ this.version = EX_VERSION;
            /**
         * Listen to and emit events on the Engine
         */ this.events = new EventEmitter();
            /**
         * Optionally set the maximum fps if not set Excalibur will go as fast as the device allows.
         *
         * You may want to constrain max fps if your game cannot maintain fps consistently, it can look and feel better to have a 30fps game than
         * one that bounces between 30fps and 60fps
         */ this.maxFps = Number.POSITIVE_INFINITY;
            this._inputEnabled = true;
            this._suppressPlayButton = false;
            /**
         * Indicates whether audio should be paused when the game is no longer visible.
         */ this.pauseAudioWhenHidden = true;
            /**
         * Indicates whether the engine should draw with debug information
         */ this._isDebug = false;
            /**
         * Sets the Transparency for the engine.
         */ this.enableCanvasTransparency = true;
            /**
         * The action to take when a fatal exception is thrown
         */ this.onFatalException = (e)=>{
                Logger.getInstance().fatal(e, e.stack);
            };
            this._toaster = new Toaster();
            this._timescale = 1.0;
            this._isInitialized = false;
            this._originalOptions = {};
            this._handleWebGLContextLost = (e)=>{
                var _a;
                e.preventDefault();
                this.clock.stop();
                this._logger.fatalOnce("WebGL Graphics Lost", e);
                const container = document.createElement("div");
                container.id = "ex-webgl-graphics-context-lost";
                container.style.position = "absolute";
                container.style.zIndex = "99";
                container.style.left = "50%";
                container.style.top = "50%";
                container.style.display = "flex";
                container.style.flexDirection = "column";
                container.style.transform = "translate(-50%, -50%)";
                container.style.backgroundColor = "white";
                container.style.padding = "10px";
                container.style.borderStyle = "solid 1px";
                const div = document.createElement("div");
                div.innerHTML = `
      <h1>There was an issue rendering, please refresh the page.</h1>
      <div>
        <p>WebGL Graphics Context Lost</p>

        <button id="ex-webgl-graphics-reload">Refresh Page</button>

        <p>There are a few reasons this might happen:</p>
        <ul>
          <li>Two or more pages are placing a high demand on the GPU</li>
          <li>Another page or operation has stalled the GPU and the browser has decided to reset the GPU</li>
          <li>The computer has multiple GPUs and the user has switched between them</li>
          <li>Graphics driver has crashed or restarted</li>
          <li>Graphics driver was updated</li>
        </ul>
      </div>
    `;
                container.appendChild(div);
                if ((_a = this.canvas) === null || _a === void 0 ? void 0 : _a.parentElement) {
                    this.canvas.parentElement.appendChild(container);
                    const button = div.querySelector("#ex-webgl-graphics-reload");
                    button === null || button === void 0 || button.addEventListener("click", ()=>location.reload());
                }
            };
            this._performanceThresholdTriggered = false;
            this._fpsSamples = [];
            this._disposed = false;
            this._isLoading = false;
            this._hideLoader = false;
            this._isReadyFuture = new Future();
            /**
         * Returns the current frames elapsed milliseconds
         */ this.currentFrameElapsedMs = 0;
            /**
         * Returns the current frame lag when in fixed update mode
         */ this.currentFrameLagMs = 0;
            this._lagMs = 0;
            this._screenShotRequests = [];
            options = {
                ...Engine._DEFAULT_ENGINE_OPTIONS,
                ...options
            };
            this._originalOptions = options;
            Flags.freeze();
            // Initialize browser events facade
            this.browser = new BrowserEvents(window, document);
            // Check compatibility
            const detector = new Detector();
            if (!options.suppressMinimumBrowserFeatureDetection && !(this._compatible = detector.test())) {
                const message = document.createElement("div");
                message.innerText = "Sorry, your browser does not support all the features needed for Excalibur";
                document.body.appendChild(message);
                detector.failedTests.forEach(function(test) {
                    const testMessage = document.createElement("div");
                    testMessage.innerText = "Browser feature missing " + test;
                    document.body.appendChild(testMessage);
                });
                if (options.canvasElementId) {
                    const canvas = document.getElementById(options.canvasElementId);
                    if (canvas) canvas.parentElement.removeChild(canvas);
                }
                return;
            } else this._compatible = true;
            // Use native console API for color fun
            // eslint-disable-next-line no-console
            if (console.log && !options.suppressConsoleBootMessage) {
                // eslint-disable-next-line no-console
                console.log(`%cPowered by Excalibur.js (v${EX_VERSION})`, "background: #176BAA; color: white; border-radius: 5px; padding: 15px; font-size: 1.5em; line-height: 80px;");
                // eslint-disable-next-line no-console
                console.log("\n      /| ________________\nO|===|* >________________>\n      \\|");
                // eslint-disable-next-line no-console
                console.log("Visit", "http://excaliburjs.com", "for more information");
            }
            // Suppress play button
            if (options.suppressPlayButton) this._suppressPlayButton = true;
            this._logger = Logger.getInstance();
            // If debug is enabled, let's log browser features to the console.
            if (this._logger.defaultLevel === LogLevel.Debug) detector.logBrowserFeatures();
            this._logger.debug("Building engine...");
            this.canvasElementId = options.canvasElementId;
            if (options.canvasElementId) {
                this._logger.debug("Using Canvas element specified: " + options.canvasElementId);
                //test for existence of element
                if (document.getElementById(options.canvasElementId) === null) throw new Error("Cannot find existing element in the DOM, please ensure element is created prior to engine creation.");
                this.canvas = document.getElementById(options.canvasElementId);
            } else if (options.canvasElement) {
                this._logger.debug("Using Canvas element specified:", options.canvasElement);
                this.canvas = options.canvasElement;
            } else {
                this._logger.debug("Using generated canvas element");
                this.canvas = document.createElement("canvas");
            }
            let displayMode = (_a = options.displayMode) !== null && _a !== void 0 ? _a : DisplayMode.Fixed;
            if (options.width && options.height || options.viewport) {
                if (options.displayMode === undefined) displayMode = DisplayMode.Fixed;
                this._logger.debug("Engine viewport is size " + options.width + " x " + options.height);
            } else if (!options.displayMode) {
                this._logger.debug("Engine viewport is fit");
                displayMode = DisplayMode.FitScreen;
            }
            this._originalDisplayMode = displayMode;
            let pixelArtSampler;
            let uvPadding;
            let nativeContextAntialiasing;
            let canvasImageRendering;
            let filtering;
            let multiSampleAntialiasing;
            if (typeof options.antialiasing === "object") ({ pixelArtSampler: pixelArtSampler, nativeContextAntialiasing: nativeContextAntialiasing, multiSampleAntialiasing: multiSampleAntialiasing, filtering: filtering, canvasImageRendering: canvasImageRendering } = {
                ...options.pixelArt ? DefaultPixelArtOptions : DefaultAntialiasOptions,
                ...options.antialiasing
            });
            else {
                pixelArtSampler = !!options.pixelArt;
                nativeContextAntialiasing = false;
                multiSampleAntialiasing = options.antialiasing;
                canvasImageRendering = options.antialiasing ? "auto" : "pixelated";
                filtering = options.antialiasing ? ImageFiltering.Blended : ImageFiltering.Pixel;
            }
            if (nativeContextAntialiasing && multiSampleAntialiasing) this._logger.warnOnce(`Cannot use antialias setting nativeContextAntialiasing and multiSampleAntialiasing` + ` at the same time, they are incompatible settings. If you aren\'t sure use multiSampleAntialiasing`);
            if (options.pixelArt) uvPadding = .25;
            if (!options.antialiasing || filtering === ImageFiltering.Pixel) uvPadding = 0;
            // Override with any user option, if non default to .25 for pixel art, 0.01 for everything else
            uvPadding = (_c = (_b = options.uvPadding) !== null && _b !== void 0 ? _b : uvPadding) !== null && _c !== void 0 ? _c : 0.01;
            // Canvas 2D fallback can be flagged on
            let useCanvasGraphicsContext = Flags.isEnabled("use-canvas-context");
            if (!useCanvasGraphicsContext) // Attempt webgl first
            try {
                this.graphicsContext = new ExcaliburGraphicsContextWebGL({
                    canvasElement: this.canvas,
                    enableTransparency: this.enableCanvasTransparency,
                    pixelArtSampler: pixelArtSampler,
                    antialiasing: nativeContextAntialiasing,
                    multiSampleAntialiasing: multiSampleAntialiasing,
                    uvPadding: uvPadding,
                    powerPreference: options.powerPreference,
                    backgroundColor: options.backgroundColor,
                    snapToPixel: options.snapToPixel,
                    useDrawSorting: options.useDrawSorting,
                    handleContextLost: (_d = options.handleContextLost) !== null && _d !== void 0 ? _d : this._handleWebGLContextLost,
                    handleContextRestored: options.handleContextRestored
                });
            } catch (e) {
                this._logger.warn(`Excalibur could not load webgl for some reason (${e.message}) and loaded a Canvas 2D fallback. ` + `Some features of Excalibur will not work in this mode. \n\n` + "Read more about this issue at https://excaliburjs.com/docs/performance");
                // fallback to canvas in case of failure
                useCanvasGraphicsContext = true;
            }
            if (useCanvasGraphicsContext) this.graphicsContext = new ExcaliburGraphicsContext2DCanvas({
                canvasElement: this.canvas,
                enableTransparency: this.enableCanvasTransparency,
                antialiasing: nativeContextAntialiasing,
                backgroundColor: options.backgroundColor,
                snapToPixel: options.snapToPixel,
                useDrawSorting: options.useDrawSorting
            });
            this.screen = new Screen({
                canvas: this.canvas,
                context: this.graphicsContext,
                antialiasing: nativeContextAntialiasing,
                canvasImageRendering: canvasImageRendering,
                browser: this.browser,
                viewport: (_e = options.viewport) !== null && _e !== void 0 ? _e : options.width && options.height ? {
                    width: options.width,
                    height: options.height
                } : Resolution.SVGA,
                resolution: options.resolution,
                displayMode: displayMode,
                pixelRatio: options.suppressHiDPIScaling ? 1 : (_f = options.pixelRatio) !== null && _f !== void 0 ? _f : null
            });
            // TODO REMOVE STATIC!!!
            // Set default filtering based on antialiasing
            TextureLoader.filtering = filtering;
            if (options.backgroundColor) this.backgroundColor = options.backgroundColor.clone();
            this.grabWindowFocus = options.grabWindowFocus;
            this.pointerScope = options.pointerScope;
            this.maxFps = (_g = options.maxFps) !== null && _g !== void 0 ? _g : this.maxFps;
            this.fixedUpdateFps = (_h = options.fixedUpdateFps) !== null && _h !== void 0 ? _h : this.fixedUpdateFps;
            this.clock = new StandardClock({
                maxFps: this.maxFps,
                tick: this._mainloop.bind(this),
                onFatalException: (e)=>this.onFatalException(e)
            });
            this.enableCanvasTransparency = options.enableCanvasTransparency;
            if (typeof options.physics === "boolean") this.physics = {
                ...DefaultPhysicsConfig,
                ...DeprecatedStaticToConfig(),
                enabled: options.physics
            };
            else this.physics = {
                ...DefaultPhysicsConfig,
                ...DeprecatedStaticToConfig(),
                ...options.physics
            };
            this.debug = new DebugConfig(this);
            this.director = new Director(this, options.scenes);
            this._initialize(options);
            window.___EXCALIBUR_DEVTOOL = this;
            Engine.InstanceCount++;
        }
        _monitorPerformanceThresholdAndTriggerFallback() {
            const { allow: allow } = this._originalOptions.configurePerformanceCanvas2DFallback;
            let { threshold: threshold, showPlayerMessage: showPlayerMessage } = this._originalOptions.configurePerformanceCanvas2DFallback;
            if (threshold === undefined) threshold = Engine._DEFAULT_ENGINE_OPTIONS.configurePerformanceCanvas2DFallback.threshold;
            if (showPlayerMessage === undefined) showPlayerMessage = Engine._DEFAULT_ENGINE_OPTIONS.configurePerformanceCanvas2DFallback.showPlayerMessage;
            if (!Flags.isEnabled("use-canvas-context") && allow && this.ready && !this._performanceThresholdTriggered) {
                // Calculate Average fps for last X number of frames after start
                if (this._fpsSamples.length === threshold.numberOfFrames) this._fpsSamples.splice(0, 1);
                this._fpsSamples.push(this.clock.fpsSampler.fps);
                let total = 0;
                for(let i = 0; i < this._fpsSamples.length; i++)total += this._fpsSamples[i];
                const average = total / this._fpsSamples.length;
                if (this._fpsSamples.length === threshold.numberOfFrames) {
                    if (average <= threshold.fps) {
                        this._performanceThresholdTriggered = true;
                        this._logger.warn(`Switching to browser 2D Canvas fallback due to performance. Some features of Excalibur will not work in this mode.\n` + "this might mean your browser doesn't have webgl enabled or hardware acceleration is unavailable.\n\n" + "If in Chrome:\n" + '  * Visit Settings > Advanced > System, and ensure "Use Hardware Acceleration" is checked.\n' + '  * Visit chrome://flags/#ignore-gpu-blocklist and ensure "Override software rendering list" is "enabled"\n' + "If in Firefox, visit about:config\n" + "  * Ensure webgl.disabled = false\n" + "  * Ensure webgl.force-enabled = true\n" + "  * Ensure layers.acceleration.force-enabled = true\n\n" + "Read more about this issue at https://excaliburjs.com/docs/performance");
                        if (showPlayerMessage) this._toaster.toast("Excalibur is encountering performance issues. It's possible that your browser doesn't have hardware acceleration enabled. Visit [LINK] for more information and potential solutions.", "https://excaliburjs.com/docs/performance");
                        this.useCanvas2DFallback();
                        this.emit("fallbackgraphicscontext", this.graphicsContext);
                    }
                }
            }
        }
        /**
     * Switches the engine's graphics context to the 2D Canvas.
     * @warning Some features of Excalibur will not work in this mode.
     */ useCanvas2DFallback() {
            var _a, _b, _c;
            // Swap out the canvas
            const newCanvas = this.canvas.cloneNode(false);
            this.canvas.parentNode.replaceChild(newCanvas, this.canvas);
            this.canvas = newCanvas;
            const options = {
                ...this._originalOptions,
                antialiasing: this.getAntialiasing()
            };
            const displayMode = this._originalDisplayMode;
            // New graphics context
            this.graphicsContext = new ExcaliburGraphicsContext2DCanvas({
                canvasElement: this.canvas,
                enableTransparency: this.enableCanvasTransparency,
                antialiasing: options.antialiasing,
                backgroundColor: options.backgroundColor,
                snapToPixel: options.snapToPixel,
                useDrawSorting: options.useDrawSorting
            });
            // Reset screen
            if (this.screen) this.screen.dispose();
            this.screen = new Screen({
                canvas: this.canvas,
                context: this.graphicsContext,
                antialiasing: (_a = options.antialiasing) !== null && _a !== void 0 ? _a : true,
                browser: this.browser,
                viewport: (_b = options.viewport) !== null && _b !== void 0 ? _b : options.width && options.height ? {
                    width: options.width,
                    height: options.height
                } : Resolution.SVGA,
                resolution: options.resolution,
                displayMode: displayMode,
                pixelRatio: options.suppressHiDPIScaling ? 1 : (_c = options.pixelRatio) !== null && _c !== void 0 ? _c : null
            });
            this.screen.setCurrentCamera(this.currentScene.camera);
            // Reset pointers
            this.input.pointers.detach();
            const pointerTarget = options && options.pointerScope === PointerScope.Document ? document : this.canvas;
            this.input.pointers = this.input.pointers.recreate(pointerTarget, this);
            this.input.pointers.init();
        }
        /**
     * Attempts to completely clean up excalibur resources, including removing the canvas from the dom.
     *
     * To start again you will need to new up an Engine.
     */ dispose() {
            if (!this._disposed) {
                this._disposed = true;
                this.stop();
                this.input.toggleEnabled(false);
                this.canvas.parentNode.removeChild(this.canvas);
                this.canvas = null;
                this.screen.dispose();
                this.graphicsContext.dispose();
                this.graphicsContext = null;
                Engine.InstanceCount--;
            }
        }
        isDisposed() {
            return this._disposed;
        }
        /**
     * Returns a BoundingBox of the top left corner of the screen
     * and the bottom right corner of the screen.
     */ getWorldBounds() {
            return this.screen.getWorldBounds();
        }
        /**
     * Gets the current engine timescale factor (default is 1.0 which is 1:1 time)
     */ get timescale() {
            return this._timescale;
        }
        /**
     * Sets the current engine timescale factor. Useful for creating slow-motion effects or fast-forward effects
     * when using time-based movement.
     */ set timescale(value) {
            if (value <= 0) {
                Logger.getInstance().error("Cannot set engine.timescale to a value of 0 or less than 0.");
                return;
            }
            this._timescale = value;
        }
        /**
     * Adds a [[Timer]] to the [[currentScene]].
     * @param timer  The timer to add to the [[currentScene]].
     */ addTimer(timer) {
            return this.currentScene.addTimer(timer);
        }
        /**
     * Removes a [[Timer]] from the [[currentScene]].
     * @param timer  The timer to remove to the [[currentScene]].
     */ removeTimer(timer) {
            return this.currentScene.removeTimer(timer);
        }
        /**
     * Adds a [[Scene]] to the engine, think of scenes in Excalibur as you
     * would levels or menus.
     * @param key  The name of the scene, must be unique
     * @param scene The scene to add to the engine
     */ addScene(key, scene) {
            this.director.add(key, scene);
            return this;
        }
        /**
     * @internal
     */ removeScene(entity) {
            this.director.remove(entity);
        }
        add(entity) {
            if (arguments.length === 2) {
                this.director.add(arguments[0], arguments[1]);
                return;
            }
            const maybeDeferred = this.director.getDeferredScene();
            if (maybeDeferred instanceof Scene) maybeDeferred.add(entity);
            else this.currentScene.add(entity);
        }
        remove(entity) {
            if (entity instanceof Entity) this.currentScene.remove(entity);
            if (entity instanceof Scene || isSceneConstructor(entity)) this.removeScene(entity);
            if (typeof entity === "string") this.removeScene(entity);
        }
        /**
     * Changes the current scene with optionally supplied:
     * * Activation data
     * * Transitions
     * * Loaders
     *
     * Example:
     * ```typescript
     * game.goToScene('myScene', {
     *   sceneActivationData: {any: 'thing at all'},
     *   destinationIn: new FadeInOut({duration: 1000, direction: 'in'}),
     *   sourceOut: new FadeInOut({duration: 1000, direction: 'out'}),
     *   loader: MyLoader
     * });
     * ```
     *
     * Scenes are defined in the Engine constructor
     * ```typescript
     * const engine = new ex.Engine({
        scenes: {...}
      });
     * ```
     * Or by adding dynamically
     *
     * ```typescript
     * engine.addScene('myScene', new ex.Scene());
     * ```
     * @param destinationScene
     * @param options
     * @deprecated use goToScene, it now behaves the same as goto
     */ async goto(destinationScene, options) {
            await this.scope(async ()=>{
                await this.director.goto(destinationScene, options);
            });
        }
        /**
     * Changes the current scene with optionally supplied:
     * * Activation data
     * * Transitions
     * * Loaders
     *
     * Example:
     * ```typescript
     * game.goToScene('myScene', {
     *   sceneActivationData: {any: 'thing at all'},
     *   destinationIn: new FadeInOut({duration: 1000, direction: 'in'}),
     *   sourceOut: new FadeInOut({duration: 1000, direction: 'out'}),
     *   loader: MyLoader
     * });
     * ```
     *
     * Scenes are defined in the Engine constructor
     * ```typescript
     * const engine = new ex.Engine({
        scenes: {...}
      });
     * ```
     * Or by adding dynamically
     *
     * ```typescript
     * engine.addScene('myScene', new ex.Scene());
     * ```
     * @param destinationScene
     * @param options
     */ async goToScene(destinationScene, options) {
            await this.scope(async ()=>{
                await this.director.goto(destinationScene, options);
            });
        }
        /**
     * Transforms the current x, y from screen coordinates to world coordinates
     * @param point  Screen coordinate to convert
     */ screenToWorldCoordinates(point) {
            return this.screen.screenToWorldCoordinates(point);
        }
        /**
     * Transforms a world coordinate, to a screen coordinate
     * @param point  World coordinate to convert
     */ worldToScreenCoordinates(point) {
            return this.screen.worldToScreenCoordinates(point);
        }
        /**
     * Initializes the internal canvas, rendering context, display mode, and native event listeners
     */ _initialize(options) {
            var _a, _b;
            this.pageScrollPreventionMode = options.scrollPreventionMode;
            // initialize inputs
            const pointerTarget = options && options.pointerScope === PointerScope.Document ? document : this.canvas;
            const grabWindowFocus = (_b = (_a = this._originalOptions) === null || _a === void 0 ? void 0 : _a.grabWindowFocus) !== null && _b !== void 0 ? _b : true;
            this.input = new InputHost({
                pointerTarget: pointerTarget,
                grabWindowFocus: grabWindowFocus,
                engine: this
            });
            this.inputMapper = this.input.inputMapper;
            // Issue #385 make use of the visibility api
            // https://developer.mozilla.org/en-US/docs/Web/Guide/User_experience/Using_the_Page_Visibility_API
            this.browser.document.on("visibilitychange", ()=>{
                if (document.visibilityState === "hidden") {
                    this.events.emit("hidden", new HiddenEvent(this));
                    this._logger.debug("Window hidden");
                } else if (document.visibilityState === "visible") {
                    this.events.emit("visible", new VisibleEvent(this));
                    this._logger.debug("Window visible");
                }
            });
            if (!this.canvasElementId && !options.canvasElement) document.body.appendChild(this.canvas);
        }
        toggleInputEnabled(enabled) {
            this._inputEnabled = enabled;
            this.input.toggleEnabled(this._inputEnabled);
        }
        onInitialize(engine) {
        // Override me
        }
        /**
     * If supported by the browser, this will set the antialiasing flag on the
     * canvas. Set this to `false` if you want a 'jagged' pixel art look to your
     * image resources.
     * @param isSmooth  Set smoothing to true or false
     * @deprecated Set in engine constructor, will be removed in v0.30
     */ setAntialiasing(isSmooth) {
            this.screen.antialiasing = isSmooth;
        }
        /**
     * Return the current smoothing status of the canvas
     * @deprecated Set in engine constructor, will be removed in v0.30
     */ getAntialiasing() {
            return this.screen.antialiasing;
        }
        /**
     * Gets whether the actor is Initialized
     */ get isInitialized() {
            return this._isInitialized;
        }
        async _overrideInitialize(engine) {
            if (!this.isInitialized) {
                await this.director.onInitialize();
                await this.onInitialize(engine);
                this.events.emit("initialize", new InitializeEvent(engine, this));
                this._isInitialized = true;
            }
        }
        /**
     * Updates the entire state of the game
     * @param delta  Number of milliseconds elapsed since the last update.
     */ _update(delta) {
            var _a;
            if (this._isLoading) {
                // suspend updates until loading is finished
                (_a = this._loader) === null || _a === void 0 || _a.onUpdate(this, delta);
                // Update input listeners
                this.input.update();
                return;
            }
            // Publish preupdate events
            this.clock.__runScheduledCbs("preupdate");
            this._preupdate(delta);
            // process engine level events
            this.currentScene.update(this, delta);
            // Update graphics postprocessors
            this.graphicsContext.updatePostProcessors(delta);
            // Publish update event
            this.clock.__runScheduledCbs("postupdate");
            this._postupdate(delta);
            // Update input listeners
            this.input.update();
        }
        /**
     * @internal
     */ _preupdate(delta) {
            this.emit("preupdate", new PreUpdateEvent(this, delta, this));
            this.onPreUpdate(this, delta);
        }
        onPreUpdate(engine, delta) {
        // Override me
        }
        /**
     * @internal
     */ _postupdate(delta) {
            this.emit("postupdate", new PostUpdateEvent(this, delta, this));
            this.onPostUpdate(this, delta);
        }
        onPostUpdate(engine, delta) {
        // Override me
        }
        /**
     * Draws the entire game
     * @param delta  Number of milliseconds elapsed since the last draw.
     */ _draw(delta) {
            var _a, _b;
            this.graphicsContext.beginDrawLifecycle();
            this.graphicsContext.clear();
            this.clock.__runScheduledCbs("predraw");
            this._predraw(this.graphicsContext, delta);
            // Drawing nothing else while loading
            if (this._isLoading) {
                if (!this._hideLoader) {
                    (_a = this._loader) === null || _a === void 0 || _a.canvas.draw(this.graphicsContext, 0, 0);
                    this.clock.__runScheduledCbs("postdraw");
                    this.graphicsContext.flush();
                    this.graphicsContext.endDrawLifecycle();
                }
                return;
            }
            // Use scene background color if present, fallback to engine
            this.graphicsContext.backgroundColor = (_b = this.currentScene.backgroundColor) !== null && _b !== void 0 ? _b : this.backgroundColor;
            this.currentScene.draw(this.graphicsContext, delta);
            this.clock.__runScheduledCbs("postdraw");
            this._postdraw(this.graphicsContext, delta);
            // Flush any pending drawings
            this.graphicsContext.flush();
            this.graphicsContext.endDrawLifecycle();
            this._checkForScreenShots();
        }
        /**
     * @internal
     */ _predraw(ctx, delta) {
            this.emit("predraw", new PreDrawEvent(ctx, delta, this));
            this.onPreDraw(ctx, delta);
        }
        onPreDraw(ctx, delta) {
        // Override me
        }
        /**
     * @internal
     */ _postdraw(ctx, delta) {
            this.emit("postdraw", new PostDrawEvent(ctx, delta, this));
            this.onPostDraw(ctx, delta);
        }
        onPostDraw(ctx, delta) {
        // Override me
        }
        /**
     * Enable or disable Excalibur debugging functionality.
     * @param toggle a value that debug drawing will be changed to
     */ showDebug(toggle) {
            this._isDebug = toggle;
        }
        /**
     * Toggle Excalibur debugging functionality.
     */ toggleDebug() {
            this._isDebug = !this._isDebug;
            return this._isDebug;
        }
        /**
     * Returns true when loading is totally complete and the player has clicked start
     */ get loadingComplete() {
            return !this._isLoading;
        }
        get ready() {
            return this._isReadyFuture.isCompleted;
        }
        isReady() {
            return this._isReadyFuture.promise;
        }
        async start(sceneNameOrLoader, options) {
            await this.scope(async ()=>{
                if (!this._compatible) throw new Error("Excalibur is incompatible with your browser");
                this._isLoading = true;
                let loader;
                if (sceneNameOrLoader instanceof DefaultLoader) loader = sceneNameOrLoader;
                else if (typeof sceneNameOrLoader === "string") {
                    this.director.configureStart(sceneNameOrLoader, options);
                    loader = this.director.mainLoader;
                }
                // Start the excalibur clock which drives the mainloop
                this._logger.debug("Starting game clock...");
                this.browser.resume();
                this.clock.start();
                this._logger.debug("Game clock started");
                await this.load(loader !== null && loader !== void 0 ? loader : new Loader());
                // Initialize before ready
                await this._overrideInitialize(this);
                this._isReadyFuture.resolve();
                this.emit("start", new GameStartEvent(this));
                return this._isReadyFuture.promise;
            });
        }
        _mainloop(elapsed) {
            this.scope(()=>{
                this.emit("preframe", new PreFrameEvent(this, this.stats.prevFrame));
                const delta = elapsed * this.timescale;
                this.currentFrameElapsedMs = delta;
                // reset frame stats (reuse existing instances)
                const frameId = this.stats.prevFrame.id + 1;
                this.stats.currFrame.reset();
                this.stats.currFrame.id = frameId;
                this.stats.currFrame.delta = delta;
                this.stats.currFrame.fps = this.clock.fpsSampler.fps;
                GraphicsDiagnostics.clear();
                const beforeUpdate = this.clock.now();
                const fixedTimestepMs = 1000 / this.fixedUpdateFps;
                if (this.fixedUpdateFps) {
                    this._lagMs += delta;
                    while(this._lagMs >= fixedTimestepMs){
                        this._update(fixedTimestepMs);
                        this._lagMs -= fixedTimestepMs;
                    }
                } else this._update(delta);
                const afterUpdate = this.clock.now();
                this.currentFrameLagMs = this._lagMs;
                this._draw(delta);
                const afterDraw = this.clock.now();
                this.stats.currFrame.duration.update = afterUpdate - beforeUpdate;
                this.stats.currFrame.duration.draw = afterDraw - afterUpdate;
                this.stats.currFrame.graphics.drawnImages = GraphicsDiagnostics.DrawnImagesCount;
                this.stats.currFrame.graphics.drawCalls = GraphicsDiagnostics.DrawCallCount;
                this.emit("postframe", new PostFrameEvent(this, this.stats.currFrame));
                this.stats.prevFrame.reset(this.stats.currFrame);
                this._monitorPerformanceThresholdAndTriggerFallback();
            });
        }
        /**
     * Stops Excalibur's main loop, useful for pausing the game.
     */ stop() {
            if (this.clock.isRunning()) {
                this.emit("stop", new GameStopEvent(this));
                this.browser.pause();
                this.clock.stop();
                this._logger.debug("Game stopped");
            }
        }
        /**
     * Returns the Engine's running status, Useful for checking whether engine is running or paused.
     */ isRunning() {
            return this.clock.isRunning();
        }
        /**
     * Takes a screen shot of the current viewport and returns it as an
     * HTML Image Element.
     * @param preserveHiDPIResolution in the case of HiDPI return the full scaled backing image, by default false
     */ screenshot(preserveHiDPIResolution = false) {
            const screenShotPromise = new Promise((resolve)=>{
                this._screenShotRequests.push({
                    preserveHiDPIResolution: preserveHiDPIResolution,
                    resolve: resolve
                });
            });
            return screenShotPromise;
        }
        _checkForScreenShots() {
            // We must grab the draw buffer before we yield to the browser
            // the draw buffer is cleared after compositing
            // the reason for the asynchrony is setting `preserveDrawingBuffer: true`
            // forces the browser to copy buffers which can have a mass perf impact on mobile
            for (const request of this._screenShotRequests){
                const finalWidth = request.preserveHiDPIResolution ? this.canvas.width : this.screen.resolution.width;
                const finalHeight = request.preserveHiDPIResolution ? this.canvas.height : this.screen.resolution.height;
                const screenshot = document.createElement("canvas");
                screenshot.width = finalWidth;
                screenshot.height = finalHeight;
                const ctx = screenshot.getContext("2d");
                ctx.imageSmoothingEnabled = this.screen.antialiasing;
                ctx.drawImage(this.canvas, 0, 0, finalWidth, finalHeight);
                const result = new Image();
                const raw = screenshot.toDataURL("image/png");
                result.src = raw;
                request.resolve(result);
            }
            // Reset state
            this._screenShotRequests.length = 0;
        }
        /**
     * Another option available to you to load resources into the game.
     * Immediately after calling this the game will pause and the loading screen
     * will appear.
     * @param loader  Some [[Loadable]] such as a [[Loader]] collection, [[Sound]], or [[Texture]].
     */ async load(loader, hideLoader = false) {
            await this.scope(async ()=>{
                try {
                    // early exit if loaded
                    if (loader.isLoaded()) return;
                    this._loader = loader;
                    this._isLoading = true;
                    this._hideLoader = hideLoader;
                    if (loader instanceof Loader) loader.suppressPlayButton = this._suppressPlayButton;
                    this._loader.onInitialize(this);
                    await loader.load();
                } catch (e) {
                    this._logger.error("Error loading resources, things may not behave properly", e);
                    await Promise.resolve();
                } finally{
                    this._isLoading = false;
                    this._hideLoader = false;
                    this._loader = null;
                }
            });
        }
    }
    Engine.Context = createContext();
    Engine.InstanceCount = 0;
    /**
 * Default [[EngineOptions]]
 */ Engine._DEFAULT_ENGINE_OPTIONS = {
        width: 0,
        height: 0,
        enableCanvasTransparency: true,
        useDrawSorting: true,
        configurePerformanceCanvas2DFallback: {
            allow: false,
            showPlayerMessage: false,
            threshold: {
                fps: 20,
                numberOfFrames: 100
            }
        },
        canvasElementId: "",
        canvasElement: undefined,
        snapToPixel: false,
        antialiasing: true,
        pixelArt: false,
        powerPreference: "high-performance",
        pointerScope: PointerScope.Canvas,
        suppressConsoleBootMessage: null,
        suppressMinimumBrowserFeatureDetection: null,
        suppressHiDPIScaling: null,
        suppressPlayButton: null,
        grabWindowFocus: true,
        scrollPreventionMode: ScrollPreventionMode.Canvas,
        backgroundColor: Color.fromHex("#2185d0") // Excalibur blue
    };
    /**
 * @deprecated Use [[EventEmitter]] will be removed in v0.29.0
 */ class EventDispatcher {
        constructor(){
            this._handlers = {};
            this._wiredEventDispatchers = [];
            this._deferedHandlerRemovals = [];
        }
        /**
     * Clears any existing handlers or wired event dispatchers on this event dispatcher
     */ clear() {
            this._handlers = {};
            this._wiredEventDispatchers = [];
        }
        _processDeferredHandlerRemovals() {
            for (const eventHandler of this._deferedHandlerRemovals)this._removeHandler(eventHandler.name, eventHandler.handler);
            this._deferedHandlerRemovals.length = 0;
        }
        /**
     * Emits an event for target
     * @param eventName  The name of the event to publish
     * @param event      Optionally pass an event data object to the handler
     */ emit(eventName, event) {
            this._processDeferredHandlerRemovals();
            if (!eventName) // key not mapped
            return;
            eventName = eventName.toLowerCase();
            if (typeof event === "undefined" || event === null) event = new GameEvent();
            let i, len;
            if (this._handlers[eventName]) {
                i = 0;
                len = this._handlers[eventName].length;
                for(i; i < len; i++)this._handlers[eventName][i](event);
            }
            i = 0;
            len = this._wiredEventDispatchers.length;
            for(i; i < len; i++)this._wiredEventDispatchers[i].emit(eventName, event);
        }
        /**
     * Subscribe an event handler to a particular event name, multiple handlers per event name are allowed.
     * @param eventName  The name of the event to subscribe to
     * @param handler    The handler callback to fire on this event
     */ on(eventName, handler) {
            this._processDeferredHandlerRemovals();
            eventName = eventName.toLowerCase();
            if (!this._handlers[eventName]) this._handlers[eventName] = [];
            this._handlers[eventName].push(handler);
        }
        /**
     * Unsubscribe an event handler(s) from an event. If a specific handler
     * is specified for an event, only that handler will be unsubscribed.
     * Otherwise all handlers will be unsubscribed for that event.
     * @param eventName  The name of the event to unsubscribe
     * @param handler    Optionally the specific handler to unsubscribe
     */ off(eventName, handler) {
            this._deferedHandlerRemovals.push({
                name: eventName,
                handler: handler
            });
        }
        _removeHandler(eventName, handler) {
            eventName = eventName.toLowerCase();
            const eventHandlers = this._handlers[eventName];
            if (eventHandlers) {
                // if no explicit handler is give with the event name clear all handlers
                if (!handler) this._handlers[eventName].length = 0;
                else {
                    const index = eventHandlers.indexOf(handler);
                    if (index > -1) this._handlers[eventName].splice(index, 1);
                }
            }
        }
        /**
     * Once listens to an event one time, then unsubscribes from that event
     * @param eventName The name of the event to subscribe to once
     * @param handler   The handler of the event that will be auto unsubscribed
     */ once(eventName, handler) {
            this._processDeferredHandlerRemovals();
            const metaHandler = (event)=>{
                const ev = event || new GameEvent();
                this.off(eventName, metaHandler);
                handler(ev);
            };
            this.on(eventName, metaHandler);
        }
        /**
     * Wires this event dispatcher to also receive events from another
     */ wire(eventDispatcher) {
            eventDispatcher._wiredEventDispatchers.push(this);
        }
        /**
     * Unwires this event dispatcher from another
     */ unwire(eventDispatcher) {
            const index = eventDispatcher._wiredEventDispatchers.indexOf(this);
            if (index > -1) eventDispatcher._wiredEventDispatchers.splice(index, 1);
        }
    }
    /**
 * Labels are the way to draw small amounts of text to the screen. They are
 * actors and inherit all of the benefits and capabilities.
 */ class Label extends Actor {
        get font() {
            return this._font;
        }
        set font(newFont) {
            this._font = newFont;
            this._text.font = newFont;
        }
        /**
     * The text to draw.
     */ get text() {
            return this._text.text;
        }
        set text(text) {
            this._text.text = text;
        }
        get color() {
            return this._text.color;
        }
        set color(color) {
            if (this._text) this._text.color = color;
        }
        get opacity() {
            return this._text.opacity;
        }
        set opacity(opacity) {
            this._text.opacity = opacity;
        }
        /**
     * The [[SpriteFont]] to use, if any. Overrides [[Font|font]] if present.
     */ get spriteFont() {
            return this._spriteFont;
        }
        set spriteFont(sf) {
            if (sf) {
                this._spriteFont = sf;
                this._text.font = this._spriteFont;
            }
        }
        /**
     * Build a new label
     * @param options
     */ constructor(options){
            super(options);
            this._font = new Font();
            this._text = new Text({
                text: "",
                font: this._font
            });
            const { text: text, pos: pos, x: x, y: y, spriteFont: spriteFont, font: font, color: color } = {
                text: "",
                ...options
            };
            this.pos = pos !== null && pos !== void 0 ? pos : x && y ? vec(x, y) : this.pos;
            this.text = text !== null && text !== void 0 ? text : this.text;
            this.font = font !== null && font !== void 0 ? font : this.font;
            this.spriteFont = spriteFont !== null && spriteFont !== void 0 ? spriteFont : this.spriteFont;
            this._text.color = color !== null && color !== void 0 ? color : this.color;
            const gfx = this.get(GraphicsComponent);
            gfx.anchor = Vector.Zero;
            gfx.use(this._text);
        }
        _initialize(engine) {
            super._initialize(engine);
        }
        /**
     * Returns the width of the text in the label (in pixels);
     */ getTextWidth() {
            return this._text.width;
        }
    }
    class IsometricTile extends Entity {
        getGraphics() {
            return this._graphics;
        }
        /**
     * Tile graphics
     */ addGraphic(graphic, options) {
            this._graphics.push(graphic);
            this._gfx.visible = this.map.visible;
            this._gfx.opacity = this.map.opacity;
            if (options === null || options === void 0 ? void 0 : options.offset) this._gfx.offset = options.offset;
            // TODO detect when this changes on the map and apply to all tiles
            this._gfx.localBounds = this._recalculateBounds();
        }
        _recalculateBounds() {
            let bounds = this._tileBounds.clone();
            for (const graphic of this._graphics){
                const offset = vec(this.map.graphicsOffset.x - this.map.tileWidth / 2, this.map.graphicsOffset.y - (this.map.renderFromTopOfGraphic ? 0 : graphic.height - this.map.tileHeight));
                bounds = bounds.combine(graphic.localBounds.translate(offset));
            }
            return bounds;
        }
        removeGraphic(graphic) {
            const index = this._graphics.indexOf(graphic);
            if (index > -1) this._graphics.splice(index, 1);
            this._gfx.localBounds = this._recalculateBounds();
        }
        clearGraphics() {
            this._graphics.length = 0;
            this._gfx.visible = false;
            this._gfx.localBounds = this._recalculateBounds();
        }
        getColliders() {
            return this._colliders;
        }
        /**
     * Adds a collider to the IsometricTile
     *
     * **Note!** the [[Tile.solid]] must be set to true for it to act as a "fixed" collider
     * @param collider
     */ addCollider(collider) {
            this._colliders.push(collider);
            this.map.flagCollidersDirty();
        }
        /**
     * Removes a collider from the IsometricTile
     * @param collider
     */ removeCollider(collider) {
            const index = this._colliders.indexOf(collider);
            if (index > -1) this._colliders.splice(index, 1);
            this.map.flagCollidersDirty();
        }
        /**
     * Clears all colliders from the IsometricTile
     */ clearColliders() {
            this._colliders.length = 0;
            this.map.flagCollidersDirty();
        }
        /**
     * Returns the top left corner of the [[IsometricTile]] in world space
     */ get pos() {
            return this.map.tileToWorld(vec(this.x, this.y));
        }
        /**
     * Returns the center of the [[IsometricTile]]
     */ get center() {
            return this.pos.add(vec(0, this.map.tileHeight / 2));
        }
        /**
     * Construct a new IsometricTile
     * @param x tile coordinate in x (not world position)
     * @param y tile coordinate in y (not world position)
     * @param graphicsOffset offset that tile should be shifted by (default (0, 0))
     * @param map reference to owning IsometricMap
     */ constructor(x, y, graphicsOffset, map){
            super([
                new TransformComponent(),
                new GraphicsComponent({
                    offset: graphicsOffset !== null && graphicsOffset !== void 0 ? graphicsOffset : Vector.Zero,
                    onPostDraw: (gfx, elapsed)=>this.draw(gfx, elapsed)
                }),
                new IsometricEntityComponent(map)
            ]);
            /**
         * Indicates whether this tile is solid
         */ this.solid = false;
            this.events = new EventEmitter();
            this._tileBounds = new BoundingBox();
            this._graphics = [];
            /**
         * Tile colliders
         */ this._colliders = [];
            /**
         * Arbitrary data storage per tile, useful for any game specific data
         */ this.data = new Map();
            this.x = x;
            this.y = y;
            this.map = map;
            this._transform = this.get(TransformComponent);
            this._isometricEntityComponent = this.get(IsometricEntityComponent);
            const halfTileWidth = this.map.tileWidth / 2;
            const halfTileHeight = this.map.tileHeight / 2;
            // See https://clintbellanger.net/articles/isometric_math/ for formula
            // The x position shifts left with every y step
            const xPos = (this.x - this.y) * halfTileWidth;
            // The y position needs to go down with every x step
            const yPos = (this.x + this.y) * halfTileHeight;
            this._transform.pos = vec(xPos, yPos);
            this._isometricEntityComponent.elevation = map.elevation;
            this._gfx = this.get(GraphicsComponent);
            this._gfx.visible = false; // start not visible
            const totalWidth = this.map.tileWidth;
            const totalHeight = this.map.tileHeight;
            // initial guess at gfx bounds based on the tile
            const offset = vec(0, this.map.renderFromTopOfGraphic ? totalHeight : 0);
            this._gfx.localBounds = this._tileBounds = new BoundingBox({
                left: -totalWidth / 2,
                top: -totalHeight,
                right: totalWidth / 2,
                bottom: totalHeight
            }).translate(offset);
        }
        draw(gfx, _elapsed) {
            const halfTileWidth = this.map.tileWidth / 2;
            gfx.save();
            // shift left origin to corner of map, not the left corner of the first sprite
            gfx.translate(-halfTileWidth, 0);
            for (const graphic of this._graphics)graphic.draw(gfx, this.map.graphicsOffset.x, this.map.graphicsOffset.y - (this.map.renderFromTopOfGraphic ? 0 : graphic.height - this.map.tileHeight));
            gfx.restore();
        }
    }
    /**
 * The IsometricMap is a special tile map that provides isometric rendering support to Excalibur
 *
 * The tileWidth and tileHeight should be the height and width in pixels of the parallelogram of the base of the tile art asset.
 * The tileWidth and tileHeight is not necessarily the same as your graphic pixel width and height.
 *
 * Please refer to the docs https://excaliburjs.com for more details calculating what your tile width and height should be given
 * your art assets.
 */ class IsometricMap extends Entity {
        constructor(options){
            super([
                new TransformComponent(),
                new BodyComponent({
                    type: CollisionType.Fixed
                }),
                new ColliderComponent(),
                new PointerComponent(),
                new DebugGraphicsComponent((ctx, debugFlags)=>this.debug(ctx, debugFlags), false)
            ], options.name);
            this.elevation = 0;
            /**
         * Whether tiles should be visible
         */ this.visible = true;
            /**
         * Opacity of tiles
         */ this.opacity = 1.0;
            /**
         * Render the tile graphic from the top instead of the bottom
         *
         * default is `false` meaning rendering from the bottom
         */ this.renderFromTopOfGraphic = false;
            this.graphicsOffset = vec(0, 0);
            this._forwardPointerEventToTile = (eventType)=>(evt)=>{
                    const tile = this.getTileByPoint(evt.worldPos);
                    if (tile) tile.events.emit(eventType, evt);
                };
            this._collidersDirty = false;
            this._originalOffsets = new WeakMap();
            const { pos: pos, tileWidth: tileWidth, tileHeight: tileHeight, columns: width, rows: height, renderFromTopOfGraphic: renderFromTopOfGraphic, graphicsOffset: graphicsOffset, elevation: elevation } = options;
            this.transform = this.get(TransformComponent);
            if (pos) this.transform.pos = pos;
            this.collider = this.get(ColliderComponent);
            if (this.collider) this.collider.set(this._composite = new CompositeCollider([]));
            this.pointer = this.get(PointerComponent);
            this.renderFromTopOfGraphic = renderFromTopOfGraphic !== null && renderFromTopOfGraphic !== void 0 ? renderFromTopOfGraphic : this.renderFromTopOfGraphic;
            this.graphicsOffset = graphicsOffset !== null && graphicsOffset !== void 0 ? graphicsOffset : this.graphicsOffset;
            this.elevation = elevation !== null && elevation !== void 0 ? elevation : this.elevation;
            this.tileWidth = tileWidth;
            this.tileHeight = tileHeight;
            this.columns = width;
            this.rows = height;
            this.tiles = new Array(width * height);
            // build up tile representation
            for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
                const tile = new IsometricTile(x, y, this.graphicsOffset, this);
                this.tiles[x + y * width] = tile;
                this.addChild(tile);
            }
            this.pointer.localBounds = BoundingBox.fromDimension(tileWidth * width * this.transform.scale.x, tileHeight * height * this.transform.scale.y, vec(.5, 0));
            this._setupPointerToTile();
        }
        _setupPointerToTile() {
            this.events.on("pointerup", this._forwardPointerEventToTile("pointerup"));
            this.events.on("pointerdown", this._forwardPointerEventToTile("pointerdown"));
            this.events.on("pointermove", this._forwardPointerEventToTile("pointermove"));
            this.events.on("pointercancel", this._forwardPointerEventToTile("pointercancel"));
        }
        update() {
            if (this._collidersDirty) {
                this.updateColliders();
                this._collidersDirty = false;
            }
        }
        flagCollidersDirty() {
            this._collidersDirty = true;
        }
        _getOrSetColliderOriginalOffset(collider) {
            if (!this._originalOffsets.has(collider)) {
                const originalOffset = collider.offset;
                this._originalOffsets.set(collider, originalOffset);
                return originalOffset;
            } else return this._originalOffsets.get(collider);
        }
        updateColliders() {
            this._composite.clearColliders();
            const pos = this.get(TransformComponent).pos;
            for (const tile of this.tiles){
                if (tile.solid) for (const collider of tile.getColliders()){
                    const originalOffset = this._getOrSetColliderOriginalOffset(collider);
                    collider.offset = this.tileToWorld(vec(tile.x, tile.y)).sub(pos).add(originalOffset).sub(vec(this.tileWidth / 2, this.tileHeight)); // We need to unshift height based on drawing
                    collider.owner = this;
                    this._composite.addCollider(collider);
                }
            }
            this.collider.update();
        }
        /**
     * Convert world space coordinates to the tile x, y coordinate
     * @param worldCoordinate
     */ worldToTile(worldCoordinate) {
            // TODO I don't think this handles parent transform see TileMap
            worldCoordinate = worldCoordinate.sub(this.transform.globalPos);
            const halfTileWidth = this.tileWidth / 2;
            const halfTileHeight = this.tileHeight / 2;
            // See https://clintbellanger.net/articles/isometric_math/ for formula
            return vec(~~((worldCoordinate.x / halfTileWidth + worldCoordinate.y / halfTileHeight) / 2), ~~((worldCoordinate.y / halfTileHeight - worldCoordinate.x / halfTileWidth) / 2));
        }
        /**
     * Given a tile coordinate, return the top left corner in world space
     * @param tileCoordinate
     */ tileToWorld(tileCoordinate) {
            const halfTileWidth = this.tileWidth / 2;
            const halfTileHeight = this.tileHeight / 2;
            // The x position shifts left with every y step
            const xPos = (tileCoordinate.x - tileCoordinate.y) * halfTileWidth;
            // The y position needs to go down with every x step
            const yPos = (tileCoordinate.x + tileCoordinate.y) * halfTileHeight;
            return vec(xPos, yPos).add(this.transform.pos);
        }
        /**
     * Returns the [[IsometricTile]] by its x and y coordinates
     */ getTile(x, y) {
            if (x < 0 || y < 0 || x >= this.columns || y >= this.rows) return null;
            return this.tiles[x + y * this.columns];
        }
        /**
     * Returns the [[IsometricTile]] by testing a point in world coordinates,
     * returns `null` if no Tile was found.
     */ getTileByPoint(point) {
            const tileCoord = this.worldToTile(point);
            const tile = this.getTile(tileCoord.x, tileCoord.y);
            return tile;
        }
        _getMaxZIndex() {
            let maxZ = Number.NEGATIVE_INFINITY;
            for (const tile of this.tiles){
                const currentZ = tile.get(TransformComponent).z;
                if (currentZ > maxZ) maxZ = currentZ;
            }
            return maxZ;
        }
        /**
     * Debug draw for IsometricMap, called internally by excalibur when debug mode is toggled on
     * @param gfx
     */ debug(gfx, debugFlags) {
            const { showAll: showAll, showPosition: showPosition, positionColor: positionColor, positionSize: positionSize, showGrid: showGrid, gridColor: gridColor, gridWidth: gridWidth, showColliderGeometry: showColliderGeometry } = debugFlags.isometric;
            const { geometryColor: geometryColor, geometryLineWidth: geometryLineWidth, geometryPointSize: geometryPointSize } = debugFlags.collider;
            gfx.save();
            gfx.z = this._getMaxZIndex() + 0.5;
            if (showAll || showGrid) {
                for(let y = 0; y < this.rows + 1; y++){
                    const left = this.tileToWorld(vec(0, y));
                    const right = this.tileToWorld(vec(this.columns, y));
                    gfx.drawLine(left, right, gridColor, gridWidth);
                }
                for(let x = 0; x < this.columns + 1; x++){
                    const top = this.tileToWorld(vec(x, 0));
                    const bottom = this.tileToWorld(vec(x, this.rows));
                    gfx.drawLine(top, bottom, gridColor, gridWidth);
                }
            }
            if (showAll || showPosition) for (const tile of this.tiles)gfx.drawCircle(this.tileToWorld(vec(tile.x, tile.y)), positionSize, positionColor);
            if (showAll || showColliderGeometry) for (const tile of this.tiles){
                if (tile.solid) for (const collider of tile.getColliders())collider.debug(gfx, geometryColor, {
                    lineWidth: geometryLineWidth,
                    pointSize: geometryPointSize
                });
            }
            gfx.restore();
        }
    }
    /**
 * Action that can represent a sequence of actions, this can be useful in conjunction with
 * [[ParallelActions]] to run multiple sequences in parallel.
 */ class ActionSequence {
        constructor(entity, actionBuilder){
            this._stopped = false;
            this._sequenceBuilder = actionBuilder;
            this._sequenceContext = new ActionContext(entity);
            this._actionQueue = this._sequenceContext.getQueue();
            this._sequenceBuilder(this._sequenceContext);
        }
        update(delta) {
            this._actionQueue.update(delta);
        }
        isComplete() {
            return this._stopped || this._actionQueue.isComplete();
        }
        stop() {
            this._stopped = true;
        }
        reset() {
            this._stopped = false;
            this._actionQueue.reset();
        }
        clone(entity) {
            return new ActionSequence(entity, this._sequenceBuilder);
        }
    }
    /**
 * Action that can run multiple [[Action]]s or [[ActionSequence]]s at the same time
 */ class ParallelActions {
        constructor(parallelActions){
            this._actions = parallelActions;
        }
        update(delta) {
            for(let i = 0; i < this._actions.length; i++)this._actions[i].update(delta);
        }
        isComplete(entity) {
            return this._actions.every((a)=>a.isComplete(entity));
        }
        reset() {
            this._actions.forEach((a)=>a.reset());
        }
        stop() {
            this._actions.forEach((a)=>a.stop());
        }
    }
    /**
 * QuadTree spatial data structure. Useful for quickly retrieving all objects that might
 * be in a specific location.
 */ class QuadTree {
        constructor(bounds, options){
            this.bounds = bounds;
            this.options = options;
            this._defaultOptions = {
                maxDepth: 10,
                capacity: 10,
                level: 0
            };
            this.items = [];
            this._isDivided = false;
            this.topLeft = null;
            this.topRight = null;
            this.bottomLeft = null;
            this.bottomRight = null;
            this.options = {
                ...this._defaultOptions,
                ...options
            };
            this.halfWidth = bounds.width / 2;
            this.halfHeight = bounds.height / 2;
        }
        /**
     * Splits the quad tree one level deeper
     */ _split() {
            this._isDivided = true;
            const newLevelOptions = {
                maxDepth: this.options.maxDepth,
                capacity: this.options.capacity,
                level: this.options.level + 1
            };
            this.topLeft = new QuadTree(new BoundingBox({
                left: this.bounds.left,
                top: this.bounds.top,
                right: this.bounds.left + this.halfWidth,
                bottom: this.bounds.top + this.halfHeight
            }), newLevelOptions);
            this.topRight = new QuadTree(new BoundingBox({
                left: this.bounds.left + this.halfWidth,
                top: this.bounds.top,
                right: this.bounds.right,
                bottom: this.bounds.top + this.halfHeight
            }), newLevelOptions);
            this.bottomLeft = new QuadTree(new BoundingBox({
                left: this.bounds.left,
                top: this.bounds.top + this.halfHeight,
                right: this.bounds.left + this.halfWidth,
                bottom: this.bounds.bottom
            }), newLevelOptions);
            this.bottomRight = new QuadTree(new BoundingBox({
                left: this.bounds.left + this.halfWidth,
                top: this.bounds.top + this.halfHeight,
                right: this.bounds.right,
                bottom: this.bounds.bottom
            }), newLevelOptions);
        }
        _insertIntoSubNodes(item) {
            var _a, _b, _c, _d;
            if ((_a = this.topLeft) === null || _a === void 0 ? void 0 : _a.bounds.overlaps(item.bounds)) this.topLeft.insert(item);
            if ((_b = this.topRight) === null || _b === void 0 ? void 0 : _b.bounds.overlaps(item.bounds)) this.topRight.insert(item);
            if ((_c = this.bottomLeft) === null || _c === void 0 ? void 0 : _c.bounds.overlaps(item.bounds)) this.bottomLeft.insert(item);
            if ((_d = this.bottomRight) === null || _d === void 0 ? void 0 : _d.bounds.overlaps(item.bounds)) this.bottomRight.insert(item);
        }
        /**
     * Insert an item to be tracked in the QuadTree
     * @param item
     */ insert(item) {
            // add to subnodes if it matches
            if (this._isDivided) {
                this._insertIntoSubNodes(item);
                return;
            }
            // leaf case
            this.items.push(item);
            // capacity
            if (this.items.length > this.options.capacity && this.options.level < this.options.maxDepth) {
                if (!this._isDivided) this._split();
                // divide this level's items into it's subnodes
                for (const item of this.items)this._insertIntoSubNodes(item);
                // clear this level
                this.items.length = 0;
            }
        }
        /**
     * Remove a tracked item in the QuadTree
     * @param item
     */ remove(item) {
            var _a, _b, _c, _d;
            if (!this.bounds.overlaps(item.bounds)) return;
            if (!this._isDivided) {
                const index = this.items.indexOf(item);
                if (index > -1) this.items.splice(index, 1);
                return;
            }
            if ((_a = this.topLeft) === null || _a === void 0 ? void 0 : _a.bounds.overlaps(item.bounds)) this.topLeft.remove(item);
            if ((_b = this.topRight) === null || _b === void 0 ? void 0 : _b.bounds.overlaps(item.bounds)) this.topRight.remove(item);
            if ((_c = this.bottomLeft) === null || _c === void 0 ? void 0 : _c.bounds.overlaps(item.bounds)) this.bottomLeft.remove(item);
            if ((_d = this.bottomRight) === null || _d === void 0 ? void 0 : _d.bounds.overlaps(item.bounds)) this.bottomRight.remove(item);
        }
        /**
     * Query the structure for all objects that intersect the bounding box
     * @param boundingBox
     * @returns items
     */ query(boundingBox) {
            let results = this.items;
            if (this._isDivided) {
                if (this.topLeft.bounds.overlaps(boundingBox)) results = results.concat(this.topLeft.query(boundingBox));
                if (this.topRight.bounds.overlaps(boundingBox)) results = results.concat(this.topRight.query(boundingBox));
                if (this.bottomLeft.bounds.overlaps(boundingBox)) results = results.concat(this.bottomLeft.query(boundingBox));
                if (this.bottomRight.bounds.overlaps(boundingBox)) results = results.concat(this.bottomRight.query(boundingBox));
            }
            results = results.filter((item, index)=>{
                return results.indexOf(item) >= index;
            });
            return results;
        }
        clear() {
            this.items = [];
            this._isDivided = false;
            this.topLeft = null;
            this.topRight = null;
            this.bottomLeft = null;
            this.bottomRight = null;
        }
        getAllItems() {
            let results = this.items;
            if (this._isDivided) {
                results = results.concat(this.topLeft.getAllItems());
                results = results.concat(this.topRight.getAllItems());
                results = results.concat(this.bottomLeft.getAllItems());
                results = results.concat(this.bottomRight.getAllItems());
            }
            results = results.filter((item, index)=>{
                return results.indexOf(item) >= index;
            });
            return results;
        }
        getTreeDepth() {
            if (!this._isDivided) return 0;
            return 1 + Math.max(this.topLeft.getTreeDepth(), this.topRight.getTreeDepth(), this.bottomLeft.getTreeDepth(), this.bottomRight.getTreeDepth());
        }
        debug(ctx) {
            this.bounds.draw(ctx, Color.Yellow);
            if (this._isDivided) {
                this.topLeft.bounds.draw(ctx, Color.Yellow);
                this.topRight.bounds.draw(ctx, Color.Yellow);
                this.bottomLeft.bounds.draw(ctx, Color.Yellow);
                this.bottomRight.bounds.draw(ctx, Color.Yellow);
            }
        }
    }
    /**
 * Type guard checking for internal initialize method
 * @internal
 * @param a
 */ function has_initialize(a) {
        return !!a._initialize;
    }
    /**
 *
 */ function hasOnInitialize(a) {
        return !!a.onInitialize;
    }
    /**
 *
 */ function has_preupdate(a) {
        return !!a._preupdate;
    }
    /**
 *
 */ function hasOnPreUpdate(a) {
        return !!a.onPreUpdate;
    }
    /**
 *
 */ function has_postupdate(a) {
        return !!a.onPostUpdate;
    }
    /**
 *
 */ function hasOnPostUpdate(a) {
        return !!a.onPostUpdate;
    }
    /**
 *
 */ function hasPreDraw(a) {
        return !!a.onPreDraw;
    }
    /**
 *
 */ function hasPostDraw(a) {
        return !!a.onPostDraw;
    }
    /**
 * The [[Texture]] object allows games built in Excalibur to load image resources.
 * [[Texture]] is an [[Loadable]] which means it can be passed to a [[Loader]]
 * to pre-load before starting a level or game.
 */ class Gif {
        /**
     * @param path       Path to the image resource
     * @param color      Optionally set the color to treat as transparent the gif, by default [[Color.Magenta]]
     * @param bustCache  Optionally load texture with cache busting
     */ constructor(path, color = Color.Magenta, bustCache = false){
            this.path = path;
            this.color = color;
            this._stream = null;
            this._gif = null;
            this._textures = [];
            this._animation = null;
            this._transparentColor = null;
            this._resource = new Resource(path, "arraybuffer", bustCache);
            this._transparentColor = color;
        }
        /**
     * Should excalibur add a cache busting querystring? By default false.
     * Must be set before loading
     */ get bustCache() {
            return this._resource.bustCache;
        }
        set bustCache(val) {
            this._resource.bustCache = val;
        }
        /**
     * Begins loading the texture and returns a promise to be resolved on completion
     */ async load() {
            const arraybuffer = await this._resource.load();
            this._stream = new Stream(arraybuffer);
            this._gif = new ParseGif(this._stream, this._transparentColor);
            const images = this._gif.images.map((i)=>new ImageSource(i.src, false));
            // Load all textures
            await Promise.all(images.map((t)=>t.load()));
            return this.data = this._textures = images;
        }
        isLoaded() {
            return !!this.data;
        }
        /**
     * Return a frame of the gif as a sprite by id
     * @param id
     */ toSprite(id = 0) {
            const sprite = this._textures[id].toSprite();
            return sprite;
        }
        /**
     * Return the gif as a spritesheet
     */ toSpriteSheet() {
            const sprites = this._textures.map((image)=>{
                return image.toSprite();
            });
            return new SpriteSheet({
                sprites: sprites
            });
        }
        /**
     * Transform the GIF into an animation with duration per frame
     */ toAnimation(durationPerFrameMs) {
            const spriteSheet = this.toSpriteSheet();
            const length = spriteSheet.sprites.length;
            this._animation = Animation.fromSpriteSheet(spriteSheet, range(0, length), durationPerFrameMs);
            return this._animation;
        }
        get readCheckBytes() {
            return this._gif.checkBytes;
        }
    }
    const bitsToNum = (ba)=>{
        return ba.reduce(function(s, n) {
            return s * 2 + n;
        }, 0);
    };
    const byteToBitArr = (bite)=>{
        const a = [];
        for(let i = 7; i >= 0; i--)a.push(!!(bite & 1 << i));
        return a;
    };
    class Stream {
        constructor(dataArray){
            this.data = null;
            this.len = 0;
            this.position = 0;
            this.readByte = ()=>{
                if (this.position >= this.data.byteLength) throw new Error("Attempted to read past end of stream.");
                return this.data[this.position++];
            };
            this.readBytes = (n)=>{
                const bytes = [];
                for(let i = 0; i < n; i++)bytes.push(this.readByte());
                return bytes;
            };
            this.read = (n)=>{
                let s = "";
                for(let i = 0; i < n; i++)s += String.fromCharCode(this.readByte());
                return s;
            };
            this.readUnsigned = ()=>{
                // Little-endian.
                const a = this.readBytes(2);
                return (a[1] << 8) + a[0];
            };
            this.data = new Uint8Array(dataArray);
            this.len = this.data.byteLength;
            if (this.len === 0) throw new Error("No data loaded from file");
        }
    }
    const lzwDecode = function(minCodeSize, data) {
        // TODO: Now that the GIF parser is a bit different, maybe this should get an array of bytes instead of a String?
        let pos = 0; // Maybe this streaming thing should be merged with the Stream?
        const readCode = function(size) {
            let code = 0;
            for(let i = 0; i < size; i++){
                if (data.charCodeAt(pos >> 3) & 1 << (pos & 7)) code |= 1 << i;
                pos++;
            }
            return code;
        };
        const output = [];
        const clearCode = 1 << minCodeSize;
        const eoiCode = clearCode + 1;
        let codeSize = minCodeSize + 1;
        let dict = [];
        const clear = function() {
            dict = [];
            codeSize = minCodeSize + 1;
            for(let i = 0; i < clearCode; i++)dict[i] = [
                i
            ];
            dict[clearCode] = [];
            dict[eoiCode] = null;
        };
        let code;
        let last;
        while(true){
            last = code;
            code = readCode(codeSize);
            if (code === clearCode) {
                clear();
                continue;
            }
            if (code === eoiCode) break;
            if (code < dict.length) {
                if (last !== clearCode) dict.push(dict[last].concat(dict[code][0]));
            } else {
                if (code !== dict.length) throw new Error("Invalid LZW code.");
                dict.push(dict[last].concat(dict[last][0]));
            }
            output.push.apply(output, dict[code]);
            if (dict.length === 1 << codeSize && codeSize < 12) // If we're at the last code and codeSize is 12, the next code will be a clearCode, and it'll be 12 bits long.
            codeSize++;
        }
        // I don't know if this is technically an error, but some GIFs do it.
        //if (Math.ceil(pos / 8) !== data.length) throw new Error('Extraneous LZW bytes.');
        return output;
    };
    // The actual parsing; returns an object with properties.
    class ParseGif {
        constructor(stream, color = Color.Magenta){
            this._st = null;
            this._handler = {};
            this._transparentColor = null;
            this.frames = [];
            this.images = [];
            this.globalColorTable = [];
            this.checkBytes = [];
            // LZW (GIF-specific)
            this.parseColorTable = (entries)=>{
                // Each entry is 3 bytes, for RGB.
                const ct = [];
                for(let i = 0; i < entries; i++){
                    const rgb = this._st.readBytes(3);
                    const rgba = "#" + rgb.map((x)=>{
                        const hex = x.toString(16);
                        return hex.length === 1 ? "0" + hex : hex;
                    }).join("");
                    ct.push(rgba);
                }
                return ct;
            };
            this.readSubBlocks = ()=>{
                let size, data;
                data = "";
                do {
                    size = this._st.readByte();
                    data += this._st.read(size);
                }while (size !== 0);
                return data;
            };
            this.parseHeader = ()=>{
                const hdr = {
                    sig: null,
                    ver: null,
                    width: null,
                    height: null,
                    colorRes: null,
                    globalColorTableSize: null,
                    gctFlag: null,
                    sorted: null,
                    globalColorTable: [],
                    bgColor: null,
                    pixelAspectRatio: null // if not 0, aspectRatio = (pixelAspectRatio + 15) / 64
                };
                hdr.sig = this._st.read(3);
                hdr.ver = this._st.read(3);
                if (hdr.sig !== "GIF") throw new Error("Not a GIF file."); // XXX: This should probably be handled more nicely.
                hdr.width = this._st.readUnsigned();
                hdr.height = this._st.readUnsigned();
                const bits = byteToBitArr(this._st.readByte());
                hdr.gctFlag = bits.shift();
                hdr.colorRes = bitsToNum(bits.splice(0, 3));
                hdr.sorted = bits.shift();
                hdr.globalColorTableSize = bitsToNum(bits.splice(0, 3));
                hdr.bgColor = this._st.readByte();
                hdr.pixelAspectRatio = this._st.readByte(); // if not 0, aspectRatio = (pixelAspectRatio + 15) / 64
                if (hdr.gctFlag) {
                    hdr.globalColorTable = this.parseColorTable(1 << hdr.globalColorTableSize + 1);
                    this.globalColorTable = hdr.globalColorTable;
                }
                if (this._handler.hdr && this._handler.hdr(hdr)) this.checkBytes.push(this._handler.hdr);
            };
            this.parseExt = (block)=>{
                const parseGCExt = (block)=>{
                    this.checkBytes.push(this._st.readByte()); // Always 4
                    const bits = byteToBitArr(this._st.readByte());
                    block.reserved = bits.splice(0, 3); // Reserved; should be 000.
                    block.disposalMethod = bitsToNum(bits.splice(0, 3));
                    block.userInput = bits.shift();
                    block.transparencyGiven = bits.shift();
                    block.delayTime = this._st.readUnsigned();
                    block.transparencyIndex = this._st.readByte();
                    block.terminator = this._st.readByte();
                    if (this._handler.gce && this._handler.gce(block)) this.checkBytes.push(this._handler.gce);
                };
                const parseComExt = (block)=>{
                    block.comment = this.readSubBlocks();
                    if (this._handler.com && this._handler.com(block)) this.checkBytes.push(this._handler.com);
                };
                const parsePTExt = (block)=>{
                    this.checkBytes.push(this._st.readByte()); // Always 12
                    block.ptHeader = this._st.readBytes(12);
                    block.ptData = this.readSubBlocks();
                    if (this._handler.pte && this._handler.pte(block)) this.checkBytes.push(this._handler.pte);
                };
                const parseAppExt = (block)=>{
                    const parseNetscapeExt = (block)=>{
                        this.checkBytes.push(this._st.readByte()); // Always 3
                        block.unknown = this._st.readByte(); // Q: Always 1? What is this?
                        block.iterations = this._st.readUnsigned();
                        block.terminator = this._st.readByte();
                        if (this._handler.app && this._handler.app.NETSCAPE && this._handler.app.NETSCAPE(block)) this.checkBytes.push(this._handler.app);
                    };
                    const parseUnknownAppExt = (block)=>{
                        block.appData = this.readSubBlocks();
                        // FIXME: This won't work if a handler wants to match on any identifier.
                        if (this._handler.app && this._handler.app[block.identifier] && this._handler.app[block.identifier](block)) this.checkBytes.push(this._handler.app[block.identifier]);
                    };
                    this.checkBytes.push(this._st.readByte()); // Always 11
                    block.identifier = this._st.read(8);
                    block.authCode = this._st.read(3);
                    switch(block.identifier){
                        case "NETSCAPE":
                            parseNetscapeExt(block);
                            break;
                        default:
                            parseUnknownAppExt(block);
                            break;
                    }
                };
                const parseUnknownExt = (block)=>{
                    block.data = this.readSubBlocks();
                    if (this._handler.unknown && this._handler.unknown(block)) this.checkBytes.push(this._handler.unknown);
                };
                block.label = this._st.readByte();
                switch(block.label){
                    case 0xf9:
                        block.extType = "gce";
                        parseGCExt(block);
                        break;
                    case 0xfe:
                        block.extType = "com";
                        parseComExt(block);
                        break;
                    case 0x01:
                        block.extType = "pte";
                        parsePTExt(block);
                        break;
                    case 0xff:
                        block.extType = "app";
                        parseAppExt(block);
                        break;
                    default:
                        block.extType = "unknown";
                        parseUnknownExt(block);
                        break;
                }
            };
            this.parseImg = (img)=>{
                const deinterlace = (pixels, width)=>{
                    // Of course this defeats the purpose of interlacing. And it's *probably*
                    // the least efficient way it's ever been implemented. But nevertheless...
                    const newPixels = new Array(pixels.length);
                    const rows = pixels.length / width;
                    const cpRow = (toRow, fromRow)=>{
                        const fromPixels = pixels.slice(fromRow * width, (fromRow + 1) * width);
                        newPixels.splice.apply(newPixels, [
                            toRow * width,
                            width
                        ].concat(fromPixels));
                    };
                    const offsets = [
                        0,
                        4,
                        2,
                        1
                    ];
                    const steps = [
                        8,
                        8,
                        4,
                        2
                    ];
                    let fromRow = 0;
                    for(let pass = 0; pass < 4; pass++)for(let toRow = offsets[pass]; toRow < rows; toRow += steps[pass]){
                        cpRow(toRow, fromRow);
                        fromRow++;
                    }
                    return newPixels;
                };
                img.leftPos = this._st.readUnsigned();
                img.topPos = this._st.readUnsigned();
                img.width = this._st.readUnsigned();
                img.height = this._st.readUnsigned();
                const bits = byteToBitArr(this._st.readByte());
                img.lctFlag = bits.shift();
                img.interlaced = bits.shift();
                img.sorted = bits.shift();
                img.reserved = bits.splice(0, 2);
                img.lctSize = bitsToNum(bits.splice(0, 3));
                if (img.lctFlag) img.lct = this.parseColorTable(1 << img.lctSize + 1);
                img.lzwMinCodeSize = this._st.readByte();
                const lzwData = this.readSubBlocks();
                img.pixels = lzwDecode(img.lzwMinCodeSize, lzwData);
                if (img.interlaced) // Move
                img.pixels = deinterlace(img.pixels, img.width);
                this.frames.push(img);
                this.arrayToImage(img);
                if (this._handler.img && this._handler.img(img)) this.checkBytes.push(this._handler);
            };
            this.parseBlock = ()=>{
                const block = {
                    sentinel: this._st.readByte(),
                    type: ""
                };
                const blockChar = String.fromCharCode(block.sentinel);
                switch(blockChar){
                    case "!":
                        block.type = "ext";
                        this.parseExt(block);
                        break;
                    case ",":
                        block.type = "img";
                        this.parseImg(block);
                        break;
                    case ";":
                        block.type = "eof";
                        if (this._handler.eof && this._handler.eof(block)) this.checkBytes.push(this._handler.eof);
                        break;
                    default:
                        throw new Error("Unknown block: 0x" + block.sentinel.toString(16));
                }
                if (block.type !== "eof") this.parseBlock();
            };
            this.arrayToImage = (frame)=>{
                let count = 0;
                const c = document.createElement("canvas");
                c.id = count.toString();
                c.width = frame.width;
                c.height = frame.height;
                count++;
                const context = c.getContext("2d");
                const pixSize = 1;
                let y = 0;
                let x = 0;
                for(let i = 0; i < frame.pixels.length; i++){
                    if (x % frame.width === 0) {
                        y++;
                        x = 0;
                    }
                    if (this.globalColorTable[frame.pixels[i]] === this._transparentColor.toHex()) context.fillStyle = `rgba(0, 0, 0, 0)`;
                    else context.fillStyle = this.globalColorTable[frame.pixels[i]];
                    context.fillRect(x, y, pixSize, pixSize);
                    x++;
                }
                const img = new Image();
                img.src = c.toDataURL();
                this.images.push(img);
            };
            this._st = stream;
            this._handler = {};
            this._transparentColor = color;
            this.parseHeader();
            this.parseBlock();
        }
    }
    class FontSource {
        constructor(/**
     * Path to the font resource relative from the HTML document hosting the game, or absolute
     */ path, /**
     * The font family name
     */ family, { bustCache: bustCache, ...options } = {}){
            this.path = path;
            this.family = family;
            this._isLoaded = false;
            this._resource = new Resource(path, "blob", bustCache);
            this._options = options;
        }
        async load() {
            if (this.isLoaded()) return this.data;
            try {
                const blob = await this._resource.load();
                const url = URL.createObjectURL(blob);
                if (!this.data) {
                    this.data = new FontFace(this.family, `url(${url})`);
                    document.fonts.add(this.data);
                }
                await this.data.load();
                this._isLoaded = true;
            } catch (error) {
                throw `Error loading FontSource from path '${this.path}' with error [${error.message}]`;
            }
            return this.data;
        }
        isLoaded() {
            return this._isLoaded;
        }
        /**
     * Build a font from this FontSource.
     * @param options {FontOptions} Override the font options
     */ toFont(options) {
            return new Font({
                family: this.family,
                ...this._options,
                ...options
            });
        }
    }
    const generatorFunctionDeclaration = /^\s*(?:function)?\*/;
    /**
 *
 */ function isCoroutineGenerator(x) {
        if (typeof x !== "function") return false;
        if (generatorFunctionDeclaration.test(Function.prototype.toString.call(x))) return true;
        if (!Object.getPrototypeOf) return false;
        return Object.getPrototypeOf(x) === Object.getPrototypeOf(new Function("return function * () {}")());
    }
    /**
 *
 */ function coroutine(...args) {
        let coroutineGenerator;
        let thisArg;
        let options;
        let passedEngine;
        // coroutine(coroutineGenerator: CoroutineGenerator, options?: CoroutineOptions): Promise<void>;
        if (isCoroutineGenerator(args[0])) {
            thisArg = globalThis;
            coroutineGenerator = args[0];
            options = args[1];
        }
        // coroutine(thisArg: any, coroutineGenerator: CoroutineGenerator, options?: CoroutineOptions): Promise<void>;
        if (isCoroutineGenerator(args[1])) {
            thisArg = args[0];
            coroutineGenerator = args[1];
            options = args[2];
        }
        // coroutine(thisArg: any, engine: Engine, coroutineGenerator: CoroutineGenerator, options?: CoroutineOptions): Promise<void>;
        if (args[1] instanceof Engine) {
            thisArg = args[0];
            passedEngine = args[1];
            coroutineGenerator = args[2];
            options = args[3];
        }
        // coroutine(engine: Engine, coroutineGenerator: CoroutineGenerator, options?: CoroutineOptions): Promise<void>;
        if (args[0] instanceof Engine) {
            thisArg = globalThis;
            passedEngine = args[0];
            coroutineGenerator = args[1];
            options = args[2];
        }
        const schedule = options === null || options === void 0 ? void 0 : options.timing;
        let engine;
        try {
            engine = passedEngine !== null && passedEngine !== void 0 ? passedEngine : Engine.useEngine();
        } catch (_) {
            throw Error("Cannot run coroutine without engine parameter outside of an excalibur lifecycle method.\nPass an engine parameter to ex.coroutine(engine, function * {...})");
        }
        const generatorFcn = coroutineGenerator.bind(thisArg);
        return new Promise((resolve, reject)=>{
            const generator = generatorFcn();
            const loop = (elapsedMs)=>{
                try {
                    const { done: done, value: value } = generator.next(elapsedMs);
                    if (done) resolve();
                    if (value instanceof Promise) value.then(()=>{
                        // schedule next loop
                        engine.clock.schedule(loop, 0, schedule);
                    });
                    else if (value === undefined || value === void 0) // schedule next frame
                    engine.clock.schedule(loop, 0, schedule);
                    else // schedule value milliseconds from now
                    engine.clock.schedule(loop, value || 0, schedule);
                } catch (e) {
                    reject(e);
                }
            };
            loop(engine.clock.elapsed()); // run first frame immediately
        });
    }
    /**
 * Base Transition that can be extended to provide custom scene transitions in Excalibur.
 */ class Transition extends Entity {
        /**
     * Returns a number between [0, 1] indicating what state the transition is in.
     *
     * * For 'out' direction transitions start at 0 and end at 1
     * * For 'in' direction transitions start at 1 and end at 0
     */ get progress() {
            return this._currentProgress;
        }
        get complete() {
            if (this.direction === "out") return this.progress >= 1;
            else return this.progress <= 0;
        }
        constructor(options){
            var _a, _b, _c, _d;
            super();
            this._logger = Logger.getInstance();
            this.transform = new TransformComponent();
            this.graphics = new GraphicsComponent();
            this._completeFuture = new Future();
            // State needs to be reset between uses
            this.started = false;
            this._currentDistance = 0;
            this._currentProgress = 0;
            this.done = this._completeFuture.promise;
            this.name = `Transition#${this.id}`;
            this.duration = options.duration;
            this.easing = (_a = options.easing) !== null && _a !== void 0 ? _a : EasingFunctions.Linear;
            this.direction = (_b = options.direction) !== null && _b !== void 0 ? _b : "out";
            this.hideLoader = (_c = options.hideLoader) !== null && _c !== void 0 ? _c : false;
            this.blockInput = (_d = options.blockInput) !== null && _d !== void 0 ? _d : false;
            this.transform.coordPlane = CoordPlane.Screen;
            this.transform.pos = Vector.Zero;
            this.transform.z = Infinity; // Transitions sit on top of everything
            this.graphics.anchor = Vector.Zero;
            this.addComponent(this.transform);
            this.addComponent(this.graphics);
            if (this.direction === "out") this._currentProgress = 0;
            else this._currentProgress = 1;
        }
        /**
     * Overridable lifecycle method, called before each update.
     *
     * **WARNING BE SURE** to call `super.updateTransition()` if overriding in your own custom implementation
     * @param engine
     * @param delta
     */ updateTransition(engine, delta) {
            if (this.complete) return;
            this._currentDistance += clamp(delta / this.duration, 0, 1);
            if (this._currentDistance >= 1) this._currentDistance = 1;
            if (this.direction === "out") this._currentProgress = clamp(this.easing(this._currentDistance, 0, 1, 1), 0, 1);
            else this._currentProgress = clamp(this.easing(this._currentDistance, 1, 0, 1), 0, 1);
        }
        /**
     * Overridable lifecycle method, called right before the previous scene has deactivated.
     *
     * This gives incoming transition a chance to grab info from previous scene if desired
     * @param scene
     */ async onPreviousSceneDeactivate(scene) {
        // override me
        }
        /**
     * Overridable lifecycle method, called once at the beginning of the transition
     *
     * `progress` is given between 0 and 1
     * @param progress
     */ onStart(progress) {
        // override me
        }
        /**
     * Overridable lifecycle method, called every frame of the transition
     *
     * `progress` is given between 0 and 1
     * @param progress
     */ onUpdate(progress) {
        // override me
        }
        /**
     * Overridable lifecycle method, called at the end of the transition,
     *
     * `progress` is given between 0 and 1
     * @param progress
     */ onEnd(progress) {
        // override me
        }
        /**
     * Overridable lifecycle method, called when the transition is reset
     *
     * Use this to override and provide your own reset logic for internal state in custom transition implementations
     */ onReset() {
        // override me
        }
        /**
     * reset() is called by the engine to reset transitions
     */ reset() {
            this.started = false;
            this._completeFuture = new Future();
            this.done = this._completeFuture.promise;
            this._currentDistance = 0;
            if (this.direction === "out") this._currentProgress = 0;
            else this._currentProgress = 1;
            this.onReset();
        }
        play(engine, targetScene) {
            if (this.started) {
                this.reset();
                this._logger.warn(`Attempted to play a transition ${this.name} that is already playing, reset transition.`);
            }
            const currentScene = targetScene !== null && targetScene !== void 0 ? targetScene : engine.currentScene;
            currentScene.add(this);
            const self1 = this;
            return coroutine(engine, function*() {
                while(!self1.complete){
                    const elapsed = yield; // per frame
                    self1.updateTransition(engine, elapsed);
                    self1.execute();
                }
            });
        }
        /**
     * execute() is called by the engine every frame to update the Transition lifecycle onStart/onUpdate/onEnd
     */ execute() {
            if (!this.isInitialized) return;
            if (!this.started) {
                this.started = true;
                this.onStart(this.progress);
            }
            this.onUpdate(this.progress);
            if (this.complete && !this._completeFuture.isCompleted) {
                this.onEnd(this.progress);
                this._completeFuture.resolve();
            }
        }
    }
    class FadeInOut extends Transition {
        constructor(options){
            var _a, _b;
            super({
                ...options,
                duration: (_a = options.duration) !== null && _a !== void 0 ? _a : 2000
            });
            this.name = `FadeInOut#${this.id}`;
            this.color = (_b = options.color) !== null && _b !== void 0 ? _b : Color.Black;
        }
        onInitialize(engine) {
            this.transform.pos = engine.screen.unsafeArea.topLeft;
            this.screenCover = new Rectangle({
                width: engine.screen.resolution.width,
                height: engine.screen.resolution.height,
                color: this.color
            });
            this.graphics.add(this.screenCover);
            this.graphics.opacity = this.progress;
        }
        onReset() {
            this.graphics.opacity = this.progress;
        }
        onStart(progress) {
            this.graphics.opacity = progress;
        }
        onEnd(progress) {
            this.graphics.opacity = progress;
        }
        onUpdate(progress) {
            this.graphics.opacity = progress;
        }
    }
    /**
 * CrossFades between the previous scene and the destination scene
 *
 * Note: CrossFade only works as an "in" transition
 */ class CrossFade extends Transition {
        constructor(options){
            super({
                direction: "in",
                ...options
            }); // default the correct direction
            this.name = `CrossFade#${this.id}`;
        }
        async onPreviousSceneDeactivate(scene) {
            this.image = await scene.engine.screenshot(true);
            // Firefox is particularly slow
            // needed in case the image isn't ready yet
            await this.image.decode();
        }
        onInitialize(engine) {
            this.engine = engine;
            this.transform.pos = engine.screen.unsafeArea.topLeft;
            this.screenCover = ImageSource.fromHtmlImageElement(this.image).toSprite();
            this.graphics.add(this.screenCover);
            this.transform.scale = vec(1 / engine.screen.pixelRatio, 1 / engine.screen.pixelRatio);
            this.graphics.opacity = this.progress;
        }
        onStart(_progress) {
            this.graphics.opacity = this.progress;
        }
        onReset() {
            this.graphics.opacity = this.progress;
        }
        onEnd(progress) {
            this.graphics.opacity = progress;
        }
        onUpdate(progress) {
            this.graphics.opacity = progress;
        }
    }
    class Line extends Graphic {
        constructor(options){
            super();
            this.color = Color.Black;
            this.thickness = 1;
            const { start: start, end: end, color: color, thickness: thickness } = options;
            this.start = start;
            this.end = end;
            this.color = color !== null && color !== void 0 ? color : this.color;
            this.thickness = thickness !== null && thickness !== void 0 ? thickness : this.thickness;
            this._localBounds = this._calculateBounds();
            const { width: width, height: height } = this._localBounds;
            this.width = width;
            this.height = height;
        }
        get localBounds() {
            return this._localBounds;
        }
        _calculateBounds() {
            const lineNormal = this.end.sub(this.start).normal();
            const halfThickness = this.thickness / 2;
            const points = [
                this.start.add(lineNormal.scale(halfThickness)),
                this.end.add(lineNormal.scale(halfThickness)),
                this.end.add(lineNormal.scale(-halfThickness)),
                this.start.add(lineNormal.scale(-halfThickness))
            ];
            return BoundingBox.fromPoints(points);
        }
        _drawImage(ctx, _x, _y) {
            ctx.drawLine(this.start, this.end, this.color, this.thickness);
        }
        clone() {
            return new Line({
                start: this.start,
                end: this.end,
                color: this.color,
                thickness: this.thickness
            });
        }
    }
    /**
 * A polygon [[Graphic]] for drawing arbitrary polygons to the [[ExcaliburGraphicsContext]]
 *
 * Polygons default to [[ImageFiltering.Blended]]
 */ class Polygon extends Raster {
        get points() {
            return this._points;
        }
        set points(points) {
            this._points = points;
            const min = this.minPoint;
            this.width = this._points.reduce((max, p)=>Math.max(p.x, max), 0) - min.x;
            this.height = this._points.reduce((max, p)=>Math.max(p.y, max), 0) - min.y;
            this.flagDirty();
        }
        get minPoint() {
            const minX = this._points.reduce((min, p)=>Math.min(p.x, min), Infinity);
            const minY = this._points.reduce((min, p)=>Math.min(p.y, min), Infinity);
            return vec(minX, minY);
        }
        constructor(options){
            super(options);
            this.points = options.points;
            this.filtering = ImageFiltering.Blended;
            this.rasterize();
        }
        clone() {
            return new Polygon({
                points: this.points.map((p)=>p.clone()),
                ...this.cloneGraphicOptions(),
                ...this.cloneRasterOptions()
            });
        }
        execute(ctx) {
            if (this.points && this.points.length) {
                ctx.beginPath();
                // Iterate through the supplied points and construct a 'polygon'
                const min = this.minPoint.negate();
                const firstPoint = this.points[0].add(min);
                ctx.moveTo(firstPoint.x, firstPoint.y);
                this.points.forEach((point)=>{
                    ctx.lineTo(point.x + min.x, point.y + min.y);
                });
                ctx.lineTo(firstPoint.x, firstPoint.y);
                ctx.closePath();
                if (this.color) ctx.fill();
                if (this.strokeColor) ctx.stroke();
            }
        }
    }
    const maxMessages = 5;
    const obsoleteMessage = {};
    const resetObsoleteCounter = ()=>{
        for(const message in obsoleteMessage)obsoleteMessage[message] = 0;
    };
    const logMessage = (message, options)=>{
        const suppressObsoleteMessages = Flags.isEnabled("suppress-obsolete-message");
        if (obsoleteMessage[message] < maxMessages && !suppressObsoleteMessages) {
            Logger.getInstance().warn(message);
            // tslint:disable-next-line: no-console
            if (console.trace && options.showStackTrace) // tslint:disable-next-line: no-console
            console.trace();
        }
        obsoleteMessage[message]++;
    };
    /**
 * Obsolete decorator for marking Excalibur methods obsolete, you can optionally specify a custom message and/or alternate replacement
 * method do the deprecated one. Inspired by https://github.com/jayphelps/core-decorators.js
 */ function obsolete(options) {
        options = {
            message: "This feature will be removed in future versions of Excalibur.",
            alternateMethod: null,
            showStackTrace: false,
            ...options
        };
        return function(target, property, descriptor) {
            if (descriptor && !(typeof descriptor.value === "function" || typeof descriptor.get === "function" || typeof descriptor.set === "function")) throw new SyntaxError("Only classes/functions/getters/setters can be marked as obsolete");
            const methodSignature = `${target.name || ""}${target.name && property ? "." : ""}${property ? property : ""}`;
            const message = `${methodSignature} is marked obsolete: ${options.message}` + (options.alternateMethod ? ` Use ${options.alternateMethod} instead` : "");
            if (!obsoleteMessage[message]) obsoleteMessage[message] = 0;
            // If descriptor is null it is a class
            const method = descriptor ? {
                ...descriptor
            } : target;
            if (!descriptor) {
                // with es2015 classes we need to change our decoration tactic
                class DecoratedClass extends method {
                    constructor(...args){
                        logMessage(message, options);
                        super(...args);
                    }
                }
                return DecoratedClass;
            }
            if (descriptor && descriptor.value) {
                method.value = function() {
                    logMessage(message, options);
                    return descriptor.value.apply(this, arguments);
                };
                return method;
            }
            if (descriptor && descriptor.get) method.get = function() {
                logMessage(message, options);
                return descriptor.get.apply(this, arguments);
            };
            if (descriptor && descriptor.set) method.set = function() {
                logMessage(message, options);
                return descriptor.set.apply(this, arguments);
            };
            return method;
        };
    }
    class AsyncWaitQueue {
        constructor(){
            // Code from StephenCleary https://gist.github.com/StephenCleary/ba50b2da419c03b9cba1d20cb4654d5e
            this._queue = [];
        }
        get length() {
            return this._queue.length;
        }
        enqueue() {
            const future = new Future();
            this._queue.push(future);
            return future.promise;
        }
        dequeue(value) {
            const future = this._queue.shift();
            future.resolve(value);
        }
    }
    /**
 * Semaphore allows you to limit the amount of async calls happening between `enter()` and `exit()`
 *
 * This can be useful when limiting the number of http calls, browser api calls, etc either for performance or to work
 * around browser limitations like max Image.decode() calls in chromium being 256.
 */ class Semaphore {
        constructor(_count){
            this._count = _count;
            this._waitQueue = new AsyncWaitQueue();
        }
        get count() {
            return this._count;
        }
        get waiting() {
            return this._waitQueue.length;
        }
        // eslint-disable-next-line require-await
        async enter() {
            if (this._count !== 0) {
                this._count--;
                return Promise.resolve();
            }
            return this._waitQueue.enqueue();
        }
        exit(count = 1) {
            if (count === 0) return;
            while(count !== 0 && this._waitQueue.length !== 0){
                this._waitQueue.dequeue(null);
                count--;
            }
            this._count += count;
        }
    }
    /**
 * The current Excalibur version string
 * @description `process.env.__EX_VERSION` gets replaced by Webpack on build
 */ const EX_VERSION = "0.29.2";
    polyfill();
// This file is used as the bundle entry point and exports everything
// that will be exposed as the `ex` global variable.
// ex.Events namespace
// ex.Input namespace
// TODO deprecated import site remove in v0.29.0
// ex.Util namespaces
// ex.Deprecated
// import * as deprecated from './Deprecated';
// export { deprecated as Deprecated };
// export * from './Deprecated';
})();
var $2c23f148d58cd887$export$f05c91211c084e80 = $2c23f148d58cd887$var$__webpack_exports__.eKr;
var $2c23f148d58cd887$export$e04e17a44f37debc = $2c23f148d58cd887$var$__webpack_exports__.yVm;
var $2c23f148d58cd887$export$dfcd1bb88f6d711b = $2c23f148d58cd887$var$__webpack_exports__.a7j;
var $2c23f148d58cd887$export$89f31cec7c284d42 = $2c23f148d58cd887$var$__webpack_exports__.U_w;
var $2c23f148d58cd887$export$a3f070f3e473c3b = $2c23f148d58cd887$var$__webpack_exports__.JF2;
var $2c23f148d58cd887$export$856e7d6d9d698871 = $2c23f148d58cd887$var$__webpack_exports__.htg;
var $2c23f148d58cd887$export$caffe607ed29fca1 = $2c23f148d58cd887$var$__webpack_exports__.HXL;
var $2c23f148d58cd887$export$adc62e83dbcda319 = $2c23f148d58cd887$var$__webpack_exports__.mcg;
var $2c23f148d58cd887$export$f73d3eb6fd876d80 = $2c23f148d58cd887$var$__webpack_exports__.Agj;
var $2c23f148d58cd887$export$da248c61eea53296 = $2c23f148d58cd887$var$__webpack_exports__.u6S;
var $2c23f148d58cd887$export$f0455ab08e3fbd0e = $2c23f148d58cd887$var$__webpack_exports__.x7M;
var $2c23f148d58cd887$export$c35d437ae5945fcd = $2c23f148d58cd887$var$__webpack_exports__.X55;
var $2c23f148d58cd887$export$67ee29bab3792d4c = $2c23f148d58cd887$var$__webpack_exports__.m3M;
var $2c23f148d58cd887$export$d230853e97069d46 = $2c23f148d58cd887$var$__webpack_exports__.aE5;
var $2c23f148d58cd887$export$6cfd78ddb48c90c6 = $2c23f148d58cd887$var$__webpack_exports__.YJU;
var $2c23f148d58cd887$export$3769e64eb87b5ecc = $2c23f148d58cd887$var$__webpack_exports__.eZi;
var $2c23f148d58cd887$export$54dc36bc2fac5425 = $2c23f148d58cd887$var$__webpack_exports__.GNv;
var $2c23f148d58cd887$export$387a78ab20784494 = $2c23f148d58cd887$var$__webpack_exports__.Y56;
var $2c23f148d58cd887$export$d06866a9fb0606da = $2c23f148d58cd887$var$__webpack_exports__._0v;
var $2c23f148d58cd887$export$83c931ba0d3bbaf5 = $2c23f148d58cd887$var$__webpack_exports__.vhs;
var $2c23f148d58cd887$export$1a553341cd0b8415 = $2c23f148d58cd887$var$__webpack_exports__.Z8b;
var $2c23f148d58cd887$export$43416332cf06b1f = $2c23f148d58cd887$var$__webpack_exports__.Yfw;
var $2c23f148d58cd887$export$63080c4de6cfc362 = $2c23f148d58cd887$var$__webpack_exports__.IcQ;
var $2c23f148d58cd887$export$fa45ecb18b97ae89 = $2c23f148d58cd887$var$__webpack_exports__.Rl2;
var $2c23f148d58cd887$export$c24f8f35353a1e26 = $2c23f148d58cd887$var$__webpack_exports__.kgJ;
var $2c23f148d58cd887$export$8688def55452cbca = $2c23f148d58cd887$var$__webpack_exports__.GTT;
var $2c23f148d58cd887$export$665d5a662b7213f3 = $2c23f148d58cd887$var$__webpack_exports__.ypY;
var $2c23f148d58cd887$export$79f141de891a5fed = $2c23f148d58cd887$var$__webpack_exports__.i7d;
var $2c23f148d58cd887$export$41606648ac8a293c = $2c23f148d58cd887$var$__webpack_exports__.fQ3;
var $2c23f148d58cd887$export$8d01c972ee8b14a9 = $2c23f148d58cd887$var$__webpack_exports__.HlI;
var $2c23f148d58cd887$export$c89a927ffc67e6fa = $2c23f148d58cd887$var$__webpack_exports__.jlt;
var $2c23f148d58cd887$export$e2395b697f5a931f = $2c23f148d58cd887$var$__webpack_exports__.VQc;
var $2c23f148d58cd887$export$9735c82c4bae3302 = $2c23f148d58cd887$var$__webpack_exports__.zD7;
var $2c23f148d58cd887$export$44e6803d1d57f89a = $2c23f148d58cd887$var$__webpack_exports__.I0I;
var $2c23f148d58cd887$export$1ed419d47673a225 = $2c23f148d58cd887$var$__webpack_exports__.AUF;
var $2c23f148d58cd887$export$b7c6eef0ebb06133 = $2c23f148d58cd887$var$__webpack_exports__.JoF;
var $2c23f148d58cd887$export$3c9e91dc1b611d2e = $2c23f148d58cd887$var$__webpack_exports__.MlA;
var $2c23f148d58cd887$export$ce0ca64520c7bfd2 = $2c23f148d58cd887$var$__webpack_exports__.PZh;
var $2c23f148d58cd887$export$83caf30c40e9d4b8 = $2c23f148d58cd887$var$__webpack_exports__.qA;
var $2c23f148d58cd887$export$4df0464d8c812c98 = $2c23f148d58cd887$var$__webpack_exports__.CrD;
var $2c23f148d58cd887$export$55e924fc640a8405 = $2c23f148d58cd887$var$__webpack_exports__.dQK;
var $2c23f148d58cd887$export$fbd6eb86d6a3f08 = $2c23f148d58cd887$var$__webpack_exports__.D3r;
var $2c23f148d58cd887$export$7cd2649c3408da6c = $2c23f148d58cd887$var$__webpack_exports__.Qpo;
var $2c23f148d58cd887$export$897cd666d936ac4c = $2c23f148d58cd887$var$__webpack_exports__.D9n;
var $2c23f148d58cd887$export$cf976780b3106589 = $2c23f148d58cd887$var$__webpack_exports__.b6v;
var $2c23f148d58cd887$export$5dcfde0f6b96512b = $2c23f148d58cd887$var$__webpack_exports__.mvh;
var $2c23f148d58cd887$export$ddb2ed749236e720 = $2c23f148d58cd887$var$__webpack_exports__.Bpo;
var $2c23f148d58cd887$export$892596cec99bc70e = $2c23f148d58cd887$var$__webpack_exports__.Q1f;
var $2c23f148d58cd887$export$8ed4b5bb5352fe14 = $2c23f148d58cd887$var$__webpack_exports__.IKv;
var $2c23f148d58cd887$export$c46090c9df657074 = $2c23f148d58cd887$var$__webpack_exports__.fcV;
var $2c23f148d58cd887$export$b3bf2ffaa538264b = $2c23f148d58cd887$var$__webpack_exports__.Glf;
var $2c23f148d58cd887$export$16fa2f45be04daa8 = $2c23f148d58cd887$var$__webpack_exports__.uAl;
var $2c23f148d58cd887$export$d16a7c95008e315d = $2c23f148d58cd887$var$__webpack_exports__.ElT;
var $2c23f148d58cd887$export$abda45806f5adbae = $2c23f148d58cd887$var$__webpack_exports__.MPu;
var $2c23f148d58cd887$export$e5a30aa3d28b26e2 = $2c23f148d58cd887$var$__webpack_exports__.Z8r;
var $2c23f148d58cd887$export$de7807bd8bd828df = $2c23f148d58cd887$var$__webpack_exports__.QSL;
var $2c23f148d58cd887$export$1bdfb0c7c42d632d = $2c23f148d58cd887$var$__webpack_exports__.sPV;
var $2c23f148d58cd887$export$bf92f329076cd7a3 = $2c23f148d58cd887$var$__webpack_exports__.nAn;
var $2c23f148d58cd887$export$71de6146fb6d69d2 = $2c23f148d58cd887$var$__webpack_exports__.zCU;
var $2c23f148d58cd887$export$71efaa2be447940c = $2c23f148d58cd887$var$__webpack_exports__.QrV;
var $2c23f148d58cd887$export$d78c8c6074541cf2 = $2c23f148d58cd887$var$__webpack_exports__.fF9;
var $2c23f148d58cd887$export$7d34ad93c25aa8e7 = $2c23f148d58cd887$var$__webpack_exports__.xI8;
var $2c23f148d58cd887$export$153e5dc2c098b35c = $2c23f148d58cd887$var$__webpack_exports__.yar;
var $2c23f148d58cd887$export$f7c1896972d6c454 = $2c23f148d58cd887$var$__webpack_exports__.SP7;
var $2c23f148d58cd887$export$c3e6e677dda8521a = $2c23f148d58cd887$var$__webpack_exports__.oRy;
var $2c23f148d58cd887$export$e52858e61b0ea117 = $2c23f148d58cd887$var$__webpack_exports__.f5X;
var $2c23f148d58cd887$export$3d1f12550a40f54d = $2c23f148d58cd887$var$__webpack_exports__.V1c;
var $2c23f148d58cd887$export$4544b2d7eff33859 = $2c23f148d58cd887$var$__webpack_exports__.Mlx;
var $2c23f148d58cd887$export$dd6b48f99ee8a36 = $2c23f148d58cd887$var$__webpack_exports__.ZCo;
var $2c23f148d58cd887$export$aafe01318a900193 = $2c23f148d58cd887$var$__webpack_exports__.Vy3;
var $2c23f148d58cd887$export$fd69b6a3b7f47e29 = $2c23f148d58cd887$var$__webpack_exports__.J5p;
var $2c23f148d58cd887$export$e1545123b54f6785 = $2c23f148d58cd887$var$__webpack_exports__.mL_;
var $2c23f148d58cd887$export$7419ff430885d61c = $2c23f148d58cd887$var$__webpack_exports__.Guw;
var $2c23f148d58cd887$export$a340d4e5571cbd07 = $2c23f148d58cd887$var$__webpack_exports__.VKx;
var $2c23f148d58cd887$export$e695250628cde35 = $2c23f148d58cd887$var$__webpack_exports__.N5j;
var $2c23f148d58cd887$export$c5e124f7bab3d492 = $2c23f148d58cd887$var$__webpack_exports__.pgY;
var $2c23f148d58cd887$export$cacd6541cfeeb6c1 = $2c23f148d58cd887$var$__webpack_exports__.OP3;
var $2c23f148d58cd887$export$a74d557191881f82 = $2c23f148d58cd887$var$__webpack_exports__.rl5;
var $2c23f148d58cd887$export$99bf88c530739783 = $2c23f148d58cd887$var$__webpack_exports__.eod;
var $2c23f148d58cd887$export$4b7264771109adb6 = $2c23f148d58cd887$var$__webpack_exports__.q5Z;
var $2c23f148d58cd887$export$62053d374d83dfb1 = $2c23f148d58cd887$var$__webpack_exports__.YUC;
var $2c23f148d58cd887$export$d7078bb1ea3ba3f2 = $2c23f148d58cd887$var$__webpack_exports__.saR;
var $2c23f148d58cd887$export$86ae8da356d53161 = $2c23f148d58cd887$var$__webpack_exports__.hvr;
var $2c23f148d58cd887$export$62230588c4867d28 = $2c23f148d58cd887$var$__webpack_exports__.Qol;
var $2c23f148d58cd887$export$df007b1d5b86e25a = $2c23f148d58cd887$var$__webpack_exports__.Wf4;
var $2c23f148d58cd887$export$6ff391a2049fdf40 = $2c23f148d58cd887$var$__webpack_exports__.JCs;
var $2c23f148d58cd887$export$89e5ccdc4c19a8f6 = $2c23f148d58cd887$var$__webpack_exports__.gJV;
var $2c23f148d58cd887$export$2cbc8fe61dd10773 = $2c23f148d58cd887$var$__webpack_exports__.fWD;
var $2c23f148d58cd887$export$d45269226a4bbdc1 = $2c23f148d58cd887$var$__webpack_exports__.Va_;
var $2c23f148d58cd887$export$2c3b404bf3a77a1f = $2c23f148d58cd887$var$__webpack_exports__.N$8;
var $2c23f148d58cd887$export$20434e7e042d306a = $2c23f148d58cd887$var$__webpack_exports__._jQ;
var $2c23f148d58cd887$export$462adefbb095232e = $2c23f148d58cd887$var$__webpack_exports__.rxj;
var $2c23f148d58cd887$export$83f8212621739c1f = $2c23f148d58cd887$var$__webpack_exports__.rhv;
var $2c23f148d58cd887$export$bc644a473284d944 = $2c23f148d58cd887$var$__webpack_exports__.wCu;
var $2c23f148d58cd887$export$66b8a9cb33a156c = $2c23f148d58cd887$var$__webpack_exports__.HAp;
var $2c23f148d58cd887$export$c7b7134fd828a5 = $2c23f148d58cd887$var$__webpack_exports__.Zy1;
var $2c23f148d58cd887$export$ec8b666c5fe2c75a = $2c23f148d58cd887$var$__webpack_exports__.Qev;
var $2c23f148d58cd887$export$4fae95256245c8c0 = $2c23f148d58cd887$var$__webpack_exports__.bkB;
var $2c23f148d58cd887$export$86d9a347f2bf71d6 = $2c23f148d58cd887$var$__webpack_exports__.wfL;
var $2c23f148d58cd887$export$ada873a34909da65 = $2c23f148d58cd887$var$__webpack_exports__.sVA;
var $2c23f148d58cd887$export$afee3afd6be961ec = $2c23f148d58cd887$var$__webpack_exports__.$Gs;
var $2c23f148d58cd887$export$c03216fb3a7a2f87 = $2c23f148d58cd887$var$__webpack_exports__.CJ0;
var $2c23f148d58cd887$export$81940238f313e11f = $2c23f148d58cd887$var$__webpack_exports__.NWh;
var $2c23f148d58cd887$export$40f8f9a8f94db930 = $2c23f148d58cd887$var$__webpack_exports__.tWi;
var $2c23f148d58cd887$export$c579e21b95165414 = $2c23f148d58cd887$var$__webpack_exports__.xAj;
var $2c23f148d58cd887$export$c983850c6c9d8b0e = $2c23f148d58cd887$var$__webpack_exports__.zWh;
var $2c23f148d58cd887$export$be5b6c6ac24b4683 = $2c23f148d58cd887$var$__webpack_exports__.i_4;
var $2c23f148d58cd887$export$434ba092ed0eee4e = $2c23f148d58cd887$var$__webpack_exports__.iIx;
var $2c23f148d58cd887$export$455f05776f1ba8ba = $2c23f148d58cd887$var$__webpack_exports__.c9e;
var $2c23f148d58cd887$export$89abf52a030e56ee = $2c23f148d58cd887$var$__webpack_exports__.KQV;
var $2c23f148d58cd887$export$549c899505235621 = $2c23f148d58cd887$var$__webpack_exports__.weH;
var $2c23f148d58cd887$export$1f6d1255105a925c = $2c23f148d58cd887$var$__webpack_exports__.jXp;
var $2c23f148d58cd887$export$23b468d4ca3f8c96 = $2c23f148d58cd887$var$__webpack_exports__.zzY;
var $2c23f148d58cd887$export$6976e674e6d5804c = $2c23f148d58cd887$var$__webpack_exports__.yRQ;
var $2c23f148d58cd887$export$420acfc1740638d3 = $2c23f148d58cd887$var$__webpack_exports__.MtE;
var $2c23f148d58cd887$export$e84927905accfe51 = $2c23f148d58cd887$var$__webpack_exports__.rPj;
var $2c23f148d58cd887$export$c9d7bf589772a8ce = $2c23f148d58cd887$var$__webpack_exports__.KLc;
var $2c23f148d58cd887$export$d5011a4647754c9b = $2c23f148d58cd887$var$__webpack_exports__.Fir;
var $2c23f148d58cd887$export$b8c6aa234afa01bc = $2c23f148d58cd887$var$__webpack_exports__.V5f;
var $2c23f148d58cd887$export$6c3776220abeb931 = $2c23f148d58cd887$var$__webpack_exports__.Xj7;
var $2c23f148d58cd887$export$27a9cd7ebdd38262 = $2c23f148d58cd887$var$__webpack_exports__.Wud;
var $2c23f148d58cd887$export$fb1b94e06ba8ebc8 = $2c23f148d58cd887$var$__webpack_exports__.FVg;
var $2c23f148d58cd887$export$3d953a2d86354b5f = $2c23f148d58cd887$var$__webpack_exports__.g5Y;
var $2c23f148d58cd887$export$88528019d270f582 = $2c23f148d58cd887$var$__webpack_exports__.YQB;
var $2c23f148d58cd887$export$402da60b1c009e43 = $2c23f148d58cd887$var$__webpack_exports__.KPb;
var $2c23f148d58cd887$export$757ccd1717b77f48 = $2c23f148d58cd887$var$__webpack_exports__.nHK;
var $2c23f148d58cd887$export$48ebf29bc7cb1dd7 = $2c23f148d58cd887$var$__webpack_exports__.TX_;
var $2c23f148d58cd887$export$3c8c04bde7eed7cb = $2c23f148d58cd887$var$__webpack_exports__.r3n;
var $2c23f148d58cd887$export$adfa9d260876eca5 = $2c23f148d58cd887$var$__webpack_exports__.vYh;
var $2c23f148d58cd887$export$6c043ed3a716859a = $2c23f148d58cd887$var$__webpack_exports__.hnk;
var $2c23f148d58cd887$export$9f9afb456a8bef30 = $2c23f148d58cd887$var$__webpack_exports__.D2R;
var $2c23f148d58cd887$export$1033a6fa0779f4f5 = $2c23f148d58cd887$var$__webpack_exports__.n1o;
var $2c23f148d58cd887$export$38f8109d2b8f43ef = $2c23f148d58cd887$var$__webpack_exports__.RLG;
var $2c23f148d58cd887$export$b5aa7fe3676b74a9 = $2c23f148d58cd887$var$__webpack_exports__.fBU;
var $2c23f148d58cd887$export$5213deb2877a09f2 = $2c23f148d58cd887$var$__webpack_exports__.Adb;
var $2c23f148d58cd887$export$280e9a68c3ffd919 = $2c23f148d58cd887$var$__webpack_exports__.bEs;
var $2c23f148d58cd887$export$33e0492c95e498b6 = $2c23f148d58cd887$var$__webpack_exports__.wCy;
var $2c23f148d58cd887$export$79acae2c80dc546e = $2c23f148d58cd887$var$__webpack_exports__.CbD;
var $2c23f148d58cd887$export$49a1ecce8d203 = $2c23f148d58cd887$var$__webpack_exports__.x_C;
var $2c23f148d58cd887$export$f5b8910cec6cf069 = $2c23f148d58cd887$var$__webpack_exports__.pde;
var $2c23f148d58cd887$export$99f13cbf742a0580 = $2c23f148d58cd887$var$__webpack_exports__.pGf;
var $2c23f148d58cd887$export$2ae6ec0f10d96242 = $2c23f148d58cd887$var$__webpack_exports__.ibQ;
var $2c23f148d58cd887$export$d379657aa3df1705 = $2c23f148d58cd887$var$__webpack_exports__.QlN;
var $2c23f148d58cd887$export$ffed6a4cd9a88787 = $2c23f148d58cd887$var$__webpack_exports__.shR;
var $2c23f148d58cd887$export$7705889256a9371a = $2c23f148d58cd887$var$__webpack_exports__.Yjk;
var $2c23f148d58cd887$export$539f65e788a82c62 = $2c23f148d58cd887$var$__webpack_exports__._u1;
var $2c23f148d58cd887$export$851e6d93385b6ad2 = $2c23f148d58cd887$var$__webpack_exports__.OBI;
var $2c23f148d58cd887$export$4b0c1c390bf9a356 = $2c23f148d58cd887$var$__webpack_exports__.klh;
var $2c23f148d58cd887$export$16e4d70cc375e707 = $2c23f148d58cd887$var$__webpack_exports__.s3S;
var $2c23f148d58cd887$export$4b0075e5ea5e1f26 = $2c23f148d58cd887$var$__webpack_exports__.D$R;
var $2c23f148d58cd887$export$f3a6c1ca682fd40f = $2c23f148d58cd887$var$__webpack_exports__.xth;
var $2c23f148d58cd887$export$b04be29aa201d4f5 = $2c23f148d58cd887$var$__webpack_exports__.JU7;
var $2c23f148d58cd887$export$b3509fba7d85d294 = $2c23f148d58cd887$var$__webpack_exports__.h9x;
var $2c23f148d58cd887$export$17d680238e50603e = $2c23f148d58cd887$var$__webpack_exports__.N1A;
var $2c23f148d58cd887$export$8b98feb4a2766c75 = $2c23f148d58cd887$var$__webpack_exports__.e_k;
var $2c23f148d58cd887$export$3b0d6d7590275603 = $2c23f148d58cd887$var$__webpack_exports__.aHM;
var $2c23f148d58cd887$export$38d47553764a3d88 = $2c23f148d58cd887$var$__webpack_exports__.tlv;
var $2c23f148d58cd887$export$1c4c6d3f8d56581 = $2c23f148d58cd887$var$__webpack_exports__.Vi9;
var $2c23f148d58cd887$export$fc869739b2177284 = $2c23f148d58cd887$var$__webpack_exports__.ieR;
var $2c23f148d58cd887$export$243e62d78d3b544d = $2c23f148d58cd887$var$__webpack_exports__.$bb;
var $2c23f148d58cd887$export$efa9a398d6368992 = $2c23f148d58cd887$var$__webpack_exports__.VyI;
var $2c23f148d58cd887$export$a2d8b23205c25948 = $2c23f148d58cd887$var$__webpack_exports__.imn;
var $2c23f148d58cd887$export$5b12bf1653c0dd85 = $2c23f148d58cd887$var$__webpack_exports__.uqu;
var $2c23f148d58cd887$export$9f9b2346169b00c0 = $2c23f148d58cd887$var$__webpack_exports__.QnL;
var $2c23f148d58cd887$export$8c37b217b84d3f89 = $2c23f148d58cd887$var$__webpack_exports__.vnc;
var $2c23f148d58cd887$export$35624b13e79b24a9 = $2c23f148d58cd887$var$__webpack_exports__.wk_;
var $2c23f148d58cd887$export$f75e7304717c9cbc = $2c23f148d58cd887$var$__webpack_exports__.GH0;
var $2c23f148d58cd887$export$ec1251c88c8bd5c9 = $2c23f148d58cd887$var$__webpack_exports__._1r;
var $2c23f148d58cd887$export$d17844835b0fe8a8 = $2c23f148d58cd887$var$__webpack_exports__.l0X;
var $2c23f148d58cd887$export$d1d8cb3d5c2a5671 = $2c23f148d58cd887$var$__webpack_exports__.HHX;
var $2c23f148d58cd887$export$4d607ef791645d6 = $2c23f148d58cd887$var$__webpack_exports__.tjk;
var $2c23f148d58cd887$export$f0b55daf9f154b55 = $2c23f148d58cd887$var$__webpack_exports__.rWe;
var $2c23f148d58cd887$export$fa9699e41ba6faff = $2c23f148d58cd887$var$__webpack_exports__.j9l;
var $2c23f148d58cd887$export$57ca7e07b341709d = $2c23f148d58cd887$var$__webpack_exports__.NVp;
var $2c23f148d58cd887$export$77cea355fa80b5f4 = $2c23f148d58cd887$var$__webpack_exports__.cPK;
var $2c23f148d58cd887$export$8844adde4348f85c = $2c23f148d58cd887$var$__webpack_exports__.XoL;
var $2c23f148d58cd887$export$d63d7cff08fe4dc9 = $2c23f148d58cd887$var$__webpack_exports__.RmF;
var $2c23f148d58cd887$export$a960801e47624f4f = $2c23f148d58cd887$var$__webpack_exports__.DXI;
var $2c23f148d58cd887$export$ed6a63ee685a4d78 = $2c23f148d58cd887$var$__webpack_exports__.tCD;
var $2c23f148d58cd887$export$4fe52ae24ae61d51 = $2c23f148d58cd887$var$__webpack_exports__.oGn;
var $2c23f148d58cd887$export$c36c68baa13912a5 = $2c23f148d58cd887$var$__webpack_exports__.J3D;
var $2c23f148d58cd887$export$616c632b282478dd = $2c23f148d58cd887$var$__webpack_exports__.vCJ;
var $2c23f148d58cd887$export$459b1801e3134a24 = $2c23f148d58cd887$var$__webpack_exports__.f9l;
var $2c23f148d58cd887$export$2f09efa5b67124a7 = $2c23f148d58cd887$var$__webpack_exports__.AQx;
var $2c23f148d58cd887$export$618424ba3f30cd41 = $2c23f148d58cd887$var$__webpack_exports__.v9m;
var $2c23f148d58cd887$export$4a963ea7a16edf21 = $2c23f148d58cd887$var$__webpack_exports__.yRJ;
var $2c23f148d58cd887$export$a4017560efebe97d = $2c23f148d58cd887$var$__webpack_exports__.EU6;
var $2c23f148d58cd887$export$982e5de016bedff1 = $2c23f148d58cd887$var$__webpack_exports__.m3O;
var $2c23f148d58cd887$export$6860c0696b73f79b = $2c23f148d58cd887$var$__webpack_exports__.Ryz;
var $2c23f148d58cd887$export$94806efd9890932f = $2c23f148d58cd887$var$__webpack_exports__.OxP;
var $2c23f148d58cd887$export$3bee0b2628b43478 = $2c23f148d58cd887$var$__webpack_exports__.LEs;
var $2c23f148d58cd887$export$caed39dbb767d548 = $2c23f148d58cd887$var$__webpack_exports__.Ec;
var $2c23f148d58cd887$export$7e5ab4f7f9fd407 = $2c23f148d58cd887$var$__webpack_exports__.Pi5;
var $2c23f148d58cd887$export$330520496d871ecf = $2c23f148d58cd887$var$__webpack_exports__.gmH;
var $2c23f148d58cd887$export$7d31b617c820d435 = $2c23f148d58cd887$var$__webpack_exports__.tS;
var $2c23f148d58cd887$export$f23a2a272a8df60 = $2c23f148d58cd887$var$__webpack_exports__.XxX;
var $2c23f148d58cd887$export$14963ee5c8637e11 = $2c23f148d58cd887$var$__webpack_exports__.bCz;
var $2c23f148d58cd887$export$1d2c184034fc4cc2 = $2c23f148d58cd887$var$__webpack_exports__.nYS;
var $2c23f148d58cd887$export$fea21a521a6360c1 = $2c23f148d58cd887$var$__webpack_exports__.yiT;
var $2c23f148d58cd887$export$8c15bdf7e3727f73 = $2c23f148d58cd887$var$__webpack_exports__.NHl;
var $2c23f148d58cd887$export$6eb043bf81d89752 = $2c23f148d58cd887$var$__webpack_exports__.mO8;
var $2c23f148d58cd887$export$e390b859365a3d5b = $2c23f148d58cd887$var$__webpack_exports__.PXI;
var $2c23f148d58cd887$export$82a33120f6a0d987 = $2c23f148d58cd887$var$__webpack_exports__.bn5;
var $2c23f148d58cd887$export$1ec85152758537e0 = $2c23f148d58cd887$var$__webpack_exports__.Ywr;
var $2c23f148d58cd887$export$a8584993858a18df = $2c23f148d58cd887$var$__webpack_exports__.cMd;
var $2c23f148d58cd887$export$906049a3747337a6 = $2c23f148d58cd887$var$__webpack_exports__.Bs6;
var $2c23f148d58cd887$export$dbd8a6303ac26a42 = $2c23f148d58cd887$var$__webpack_exports__.G0k;
var $2c23f148d58cd887$export$9f68b6f37a444556 = $2c23f148d58cd887$var$__webpack_exports__.pyn;
var $2c23f148d58cd887$export$fe2b6ac465da985d = $2c23f148d58cd887$var$__webpack_exports__.QeM;
var $2c23f148d58cd887$export$4c3c82f4dcd79fcc = $2c23f148d58cd887$var$__webpack_exports__.aPX;
var $2c23f148d58cd887$export$e4ce43ec0499fb8f = $2c23f148d58cd887$var$__webpack_exports__.ITP;
var $2c23f148d58cd887$export$e44279b5c44add28 = $2c23f148d58cd887$var$__webpack_exports__.BY0;
var $2c23f148d58cd887$export$dfa3a012bb2ef2e1 = $2c23f148d58cd887$var$__webpack_exports__.MFw;
var $2c23f148d58cd887$export$8201b979875baf73 = $2c23f148d58cd887$var$__webpack_exports__.sBn;
var $2c23f148d58cd887$export$b82688eb02220411 = $2c23f148d58cd887$var$__webpack_exports__.S3L;
var $2c23f148d58cd887$export$62297b13309008b2 = $2c23f148d58cd887$var$__webpack_exports__.XKQ;
var $2c23f148d58cd887$export$b986383a50b53ea4 = $2c23f148d58cd887$var$__webpack_exports__.ESI;
var $2c23f148d58cd887$export$ad5b3d166367714c = $2c23f148d58cd887$var$__webpack_exports__.uxz;
var $2c23f148d58cd887$export$a92776769f460054 = $2c23f148d58cd887$var$__webpack_exports__.o8N;
var $2c23f148d58cd887$export$eeb71495ca594706 = $2c23f148d58cd887$var$__webpack_exports__.u_r;
var $2c23f148d58cd887$export$a186db52eed6d40e = $2c23f148d58cd887$var$__webpack_exports__.RlV;
var $2c23f148d58cd887$export$c07ce6d13c46df49 = $2c23f148d58cd887$var$__webpack_exports__.gVA;
var $2c23f148d58cd887$export$4617fb02663045ef = $2c23f148d58cd887$var$__webpack_exports__.M_G;
var $2c23f148d58cd887$export$32437fc39ad02208 = $2c23f148d58cd887$var$__webpack_exports__.GRB;
var $2c23f148d58cd887$export$f9d61a2a6155ab51 = $2c23f148d58cd887$var$__webpack_exports__.kM6;
var $2c23f148d58cd887$export$9bd81f7d9b69ccb3 = $2c23f148d58cd887$var$__webpack_exports__.dO8;
var $2c23f148d58cd887$export$3e4ff2216a90b8a4 = $2c23f148d58cd887$var$__webpack_exports__.jgM;
var $2c23f148d58cd887$export$39a853cfb5a94a63 = $2c23f148d58cd887$var$__webpack_exports__.FWq;
var $2c23f148d58cd887$export$62833702c6700187 = $2c23f148d58cd887$var$__webpack_exports__.s3j;
var $2c23f148d58cd887$export$a43177620e7a9310 = $2c23f148d58cd887$var$__webpack_exports__.hlw;
var $2c23f148d58cd887$export$a16b6ef1fd362a19 = $2c23f148d58cd887$var$__webpack_exports__.B7e;
var $2c23f148d58cd887$export$91397be43fc980cc = $2c23f148d58cd887$var$__webpack_exports__.H_X;
var $2c23f148d58cd887$export$23b9d128e61caefd = $2c23f148d58cd887$var$__webpack_exports__.S_d;
var $2c23f148d58cd887$export$ab681471d41eeddc = $2c23f148d58cd887$var$__webpack_exports__.U7E;
var $2c23f148d58cd887$export$38af1803e3442a7f = $2c23f148d58cd887$var$__webpack_exports__.Z58;
var $2c23f148d58cd887$export$c1825d965cf69ea3 = $2c23f148d58cd887$var$__webpack_exports__.yh2;
var $2c23f148d58cd887$export$a98515d67472a41f = $2c23f148d58cd887$var$__webpack_exports__.ff$;
var $2c23f148d58cd887$export$57486627f01aaaf3 = $2c23f148d58cd887$var$__webpack_exports__.cWi;
var $2c23f148d58cd887$export$77630fcd7c3f2eb6 = $2c23f148d58cd887$var$__webpack_exports__.NBt;
var $2c23f148d58cd887$export$3bf088dd0bb7575 = $2c23f148d58cd887$var$__webpack_exports__.oNz;
var $2c23f148d58cd887$export$2f3ac66e390c188b = $2c23f148d58cd887$var$__webpack_exports__.QlU;
var $2c23f148d58cd887$export$d160a188872e1e4e = $2c23f148d58cd887$var$__webpack_exports__.Xey;
var $2c23f148d58cd887$export$5c7bd08c630c970c = $2c23f148d58cd887$var$__webpack_exports__.jft;
var $2c23f148d58cd887$export$462bb059fed9d9e5 = $2c23f148d58cd887$var$__webpack_exports__.Mtr;
var $2c23f148d58cd887$export$6428a7f2611ef1fa = $2c23f148d58cd887$var$__webpack_exports__.ypk;
var $2c23f148d58cd887$export$80a00690bda7f17e = $2c23f148d58cd887$var$__webpack_exports__.mnM;
var $2c23f148d58cd887$export$50994fad4c4676f4 = $2c23f148d58cd887$var$__webpack_exports__.bAZ;
var $2c23f148d58cd887$export$85990f0f98a390bb = $2c23f148d58cd887$var$__webpack_exports__.ABN;
var $2c23f148d58cd887$export$5bff0d6cc6200d64 = $2c23f148d58cd887$var$__webpack_exports__.VK6;
var $2c23f148d58cd887$export$3075603db8e6204c = $2c23f148d58cd887$var$__webpack_exports__.kxk;
var $2c23f148d58cd887$export$e1896ac0c4970221 = $2c23f148d58cd887$var$__webpack_exports__.DT1;
var $2c23f148d58cd887$export$bd73ddfe5f8475d8 = $2c23f148d58cd887$var$__webpack_exports__.FLG;
var $2c23f148d58cd887$export$f62bb2892382b3dd = $2c23f148d58cd887$var$__webpack_exports__.qN_;
var $2c23f148d58cd887$export$cbf2d83d1eab018a = $2c23f148d58cd887$var$__webpack_exports__.Z37;
var $2c23f148d58cd887$export$9ad53eded130cce4 = $2c23f148d58cd887$var$__webpack_exports__.FtL;
var $2c23f148d58cd887$export$6a4eb2e7fc9e8903 = $2c23f148d58cd887$var$__webpack_exports__.Z6X;
var $2c23f148d58cd887$export$e1dae5660003ffa7 = $2c23f148d58cd887$var$__webpack_exports__.iQT;
var $2c23f148d58cd887$export$a12e67a4b4590901 = $2c23f148d58cd887$var$__webpack_exports__.ziO;
var $2c23f148d58cd887$export$7c88eb83095afadd = $2c23f148d58cd887$var$__webpack_exports__.OEF;
var $2c23f148d58cd887$export$c586aa7b67d94d19 = $2c23f148d58cd887$var$__webpack_exports__.uuE;
var $2c23f148d58cd887$export$47b45ce774071a36 = $2c23f148d58cd887$var$__webpack_exports__.tiv;
var $2c23f148d58cd887$export$9440a22058545f9a = $2c23f148d58cd887$var$__webpack_exports__.T$Y;
var $2c23f148d58cd887$export$5f1af8db9871e1d6 = $2c23f148d58cd887$var$__webpack_exports__.EYj;
var $2c23f148d58cd887$export$3720eb13f948f394 = $2c23f148d58cd887$var$__webpack_exports__.nOB;
var $2c23f148d58cd887$export$fd1bfc71f64c538c = $2c23f148d58cd887$var$__webpack_exports__.Tap;
var $2c23f148d58cd887$export$235cb65c20ad2b7 = $2c23f148d58cd887$var$__webpack_exports__.FAs;
var $2c23f148d58cd887$export$16ec26812de3ce7a = $2c23f148d58cd887$var$__webpack_exports__.B_P;
var $2c23f148d58cd887$export$dac3abbdc575ce73 = $2c23f148d58cd887$var$__webpack_exports__.aA5;
var $2c23f148d58cd887$export$c57e9b2d8b9e4de = $2c23f148d58cd887$var$__webpack_exports__.M4G;
var $2c23f148d58cd887$export$fb98e3a2a4cd92d7 = $2c23f148d58cd887$var$__webpack_exports__.l$l;
var $2c23f148d58cd887$export$563a914cafbdc389 = $2c23f148d58cd887$var$__webpack_exports__.dLy;
var $2c23f148d58cd887$export$1def2aa75b7c7fe0 = $2c23f148d58cd887$var$__webpack_exports__.WZP;
var $2c23f148d58cd887$export$be58926105124dd4 = $2c23f148d58cd887$var$__webpack_exports__.eB6;
var $2c23f148d58cd887$export$2eba8ec3a333fdbb = $2c23f148d58cd887$var$__webpack_exports__.nFK;
var $2c23f148d58cd887$export$41fb9f06171c75f4 = $2c23f148d58cd887$var$__webpack_exports__.l9z;
var $2c23f148d58cd887$export$14963f945d6d59f0 = $2c23f148d58cd887$var$__webpack_exports__.YOF;
var $2c23f148d58cd887$export$ba8651401a8a2b84 = $2c23f148d58cd887$var$__webpack_exports__.yhB;
var $2c23f148d58cd887$export$f8f26dd395d7e1bd = $2c23f148d58cd887$var$__webpack_exports__.J0N;
var $2c23f148d58cd887$export$9b781de7bf37bf48 = $2c23f148d58cd887$var$__webpack_exports__.Miz;
var $2c23f148d58cd887$export$ab650c8e5b9b9f2c = $2c23f148d58cd887$var$__webpack_exports__.Bj4;
var $2c23f148d58cd887$export$41825a1ed6473903 = $2c23f148d58cd887$var$__webpack_exports__.Rcs;
var $2c23f148d58cd887$export$f5ae2f144b95ebf4 = $2c23f148d58cd887$var$__webpack_exports__.vJ4;
var $2c23f148d58cd887$export$31ac8f65680039dd = $2c23f148d58cd887$var$__webpack_exports__.TqC;
var $2c23f148d58cd887$export$d5c6f73f7a77b9d = $2c23f148d58cd887$var$__webpack_exports__.nM0;
var $2c23f148d58cd887$export$8bfbf00b5dba81f6 = $2c23f148d58cd887$var$__webpack_exports__.X1u;
var $2c23f148d58cd887$export$2af5ef044257da25 = $2c23f148d58cd887$var$__webpack_exports__.SpZ;
var $2c23f148d58cd887$export$8c3375c231593a9d = $2c23f148d58cd887$var$__webpack_exports__.DX8;
var $2c23f148d58cd887$export$9a4eae43f302c46e = $2c23f148d58cd887$var$__webpack_exports__.Yx$;
var $2c23f148d58cd887$export$812cd9544993280d = $2c23f148d58cd887$var$__webpack_exports__.HK4;
var $2c23f148d58cd887$export$a4913eafbb02ceb4 = $2c23f148d58cd887$var$__webpack_exports__.SE$;
var $2c23f148d58cd887$export$7d15b64cf5a3a4c4 = $2c23f148d58cd887$var$__webpack_exports__.qE8;
var $2c23f148d58cd887$export$c372a5d5a3996cbf = $2c23f148d58cd887$var$__webpack_exports__.Pz7;
var $2c23f148d58cd887$export$7149c6ffc9994c32 = $2c23f148d58cd887$var$__webpack_exports__.sX_;
var $2c23f148d58cd887$export$d436988b04cb99a5 = $2c23f148d58cd887$var$__webpack_exports__.JuI;
var $2c23f148d58cd887$export$3ba9f2e94585ecc6 = $2c23f148d58cd887$var$__webpack_exports__.Nl$;
var $2c23f148d58cd887$export$25dac40984956196 = $2c23f148d58cd887$var$__webpack_exports__.OwT;
var $2c23f148d58cd887$export$57932b71da6538b7 = $2c23f148d58cd887$var$__webpack_exports__.P$G;
var $2c23f148d58cd887$export$a17402ef5f32064d = $2c23f148d58cd887$var$__webpack_exports__.mHV;
var $2c23f148d58cd887$export$d5dea09620a858fd = $2c23f148d58cd887$var$__webpack_exports__.Fx_;
var $2c23f148d58cd887$export$1377812d73ae3cab = $2c23f148d58cd887$var$__webpack_exports__.WFC;
var $2c23f148d58cd887$export$331f4c7ef74a9752 = $2c23f148d58cd887$var$__webpack_exports__.aDq;
var $2c23f148d58cd887$export$5f4e18965661d41f = $2c23f148d58cd887$var$__webpack_exports__.jIg;
var $2c23f148d58cd887$export$817667946f51142b = $2c23f148d58cd887$var$__webpack_exports__.UH3;
var $2c23f148d58cd887$export$adc479603c39b28 = $2c23f148d58cd887$var$__webpack_exports__.K6X;
var $2c23f148d58cd887$export$ba30ba18962891e7 = $2c23f148d58cd887$var$__webpack_exports__.C1Y;
var $2c23f148d58cd887$export$bcf8f1355133000b = $2c23f148d58cd887$var$__webpack_exports__.Aw1;
var $2c23f148d58cd887$export$256576ea924e6c90 = $2c23f148d58cd887$var$__webpack_exports__.A8$;
var $2c23f148d58cd887$export$786d9ab531bddbaa = $2c23f148d58cd887$var$__webpack_exports__.hsx;
var $2c23f148d58cd887$export$e87630d8ef35465d = $2c23f148d58cd887$var$__webpack_exports__.l9E;
var $2c23f148d58cd887$export$c3cedacda2d7ce48 = $2c23f148d58cd887$var$__webpack_exports__.aSf;
var $2c23f148d58cd887$export$5a62d8eea226ddc = $2c23f148d58cd887$var$__webpack_exports__.Zex;
var $2c23f148d58cd887$export$640d107500a3202a = $2c23f148d58cd887$var$__webpack_exports__.mXP;
var $2c23f148d58cd887$export$c6ab03c33733124a = $2c23f148d58cd887$var$__webpack_exports__.vt$;
var $2c23f148d58cd887$export$64a4b86c523eb0e1 = $2c23f148d58cd887$var$__webpack_exports__.hCA;
var $2c23f148d58cd887$export$506bf22710a79182 = $2c23f148d58cd887$var$__webpack_exports__.pjR;
var $2c23f148d58cd887$export$8b958c8ecd94a804 = $2c23f148d58cd887$var$__webpack_exports__.U43;
var $2c23f148d58cd887$export$816343276f749e02 = $2c23f148d58cd887$var$__webpack_exports__.pSZ;
var $2c23f148d58cd887$export$d02631cccf789723 = $2c23f148d58cd887$var$__webpack_exports__.y17;
var $2c23f148d58cd887$export$5dc5812d8b390c43 = $2c23f148d58cd887$var$__webpack_exports__.jVr;
var $2c23f148d58cd887$export$c5552dfdbc7cec71 = $2c23f148d58cd887$var$__webpack_exports__._SZ;
var $2c23f148d58cd887$export$56cb859c01fa134d = $2c23f148d58cd887$var$__webpack_exports__.xWn;
var $2c23f148d58cd887$export$cba01ba138429a1d = $2c23f148d58cd887$var$__webpack_exports__.ehJ;
var $2c23f148d58cd887$export$202e0172ed3c7be0 = $2c23f148d58cd887$var$__webpack_exports__.t6s;
var $2c23f148d58cd887$export$d55298c9efc5ed14 = $2c23f148d58cd887$var$__webpack_exports__.Eyn;




var $1fbc8b8cf4bb0471$exports = {};
$1fbc8b8cf4bb0471$exports = new URL("cal.efcc29bc.png", import.meta.url).toString();


var $bac6d69bf729691b$exports = {};
$bac6d69bf729691b$exports = new URL("Silkscreen-Regular.341186eb.ttf", import.meta.url).toString();


const $7c4c300842bd4cf2$export$e9a269813a6315a4 = {
    CalSpriteSheet: new (0, $2c23f148d58cd887$export$280e9a68c3ffd919)((0, (/*@__PURE__*/$parcel$interopDefault($1fbc8b8cf4bb0471$exports)))),
    PixelFont: new (0, $2c23f148d58cd887$export$1f6d1255105a925c)((0, (/*@__PURE__*/$parcel$interopDefault($bac6d69bf729691b$exports))), "silkscreen")
};
const $7c4c300842bd4cf2$export$775cd2490918dd55 = (0, $2c23f148d58cd887$export$bd73ddfe5f8475d8).fromImageSource({
    image: $7c4c300842bd4cf2$export$e9a269813a6315a4.CalSpriteSheet,
    grid: {
        rows: 1,
        columns: 9,
        spriteHeight: 32,
        spriteWidth: 32
    }
});
const $7c4c300842bd4cf2$export$411b824e9aec2643 = (0, $2c23f148d58cd887$export$c35d437ae5945fcd).fromSpriteSheetCoordinates({
    spriteSheet: $7c4c300842bd4cf2$export$775cd2490918dd55,
    frameCoordinates: [
        {
            x: 2,
            y: 0
        },
        {
            x: 3,
            y: 0
        }
    ],
    durationPerFrameMs: 300
});
const $7c4c300842bd4cf2$export$f4c5de44377d2946 = new (0, $2c23f148d58cd887$export$3b0d6d7590275603)();
for (let res of Object.values($7c4c300842bd4cf2$export$e9a269813a6315a4))$7c4c300842bd4cf2$export$f4c5de44377d2946.addResource(res);


const $2f4cd9ba4fceb80d$export$4dd36135bf0813ea = (screen)=>{
    const origin = screen.worldToPageCoordinates((0, $2c23f148d58cd887$export$9b781de7bf37bf48).Zero);
    const singlePixel = screen.worldToPageCoordinates((0, $2c23f148d58cd887$export$202e0172ed3c7be0)(1, 0)).sub(origin);
    const pixelConversion = singlePixel.x;
    document.documentElement.style.setProperty("--pixel-conversion", pixelConversion.toString());
};
class $2f4cd9ba4fceb80d$export$d9b273488cd8ce6f {
    constructor(scene){
        this.scene = scene;
        this.currentWorldPos = (0, $2c23f148d58cd887$export$202e0172ed3c7be0)(0, 0);
        scene.input.pointers.on("down", (evt)=>{
            this.show();
            this.currentWorldPos = scene.engine.screen.pageToWorldCoordinates((0, $2c23f148d58cd887$export$202e0172ed3c7be0)(evt.pagePos.x, evt.pagePos.y));
            document.documentElement.style.setProperty("--pointer-x", evt.pagePos.x.toString() + "px");
            document.documentElement.style.setProperty("--pointer-y", evt.pagePos.y.toString() + "px");
        });
        const rootElement = document.getElementById("menu");
        const addUnitButton = document.getElementById("add-unit");
        const removeUnitButton = document.getElementById("remove-unit");
        if (rootElement && addUnitButton && removeUnitButton) {
            this.rootElement = rootElement;
            this.addUnitButton = addUnitButton;
            this.removeUnitButton = removeUnitButton;
            this.addUnitButton.addEventListener("click", (evt)=>{
                this.addUnit();
            });
            this.removeUnitButton.addEventListener("click", (evt)=>{
                this.removeUnit();
            });
        } else throw Error("Could not initialize menu, element with id='menu'");
    }
    addUnit() {
        const actor = new (0, $2c23f148d58cd887$export$f73d3eb6fd876d80)({
            pos: this.currentWorldPos,
            scale: (0, $2c23f148d58cd887$export$202e0172ed3c7be0)(2, 2),
            color: (0, $2c23f148d58cd887$export$892596cec99bc70e).Red
        });
        actor.graphics.use((0, $7c4c300842bd4cf2$export$411b824e9aec2643));
        this.scene.add(actor);
        this.hide();
    }
    removeUnit() {
        for (let actor of this.scene.actors)if (actor.graphics.bounds.contains(this.currentWorldPos)) actor.kill();
        this.hide();
    }
    show() {
        this.rootElement.classList.remove("hide");
        this.rootElement.classList.add("show");
    }
    hide() {
        this.rootElement.classList.remove("show");
        this.rootElement.classList.add("hide");
    }
}



const $ad2bcec7a0192558$var$game = new (0, $2c23f148d58cd887$export$2c3b404bf3a77a1f)({
    canvasElementId: "game",
    width: 800,
    height: 600,
    pixelArt: true,
    displayMode: (0, $2c23f148d58cd887$export$4b7264771109adb6).FitScreen
});
$ad2bcec7a0192558$var$game.screen.events.on("resize", ()=>(0, $2f4cd9ba4fceb80d$export$4dd36135bf0813ea)($ad2bcec7a0192558$var$game.screen));
$ad2bcec7a0192558$var$game.start((0, $7c4c300842bd4cf2$export$f4c5de44377d2946)).then(()=>{
    (0, $2f4cd9ba4fceb80d$export$4dd36135bf0813ea)($ad2bcec7a0192558$var$game.screen);
    const menu = new (0, $2f4cd9ba4fceb80d$export$d9b273488cd8ce6f)($ad2bcec7a0192558$var$game.currentScene);
});


//# sourceMappingURL=index.32fa273c.js.map
